export const destinations = [
  {
    sortOrder: 1,
    selectable: false,
    destinationUrlName: 'USA',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77',
    parentId: 8,
    timeZone: 'America/New_York',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'USA',
    destinationId: 77,
    latitude: 37.09024,
    longitude: -95.712891,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Alabama',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22212',
    parentId: 77,
    timeZone: 'America/Chicago',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Alabama',
    destinationId: 22212,
    latitude: 32.34,
    longitude: -86.26,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Alaska',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.270',
    parentId: 77,
    timeZone: 'America/Anchorage',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Alaska',
    destinationId: 270,
    latitude: 63.588753,
    longitude: -154.4930619,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Arizona',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.271',
    parentId: 77,
    timeZone: 'America/Phoenix',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Arizona',
    destinationId: 271,
    latitude: 34.0489281,
    longitude: -111.0937311,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Arkansas',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22213',
    parentId: 77,
    timeZone: 'America/Chicago',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Arkansas',
    destinationId: 22213,
    latitude: 35.2011,
    longitude: -91.8318,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'California',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272',
    parentId: 77,
    timeZone: 'America/Los_Angeles',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'California',
    destinationId: 272,
    latitude: 36.778261,
    longitude: -119.4179324,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Colorado',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.273',
    parentId: 77,
    timeZone: 'America/Denver',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Colorado',
    destinationId: 273,
    latitude: 39.5500507,
    longitude: -105.7820674,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Connecticut',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22214',
    parentId: 77,
    timeZone: 'America/New_York',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Connecticut',
    destinationId: 22214,
    latitude: 41.6032,
    longitude: -73.0877,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Delaware',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22775',
    parentId: 77,
    timeZone: 'America/New_York',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Delaware',
    destinationId: 22775,
    latitude: 38.9108,
    longitude: -75.5277,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Florida',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.276',
    parentId: 77,
    timeZone: 'America/New_York',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Florida',
    destinationId: 276,
    latitude: 27.6648274,
    longitude: -81.5157535,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Georgia',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.277',
    parentId: 77,
    timeZone: 'US/Eastern',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Georgia',
    destinationId: 277,
    latitude: 32.1574351,
    longitude: -82.907123,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Hawaii',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.278',
    parentId: 77,
    timeZone: 'Pacific/Honolulu',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Hawaii',
    destinationId: 278,
    latitude: 19.8986819,
    longitude: -155.6658568,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Idaho',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22215',
    parentId: 77,
    timeZone: 'America/Los_Angeles',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Idaho',
    destinationId: 22215,
    latitude: 45.4066116,
    longitude: -118.6312161,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Illinois',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22032',
    parentId: 77,
    timeZone: 'America/Chicago',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Illinois',
    destinationId: 22032,
    latitude: 39.081488,
    longitude: -89.449207,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Indiana',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22216',
    parentId: 77,
    timeZone: 'America/Indiana/Indianapolis',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Indiana',
    destinationId: 22216,
    latitude: 40.2672,
    longitude: -86.1349,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Iowa',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22217',
    parentId: 77,
    timeZone: 'America/Chicago',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Iowa',
    destinationId: 22217,
    latitude: 41.8508057,
    longitude: -97.8790946,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Kansas',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22218',
    parentId: 77,
    timeZone: 'America/Chicago',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Kansas',
    destinationId: 22218,
    latitude: 39.0119,
    longitude: -98.4842,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Kentucky',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22325',
    parentId: 77,
    timeZone: 'America/Chicago',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Kentucky',
    destinationId: 22325,
    latitude: 37.73699,
    longitude: -90.259035,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Louisiana',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22168',
    parentId: 77,
    timeZone: 'US/Central',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Louisiana',
    destinationId: 22168,
    latitude: 32.436083,
    longitude: -93.176736,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Maine',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.21458',
    parentId: 77,
    timeZone: 'America/New_York',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Maine',
    destinationId: 21458,
    latitude: 45.2743,
    longitude: -69.2028,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Maryland',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.282',
    parentId: 77,
    timeZone: 'America/New_York',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Maryland',
    destinationId: 282,
    latitude: 39.0457549,
    longitude: -76.6412712,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Massachusetts',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22172',
    parentId: 77,
    timeZone: 'US/Eastern',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Massachusetts',
    destinationId: 22172,
    latitude: 42.374154,
    longitude: -72.503869,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'Michigan',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22219',
    parentId: 77,
    timeZone: 'America/Detroit',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Michigan',
    destinationId: 22219,
    latitude: 45.0008,
    longitude: -86.2706,
  },
  {
    sortOrder: 23,
    selectable: true,
    destinationUrlName: 'Minnesota',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22206',
    parentId: 77,
    timeZone: 'America/Chicago',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Minnesota',
    destinationId: 22206,
    latitude: 46.4419,
    longitude: -93.3615,
  },
  {
    sortOrder: 24,
    selectable: true,
    destinationUrlName: 'Mississippi',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22220',
    parentId: 77,
    timeZone: 'America/Chicago',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Mississippi',
    destinationId: 22220,
    latitude: 32.9409,
    longitude: -89.702,
  },
  {
    sortOrder: 25,
    selectable: true,
    destinationUrlName: 'Missouri',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5234',
    parentId: 77,
    timeZone: 'America/Chicago',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Missouri',
    destinationId: 5234,
    latitude: 38.219007,
    longitude: -96.9277223,
  },
  {
    sortOrder: 26,
    selectable: true,
    destinationUrlName: 'Montana',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22221',
    parentId: 77,
    timeZone: 'America/Denver',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Montana',
    destinationId: 22221,
    latitude: 46.879682,
    longitude: -110.362566,
  },
  {
    sortOrder: 27,
    selectable: true,
    destinationUrlName: 'Nebraska',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22222',
    parentId: 77,
    timeZone: 'America/Denver',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Nebraska',
    destinationId: 22222,
    latitude: 41.4134579,
    longitude: -104.170361,
  },
  {
    sortOrder: 28,
    selectable: true,
    destinationUrlName: 'Nevada',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22171',
    parentId: 77,
    timeZone: 'US/Mountain',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Nevada',
    destinationId: 22171,
    latitude: 40.66091,
    longitude: -117.176869,
  },
  {
    sortOrder: 29,
    selectable: true,
    destinationUrlName: 'New-Hampshire',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22223',
    parentId: 77,
    timeZone: 'America/New_York',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'New Hampshire',
    destinationId: 22223,
    latitude: 43.19385,
    longitude: -71.5724,
  },
  {
    sortOrder: 30,
    selectable: true,
    destinationUrlName: 'New-Jersey',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22324',
    parentId: 77,
    timeZone: 'America/New_York',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'New Jersey',
    destinationId: 22324,
    latitude: 40.0676363,
    longitude: -75.8454513,
  },
  {
    sortOrder: 31,
    selectable: true,
    destinationUrlName: 'New-Mexico',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22224',
    parentId: 77,
    timeZone: 'America/Denver',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'New Mexico',
    destinationId: 22224,
    latitude: 34.4815,
    longitude: -106.0598,
  },
  {
    sortOrder: 32,
    selectable: true,
    destinationUrlName: 'New-York',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5560',
    parentId: 77,
    timeZone: 'America/New_York',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'New York',
    destinationId: 5560,
    latitude: 43.166316,
    longitude: -77.429529,
  },
  {
    sortOrder: 33,
    selectable: true,
    destinationUrlName: 'North-Carolina',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5283',
    parentId: 77,
    timeZone: 'US/Eastern',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'North Carolina',
    destinationId: 5283,
    latitude: 35.75957,
    longitude: -79.0193,
  },
  {
    sortOrder: 34,
    selectable: true,
    destinationUrlName: 'North-Dakota',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22225',
    parentId: 77,
    timeZone: 'America/Chicago',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'North Dakota',
    destinationId: 22225,
    latitude: 47.5284,
    longitude: -100.445,
  },
  {
    sortOrder: 35,
    selectable: true,
    destinationUrlName: 'Ohio',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22226',
    parentId: 77,
    timeZone: 'America/New_York',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Ohio',
    destinationId: 22226,
    latitude: 40.41729,
    longitude: -82.90712,
  },
  {
    sortOrder: 36,
    selectable: true,
    destinationUrlName: 'Oklahoma',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22227',
    parentId: 77,
    timeZone: 'America/Chicago',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Oklahoma',
    destinationId: 22227,
    latitude: 35.7324,
    longitude: -97.3868,
  },
  {
    sortOrder: 37,
    selectable: true,
    destinationUrlName: 'Oregon',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5064',
    parentId: 77,
    timeZone: 'US/Pacific',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Oregon',
    destinationId: 5064,
    latitude: 43.8041334,
    longitude: -120.5542012,
  },
  {
    sortOrder: 38,
    selectable: true,
    destinationUrlName: 'Pennsylvania',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.293',
    parentId: 77,
    timeZone: 'America/New_York',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Pennsylvania',
    destinationId: 293,
    latitude: 41.2033216,
    longitude: -77.1945247,
  },
  {
    sortOrder: 39,
    selectable: true,
    destinationUrlName: 'Rhode-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5266',
    parentId: 77,
    timeZone: 'US/Eastern',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Rhode Island',
    destinationId: 5266,
    latitude: 41.5800945,
    longitude: -71.4774291,
  },
  {
    sortOrder: 40,
    selectable: true,
    destinationUrlName: 'South-Carolina',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.294',
    parentId: 77,
    timeZone: 'America/New_York',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'South Carolina',
    destinationId: 294,
    latitude: 33.836081,
    longitude: -81.1637245,
  },
  {
    sortOrder: 41,
    selectable: true,
    destinationUrlName: 'South-Dakota',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22169',
    parentId: 77,
    timeZone: 'America/Chicago',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'South Dakota',
    destinationId: 22169,
    latitude: 43.96951,
    longitude: -99.90181,
  },
  {
    sortOrder: 42,
    selectable: true,
    destinationUrlName: 'Tennessee',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.295',
    parentId: 77,
    timeZone: 'America/Chicago',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Tennessee',
    destinationId: 295,
    latitude: 35.5174913,
    longitude: -86.5804473,
  },
  {
    sortOrder: 43,
    selectable: true,
    destinationUrlName: 'Texas',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.296',
    parentId: 77,
    timeZone: 'America/Chicago',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Texas',
    destinationId: 296,
    latitude: 31.9685988,
    longitude: -99.9018131,
  },
  {
    sortOrder: 44,
    selectable: true,
    destinationUrlName: 'Tskaltubo',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.277.51887',
    parentId: 277,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Tskaltubo',
    destinationId: 51887,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 45,
    selectable: true,
    destinationUrlName: 'Utah',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.785',
    parentId: 77,
    timeZone: 'America/Denver',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Utah',
    destinationId: 785,
    latitude: 39.3209801,
    longitude: -111.0937311,
  },
  {
    sortOrder: 46,
    selectable: true,
    destinationUrlName: 'Vermont',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22228',
    parentId: 77,
    timeZone: 'America/New_York',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Vermont',
    destinationId: 22228,
    latitude: 44.0752,
    longitude: -72.7356,
  },
  {
    sortOrder: 47,
    selectable: true,
    destinationUrlName: 'Virginia',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22229',
    parentId: 77,
    timeZone: 'America/New_York',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Virginia',
    destinationId: 22229,
    latitude: 37.392018,
    longitude: -78.41444,
  },
  {
    sortOrder: 48,
    selectable: true,
    destinationUrlName: 'Washington',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.298',
    parentId: 77,
    timeZone: 'America/Los_Angeles',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Washington',
    destinationId: 298,
    latitude: 48.001618,
    longitude: -119.738492,
  },
  {
    sortOrder: 49,
    selectable: true,
    destinationUrlName: 'West-Virginia',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22230',
    parentId: 77,
    timeZone: 'America/New_York',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'West Virginia',
    destinationId: 22230,
    latitude: 38.7184,
    longitude: -80.7352,
  },
  {
    sortOrder: 50,
    selectable: true,
    destinationUrlName: 'Wisconsin',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22231',
    parentId: 77,
    timeZone: 'America/Chicago',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Wisconsin',
    destinationId: 22231,
    latitude: 44.8127882,
    longitude: -94.0576719,
  },
  {
    sortOrder: 51,
    selectable: true,
    destinationUrlName: 'Wyoming',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5260',
    parentId: 77,
    timeZone: 'US/Mountain',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Wyoming',
    destinationId: 5260,
    latitude: 43.0330835986,
    longitude: -107.55456695,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Albany',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5560.23070',
    parentId: 5560,
    timeZone: 'America/New_York',
    iataCode: 'ALB',
    destinationType: 'CITY',
    destinationName: 'Albany',
    destinationId: 23070,
    latitude: 42.652812,
    longitude: -73.754368,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Albuquerque',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22224.28131',
    parentId: 22224,
    timeZone: 'America/Denver',
    iataCode: 'ABQ',
    destinationType: 'CITY',
    destinationName: 'Albuquerque',
    destinationId: 28131,
    latitude: 35.08533,
    longitude: -106.60555,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Amarillo',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.296.29045',
    parentId: 296,
    timeZone: 'America/Chicago',
    iataCode: 'AMA',
    destinationType: 'CITY',
    destinationName: 'Amarillo',
    destinationId: 29045,
    latitude: 35.222,
    longitude: -101.8313,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Anaheim-and-Buena-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.797',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: 'ANA',
    destinationType: 'CITY',
    destinationName: 'Anaheim & Buena Park',
    destinationId: 797,
    latitude: 33.859013,
    longitude: -117.9778750001,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Anchorage',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.270.4152',
    parentId: 270,
    timeZone: 'US/Alaska',
    iataCode: 'ANC',
    destinationType: 'CITY',
    destinationName: 'Anchorage',
    destinationId: 4152,
    latitude: 61.2180556,
    longitude: -149.9002778,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Annapolis',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.282.40943',
    parentId: 282,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Annapolis',
    destinationId: 40943,
    latitude: 38.9724637,
    longitude: -76.5397139,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Asheville',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5283.22561',
    parentId: 5283,
    timeZone: 'America/New_York',
    iataCode: 'AVL',
    destinationType: 'CITY',
    destinationName: 'Asheville',
    destinationId: 22561,
    latitude: 35.59506,
    longitude: -82.55149,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Ashland',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5064.28293',
    parentId: 5064,
    timeZone: 'America/Los_Angeles',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ashland',
    destinationId: 28293,
    latitude: 42.19458,
    longitude: -122.70948,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Aspen',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.273.26395',
    parentId: 273,
    timeZone: 'America/Denver',
    iataCode: 'ASE',
    destinationType: 'CITY',
    destinationName: 'Aspen',
    destinationId: 26395,
    latitude: 39.191098,
    longitude: -106.817539,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Astoria',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.4370',
    parentId: 77,
    timeZone: 'America/Los_Angeles',
    iataCode: 'AST',
    destinationType: 'CITY',
    destinationName: 'Astoria',
    destinationId: 4370,
    latitude: 46.187884,
    longitude: -123.831253,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Atlanta',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.277.784',
    parentId: 277,
    timeZone: 'America/New_York',
    iataCode: 'ATL',
    destinationType: 'CITY',
    destinationName: 'Atlanta',
    destinationId: 784,
    latitude: 33.7489954,
    longitude: -84.3879824,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Atlantic-City',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22324.22927',
    parentId: 22324,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Atlantic City',
    destinationId: 22927,
    latitude: 39.36428,
    longitude: -74.42293,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Austin',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.296.5021',
    parentId: 296,
    timeZone: 'US/Central',
    iataCode: 'AUS',
    destinationType: 'CITY',
    destinationName: 'Austin',
    destinationId: 5021,
    latitude: 30.267153,
    longitude: -97.7430608,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Baker-City',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5064.37309',
    parentId: 5064,
    timeZone: 'America/Los_Angeles',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Baker City',
    destinationId: 37309,
    latitude: 44.7746115,
    longitude: -117.8667479,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Baltimore',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.282.4375',
    parentId: 282,
    timeZone: 'America/New_York',
    iataCode: 'BWI',
    destinationType: 'CITY',
    destinationName: 'Baltimore',
    destinationId: 4375,
    latitude: 39.290385,
    longitude: -76.612189,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Bar-Harbor',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.21458.4371',
    parentId: 21458,
    timeZone: 'America/New_York',
    iataCode: 'BHB',
    destinationType: 'CITY',
    destinationName: 'Bar Harbor',
    destinationId: 4371,
    latitude: 44.3852,
    longitude: -68.2711,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Bend',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5064.22372',
    parentId: 5064,
    timeZone: 'America/Los_Angeles',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bend',
    destinationId: 22372,
    latitude: 44.05817,
    longitude: -121.31531,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Big-Bear',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.50762',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Big Bear',
    destinationId: 50762,
    latitude: 34.266369,
    longitude: -116.846771,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Big-Bend-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.296.50795',
    parentId: 296,
    timeZone: 'America/Chicago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Big Bend National Park',
    destinationId: 50795,
    latitude: 29.127487,
    longitude: -103.242538,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Big-Island-of-Hawaii',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.278.669',
    parentId: 278,
    timeZone: 'Pacific/Honolulu',
    iataCode: 'KOA',
    destinationType: 'CITY',
    destinationName: 'Big Island of Hawaii',
    destinationId: 669,
    latitude: 19.7252210566,
    longitude: -155.0869560242,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Big-Sky',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22221.50777',
    parentId: 22221,
    timeZone: 'America/Denver',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Big Sky',
    destinationId: 50777,
    latitude: 45.264629,
    longitude: -111.253258,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'Billings',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22221.22825',
    parentId: 22221,
    timeZone: 'America/Denver',
    iataCode: 'BIL',
    destinationType: 'CITY',
    destinationName: 'Billings',
    destinationId: 22825,
    latitude: 45.783286,
    longitude: -108.50069,
  },
  {
    sortOrder: 23,
    selectable: true,
    destinationUrlName: 'Biloxi',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22220.22663',
    parentId: 22220,
    timeZone: 'America/Chicago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Biloxi',
    destinationId: 22663,
    latitude: 30.39603,
    longitude: -88.88531,
  },
  {
    sortOrder: 24,
    selectable: true,
    destinationUrlName: 'Birmingham',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22212.34184',
    parentId: 22212,
    timeZone: 'America/Chicago',
    iataCode: 'BHM',
    destinationType: 'CITY',
    destinationName: 'Birmingham',
    destinationId: 34184,
    latitude: 33.520046,
    longitude: -86.795242,
  },
  {
    sortOrder: 25,
    selectable: true,
    destinationUrlName: 'Bloomington',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22206.50635',
    parentId: 22206,
    timeZone: 'America/Indiana/Indianapolis',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bloomington',
    destinationId: 50635,
    latitude: 39.165325,
    longitude: -86.526382,
  },
  {
    sortOrder: 26,
    selectable: true,
    destinationUrlName: 'Boca-Raton',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.276.25267',
    parentId: 276,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Boca Raton',
    destinationId: 25267,
    latitude: 26.368306,
    longitude: -80.128932,
  },
  {
    sortOrder: 27,
    selectable: true,
    destinationUrlName: 'Boise',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22215.32778',
    parentId: 22215,
    timeZone: 'America/Boise',
    iataCode: 'BOI',
    destinationType: 'CITY',
    destinationName: 'Boise',
    destinationId: 32778,
    latitude: 43.618774,
    longitude: -116.214554,
  },
  {
    sortOrder: 28,
    selectable: true,
    destinationUrlName: 'Boone',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5283.23227',
    parentId: 5283,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Boone',
    destinationId: 23227,
    latitude: 36.216795,
    longitude: -81.674552,
  },
  {
    sortOrder: 29,
    selectable: true,
    destinationUrlName: 'Boston',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22172.678',
    parentId: 22172,
    timeZone: 'America/New_York',
    iataCode: 'BOS',
    destinationType: 'CITY',
    destinationName: 'Boston',
    destinationId: 678,
    latitude: 42.3656470028,
    longitude: -71.0527038574,
  },
  {
    sortOrder: 30,
    selectable: true,
    destinationUrlName: 'Boulder',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.273.22773',
    parentId: 273,
    timeZone: 'America/Denver',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Boulder',
    destinationId: 22773,
    latitude: 40.014986,
    longitude: -105.270546,
  },
  {
    sortOrder: 31,
    selectable: true,
    destinationUrlName: 'Bowling-Green',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22325.50733',
    parentId: 22325,
    timeZone: 'America/Chicago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bowling Green',
    destinationId: 50733,
    latitude: 37.00241,
    longitude: -86.44349,
  },
  {
    sortOrder: 32,
    selectable: true,
    destinationUrlName: 'Bozeman',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22221.22771',
    parentId: 22221,
    timeZone: 'America/Denver',
    iataCode: 'BZN',
    destinationType: 'CITY',
    destinationName: 'Bozeman',
    destinationId: 22771,
    latitude: 45.676998,
    longitude: -111.042934,
  },
  {
    sortOrder: 33,
    selectable: true,
    destinationUrlName: 'Branson',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5234.5235',
    parentId: 5234,
    timeZone: 'America/Chicago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Branson',
    destinationId: 5235,
    latitude: 36.64367,
    longitude: -93.21851,
  },
  {
    sortOrder: 34,
    selectable: true,
    destinationUrlName: 'Breckenridge',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.273.26252',
    parentId: 273,
    timeZone: 'America/Denver',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Breckenridge',
    destinationId: 26252,
    latitude: 39.481654,
    longitude: -106.038352,
  },
  {
    sortOrder: 35,
    selectable: true,
    destinationUrlName: 'Brooklyn',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5560.22371',
    parentId: 5560,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Brooklyn',
    destinationId: 22371,
    latitude: 40.67818,
    longitude: -73.94416,
  },
  {
    sortOrder: 36,
    selectable: true,
    destinationUrlName: 'Bryce-Canyon-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.785.50798',
    parentId: 785,
    timeZone: 'America/Denver',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bryce Canyon National Park',
    destinationId: 50798,
    latitude: 37.627361,
    longitude: -112.185257,
  },
  {
    sortOrder: 37,
    selectable: true,
    destinationUrlName: 'Buena-Vista',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.273.22370',
    parentId: 273,
    timeZone: 'America/Denver',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Buena Vista',
    destinationId: 22370,
    latitude: 38.842218,
    longitude: -106.131129,
  },
  {
    sortOrder: 38,
    selectable: true,
    destinationUrlName: 'Buffalo',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5560.23066',
    parentId: 5560,
    timeZone: 'America/New_York',
    iataCode: 'BUF',
    destinationType: 'CITY',
    destinationName: 'Buffalo',
    destinationId: 23066,
    latitude: 42.886447,
    longitude: -78.878369,
  },
  {
    sortOrder: 39,
    selectable: true,
    destinationUrlName: 'Burlington',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22228.23484',
    parentId: 22228,
    timeZone: 'America/New_York',
    iataCode: 'BTV',
    destinationType: 'CITY',
    destinationName: 'Burlington',
    destinationId: 23484,
    latitude: 44.475882,
    longitude: -73.212072,
  },
  {
    sortOrder: 40,
    selectable: true,
    destinationUrlName: 'Cambridge',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22172.22877',
    parentId: 22172,
    timeZone: 'US/Eastern',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cambridge',
    destinationId: 22877,
    latitude: 42.373616,
    longitude: -71.109734,
  },
  {
    sortOrder: 41,
    selectable: true,
    destinationUrlName: 'Camden',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.21458.22448',
    parentId: 21458,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Camden',
    destinationId: 22448,
    latitude: 44.217925,
    longitude: -69.082437,
  },
  {
    sortOrder: 42,
    selectable: true,
    destinationUrlName: 'Canon-City',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.273.22360',
    parentId: 273,
    timeZone: 'America/Denver',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cañon City',
    destinationId: 22360,
    latitude: 38.449406,
    longitude: -105.225332,
  },
  {
    sortOrder: 43,
    selectable: true,
    destinationUrlName: 'Cape-Canaveral',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.276.22936',
    parentId: 276,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cape Canaveral',
    destinationId: 22936,
    latitude: 28.39222,
    longitude: -80.60771,
  },
  {
    sortOrder: 44,
    selectable: true,
    destinationUrlName: 'Cape-Cod',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22172.26302',
    parentId: 22172,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cape Cod',
    destinationId: 26302,
    latitude: 41.699096,
    longitude: -70.320911,
  },
  {
    sortOrder: 45,
    selectable: true,
    destinationUrlName: 'Cape-May',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22324.33066',
    parentId: 22324,
    timeZone: 'America/New_York',
    iataCode: 'WWD',
    destinationType: 'CITY',
    destinationName: 'Cape May',
    destinationId: 33066,
    latitude: 38.93537,
    longitude: -74.90662,
  },
  {
    sortOrder: 46,
    selectable: true,
    destinationUrlName: 'Carlsbad',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.23228',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: 'CLD',
    destinationType: 'CITY',
    destinationName: 'Carlsbad',
    destinationId: 23228,
    latitude: 33.15809,
    longitude: -117.35059,
  },
  {
    sortOrder: 47,
    selectable: true,
    destinationUrlName: 'Carolina-Beach',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5283.50781',
    parentId: 5283,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Carolina Beach',
    destinationId: 50781,
    latitude: 34.035172,
    longitude: -77.8936,
  },
  {
    sortOrder: 48,
    selectable: true,
    destinationUrlName: 'Catalina-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.24024',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Catalina Island',
    destinationId: 24024,
    latitude: 33.38789,
    longitude: -118.41631,
  },
  {
    sortOrder: 49,
    selectable: true,
    destinationUrlName: 'Charleston',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.294.4384',
    parentId: 294,
    timeZone: 'America/New_York',
    iataCode: 'CHS',
    destinationType: 'CITY',
    destinationName: 'Charleston',
    destinationId: 4384,
    latitude: 32.7765656,
    longitude: -79.9309216,
  },
  {
    sortOrder: 50,
    selectable: true,
    destinationUrlName: 'Charlotte',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5283.5284',
    parentId: 5283,
    timeZone: 'US/Eastern',
    iataCode: 'CLT',
    destinationType: 'CITY',
    destinationName: 'Charlotte',
    destinationId: 5284,
    latitude: 35.22709,
    longitude: -80.84313,
  },
  {
    sortOrder: 51,
    selectable: true,
    destinationUrlName: 'Charlottesville',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22229.23229',
    parentId: 22229,
    timeZone: 'America/New_York',
    iataCode: 'CHO',
    destinationType: 'CITY',
    destinationName: 'Charlottesville',
    destinationId: 23229,
    latitude: 38.02931,
    longitude: -78.47668,
  },
  {
    sortOrder: 52,
    selectable: true,
    destinationUrlName: 'Chattanooga',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.295.27404',
    parentId: 295,
    timeZone: 'America/New_York',
    iataCode: 'CHA',
    destinationType: 'CITY',
    destinationName: 'Chattanooga',
    destinationId: 27404,
    latitude: 35.04563,
    longitude: -85.30968,
  },
  {
    sortOrder: 53,
    selectable: true,
    destinationUrlName: 'Chelan',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.298.23638',
    parentId: 298,
    timeZone: 'America/Los_Angeles',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Chelan',
    destinationId: 23638,
    latitude: 47.84476,
    longitude: -120.01908,
  },
  {
    sortOrder: 54,
    selectable: true,
    destinationUrlName: 'Chicago',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22032.673',
    parentId: 22032,
    timeZone: 'America/Chicago',
    iataCode: 'CHI',
    destinationType: 'CITY',
    destinationName: 'Chicago',
    destinationId: 673,
    latitude: 41.8781136,
    longitude: -87.6297982,
  },
  {
    sortOrder: 55,
    selectable: true,
    destinationUrlName: 'Chinle',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.271.50556',
    parentId: 271,
    timeZone: 'America/Denver',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Chinle',
    destinationId: 50556,
    latitude: 36.15242,
    longitude: -109.556702,
  },
  {
    sortOrder: 56,
    selectable: true,
    destinationUrlName: 'Cincinnati',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22226.27186',
    parentId: 22226,
    timeZone: 'America/New_York',
    iataCode: 'CVG',
    destinationType: 'CITY',
    destinationName: 'Cincinnati',
    destinationId: 27186,
    latitude: 39.10312,
    longitude: -84.51202,
  },
  {
    sortOrder: 57,
    selectable: true,
    destinationUrlName: 'Claypool',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.271.50727',
    parentId: 271,
    timeZone: 'America/Phoenix',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Claypool',
    destinationId: 50727,
    latitude: 33.41064,
    longitude: -110.84299,
  },
  {
    sortOrder: 58,
    selectable: true,
    destinationUrlName: 'Clayton',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5560.23064',
    parentId: 5560,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Clayton',
    destinationId: 23064,
    latitude: 44.23968,
    longitude: -76.085288,
  },
  {
    sortOrder: 59,
    selectable: true,
    destinationUrlName: 'Clearwater',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.276.22457',
    parentId: 276,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Clearwater',
    destinationId: 22457,
    latitude: 27.96585,
    longitude: -82.8001,
  },
  {
    sortOrder: 60,
    selectable: true,
    destinationUrlName: 'Cleveland',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22226.22926',
    parentId: 22226,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cleveland',
    destinationId: 22926,
    latitude: 41.49932,
    longitude: -81.69436,
  },
  {
    sortOrder: 61,
    selectable: true,
    destinationUrlName: 'Cocoa-Beach',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.276.25319',
    parentId: 276,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cocoa Beach',
    destinationId: 25319,
    latitude: 28.320007,
    longitude: -80.607551,
  },
  {
    sortOrder: 62,
    selectable: true,
    destinationUrlName: 'Cody',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5260.22772',
    parentId: 5260,
    timeZone: 'America/Denver',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cody',
    destinationId: 22772,
    latitude: 44.526342,
    longitude: -109.056531,
  },
  {
    sortOrder: 63,
    selectable: true,
    destinationUrlName: 'Colorado-Springs',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.273.22201',
    parentId: 273,
    timeZone: 'America/Denver',
    iataCode: 'COS',
    destinationType: 'CITY',
    destinationName: 'Colorado Springs',
    destinationId: 22201,
    latitude: 38.833882,
    longitude: -104.821363,
  },
  {
    sortOrder: 64,
    selectable: true,
    destinationUrlName: 'Columbus',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22226.23485',
    parentId: 22226,
    timeZone: 'America/New_York',
    iataCode: 'CMH',
    destinationType: 'CITY',
    destinationName: 'Columbus',
    destinationId: 23485,
    latitude: 39.961176,
    longitude: -82.998794,
  },
  {
    sortOrder: 65,
    selectable: true,
    destinationUrlName: 'Cooperstown',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5560.26435',
    parentId: 5560,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cooperstown',
    destinationId: 26435,
    latitude: 42.700734,
    longitude: -74.923902,
  },
  {
    sortOrder: 66,
    selectable: true,
    destinationUrlName: 'Corpus-Christi',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.296.28078',
    parentId: 296,
    timeZone: 'America/Chicago',
    iataCode: 'CRP',
    destinationType: 'CITY',
    destinationName: 'Corpus Christi',
    destinationId: 28078,
    latitude: 27.80058,
    longitude: -97.39638,
  },
  {
    sortOrder: 67,
    selectable: true,
    destinationUrlName: 'Crystal-River',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.276.22318',
    parentId: 276,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Crystal River',
    destinationId: 22318,
    latitude: 28.90248,
    longitude: -82.5926,
  },
  {
    sortOrder: 68,
    selectable: true,
    destinationUrlName: 'Custer',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22169.23073',
    parentId: 22169,
    timeZone: 'America/Denver',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Custer',
    destinationId: 23073,
    latitude: 43.76665,
    longitude: -103.59881,
  },
  {
    sortOrder: 69,
    selectable: true,
    destinationUrlName: 'Dallas',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.296.918',
    parentId: 296,
    timeZone: 'America/Chicago',
    iataCode: 'DFW',
    destinationType: 'CITY',
    destinationName: 'Dallas',
    destinationId: 918,
    latitude: 32.802955,
    longitude: -96.769923,
  },
  {
    sortOrder: 70,
    selectable: true,
    destinationUrlName: 'Dana-Point',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.22659',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Dana Point',
    destinationId: 22659,
    latitude: 33.466972,
    longitude: -117.698107,
  },
  {
    sortOrder: 71,
    selectable: true,
    destinationUrlName: 'Daytona-Beach',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.276.25790',
    parentId: 276,
    timeZone: 'America/New_York',
    iataCode: 'DAB',
    destinationType: 'CITY',
    destinationName: 'Daytona Beach',
    destinationId: 25790,
    latitude: 29.210815,
    longitude: -81.022833,
  },
  {
    sortOrder: 72,
    selectable: true,
    destinationUrlName: 'Denali-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.270.22364',
    parentId: 270,
    timeZone: 'America/Anchorage',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Denali National Park',
    destinationId: 22364,
    latitude: 63.73,
    longitude: -148.91,
  },
  {
    sortOrder: 73,
    selectable: true,
    destinationUrlName: 'Denver',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.273.4837',
    parentId: 273,
    timeZone: 'America/Denver',
    iataCode: 'DEN',
    destinationType: 'CITY',
    destinationName: 'Denver',
    destinationId: 4837,
    latitude: 39.737567,
    longitude: -104.9847179,
  },
  {
    sortOrder: 74,
    selectable: true,
    destinationUrlName: 'Destin',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.276.25549',
    parentId: 276,
    timeZone: 'America/Chicago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Destin',
    destinationId: 25549,
    latitude: 30.393534,
    longitude: -86.495783,
  },
  {
    sortOrder: 75,
    selectable: true,
    destinationUrlName: 'Detroit',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22219.22934',
    parentId: 22219,
    timeZone: 'America/Detroit',
    iataCode: 'DTT',
    destinationType: 'CITY',
    destinationName: 'Detroit',
    destinationId: 22934,
    latitude: 42.33143,
    longitude: -83.04575,
  },
  {
    sortOrder: 76,
    selectable: true,
    destinationUrlName: 'Duluth',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22206.22210',
    parentId: 22206,
    timeZone: 'America/Chicago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Duluth',
    destinationId: 22210,
    latitude: 46.785947,
    longitude: -92.09836,
  },
  {
    sortOrder: 77,
    selectable: true,
    destinationUrlName: 'Durango',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.273.23639',
    parentId: 273,
    timeZone: 'America/Denver',
    iataCode: 'DRO',
    destinationType: 'CITY',
    destinationName: 'Durango',
    destinationId: 23639,
    latitude: 37.27528,
    longitude: -107.88007,
  },
  {
    sortOrder: 78,
    selectable: true,
    destinationUrlName: 'El-Paso',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.296.50135',
    parentId: 296,
    timeZone: 'America/Denver',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'El Paso',
    destinationId: 50135,
    latitude: 31.8108262,
    longitude: -106.7047064,
  },
  {
    sortOrder: 79,
    selectable: true,
    destinationUrlName: 'Erie',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.293.50739',
    parentId: 293,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Erie',
    destinationId: 50739,
    latitude: 42.127949,
    longitude: -80.082581,
  },
  {
    sortOrder: 80,
    selectable: true,
    destinationUrlName: 'Estes-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.273.32992',
    parentId: 273,
    timeZone: 'America/Denver',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Estes Park',
    destinationId: 32992,
    latitude: 40.377216,
    longitude: -105.520812,
  },
  {
    sortOrder: 81,
    selectable: true,
    destinationUrlName: 'Eugene',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5064.35679',
    parentId: 5064,
    timeZone: 'America/Los_Angeles',
    iataCode: 'EUG',
    destinationType: 'CITY',
    destinationName: 'Eugene',
    destinationId: 35679,
    latitude: 44.0563,
    longitude: -123.1173,
  },
  {
    sortOrder: 82,
    selectable: true,
    destinationUrlName: 'Eureka-Springs',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22213.50757',
    parentId: 22213,
    timeZone: 'America/Chicago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Eureka Springs',
    destinationId: 50757,
    latitude: 36.402679,
    longitude: -93.735962,
  },
  {
    sortOrder: 83,
    selectable: true,
    destinationUrlName: 'Everglades-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.276.5286',
    parentId: 276,
    timeZone: 'US/Eastern',
    iataCode: 'MIA',
    destinationType: 'CITY',
    destinationName: 'Everglades National Park',
    destinationId: 5286,
    latitude: 25.28662,
    longitude: -80.89865,
  },
  {
    sortOrder: 84,
    selectable: true,
    destinationUrlName: 'Fairbanks',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.270.5269',
    parentId: 270,
    timeZone: 'America/Anchorage',
    iataCode: 'FAI',
    destinationType: 'CITY',
    destinationName: 'Fairbanks',
    destinationId: 5269,
    latitude: 64.837778,
    longitude: -147.716389,
  },
  {
    sortOrder: 85,
    selectable: true,
    destinationUrlName: 'Fayetteville',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22230.25666',
    parentId: 22230,
    timeZone: 'America/New_York',
    iataCode: 'FYV',
    destinationType: 'CITY',
    destinationName: 'Fayetteville',
    destinationId: 25666,
    latitude: 35.052664,
    longitude: -78.878358,
  },
  {
    sortOrder: 86,
    selectable: true,
    destinationUrlName: 'Flagstaff',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.271.21450',
    parentId: 271,
    timeZone: 'America/Phoenix',
    iataCode: 'FLG',
    destinationType: 'CITY',
    destinationName: 'Flagstaff',
    destinationId: 21450,
    latitude: 35.19828,
    longitude: -111.6513,
  },
  {
    sortOrder: 87,
    selectable: true,
    destinationUrlName: 'Folly-Beach',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.294.50788',
    parentId: 294,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Folly Beach',
    destinationId: 50788,
    latitude: 32.655949,
    longitude: -79.941071,
  },
  {
    sortOrder: 88,
    selectable: true,
    destinationUrlName: 'Fort-Collins',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.273.22741',
    parentId: 273,
    timeZone: 'America/Denver',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Fort Collins',
    destinationId: 22741,
    latitude: 40.584934,
    longitude: -105.081998,
  },
  {
    sortOrder: 89,
    selectable: true,
    destinationUrlName: 'Fort-Lauderdale',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.276.660',
    parentId: 276,
    timeZone: 'America/New_York',
    iataCode: 'FLL',
    destinationType: 'CITY',
    destinationName: 'Fort Lauderdale',
    destinationId: 660,
    latitude: 26.1224594401,
    longitude: -80.1282691956,
  },
  {
    sortOrder: 90,
    selectable: true,
    destinationUrlName: 'Fort-Myers',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.276.5196',
    parentId: 276,
    timeZone: 'US/Eastern',
    iataCode: 'FMY',
    destinationType: 'CITY',
    destinationName: 'Fort Myers',
    destinationId: 5196,
    latitude: 26.6403,
    longitude: -81.8725,
  },
  {
    sortOrder: 91,
    selectable: true,
    destinationUrlName: 'Fort-Worth',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.296.33749',
    parentId: 296,
    timeZone: 'America/Chicago',
    iataCode: 'DFW',
    destinationType: 'CITY',
    destinationName: 'Fort Worth',
    destinationId: 33749,
    latitude: 32.755182,
    longitude: -97.326263,
  },
  {
    sortOrder: 92,
    selectable: true,
    destinationUrlName: 'Frankfort',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22219.27763',
    parentId: 22219,
    timeZone: 'America/Detroit',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Frankfort',
    destinationId: 27763,
    latitude: 44.63361,
    longitude: -86.23454,
  },
  {
    sortOrder: 93,
    selectable: true,
    destinationUrlName: 'Franklin',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.295.50741',
    parentId: 295,
    timeZone: 'America/Chicago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Franklin',
    destinationId: 50741,
    latitude: 35.925064,
    longitude: -86.868889,
  },
  {
    sortOrder: 94,
    selectable: true,
    destinationUrlName: 'Frederick',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.282.22824',
    parentId: 282,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Frederick',
    destinationId: 22824,
    latitude: 39.413801,
    longitude: -77.409979,
  },
  {
    sortOrder: 95,
    selectable: true,
    destinationUrlName: 'Fredericksburg',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.296.50796',
    parentId: 296,
    timeZone: 'America/Chicago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Fredericksburg',
    destinationId: 50796,
    latitude: 30.271851,
    longitude: -98.87529,
  },
  {
    sortOrder: 96,
    selectable: true,
    destinationUrlName: 'Fresno',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.50817',
    parentId: 272,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Fresno',
    destinationId: 50817,
    latitude: 36.8610051964,
    longitude: -119.7868102207,
  },
  {
    sortOrder: 97,
    selectable: true,
    destinationUrlName: 'Gainesville',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.276.29648',
    parentId: 276,
    timeZone: 'America/New_York',
    iataCode: 'GNV',
    destinationType: 'CITY',
    destinationName: 'Gainesville',
    destinationId: 29648,
    latitude: 29.65163,
    longitude: -82.32483,
  },
  {
    sortOrder: 98,
    selectable: true,
    destinationUrlName: 'Galveston',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.296.4385',
    parentId: 296,
    timeZone: 'America/Chicago',
    iataCode: 'GLS',
    destinationType: 'CITY',
    destinationName: 'Galveston',
    destinationId: 4385,
    latitude: 29.30135,
    longitude: -94.7977,
  },
  {
    sortOrder: 99,
    selectable: true,
    destinationUrlName: 'Gardiner',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22221.50734',
    parentId: 22221,
    timeZone: 'America/Denver',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Gardiner',
    destinationId: 50734,
    latitude: 45.030499,
    longitude: -110.70549,
  },
  {
    sortOrder: 100,
    selectable: true,
    destinationUrlName: 'Gatlinburg',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.295.24151',
    parentId: 295,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Gatlinburg',
    destinationId: 24151,
    latitude: 35.714164,
    longitude: -83.509306,
  },
  {
    sortOrder: 101,
    selectable: true,
    destinationUrlName: 'Gettysburg',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.293.28146',
    parentId: 293,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Gettysburg',
    destinationId: 28146,
    latitude: 39.83093,
    longitude: -77.2311,
  },
  {
    sortOrder: 102,
    selectable: true,
    destinationUrlName: 'Glenwood-Springs',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.273.23482',
    parentId: 273,
    timeZone: 'America/Denver',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Glenwood Springs',
    destinationId: 23482,
    latitude: 39.550538,
    longitude: -107.324776,
  },
  {
    sortOrder: 103,
    selectable: true,
    destinationUrlName: 'Gloucester',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22172.24267',
    parentId: 22172,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Gloucester',
    destinationId: 24267,
    latitude: 42.615804,
    longitude: -70.660357,
  },
  {
    sortOrder: 104,
    selectable: true,
    destinationUrlName: 'Golden-Isles',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.277.24043',
    parentId: 277,
    timeZone: 'America/Nassau',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Golden Isles',
    destinationId: 24043,
    latitude: 25.0069,
    longitude: -77.3902,
  },
  {
    sortOrder: 105,
    selectable: true,
    destinationUrlName: 'Grand-Canyon-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.271.815',
    parentId: 271,
    timeZone: 'America/Phoenix',
    iataCode: 'GCN',
    destinationType: 'CITY',
    destinationName: 'Grand Canyon National Park',
    destinationId: 815,
    latitude: 36.2472571,
    longitude: -112.3337769,
  },
  {
    sortOrder: 106,
    selectable: true,
    destinationUrlName: 'Grand-Rapids',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22219.50737',
    parentId: 22219,
    timeZone: 'America/Detroit',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Grand Rapids',
    destinationId: 50737,
    latitude: 42.965462,
    longitude: -85.670174,
  },
  {
    sortOrder: 107,
    selectable: true,
    destinationUrlName: 'Grand-Teton-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5260.22873',
    parentId: 5260,
    timeZone: 'America/Denver',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Grand Teton National Park',
    destinationId: 22873,
    latitude: 43.79043,
    longitude: -110.68176,
  },
  {
    sortOrder: 108,
    selectable: true,
    destinationUrlName: 'Great-Smoky-Mountains-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.295.24149',
    parentId: 295,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Great Smoky Mountains National Park',
    destinationId: 24149,
    latitude: 35.611764,
    longitude: -83.489545,
  },
  {
    sortOrder: 109,
    selectable: true,
    destinationUrlName: 'Green-Bay-and-Door-County',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22231.29044',
    parentId: 22231,
    timeZone: 'America/Chicago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Green Bay & Door County',
    destinationId: 29044,
    latitude: 45.35104,
    longitude: -86.94126,
  },
  {
    sortOrder: 110,
    selectable: true,
    destinationUrlName: 'Greenville',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.294.24778',
    parentId: 294,
    timeZone: 'America/New_York',
    iataCode: 'GSP',
    destinationType: 'CITY',
    destinationName: 'Greenville',
    destinationId: 24778,
    latitude: 34.852618,
    longitude: -82.39401,
  },
  {
    sortOrder: 111,
    selectable: true,
    destinationUrlName: 'Gulf-Shores',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22212.29364',
    parentId: 22212,
    timeZone: 'America/Chicago',
    iataCode: 'GUF',
    destinationType: 'CITY',
    destinationName: 'Gulf Shores',
    destinationId: 29364,
    latitude: 30.24604,
    longitude: -87.70082,
  },
  {
    sortOrder: 112,
    selectable: true,
    destinationUrlName: 'Haines',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.270.4357',
    parentId: 270,
    timeZone: 'America/Juneau',
    iataCode: 'HMS',
    destinationType: 'CITY',
    destinationName: 'Haines',
    destinationId: 4357,
    latitude: 59.236449,
    longitude: -135.443047,
  },
  {
    sortOrder: 113,
    selectable: true,
    destinationUrlName: 'Harrisburg',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.293.24145',
    parentId: 293,
    timeZone: 'America/New_York',
    iataCode: 'HAR',
    destinationType: 'CITY',
    destinationName: 'Harrisburg',
    destinationId: 24145,
    latitude: 40.273185,
    longitude: -76.887939,
  },
  {
    sortOrder: 114,
    selectable: true,
    destinationUrlName: 'Hartford',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.295.50638',
    parentId: 295,
    timeZone: 'America/Chicago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Hartford',
    destinationId: 50638,
    latitude: 41.588821,
    longitude: -93.620308,
  },
  {
    sortOrder: 115,
    selectable: true,
    destinationUrlName: 'Hartford',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22214.23403',
    parentId: 22214,
    timeZone: 'America/New_York',
    iataCode: 'HFD',
    destinationType: 'CITY',
    destinationName: 'Hartford',
    destinationId: 23403,
    latitude: 41.763457,
    longitude: -72.683223,
  },
  {
    sortOrder: 116,
    selectable: true,
    destinationUrlName: 'Hayward',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22231.50811',
    parentId: 22231,
    timeZone: 'America/Chicago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Hayward',
    destinationId: 50811,
    latitude: 46.009991,
    longitude: -91.482094,
  },
  {
    sortOrder: 117,
    selectable: true,
    destinationUrlName: 'Healdsburg',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.22499',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Healdsburg',
    destinationId: 22499,
    latitude: 38.61047,
    longitude: -122.86916,
  },
  {
    sortOrder: 118,
    selectable: true,
    destinationUrlName: 'Hershey',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.293.24150',
    parentId: 293,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Hershey',
    destinationId: 24150,
    latitude: 40.28592,
    longitude: -76.65025,
  },
  {
    sortOrder: 119,
    selectable: true,
    destinationUrlName: 'Hilton-Head-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.294.31480',
    parentId: 294,
    timeZone: 'America/New_York',
    iataCode: 'HHH',
    destinationType: 'CITY',
    destinationName: 'Hilton Head Island',
    destinationId: 31480,
    latitude: 32.20166,
    longitude: -80.84256,
  },
  {
    sortOrder: 120,
    selectable: true,
    destinationUrlName: 'Homer',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.270.4359',
    parentId: 270,
    timeZone: 'America/Juneau',
    iataCode: 'HOM',
    destinationType: 'CITY',
    destinationName: 'Homer',
    destinationId: 4359,
    latitude: 59.6425,
    longitude: -151.5483,
  },
  {
    sortOrder: 121,
    selectable: true,
    destinationUrlName: 'Hoonah',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.270.26215',
    parentId: 270,
    timeZone: 'America/Anchorage',
    iataCode: 'HNH',
    destinationType: 'CITY',
    destinationName: 'Hoonah',
    destinationId: 26215,
    latitude: 58.11,
    longitude: -135.4436,
  },
  {
    sortOrder: 122,
    selectable: true,
    destinationUrlName: 'Hot-Springs',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22213.50758',
    parentId: 22213,
    timeZone: 'America/Chicago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Hot Springs',
    destinationId: 50758,
    latitude: 34.502781,
    longitude: -93.055656,
  },
  {
    sortOrder: 123,
    selectable: true,
    destinationUrlName: 'Houston',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.296.5186',
    parentId: 296,
    timeZone: 'US/Central',
    iataCode: 'HOU',
    destinationType: 'CITY',
    destinationName: 'Houston',
    destinationId: 5186,
    latitude: 29.762778,
    longitude: -95.383056,
  },
  {
    sortOrder: 124,
    selectable: true,
    destinationUrlName: 'Idaho-Springs',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.273.26216',
    parentId: 273,
    timeZone: 'America/Denver',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Idaho Springs',
    destinationId: 26216,
    latitude: 39.742488,
    longitude: -105.513608,
  },
  {
    sortOrder: 125,
    selectable: true,
    destinationUrlName: 'Indianapolis',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22216.25792',
    parentId: 22216,
    timeZone: 'America/Indiana/Indianapolis',
    iataCode: 'IND',
    destinationType: 'CITY',
    destinationName: 'Indianapolis',
    destinationId: 25792,
    latitude: 39.768403,
    longitude: -86.158068,
  },
  {
    sortOrder: 126,
    selectable: true,
    destinationUrlName: 'Islamorada',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.276.23474',
    parentId: 276,
    timeZone: 'America/Kentucky/Monticello',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Islamorada',
    destinationId: 23474,
    latitude: 24.9295595,
    longitude: -80.779337,
  },
  {
    sortOrder: 127,
    selectable: true,
    destinationUrlName: 'Isle-of-Palms',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.294.50789',
    parentId: 294,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Isle of Palms',
    destinationId: 50789,
    latitude: 32.78842,
    longitude: -79.78775,
  },
  {
    sortOrder: 128,
    selectable: true,
    destinationUrlName: 'Ithaca',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5560.23069',
    parentId: 5560,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ithaca',
    destinationId: 23069,
    latitude: 42.443961,
    longitude: -76.501881,
  },
  {
    sortOrder: 129,
    selectable: true,
    destinationUrlName: 'Jackson-Hole',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5260.5261',
    parentId: 5260,
    timeZone: 'US/Mountain',
    iataCode: 'JAC',
    destinationType: 'CITY',
    destinationName: 'Jackson Hole',
    destinationId: 5261,
    latitude: 43.4745213036,
    longitude: -110.77559745,
  },
  {
    sortOrder: 130,
    selectable: true,
    destinationUrlName: 'Jacksonville',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.276.4373',
    parentId: 276,
    timeZone: 'America/New_York',
    iataCode: 'JAX',
    destinationType: 'CITY',
    destinationName: 'Jacksonville',
    destinationId: 4373,
    latitude: 30.332184,
    longitude: -81.655651,
  },
  {
    sortOrder: 131,
    selectable: true,
    destinationUrlName: 'Jamestown',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5560.23065',
    parentId: 5560,
    timeZone: 'America/New_York',
    iataCode: 'JHW',
    destinationType: 'CITY',
    destinationName: 'Jamestown',
    destinationId: 23065,
    latitude: 37.208268,
    longitude: -76.77409,
  },
  {
    sortOrder: 132,
    selectable: true,
    destinationUrlName: 'Jersey-City',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22324.24760',
    parentId: 22324,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Jersey City',
    destinationId: 24760,
    latitude: 40.72816,
    longitude: -74.07764,
  },
  {
    sortOrder: 133,
    selectable: true,
    destinationUrlName: 'Juneau',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.270.941',
    parentId: 270,
    timeZone: 'America/Anchorage',
    iataCode: 'JNU',
    destinationType: 'CITY',
    destinationName: 'Juneau',
    destinationId: 941,
    latitude: 58.3023188838,
    longitude: -134.4306850433,
  },
  {
    sortOrder: 134,
    selectable: true,
    destinationUrlName: 'Kalamazoo',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22219.50775',
    parentId: 22219,
    timeZone: 'America/Detroit',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kalamazoo',
    destinationId: 50775,
    latitude: 42.291706,
    longitude: -85.587227,
  },
  {
    sortOrder: 135,
    selectable: true,
    destinationUrlName: 'Kansas-City',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22218.28609',
    parentId: 22218,
    timeZone: 'America/Chicago',
    iataCode: 'KCK',
    destinationType: 'CITY',
    destinationName: 'Kansas City',
    destinationId: 28609,
    latitude: 39.11405,
    longitude: -94.62746,
  },
  {
    sortOrder: 136,
    selectable: true,
    destinationUrlName: 'Kansas-City',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5234.22925',
    parentId: 5234,
    timeZone: 'America/Chicago',
    iataCode: 'MKC',
    destinationType: 'CITY',
    destinationName: 'Kansas City',
    destinationId: 22925,
    latitude: 39.09973,
    longitude: -94.57857,
  },
  {
    sortOrder: 137,
    selectable: true,
    destinationUrlName: 'Kauai',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.278.670',
    parentId: 278,
    timeZone: 'Pacific/Honolulu',
    iataCode: 'LIH',
    destinationType: 'CITY',
    destinationName: 'Kauai',
    destinationId: 670,
    latitude: 22.2188736586,
    longitude: -159.4277143478,
  },
  {
    sortOrder: 138,
    selectable: true,
    destinationUrlName: 'Kelleys-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22226.50782',
    parentId: 22226,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kelleys Island',
    destinationId: 50782,
    latitude: 41.606522,
    longitude: -82.708443,
  },
  {
    sortOrder: 139,
    selectable: true,
    destinationUrlName: 'Kennebunkport',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.21458.50770',
    parentId: 21458,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kennebunkport',
    destinationId: 50770,
    latitude: 43.360882,
    longitude: -70.474098,
  },
  {
    sortOrder: 140,
    selectable: true,
    destinationUrlName: 'Ketchikan',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.270.942',
    parentId: 270,
    timeZone: 'America/Anchorage',
    iataCode: 'KTN',
    destinationType: 'CITY',
    destinationName: 'Ketchikan',
    destinationId: 942,
    latitude: 55.3394208967,
    longitude: -131.6416168213,
  },
  {
    sortOrder: 141,
    selectable: true,
    destinationUrlName: 'Key-Largo',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.276.23475',
    parentId: 276,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Key Largo',
    destinationId: 23475,
    latitude: 25.086515,
    longitude: -80.44728,
  },
  {
    sortOrder: 142,
    selectable: true,
    destinationUrlName: 'Key-West',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.276.661',
    parentId: 276,
    timeZone: 'America/New_York',
    iataCode: 'EYW',
    destinationType: 'CITY',
    destinationName: 'Key West',
    destinationId: 661,
    latitude: 24.5557025,
    longitude: -81.7825914,
  },
  {
    sortOrder: 143,
    selectable: true,
    destinationUrlName: 'Kingman',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.271.50726',
    parentId: 271,
    timeZone: 'America/Phoenix',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kingman',
    destinationId: 50726,
    latitude: 35.189812,
    longitude: -114.060669,
  },
  {
    sortOrder: 144,
    selectable: true,
    destinationUrlName: 'Knoxville',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.295.32982',
    parentId: 295,
    timeZone: 'America/New_York',
    iataCode: 'TYS',
    destinationType: 'CITY',
    destinationName: 'Knoxville',
    destinationId: 32982,
    latitude: 35.959805,
    longitude: -83.925976,
  },
  {
    sortOrder: 145,
    selectable: true,
    destinationUrlName: 'Lafayette',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22168.27791',
    parentId: 22168,
    timeZone: 'America/Chicago',
    iataCode: 'LAF',
    destinationType: 'CITY',
    destinationName: 'Lafayette',
    destinationId: 27791,
    latitude: 30.22409,
    longitude: -92.01984,
  },
  {
    sortOrder: 146,
    selectable: true,
    destinationUrlName: 'Laguna-Beach',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.23855',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Laguna Beach',
    destinationId: 23855,
    latitude: 33.542248,
    longitude: -117.78311,
  },
  {
    sortOrder: 147,
    selectable: true,
    destinationUrlName: 'La-Jolla',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.22636',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'La Jolla',
    destinationId: 22636,
    latitude: 32.83281,
    longitude: -117.27127,
  },
  {
    sortOrder: 148,
    selectable: true,
    destinationUrlName: 'Lake-Havasu',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.271.50753',
    parentId: 271,
    timeZone: 'America/Phoenix',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lake Havasu',
    destinationId: 50753,
    latitude: 34.49614,
    longitude: -114.348953,
  },
  {
    sortOrder: 149,
    selectable: true,
    destinationUrlName: 'Lake-Tahoe',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.816',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: 'RNO',
    destinationType: 'CITY',
    destinationName: 'Lake Tahoe',
    destinationId: 816,
    latitude: 39.1272558,
    longitude: -120.0202964,
  },
  {
    sortOrder: 150,
    selectable: true,
    destinationUrlName: 'Lanai',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.278.50815',
    parentId: 278,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lanai',
    destinationId: 50815,
    latitude: 20.8289083,
    longitude: -156.927093,
  },
  {
    sortOrder: 151,
    selectable: true,
    destinationUrlName: 'Lancaster',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.293.24305',
    parentId: 293,
    timeZone: 'America/New_York',
    iataCode: 'LNS',
    destinationType: 'CITY',
    destinationName: 'Lancaster',
    destinationId: 24305,
    latitude: 40.037875,
    longitude: -76.305514,
  },
  {
    sortOrder: 152,
    selectable: true,
    destinationUrlName: 'Las-Vegas',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22171.684',
    parentId: 22171,
    timeZone: 'America/Los_Angeles',
    iataCode: 'LAS',
    destinationType: 'CITY',
    destinationName: 'Las Vegas',
    destinationId: 684,
    latitude: 36.114646,
    longitude: -115.172816,
  },
  {
    sortOrder: 153,
    selectable: true,
    destinationUrlName: 'Leavenworth',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.298.50809',
    parentId: 298,
    timeZone: 'America/Los_Angeles',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Leavenworth',
    destinationId: 50809,
    latitude: 47.592789,
    longitude: -120.667648,
  },
  {
    sortOrder: 154,
    selectable: true,
    destinationUrlName: 'Lexington',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22325.25316',
    parentId: 22325,
    timeZone: 'America/New_York',
    iataCode: 'LEX',
    destinationType: 'CITY',
    destinationName: 'Lexington',
    destinationId: 25316,
    latitude: 38.040584,
    longitude: -84.503716,
  },
  {
    sortOrder: 155,
    selectable: true,
    destinationUrlName: 'Lincoln-City',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5064.50785',
    parentId: 5064,
    timeZone: 'America/Los_Angeles',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lincoln City',
    destinationId: 50785,
    latitude: 44.973862,
    longitude: -124.013428,
  },
  {
    sortOrder: 156,
    selectable: true,
    destinationUrlName: 'Little-Rock',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22213.50756',
    parentId: 22213,
    timeZone: 'America/Chicago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Little Rock',
    destinationId: 50756,
    latitude: 34.746483,
    longitude: -92.289597,
  },
  {
    sortOrder: 157,
    selectable: true,
    destinationUrlName: 'Long-Beach',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.5409',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: 'LGB',
    destinationType: 'CITY',
    destinationName: 'Long Beach',
    destinationId: 5409,
    latitude: 33.7683,
    longitude: -118.1956,
  },
  {
    sortOrder: 158,
    selectable: true,
    destinationUrlName: 'Long-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5560.23788',
    parentId: 5560,
    timeZone: 'America/New_York',
    iataCode: 'LIJ',
    destinationType: 'CITY',
    destinationName: 'Long Island',
    destinationId: 23788,
    latitude: 40.789142,
    longitude: -73.134961,
  },
  {
    sortOrder: 159,
    selectable: true,
    destinationUrlName: 'Los-Angeles',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.645',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: 'LAX',
    destinationType: 'CITY',
    destinationName: 'Los Angeles',
    destinationId: 645,
    latitude: 34.05223,
    longitude: -118.24368,
  },
  {
    sortOrder: 160,
    selectable: true,
    destinationUrlName: 'Louisville',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22325.25791',
    parentId: 22325,
    timeZone: 'America/Kentucky/Louisville',
    iataCode: 'SDF',
    destinationType: 'CITY',
    destinationName: 'Louisville',
    destinationId: 25791,
    latitude: 38.252665,
    longitude: -85.758456,
  },
  {
    sortOrder: 161,
    selectable: true,
    destinationUrlName: 'Mackinaw-City',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22219.22876',
    parentId: 22219,
    timeZone: 'America/Detroit',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mackinaw City',
    destinationId: 22876,
    latitude: 45.777563,
    longitude: -84.724876,
  },
  {
    sortOrder: 162,
    selectable: true,
    destinationUrlName: 'Madison',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22231.24146',
    parentId: 22231,
    timeZone: 'America/Chicago',
    iataCode: 'MSN',
    destinationType: 'CITY',
    destinationName: 'Madison',
    destinationId: 24146,
    latitude: 43.073052,
    longitude: -89.40123,
  },
  {
    sortOrder: 163,
    selectable: true,
    destinationUrlName: 'Malibu',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.25704',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Malibu',
    destinationId: 25704,
    latitude: 34.025922,
    longitude: -118.779757,
  },
  {
    sortOrder: 164,
    selectable: true,
    destinationUrlName: 'Mammoth-Lakes',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.25075',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mammoth Lakes',
    destinationId: 25075,
    latitude: 37.648546,
    longitude: -118.972079,
  },
  {
    sortOrder: 165,
    selectable: true,
    destinationUrlName: 'Manassas',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22229.24845',
    parentId: 22229,
    timeZone: 'America/New_York',
    iataCode: 'MNZ',
    destinationType: 'CITY',
    destinationName: 'Manassas',
    destinationId: 24845,
    latitude: 38.7479,
    longitude: -77.4838,
  },
  {
    sortOrder: 166,
    selectable: true,
    destinationUrlName: 'Manchester',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22223.23341',
    parentId: 22223,
    timeZone: 'America/New_York',
    iataCode: 'MAN',
    destinationType: 'CITY',
    destinationName: 'Manchester',
    destinationId: 23341,
    latitude: 42.99564,
    longitude: -71.454789,
  },
  {
    sortOrder: 167,
    selectable: true,
    destinationUrlName: 'Marble-Falls',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.296.50074',
    parentId: 296,
    timeZone: 'America/Chicago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Marble Falls',
    destinationId: 50074,
    latitude: 30.5899073,
    longitude: -98.3056197,
  },
  {
    sortOrder: 168,
    selectable: true,
    destinationUrlName: 'Marfa',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.296.50794',
    parentId: 296,
    timeZone: 'America/Chicago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Marfa',
    destinationId: 50794,
    latitude: 30.30945,
    longitude: -104.020638,
  },
  {
    sortOrder: 169,
    selectable: true,
    destinationUrlName: 'Marthas-Vineyard',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22172.50772',
    parentId: 22172,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: "Martha's Vineyard",
    destinationId: 50772,
    latitude: 41.39278,
    longitude: -70.6082,
  },
  {
    sortOrder: 170,
    selectable: true,
    destinationUrlName: 'Maui',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.278.671',
    parentId: 278,
    timeZone: 'Pacific/Honolulu',
    iataCode: 'OGG',
    destinationType: 'CITY',
    destinationName: 'Maui',
    destinationId: 671,
    latitude: 20.8931357834,
    longitude: -156.4655685425,
  },
  {
    sortOrder: 171,
    selectable: true,
    destinationUrlName: 'McCall',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22215.22361',
    parentId: 22215,
    timeZone: 'America/Boise',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'McCall',
    destinationId: 22361,
    latitude: 44.911,
    longitude: -116.0987,
  },
  {
    sortOrder: 172,
    selectable: true,
    destinationUrlName: 'Memphis',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.295.783',
    parentId: 295,
    timeZone: 'America/Chicago',
    iataCode: 'MEM',
    destinationType: 'CITY',
    destinationName: 'Memphis',
    destinationId: 783,
    latitude: 35.1495343,
    longitude: -90.0489801,
  },
  {
    sortOrder: 173,
    selectable: true,
    destinationUrlName: 'Mendocino',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.50761',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mendocino',
    destinationId: 50761,
    latitude: 39.305168,
    longitude: -123.79821,
  },
  {
    sortOrder: 174,
    selectable: true,
    destinationUrlName: 'Miami',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.276.662',
    parentId: 276,
    timeZone: 'America/New_York',
    iataCode: 'MIA',
    destinationType: 'CITY',
    destinationName: 'Miami',
    destinationId: 662,
    latitude: 25.7836623106,
    longitude: -80.1908397675,
  },
  {
    sortOrder: 175,
    selectable: true,
    destinationUrlName: 'Milwaukee',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22231.22412',
    parentId: 22231,
    timeZone: 'America/Chicago',
    iataCode: 'MKE',
    destinationType: 'CITY',
    destinationName: 'Milwaukee',
    destinationId: 22412,
    latitude: 43.0389,
    longitude: -87.90647,
  },
  {
    sortOrder: 176,
    selectable: true,
    destinationUrlName: 'Minneapolis-Saint-Paul',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22206.22209',
    parentId: 22206,
    timeZone: 'America/Chicago',
    iataCode: 'MSP',
    destinationType: 'CITY',
    destinationName: 'Minneapolis-Saint Paul',
    destinationId: 22209,
    latitude: 44.97775,
    longitude: -93.26501,
  },
  {
    sortOrder: 177,
    selectable: true,
    destinationUrlName: 'Moab',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.785.5600',
    parentId: 785,
    timeZone: 'US/Mountain',
    iataCode: 'CNY',
    destinationType: 'CITY',
    destinationName: 'Moab',
    destinationId: 5600,
    latitude: 38.573315,
    longitude: -109.54984,
  },
  {
    sortOrder: 178,
    selectable: true,
    destinationUrlName: 'Mobile',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22212.4377',
    parentId: 22212,
    timeZone: 'America/Chicago',
    iataCode: 'MOB',
    destinationType: 'CITY',
    destinationName: 'Mobile',
    destinationId: 4377,
    latitude: 30.69537,
    longitude: -88.03989,
  },
  {
    sortOrder: 179,
    selectable: true,
    destinationUrlName: 'Monterey-and-Carmel',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.5250',
    parentId: 272,
    timeZone: 'US/Pacific',
    iataCode: 'MRY',
    destinationType: 'CITY',
    destinationName: 'Monterey & Carmel',
    destinationId: 5250,
    latitude: 36.600238,
    longitude: -121.894676,
  },
  {
    sortOrder: 180,
    selectable: true,
    destinationUrlName: 'Montgomery',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22212.50136',
    parentId: 22212,
    timeZone: 'America/Chicago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Montgomery',
    destinationId: 50136,
    latitude: 32.376541,
    longitude: -86.29966,
  },
  {
    sortOrder: 181,
    selectable: true,
    destinationUrlName: 'Monument-Valley',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.785.24945',
    parentId: 785,
    timeZone: 'America/Denver',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Monument Valley',
    destinationId: 24945,
    latitude: 36.998028,
    longitude: -110.098457,
  },
  {
    sortOrder: 182,
    selectable: true,
    destinationUrlName: 'Mount-Pleasant',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.294.50740',
    parentId: 294,
    timeZone: 'America/Kentucky/Monticello',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mount Pleasant',
    destinationId: 50740,
    latitude: 32.79044,
    longitude: -79.8765,
  },
  {
    sortOrder: 183,
    selectable: true,
    destinationUrlName: 'Myrtle-Beach',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.294.5217',
    parentId: 294,
    timeZone: 'US/Eastern',
    iataCode: 'MYR',
    destinationType: 'CITY',
    destinationName: 'Myrtle Beach',
    destinationId: 5217,
    latitude: 33.6889,
    longitude: -78.8869,
  },
  {
    sortOrder: 184,
    selectable: true,
    destinationUrlName: 'Mystic',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22214.23483',
    parentId: 22214,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mystic',
    destinationId: 23483,
    latitude: 41.354266,
    longitude: -71.966462,
  },
  {
    sortOrder: 185,
    selectable: true,
    destinationUrlName: 'Nantucket',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22172.50773',
    parentId: 22172,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nantucket',
    destinationId: 50773,
    latitude: 41.28347,
    longitude: -70.099449,
  },
  {
    sortOrder: 186,
    selectable: true,
    destinationUrlName: 'Napa-and-Sonoma',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.914',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: 'SFO',
    destinationType: 'CITY',
    destinationName: 'Napa & Sonoma',
    destinationId: 914,
    latitude: 38.3047222,
    longitude: -122.2988889,
  },
  {
    sortOrder: 187,
    selectable: true,
    destinationUrlName: 'Naples',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.276.22381',
    parentId: 276,
    timeZone: 'America/New_York',
    iataCode: 'APF',
    destinationType: 'CITY',
    destinationName: 'Naples',
    destinationId: 22381,
    latitude: 26.142036,
    longitude: -81.79481,
  },
  {
    sortOrder: 188,
    selectable: true,
    destinationUrlName: 'Nashville',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.295.799',
    parentId: 295,
    timeZone: 'America/Chicago',
    iataCode: 'BNA',
    destinationType: 'CITY',
    destinationName: 'Nashville',
    destinationId: 799,
    latitude: 36.1658899,
    longitude: -86.7844432,
  },
  {
    sortOrder: 189,
    selectable: true,
    destinationUrlName: 'Newark',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22324.22848',
    parentId: 22324,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Newark',
    destinationId: 22848,
    latitude: 40.735657,
    longitude: -74.172367,
  },
  {
    sortOrder: 190,
    selectable: true,
    destinationUrlName: 'New-Haven',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22214.23481',
    parentId: 22214,
    timeZone: 'America/New_York',
    iataCode: 'HVN',
    destinationType: 'CITY',
    destinationName: 'New Haven',
    destinationId: 23481,
    latitude: 41.308274,
    longitude: -72.927884,
  },
  {
    sortOrder: 191,
    selectable: true,
    destinationUrlName: 'New-Hope',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.293.24782',
    parentId: 293,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'New Hope',
    destinationId: 24782,
    latitude: 40.364273,
    longitude: -74.951279,
  },
  {
    sortOrder: 192,
    selectable: true,
    destinationUrlName: 'New-London',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22214.23486',
    parentId: 22214,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'New London',
    destinationId: 23486,
    latitude: 41.3556,
    longitude: -72.0998,
  },
  {
    sortOrder: 193,
    selectable: true,
    destinationUrlName: 'New-Orleans',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22168.675',
    parentId: 22168,
    timeZone: 'America/Chicago',
    iataCode: 'MSY',
    destinationType: 'CITY',
    destinationName: 'New Orleans',
    destinationId: 675,
    latitude: 29.9351142253,
    longitude: -90.0638151169,
  },
  {
    sortOrder: 194,
    selectable: true,
    destinationUrlName: 'Newport',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5266.4380',
    parentId: 5266,
    timeZone: 'US/Eastern',
    iataCode: 'PVD',
    destinationType: 'CITY',
    destinationName: 'Newport',
    destinationId: 4380,
    latitude: 41.4901024,
    longitude: -71.3128285,
  },
  {
    sortOrder: 195,
    selectable: true,
    destinationUrlName: 'Newport-Beach',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.26104',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Newport Beach',
    destinationId: 26104,
    latitude: 33.61891,
    longitude: -117.928947,
  },
  {
    sortOrder: 196,
    selectable: true,
    destinationUrlName: 'New-York-City',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5560.687',
    parentId: 5560,
    timeZone: 'America/New_York',
    iataCode: 'NYC',
    destinationType: 'CITY',
    destinationName: 'New York City',
    destinationId: 687,
    latitude: 40.7163629124,
    longitude: -74.0132188797,
  },
  {
    sortOrder: 197,
    selectable: true,
    destinationUrlName: 'Niagara-Falls',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5560.23183',
    parentId: 5560,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Niagara Falls',
    destinationId: 23183,
    latitude: 43.09621,
    longitude: -79.03774,
  },
  {
    sortOrder: 198,
    selectable: true,
    destinationUrlName: 'Norfolk',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22229.22447',
    parentId: 22229,
    timeZone: 'America/New_York',
    iataCode: 'ORF',
    destinationType: 'CITY',
    destinationName: 'Norfolk',
    destinationId: 22447,
    latitude: 36.85077,
    longitude: -76.28587,
  },
  {
    sortOrder: 199,
    selectable: true,
    destinationUrlName: 'Oahu',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.278.672',
    parentId: 278,
    timeZone: 'Pacific/Honolulu',
    iataCode: 'HNL',
    destinationType: 'CITY',
    destinationName: 'Oahu',
    destinationId: 672,
    latitude: 21.3923440712,
    longitude: -157.9820251465,
  },
  {
    sortOrder: 200,
    selectable: true,
    destinationUrlName: 'Oakland',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.22040',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: 'OAK',
    destinationType: 'CITY',
    destinationName: 'Oakland',
    destinationId: 22040,
    latitude: 37.804364,
    longitude: -122.271114,
  },
  {
    sortOrder: 201,
    selectable: true,
    destinationUrlName: 'Ocean-City',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.282.24781',
    parentId: 282,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ocean City',
    destinationId: 24781,
    latitude: 39.2776,
    longitude: -74.5746,
  },
  {
    sortOrder: 202,
    selectable: true,
    destinationUrlName: 'Ogden',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.785.50800',
    parentId: 785,
    timeZone: 'America/Denver',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ogden',
    destinationId: 50800,
    latitude: 41.222759,
    longitude: -111.970421,
  },
  {
    sortOrder: 203,
    selectable: true,
    destinationUrlName: 'Oklahoma-City',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22227.28077',
    parentId: 22227,
    timeZone: 'America/Chicago',
    iataCode: 'OKC',
    destinationType: 'CITY',
    destinationName: 'Oklahoma City',
    destinationId: 28077,
    latitude: 35.46756,
    longitude: -97.51643,
  },
  {
    sortOrder: 204,
    selectable: true,
    destinationUrlName: 'Olympic-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.298.50807',
    parentId: 298,
    timeZone: 'America/Los_Angeles',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Olympic National Park',
    destinationId: 50807,
    latitude: 48.242321,
    longitude: -124.525742,
  },
  {
    sortOrder: 205,
    selectable: true,
    destinationUrlName: 'Omaha',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22222.50637',
    parentId: 22222,
    timeZone: 'America/Chicago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Omaha',
    destinationId: 50637,
    latitude: 41.258652,
    longitude: -95.937187,
  },
  {
    sortOrder: 206,
    selectable: true,
    destinationUrlName: 'Orange-Beach',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22212.50751',
    parentId: 22212,
    timeZone: 'America/Chicago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Orange Beach',
    destinationId: 50751,
    latitude: 30.29211,
    longitude: -87.579178,
  },
  {
    sortOrder: 207,
    selectable: true,
    destinationUrlName: 'Orlando',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.276.663',
    parentId: 276,
    timeZone: 'America/New_York',
    iataCode: 'ORL',
    destinationType: 'CITY',
    destinationName: 'Orlando',
    destinationId: 663,
    latitude: 28.5383355,
    longitude: -81.3792365,
  },
  {
    sortOrder: 208,
    selectable: true,
    destinationUrlName: 'Outer-Banks',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5283.26783',
    parentId: 5283,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Outer Banks',
    destinationId: 26783,
    latitude: 35.55849,
    longitude: -75.46652,
  },
  {
    sortOrder: 209,
    selectable: true,
    destinationUrlName: 'Page',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.271.23393',
    parentId: 271,
    timeZone: 'America/Denver',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Page',
    destinationId: 23393,
    latitude: 36.9147,
    longitude: -111.4558,
  },
  {
    sortOrder: 210,
    selectable: true,
    destinationUrlName: 'Pagosa-Springs',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.273.23315',
    parentId: 273,
    timeZone: 'America/Denver',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Pagosa Springs',
    destinationId: 23315,
    latitude: 37.26945,
    longitude: -107.009762,
  },
  {
    sortOrder: 211,
    selectable: true,
    destinationUrlName: 'Palm-Springs',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.648',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: 'PSP',
    destinationType: 'CITY',
    destinationName: 'Palm Springs',
    destinationId: 648,
    latitude: 33.8302961,
    longitude: -116.5452921,
  },
  {
    sortOrder: 212,
    selectable: true,
    destinationUrlName: 'Panama-City-Beach',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.276.22828',
    parentId: 276,
    timeZone: 'America/Chicago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Panama City Beach',
    destinationId: 22828,
    latitude: 30.176591,
    longitude: -85.805488,
  },
  {
    sortOrder: 213,
    selectable: true,
    destinationUrlName: 'Park-City',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.785.22368',
    parentId: 785,
    timeZone: 'America/Denver',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Park City',
    destinationId: 22368,
    latitude: 40.646062,
    longitude: -111.497973,
  },
  {
    sortOrder: 214,
    selectable: true,
    destinationUrlName: 'Paso-Robles',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.24369',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Paso Robles',
    destinationId: 24369,
    latitude: 35.636876,
    longitude: -120.654502,
  },
  {
    sortOrder: 215,
    selectable: true,
    destinationUrlName: 'Pensacola',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.276.23182',
    parentId: 276,
    timeZone: 'America/Chicago',
    iataCode: 'PNS',
    destinationType: 'CITY',
    destinationName: 'Pensacola',
    destinationId: 23182,
    latitude: 30.421309,
    longitude: -87.216915,
  },
  {
    sortOrder: 216,
    selectable: true,
    destinationUrlName: 'Philadelphia',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.293.906',
    parentId: 293,
    timeZone: 'America/New_York',
    iataCode: 'PHL',
    destinationType: 'CITY',
    destinationName: 'Philadelphia',
    destinationId: 906,
    latitude: 39.952335,
    longitude: -75.163789,
  },
  {
    sortOrder: 217,
    selectable: true,
    destinationUrlName: 'Phoenix',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.271.639',
    parentId: 271,
    timeZone: 'America/Phoenix',
    iataCode: 'PHX',
    destinationType: 'CITY',
    destinationName: 'Phoenix',
    destinationId: 639,
    latitude: 33.4483771,
    longitude: -112.0740373,
  },
  {
    sortOrder: 218,
    selectable: true,
    destinationUrlName: 'Pigeon-Forge',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.295.22823',
    parentId: 295,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Pigeon Forge',
    destinationId: 22823,
    latitude: 35.78842,
    longitude: -83.55433,
  },
  {
    sortOrder: 219,
    selectable: true,
    destinationUrlName: 'Pismo-Beach',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.50729',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Pismo Beach',
    destinationId: 50729,
    latitude: 35.1413,
    longitude: -120.64208,
  },
  {
    sortOrder: 220,
    selectable: true,
    destinationUrlName: 'Pittsburgh',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.293.22639',
    parentId: 293,
    timeZone: 'America/New_York',
    iataCode: 'PIT',
    destinationType: 'CITY',
    destinationName: 'Pittsburgh',
    destinationId: 22639,
    latitude: 40.44062,
    longitude: -79.99589,
  },
  {
    sortOrder: 221,
    selectable: true,
    destinationUrlName: 'Plymouth',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22172.50557',
    parentId: 22172,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Plymouth',
    destinationId: 50557,
    latitude: 41.95575,
    longitude: -70.664391,
  },
  {
    sortOrder: 222,
    selectable: true,
    destinationUrlName: 'Pocono-Mountains',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.293.26420',
    parentId: 293,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Pocono Mountains',
    destinationId: 26420,
    latitude: 41.71501,
    longitude: -75.56047,
  },
  {
    sortOrder: 223,
    selectable: true,
    destinationUrlName: 'Port-Angeles',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.298.4390',
    parentId: 298,
    timeZone: 'America/Los_Angeles',
    iataCode: 'CLM',
    destinationType: 'CITY',
    destinationName: 'Port Angeles',
    destinationId: 4390,
    latitude: 48.118146,
    longitude: -123.430741,
  },
  {
    sortOrder: 224,
    selectable: true,
    destinationUrlName: 'Port-Aransas',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.296.50797',
    parentId: 296,
    timeZone: 'America/Chicago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Port Aransas',
    destinationId: 50797,
    latitude: 27.83247,
    longitude: -97.063202,
  },
  {
    sortOrder: 225,
    selectable: true,
    destinationUrlName: 'Portland',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.21458.4382',
    parentId: 21458,
    timeZone: 'America/New_York',
    iataCode: 'PWM',
    destinationType: 'CITY',
    destinationName: 'Portland',
    destinationId: 4382,
    latitude: 43.66147,
    longitude: -70.25533,
  },
  {
    sortOrder: 226,
    selectable: true,
    destinationUrlName: 'Portland',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5064.5065',
    parentId: 5064,
    timeZone: 'US/Pacific',
    iataCode: 'PDX',
    destinationType: 'CITY',
    destinationName: 'Portland',
    destinationId: 5065,
    latitude: 45.5234515,
    longitude: -122.6762071,
  },
  {
    sortOrder: 227,
    selectable: true,
    destinationUrlName: 'Portsmouth',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22223.24529',
    parentId: 22223,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Portsmouth',
    destinationId: 24529,
    latitude: 43.0718,
    longitude: -70.7626,
  },
  {
    sortOrder: 228,
    selectable: true,
    destinationUrlName: 'Prescott',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.271.50754',
    parentId: 271,
    timeZone: 'America/Phoenix',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Prescott',
    destinationId: 50754,
    latitude: 34.541851,
    longitude: -112.468712,
  },
  {
    sortOrder: 229,
    selectable: true,
    destinationUrlName: 'Providence',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5266.22849',
    parentId: 5266,
    timeZone: 'America/New_York',
    iataCode: 'PVD',
    destinationType: 'CITY',
    destinationName: 'Providence',
    destinationId: 22849,
    latitude: 41.8234,
    longitude: -71.412288,
  },
  {
    sortOrder: 230,
    selectable: true,
    destinationUrlName: 'Provo',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.785.50801',
    parentId: 785,
    timeZone: 'America/Denver',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Provo',
    destinationId: 50801,
    latitude: 40.233845,
    longitude: -111.658531,
  },
  {
    sortOrder: 231,
    selectable: true,
    destinationUrlName: 'Raleigh',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5283.33621',
    parentId: 5283,
    timeZone: 'America/New_York',
    iataCode: 'RDU',
    destinationType: 'CITY',
    destinationName: 'Raleigh',
    destinationId: 33621,
    latitude: 35.781044,
    longitude: -78.632705,
  },
  {
    sortOrder: 232,
    selectable: true,
    destinationUrlName: 'Rapid-City',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22169.22170',
    parentId: 22169,
    timeZone: 'America/Denver',
    iataCode: 'RAP',
    destinationType: 'CITY',
    destinationName: 'Rapid City',
    destinationId: 22170,
    latitude: 44.080543,
    longitude: -103.231015,
  },
  {
    sortOrder: 233,
    selectable: true,
    destinationUrlName: 'Rehoboth-Beach',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22775.23416',
    parentId: 22775,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Rehoboth Beach',
    destinationId: 23416,
    latitude: 38.720945,
    longitude: -75.076014,
  },
  {
    sortOrder: 234,
    selectable: true,
    destinationUrlName: 'Reno',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22171.23010',
    parentId: 22171,
    timeZone: 'America/Los_Angeles',
    iataCode: 'RNO',
    destinationType: 'CITY',
    destinationName: 'Reno',
    destinationId: 23010,
    latitude: 39.529633,
    longitude: -119.813803,
  },
  {
    sortOrder: 235,
    selectable: true,
    destinationUrlName: 'Richmond',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22229.23016',
    parentId: 22229,
    timeZone: 'America/New_York',
    iataCode: 'RIC',
    destinationType: 'CITY',
    destinationName: 'Richmond',
    destinationId: 23016,
    latitude: 37.54072,
    longitude: -77.43605,
  },
  {
    sortOrder: 236,
    selectable: true,
    destinationUrlName: 'Roanoke',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22229.24759',
    parentId: 22229,
    timeZone: 'America/New_York',
    iataCode: 'ROA',
    destinationType: 'CITY',
    destinationName: 'Roanoke',
    destinationId: 24759,
    latitude: 37.27097,
    longitude: -79.941427,
  },
  {
    sortOrder: 237,
    selectable: true,
    destinationUrlName: 'Rochester',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5560.23068',
    parentId: 5560,
    timeZone: 'America/New_York',
    iataCode: 'ROC',
    destinationType: 'CITY',
    destinationName: 'Rochester',
    destinationId: 23068,
    latitude: 43.16103,
    longitude: -77.610922,
  },
  {
    sortOrder: 238,
    selectable: true,
    destinationUrlName: 'Rocky-Mountain-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.273.51194',
    parentId: 273,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Rocky Mountain National Park',
    destinationId: 51194,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 239,
    selectable: true,
    destinationUrlName: 'Sacramento',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.22319',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: 'SAC',
    destinationType: 'CITY',
    destinationName: 'Sacramento',
    destinationId: 22319,
    latitude: 38.58157,
    longitude: -121.4944,
  },
  {
    sortOrder: 240,
    selectable: true,
    destinationUrlName: 'Salem',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22172.22414',
    parentId: 22172,
    timeZone: 'America/New_York',
    iataCode: 'SLE',
    destinationType: 'CITY',
    destinationName: 'Salem',
    destinationId: 22414,
    latitude: 42.51954,
    longitude: -70.89672,
  },
  {
    sortOrder: 241,
    selectable: true,
    destinationUrlName: 'Salt-Lake-City',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.785.5200',
    parentId: 785,
    timeZone: 'US/Mountain',
    iataCode: 'SLC',
    destinationType: 'CITY',
    destinationName: 'Salt Lake City',
    destinationId: 5200,
    latitude: 40.762581,
    longitude: -111.90102,
  },
  {
    sortOrder: 242,
    selectable: true,
    destinationUrlName: 'San-Antonio',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.296.910',
    parentId: 296,
    timeZone: 'America/Chicago',
    iataCode: 'SAT',
    destinationType: 'CITY',
    destinationName: 'San Antonio',
    destinationId: 910,
    latitude: 29.4241219,
    longitude: -98.4936282,
  },
  {
    sortOrder: 243,
    selectable: true,
    destinationUrlName: 'San-Diego',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.736',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: 'SAN',
    destinationType: 'CITY',
    destinationName: 'San Diego',
    destinationId: 736,
    latitude: 32.711766573,
    longitude: -117.164812088,
  },
  {
    sortOrder: 244,
    selectable: true,
    destinationUrlName: 'Sandusky',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22226.29093',
    parentId: 22226,
    timeZone: 'America/New_York',
    iataCode: 'SKY',
    destinationType: 'CITY',
    destinationName: 'Sandusky',
    destinationId: 29093,
    latitude: 41.44894,
    longitude: -82.70796,
  },
  {
    sortOrder: 245,
    selectable: true,
    destinationUrlName: 'San-Francisco',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.651',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: 'SFO',
    destinationType: 'CITY',
    destinationName: 'San Francisco',
    destinationId: 651,
    latitude: 37.7947962975,
    longitude: -122.4000549316,
  },
  {
    sortOrder: 246,
    selectable: true,
    destinationUrlName: 'San-Jose',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.25463',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: 'SJC',
    destinationType: 'CITY',
    destinationName: 'San Jose',
    destinationId: 25463,
    latitude: 37.33939,
    longitude: -121.89496,
  },
  {
    sortOrder: 247,
    selectable: true,
    destinationUrlName: 'San-Juan-Islands',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.298.30630',
    parentId: 298,
    timeZone: 'America/Los_Angeles',
    iataCode: 'FRD',
    destinationType: 'CITY',
    destinationName: 'San Juan Islands',
    destinationId: 30630,
    latitude: 48.55137,
    longitude: -123.07811,
  },
  {
    sortOrder: 248,
    selectable: true,
    destinationUrlName: 'San-Luis-Obispo',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.33000',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: 'SBP',
    destinationType: 'CITY',
    destinationName: 'San Luis Obispo',
    destinationId: 33000,
    latitude: 35.282251,
    longitude: -120.660046,
  },
  {
    sortOrder: 249,
    selectable: true,
    destinationUrlName: 'Santa-Barbara',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.4372',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: 'SBA',
    destinationType: 'CITY',
    destinationName: 'Santa Barbara',
    destinationId: 4372,
    latitude: 34.425833,
    longitude: -119.714167,
  },
  {
    sortOrder: 250,
    selectable: true,
    destinationUrlName: 'Santa-Cruz',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.23518',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Santa Cruz',
    destinationId: 23518,
    latitude: 36.974117,
    longitude: -122.030796,
  },
  {
    sortOrder: 251,
    selectable: true,
    destinationUrlName: 'Santa-Fe',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22224.22369',
    parentId: 22224,
    timeZone: 'America/Denver',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Santa Fe',
    destinationId: 22369,
    latitude: 35.686975,
    longitude: -105.937799,
  },
  {
    sortOrder: 252,
    selectable: true,
    destinationUrlName: 'Santa-Monica',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.32539',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: 'SMO',
    destinationType: 'CITY',
    destinationName: 'Santa Monica',
    destinationId: 32539,
    latitude: 34.016032,
    longitude: -118.496164,
  },
  {
    sortOrder: 253,
    selectable: true,
    destinationUrlName: 'Santa-Rosa',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.22662',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: 'STS',
    destinationType: 'CITY',
    destinationName: 'Santa Rosa',
    destinationId: 22662,
    latitude: 38.44043,
    longitude: -122.71405,
  },
  {
    sortOrder: 254,
    selectable: true,
    destinationUrlName: 'Sarasota',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.276.25738',
    parentId: 276,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sarasota',
    destinationId: 25738,
    latitude: 27.336435,
    longitude: -82.530653,
  },
  {
    sortOrder: 255,
    selectable: true,
    destinationUrlName: 'Sausalito',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.32779',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: 'NOT',
    destinationType: 'CITY',
    destinationName: 'Sausalito',
    destinationId: 32779,
    latitude: 37.858819,
    longitude: -122.4938,
  },
  {
    sortOrder: 256,
    selectable: true,
    destinationUrlName: 'Savannah',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.277.5166',
    parentId: 277,
    timeZone: 'US/Eastern',
    iataCode: 'SAV',
    destinationType: 'CITY',
    destinationName: 'Savannah',
    destinationId: 5166,
    latitude: 32.083541,
    longitude: -81.099834,
  },
  {
    sortOrder: 257,
    selectable: true,
    destinationUrlName: 'Scottsdale',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.271.38685',
    parentId: 271,
    timeZone: 'America/Phoenix',
    iataCode: 'SCF',
    destinationType: 'CITY',
    destinationName: 'Scottsdale',
    destinationId: 38685,
    latitude: 33.6738933,
    longitude: -112.1393414,
  },
  {
    sortOrder: 258,
    selectable: true,
    destinationUrlName: 'Seattle',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.298.704',
    parentId: 298,
    timeZone: 'America/Los_Angeles',
    iataCode: 'SEA',
    destinationType: 'CITY',
    destinationName: 'Seattle',
    destinationId: 704,
    latitude: 47.6039061034,
    longitude: -122.3373126984,
  },
  {
    sortOrder: 259,
    selectable: true,
    destinationUrlName: 'Sedona',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.271.750',
    parentId: 271,
    timeZone: 'America/Phoenix',
    iataCode: 'FLG',
    destinationType: 'CITY',
    destinationName: 'Sedona',
    destinationId: 750,
    latitude: 34.85867,
    longitude: -111.76321,
  },
  {
    sortOrder: 260,
    selectable: true,
    destinationUrlName: 'Sequoia-and-Kings-Canyon-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.50760',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sequoia and Kings Canyon National Park',
    destinationId: 50760,
    latitude: 36.832581,
    longitude: -118.259087,
  },
  {
    sortOrder: 261,
    selectable: true,
    destinationUrlName: 'Sevierville',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.295.50562',
    parentId: 295,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sevierville',
    destinationId: 50562,
    latitude: 35.868382,
    longitude: -83.562981,
  },
  {
    sortOrder: 262,
    selectable: true,
    destinationUrlName: 'Seward',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.270.4368',
    parentId: 270,
    timeZone: 'America/Juneau',
    iataCode: 'SWD',
    destinationType: 'CITY',
    destinationName: 'Seward',
    destinationId: 4368,
    latitude: 60.124444,
    longitude: -149.433333,
  },
  {
    sortOrder: 263,
    selectable: true,
    destinationUrlName: 'Sioux-Falls',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22169.50792',
    parentId: 22169,
    timeZone: 'America/Chicago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sioux Falls',
    destinationId: 50792,
    latitude: 43.54731,
    longitude: -96.7313,
  },
  {
    sortOrder: 264,
    selectable: true,
    destinationUrlName: 'Sitka',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.270.4153',
    parentId: 270,
    timeZone: 'US/Alaska',
    iataCode: 'SIT',
    destinationType: 'CITY',
    destinationName: 'Sitka',
    destinationId: 4153,
    latitude: 57.0530556,
    longitude: -135.33,
  },
  {
    sortOrder: 265,
    selectable: true,
    destinationUrlName: 'Skagway',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.270.943',
    parentId: 270,
    timeZone: 'America/Anchorage',
    iataCode: 'SGY',
    destinationType: 'CITY',
    destinationName: 'Skagway',
    destinationId: 943,
    latitude: 59.4509650737,
    longitude: -135.3353404999,
  },
  {
    sortOrder: 266,
    selectable: true,
    destinationUrlName: 'Soldotna',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.270.26154',
    parentId: 270,
    timeZone: 'America/Anchorage',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Soldotna',
    destinationId: 26154,
    latitude: 60.487768,
    longitude: -151.056017,
  },
  {
    sortOrder: 267,
    selectable: true,
    destinationUrlName: 'South-Padre-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.296.22446',
    parentId: 296,
    timeZone: 'America/Chicago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'South Padre Island',
    destinationId: 22446,
    latitude: 26.11184,
    longitude: -97.168126,
  },
  {
    sortOrder: 268,
    selectable: true,
    destinationUrlName: 'St-Augustine',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.276.823',
    parentId: 276,
    timeZone: 'America/New_York',
    iataCode: 'UST',
    destinationType: 'CITY',
    destinationName: 'St Augustine',
    destinationId: 823,
    latitude: 29.8942639,
    longitude: -81.3132083,
  },
  {
    sortOrder: 269,
    selectable: true,
    destinationUrlName: 'Steamboat-Springs',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.273.26379',
    parentId: 273,
    timeZone: 'America/Denver',
    iataCode: 'SBS',
    destinationType: 'CITY',
    destinationName: 'Steamboat Springs',
    destinationId: 26379,
    latitude: 40.484977,
    longitude: -106.831716,
  },
  {
    sortOrder: 270,
    selectable: true,
    destinationUrlName: 'St-George',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.785.23945',
    parentId: 785,
    timeZone: 'America/Denver',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'St George',
    destinationId: 23945,
    latitude: 37.0965,
    longitude: -113.5684,
  },
  {
    sortOrder: 271,
    selectable: true,
    destinationUrlName: 'St-Louis',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5234.24780',
    parentId: 5234,
    timeZone: 'America/Chicago',
    iataCode: 'STL',
    destinationType: 'CITY',
    destinationName: 'St Louis',
    destinationId: 24780,
    latitude: 38.627003,
    longitude: -90.199404,
  },
  {
    sortOrder: 272,
    selectable: true,
    destinationUrlName: 'Stockton',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.22359',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: 'SCK',
    destinationType: 'CITY',
    destinationName: 'Stockton',
    destinationId: 22359,
    latitude: 37.957702,
    longitude: -121.29078,
  },
  {
    sortOrder: 273,
    selectable: true,
    destinationUrlName: 'St-Petersburg',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.276.5403',
    parentId: 276,
    timeZone: 'US/Eastern',
    iataCode: 'PIE',
    destinationType: 'CITY',
    destinationName: 'St Petersburg',
    destinationId: 5403,
    latitude: 27.75224,
    longitude: -82.631154,
  },
  {
    sortOrder: 274,
    selectable: true,
    destinationUrlName: 'Sturgeon-Bay',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22231.50810',
    parentId: 22231,
    timeZone: 'America/Chicago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sturgeon Bay',
    destinationId: 50810,
    latitude: 44.834209,
    longitude: -87.376266,
  },
  {
    sortOrder: 275,
    selectable: true,
    destinationUrlName: 'Sun-Valley',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22215.22317',
    parentId: 22215,
    timeZone: 'America/Boise',
    iataCode: 'SUN',
    destinationType: 'CITY',
    destinationName: 'Sun Valley',
    destinationId: 22317,
    latitude: 43.697425,
    longitude: -114.348886,
  },
  {
    sortOrder: 276,
    selectable: true,
    destinationUrlName: 'Surfside-Beach',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.294.50790',
    parentId: 294,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Surfside Beach',
    destinationId: 50790,
    latitude: 33.60875,
    longitude: -78.97702,
  },
  {
    sortOrder: 277,
    selectable: true,
    destinationUrlName: 'Syracuse',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5560.23062',
    parentId: 5560,
    timeZone: 'America/New_York',
    iataCode: 'SYR',
    destinationType: 'CITY',
    destinationName: 'Syracuse',
    destinationId: 23062,
    latitude: 43.0481,
    longitude: -76.1474,
  },
  {
    sortOrder: 278,
    selectable: true,
    destinationUrlName: 'Tallahassee',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.276.50893',
    parentId: 276,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tallahassee',
    destinationId: 50893,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 279,
    selectable: true,
    destinationUrlName: 'Tampa',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.276.666',
    parentId: 276,
    timeZone: 'America/New_York',
    iataCode: 'TPA',
    destinationType: 'CITY',
    destinationName: 'Tampa',
    destinationId: 666,
    latitude: 27.9424741768,
    longitude: -82.4541950226,
  },
  {
    sortOrder: 280,
    selectable: true,
    destinationUrlName: 'Taos',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22224.33082',
    parentId: 22224,
    timeZone: 'America/Denver',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Taos',
    destinationId: 33082,
    latitude: 36.407222,
    longitude: -105.572533,
  },
  {
    sortOrder: 281,
    selectable: true,
    destinationUrlName: 'Telluride',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.273.26378',
    parentId: 273,
    timeZone: 'America/Denver',
    iataCode: 'TEX',
    destinationType: 'CITY',
    destinationName: 'Telluride',
    destinationId: 26378,
    latitude: 37.937494,
    longitude: -107.812285,
  },
  {
    sortOrder: 282,
    selectable: true,
    destinationUrlName: 'Temecula',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.24203',
    parentId: 272,
    timeZone: 'America/Los_Angeles',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Temecula',
    destinationId: 24203,
    latitude: 33.49364,
    longitude: -117.14836,
  },
  {
    sortOrder: 283,
    selectable: true,
    destinationUrlName: 'The-Catskills',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5560.50779',
    parentId: 5560,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'The Catskills',
    destinationId: 50779,
    latitude: 42.40881,
    longitude: -74.617889,
  },
  {
    sortOrder: 284,
    selectable: true,
    destinationUrlName: 'The-Lake-of-the-Ozarks',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5234.50776',
    parentId: 5234,
    timeZone: 'America/Chicago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'The Lake of the Ozarks',
    destinationId: 50776,
    latitude: 38.096611,
    longitude: -92.586258,
  },
  {
    sortOrder: 285,
    selectable: true,
    destinationUrlName: 'Toledo',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22226.50899',
    parentId: 22226,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Toledo',
    destinationId: 50899,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 286,
    selectable: true,
    destinationUrlName: 'Tombstone',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.271.50755',
    parentId: 271,
    timeZone: 'America/Phoenix',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tombstone',
    destinationId: 50755,
    latitude: 31.714081,
    longitude: -110.06778,
  },
  {
    sortOrder: 287,
    selectable: true,
    destinationUrlName: 'Traverse-City',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22219.27762',
    parentId: 22219,
    timeZone: 'America/Detroit',
    iataCode: 'TVC',
    destinationType: 'CITY',
    destinationName: 'Traverse City',
    destinationId: 27762,
    latitude: 44.76306,
    longitude: -85.62063,
  },
  {
    sortOrder: 288,
    selectable: true,
    destinationUrlName: 'Tucson',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.271.808',
    parentId: 271,
    timeZone: 'America/Phoenix',
    iataCode: 'TUS',
    destinationType: 'CITY',
    destinationName: 'Tucson',
    destinationId: 808,
    latitude: 32.2217429,
    longitude: -110.926479,
  },
  {
    sortOrder: 289,
    selectable: true,
    destinationUrlName: 'Tulsa',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22227.50783',
    parentId: 22227,
    timeZone: 'America/Chicago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tulsa',
    destinationId: 50783,
    latitude: 36.15398,
    longitude: -95.992775,
  },
  {
    sortOrder: 290,
    selectable: true,
    destinationUrlName: 'Tybee-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.277.50765',
    parentId: 277,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tybee Island',
    destinationId: 50765,
    latitude: 31.992411,
    longitude: -80.849251,
  },
  {
    sortOrder: 291,
    selectable: true,
    destinationUrlName: 'Upper-Peninsula',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22219.29649',
    parentId: 22219,
    timeZone: 'America/Detroit',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Upper Peninsula',
    destinationId: 29649,
    latitude: 46.53748,
    longitude: -87.39521,
  },
  {
    sortOrder: 292,
    selectable: true,
    destinationUrlName: 'Vail',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.273.22367',
    parentId: 273,
    timeZone: 'America/Denver',
    iataCode: 'EGE',
    destinationType: 'CITY',
    destinationName: 'Vail',
    destinationId: 22367,
    latitude: 39.640264,
    longitude: -106.374195,
  },
  {
    sortOrder: 293,
    selectable: true,
    destinationUrlName: 'Ventura',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.50846',
    parentId: 272,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ventura',
    destinationId: 50846,
    latitude: 34.2806896241,
    longitude: -119.2936858256,
  },
  {
    sortOrder: 294,
    selectable: true,
    destinationUrlName: 'Vero-Beach',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.276.50900',
    parentId: 276,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Vero Beach',
    destinationId: 50900,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 295,
    selectable: true,
    destinationUrlName: 'Virginia-Beach',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22229.23013',
    parentId: 22229,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Virginia Beach',
    destinationId: 23013,
    latitude: 36.85293,
    longitude: -75.97798,
  },
  {
    sortOrder: 296,
    selectable: true,
    destinationUrlName: 'Virgin-River',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.785.50802',
    parentId: 785,
    timeZone: 'America/Denver',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Virgin River',
    destinationId: 50802,
    latitude: 37.125778,
    longitude: -113.487907,
  },
  {
    sortOrder: 297,
    selectable: true,
    destinationUrlName: 'Waco',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.296.50076',
    parentId: 296,
    timeZone: 'America/Chicago',
    iataCode: 'ACT',
    destinationType: 'CITY',
    destinationName: 'Waco',
    destinationId: 50076,
    latitude: 31.5532527,
    longitude: -97.3276664,
  },
  {
    sortOrder: 298,
    selectable: true,
    destinationUrlName: 'Washington-DC',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.657',
    parentId: 77,
    timeZone: 'America/New_York',
    iataCode: 'WAS',
    destinationType: 'CITY',
    destinationName: 'Washington DC',
    destinationId: 657,
    latitude: 38.8951118,
    longitude: -77.0363658,
  },
  {
    sortOrder: 299,
    selectable: true,
    destinationUrlName: 'Westchester-County',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5560.50561',
    parentId: 5560,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Westchester County',
    destinationId: 50561,
    latitude: 41.02962,
    longitude: -73.74218,
  },
  {
    sortOrder: 300,
    selectable: true,
    destinationUrlName: 'West-Glacier',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22221.50559',
    parentId: 22221,
    timeZone: 'America/Denver',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'West Glacier',
    destinationId: 50559,
    latitude: 48.50228,
    longitude: -113.98853,
  },
  {
    sortOrder: 301,
    selectable: true,
    destinationUrlName: 'West-Palm-Beach',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.276.24204',
    parentId: 276,
    timeZone: 'America/New_York',
    iataCode: 'PBI',
    destinationType: 'CITY',
    destinationName: 'West Palm Beach',
    destinationId: 24204,
    latitude: 26.715342,
    longitude: -80.053375,
  },
  {
    sortOrder: 302,
    selectable: true,
    destinationUrlName: 'West-Yellowstone',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22221.50636',
    parentId: 22221,
    timeZone: 'America/Denver',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'West Yellowstone',
    destinationId: 50636,
    latitude: 44.662251,
    longitude: -111.104187,
  },
  {
    sortOrder: 303,
    selectable: true,
    destinationUrlName: 'White-Mountains',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22223.24111',
    parentId: 22223,
    timeZone: 'America/Los_Angeles',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'White Mountains',
    destinationId: 24111,
    latitude: 37.7258,
    longitude: -118.3433,
  },
  {
    sortOrder: 304,
    selectable: true,
    destinationUrlName: 'Whittier',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.270.22320',
    parentId: 270,
    timeZone: 'America/Anchorage',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Whittier',
    destinationId: 22320,
    latitude: 60.773,
    longitude: -148.6838,
  },
  {
    sortOrder: 305,
    selectable: true,
    destinationUrlName: 'Williamsburg',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22229.33617',
    parentId: 22229,
    timeZone: 'America/New_York',
    iataCode: 'PHF',
    destinationType: 'CITY',
    destinationName: 'Williamsburg',
    destinationId: 33617,
    latitude: 37.270596,
    longitude: -76.705826,
  },
  {
    sortOrder: 306,
    selectable: true,
    destinationUrlName: 'Wilmington',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5283.33417',
    parentId: 5283,
    timeZone: 'America/New_York',
    iataCode: 'ILM',
    destinationType: 'CITY',
    destinationName: 'Wilmington',
    destinationId: 33417,
    latitude: 34.225853,
    longitude: -77.940565,
  },
  {
    sortOrder: 307,
    selectable: true,
    destinationUrlName: 'Winston-Salem',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5283.50735',
    parentId: 5283,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Winston Salem',
    destinationId: 50735,
    latitude: 36.09626,
    longitude: -80.243736,
  },
  {
    sortOrder: 308,
    selectable: true,
    destinationUrlName: 'Wisconsin-Dells',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.22231.27740',
    parentId: 22231,
    timeZone: 'America/Chicago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Wisconsin Dells',
    destinationId: 27740,
    latitude: 43.62748,
    longitude: -89.77096,
  },
  {
    sortOrder: 309,
    selectable: true,
    destinationUrlName: 'Yellowstone-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.5260.22411',
    parentId: 5260,
    timeZone: 'America/Denver',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Yellowstone National Park',
    destinationId: 22411,
    latitude: 44.42797,
    longitude: -110.58845,
  },
  {
    sortOrder: 310,
    selectable: true,
    destinationUrlName: 'Yosemite-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.272.5265',
    parentId: 272,
    timeZone: 'US/Pacific',
    iataCode: 'FAT',
    destinationType: 'CITY',
    destinationName: 'Yosemite National Park',
    destinationId: 5265,
    latitude: 37.8499232,
    longitude: -119.5676663,
  },
  {
    sortOrder: 311,
    selectable: true,
    destinationUrlName: 'Zion-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '8.77.785.5610',
    parentId: 785,
    timeZone: 'US/Mountain',
    iataCode: 'SGU',
    destinationType: 'CITY',
    destinationName: 'Zion National Park',
    destinationId: 5610,
    latitude: 37.322817,
    longitude: -113.045716,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Australia',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22',
    parentId: 3,
    timeZone: 'Australia/Sydney',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Australia',
    destinationId: 22,
    latitude: -25.2743980001,
    longitude: 133.775136,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'New-South-Wales',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.120',
    parentId: 22,
    timeZone: 'Australia/Sydney',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'New South Wales',
    destinationId: 120,
    latitude: -32.8310013,
    longitude: 150.1390075,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Northern-Territory',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.121',
    parentId: 22,
    timeZone: 'Australia/Darwin',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Northern Territory',
    destinationId: 121,
    latitude: -18.4883003,
    longitude: 133.5010071,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Queensland',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.122',
    parentId: 22,
    timeZone: 'Australia/Brisbane',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Queensland',
    destinationId: 122,
    latitude: -23.0891646,
    longitude: 144.4006229,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'South-Australia',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.123',
    parentId: 22,
    timeZone: 'Australia/Adelaide',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'South Australia',
    destinationId: 123,
    latitude: -32.0289002,
    longitude: 135.0019989,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Tasmania',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.124',
    parentId: 22,
    timeZone: 'Australia/Hobart',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Tasmania',
    destinationId: 124,
    latitude: -41.7071991,
    longitude: 146.1490021,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Victoria',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.125',
    parentId: 22,
    timeZone: 'Australia/Melbourne',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Victoria',
    destinationId: 125,
    latitude: -37.47131,
    longitude: 144.785156,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Western-Australia',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.126',
    parentId: 22,
    timeZone: 'Australia/Perth',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Western Australia',
    destinationId: 126,
    latitude: -24.4132995,
    longitude: 121.0790024,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Adelaide',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.123.376',
    parentId: 123,
    timeZone: 'Australia/Adelaide',
    iataCode: 'ADL',
    destinationType: 'CITY',
    destinationName: 'Adelaide',
    destinationId: 376,
    latitude: -34.92577,
    longitude: 138.599732,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Aeroglen',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.122.50215',
    parentId: 122,
    timeZone: 'Australia/Brisbane',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Aeroglen',
    destinationId: 50215,
    latitude: -16.8847,
    longitude: 145.7466,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Agnes-Water',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.122.24847',
    parentId: 122,
    timeZone: 'Australia/Brisbane',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Agnes Water',
    destinationId: 24847,
    latitude: -24.21299,
    longitude: 151.90274,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Airlie-Beach',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.122.28628',
    parentId: 122,
    timeZone: 'Australia/Brisbane',
    iataCode: 'JHQ',
    destinationType: 'CITY',
    destinationName: 'Airlie Beach',
    destinationId: 28628,
    latitude: -20.26872,
    longitude: 148.71846,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Albany',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.126.4748',
    parentId: 126,
    timeZone: 'Australia/Perth',
    iataCode: 'ALH',
    destinationType: 'CITY',
    destinationName: 'Albany',
    destinationId: 4748,
    latitude: -35.027592,
    longitude: 117.883928,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Alice-Springs',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.121.358',
    parentId: 121,
    timeZone: 'Australia/Darwin',
    iataCode: 'ASP',
    destinationType: 'CITY',
    destinationName: 'Alice Springs',
    destinationId: 358,
    latitude: -23.700358,
    longitude: 133.880889,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Ballarat',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.125.25941',
    parentId: 125,
    timeZone: 'Australia/Melbourne',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ballarat',
    destinationId: 25941,
    latitude: -37.562198,
    longitude: 143.847492,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Barossa-Valley',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.123.5623',
    parentId: 123,
    timeZone: 'Australia/Adelaide',
    iataCode: 'YWK',
    destinationType: 'CITY',
    destinationName: 'Barossa Valley',
    destinationId: 5623,
    latitude: -34.533333,
    longitude: 138.95,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Batemans-Bay',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.120.37748',
    parentId: 120,
    timeZone: 'Australia/Sydney',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Batemans Bay',
    destinationId: 37748,
    latitude: -35.7083174,
    longitude: 150.1319322,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Blue-Mountains',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.120.5402',
    parentId: 120,
    timeZone: 'Australia/Sydney',
    iataCode: 'SYD',
    destinationType: 'CITY',
    destinationName: 'Blue Mountains',
    destinationId: 5402,
    latitude: -33.6506548,
    longitude: 150.4428323,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Brisbane',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.122.363',
    parentId: 122,
    timeZone: 'Australia/Brisbane',
    iataCode: 'BNE',
    destinationType: 'CITY',
    destinationName: 'Brisbane',
    destinationId: 363,
    latitude: -27.46758,
    longitude: 153.027892,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Broome',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.126.789',
    parentId: 126,
    timeZone: 'Australia/Perth',
    iataCode: 'BME',
    destinationType: 'CITY',
    destinationName: 'Broome',
    destinationId: 789,
    latitude: -17.955123,
    longitude: 122.241457,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Brunswick-Heads',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.120.27543',
    parentId: 120,
    timeZone: 'Australia/Sydney',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Brunswick Heads',
    destinationId: 27543,
    latitude: -28.54053,
    longitude: 153.54949,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Bunbury',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.126.4750',
    parentId: 126,
    timeZone: 'Australia/Perth',
    iataCode: 'BUY',
    destinationType: 'CITY',
    destinationName: 'Bunbury',
    destinationId: 4750,
    latitude: -33.3443,
    longitude: 115.6502,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Burnie',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.124.40325',
    parentId: 124,
    timeZone: 'Australia/Hobart',
    iataCode: 'BWT',
    destinationType: 'CITY',
    destinationName: 'Burnie',
    destinationId: 40325,
    latitude: -41.0541043,
    longitude: 145.8919412,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Busselton',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.126.23522',
    parentId: 126,
    timeZone: 'Australia/Perth',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Busselton',
    destinationId: 23522,
    latitude: -33.64994,
    longitude: 115.34461,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Byron-Bay',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.120.5259',
    parentId: 120,
    timeZone: 'Australia/Brisbane',
    iataCode: 'BNK',
    destinationType: 'CITY',
    destinationName: 'Byron Bay',
    destinationId: 5259,
    latitude: -28.6441616,
    longitude: 153.6123788,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Cairns-and-the-Tropical-North',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.122.754',
    parentId: 122,
    timeZone: 'Australia/Brisbane',
    iataCode: 'CNS',
    destinationType: 'CITY',
    destinationName: 'Cairns & the Tropical North',
    destinationId: 754,
    latitude: -16.925397,
    longitude: 145.775178,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Canberra',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.819',
    parentId: 22,
    timeZone: 'Australia/Sydney',
    iataCode: 'CBR',
    destinationType: 'CITY',
    destinationName: 'Canberra',
    destinationId: 819,
    latitude: -35.28204,
    longitude: 149.12858,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Cape-Tribulation',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.122.32538',
    parentId: 122,
    timeZone: 'Australia/Brisbane',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cape Tribulation',
    destinationId: 32538,
    latitude: -16.087433,
    longitude: 145.454803,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Coffs-Harbour',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.120.27519',
    parentId: 120,
    timeZone: 'Australia/Sydney',
    iataCode: 'CFS',
    destinationType: 'CITY',
    destinationName: 'Coffs Harbour',
    destinationId: 27519,
    latitude: -30.29631,
    longitude: 153.11567,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'Coles-Bay',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.124.4741',
    parentId: 124,
    timeZone: 'Australia/Hobart',
    iataCode: 'HLS',
    destinationType: 'CITY',
    destinationName: 'Coles Bay',
    destinationId: 4741,
    latitude: -42.081072,
    longitude: 148.237453,
  },
  {
    sortOrder: 23,
    selectable: true,
    destinationUrlName: 'Coral-Bay',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.126.50216',
    parentId: 126,
    timeZone: 'Australia/Perth',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Coral Bay',
    destinationId: 50216,
    latitude: -23.1437,
    longitude: 113.7715,
  },
  {
    sortOrder: 24,
    selectable: true,
    destinationUrlName: 'Cradle-Mountain-Lake-St-Clair-National-Park',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.124.50302',
    parentId: 124,
    timeZone: 'Australia/Hobart',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cradle Mountain-Lake St. Clair National Park',
    destinationId: 50302,
    latitude: -41.8333,
    longitude: 146.0,
  },
  {
    sortOrder: 25,
    selectable: true,
    destinationUrlName: 'Darwin',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.121.360',
    parentId: 121,
    timeZone: 'Australia/Darwin',
    iataCode: 'DRW',
    destinationType: 'CITY',
    destinationName: 'Darwin',
    destinationId: 360,
    latitude: -12.4628198,
    longitude: 130.8417694,
  },
  {
    sortOrder: 26,
    selectable: true,
    destinationUrlName: 'Echuca',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.125.50379',
    parentId: 125,
    timeZone: 'Australia/Melbourne',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Echuca',
    destinationId: 50379,
    latitude: -36.144658,
    longitude: 144.744968,
  },
  {
    sortOrder: 27,
    selectable: true,
    destinationUrlName: 'Exmouth',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.126.4752',
    parentId: 126,
    timeZone: 'Australia/Perth',
    iataCode: 'LEA',
    destinationType: 'CITY',
    destinationName: 'Exmouth',
    destinationId: 4752,
    latitude: -21.94474,
    longitude: 114.133974,
  },
  {
    sortOrder: 28,
    selectable: true,
    destinationUrlName: 'Flinders-Ranges-National-Park',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.123.51279',
    parentId: 123,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Flinders Ranges National Park',
    destinationId: 51279,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 29,
    selectable: true,
    destinationUrlName: 'Fraser-Island',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.122.366',
    parentId: 122,
    timeZone: 'Australia/Brisbane',
    iataCode: 'HVB',
    destinationType: 'CITY',
    destinationName: 'Fraser Island',
    destinationId: 366,
    latitude: -25.2663148,
    longitude: 153.1560853,
  },
  {
    sortOrder: 30,
    selectable: true,
    destinationUrlName: 'Fremantle',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.126.22027',
    parentId: 126,
    timeZone: 'Australia/Perth',
    iataCode: 'PER',
    destinationType: 'CITY',
    destinationName: 'Fremantle',
    destinationId: 22027,
    latitude: -32.05604,
    longitude: 115.74718,
  },
  {
    sortOrder: 31,
    selectable: true,
    destinationUrlName: 'Geelong',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.125.27083',
    parentId: 125,
    timeZone: 'Australia/Melbourne',
    iataCode: 'GEX',
    destinationType: 'CITY',
    destinationName: 'Geelong',
    destinationId: 27083,
    latitude: -38.14854,
    longitude: 144.36135,
  },
  {
    sortOrder: 32,
    selectable: true,
    destinationUrlName: 'Geraldton',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.126.4753',
    parentId: 126,
    timeZone: 'Australia/Perth',
    iataCode: 'GET',
    destinationType: 'CITY',
    destinationName: 'Geraldton',
    destinationId: 4753,
    latitude: -28.77322,
    longitude: 114.60963,
  },
  {
    sortOrder: 33,
    selectable: true,
    destinationUrlName: 'Gold-Coast',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.122.367',
    parentId: 122,
    timeZone: 'Australia/Brisbane',
    iataCode: 'OOL',
    destinationType: 'CITY',
    destinationName: 'Gold Coast',
    destinationId: 367,
    latitude: -27.9852778,
    longitude: 153.3919444,
  },
  {
    sortOrder: 34,
    selectable: true,
    destinationUrlName: 'Grampians',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.125.51241',
    parentId: 125,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Grampians',
    destinationId: 51241,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 35,
    selectable: true,
    destinationUrlName: 'Great-Ocean-Road',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.125.30794',
    parentId: 125,
    timeZone: 'Australia/Melbourne',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Great Ocean Road',
    destinationId: 30794,
    latitude: -38.68056,
    longitude: 143.39162,
  },
  {
    sortOrder: 36,
    selectable: true,
    destinationUrlName: 'Hervey-Bay',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.122.22028',
    parentId: 122,
    timeZone: 'Australia/Brisbane',
    iataCode: 'HVB',
    destinationType: 'CITY',
    destinationName: 'Hervey Bay',
    destinationId: 22028,
    latitude: -25.287966,
    longitude: 152.770538,
  },
  {
    sortOrder: 37,
    selectable: true,
    destinationUrlName: 'Hobart',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.124.379',
    parentId: 124,
    timeZone: 'Australia/Hobart',
    iataCode: 'HBA',
    destinationType: 'CITY',
    destinationName: 'Hobart',
    destinationId: 379,
    latitude: -42.8819032,
    longitude: 147.3238148,
  },
  {
    sortOrder: 38,
    selectable: true,
    destinationUrlName: 'Hunter-Valley',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.120.30973',
    parentId: 120,
    timeZone: 'Australia/Sydney',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Hunter Valley',
    destinationId: 30973,
    latitude: -32.72765,
    longitude: 151.52831,
  },
  {
    sortOrder: 39,
    selectable: true,
    destinationUrlName: 'Ipswich',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.122.25169',
    parentId: 122,
    timeZone: 'Australia/Brisbane',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ipswich',
    destinationId: 25169,
    latitude: -27.616,
    longitude: 152.7609,
  },
  {
    sortOrder: 40,
    selectable: true,
    destinationUrlName: 'Jervis-Bay',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.120.22045',
    parentId: 120,
    timeZone: 'Australia/Sydney',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Jervis Bay',
    destinationId: 22045,
    latitude: -35.063265,
    longitude: 150.732362,
  },
  {
    sortOrder: 41,
    selectable: true,
    destinationUrlName: 'Kakadu',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.121.39807',
    parentId: 121,
    timeZone: 'Australia/Darwin',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kakadu',
    destinationId: 39807,
    latitude: -12.9382689,
    longitude: 131.3147294,
  },
  {
    sortOrder: 42,
    selectable: true,
    destinationUrlName: 'Kalbarri',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.126.50930',
    parentId: 126,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kalbarri',
    destinationId: 50930,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 43,
    selectable: true,
    destinationUrlName: 'Kangaroo-Island',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.123.4863',
    parentId: 123,
    timeZone: 'Australia/Adelaide',
    iataCode: 'KGC',
    destinationType: 'CITY',
    destinationName: 'Kangaroo Island',
    destinationId: 4863,
    latitude: -35.7752426,
    longitude: 137.2142417,
  },
  {
    sortOrder: 44,
    selectable: true,
    destinationUrlName: 'Karratha',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.126.34948',
    parentId: 126,
    timeZone: 'Australia/Perth',
    iataCode: 'KTA',
    destinationType: 'CITY',
    destinationName: 'Karratha',
    destinationId: 34948,
    latitude: -20.7348765,
    longitude: 116.8414597,
  },
  {
    sortOrder: 45,
    selectable: true,
    destinationUrlName: 'Katherine',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.121.22030',
    parentId: 121,
    timeZone: 'Australia/Darwin',
    iataCode: 'KTR',
    destinationType: 'CITY',
    destinationName: 'Katherine',
    destinationId: 22030,
    latitude: -14.452008,
    longitude: 132.27285,
  },
  {
    sortOrder: 46,
    selectable: true,
    destinationUrlName: 'Kings-Canyon',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.121.25710',
    parentId: 121,
    timeZone: 'Australia/Darwin',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kings Canyon',
    destinationId: 25710,
    latitude: -24.25651,
    longitude: 131.495355,
  },
  {
    sortOrder: 47,
    selectable: true,
    destinationUrlName: 'Kununurra',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.126.22937',
    parentId: 126,
    timeZone: 'Australia/Perth',
    iataCode: 'KNX',
    destinationType: 'CITY',
    destinationName: 'Kununurra',
    destinationId: 22937,
    latitude: -15.779303,
    longitude: 128.750186,
  },
  {
    sortOrder: 48,
    selectable: true,
    destinationUrlName: 'Launceston',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.124.939',
    parentId: 124,
    timeZone: 'Australia/Hobart',
    iataCode: 'LST',
    destinationType: 'CITY',
    destinationName: 'Launceston',
    destinationId: 939,
    latitude: -41.45,
    longitude: 147.166667,
  },
  {
    sortOrder: 49,
    selectable: true,
    destinationUrlName: 'Longreach',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.122.50378',
    parentId: 122,
    timeZone: 'Australia/Brisbane',
    iataCode: 'LRE',
    destinationType: 'CITY',
    destinationName: 'Longreach',
    destinationId: 50378,
    latitude: -23.4403,
    longitude: 144.2506,
  },
  {
    sortOrder: 50,
    selectable: true,
    destinationUrlName: 'Mackay',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.122.25078',
    parentId: 122,
    timeZone: 'Australia/Brisbane',
    iataCode: 'MKY',
    destinationType: 'CITY',
    destinationName: 'Mackay',
    destinationId: 25078,
    latitude: -21.1439,
    longitude: 149.15,
  },
  {
    sortOrder: 51,
    selectable: true,
    destinationUrlName: 'Magnetic-Island',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.122.32554',
    parentId: 122,
    timeZone: 'Australia/Brisbane',
    iataCode: 'TSV',
    destinationType: 'CITY',
    destinationName: 'Magnetic Island',
    destinationId: 32554,
    latitude: -19.135358,
    longitude: 146.842303,
  },
  {
    sortOrder: 52,
    selectable: true,
    destinationUrlName: 'Mandurah',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.126.36688',
    parentId: 126,
    timeZone: 'Australia/Perth',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mandurah',
    destinationId: 36688,
    latitude: -32.5238369,
    longitude: 115.169277,
  },
  {
    sortOrder: 53,
    selectable: true,
    destinationUrlName: 'Margaret-River',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.126.24851',
    parentId: 126,
    timeZone: 'Australia/Perth',
    iataCode: 'MQZ',
    destinationType: 'CITY',
    destinationName: 'Margaret River',
    destinationId: 24851,
    latitude: -33.955192,
    longitude: 115.077405,
  },
  {
    sortOrder: 54,
    selectable: true,
    destinationUrlName: 'Margaret-River-Region',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.126.51263',
    parentId: 126,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Margaret River Region',
    destinationId: 51263,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 55,
    selectable: true,
    destinationUrlName: 'McLaren-Vale',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.123.32555',
    parentId: 123,
    timeZone: 'Australia/Adelaide',
    iataCode: 'ADL',
    destinationType: 'CITY',
    destinationName: 'McLaren Vale',
    destinationId: 32555,
    latitude: -35.220906,
    longitude: 138.546095,
  },
  {
    sortOrder: 56,
    selectable: true,
    destinationUrlName: 'Melbourne',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.125.384',
    parentId: 125,
    timeZone: 'Australia/Melbourne',
    iataCode: 'MEL',
    destinationType: 'CITY',
    destinationName: 'Melbourne',
    destinationId: 384,
    latitude: -37.814251,
    longitude: 144.963169,
  },
  {
    sortOrder: 57,
    selectable: true,
    destinationUrlName: 'Mission-Beach',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.122.32531',
    parentId: 122,
    timeZone: 'Australia/Brisbane',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mission Beach',
    destinationId: 32531,
    latitude: -17.869033,
    longitude: 146.104053,
  },
  {
    sortOrder: 58,
    selectable: true,
    destinationUrlName: 'Moreton-Bay-Region',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.122.50992',
    parentId: 122,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Moreton Bay Region',
    destinationId: 50992,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 59,
    selectable: true,
    destinationUrlName: 'Mornington-Peninsula',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.125.22999',
    parentId: 125,
    timeZone: 'Australia/Melbourne',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mornington Peninsula',
    destinationId: 22999,
    latitude: -38.28541,
    longitude: 145.09345,
  },
  {
    sortOrder: 60,
    selectable: true,
    destinationUrlName: 'Newcastle',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.120.25551',
    parentId: 120,
    timeZone: 'Australia/Sydney',
    iataCode: 'NCL',
    destinationType: 'CITY',
    destinationName: 'Newcastle',
    destinationId: 25551,
    latitude: -32.8453,
    longitude: 151.815,
  },
  {
    sortOrder: 61,
    selectable: true,
    destinationUrlName: 'Noosa-and-Sunshine-Coast',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.122.374',
    parentId: 122,
    timeZone: 'Australia/Brisbane',
    iataCode: 'NSA',
    destinationType: 'CITY',
    destinationName: 'Noosa & Sunshine Coast',
    destinationId: 374,
    latitude: -26.4516684,
    longitude: 153.0883543,
  },
  {
    sortOrder: 62,
    selectable: true,
    destinationUrlName: 'Norfolk-Island',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.120.28823',
    parentId: 120,
    timeZone: 'Pacific/Norfolk',
    iataCode: 'NLK',
    destinationType: 'CITY',
    destinationName: 'Norfolk Island',
    destinationId: 28823,
    latitude: -29.02566,
    longitude: 167.94159,
  },
  {
    sortOrder: 63,
    selectable: true,
    destinationUrlName: 'Palm-Cove',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.122.788',
    parentId: 122,
    timeZone: 'Australia/Brisbane',
    iataCode: 'CNS',
    destinationType: 'CITY',
    destinationName: 'Palm Cove',
    destinationId: 788,
    latitude: -16.747083,
    longitude: 145.670998,
  },
  {
    sortOrder: 64,
    selectable: true,
    destinationUrlName: 'Perth',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.126.389',
    parentId: 126,
    timeZone: 'Australia/Perth',
    iataCode: 'PER',
    destinationType: 'CITY',
    destinationName: 'Perth',
    destinationId: 389,
    latitude: -31.9554,
    longitude: 115.85859,
  },
  {
    sortOrder: 65,
    selectable: true,
    destinationUrlName: 'Phillip-Island',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.125.5598',
    parentId: 125,
    timeZone: 'Australia/Melbourne',
    iataCode: 'MBW',
    destinationType: 'CITY',
    destinationName: 'Phillip Island',
    destinationId: 5598,
    latitude: -38.48987,
    longitude: 145.203828,
  },
  {
    sortOrder: 66,
    selectable: true,
    destinationUrlName: 'Port-Arthur',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.124.32553',
    parentId: 124,
    timeZone: 'Australia/Hobart',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Port Arthur',
    destinationId: 32553,
    latitude: -43.177382,
    longitude: 147.842379,
  },
  {
    sortOrder: 67,
    selectable: true,
    destinationUrlName: 'Port-Douglas',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.122.787',
    parentId: 122,
    timeZone: 'Australia/Lindeman',
    iataCode: 'PTI',
    destinationType: 'CITY',
    destinationName: 'Port Douglas',
    destinationId: 787,
    latitude: -16.483986,
    longitude: 145.46582,
  },
  {
    sortOrder: 68,
    selectable: true,
    destinationUrlName: 'Port-Lincoln',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.123.22821',
    parentId: 123,
    timeZone: 'Australia/Adelaide',
    iataCode: 'PLO',
    destinationType: 'CITY',
    destinationName: 'Port Lincoln',
    destinationId: 22821,
    latitude: -34.730315,
    longitude: 135.851997,
  },
  {
    sortOrder: 69,
    selectable: true,
    destinationUrlName: 'Port-Stephens',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.120.23018',
    parentId: 120,
    timeZone: 'Australia/Sydney',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Port Stephens',
    destinationId: 23018,
    latitude: -32.717108,
    longitude: 152.105929,
  },
  {
    sortOrder: 70,
    selectable: true,
    destinationUrlName: 'Rainbow-Beach',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.122.24032',
    parentId: 122,
    timeZone: 'Australia/Brisbane',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Rainbow Beach',
    destinationId: 24032,
    latitude: -25.907825,
    longitude: 153.087489,
  },
  {
    sortOrder: 71,
    selectable: true,
    destinationUrlName: 'Rottnest-Island',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.126.30972',
    parentId: 126,
    timeZone: 'Australia/Perth',
    iataCode: 'RTS',
    destinationType: 'CITY',
    destinationName: 'Rottnest Island',
    destinationId: 30972,
    latitude: -32.0062,
    longitude: 115.51234,
  },
  {
    sortOrder: 72,
    selectable: true,
    destinationUrlName: 'St-Kilda',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.125.50380',
    parentId: 125,
    timeZone: 'Australia/Melbourne',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'St Kilda',
    destinationId: 50380,
    latitude: -37.864103,
    longitude: 144.982902,
  },
  {
    sortOrder: 73,
    selectable: true,
    destinationUrlName: 'Strahan',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.124.24028',
    parentId: 124,
    timeZone: 'Australia/Hobart',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Strahan',
    destinationId: 24028,
    latitude: -42.149968,
    longitude: 145.317237,
  },
  {
    sortOrder: 74,
    selectable: true,
    destinationUrlName: 'Surfers-Paradise',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.122.22738',
    parentId: 122,
    timeZone: 'Australia/Sydney',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Surfers Paradise',
    destinationId: 22738,
    latitude: -28.000327,
    longitude: 153.417392,
  },
  {
    sortOrder: 75,
    selectable: true,
    destinationUrlName: 'Sydney',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.120.357',
    parentId: 120,
    timeZone: 'Australia/Sydney',
    iataCode: 'SYD',
    destinationType: 'CITY',
    destinationName: 'Sydney',
    destinationId: 357,
    latitude: -33.8671390001,
    longitude: 151.207114,
  },
  {
    sortOrder: 76,
    selectable: true,
    destinationUrlName: 'The-Whitsundays-and-Hamilton-Island',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.122.753',
    parentId: 122,
    timeZone: 'Australia/Brisbane',
    iataCode: 'HTI',
    destinationType: 'CITY',
    destinationName: 'The Whitsundays & Hamilton Island',
    destinationId: 753,
    latitude: -20.347649,
    longitude: 148.953084,
  },
  {
    sortOrder: 77,
    selectable: true,
    destinationUrlName: 'Townsville',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.122.4739',
    parentId: 122,
    timeZone: 'Australia/Brisbane',
    iataCode: 'TSV',
    destinationType: 'CITY',
    destinationName: 'Townsville',
    destinationId: 4739,
    latitude: -19.257622,
    longitude: 146.817879,
  },
  {
    sortOrder: 78,
    selectable: true,
    destinationUrlName: 'Tweed-Heads',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.120.37749',
    parentId: 120,
    timeZone: 'Australia/Brisbane',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tweed Heads',
    destinationId: 37749,
    latitude: -28.177941,
    longitude: 153.5295715,
  },
  {
    sortOrder: 79,
    selectable: true,
    destinationUrlName: 'Uluru',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.121.359',
    parentId: 121,
    timeZone: 'Australia/Darwin',
    iataCode: 'AYQ',
    destinationType: 'CITY',
    destinationName: 'Uluru',
    destinationId: 359,
    latitude: -25.3833333,
    longitude: 131.0833333,
  },
  {
    sortOrder: 80,
    selectable: true,
    destinationUrlName: 'Wilsons-Promontory-National-Park',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.125.50381',
    parentId: 125,
    timeZone: 'Australia/Melbourne',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Wilsons Promontory National Park',
    destinationId: 50381,
    latitude: -39.0308,
    longitude: 146.3256,
  },
  {
    sortOrder: 81,
    selectable: true,
    destinationUrlName: 'Yarra-Valley',
    defaultCurrencyCode: 'AUD',
    lookupId: '3.22.125.22734',
    parentId: 125,
    timeZone: 'Australia/Melbourne',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Yarra Valley',
    destinationId: 22734,
    latitude: -37.65681,
    longitude: 145.44716,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'New-Zealand',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24',
    parentId: 3,
    timeZone: 'Pacific/Auckland',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'New Zealand',
    destinationId: 24,
    latitude: -40.900557,
    longitude: 174.885971,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'North-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.128',
    parentId: 24,
    timeZone: 'Pacific/Auckland',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'North Island',
    destinationId: 128,
    latitude: -37.8965461,
    longitude: 175.6023643,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'South-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.129',
    parentId: 24,
    timeZone: 'Pacific/Auckland',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'South Island',
    destinationId: 129,
    latitude: -43.9695148,
    longitude: 170.0981869,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Akaroa',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.129.23350',
    parentId: 129,
    timeZone: 'Pacific/Auckland',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Akaroa',
    destinationId: 23350,
    latitude: -43.803754,
    longitude: 172.968097,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Aoraki-Mount-Cook-National-Park-Te-Wahipounamu',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.129.51233',
    parentId: 129,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Aoraki Mount Cook National Park (Te Wahipounamu)',
    destinationId: 51233,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Auckland',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.128.391',
    parentId: 128,
    timeZone: 'Pacific/Auckland',
    iataCode: 'AKL',
    destinationType: 'CITY',
    destinationName: 'Auckland',
    destinationId: 391,
    latitude: -36.847385,
    longitude: 174.765735,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Bay-of-Islands',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.128.755',
    parentId: 128,
    timeZone: 'Pacific/Auckland',
    iataCode: 'KKE',
    destinationType: 'CITY',
    destinationName: 'Bay of Islands',
    destinationId: 755,
    latitude: -35.280797,
    longitude: 174.090371,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Blenheim',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.129.22286',
    parentId: 129,
    timeZone: 'Pacific/Auckland',
    iataCode: 'BHE',
    destinationType: 'CITY',
    destinationName: 'Blenheim',
    destinationId: 22286,
    latitude: -41.51344,
    longitude: 173.96125,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Canterbury',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.129.25980',
    parentId: 129,
    timeZone: 'Pacific/Auckland',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Canterbury',
    destinationId: 25980,
    latitude: -43.6,
    longitude: 172.0,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Christchurch',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.129.400',
    parentId: 129,
    timeZone: 'Pacific/Auckland',
    iataCode: 'CHC',
    destinationType: 'CITY',
    destinationName: 'Christchurch',
    destinationId: 400,
    latitude: -43.531637,
    longitude: 172.636645,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Coromandel',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.128.50441',
    parentId: 128,
    timeZone: 'Pacific/Auckland',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Coromandel',
    destinationId: 50441,
    latitude: -36.757198,
    longitude: 175.498001,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Dunedin-and-The-Otago-Peninsula',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.129.758',
    parentId: 129,
    timeZone: 'Pacific/Auckland',
    iataCode: 'DUD',
    destinationType: 'CITY',
    destinationName: 'Dunedin & The Otago Peninsula',
    destinationId: 758,
    latitude: -45.8787605,
    longitude: 170.5027976,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Fiordland-and-Milford-Sound',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.129.756',
    parentId: 129,
    timeZone: 'Pacific/Auckland',
    iataCode: 'TEU',
    destinationType: 'CITY',
    destinationName: 'Fiordland & Milford Sound',
    destinationId: 756,
    latitude: -44.669786,
    longitude: 167.928033,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Fox-Glacier',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.129.36398',
    parentId: 129,
    timeZone: 'Pacific/Auckland',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Fox Glacier',
    destinationId: 36398,
    latitude: -43.4701105,
    longitude: 169.8568442,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Franz-Josef-and-Fox-Glacier',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.129.757',
    parentId: 129,
    timeZone: 'Pacific/Auckland',
    iataCode: 'WHO',
    destinationType: 'CITY',
    destinationName: 'Franz Josef & Fox Glacier',
    destinationId: 757,
    latitude: -43.464323,
    longitude: 170.017919,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Greymouth',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.129.34195',
    parentId: 129,
    timeZone: 'Pacific/Auckland',
    iataCode: 'GMN',
    destinationType: 'CITY',
    destinationName: 'Greymouth',
    destinationId: 34195,
    latitude: -42.450406,
    longitude: 171.214125,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Hamilton',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.128.22203',
    parentId: 128,
    timeZone: 'Pacific/Auckland',
    iataCode: 'HLT',
    destinationType: 'CITY',
    destinationName: 'Hamilton',
    destinationId: 22203,
    latitude: -37.787133,
    longitude: 175.28019,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Hanmer-Springs',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.129.34936',
    parentId: 129,
    timeZone: 'Pacific/Auckland',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Hanmer Springs',
    destinationId: 34936,
    latitude: -42.5181632,
    longitude: 172.7580166,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Hastings',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.128.22282',
    parentId: 128,
    timeZone: 'Pacific/Auckland',
    iataCode: 'NPE',
    destinationType: 'CITY',
    destinationName: 'Hastings',
    destinationId: 22282,
    latitude: -39.640285,
    longitude: 176.841454,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Havelock',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.129.50981',
    parentId: 129,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Havelock',
    destinationId: 50981,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Invercargill',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.129.38170',
    parentId: 129,
    timeZone: 'Pacific/Auckland',
    iataCode: 'IVC',
    destinationType: 'CITY',
    destinationName: 'Invercargill',
    destinationId: 38170,
    latitude: -46.4311124,
    longitude: 168.3059631,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Kaikoura',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.129.34937',
    parentId: 129,
    timeZone: 'Pacific/Auckland',
    iataCode: 'KBZ',
    destinationType: 'CITY',
    destinationName: 'Kaikoura',
    destinationId: 34937,
    latitude: -42.418546,
    longitude: 173.5709468,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Lake-Tekapo',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.129.51201',
    parentId: 129,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lake Tekapo',
    destinationId: 51201,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Marahau',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.129.50277',
    parentId: 129,
    timeZone: 'Pacific/Auckland',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Marahau',
    destinationId: 50277,
    latitude: -41.0078,
    longitude: 173.0089,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'Martinborough',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.128.36193',
    parentId: 128,
    timeZone: 'Pacific/Auckland',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Martinborough',
    destinationId: 36193,
    latitude: -41.2205868,
    longitude: 175.4062791,
  },
  {
    sortOrder: 23,
    selectable: true,
    destinationUrlName: 'Motueka',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.129.24533',
    parentId: 129,
    timeZone: 'Pacific/Auckland',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Motueka',
    destinationId: 24533,
    latitude: -41.1125,
    longitude: 173.0095,
  },
  {
    sortOrder: 24,
    selectable: true,
    destinationUrlName: 'Mount-Cook',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.129.405',
    parentId: 129,
    timeZone: 'Pacific/Auckland',
    iataCode: 'MON',
    destinationType: 'CITY',
    destinationName: 'Mount Cook',
    destinationId: 405,
    latitude: -43.59398,
    longitude: 170.14015,
  },
  {
    sortOrder: 25,
    selectable: true,
    destinationUrlName: 'Napier',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.128.4760',
    parentId: 128,
    timeZone: 'Pacific/Auckland',
    iataCode: 'NPE',
    destinationType: 'CITY',
    destinationName: 'Napier',
    destinationId: 4760,
    latitude: 39.4793037,
    longitude: 176.7983399,
  },
  {
    sortOrder: 26,
    selectable: true,
    destinationUrlName: 'Nelson',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.129.22292',
    parentId: 129,
    timeZone: 'Pacific/Auckland',
    iataCode: 'NSN',
    destinationType: 'CITY',
    destinationName: 'Nelson',
    destinationId: 22292,
    latitude: -41.271207,
    longitude: 173.282485,
  },
  {
    sortOrder: 27,
    selectable: true,
    destinationUrlName: 'Ohakune',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.128.36403',
    parentId: 128,
    timeZone: 'Pacific/Auckland',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ohakune',
    destinationId: 36403,
    latitude: -39.4129352,
    longitude: 175.3086187,
  },
  {
    sortOrder: 28,
    selectable: true,
    destinationUrlName: 'Picton',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.129.4769',
    parentId: 129,
    timeZone: 'Pacific/Auckland',
    iataCode: 'NSN',
    destinationType: 'CITY',
    destinationName: 'Picton',
    destinationId: 4769,
    latitude: -41.2905926,
    longitude: 174.0010044,
  },
  {
    sortOrder: 29,
    selectable: true,
    destinationUrlName: 'Port-Chalmers',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.129.50278',
    parentId: 129,
    timeZone: 'Pacific/Auckland',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Port Chalmers',
    destinationId: 50278,
    latitude: -45.8159,
    longitude: 170.6214,
  },
  {
    sortOrder: 30,
    selectable: true,
    destinationUrlName: 'Queenstown',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.129.407',
    parentId: 129,
    timeZone: 'Pacific/Auckland',
    iataCode: 'ZQN',
    destinationType: 'CITY',
    destinationName: 'Queenstown',
    destinationId: 407,
    latitude: -45.031104,
    longitude: 168.662731,
  },
  {
    sortOrder: 31,
    selectable: true,
    destinationUrlName: 'Rotorua',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.128.395',
    parentId: 128,
    timeZone: 'Pacific/Auckland',
    iataCode: 'ROT',
    destinationType: 'CITY',
    destinationName: 'Rotorua',
    destinationId: 395,
    latitude: -38.139826,
    longitude: 176.247073,
  },
  {
    sortOrder: 32,
    selectable: true,
    destinationUrlName: 'Stewart-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.129.38918',
    parentId: 129,
    timeZone: 'Pacific/Auckland',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Stewart Island',
    destinationId: 38918,
    latitude: -46.9854961,
    longitude: 167.2777687,
  },
  {
    sortOrder: 33,
    selectable: true,
    destinationUrlName: 'Takaka',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.129.50442',
    parentId: 129,
    timeZone: 'Pacific/Auckland',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Takaka',
    destinationId: 50442,
    latitude: -40.859699,
    longitude: 172.806,
  },
  {
    sortOrder: 34,
    selectable: true,
    destinationUrlName: 'Taupo',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.128.5241',
    parentId: 128,
    timeZone: 'Pacific/Auckland',
    iataCode: 'TUO',
    destinationType: 'CITY',
    destinationName: 'Taupo',
    destinationId: 5241,
    latitude: -38.7931307,
    longitude: 175.971322,
  },
  {
    sortOrder: 35,
    selectable: true,
    destinationUrlName: 'Tauranga',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.128.4761',
    parentId: 128,
    timeZone: 'Pacific/Auckland',
    iataCode: 'TRG',
    destinationType: 'CITY',
    destinationName: 'Tauranga',
    destinationId: 4761,
    latitude: -37.686769,
    longitude: 176.166344,
  },
  {
    sortOrder: 36,
    selectable: true,
    destinationUrlName: 'Te-Anau',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.129.22016',
    parentId: 129,
    timeZone: 'Pacific/Auckland',
    iataCode: 'TEU',
    destinationType: 'CITY',
    destinationName: 'Te Anau',
    destinationId: 22016,
    latitude: -45.41445,
    longitude: 167.71805,
  },
  {
    sortOrder: 37,
    selectable: true,
    destinationUrlName: 'Tongariro-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.128.33378',
    parentId: 128,
    timeZone: 'Pacific/Auckland',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tongariro National Park',
    destinationId: 33378,
    latitude: -39.272709,
    longitude: 175.5802278,
  },
  {
    sortOrder: 38,
    selectable: true,
    destinationUrlName: 'Waiheke-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.128.32653',
    parentId: 128,
    timeZone: 'Pacific/Auckland',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Waiheke Island',
    destinationId: 32653,
    latitude: -36.801531,
    longitude: 175.108013,
  },
  {
    sortOrder: 39,
    selectable: true,
    destinationUrlName: 'Waitomo',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.128.27469',
    parentId: 128,
    timeZone: 'Pacific/Auckland',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Waitomo',
    destinationId: 27469,
    latitude: -38.26153,
    longitude: 175.11455,
  },
  {
    sortOrder: 40,
    selectable: true,
    destinationUrlName: 'Wanaka',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.129.409',
    parentId: 129,
    timeZone: 'Pacific/Auckland',
    iataCode: 'WKA',
    destinationType: 'CITY',
    destinationName: 'Wanaka',
    destinationId: 409,
    latitude: -44.703181,
    longitude: 169.132098,
  },
  {
    sortOrder: 41,
    selectable: true,
    destinationUrlName: 'Wellington',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.128.399',
    parentId: 128,
    timeZone: 'Pacific/Auckland',
    iataCode: 'WLG',
    destinationType: 'CITY',
    destinationName: 'Wellington',
    destinationId: 399,
    latitude: -41.28648,
    longitude: 174.776217,
  },
  {
    sortOrder: 42,
    selectable: true,
    destinationUrlName: 'Whitianga',
    defaultCurrencyCode: 'USD',
    lookupId: '3.24.128.50440',
    parentId: 128,
    timeZone: 'Pacific/Auckland',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Whitianga',
    destinationId: 50440,
    latitude: -36.834702,
    longitude: 175.705002,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'France',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51',
    parentId: 6,
    timeZone: 'Europe/Paris',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'France',
    destinationId: 51,
    latitude: 46.227638,
    longitude: 2.213749,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Alsace',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.174',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Alsace',
    destinationId: 174,
    latitude: 48.318179,
    longitude: 7.441624,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Aquitaine',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.175',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Aquitaine',
    destinationId: 175,
    latitude: 44.7002222,
    longitude: -0.2995785,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Brittany',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.21942',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Brittany',
    destinationId: 21942,
    latitude: 48.0054,
    longitude: -3.1922,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Burgundy',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.177',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Burgundy',
    destinationId: 177,
    latitude: 47.327213,
    longitude: 5.0439875,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Champagne',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.813',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Champagne',
    destinationId: 813,
    latitude: 49.2566023,
    longitude: 4.0330909,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Corsica',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.4799',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Corsica',
    destinationId: 4799,
    latitude: 42.1798,
    longitude: 9.0601,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'French-Riviera',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.179',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'French Riviera',
    destinationId: 179,
    latitude: 43.495573,
    longitude: 6.26575,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Ile-de-France',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.5636',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Île-de-France',
    destinationId: 5636,
    latitude: 48.688952,
    longitude: 2.697596,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Languedoc-Roussillon',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.181',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Languedoc-Roussillon',
    destinationId: 181,
    latitude: 43.5912356,
    longitude: 3.2583626,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Limousin',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.28718',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Limousin',
    destinationId: 28718,
    latitude: 45.89322,
    longitude: 1.5696,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Loire-Valley',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.178',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Loire Valley',
    destinationId: 178,
    latitude: 47.233359,
    longitude: 0.42599,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Lorraine',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.23061',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Lorraine',
    destinationId: 23061,
    latitude: 48.7657,
    longitude: 5.9374,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Midi-Pyrenees',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.5512',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Midi-Pyrénées',
    destinationId: 5512,
    latitude: 44.0859426014,
    longitude: 1.5208623995,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Nord-Pas-de-Calais',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.5642',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Nord-Pas de Calais',
    destinationId: 5642,
    latitude: 50.815363,
    longitude: 2.412989,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Normandy',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.183',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Normandy',
    destinationId: 183,
    latitude: 49.1263,
    longitude: -0.07308,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Picardy',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.28836',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Picardy',
    destinationId: 28836,
    latitude: 49.66361,
    longitude: 2.52807,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Poitou-Charentes',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.24414',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Poitou-Charentes',
    destinationId: 24414,
    latitude: 46.0259,
    longitude: -0.2208,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Provence',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.184',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Provence',
    destinationId: 184,
    latitude: 44.052787,
    longitude: 5.97089,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Rhone-Alpes',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.24268',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Rhône-Alpes',
    destinationId: 24268,
    latitude: 45.938388,
    longitude: 5.529244,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Agen',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.175.5036',
    parentId: 175,
    timeZone: 'Europe/Paris',
    iataCode: 'AGF',
    destinationType: 'CITY',
    destinationName: 'Agen',
    destinationId: 5036,
    latitude: 44.2004,
    longitude: 0.6333,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Aigues-Mortes',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.50412',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Aigues-Mortes',
    destinationId: 50412,
    latitude: 43.56877,
    longitude: 4.1901,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Aix-en-Provence',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.184.5228',
    parentId: 184,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Aix-en-Provence',
    destinationId: 5228,
    latitude: 43.529742,
    longitude: 5.447427,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Ajaccio',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.4799.4192',
    parentId: 4799,
    timeZone: 'Etc/GMT+1',
    iataCode: 'CCI',
    destinationType: 'CITY',
    destinationName: 'Ajaccio',
    destinationId: 4192,
    latitude: 41.917915,
    longitude: 8.74102,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Aloxe-Corton',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.177.51325',
    parentId: 177,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Aloxe-Corton',
    destinationId: 51325,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Amiens',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.28836.28837',
    parentId: 28836,
    timeZone: 'Europe/Paris',
    iataCode: 'QAM',
    destinationType: 'CITY',
    destinationName: 'Amiens',
    destinationId: 28837,
    latitude: 49.89407,
    longitude: 2.29575,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Angers',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.178.24202',
    parentId: 178,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Angers',
    destinationId: 24202,
    latitude: 47.478358,
    longitude: -0.563238,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Annecy',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.24268.5437',
    parentId: 24268,
    timeZone: 'Europe/Paris',
    iataCode: 'NCY',
    destinationType: 'CITY',
    destinationName: 'Annecy',
    destinationId: 5437,
    latitude: 45.898879,
    longitude: 6.128787,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Antibes',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.179.21941',
    parentId: 179,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Antibes',
    destinationId: 21941,
    latitude: 43.580333,
    longitude: 7.127761,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Arcachon',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.175.26516',
    parentId: 175,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Arcachon',
    destinationId: 26516,
    latitude: 44.652217,
    longitude: -1.177536,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Arles',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.181.28884',
    parentId: 181,
    timeZone: 'Europe/Paris',
    iataCode: 'FNI',
    destinationType: 'CITY',
    destinationName: 'Arles',
    destinationId: 28884,
    latitude: 43.67665,
    longitude: 4.62778,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Arras',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.5642.23406',
    parentId: 5642,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Arras',
    destinationId: 23406,
    latitude: 50.290972,
    longitude: 2.777582,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Auxerre',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.177.50937',
    parentId: 177,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Auxerre',
    destinationId: 50937,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Avignon',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.184.483',
    parentId: 184,
    timeZone: 'Europe/Paris',
    iataCode: 'AVN',
    destinationType: 'CITY',
    destinationName: 'Avignon',
    destinationId: 483,
    latitude: 43.9486126,
    longitude: 4.8059666,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Ay',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.813.51351',
    parentId: 813,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ay',
    destinationId: 51351,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Bayeux',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.183.909',
    parentId: 183,
    timeZone: 'Europe/Paris',
    iataCode: 'CFR',
    destinationType: 'CITY',
    destinationName: 'Bayeux',
    destinationId: 909,
    latitude: 49.2764475,
    longitude: -0.7055291,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Bayonne',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.175.5047',
    parentId: 175,
    timeZone: 'Europe/Paris',
    iataCode: 'BIQ',
    destinationType: 'CITY',
    destinationName: 'Bayonne',
    destinationId: 5047,
    latitude: 43.492949,
    longitude: -1.474841,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Beaulieu-sur-Mer',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.179.50249',
    parentId: 179,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Beaulieu-sur-Mer',
    destinationId: 50249,
    latitude: 43.7088,
    longitude: 7.33375,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Beaune',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.177.22737',
    parentId: 177,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Beaune',
    destinationId: 22737,
    latitude: 47.02603,
    longitude: 4.84,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Bergerac',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.175.24181',
    parentId: 175,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bergerac',
    destinationId: 24181,
    latitude: 44.853703,
    longitude: 0.48499,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Besancon',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.5044',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: 'DLE',
    destinationType: 'CITY',
    destinationName: 'Besancon',
    destinationId: 5044,
    latitude: 47.242859,
    longitude: 6.020023,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'Biarritz',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.175.23856',
    parentId: 175,
    timeZone: 'Europe/Paris',
    iataCode: 'BIQ',
    destinationType: 'CITY',
    destinationName: 'Biarritz',
    destinationId: 23856,
    latitude: 43.483401,
    longitude: -1.558154,
  },
  {
    sortOrder: 23,
    selectable: true,
    destinationUrlName: 'Blois',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.50324',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Blois',
    destinationId: 50324,
    latitude: 47.5861,
    longitude: 1.3359,
  },
  {
    sortOrder: 24,
    selectable: true,
    destinationUrlName: 'Bordeaux',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.175.468',
    parentId: 175,
    timeZone: 'Europe/Paris',
    iataCode: 'BOD',
    destinationType: 'CITY',
    destinationName: 'Bordeaux',
    destinationId: 468,
    latitude: 44.842055576,
    longitude: -0.567984581,
  },
  {
    sortOrder: 25,
    selectable: true,
    destinationUrlName: 'Brest',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.21942.4193',
    parentId: 21942,
    timeZone: 'Europe/Paris',
    iataCode: 'BES',
    destinationType: 'CITY',
    destinationName: 'Brest',
    destinationId: 4193,
    latitude: 48.38987,
    longitude: -4.48718,
  },
  {
    sortOrder: 26,
    selectable: true,
    destinationUrlName: 'Caen',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.183.5469',
    parentId: 183,
    timeZone: 'Europe/Paris',
    iataCode: 'CFR',
    destinationType: 'CITY',
    destinationName: 'Caen',
    destinationId: 5469,
    latitude: 49.1828630008,
    longitude: -0.3706790018,
  },
  {
    sortOrder: 27,
    selectable: true,
    destinationUrlName: 'Cannes',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.179.786',
    parentId: 179,
    timeZone: 'Europe/Paris',
    iataCode: 'CEQ',
    destinationType: 'CITY',
    destinationName: 'Cannes',
    destinationId: 786,
    latitude: 43.5456553092,
    longitude: 7.0130109787,
  },
  {
    sortOrder: 28,
    selectable: true,
    destinationUrlName: 'Cap-dAgde',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.181.26181',
    parentId: 181,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: "Cap-d'Agde",
    destinationId: 26181,
    latitude: 43.28074,
    longitude: 3.5054,
  },
  {
    sortOrder: 29,
    selectable: true,
    destinationUrlName: 'Carcassonne',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.181.22036',
    parentId: 181,
    timeZone: 'Europe/Paris',
    iataCode: 'CCF',
    destinationType: 'CITY',
    destinationName: 'Carcassonne',
    destinationId: 22036,
    latitude: 43.212003,
    longitude: 2.355987,
  },
  {
    sortOrder: 30,
    selectable: true,
    destinationUrlName: 'Cassis',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.50415',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cassis',
    destinationId: 50415,
    latitude: 43.216068,
    longitude: 5.53855,
  },
  {
    sortOrder: 31,
    selectable: true,
    destinationUrlName: 'Castellane',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.179.25737',
    parentId: 179,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Castellane',
    destinationId: 25737,
    latitude: 43.846087,
    longitude: 6.51633,
  },
  {
    sortOrder: 32,
    selectable: true,
    destinationUrlName: 'Chambery',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.50409',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: 'CMF',
    destinationType: 'CITY',
    destinationName: 'Chambery',
    destinationId: 50409,
    latitude: 45.5667,
    longitude: 5.92085,
  },
  {
    sortOrder: 33,
    selectable: true,
    destinationUrlName: 'Chamonix',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.24268.24269',
    parentId: 24268,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Chamonix',
    destinationId: 24269,
    latitude: 45.9237,
    longitude: 6.86943,
  },
  {
    sortOrder: 34,
    selectable: true,
    destinationUrlName: 'Chinon',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.178.25736',
    parentId: 178,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Chinon',
    destinationId: 25736,
    latitude: 47.167785,
    longitude: 0.240077,
  },
  {
    sortOrder: 35,
    selectable: true,
    destinationUrlName: 'Cognac',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.24414.25290',
    parentId: 24414,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cognac',
    destinationId: 25290,
    latitude: 45.690972,
    longitude: -0.328291,
  },
  {
    sortOrder: 36,
    selectable: true,
    destinationUrlName: 'Colmar',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.174.22940',
    parentId: 174,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Colmar',
    destinationId: 22940,
    latitude: 48.07936,
    longitude: 7.35851,
  },
  {
    sortOrder: 37,
    selectable: true,
    destinationUrlName: 'Deauville-City',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.183.50417',
    parentId: 183,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Deauville City',
    destinationId: 50417,
    latitude: 49.3574,
    longitude: 0.07416,
  },
  {
    sortOrder: 38,
    selectable: true,
    destinationUrlName: 'Dieppe',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.183.22277',
    parentId: 183,
    timeZone: 'Europe/Paris',
    iataCode: 'DPE',
    destinationType: 'CITY',
    destinationName: 'Dieppe',
    destinationId: 22277,
    latitude: 49.9337,
    longitude: 1.0833,
  },
  {
    sortOrder: 39,
    selectable: true,
    destinationUrlName: 'Dijon',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.177.5030',
    parentId: 177,
    timeZone: 'Europe/Paris',
    iataCode: 'DIJ',
    destinationType: 'CITY',
    destinationName: 'Dijon',
    destinationId: 5030,
    latitude: 47.322047,
    longitude: 5.04148,
  },
  {
    sortOrder: 40,
    selectable: true,
    destinationUrlName: 'Dunkirk',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.4553',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: 'DKK',
    destinationType: 'CITY',
    destinationName: 'Dunkirk',
    destinationId: 4553,
    latitude: 51.0348,
    longitude: 2.3773,
  },
  {
    sortOrder: 41,
    selectable: true,
    destinationUrlName: 'Epernay',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.813.51197',
    parentId: 813,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Epernay',
    destinationId: 51197,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 42,
    selectable: true,
    destinationUrlName: 'Evian-les-Bains',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.24268.50916',
    parentId: 24268,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Evian-les-Bains',
    destinationId: 50916,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 43,
    selectable: true,
    destinationUrlName: 'Fontainebleau',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.5636.50925',
    parentId: 5636,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Fontainebleau',
    destinationId: 50925,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 44,
    selectable: true,
    destinationUrlName: 'Frejus-Saint-Raphael',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.179.5223',
    parentId: 179,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Fréjus Saint-Raphaël',
    destinationId: 5223,
    latitude: 43.431363,
    longitude: 6.738325,
  },
  {
    sortOrder: 45,
    selectable: true,
    destinationUrlName: 'Gevrey-Chambertin',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.177.51299',
    parentId: 177,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Gevrey-Chambertin',
    destinationId: 51299,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 46,
    selectable: true,
    destinationUrlName: 'Giverny',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.183.50325',
    parentId: 183,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Giverny',
    destinationId: 50325,
    latitude: 49.0816,
    longitude: 1.5335,
  },
  {
    sortOrder: 47,
    selectable: true,
    destinationUrlName: 'Grasse',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.179.50323',
    parentId: 179,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Grasse',
    destinationId: 50323,
    latitude: 43.6602,
    longitude: 6.9265,
  },
  {
    sortOrder: 48,
    selectable: true,
    destinationUrlName: 'Grenoble',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.24268.27067',
    parentId: 24268,
    timeZone: 'Europe/Paris',
    iataCode: 'GNB',
    destinationType: 'CITY',
    destinationName: 'Grenoble',
    destinationId: 27067,
    latitude: 45.18853,
    longitude: 5.72452,
  },
  {
    sortOrder: 49,
    selectable: true,
    destinationUrlName: 'Honfleur',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.183.50416',
    parentId: 183,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Honfleur',
    destinationId: 50416,
    latitude: 49.418762,
    longitude: 0.233262,
  },
  {
    sortOrder: 50,
    selectable: true,
    destinationUrlName: 'La-Ciotat',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.50413',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'La Ciotat',
    destinationId: 50413,
    latitude: 43.174049,
    longitude: 5.60422,
  },
  {
    sortOrder: 51,
    selectable: true,
    destinationUrlName: 'La-Rochelle',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.24414.24415',
    parentId: 24414,
    timeZone: 'Europe/Paris',
    iataCode: 'LRH',
    destinationType: 'CITY',
    destinationName: 'La Rochelle',
    destinationId: 24415,
    latitude: 46.160281,
    longitude: -1.149613,
  },
  {
    sortOrder: 52,
    selectable: true,
    destinationUrlName: 'Le-Grau-du-Roi',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.181.26433',
    parentId: 181,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Le Grau-du-Roi',
    destinationId: 26433,
    latitude: 43.53703,
    longitude: 4.139545,
  },
  {
    sortOrder: 53,
    selectable: true,
    destinationUrlName: 'Le-Havre',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.183.4199',
    parentId: 183,
    timeZone: 'Europe/Paris',
    iataCode: 'LEH',
    destinationType: 'CITY',
    destinationName: 'Le Havre',
    destinationId: 4199,
    latitude: 49.494312,
    longitude: 0.106849,
  },
  {
    sortOrder: 54,
    selectable: true,
    destinationUrlName: 'Lille',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.5642.824',
    parentId: 5642,
    timeZone: 'Europe/Paris',
    iataCode: 'LIL',
    destinationType: 'CITY',
    destinationName: 'Lille',
    destinationId: 824,
    latitude: 50.6371834,
    longitude: 3.0630174,
  },
  {
    sortOrder: 55,
    selectable: true,
    destinationUrlName: 'Lourdes',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.5512.24041',
    parentId: 5512,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lourdes',
    destinationId: 24041,
    latitude: 43.09141,
    longitude: -0.044366,
  },
  {
    sortOrder: 56,
    selectable: true,
    destinationUrlName: 'Lyon',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.24268.829',
    parentId: 24268,
    timeZone: 'Europe/Paris',
    iataCode: 'LYS',
    destinationType: 'CITY',
    destinationName: 'Lyon',
    destinationId: 829,
    latitude: 45.767299,
    longitude: 4.8343287,
  },
  {
    sortOrder: 57,
    selectable: true,
    destinationUrlName: 'Macon',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.177.25311',
    parentId: 177,
    timeZone: 'Europe/Paris',
    iataCode: 'MCN',
    destinationType: 'CITY',
    destinationName: 'Mâcon',
    destinationId: 25311,
    latitude: 46.307138,
    longitude: 4.828634,
  },
  {
    sortOrder: 58,
    selectable: true,
    destinationUrlName: 'Marignane',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.50326',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Marignane',
    destinationId: 50326,
    latitude: 43.4213,
    longitude: 5.2183,
  },
  {
    sortOrder: 59,
    selectable: true,
    destinationUrlName: 'Marne-la-Vallee',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.5636.5637',
    parentId: 5636,
    timeZone: 'Europe/Paris',
    iataCode: 'XLG',
    destinationType: 'CITY',
    destinationName: 'Marne-la-Vallée',
    destinationId: 5637,
    latitude: 48.859276,
    longitude: 2.598505,
  },
  {
    sortOrder: 60,
    selectable: true,
    destinationUrlName: 'Marseille',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.184.485',
    parentId: 184,
    timeZone: 'Europe/Paris',
    iataCode: 'MRS',
    destinationType: 'CITY',
    destinationName: 'Marseille',
    destinationId: 485,
    latitude: 43.2961052028,
    longitude: 5.3653621674,
  },
  {
    sortOrder: 61,
    selectable: true,
    destinationUrlName: 'Menton',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.179.23076',
    parentId: 179,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Menton',
    destinationId: 23076,
    latitude: 43.774454,
    longitude: 7.497565,
  },
  {
    sortOrder: 62,
    selectable: true,
    destinationUrlName: 'Moliets-et-Maa',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.50410',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Moliets et Maa',
    destinationId: 50410,
    latitude: 43.84894,
    longitude: -1.35925,
  },
  {
    sortOrder: 63,
    selectable: true,
    destinationUrlName: 'Montpellier',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.181.22037',
    parentId: 181,
    timeZone: 'Europe/Paris',
    iataCode: 'MPL',
    destinationType: 'CITY',
    destinationName: 'Montpellier',
    destinationId: 22037,
    latitude: 43.61077,
    longitude: 3.87672,
  },
  {
    sortOrder: 64,
    selectable: true,
    destinationUrlName: 'Mont-St-Michel',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.183.25906',
    parentId: 183,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mont-St-Michel',
    destinationId: 25906,
    latitude: 48.63549,
    longitude: -1.511036,
  },
  {
    sortOrder: 65,
    selectable: true,
    destinationUrlName: 'Moustiers-Sainte-Marie',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.184.26221',
    parentId: 184,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Moustiers-Sainte-Marie',
    destinationId: 26221,
    latitude: 43.846,
    longitude: 6.2218,
  },
  {
    sortOrder: 66,
    selectable: true,
    destinationUrlName: 'Nancy',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.50411',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: 'ENC',
    destinationType: 'CITY',
    destinationName: 'Nancy',
    destinationId: 50411,
    latitude: 48.690781,
    longitude: 6.18246,
  },
  {
    sortOrder: 67,
    selectable: true,
    destinationUrlName: 'Nantes',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.178.23883',
    parentId: 178,
    timeZone: 'Europe/Paris',
    iataCode: 'NTE',
    destinationType: 'CITY',
    destinationName: 'Nantes',
    destinationId: 23883,
    latitude: 47.218179,
    longitude: -1.551668,
  },
  {
    sortOrder: 68,
    selectable: true,
    destinationUrlName: 'Narbonne',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.181.752',
    parentId: 181,
    timeZone: 'Europe/Paris',
    iataCode: 'BZR',
    destinationType: 'CITY',
    destinationName: 'Narbonne',
    destinationId: 752,
    latitude: 43.189715,
    longitude: 3.013615,
  },
  {
    sortOrder: 69,
    selectable: true,
    destinationUrlName: 'Nice',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.179.478',
    parentId: 179,
    timeZone: 'Europe/Paris',
    iataCode: 'NCE',
    destinationType: 'CITY',
    destinationName: 'Nice',
    destinationId: 478,
    latitude: 43.7034273,
    longitude: 7.2662656,
  },
  {
    sortOrder: 70,
    selectable: true,
    destinationUrlName: 'Nimes',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.181.22048',
    parentId: 181,
    timeZone: 'Europe/Paris',
    iataCode: 'FNI',
    destinationType: 'CITY',
    destinationName: 'Nîmes',
    destinationId: 22048,
    latitude: 43.8367,
    longitude: 4.36005,
  },
  {
    sortOrder: 71,
    selectable: true,
    destinationUrlName: 'Obernai',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.174.51227',
    parentId: 174,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Obernai',
    destinationId: 51227,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 72,
    selectable: true,
    destinationUrlName: 'Paris',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.5636.479',
    parentId: 5636,
    timeZone: 'Europe/Paris',
    iataCode: 'CDG',
    destinationType: 'CITY',
    destinationName: 'Paris',
    destinationId: 479,
    latitude: 48.8566667,
    longitude: 2.3509871,
  },
  {
    sortOrder: 73,
    selectable: true,
    destinationUrlName: 'Perpignan',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.181.26343',
    parentId: 181,
    timeZone: 'Europe/Paris',
    iataCode: 'PGF',
    destinationType: 'CITY',
    destinationName: 'Perpignan',
    destinationId: 26343,
    latitude: 42.688621,
    longitude: 2.893383,
  },
  {
    sortOrder: 74,
    selectable: true,
    destinationUrlName: 'Reims',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.813.5049',
    parentId: 813,
    timeZone: 'Europe/Paris',
    iataCode: 'RHE',
    destinationType: 'CITY',
    destinationName: 'Reims',
    destinationId: 5049,
    latitude: 49.258329,
    longitude: 4.031696,
  },
  {
    sortOrder: 75,
    selectable: true,
    destinationUrlName: 'Rennes',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.21942.21943',
    parentId: 21942,
    timeZone: 'Europe/Paris',
    iataCode: 'RNS',
    destinationType: 'CITY',
    destinationName: 'Rennes',
    destinationId: 21943,
    latitude: 48.11747,
    longitude: -1.679059,
  },
  {
    sortOrder: 76,
    selectable: true,
    destinationUrlName: 'Rouen',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.183.5089',
    parentId: 183,
    timeZone: 'Europe/Paris',
    iataCode: 'URO',
    destinationType: 'CITY',
    destinationName: 'Rouen',
    destinationId: 5089,
    latitude: 49.4304,
    longitude: 1.08,
  },
  {
    sortOrder: 77,
    selectable: true,
    destinationUrlName: 'Roussillon',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.184.50935',
    parentId: 184,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Roussillon',
    destinationId: 50935,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 78,
    selectable: true,
    destinationUrlName: 'Saint-Emilion',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.175.50245',
    parentId: 175,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Saint-Emilion',
    destinationId: 50245,
    latitude: 44.895553,
    longitude: -0.159869,
  },
  {
    sortOrder: 79,
    selectable: true,
    destinationUrlName: 'Saint-Nazaire',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.4908',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: 'SNR',
    destinationType: 'CITY',
    destinationName: 'Saint Nazaire',
    destinationId: 4908,
    latitude: 48.27771,
    longitude: -3.911591,
  },
  {
    sortOrder: 80,
    selectable: true,
    destinationUrlName: 'Saint-Remy-de-Provence',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.50327',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Saint-Remy-de-Provence',
    destinationId: 50327,
    latitude: 43.7887,
    longitude: 4.8313,
  },
  {
    sortOrder: 81,
    selectable: true,
    destinationUrlName: 'Sete',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.4201',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: 'MPL',
    destinationType: 'CITY',
    destinationName: 'Sete',
    destinationId: 4201,
    latitude: 43.407876,
    longitude: 3.700822,
  },
  {
    sortOrder: 82,
    selectable: true,
    destinationUrlName: 'Strasbourg',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.174.5502',
    parentId: 174,
    timeZone: 'Europe/Paris',
    iataCode: 'SXB',
    destinationType: 'CITY',
    destinationName: 'Strasbourg',
    destinationId: 5502,
    latitude: 48.5831480015,
    longitude: 7.7478820021,
  },
  {
    sortOrder: 83,
    selectable: true,
    destinationUrlName: 'St-Tropez',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.179.4195',
    parentId: 179,
    timeZone: 'Europe/Paris',
    iataCode: 'LTT',
    destinationType: 'CITY',
    destinationName: 'St-Tropez',
    destinationId: 4195,
    latitude: 43.26768,
    longitude: 6.64071,
  },
  {
    sortOrder: 84,
    selectable: true,
    destinationUrlName: 'Toulon',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.179.24308',
    parentId: 179,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Toulon',
    destinationId: 24308,
    latitude: 43.124282,
    longitude: 5.928235,
  },
  {
    sortOrder: 85,
    selectable: true,
    destinationUrlName: 'Toulouse',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.5512.812',
    parentId: 5512,
    timeZone: 'Europe/Paris',
    iataCode: 'TLS',
    destinationType: 'CITY',
    destinationName: 'Toulouse',
    destinationId: 812,
    latitude: 43.604363,
    longitude: 1.4429513,
  },
  {
    sortOrder: 86,
    selectable: true,
    destinationUrlName: 'Tours',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.178.5092',
    parentId: 178,
    timeZone: 'Europe/Paris',
    iataCode: 'TUF',
    destinationType: 'CITY',
    destinationName: 'Tours',
    destinationId: 5092,
    latitude: 47.393897,
    longitude: 0.685582,
  },
  {
    sortOrder: 87,
    selectable: true,
    destinationUrlName: 'Verdun',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.23061.23063',
    parentId: 23061,
    timeZone: 'Europe/Paris',
    iataCode: 'XVN',
    destinationType: 'CITY',
    destinationName: 'Verdun',
    destinationId: 23063,
    latitude: 49.15988,
    longitude: 5.38442,
  },
  {
    sortOrder: 88,
    selectable: true,
    destinationUrlName: 'Versailles',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.5636.763',
    parentId: 5636,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Versailles',
    destinationId: 763,
    latitude: 48.80233,
    longitude: 2.1298227,
  },
  {
    sortOrder: 89,
    selectable: true,
    destinationUrlName: 'Verzenay',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.813.51304',
    parentId: 813,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Verzenay',
    destinationId: 51304,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 90,
    selectable: true,
    destinationUrlName: 'Villefranche-sur-Mer',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.50322',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Villefranche-sur-Mer',
    destinationId: 50322,
    latitude: 43.704,
    longitude: 7.3111,
  },
  {
    sortOrder: 91,
    selectable: true,
    destinationUrlName: 'Villeneuve-les-Avignon',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.51.50321',
    parentId: 51,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Villeneuve-les-Avignon',
    destinationId: 50321,
    latitude: 43.9634,
    longitude: 4.797,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Italy',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57',
    parentId: 6,
    timeZone: 'Europe/Rome',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Italy',
    destinationId: 57,
    latitude: 41.87194,
    longitude: 12.56738,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Abruzzo',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.23411',
    parentId: 57,
    timeZone: 'Europe/Rome',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Abruzzo',
    destinationId: 23411,
    latitude: 42.283134,
    longitude: 12.7796472,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Amalfi-Coast',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.946',
    parentId: 57,
    timeZone: 'Europe/Rome',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Amalfi Coast',
    destinationId: 946,
    latitude: 40.633333,
    longitude: 14.601766,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Basilicata',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.28881',
    parentId: 57,
    timeZone: 'Europe/Rome',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Basilicata',
    destinationId: 28881,
    latitude: 40.64308,
    longitude: 15.96999,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Calabria',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.26226',
    parentId: 57,
    timeZone: 'Europe/Rome',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Calabria',
    destinationId: 26226,
    latitude: 39.0559,
    longitude: 16.6543,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Campania',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.28880',
    parentId: 57,
    timeZone: 'Europe/Rome',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Campania',
    destinationId: 28880,
    latitude: 41.10995,
    longitude: 14.84751,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Emilia-Romagna',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.25817',
    parentId: 57,
    timeZone: 'Europe/Vatican',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Emilia-Romagna',
    destinationId: 25817,
    latitude: 44.596761,
    longitude: 11.21864,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Friuli-Venezia-Giulia',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.29857',
    parentId: 57,
    timeZone: 'Europe/Rome',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Friuli-Venezia Giulia',
    destinationId: 29857,
    latitude: 46.22592,
    longitude: 13.10336,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Lazio',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.27405',
    parentId: 57,
    timeZone: 'Europe/Rome',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Lazio',
    destinationId: 27405,
    latitude: 41.65524,
    longitude: 12.98962,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Lombardy',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.25822',
    parentId: 57,
    timeZone: 'Europe/Vatican',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Lombardy',
    destinationId: 25822,
    latitude: 45.479067,
    longitude: 9.845243,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Marche',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.24161',
    parentId: 57,
    timeZone: 'Europe/Rome',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Marche',
    destinationId: 24161,
    latitude: 43.2785,
    longitude: 13.1587,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Piedmont-and-Liguria',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.775',
    parentId: 57,
    timeZone: 'Europe/Rome',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Piedmont & Liguria',
    destinationId: 775,
    latitude: 45.0522366,
    longitude: 7.5153885,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Puglia',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.5538',
    parentId: 57,
    timeZone: 'Europe/Rome',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Puglia',
    destinationId: 5538,
    latitude: 40.7928393011,
    longitude: 17.1011931013,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Sardinia',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.24293',
    parentId: 57,
    timeZone: 'Europe/Rome',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Sardinia',
    destinationId: 24293,
    latitude: 40.12088,
    longitude: 9.01289,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Sicily',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.205',
    parentId: 57,
    timeZone: 'Europe/Rome',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Sicily',
    destinationId: 205,
    latitude: 37.3979297,
    longitude: 14.6587821,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Trentino-Alto-Adige',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.28838',
    parentId: 57,
    timeZone: 'Europe/Rome',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Trentino-Alto Adige',
    destinationId: 28838,
    latitude: 46.7341,
    longitude: 11.2888,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Tuscany',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.206',
    parentId: 57,
    timeZone: 'Europe/Rome',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Tuscany',
    destinationId: 206,
    latitude: 43.5671153,
    longitude: 10.9807003,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Umbria',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.22033',
    parentId: 57,
    timeZone: 'Europe/Rome',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Umbria',
    destinationId: 22033,
    latitude: 42.9895316,
    longitude: 12.0176027,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Valle-dAosta',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.27407',
    parentId: 57,
    timeZone: 'Europe/Rome',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: "Valle d'Aosta",
    destinationId: 27407,
    latitude: 45.73889,
    longitude: 7.42619,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Veneto',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.23520',
    parentId: 57,
    timeZone: 'Europe/Vatican',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Veneto',
    destinationId: 23520,
    latitude: 45.762333,
    longitude: 11.690976,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Aeolian-Islands',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.205.30631',
    parentId: 205,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Aeolian Islands',
    destinationId: 30631,
    latitude: 38.49366,
    longitude: 14.9272,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Agrigento',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.205.27852',
    parentId: 205,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Agrigento',
    destinationId: 27852,
    latitude: 37.31109,
    longitude: 13.57655,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Alberobello-and-Locorotondo',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.5538.28682',
    parentId: 5538,
    timeZone: 'Europe/Rome',
    iataCode: 'BRI',
    destinationType: 'CITY',
    destinationName: 'Alberobello & Locorotondo',
    destinationId: 28682,
    latitude: 40.75591,
    longitude: 17.32628,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Alghero',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.24293.4222',
    parentId: 24293,
    timeZone: 'Europe/Rome',
    iataCode: 'AHO',
    destinationType: 'CITY',
    destinationName: 'Alghero',
    destinationId: 4222,
    latitude: 40.55795,
    longitude: 8.31929,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Amalfi',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.946.33601',
    parentId: 946,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Amalfi',
    destinationId: 33601,
    latitude: 40.633984,
    longitude: 14.602795,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Ancona',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.24161.33315',
    parentId: 24161,
    timeZone: 'Europe/Rome',
    iataCode: 'AOI',
    destinationType: 'CITY',
    destinationName: 'Ancona',
    destinationId: 33315,
    latitude: 43.615383,
    longitude: 13.520901,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Aosta',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.27407.28022',
    parentId: 27407,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Aosta',
    destinationId: 28022,
    latitude: 45.73496,
    longitude: 7.31308,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Arezzo',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.206.22631',
    parentId: 206,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Arezzo',
    destinationId: 22631,
    latitude: 43.46328,
    longitude: 11.87963,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Ascoli-Piceno',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.24161.28583',
    parentId: 24161,
    timeZone: 'Europe/Rome',
    iataCode: 'QNO',
    destinationType: 'CITY',
    destinationName: 'Ascoli Piceno',
    destinationId: 28583,
    latitude: 42.8536,
    longitude: 13.57494,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Assisi',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.22033.27667',
    parentId: 22033,
    timeZone: 'Europe/Rome',
    iataCode: 'PEG',
    destinationType: 'CITY',
    destinationName: 'Assisi',
    destinationId: 27667,
    latitude: 43.0707,
    longitude: 12.6196,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Asti',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.775.27173',
    parentId: 775,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Asti',
    destinationId: 27173,
    latitude: 44.90075,
    longitude: 8.20643,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Bari',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.5538.4226',
    parentId: 5538,
    timeZone: 'Europe/Rome',
    iataCode: 'BRI',
    destinationType: 'CITY',
    destinationName: 'Bari',
    destinationId: 4226,
    latitude: 41.11714,
    longitude: 16.87187,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Bergamo',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.25822.27538',
    parentId: 25822,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bergamo',
    destinationId: 27538,
    latitude: 45.69826,
    longitude: 9.67727,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Bologna',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.25817.791',
    parentId: 25817,
    timeZone: 'Europe/Rome',
    iataCode: 'BLQ',
    destinationType: 'CITY',
    destinationName: 'Bologna',
    destinationId: 791,
    latitude: 44.4942191,
    longitude: 11.3464815,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Bolzano',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.28838.29398',
    parentId: 28838,
    timeZone: 'Europe/Rome',
    iataCode: 'BZO',
    destinationType: 'CITY',
    destinationName: 'Bolzano',
    destinationId: 29398,
    latitude: 46.4983,
    longitude: 11.35476,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Brescia',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.25822.27188',
    parentId: 25822,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Brescia',
    destinationId: 27188,
    latitude: 45.54155,
    longitude: 10.2118,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Brindisi',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.5538.4227',
    parentId: 5538,
    timeZone: 'Europe/Rome',
    iataCode: 'BDS',
    destinationType: 'CITY',
    destinationName: 'Brindisi',
    destinationId: 4227,
    latitude: 40.63273,
    longitude: 17.94176,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Cagliari',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.24293.4229',
    parentId: 24293,
    timeZone: 'Europe/Rome',
    iataCode: 'CAG',
    destinationType: 'CITY',
    destinationName: 'Cagliari',
    destinationId: 4229,
    latitude: 39.2253834,
    longitude: 9.058338,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Capri',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.4223',
    parentId: 57,
    timeZone: 'Europe/Rome',
    iataCode: 'PRJ',
    destinationType: 'CITY',
    destinationName: 'Capri',
    destinationId: 4223,
    latitude: 40.55125,
    longitude: 14.243245,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Casoria',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.28880.50666',
    parentId: 28880,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Casoria',
    destinationId: 50666,
    latitude: 40.905449,
    longitude: 14.29007,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Castelletto-di-Branduzzo',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.25822.50591',
    parentId: 25822,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Castelletto di Branduzzo',
    destinationId: 50591,
    latitude: 45.07038,
    longitude: 9.0989,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'Catania',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.205.22664',
    parentId: 205,
    timeZone: 'Europe/Rome',
    iataCode: 'CTA',
    destinationType: 'CITY',
    destinationName: 'Catania',
    destinationId: 22664,
    latitude: 37.507877,
    longitude: 15.08303,
  },
  {
    sortOrder: 23,
    selectable: true,
    destinationUrlName: 'Cefalu',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.205.26110',
    parentId: 205,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cefalù',
    destinationId: 26110,
    latitude: 38.033676,
    longitude: 14.018093,
  },
  {
    sortOrder: 24,
    selectable: true,
    destinationUrlName: 'Chianti',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.206.26111',
    parentId: 206,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Chianti',
    destinationId: 26111,
    latitude: 43.73046,
    longitude: 11.33286,
  },
  {
    sortOrder: 25,
    selectable: true,
    destinationUrlName: 'Cinque-Terre',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.775.22149',
    parentId: 775,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cinque Terre',
    destinationId: 22149,
    latitude: 44.128109,
    longitude: 9.712391,
  },
  {
    sortOrder: 26,
    selectable: true,
    destinationUrlName: 'Cortina-dAmpezzo',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.23520.25557',
    parentId: 23520,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: "Cortina d'Ampezzo",
    destinationId: 25557,
    latitude: 46.54047,
    longitude: 12.13565,
  },
  {
    sortOrder: 27,
    selectable: true,
    destinationUrlName: 'Courmayeur',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.27407.27408',
    parentId: 27407,
    timeZone: 'Europe/Rome',
    iataCode: 'AOT',
    destinationType: 'CITY',
    destinationName: 'Courmayeur',
    destinationId: 27408,
    latitude: 45.79692,
    longitude: 6.96896,
  },
  {
    sortOrder: 28,
    selectable: true,
    destinationUrlName: 'Ferno',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.25822.50509',
    parentId: 25822,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ferno',
    destinationId: 50509,
    latitude: 45.617199,
    longitude: 8.75563,
  },
  {
    sortOrder: 29,
    selectable: true,
    destinationUrlName: 'Ferrara',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.25817.27187',
    parentId: 25817,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ferrara',
    destinationId: 27187,
    latitude: 44.83812,
    longitude: 11.61979,
  },
  {
    sortOrder: 30,
    selectable: true,
    destinationUrlName: 'Florence',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.206.519',
    parentId: 206,
    timeZone: 'Europe/Rome',
    iataCode: 'FLR',
    destinationType: 'CITY',
    destinationName: 'Florence',
    destinationId: 519,
    latitude: 43.768582,
    longitude: 11.255669,
  },
  {
    sortOrder: 31,
    selectable: true,
    destinationUrlName: 'Gaeta',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.27405.27666',
    parentId: 27405,
    timeZone: 'Europe/Rome',
    iataCode: 'NAP',
    destinationType: 'CITY',
    destinationName: 'Gaeta',
    destinationId: 27666,
    latitude: 41.21073,
    longitude: 13.57143,
  },
  {
    sortOrder: 32,
    selectable: true,
    destinationUrlName: 'Genoa',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.775.805',
    parentId: 775,
    timeZone: 'Europe/Rome',
    iataCode: 'GOA',
    destinationType: 'CITY',
    destinationName: 'Genoa',
    destinationId: 805,
    latitude: 44.414375,
    longitude: 8.918817,
  },
  {
    sortOrder: 33,
    selectable: true,
    destinationUrlName: 'Isola-dElba',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.206.33623',
    parentId: 206,
    timeZone: 'Europe/Rome',
    iataCode: 'EBA',
    destinationType: 'CITY',
    destinationName: "Isola d'Elba",
    destinationId: 33623,
    latitude: 42.809819,
    longitude: 10.310041,
  },
  {
    sortOrder: 34,
    selectable: true,
    destinationUrlName: 'Isola-dIschia',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.28880.50507',
    parentId: 28880,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: "Isola d'Ischia",
    destinationId: 50507,
    latitude: 41.62851,
    longitude: 12.6971,
  },
  {
    sortOrder: 35,
    selectable: true,
    destinationUrlName: 'Lake-Bolsena',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.27405.27406',
    parentId: 27405,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lake Bolsena',
    destinationId: 27406,
    latitude: 42.606,
    longitude: 11.95763,
  },
  {
    sortOrder: 36,
    selectable: true,
    destinationUrlName: 'Lake-Bracciano',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.27405.29095',
    parentId: 27405,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lake Bracciano',
    destinationId: 29095,
    latitude: 42.11953,
    longitude: 12.24335,
  },
  {
    sortOrder: 37,
    selectable: true,
    destinationUrlName: 'Lake-Como',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.25822.26113',
    parentId: 25822,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lake Como',
    destinationId: 26113,
    latitude: 45.983853,
    longitude: 9.261319,
  },
  {
    sortOrder: 38,
    selectable: true,
    destinationUrlName: 'Lake-Garda',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.27338',
    parentId: 57,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lake Garda',
    destinationId: 27338,
    latitude: 45.60494,
    longitude: 10.63514,
  },
  {
    sortOrder: 39,
    selectable: true,
    destinationUrlName: 'Lake-Maggiore',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.26112',
    parentId: 57,
    timeZone: 'Europe/Rome',
    iataCode: 'MXP',
    destinationType: 'CITY',
    destinationName: 'Lake Maggiore',
    destinationId: 26112,
    latitude: 45.924317,
    longitude: 8.55686,
  },
  {
    sortOrder: 40,
    selectable: true,
    destinationUrlName: 'La-Maddalena',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.24293.50508',
    parentId: 24293,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'La Maddalena',
    destinationId: 50508,
    latitude: 41.21444,
    longitude: 9.40759,
  },
  {
    sortOrder: 41,
    selectable: true,
    destinationUrlName: 'Lamezia-Terme',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.26226.36683',
    parentId: 26226,
    timeZone: 'Europe/Rome',
    iataCode: 'SUF',
    destinationType: 'CITY',
    destinationName: 'Lamezia Terme',
    destinationId: 36683,
    latitude: 38.964527,
    longitude: 16.3046809,
  },
  {
    sortOrder: 42,
    selectable: true,
    destinationUrlName: 'Langhe-Roero-and-Monferrato',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.775.25960',
    parentId: 775,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Langhe-Roero and Monferrato',
    destinationId: 25960,
    latitude: 44.69653,
    longitude: 8.03636,
  },
  {
    sortOrder: 43,
    selectable: true,
    destinationUrlName: 'La-Spezia',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.775.29856',
    parentId: 775,
    timeZone: 'Europe/Rome',
    iataCode: 'QLP',
    destinationType: 'CITY',
    destinationName: 'La Spezia',
    destinationId: 29856,
    latitude: 44.10245,
    longitude: 9.82408,
  },
  {
    sortOrder: 44,
    selectable: true,
    destinationUrlName: 'Lecce',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.5538.22769',
    parentId: 5538,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lecce',
    destinationId: 22769,
    latitude: 40.351018,
    longitude: 18.175882,
  },
  {
    sortOrder: 45,
    selectable: true,
    destinationUrlName: 'Livigno-and-Bormio',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.25822.25873',
    parentId: 25822,
    timeZone: 'Europe/Rome',
    iataCode: 'BZO',
    destinationType: 'CITY',
    destinationName: 'Livigno & Bormio',
    destinationId: 25873,
    latitude: 45.56398,
    longitude: 8.93171,
  },
  {
    sortOrder: 46,
    selectable: true,
    destinationUrlName: 'Livorno',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.206.22138',
    parentId: 206,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Livorno',
    destinationId: 22138,
    latitude: 43.546403,
    longitude: 10.298085,
  },
  {
    sortOrder: 47,
    selectable: true,
    destinationUrlName: 'Lucca',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.206.22436',
    parentId: 206,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lucca',
    destinationId: 22436,
    latitude: 43.83762,
    longitude: 10.495,
  },
  {
    sortOrder: 48,
    selectable: true,
    destinationUrlName: 'Madonna-di-Campiglio',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.28838.33431',
    parentId: 28838,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Madonna di Campiglio',
    destinationId: 33431,
    latitude: 46.229776,
    longitude: 10.828258,
  },
  {
    sortOrder: 49,
    selectable: true,
    destinationUrlName: 'Mantua',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.25822.26732',
    parentId: 25822,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mantua',
    destinationId: 26732,
    latitude: 45.15642,
    longitude: 10.79138,
  },
  {
    sortOrder: 50,
    selectable: true,
    destinationUrlName: 'Maranello',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.25817.33081',
    parentId: 25817,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Maranello',
    destinationId: 33081,
    latitude: 44.52624,
    longitude: 10.867675,
  },
  {
    sortOrder: 51,
    selectable: true,
    destinationUrlName: 'Massa-Marittima',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.206.50958',
    parentId: 206,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Massa Marittima',
    destinationId: 50958,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 52,
    selectable: true,
    destinationUrlName: 'Matera',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.22632',
    parentId: 57,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Matera',
    destinationId: 22632,
    latitude: 40.66638,
    longitude: 16.60432,
  },
  {
    sortOrder: 53,
    selectable: true,
    destinationUrlName: 'Messina',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.205.4814',
    parentId: 205,
    timeZone: 'Europe/Rome',
    iataCode: 'REG',
    destinationType: 'CITY',
    destinationName: 'Messina',
    destinationId: 4814,
    latitude: 38.1923323,
    longitude: 15.5555232,
  },
  {
    sortOrder: 54,
    selectable: true,
    destinationUrlName: 'Milan',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.25822.512',
    parentId: 25822,
    timeZone: 'Europe/Rome',
    iataCode: 'MIL',
    destinationType: 'CITY',
    destinationName: 'Milan',
    destinationId: 512,
    latitude: 45.4636889,
    longitude: 9.1881408,
  },
  {
    sortOrder: 55,
    selectable: true,
    destinationUrlName: 'Modena',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.25817.25818',
    parentId: 25817,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Modena',
    destinationId: 25818,
    latitude: 44.646614,
    longitude: 10.925935,
  },
  {
    sortOrder: 56,
    selectable: true,
    destinationUrlName: 'Montecatini-Terme',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.206.28585',
    parentId: 206,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Montecatini Terme',
    destinationId: 28585,
    latitude: 43.88085,
    longitude: 10.77544,
  },
  {
    sortOrder: 57,
    selectable: true,
    destinationUrlName: 'Montepulciano',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.206.27742',
    parentId: 206,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Montepulciano',
    destinationId: 27742,
    latitude: 43.09869,
    longitude: 11.78725,
  },
  {
    sortOrder: 58,
    selectable: true,
    destinationUrlName: 'Naples',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.508',
    parentId: 57,
    timeZone: 'Europe/Rome',
    iataCode: 'NAP',
    destinationType: 'CITY',
    destinationName: 'Naples',
    destinationId: 508,
    latitude: 40.8401614692,
    longitude: 14.2596960068,
  },
  {
    sortOrder: 59,
    selectable: true,
    destinationUrlName: 'Nocelle',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.946.51136',
    parentId: 946,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nocelle',
    destinationId: 51136,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 60,
    selectable: true,
    destinationUrlName: 'Olbia',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.24293.4231',
    parentId: 24293,
    timeZone: 'Europe/Rome',
    iataCode: 'OLB',
    destinationType: 'CITY',
    destinationName: 'Olbia',
    destinationId: 4231,
    latitude: 40.922207,
    longitude: 9.5003,
  },
  {
    sortOrder: 61,
    selectable: true,
    destinationUrlName: 'Orvieto',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.22033.22810',
    parentId: 22033,
    timeZone: 'Europe/Rome',
    iataCode: 'PEG',
    destinationType: 'CITY',
    destinationName: 'Orvieto',
    destinationId: 22810,
    latitude: 42.71851,
    longitude: 12.11074,
  },
  {
    sortOrder: 62,
    selectable: true,
    destinationUrlName: 'Padua',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.23520.23521',
    parentId: 23520,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Padua',
    destinationId: 23521,
    latitude: 45.40643,
    longitude: 11.87676,
  },
  {
    sortOrder: 63,
    selectable: true,
    destinationUrlName: 'Palermo',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.205.4815',
    parentId: 205,
    timeZone: 'Europe/Rome',
    iataCode: 'PMO',
    destinationType: 'CITY',
    destinationName: 'Palermo',
    destinationId: 4815,
    latitude: 38.11564,
    longitude: 13.3614059,
  },
  {
    sortOrder: 64,
    selectable: true,
    destinationUrlName: 'Parma',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.25817.27234',
    parentId: 25817,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Parma',
    destinationId: 27234,
    latitude: 44.80875,
    longitude: 10.32481,
  },
  {
    sortOrder: 65,
    selectable: true,
    destinationUrlName: 'Pavia',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.25822.28616',
    parentId: 25822,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Pavia',
    destinationId: 28616,
    latitude: 45.18472,
    longitude: 9.15821,
  },
  {
    sortOrder: 66,
    selectable: true,
    destinationUrlName: 'Perugia',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.22033.22034',
    parentId: 22033,
    timeZone: 'Europe/Rome',
    iataCode: 'PEG',
    destinationType: 'CITY',
    destinationName: 'Perugia',
    destinationId: 22034,
    latitude: 43.11072,
    longitude: 12.39083,
  },
  {
    sortOrder: 67,
    selectable: true,
    destinationUrlName: 'Pesaro',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.24161.31073',
    parentId: 24161,
    timeZone: 'Europe/Rome',
    iataCode: 'RMI',
    destinationType: 'CITY',
    destinationName: 'Pesaro',
    destinationId: 31073,
    latitude: 43.91248,
    longitude: 12.91555,
  },
  {
    sortOrder: 68,
    selectable: true,
    destinationUrlName: 'Pescara',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.23411.28882',
    parentId: 23411,
    timeZone: 'Europe/Rome',
    iataCode: 'PSR',
    destinationType: 'CITY',
    destinationName: 'Pescara',
    destinationId: 28882,
    latitude: 42.46179,
    longitude: 14.21609,
  },
  {
    sortOrder: 69,
    selectable: true,
    destinationUrlName: 'Pisa',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.206.520',
    parentId: 206,
    timeZone: 'Europe/Rome',
    iataCode: 'PSA',
    destinationType: 'CITY',
    destinationName: 'Pisa',
    destinationId: 520,
    latitude: 43.7161354,
    longitude: 10.3965843,
  },
  {
    sortOrder: 70,
    selectable: true,
    destinationUrlName: 'Poggibonsi',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.206.50672',
    parentId: 206,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Poggibonsi',
    destinationId: 50672,
    latitude: 43.473438,
    longitude: 11.14674,
  },
  {
    sortOrder: 71,
    selectable: true,
    destinationUrlName: 'Pompeii',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.24336',
    parentId: 57,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Pompeii',
    destinationId: 24336,
    latitude: 40.74813,
    longitude: 14.4898,
  },
  {
    sortOrder: 72,
    selectable: true,
    destinationUrlName: 'Ponza-Island',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.511.51206',
    parentId: 511,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ponza Island',
    destinationId: 51206,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 73,
    selectable: true,
    destinationUrlName: 'Porto-Ercole',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.206.50671',
    parentId: 206,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Porto Ercole',
    destinationId: 50671,
    latitude: 42.39507,
    longitude: 11.20359,
  },
  {
    sortOrder: 74,
    selectable: true,
    destinationUrlName: 'Portofino',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.775.4232',
    parentId: 775,
    timeZone: 'Europe/Rome',
    iataCode: 'PTF',
    destinationType: 'CITY',
    destinationName: 'Portofino',
    destinationId: 4232,
    latitude: 44.30316,
    longitude: 9.20979,
  },
  {
    sortOrder: 75,
    selectable: true,
    destinationUrlName: 'Positano',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.946.33602',
    parentId: 946,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Positano',
    destinationId: 33602,
    latitude: 40.62803,
    longitude: 14.484938,
  },
  {
    sortOrder: 76,
    selectable: true,
    destinationUrlName: 'Procida',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.28880.52175',
    parentId: 28880,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Procida',
    destinationId: 52175,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 77,
    selectable: true,
    destinationUrlName: 'Ragusa',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.205.26225',
    parentId: 205,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ragusa',
    destinationId: 26225,
    latitude: 36.92693,
    longitude: 14.72551,
  },
  {
    sortOrder: 78,
    selectable: true,
    destinationUrlName: 'Ravenna',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.25817.4236',
    parentId: 25817,
    timeZone: 'Europe/Rome',
    iataCode: 'RAN',
    destinationType: 'CITY',
    destinationName: 'Ravenna',
    destinationId: 4236,
    latitude: 44.41836,
    longitude: 12.20353,
  },
  {
    sortOrder: 79,
    selectable: true,
    destinationUrlName: 'Rimini',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.25817.30027',
    parentId: 25817,
    timeZone: 'Europe/Rome',
    iataCode: 'RMI',
    destinationType: 'CITY',
    destinationName: 'Rimini',
    destinationId: 30027,
    latitude: 44.06783,
    longitude: 12.56952,
  },
  {
    sortOrder: 80,
    selectable: true,
    destinationUrlName: 'Rome',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.511',
    parentId: 57,
    timeZone: 'Europe/Rome',
    iataCode: 'ROM',
    destinationType: 'CITY',
    destinationName: 'Rome',
    destinationId: 511,
    latitude: 41.8954656,
    longitude: 12.4823243,
  },
  {
    sortOrder: 81,
    selectable: true,
    destinationUrlName: 'Rovereto',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.28838.28839',
    parentId: 28838,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Rovereto',
    destinationId: 28839,
    latitude: 45.89096,
    longitude: 11.04014,
  },
  {
    sortOrder: 82,
    selectable: true,
    destinationUrlName: 'Salerno',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.4736',
    parentId: 57,
    timeZone: 'Europe/Rome',
    iataCode: 'QSR',
    destinationType: 'CITY',
    destinationName: 'Salerno',
    destinationId: 4736,
    latitude: 40.6766674107,
    longitude: 14.7579860687,
  },
  {
    sortOrder: 83,
    selectable: true,
    destinationUrlName: 'San-Gimignano',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.206.29096',
    parentId: 206,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'San Gimignano',
    destinationId: 29096,
    latitude: 43.46763,
    longitude: 11.04349,
  },
  {
    sortOrder: 84,
    selectable: true,
    destinationUrlName: 'San-Giovanni-Rotondo',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.5538.50670',
    parentId: 5538,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'San Giovanni Rotondo',
    destinationId: 50670,
    latitude: 41.706951,
    longitude: 15.72483,
  },
  {
    sortOrder: 85,
    selectable: true,
    destinationUrlName: 'Sanremo',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.775.50664',
    parentId: 775,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sanremo',
    destinationId: 50664,
    latitude: 43.81841,
    longitude: 7.77842,
  },
  {
    sortOrder: 86,
    selectable: true,
    destinationUrlName: 'SantAgata-de-Goti',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.28880.50951',
    parentId: 28880,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: "Sant'Agata de' Goti",
    destinationId: 50951,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 87,
    selectable: true,
    destinationUrlName: 'Siena',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.206.944',
    parentId: 206,
    timeZone: 'Europe/Rome',
    iataCode: 'SAY',
    destinationType: 'CITY',
    destinationName: 'Siena',
    destinationId: 944,
    latitude: 43.32024477,
    longitude: 11.3214969635,
  },
  {
    sortOrder: 88,
    selectable: true,
    destinationUrlName: 'Sorrento',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.946.947',
    parentId: 946,
    timeZone: 'Europe/Rome',
    iataCode: 'RRO',
    destinationType: 'CITY',
    destinationName: 'Sorrento',
    destinationId: 947,
    latitude: 40.6262925,
    longitude: 14.3757985,
  },
  {
    sortOrder: 89,
    selectable: true,
    destinationUrlName: 'Sperlonga',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.27405.50665',
    parentId: 27405,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sperlonga',
    destinationId: 50665,
    latitude: 41.263676,
    longitude: 13.427141,
  },
  {
    sortOrder: 90,
    selectable: true,
    destinationUrlName: 'Syracuse',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.205.22435',
    parentId: 205,
    timeZone: 'Europe/Rome',
    iataCode: 'SYR',
    destinationType: 'CITY',
    destinationName: 'Syracuse',
    destinationId: 22435,
    latitude: 37.07547,
    longitude: 15.28659,
  },
  {
    sortOrder: 91,
    selectable: true,
    destinationUrlName: 'Taormina',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.205.4237',
    parentId: 205,
    timeZone: 'Europe/Rome',
    iataCode: 'TFC',
    destinationType: 'CITY',
    destinationName: 'Taormina',
    destinationId: 4237,
    latitude: 37.8530665,
    longitude: 15.2879163,
  },
  {
    sortOrder: 92,
    selectable: true,
    destinationUrlName: 'Taranto',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.5538.28840',
    parentId: 5538,
    timeZone: 'Europe/Rome',
    iataCode: 'TAR',
    destinationType: 'CITY',
    destinationName: 'Taranto',
    destinationId: 28840,
    latitude: 40.46436,
    longitude: 17.24703,
  },
  {
    sortOrder: 93,
    selectable: true,
    destinationUrlName: 'Terracina',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.27405.50667',
    parentId: 27405,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Terracina',
    destinationId: 50667,
    latitude: 41.291222,
    longitude: 13.24887,
  },
  {
    sortOrder: 94,
    selectable: true,
    destinationUrlName: 'Toscolano-Maderno',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.25822.50668',
    parentId: 25822,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Toscolano-Maderno',
    destinationId: 50668,
    latitude: 45.635479,
    longitude: 10.60956,
  },
  {
    sortOrder: 95,
    selectable: true,
    destinationUrlName: 'Trapani',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.205.23401',
    parentId: 205,
    timeZone: 'Europe/Rome',
    iataCode: 'TPS',
    destinationType: 'CITY',
    destinationName: 'Trapani',
    destinationId: 23401,
    latitude: 38.017618,
    longitude: 12.537202,
  },
  {
    sortOrder: 96,
    selectable: true,
    destinationUrlName: 'Trento',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.28838.29399',
    parentId: 28838,
    timeZone: 'Europe/Rome',
    iataCode: 'ZIA',
    destinationType: 'CITY',
    destinationName: 'Trento',
    destinationId: 29399,
    latitude: 46.07478,
    longitude: 11.12175,
  },
  {
    sortOrder: 97,
    selectable: true,
    destinationUrlName: 'Treviso',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.23520.29720',
    parentId: 23520,
    timeZone: 'Europe/Rome',
    iataCode: 'TSF',
    destinationType: 'CITY',
    destinationName: 'Treviso',
    destinationId: 29720,
    latitude: 45.66689,
    longitude: 12.24304,
  },
  {
    sortOrder: 98,
    selectable: true,
    destinationUrlName: 'Trieste',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.29857.4239',
    parentId: 29857,
    timeZone: 'Europe/Rome',
    iataCode: 'TRS',
    destinationType: 'CITY',
    destinationName: 'Trieste',
    destinationId: 4239,
    latitude: 45.64953,
    longitude: 13.77682,
  },
  {
    sortOrder: 99,
    selectable: true,
    destinationUrlName: 'Tropea',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.26226.33165',
    parentId: 26226,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tropea',
    destinationId: 33165,
    latitude: 38.677041,
    longitude: 15.897869,
  },
  {
    sortOrder: 100,
    selectable: true,
    destinationUrlName: 'Turin',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.775.802',
    parentId: 775,
    timeZone: 'Europe/Rome',
    iataCode: 'TRN',
    destinationType: 'CITY',
    destinationName: 'Turin',
    destinationId: 802,
    latitude: 45.0705621,
    longitude: 7.6866186,
  },
  {
    sortOrder: 101,
    selectable: true,
    destinationUrlName: 'Venice',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.23520.522',
    parentId: 23520,
    timeZone: 'Europe/Rome',
    iataCode: 'VCE',
    destinationType: 'CITY',
    destinationName: 'Venice',
    destinationId: 522,
    latitude: 45.4323405192,
    longitude: 12.3067903519,
  },
  {
    sortOrder: 102,
    selectable: true,
    destinationUrlName: 'Verona',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.23520.945',
    parentId: 23520,
    timeZone: 'Europe/Rome',
    iataCode: 'VRN',
    destinationType: 'CITY',
    destinationName: 'Verona',
    destinationId: 945,
    latitude: 45.4262289,
    longitude: 10.9224915,
  },
  {
    sortOrder: 103,
    selectable: true,
    destinationUrlName: 'Versilia',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.206.26227',
    parentId: 206,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Versilia',
    destinationId: 26227,
    latitude: 44.13492,
    longitude: 12.22706,
  },
  {
    sortOrder: 104,
    selectable: true,
    destinationUrlName: 'Vicenza',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.23520.28582',
    parentId: 23520,
    timeZone: 'Europe/Rome',
    iataCode: 'VIC',
    destinationType: 'CITY',
    destinationName: 'Vicenza',
    destinationId: 28582,
    latitude: 45.54548,
    longitude: 11.53542,
  },
  {
    sortOrder: 105,
    selectable: true,
    destinationUrlName: 'Vieste',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.57.5538.50845',
    parentId: 5538,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Vieste',
    destinationId: 50845,
    latitude: 41.8826533767,
    longitude: 16.1767387658,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Spain',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67',
    parentId: 6,
    timeZone: 'Europe/Madrid',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Spain',
    destinationId: 67,
    latitude: 40.463667,
    longitude: -3.74922,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Andalucia',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.228',
    parentId: 67,
    timeZone: 'Europe/Madrid',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Andalucia',
    destinationId: 228,
    latitude: 37.544271,
    longitude: -4.727753,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Aragon',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.24333',
    parentId: 67,
    timeZone: 'Europe/Madrid',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Aragón',
    destinationId: 24333,
    latitude: 41.3951,
    longitude: -0.8392,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Asturias',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.23530',
    parentId: 67,
    timeZone: 'Europe/Madrid',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Asturias',
    destinationId: 23530,
    latitude: 43.2258,
    longitude: -6.3405,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Balearic-Islands',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.229',
    parentId: 67,
    timeZone: 'Europe/Madrid',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Balearic Islands',
    destinationId: 229,
    latitude: 39.5341789,
    longitude: 2.8577105,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Basque-Country',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.798',
    parentId: 67,
    timeZone: 'Europe/Madrid',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Basque Country',
    destinationId: 798,
    latitude: 42.9896248,
    longitude: -2.6189273,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Canary-Islands',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.231',
    parentId: 67,
    timeZone: 'Atlantic/Canary',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Canary Islands',
    destinationId: 231,
    latitude: 28.2915637,
    longitude: -16.6291304,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Castile-and-Leon',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.24343',
    parentId: 67,
    timeZone: 'Europe/Madrid',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Castile and León',
    destinationId: 24343,
    latitude: 41.835682,
    longitude: -4.397636,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Castilla-La-Mancha',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.26850',
    parentId: 67,
    timeZone: 'Europe/Madrid',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Castilla-La Mancha',
    destinationId: 26850,
    latitude: 39.27956,
    longitude: -3.0977,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Catalonia',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.25883',
    parentId: 67,
    timeZone: 'Europe/Madrid',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Catalonia',
    destinationId: 25883,
    latitude: 41.591159,
    longitude: 1.520862,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Costa-Blanca',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.769',
    parentId: 67,
    timeZone: 'Europe/Madrid',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Costa Blanca',
    destinationId: 769,
    latitude: 38.096927,
    longitude: -0.862495,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Costa-Brava',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.742',
    parentId: 67,
    timeZone: 'Europe/Madrid',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Costa Brava',
    destinationId: 742,
    latitude: 41.7795048659,
    longitude: 3.0212402344,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Costa-del-Sol',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.28471',
    parentId: 67,
    timeZone: 'Europe/Madrid',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Costa del Sol',
    destinationId: 28471,
    latitude: 36.52481,
    longitude: -5.03905,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Extremadura',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.25819',
    parentId: 67,
    timeZone: 'Europe/Madrid',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Extremadura',
    destinationId: 25819,
    latitude: 39.0,
    longitude: -6.0,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Galicia',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.26109',
    parentId: 67,
    timeZone: 'Europe/Madrid',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Galicia',
    destinationId: 26109,
    latitude: 42.575055,
    longitude: -8.133856,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'La-Rioja',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.26298',
    parentId: 67,
    timeZone: 'Europe/Madrid',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'La Rioja',
    destinationId: 26298,
    latitude: 42.2761895,
    longitude: -3.5275885,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Region-of-Murcia',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.26593',
    parentId: 67,
    timeZone: 'Europe/Madrid',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Region of Murcia',
    destinationId: 26593,
    latitude: 37.99224,
    longitude: -1.13065,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Alicante',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.23519',
    parentId: 67,
    timeZone: 'Europe/Madrid',
    iataCode: 'ALC',
    destinationType: 'CITY',
    destinationName: 'Alicante',
    destinationId: 23519,
    latitude: 38.344032,
    longitude: -0.484558,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Almeria',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.228.4483',
    parentId: 228,
    timeZone: 'Europe/Madrid',
    iataCode: 'LEI',
    destinationType: 'CITY',
    destinationName: 'Almeria',
    destinationId: 4483,
    latitude: 36.833898,
    longitude: -2.462932,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Altea-la-Vella',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.50358',
    parentId: 67,
    timeZone: 'Europe/Madrid',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Altea la Vella',
    destinationId: 50358,
    latitude: 38.6283,
    longitude: -0.0421,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Antequera',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.228.50294',
    parentId: 228,
    timeZone: 'Europe/Madrid',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Antequera',
    destinationId: 50294,
    latitude: 37.02,
    longitude: -4.5594,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Arrecife',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.231.4486',
    parentId: 231,
    timeZone: 'Europe/Madrid',
    iataCode: 'ACE',
    destinationType: 'CITY',
    destinationName: 'Arrecife',
    destinationId: 4486,
    latitude: 28.965169,
    longitude: -13.555036,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Baeza',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.228.51262',
    parentId: 228,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Baeza',
    destinationId: 51262,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Barcelona',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.25883.562',
    parentId: 25883,
    timeZone: 'Europe/Madrid',
    iataCode: 'BCN',
    destinationType: 'CITY',
    destinationName: 'Barcelona',
    destinationId: 562,
    latitude: 41.387917,
    longitude: 2.1699187,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Benahavis',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.228.50291',
    parentId: 228,
    timeZone: 'Europe/Madrid',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Benahavis',
    destinationId: 50291,
    latitude: 36.5205,
    longitude: -5.0456,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Benidorm',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.769.31484',
    parentId: 769,
    timeZone: 'Europe/Madrid',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Benidorm',
    destinationId: 31484,
    latitude: 38.54106,
    longitude: -0.12249,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Bilbao',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.798.4485',
    parentId: 798,
    timeZone: 'Europe/Madrid',
    iataCode: 'BIO',
    destinationType: 'CITY',
    destinationName: 'Bilbao',
    destinationId: 4485,
    latitude: 43.2633182,
    longitude: -2.9685838,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Burgos',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.24343.36284',
    parentId: 24343,
    timeZone: 'Europe/Madrid',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Burgos',
    destinationId: 36284,
    latitude: 42.3441047,
    longitude: -3.7647329,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Caceres',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.25819.50465',
    parentId: 25819,
    timeZone: 'Europe/Madrid',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Caceres',
    destinationId: 50465,
    latitude: 39.476219,
    longitude: -6.37086,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Cadiz',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.228.22439',
    parentId: 228,
    timeZone: 'Europe/Madrid',
    iataCode: 'CDZ',
    destinationType: 'CITY',
    destinationName: 'Cádiz',
    destinationId: 22439,
    latitude: 36.52706,
    longitude: -6.2886,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Cantabria',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.51181',
    parentId: 67,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cantabria',
    destinationId: 51181,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Cartagena',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.26593.4276',
    parentId: 26593,
    timeZone: 'Europe/Madrid',
    iataCode: 'MJV',
    destinationType: 'CITY',
    destinationName: 'Cartagena',
    destinationId: 4276,
    latitude: 37.625683,
    longitude: -0.996584,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Cordoba',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.228.5254',
    parentId: 228,
    timeZone: 'Europe/Madrid',
    iataCode: 'ODB',
    destinationType: 'CITY',
    destinationName: 'Cordoba',
    destinationId: 5254,
    latitude: 37.8915808,
    longitude: -4.7794,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Cuenca',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.50290',
    parentId: 67,
    timeZone: 'America/Guayaquil',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cuenca',
    destinationId: 50290,
    latitude: 40.0703,
    longitude: -2.1374,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Elciego',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.798.50866',
    parentId: 798,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Elciego',
    destinationId: 50866,
    latitude: 42.5154374382,
    longitude: -2.6187148851,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Falset',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.25883.51307',
    parentId: 25883,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Falset',
    destinationId: 51307,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Figueres',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.5097',
    parentId: 67,
    timeZone: 'Europe/Madrid',
    iataCode: 'GRO',
    destinationType: 'CITY',
    destinationName: 'Figueres',
    destinationId: 5097,
    latitude: 42.26551,
    longitude: 2.9581,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Formentera',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.229.50359',
    parentId: 229,
    timeZone: 'Europe/Madrid',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Formentera',
    destinationId: 50359,
    latitude: 38.6964,
    longitude: 1.4531,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'Fuerteventura',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.231.5582',
    parentId: 231,
    timeZone: 'Europe/Madrid',
    iataCode: 'FUE',
    destinationType: 'CITY',
    destinationName: 'Fuerteventura',
    destinationId: 5582,
    latitude: 28.358744,
    longitude: -14.053676,
  },
  {
    sortOrder: 23,
    selectable: true,
    destinationUrlName: 'Gijon',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.4278',
    parentId: 67,
    timeZone: 'Europe/Madrid',
    iataCode: 'OVD',
    destinationType: 'CITY',
    destinationName: 'Gijon',
    destinationId: 4278,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 24,
    selectable: true,
    destinationUrlName: 'Girona',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.25883.23015',
    parentId: 25883,
    timeZone: 'Europe/Madrid',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Girona',
    destinationId: 23015,
    latitude: 41.9794,
    longitude: 2.82143,
  },
  {
    sortOrder: 25,
    selectable: true,
    destinationUrlName: 'Granada',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.228.554',
    parentId: 228,
    timeZone: 'Europe/Madrid',
    iataCode: 'GRX',
    destinationType: 'CITY',
    destinationName: 'Granada',
    destinationId: 554,
    latitude: 37.1764874,
    longitude: -3.5979291,
  },
  {
    sortOrder: 26,
    selectable: true,
    destinationUrlName: 'Gran-Canaria',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.231.792',
    parentId: 231,
    timeZone: 'Atlantic/Canary',
    iataCode: 'LPA',
    destinationType: 'CITY',
    destinationName: 'Gran Canaria',
    destinationId: 792,
    latitude: 27.9202202,
    longitude: -15.5474373,
  },
  {
    sortOrder: 27,
    selectable: true,
    destinationUrlName: 'Ibiza',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.229.4217',
    parentId: 229,
    timeZone: 'Europe/Madrid',
    iataCode: 'IBZ',
    destinationType: 'CITY',
    destinationName: 'Ibiza',
    destinationId: 4217,
    latitude: 38.9082999695,
    longitude: 1.432299614,
  },
  {
    sortOrder: 28,
    selectable: true,
    destinationUrlName: 'La-Coruna',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.26109.741',
    parentId: 26109,
    timeZone: 'Europe/Madrid',
    iataCode: 'LCG',
    destinationType: 'CITY',
    destinationName: 'La Coruna',
    destinationId: 741,
    latitude: 43.362518,
    longitude: -8.411724,
  },
  {
    sortOrder: 29,
    selectable: true,
    destinationUrlName: 'La-Gomera',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.231.27172',
    parentId: 231,
    timeZone: 'Atlantic/Canary',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'La Gomera',
    destinationId: 27172,
    latitude: 28.1033,
    longitude: -17.21936,
  },
  {
    sortOrder: 30,
    selectable: true,
    destinationUrlName: 'Lanzarote',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.231.5482',
    parentId: 231,
    timeZone: 'Atlantic/Canary',
    iataCode: 'ACE',
    destinationType: 'CITY',
    destinationName: 'Lanzarote',
    destinationId: 5482,
    latitude: 29.0468534991,
    longitude: -13.5899732995,
  },
  {
    sortOrder: 31,
    selectable: true,
    destinationUrlName: 'La-Palma',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.231.4487',
    parentId: 231,
    timeZone: 'Europe/Madrid',
    iataCode: 'SPC',
    destinationType: 'CITY',
    destinationName: 'La Palma',
    destinationId: 4487,
    latitude: 28.6666,
    longitude: -17.8666,
  },
  {
    sortOrder: 32,
    selectable: true,
    destinationUrlName: 'Leon',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.24343.36286',
    parentId: 24343,
    timeZone: 'Europe/Madrid',
    iataCode: 'BJX',
    destinationType: 'CITY',
    destinationName: 'Leon',
    destinationId: 36286,
    latitude: 42.6036003,
    longitude: -5.6124107,
  },
  {
    sortOrder: 33,
    selectable: true,
    destinationUrlName: 'Madrid',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.566',
    parentId: 67,
    timeZone: 'Europe/Madrid',
    iataCode: 'MAD',
    destinationType: 'CITY',
    destinationName: 'Madrid',
    destinationId: 566,
    latitude: 40.4166909,
    longitude: -3.7003454,
  },
  {
    sortOrder: 34,
    selectable: true,
    destinationUrlName: 'Malaga',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.228.956',
    parentId: 228,
    timeZone: 'Europe/Madrid',
    iataCode: 'AGP',
    destinationType: 'CITY',
    destinationName: 'Malaga',
    destinationId: 956,
    latitude: 36.7196484,
    longitude: -4.4200163,
  },
  {
    sortOrder: 35,
    selectable: true,
    destinationUrlName: 'Mallorca',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.229.955',
    parentId: 229,
    timeZone: 'Europe/Madrid',
    iataCode: 'PMI',
    destinationType: 'CITY',
    destinationName: 'Mallorca',
    destinationId: 955,
    latitude: 39.554353644,
    longitude: 2.6264190674,
  },
  {
    sortOrder: 36,
    selectable: true,
    destinationUrlName: 'Marbella',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.28471.22304',
    parentId: 28471,
    timeZone: 'Europe/Madrid',
    iataCode: 'QRL',
    destinationType: 'CITY',
    destinationName: 'Marbella',
    destinationId: 22304,
    latitude: 36.51007,
    longitude: -4.88245,
  },
  {
    sortOrder: 37,
    selectable: true,
    destinationUrlName: 'Menorca',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.229.4216',
    parentId: 229,
    timeZone: 'Europe/Madrid',
    iataCode: 'MAH',
    destinationType: 'CITY',
    destinationName: 'Menorca',
    destinationId: 4216,
    latitude: 40.0028979166,
    longitude: 3.8394641876,
  },
  {
    sortOrder: 38,
    selectable: true,
    destinationUrlName: 'Merida',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.25819.51211',
    parentId: 25819,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Merida',
    destinationId: 51211,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 39,
    selectable: true,
    destinationUrlName: 'Montblanc',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.25883.51283',
    parentId: 25883,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Montblanc',
    destinationId: 51283,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 40,
    selectable: true,
    destinationUrlName: 'Figtree',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.25883.51199',
    parentId: 25883,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Figtree',
    destinationId: 51199,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 41,
    selectable: true,
    destinationUrlName: 'Murcia',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.26593.50360',
    parentId: 26593,
    timeZone: 'Europe/Madrid',
    iataCode: 'MJV',
    destinationType: 'CITY',
    destinationName: 'Murcia',
    destinationId: 50360,
    latitude: 37.9922,
    longitude: -1.1307,
  },
  {
    sortOrder: 42,
    selectable: true,
    destinationUrlName: 'Oviedo',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.23530.50357',
    parentId: 23530,
    timeZone: 'Europe/Madrid',
    iataCode: 'OVD',
    destinationType: 'CITY',
    destinationName: 'Oviedo',
    destinationId: 50357,
    latitude: 43.3619,
    longitude: -5.8494,
  },
  {
    sortOrder: 43,
    selectable: true,
    destinationUrlName: 'Pamplona',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.22689',
    parentId: 67,
    timeZone: 'Europe/Madrid',
    iataCode: 'PNA',
    destinationType: 'CITY',
    destinationName: 'Pamplona',
    destinationId: 22689,
    latitude: 42.813116,
    longitude: -1.645902,
  },
  {
    sortOrder: 44,
    selectable: true,
    destinationUrlName: 'Puerto-del-Rosario',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.231.4488',
    parentId: 231,
    timeZone: 'Europe/Madrid',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Puerto del Rosario',
    destinationId: 4488,
    latitude: 28.4993413,
    longitude: -13.87939,
  },
  {
    sortOrder: 45,
    selectable: true,
    destinationUrlName: 'Salamanca',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.24343.25935',
    parentId: 24343,
    timeZone: 'Europe/Madrid',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Salamanca',
    destinationId: 25935,
    latitude: 40.969979,
    longitude: -5.661359,
  },
  {
    sortOrder: 46,
    selectable: true,
    destinationUrlName: 'San-Sebastian',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.798.5505',
    parentId: 798,
    timeZone: 'Europe/Madrid',
    iataCode: 'EAS',
    destinationType: 'CITY',
    destinationName: 'San Sebastian',
    destinationId: 5505,
    latitude: 43.3183339989,
    longitude: -1.9812313013,
  },
  {
    sortOrder: 47,
    selectable: true,
    destinationUrlName: 'San-Sebastian-de-La-Gomera',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.231.4489',
    parentId: 231,
    timeZone: 'Europe/Madrid',
    iataCode: 'GMZ',
    destinationType: 'CITY',
    destinationName: 'San Sebastian de La Gomera',
    destinationId: 4489,
    latitude: 28.0938,
    longitude: -17.109858,
  },
  {
    sortOrder: 48,
    selectable: true,
    destinationUrlName: 'Santander',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.50292',
    parentId: 67,
    timeZone: 'Europe/Madrid',
    iataCode: 'SDR',
    destinationType: 'CITY',
    destinationName: 'Santander',
    destinationId: 50292,
    latitude: 43.4623,
    longitude: -3.81,
  },
  {
    sortOrder: 49,
    selectable: true,
    destinationUrlName: 'Santiago-de-Compostela',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.26109.565',
    parentId: 26109,
    timeZone: 'Europe/Madrid',
    iataCode: 'SCQ',
    destinationType: 'CITY',
    destinationName: 'Santiago de Compostela',
    destinationId: 565,
    latitude: 42.8804471,
    longitude: -8.5463034,
  },
  {
    sortOrder: 50,
    selectable: true,
    destinationUrlName: 'Santillana-del-Mar',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.51181.51513',
    parentId: 51181,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Santillana del Mar',
    destinationId: 51513,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 51,
    selectable: true,
    destinationUrlName: 'San-Vicente-de-la-Sonsierra',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.26298.51123',
    parentId: 26298,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'San Vicente de la Sonsierra',
    destinationId: 51123,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 52,
    selectable: true,
    destinationUrlName: 'Sarria',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.26109.50973',
    parentId: 26109,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sarria',
    destinationId: 50973,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 53,
    selectable: true,
    destinationUrlName: 'Segovia',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.24343.26564',
    parentId: 24343,
    timeZone: 'Europe/Madrid',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Segovia',
    destinationId: 26564,
    latitude: 40.9429,
    longitude: -4.10881,
  },
  {
    sortOrder: 54,
    selectable: true,
    destinationUrlName: 'Seville',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.228.556',
    parentId: 228,
    timeZone: 'Europe/Madrid',
    iataCode: 'SVQ',
    destinationType: 'CITY',
    destinationName: 'Seville',
    destinationId: 556,
    latitude: 37.38264,
    longitude: -5.9962951,
  },
  {
    sortOrder: 55,
    selectable: true,
    destinationUrlName: 'Sierra-de-Grazalema-Natural-Park',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.228.51318',
    parentId: 228,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sierra de Grazalema Natural Park',
    destinationId: 51318,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 56,
    selectable: true,
    destinationUrlName: 'Tarifa',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.50288',
    parentId: 67,
    timeZone: 'Europe/Madrid',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tarifa',
    destinationId: 50288,
    latitude: 36.0143,
    longitude: -5.6044,
  },
  {
    sortOrder: 57,
    selectable: true,
    destinationUrlName: 'Tarragona',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.25883.23038',
    parentId: 25883,
    timeZone: 'Europe/Madrid',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tarragona',
    destinationId: 23038,
    latitude: 41.11888,
    longitude: 1.24449,
  },
  {
    sortOrder: 58,
    selectable: true,
    destinationUrlName: 'Tenerife',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.231.5404',
    parentId: 231,
    timeZone: 'Europe/Madrid',
    iataCode: 'TFS',
    destinationType: 'CITY',
    destinationName: 'Tenerife',
    destinationId: 5404,
    latitude: 28.291565,
    longitude: -16.629129,
  },
  {
    sortOrder: 59,
    selectable: true,
    destinationUrlName: 'Toledo',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.22438',
    parentId: 67,
    timeZone: 'Europe/Madrid',
    iataCode: 'TOL',
    destinationType: 'CITY',
    destinationName: 'Toledo',
    destinationId: 22438,
    latitude: 39.86283,
    longitude: -4.02732,
  },
  {
    sortOrder: 60,
    selectable: true,
    destinationUrlName: 'Torrevieja',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.769.27761',
    parentId: 769,
    timeZone: 'Europe/Madrid',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Torrevieja',
    destinationId: 27761,
    latitude: 37.9847,
    longitude: -0.68082,
  },
  {
    sortOrder: 61,
    selectable: true,
    destinationUrlName: 'Trujillo',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.25819.51242',
    parentId: 25819,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Trujillo',
    destinationId: 51242,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 62,
    selectable: true,
    destinationUrlName: 'Ubeda',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.228.51230',
    parentId: 228,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ubeda',
    destinationId: 51230,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 63,
    selectable: true,
    destinationUrlName: 'Valencia',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.811',
    parentId: 67,
    timeZone: 'Europe/Madrid',
    iataCode: 'VLC',
    destinationType: 'CITY',
    destinationName: 'Valencia',
    destinationId: 811,
    latitude: 39.4389108292,
    longitude: -0.3164577484,
  },
  {
    sortOrder: 64,
    selectable: true,
    destinationUrlName: 'Valenica-Province',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.51395',
    parentId: 67,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Valenica Province',
    destinationId: 51395,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 65,
    selectable: true,
    destinationUrlName: 'Valladolid',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.24343.36285',
    parentId: 24343,
    timeZone: 'Europe/Madrid',
    iataCode: 'VLL',
    destinationType: 'CITY',
    destinationName: 'Valladolid',
    destinationId: 36285,
    latitude: 41.7031684,
    longitude: -4.948896,
  },
  {
    sortOrder: 66,
    selectable: true,
    destinationUrlName: 'Vigo',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.26109.27330',
    parentId: 26109,
    timeZone: 'Europe/Madrid',
    iataCode: 'VGO',
    destinationType: 'CITY',
    destinationName: 'Vigo',
    destinationId: 27330,
    latitude: 42.2406,
    longitude: -8.72073,
  },
  {
    sortOrder: 67,
    selectable: true,
    destinationUrlName: 'Xativa',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.811.51260',
    parentId: 811,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Xativa',
    destinationId: 51260,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 68,
    selectable: true,
    destinationUrlName: 'Zaragoza',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.67.24333.28720',
    parentId: 24333,
    timeZone: 'Europe/Madrid',
    iataCode: 'ZAZ',
    destinationType: 'CITY',
    destinationName: 'Zaragoza',
    destinationId: 28720,
    latitude: 41.64882,
    longitude: -0.88909,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'England',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731',
    parentId: 6,
    timeZone: 'Europe/London',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'England',
    destinationId: 731,
    latitude: 52.0190289,
    longitude: -0.7704274,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'East-Midlands',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.25814',
    parentId: 731,
    timeZone: 'Europe/London',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'East Midlands',
    destinationId: 25814,
    latitude: 52.82937,
    longitude: -1.33213,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'East-of-England',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.22326',
    parentId: 731,
    timeZone: 'Europe/London',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'East of England',
    destinationId: 22326,
    latitude: 52.35552,
    longitude: -1.17432,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Isle-of-Man',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.5017',
    parentId: 731,
    timeZone: 'Europe/Isle_of_Man',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Isle of Man',
    destinationId: 5017,
    latitude: 54.2357,
    longitude: -4.5151,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Lake-District',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.822',
    parentId: 731,
    timeZone: 'Europe/London',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Lake District',
    destinationId: 822,
    latitude: 54.5,
    longitude: -3.1666667,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'North-East-England',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.23188',
    parentId: 731,
    timeZone: 'Europe/London',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'North East England',
    destinationId: 23188,
    latitude: 52.35552,
    longitude: -1.17432,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'North-West-England',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.766',
    parentId: 731,
    timeZone: 'Europe/London',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'North West England',
    destinationId: 766,
    latitude: 53.9577018,
    longitude: -1.0822855,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Peak-District-National-Park',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.33079',
    parentId: 731,
    timeZone: 'Europe/London',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Peak District National Park',
    destinationId: 33079,
    latitude: 53.247247,
    longitude: -1.763678,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'South-East-England',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.5536',
    parentId: 731,
    timeZone: 'Europe/London',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'South East England',
    destinationId: 5536,
    latitude: 51.7610850731,
    longitude: -1.1303743883,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'South-West-England',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.23059',
    parentId: 731,
    timeZone: 'Europe/London',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'South West England',
    destinationId: 23059,
    latitude: 50.96,
    longitude: -3.22,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'West-Midlands',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.22392',
    parentId: 731,
    timeZone: 'Europe/London',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'West Midlands',
    destinationId: 22392,
    latitude: 52.590887,
    longitude: -1.866009,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Yorkshire',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.22770',
    parentId: 731,
    timeZone: 'Europe/London',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Yorkshire',
    destinationId: 22770,
    latitude: 54.058669,
    longitude: -0.432398,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Alton',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.22392.33092',
    parentId: 22392,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Alton',
    destinationId: 33092,
    latitude: 51.15063,
    longitude: -0.973058,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Bath',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.23059.27175',
    parentId: 23059,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bath',
    destinationId: 27175,
    latitude: 51.3758,
    longitude: -2.3599,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Birmingham',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.22392.22776',
    parentId: 22392,
    timeZone: 'Europe/London',
    iataCode: 'BHX',
    destinationType: 'CITY',
    destinationName: 'Birmingham',
    destinationId: 22776,
    latitude: 52.486084,
    longitude: -1.884498,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Blackpool',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.766.22389',
    parentId: 766,
    timeZone: 'Europe/London',
    iataCode: 'BLK',
    destinationType: 'CITY',
    destinationName: 'Blackpool',
    destinationId: 22389,
    latitude: 53.817575,
    longitude: -3.034394,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Bournemouth',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.23059.25977',
    parentId: 23059,
    timeZone: 'Europe/London',
    iataCode: 'BOH',
    destinationType: 'CITY',
    destinationName: 'Bournemouth',
    destinationId: 25977,
    latitude: 50.718354,
    longitude: -1.874035,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Brighton',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.5536.24027',
    parentId: 5536,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Brighton',
    destinationId: 24027,
    latitude: 50.821949,
    longitude: -0.134087,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Bristol',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.23059.4293',
    parentId: 23059,
    timeZone: 'Europe/London',
    iataCode: 'BRS',
    destinationType: 'CITY',
    destinationName: 'Bristol',
    destinationId: 4293,
    latitude: 51.454511,
    longitude: -2.588096,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Cambridge',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.22326.22327',
    parentId: 22326,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cambridge',
    destinationId: 22327,
    latitude: 52.20534,
    longitude: 0.12182,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Canterbury',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.5536.24670',
    parentId: 5536,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Canterbury',
    destinationId: 24670,
    latitude: 51.28023,
    longitude: 1.080095,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Carlisle',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.766.26513',
    parentId: 766,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Carlisle',
    destinationId: 26513,
    latitude: 54.88,
    longitude: -2.93,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Castleton',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.33079.50653',
    parentId: 33079,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Castleton',
    destinationId: 50653,
    latitude: 53.34322,
    longitude: -1.7753,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Chatham',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.5536.26504',
    parentId: 5536,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Chatham',
    destinationId: 26504,
    latitude: 51.381359,
    longitude: 0.524342,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Chester',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.766.36691',
    parentId: 766,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Chester',
    destinationId: 36691,
    latitude: 53.1924838,
    longitude: -3.4481848,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Cornwall',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.23059.24556',
    parentId: 23059,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cornwall',
    destinationId: 24556,
    latitude: 50.4379573,
    longitude: -6.0770247,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Cotswolds',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.28629',
    parentId: 731,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cotswolds',
    destinationId: 28629,
    latitude: 51.99967,
    longitude: -1.69955,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Coventry',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.22392.23891',
    parentId: 22392,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Coventry',
    destinationId: 23891,
    latitude: 52.406681,
    longitude: -1.517796,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Devon',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.28613',
    parentId: 731,
    timeZone: 'Europe/London',
    iataCode: 'EXT',
    destinationType: 'CITY',
    destinationName: 'Devon',
    destinationId: 28613,
    latitude: 50.71556,
    longitude: -3.53087,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Douglas',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.5017.5018',
    parentId: 5017,
    timeZone: 'Europe/Isle_of_Man',
    iataCode: 'IOM',
    destinationType: 'CITY',
    destinationName: 'Douglas',
    destinationId: 5018,
    latitude: 31.508869,
    longitude: -82.850388,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Dover',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.5536.32552',
    parentId: 5536,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Dover',
    destinationId: 32552,
    latitude: 51.127955,
    longitude: 1.313396,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Falmouth',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.23059.4306',
    parentId: 23059,
    timeZone: 'Europe/London',
    iataCode: 'NQY',
    destinationType: 'CITY',
    destinationName: 'Falmouth',
    destinationId: 4306,
    latitude: 50.1552,
    longitude: -5.0688,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Hastings',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.5536.26251',
    parentId: 5536,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Hastings',
    destinationId: 26251,
    latitude: 50.8554,
    longitude: 0.5825,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'Hereford',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.22392.24632',
    parentId: 22392,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Hereford',
    destinationId: 24632,
    latitude: 52.05,
    longitude: -2.7167,
  },
  {
    sortOrder: 23,
    selectable: true,
    destinationUrlName: 'Horley',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.5536.50500',
    parentId: 5536,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Horley',
    destinationId: 50500,
    latitude: 51.174271,
    longitude: -0.15917,
  },
  {
    sortOrder: 24,
    selectable: true,
    destinationUrlName: 'Isle-of-Wight',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.5536.23531',
    parentId: 5536,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Isle of Wight',
    destinationId: 23531,
    latitude: 50.693179,
    longitude: -1.295155,
  },
  {
    sortOrder: 25,
    selectable: true,
    destinationUrlName: 'Kendal',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.822.50312',
    parentId: 822,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kendal',
    destinationId: 50312,
    latitude: 54.328104,
    longitude: -2.74551,
  },
  {
    sortOrder: 26,
    selectable: true,
    destinationUrlName: 'Keswick',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.822.26224',
    parentId: 822,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Keswick',
    destinationId: 26224,
    latitude: 54.601182,
    longitude: -3.133563,
  },
  {
    sortOrder: 27,
    selectable: true,
    destinationUrlName: 'Leeds',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.22770.26342',
    parentId: 22770,
    timeZone: 'Europe/London',
    iataCode: 'LBA',
    destinationType: 'CITY',
    destinationName: 'Leeds',
    destinationId: 26342,
    latitude: 53.800446,
    longitude: -1.541407,
  },
  {
    sortOrder: 28,
    selectable: true,
    destinationUrlName: 'Leicester',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.25814.25957',
    parentId: 25814,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Leicester',
    destinationId: 25957,
    latitude: 52.63,
    longitude: -1.1332,
  },
  {
    sortOrder: 29,
    selectable: true,
    destinationUrlName: 'Liverpool',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.766.940',
    parentId: 766,
    timeZone: 'Europe/London',
    iataCode: 'LPL',
    destinationType: 'CITY',
    destinationName: 'Liverpool',
    destinationId: 940,
    latitude: 53.416667,
    longitude: -3.0,
  },
  {
    sortOrder: 30,
    selectable: true,
    destinationUrlName: 'London',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.737',
    parentId: 731,
    timeZone: 'Europe/London',
    iataCode: 'LON',
    destinationType: 'CITY',
    destinationName: 'London',
    destinationId: 737,
    latitude: 51.5072,
    longitude: -0.1275,
  },
  {
    sortOrder: 31,
    selectable: true,
    destinationUrlName: 'Manchester',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.766.4056',
    parentId: 766,
    timeZone: 'Etc/GMT',
    iataCode: 'MAN',
    destinationType: 'CITY',
    destinationName: 'Manchester',
    destinationId: 4056,
    latitude: 53.479251,
    longitude: -2.247926,
  },
  {
    sortOrder: 32,
    selectable: true,
    destinationUrlName: 'Middlesbrough',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.22770.25932',
    parentId: 22770,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Middlesbrough',
    destinationId: 25932,
    latitude: 54.5804,
    longitude: -1.23,
  },
  {
    sortOrder: 33,
    selectable: true,
    destinationUrlName: 'Milton-Keynes',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.5536.50656',
    parentId: 5536,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Milton Keynes',
    destinationId: 50656,
    latitude: 52.040623,
    longitude: -0.759417,
  },
  {
    sortOrder: 34,
    selectable: true,
    destinationUrlName: 'Newcastle-upon-Tyne',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.23188.23189',
    parentId: 23188,
    timeZone: 'Europe/London',
    iataCode: 'NCL',
    destinationType: 'CITY',
    destinationName: 'Newcastle-upon-Tyne',
    destinationId: 23189,
    latitude: 55.0022917,
    longitude: -1.7969253,
  },
  {
    sortOrder: 35,
    selectable: true,
    destinationUrlName: 'Newquay',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.23059.25933',
    parentId: 23059,
    timeZone: 'Europe/London',
    iataCode: 'NQY',
    destinationType: 'CITY',
    destinationName: 'Newquay',
    destinationId: 25933,
    latitude: 50.4144,
    longitude: -5.0751,
  },
  {
    sortOrder: 36,
    selectable: true,
    destinationUrlName: 'Northampton',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.25814.25815',
    parentId: 25814,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Northampton',
    destinationId: 25815,
    latitude: 52.240184,
    longitude: -0.896794,
  },
  {
    sortOrder: 37,
    selectable: true,
    destinationUrlName: 'Norwich',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.22326.25031',
    parentId: 22326,
    timeZone: 'Europe/London',
    iataCode: 'NWI',
    destinationType: 'CITY',
    destinationName: 'Norwich',
    destinationId: 25031,
    latitude: 52.630762,
    longitude: 1.298737,
  },
  {
    sortOrder: 38,
    selectable: true,
    destinationUrlName: 'Nottingham',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.25814.32685',
    parentId: 25814,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nottingham',
    destinationId: 32685,
    latitude: 52.9703,
    longitude: -1.17,
  },
  {
    sortOrder: 39,
    selectable: true,
    destinationUrlName: 'Oxford',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.5536.5537',
    parentId: 5536,
    timeZone: 'Europe/London',
    iataCode: 'OXF',
    destinationType: 'CITY',
    destinationName: 'Oxford',
    destinationId: 5537,
    latitude: 51.7528710509,
    longitude: -1.2687126291,
  },
  {
    sortOrder: 40,
    selectable: true,
    destinationUrlName: 'Peel',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.5017.51686',
    parentId: 5017,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Peel',
    destinationId: 51686,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 41,
    selectable: true,
    destinationUrlName: 'Pembrokeshire',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.4966',
    parentId: 731,
    timeZone: 'Europe/London',
    iataCode: 'HAW',
    destinationType: 'CITY',
    destinationName: 'Pembrokeshire',
    destinationId: 4966,
    latitude: 51.875708,
    longitude: -4.939193,
  },
  {
    sortOrder: 42,
    selectable: true,
    destinationUrlName: 'Peterborough',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.22326.27665',
    parentId: 22326,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Peterborough',
    destinationId: 27665,
    latitude: 52.5695,
    longitude: -0.24053,
  },
  {
    sortOrder: 43,
    selectable: true,
    destinationUrlName: 'Plymouth',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.4332',
    parentId: 731,
    timeZone: 'Europe/London',
    iataCode: 'PLH',
    destinationType: 'CITY',
    destinationName: 'Plymouth',
    destinationId: 4332,
    latitude: 50.37546,
    longitude: -4.14266,
  },
  {
    sortOrder: 44,
    selectable: true,
    destinationUrlName: 'Poole',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.23059.29968',
    parentId: 23059,
    timeZone: 'Europe/London',
    iataCode: 'BOH',
    destinationType: 'CITY',
    destinationName: 'Poole',
    destinationId: 29968,
    latitude: 50.71505,
    longitude: -1.98725,
  },
  {
    sortOrder: 45,
    selectable: true,
    destinationUrlName: 'Portsmouth',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.5536.22390',
    parentId: 5536,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Portsmouth',
    destinationId: 22390,
    latitude: 50.819658,
    longitude: -1.087022,
  },
  {
    sortOrder: 46,
    selectable: true,
    destinationUrlName: 'Salisbury',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.23059.23165',
    parentId: 23059,
    timeZone: 'Europe/London',
    iataCode: 'SAY',
    destinationType: 'CITY',
    destinationName: 'Salisbury',
    destinationId: 23165,
    latitude: 51.068557,
    longitude: -1.790948,
  },
  {
    sortOrder: 47,
    selectable: true,
    destinationUrlName: 'Scarborough',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.22770.23561',
    parentId: 22770,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Scarborough',
    destinationId: 23561,
    latitude: 54.282949,
    longitude: -0.396982,
  },
  {
    sortOrder: 48,
    selectable: true,
    destinationUrlName: 'Sheffield',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.22770.32777',
    parentId: 22770,
    timeZone: 'Europe/London',
    iataCode: 'DSA',
    destinationType: 'CITY',
    destinationName: 'Sheffield',
    destinationId: 32777,
    latitude: 53.381398,
    longitude: -1.470153,
  },
  {
    sortOrder: 49,
    selectable: true,
    destinationUrlName: 'Southampton',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.5536.22563',
    parentId: 5536,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Southampton',
    destinationId: 22563,
    latitude: 50.909101,
    longitude: -1.399551,
  },
  {
    sortOrder: 50,
    selectable: true,
    destinationUrlName: 'Stansted-Mountfitchet',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.22326.50651',
    parentId: 22326,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Stansted Mountfitchet',
    destinationId: 50651,
    latitude: 51.90217,
    longitude: 0.19944,
  },
  {
    sortOrder: 51,
    selectable: true,
    destinationUrlName: 'St-Ives',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.23059.25930',
    parentId: 23059,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'St Ives',
    destinationId: 25930,
    latitude: 50.2149,
    longitude: -5.4796,
  },
  {
    sortOrder: 52,
    selectable: true,
    destinationUrlName: 'Stratford-upon-Avon',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.22392.22393',
    parentId: 22392,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Stratford-upon-Avon',
    destinationId: 22393,
    latitude: 52.19173,
    longitude: -1.7083,
  },
  {
    sortOrder: 53,
    selectable: true,
    destinationUrlName: 'Warwick',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.22392.24378',
    parentId: 22392,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Warwick',
    destinationId: 24378,
    latitude: 52.282141,
    longitude: -1.583583,
  },
  {
    sortOrder: 54,
    selectable: true,
    destinationUrlName: 'Weymouth',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.23059.25931',
    parentId: 23059,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Weymouth',
    destinationId: 25931,
    latitude: 50.6096,
    longitude: -2.4543,
  },
  {
    sortOrder: 55,
    selectable: true,
    destinationUrlName: 'Windermere',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.822.22565',
    parentId: 822,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Windermere',
    destinationId: 22565,
    latitude: 54.380583,
    longitude: -2.905259,
  },
  {
    sortOrder: 56,
    selectable: true,
    destinationUrlName: 'Windsor-and-Eton',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.5536.22321',
    parentId: 5536,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Windsor & Eton',
    destinationId: 22321,
    latitude: 51.4874,
    longitude: -0.60794,
  },
  {
    sortOrder: 57,
    selectable: true,
    destinationUrlName: 'Worcester',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.22392.26105',
    parentId: 22392,
    timeZone: 'America/New_York',
    iataCode: 'ORH',
    destinationType: 'CITY',
    destinationName: 'Worcester',
    destinationId: 26105,
    latitude: 42.262592,
    longitude: -71.802292,
  },
  {
    sortOrder: 58,
    selectable: true,
    destinationUrlName: 'York',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.22770.5446',
    parentId: 22770,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'York',
    destinationId: 5446,
    latitude: 53.9618514,
    longitude: -1.0875509,
  },
  {
    sortOrder: 59,
    selectable: true,
    destinationUrlName: 'Yorkshire-Dales-National-Park',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.731.22770.51234',
    parentId: 22770,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Yorkshire Dales National Park',
    destinationId: 51234,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Netherlands',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.60',
    parentId: 6,
    timeZone: 'Europe/Amsterdam',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Netherlands',
    destinationId: 60,
    latitude: 52.132633,
    longitude: 5.291266,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'North-Holland',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.60.26222',
    parentId: 60,
    timeZone: 'Europe/Amsterdam',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'North Holland',
    destinationId: 26222,
    latitude: 52.6848,
    longitude: 4.9477,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'South-Holland',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.60.5435',
    parentId: 60,
    timeZone: 'Europe/Amsterdam',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'South Holland',
    destinationId: 5435,
    latitude: 51.9433333,
    longitude: 4.1425,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Alkmaar',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.60.26222.26416',
    parentId: 26222,
    timeZone: 'Europe/Amsterdam',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Alkmaar',
    destinationId: 26416,
    latitude: 52.632244,
    longitude: 4.755634,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Amsterdam',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.60.525',
    parentId: 60,
    timeZone: 'Europe/Amsterdam',
    iataCode: 'AMS',
    destinationType: 'CITY',
    destinationName: 'Amsterdam',
    destinationId: 525,
    latitude: 52.376856714,
    longitude: 4.9053955078,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Arnhem',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.60.26525',
    parentId: 60,
    timeZone: 'Europe/Amsterdam',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Arnhem',
    destinationId: 26525,
    latitude: 51.9851,
    longitude: 5.89873,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Canal-Ring-Grachtengordel',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.60.525.51473',
    parentId: 525,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Canal Ring (Grachtengordel)',
    destinationId: 51473,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'De-Pijp',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.60.525.51474',
    parentId: 525,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'De Pijp',
    destinationId: 51474,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Dordrecht',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.60.5435.26382',
    parentId: 5435,
    timeZone: 'Europe/Amsterdam',
    iataCode: 'RTM',
    destinationType: 'CITY',
    destinationName: 'Dordrecht',
    destinationId: 26382,
    latitude: 51.813016,
    longitude: 4.694263,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Eindhoven',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.60.5435.24978',
    parentId: 5435,
    timeZone: 'Europe/Amsterdam',
    iataCode: 'EIN',
    destinationType: 'CITY',
    destinationName: 'Eindhoven',
    destinationId: 24978,
    latitude: 51.441685,
    longitude: 5.474083,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Enkhuizen',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.60.26222.26297',
    parentId: 26222,
    timeZone: 'Europe/Amsterdam',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Enkhuizen',
    destinationId: 26297,
    latitude: 52.707309,
    longitude: 5.276647,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Gouda',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.60.5435.26397',
    parentId: 5435,
    timeZone: 'Europe/Amsterdam',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Gouda',
    destinationId: 26397,
    latitude: 52.011602,
    longitude: 4.711696,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Groningen',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.60.26222.26476',
    parentId: 26222,
    timeZone: 'Europe/Amsterdam',
    iataCode: 'GRQ',
    destinationType: 'CITY',
    destinationName: 'Groningen',
    destinationId: 26476,
    latitude: 53.219269,
    longitude: 6.566681,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Haarlem',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.60.26222.26223',
    parentId: 26222,
    timeZone: 'Europe/Amsterdam',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Haarlem',
    destinationId: 26223,
    latitude: 52.387385,
    longitude: 4.64794,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Hoorn',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.60.26222.26383',
    parentId: 26222,
    timeZone: 'Europe/Amsterdam',
    iataCode: 'AMS',
    destinationType: 'CITY',
    destinationName: 'Hoorn',
    destinationId: 26383,
    latitude: 52.642326,
    longitude: 5.058956,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Leeuwarden',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.60.26222.26514',
    parentId: 26222,
    timeZone: 'Europe/Amsterdam',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Leeuwarden',
    destinationId: 26514,
    latitude: 53.201424,
    longitude: 5.795928,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Leiden',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.60.5435.26505',
    parentId: 5435,
    timeZone: 'Europe/Amsterdam',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Leiden',
    destinationId: 26505,
    latitude: 52.160141,
    longitude: 4.499434,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Maastricht',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.60.5435.22820',
    parentId: 5435,
    timeZone: 'Europe/Amsterdam',
    iataCode: 'MST',
    destinationType: 'CITY',
    destinationName: 'Maastricht',
    destinationId: 22820,
    latitude: 50.851588,
    longitude: 5.692747,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Middelburg',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.60.26475',
    parentId: 60,
    timeZone: 'Europe/Amsterdam',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Middelburg',
    destinationId: 26475,
    latitude: 51.4988,
    longitude: 3.611,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Nijmegen',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.60.26498',
    parentId: 60,
    timeZone: 'Europe/Amsterdam',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nijmegen',
    destinationId: 26498,
    latitude: 51.812287,
    longitude: 5.837403,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Rotterdam',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.60.4211',
    parentId: 60,
    timeZone: 'Europe/Amsterdam',
    iataCode: 'RTM',
    destinationType: 'CITY',
    destinationName: 'Rotterdam',
    destinationId: 4211,
    latitude: 51.920525,
    longitude: 4.480866,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'The-Hague',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.60.5435.5436',
    parentId: 5435,
    timeZone: 'Europe/Amsterdam',
    iataCode: 'HAG',
    destinationType: 'CITY',
    destinationName: 'The Hague',
    destinationId: 5436,
    latitude: 52.0704978,
    longitude: 4.3006999,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Utrecht',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.60.24976',
    parentId: 60,
    timeZone: 'Europe/Amsterdam',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Utrecht',
    destinationId: 24976,
    latitude: 52.090258,
    longitude: 5.12326,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Zaandam',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.60.22382',
    parentId: 60,
    timeZone: 'Europe/Amsterdam',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Zaandam',
    destinationId: 22382,
    latitude: 52.441914,
    longitude: 4.830535,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Albania',
    defaultCurrencyCode: 'USD',
    lookupId: '6.4471',
    parentId: 6,
    timeZone: 'Europe/Tirane',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Albania',
    destinationId: 4471,
    latitude: 41.15333,
    longitude: 20.16833,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Rinas',
    defaultCurrencyCode: 'USD',
    lookupId: '6.4471.51985',
    parentId: 4471,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Rinas',
    destinationId: 51985,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Gjirokaster',
    defaultCurrencyCode: 'USD',
    lookupId: '6.4471.50367',
    parentId: 4471,
    timeZone: 'Europe/Tirane',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Gjirokaster',
    destinationId: 50367,
    latitude: 40.068697,
    longitude: 20.103884,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Himare',
    defaultCurrencyCode: 'USD',
    lookupId: '6.4471.50368.51560',
    parentId: 50368,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Himare',
    destinationId: 51560,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Ksamil',
    defaultCurrencyCode: 'USD',
    lookupId: '6.4471.50197.51550',
    parentId: 50197,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ksamil',
    destinationId: 51550,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Llogara-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '6.4471.50368.51736',
    parentId: 50368,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Llogara National Park',
    destinationId: 51736,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Permet',
    defaultCurrencyCode: 'USD',
    lookupId: '6.4471.50367.51663',
    parentId: 50367,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Permet',
    destinationId: 51663,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Saranda',
    defaultCurrencyCode: 'USD',
    lookupId: '6.4471.50197',
    parentId: 4471,
    timeZone: 'Europe/Tirane',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Saranda',
    destinationId: 50197,
    latitude: 39.87516,
    longitude: 20.006639,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Shkoder',
    defaultCurrencyCode: 'USD',
    lookupId: '6.4471.50299',
    parentId: 4471,
    timeZone: 'Europe/Tirane',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Shkoder',
    destinationId: 50299,
    latitude: 42.0693,
    longitude: 19.5033,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Tirana',
    defaultCurrencyCode: 'USD',
    lookupId: '6.4471.23957',
    parentId: 4471,
    timeZone: 'Europe/Tirane',
    iataCode: 'TIA',
    destinationType: 'CITY',
    destinationName: 'Tirana',
    destinationId: 23957,
    latitude: 41.32755,
    longitude: 19.8187,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Vlore',
    defaultCurrencyCode: 'USD',
    lookupId: '6.4471.50368',
    parentId: 4471,
    timeZone: 'Europe/Tirane',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Vlore',
    destinationId: 50368,
    latitude: 40.4661,
    longitude: 19.4914,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Algeria',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21801',
    parentId: 1,
    timeZone: 'Africa/Algiers',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Algeria',
    destinationId: 21801,
    latitude: 29.431548,
    longitude: 2.127873,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Djanet',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21801.51832',
    parentId: 21801,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Djanet',
    destinationId: 51832,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Ghardaia',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21801.51801',
    parentId: 21801,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Ghardaia',
    destinationId: 51801,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Algiers',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21801.25745',
    parentId: 21801,
    timeZone: 'Africa/Algiers',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Algiers',
    destinationId: 25745,
    latitude: 36.7631,
    longitude: 3.0506,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Andorra',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21795',
    parentId: 6,
    timeZone: 'Europe/Andorra',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Andorra',
    destinationId: 21795,
    latitude: 42.551345,
    longitude: 1.606385,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Andorra-la-Vella',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21795.50643',
    parentId: 21795,
    timeZone: 'Europe/Andorra',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Andorra la Vella',
    destinationId: 50643,
    latitude: 42.50753,
    longitude: 1.52182,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Angola',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21471',
    parentId: 1,
    timeZone: 'Africa/Luanda',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Angola',
    destinationId: 21471,
    latitude: -11.2027,
    longitude: 17.8739,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Luanda',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21471.34194',
    parentId: 21471,
    timeZone: 'Africa/Luanda',
    iataCode: 'LAD',
    destinationType: 'CITY',
    destinationName: 'Luanda',
    destinationId: 34194,
    latitude: -8.839258,
    longitude: 13.294393,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Anguilla',
    defaultCurrencyCode: 'USD',
    lookupId: '4.810',
    parentId: 4,
    timeZone: 'America/Anguilla',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Anguilla',
    destinationId: 810,
    latitude: 18.220554,
    longitude: -63.068615,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Antigua-and-Barbuda',
    defaultCurrencyCode: 'USD',
    lookupId: '4.27',
    parentId: 4,
    timeZone: 'America/Antigua',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Antigua and Barbuda',
    destinationId: 27,
    latitude: 17.060816,
    longitude: -61.796428,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Antigua',
    defaultCurrencyCode: 'USD',
    lookupId: '4.27.22046',
    parentId: 27,
    timeZone: 'America/St_Johns',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Antigua',
    destinationId: 22046,
    latitude: 17.074656,
    longitude: -61.817521,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Five-Islands-Village',
    defaultCurrencyCode: 'USD',
    lookupId: '4.27.50369',
    parentId: 27,
    timeZone: 'America/Antigua',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Five Islands Village',
    destinationId: 50369,
    latitude: 17.1197,
    longitude: -61.8848,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'St-Johns',
    defaultCurrencyCode: 'USD',
    lookupId: '4.27.22046.22047',
    parentId: 22046,
    timeZone: 'America/St_Johns',
    iataCode: 'ANU',
    destinationType: 'CITY',
    destinationName: "St John's",
    destinationId: 22047,
    latitude: 17.12741,
    longitude: -61.846772,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Argentina',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78',
    parentId: 9,
    timeZone: 'America/Argentina/Buenos_Aires',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Argentina',
    destinationId: 78,
    latitude: -38.416097,
    longitude: -63.616672,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Lake-District',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78.21483',
    parentId: 78,
    timeZone: 'America/Argentina/Ushuaia',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Lake District',
    destinationId: 21483,
    latitude: -40.58249,
    longitude: -71.685715,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Northwest-Argentina',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78.30283',
    parentId: 78,
    timeZone: 'America/Argentina/Salta',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Northwest Argentina',
    destinationId: 30283,
    latitude: -38.4161,
    longitude: -63.61667,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Patagonia',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78.934',
    parentId: 78,
    timeZone: 'America/Argentina/Salta',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Patagonia',
    destinationId: 934,
    latitude: -45.8666667,
    longitude: -67.5,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'The-Pampas',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78.22280',
    parentId: 78,
    timeZone: 'America/Argentina/Cordoba',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'The Pampas',
    destinationId: 22280,
    latitude: -33.250005,
    longitude: -61.229129,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Bariloche',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78.21483.938',
    parentId: 21483,
    timeZone: 'America/Argentina/Buenos_Aires',
    iataCode: 'BRC',
    destinationType: 'CITY',
    destinationName: 'Bariloche',
    destinationId: 938,
    latitude: -41.15,
    longitude: -71.3,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Buenos-Aires',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78.22280.901',
    parentId: 22280,
    timeZone: 'America/Argentina/Buenos_Aires',
    iataCode: 'BUE',
    destinationType: 'CITY',
    destinationName: 'Buenos Aires',
    destinationId: 901,
    latitude: -34.6084175,
    longitude: -58.3731613,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Buenos-Aires-Province',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78.51386',
    parentId: 78,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Buenos Aires Province',
    destinationId: 51386,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Cachi',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78.24736',
    parentId: 78,
    timeZone: 'America/Argentina/Salta',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cachi',
    destinationId: 24736,
    latitude: -25.120192,
    longitude: -66.162129,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Cafayate',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78.30283.31320',
    parentId: 30283,
    timeZone: 'America/Argentina/Salta',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cafayate',
    destinationId: 31320,
    latitude: -26.07308,
    longitude: -65.97605,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Capilla-del-Senor',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78.51386.52101',
    parentId: 51386,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Capilla del Senor',
    destinationId: 52101,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Cordoba',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78.22280.22281',
    parentId: 22280,
    timeZone: 'America/Argentina/Cordoba',
    iataCode: 'COR',
    destinationType: 'CITY',
    destinationName: 'Córdoba',
    destinationId: 22281,
    latitude: -31.3993438,
    longitude: -64.3344291,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Corrientes-Province',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78.51387',
    parentId: 78,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Corrientes Province',
    destinationId: 51387,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'El-Calafate',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78.934.935',
    parentId: 934,
    timeZone: 'America/Argentina/Rio_Gallegos',
    iataCode: 'RZA',
    destinationType: 'CITY',
    destinationName: 'El Calafate',
    destinationId: 935,
    latitude: -50.2803,
    longitude: -72.0531,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'El-Chalten',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78.934.23529',
    parentId: 934,
    timeZone: 'America/Argentina/Rio_Gallegos',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'El Chaltén',
    destinationId: 23529,
    latitude: -49.331467,
    longitude: -72.885605,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Ezeiza',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78.51386.52102',
    parentId: 51386,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ezeiza',
    destinationId: 52102,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'La-Rioja-Province',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78.51388',
    parentId: 78,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'La Rioja Province',
    destinationId: 51388,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Lujan-de-Cuyo',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78.931.52093',
    parentId: 931,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lujan de Cuyo',
    destinationId: 52093,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Maipu',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78.931.50926',
    parentId: 931,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Maipu',
    destinationId: 50926,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Mar-del-Plata',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78.36397',
    parentId: 78,
    timeZone: 'America/Argentina/Buenos_Aires',
    iataCode: 'MDQ',
    destinationType: 'CITY',
    destinationName: 'Mar del Plata',
    destinationId: 36397,
    latitude: -38.0174836,
    longitude: -59.8417537,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Mendoza',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78.931',
    parentId: 78,
    timeZone: 'America/Argentina/Mendoza',
    iataCode: 'MDZ',
    destinationType: 'CITY',
    destinationName: 'Mendoza',
    destinationId: 931,
    latitude: -32.890183,
    longitude: -68.8440498,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Mendoza-Province',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78.51255',
    parentId: 78,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mendoza Province',
    destinationId: 51255,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Puerto-Iguazu',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78.971',
    parentId: 78,
    timeZone: 'America/Argentina/Cordoba',
    iataCode: 'IGU',
    destinationType: 'CITY',
    destinationName: 'Puerto Iguazu',
    destinationId: 971,
    latitude: -25.5971635,
    longitude: -54.578599,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Puerto-Madryn',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78.934.4414',
    parentId: 934,
    timeZone: 'America/Argentina/Catamarca',
    iataCode: 'PMY',
    destinationType: 'CITY',
    destinationName: 'Puerto Madryn',
    destinationId: 4414,
    latitude: -42.769452,
    longitude: -65.033005,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Salta',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78.30283.5484',
    parentId: 30283,
    timeZone: 'America/Argentina/Salta',
    iataCode: 'SLA',
    destinationType: 'CITY',
    destinationName: 'Salta',
    destinationId: 5484,
    latitude: -24.7829322983,
    longitude: -65.4121552018,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'San-Antonio-de-los-Cobres',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78.30283.50970',
    parentId: 30283,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'San Antonio de los Cobres',
    destinationId: 50970,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'San-Fernando',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78.50376',
    parentId: 78,
    timeZone: 'America/Argentina/Buenos_Aires',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'San Fernando',
    destinationId: 50376,
    latitude: -34.4431,
    longitude: -58.558,
  },
  {
    sortOrder: 23,
    selectable: true,
    destinationUrlName: 'San-Juan',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78.50300',
    parentId: 78,
    timeZone: 'America/Argentina/San_Juan',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'San Juan',
    destinationId: 50300,
    latitude: -31.5351,
    longitude: -68.5386,
  },
  {
    sortOrder: 24,
    selectable: true,
    destinationUrlName: 'San-Martin-de-los-Andes',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78.21483.21484',
    parentId: 21483,
    timeZone: 'America/Santiago',
    iataCode: 'CPC',
    destinationType: 'CITY',
    destinationName: 'San Martin de los Andes',
    destinationId: 21484,
    latitude: -40.15509,
    longitude: -71.354195,
  },
  {
    sortOrder: 25,
    selectable: true,
    destinationUrlName: 'San-Miguel-de-Tucuman',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78.30283.25273',
    parentId: 30283,
    timeZone: 'America/Argentina/Tucuman',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'San Miguel de Tucumán',
    destinationId: 25273,
    latitude: -26.809326,
    longitude: -65.219293,
  },
  {
    sortOrder: 26,
    selectable: true,
    destinationUrlName: 'San-Salvador-de-Jujuy',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78.50377',
    parentId: 78,
    timeZone: 'America/Argentina/Jujuy',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'San Salvador de Jujuy',
    destinationId: 50377,
    latitude: -24.1858,
    longitude: -65.2995,
  },
  {
    sortOrder: 27,
    selectable: true,
    destinationUrlName: 'Tilcara',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78.30283.36677',
    parentId: 30283,
    timeZone: 'America/Argentina/Jujuy',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tilcara',
    destinationId: 36677,
    latitude: -23.5792105,
    longitude: -65.404902,
  },
  {
    sortOrder: 28,
    selectable: true,
    destinationUrlName: 'Ushuaia',
    defaultCurrencyCode: 'USD',
    lookupId: '9.78.933',
    parentId: 78,
    timeZone: 'America/Argentina/Ushuaia',
    iataCode: 'USH',
    destinationType: 'CITY',
    destinationName: 'Ushuaia',
    destinationId: 933,
    latitude: -54.7916794,
    longitude: -68.229248,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Armenia',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21802',
    parentId: 6,
    timeZone: 'Asia/Yerevan',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Armenia',
    destinationId: 21802,
    latitude: 40.283216,
    longitude: 44.602402,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Goris',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21802.51723',
    parentId: 21802,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Goris',
    destinationId: 51723,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Gyumri',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21802.51617',
    parentId: 21802,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Gyumri',
    destinationId: 51617,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Ijevan',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21802.51676',
    parentId: 21802,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Ijevan',
    destinationId: 51676,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Jermuk',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21802.51648',
    parentId: 21802,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Jermuk',
    destinationId: 51648,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Lori-Province',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21802.51856',
    parentId: 21802,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Lori Province',
    destinationId: 51856,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Haghpat',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21802.51856.52188',
    parentId: 51856,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Haghpat',
    destinationId: 52188,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Odzun',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21802.51856.52189',
    parentId: 51856,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Odzun',
    destinationId: 52189,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Yerevan',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21802.22425',
    parentId: 21802,
    timeZone: 'Asia/Yerevan',
    iataCode: 'EVN',
    destinationType: 'CITY',
    destinationName: 'Yerevan',
    destinationId: 22425,
    latitude: 40.181246,
    longitude: 44.500056,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Aruba',
    defaultCurrencyCode: 'USD',
    lookupId: '4.28',
    parentId: 4,
    timeZone: 'America/Aruba',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Aruba',
    destinationId: 28,
    latitude: 12.52111,
    longitude: -69.968338,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Oranjestad',
    defaultCurrencyCode: 'USD',
    lookupId: '4.28.50211',
    parentId: 28,
    timeZone: 'America/Aruba',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Oranjestad',
    destinationId: 50211,
    latitude: 12.5092,
    longitude: -70.0086,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Palm-Eagle-Beach',
    defaultCurrencyCode: 'USD',
    lookupId: '4.28.50199',
    parentId: 28,
    timeZone: 'America/Aruba',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Palm - Eagle Beach',
    destinationId: 50199,
    latitude: 12.5513,
    longitude: -70.0565,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Austria',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.44',
    parentId: 6,
    timeZone: 'Europe/Vienna',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Austria',
    destinationId: 44,
    latitude: 47.516231,
    longitude: 14.550072,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Austrian-Alps',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.44.26232',
    parentId: 44,
    timeZone: 'Europe/Vienna',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Austrian Alps',
    destinationId: 26232,
    latitude: 47.53326,
    longitude: 12.707249,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Burgenland',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.44.25572',
    parentId: 44,
    timeZone: 'Europe/Vienna',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Burgenland',
    destinationId: 25572,
    latitude: 47.4732647,
    longitude: 16.0180867,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Lower-Austria',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.44.25794',
    parentId: 44,
    timeZone: 'Europe/Vienna',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Lower Austria',
    destinationId: 25794,
    latitude: 48.2213,
    longitude: 15.5759,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Upper-Austria',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.44.28061',
    parentId: 44,
    timeZone: 'Europe/Vienna',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Upper Austria',
    destinationId: 28061,
    latitude: 48.02585,
    longitude: 13.97237,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Bregenz',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.44.26232.51204',
    parentId: 26232,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bregenz',
    destinationId: 51204,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Graz',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.44.26232.452',
    parentId: 26232,
    timeZone: 'Europe/Vienna',
    iataCode: 'GRZ',
    destinationType: 'CITY',
    destinationName: 'Graz',
    destinationId: 452,
    latitude: 47.070714,
    longitude: 15.439504,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Hallstatt',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.44.25793',
    parentId: 44,
    timeZone: 'Europe/Vienna',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Hallstatt',
    destinationId: 25793,
    latitude: 47.56223,
    longitude: 13.64926,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Innsbruck',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.44.26232.5173',
    parentId: 26232,
    timeZone: 'Europe/Vienna',
    iataCode: 'INN',
    destinationType: 'CITY',
    destinationName: 'Innsbruck',
    destinationId: 5173,
    latitude: 47.269212,
    longitude: 11.404102,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Klagenfurt',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.44.26232.24633',
    parentId: 26232,
    timeZone: 'Europe/Vienna',
    iataCode: 'KLU',
    destinationType: 'CITY',
    destinationName: 'Klagenfurt',
    destinationId: 24633,
    latitude: 46.6203,
    longitude: 14.31,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Linz',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.44.28061.28062',
    parentId: 28061,
    timeZone: 'Europe/Vienna',
    iataCode: 'LNZ',
    destinationType: 'CITY',
    destinationName: 'Linz',
    destinationId: 28062,
    latitude: 48.30694,
    longitude: 14.28583,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Salzburg',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.44.26232.451',
    parentId: 26232,
    timeZone: 'Europe/Vienna',
    iataCode: 'SZG',
    destinationType: 'CITY',
    destinationName: 'Salzburg',
    destinationId: 451,
    latitude: 47.800499,
    longitude: 13.04441,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Schwechat',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.44.25794.50575',
    parentId: 25794,
    timeZone: 'Europe/Vienna',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Schwechat',
    destinationId: 50575,
    latitude: 48.140541,
    longitude: 16.477221,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Vienna',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.44.454',
    parentId: 44,
    timeZone: 'Europe/Vienna',
    iataCode: 'VIE',
    destinationType: 'CITY',
    destinationName: 'Vienna',
    destinationId: 454,
    latitude: 48.2092062,
    longitude: 16.3727778,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Villach',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.44.26232.50909',
    parentId: 26232,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Villach',
    destinationId: 50909,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Wattens',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.44.26232.36693',
    parentId: 26232,
    timeZone: 'Europe/Vienna',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Wattens',
    destinationId: 36693,
    latitude: 47.2726197,
    longitude: 11.5630907,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Azerbaijan',
    defaultCurrencyCode: 'USD',
    lookupId: '1.22315',
    parentId: 1,
    timeZone: 'Asia/Baku',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Azerbaijan',
    destinationId: 22315,
    latitude: 40.354172,
    longitude: 48.000879,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Guba-Khachmaz-Region',
    defaultCurrencyCode: 'USD',
    lookupId: '1.22315.51847',
    parentId: 22315,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Guba-Khachmaz Region',
    destinationId: 51847,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Baku',
    defaultCurrencyCode: 'USD',
    lookupId: '1.22315.22974',
    parentId: 22315,
    timeZone: 'Asia/Baku',
    iataCode: 'BAK',
    destinationType: 'CITY',
    destinationName: 'Baku',
    destinationId: 22974,
    latitude: 40.408234,
    longitude: 49.867135,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Ganja',
    defaultCurrencyCode: 'USD',
    lookupId: '1.22315.51427',
    parentId: 22315,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ganja',
    destinationId: 51427,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Qabala',
    defaultCurrencyCode: 'USD',
    lookupId: '1.22315.50577',
    parentId: 22315,
    timeZone: 'Asia/Baku',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Qabala',
    destinationId: 50577,
    latitude: 40.97986,
    longitude: 47.84783,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Bahamas',
    defaultCurrencyCode: 'USD',
    lookupId: '4.29',
    parentId: 4,
    timeZone: 'America/Nassau',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Bahamas',
    destinationId: 29,
    latitude: 25.03428,
    longitude: -77.39628,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Grand-Bahama-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '4.29.23960',
    parentId: 29,
    timeZone: 'America/Nassau',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Grand Bahama Island',
    destinationId: 23960,
    latitude: 26.659447,
    longitude: -78.52065,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'New-Providence-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '4.29.24115',
    parentId: 29,
    timeZone: 'America/Nassau',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'New Providence Island',
    destinationId: 24115,
    latitude: 25.051928,
    longitude: -77.40134,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Out-Islands',
    defaultCurrencyCode: 'USD',
    lookupId: '4.29.23959',
    parentId: 29,
    timeZone: 'America/Nassau',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Out Islands',
    destinationId: 23959,
    latitude: 25.0259,
    longitude: -78.0359,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Eleuthera',
    defaultCurrencyCode: 'USD',
    lookupId: '4.29.23959.50305',
    parentId: 23959,
    timeZone: 'America/Nassau',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Eleuthera',
    destinationId: 50305,
    latitude: 25.078136,
    longitude: -76.126328,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Freeport',
    defaultCurrencyCode: 'USD',
    lookupId: '4.29.23960.419',
    parentId: 23960,
    timeZone: 'America/Nassau',
    iataCode: 'FPO',
    destinationType: 'CITY',
    destinationName: 'Freeport',
    destinationId: 419,
    latitude: 26.5284722,
    longitude: -78.6965833,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Great-Exuma',
    defaultCurrencyCode: 'USD',
    lookupId: '4.29.23959.26436',
    parentId: 23959,
    timeZone: 'America/Nassau',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Great Exuma',
    destinationId: 26436,
    latitude: 23.533373,
    longitude: -75.83233,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Nassau',
    defaultCurrencyCode: 'USD',
    lookupId: '4.29.24115.420',
    parentId: 24115,
    timeZone: 'America/Nassau',
    iataCode: 'NAS',
    destinationType: 'CITY',
    destinationName: 'Nassau',
    destinationId: 420,
    latitude: 25.0776696965,
    longitude: -77.3380851746,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'West-End',
    defaultCurrencyCode: 'USD',
    lookupId: '4.29.23960.50382',
    parentId: 23960,
    timeZone: 'America/Nassau',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'West End',
    destinationId: 50382,
    latitude: 26.686719,
    longitude: -78.970838,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Bahrain',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4458',
    parentId: 1,
    timeZone: 'Asia/Bahrain',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Bahrain',
    destinationId: 4458,
    latitude: 25.9304,
    longitude: 50.6378,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Manama',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4458.31482',
    parentId: 4458,
    timeZone: 'Asia/Bahrain',
    iataCode: 'BAH',
    destinationType: 'CITY',
    destinationName: 'Manama',
    destinationId: 31482,
    latitude: 26.22852,
    longitude: 50.58605,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'Bangladesh',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21768',
    parentId: 2,
    timeZone: 'Asia/Dhaka',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Bangladesh',
    destinationId: 21768,
    latitude: 23.685,
    longitude: 90.3563,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Chittagong',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21768.23408',
    parentId: 21768,
    timeZone: 'Asia/Dhaka',
    iataCode: 'CGP',
    destinationType: 'CITY',
    destinationName: 'Chittagong',
    destinationId: 23408,
    latitude: 22.34754,
    longitude: 91.81233,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Dhaka',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21768.22495',
    parentId: 21768,
    timeZone: 'Asia/Dhaka',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Dhaka',
    destinationId: 22495,
    latitude: 23.81033,
    longitude: 90.41252,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Rajshahi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21768.24947',
    parentId: 21768,
    timeZone: 'Asia/Dhaka',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Rajshahi',
    destinationId: 24947,
    latitude: 24.377454,
    longitude: 88.639005,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Sylhet',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21768.30635',
    parentId: 21768,
    timeZone: 'Asia/Dhaka',
    iataCode: 'ZYL',
    destinationType: 'CITY',
    destinationName: 'Sylhet',
    destinationId: 30635,
    latitude: 24.90454,
    longitude: 91.8611,
  },
  {
    sortOrder: 23,
    selectable: true,
    destinationUrlName: 'Barbados',
    defaultCurrencyCode: 'USD',
    lookupId: '4.30',
    parentId: 4,
    timeZone: 'America/Barbados',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Barbados',
    destinationId: 30,
    latitude: 13.193887,
    longitude: -59.543198,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Bridgetown',
    defaultCurrencyCode: 'USD',
    lookupId: '4.30.50217',
    parentId: 30,
    timeZone: 'America/Barbados',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bridgetown',
    destinationId: 50217,
    latitude: 13.106,
    longitude: -59.6132,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Diamond-Valley',
    defaultCurrencyCode: 'USD',
    lookupId: '4.30.50198',
    parentId: 30,
    timeZone: 'America/Barbados',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Diamond Valley',
    destinationId: 50198,
    latitude: 13.11279,
    longitude: -59.448608,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Saint-Joseph-Parish',
    defaultCurrencyCode: 'USD',
    lookupId: '4.30.50218',
    parentId: 30,
    timeZone: 'America/Barbados',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Saint Joseph Parish',
    destinationId: 50218,
    latitude: 13.2005,
    longitude: -59.5393,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Saint-Thomas-Parish',
    defaultCurrencyCode: 'USD',
    lookupId: '4.30.50303',
    parentId: 30,
    timeZone: 'America/Barbados',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Saint Thomas Parish',
    destinationId: 50303,
    latitude: 13.1741,
    longitude: -59.5828,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Speightstown',
    defaultCurrencyCode: 'USD',
    lookupId: '4.30.50974',
    parentId: 30,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Speightstown',
    destinationId: 50974,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 24,
    selectable: true,
    destinationUrlName: 'Belgium',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.45',
    parentId: 6,
    timeZone: 'Europe/Brussels',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Belgium',
    destinationId: 45,
    latitude: 50.503887,
    longitude: 4.469936,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Flanders',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.45.5298',
    parentId: 45,
    timeZone: 'Europe/Brussels',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Flanders',
    destinationId: 5298,
    latitude: 51.03113,
    longitude: 4.201182,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Wallonia',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.45.24029',
    parentId: 45,
    timeZone: 'Europe/Brussels',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Wallonia',
    destinationId: 24029,
    latitude: 50.5,
    longitude: 4.75,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Antwerp',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.45.5298.764',
    parentId: 5298,
    timeZone: 'Europe/Brussels',
    iataCode: 'ANR',
    destinationType: 'CITY',
    destinationName: 'Antwerp',
    destinationId: 764,
    latitude: 51.2194,
    longitude: 4.4025,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Bruges',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.45.4836',
    parentId: 45,
    timeZone: 'Europe/Brussels',
    iataCode: 'OST',
    destinationType: 'CITY',
    destinationName: 'Bruges',
    destinationId: 4836,
    latitude: 51.2108365,
    longitude: 3.2248692,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Brussels',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.45.458',
    parentId: 45,
    timeZone: 'Europe/Brussels',
    iataCode: 'BRU',
    destinationType: 'CITY',
    destinationName: 'Brussels',
    destinationId: 458,
    latitude: 50.8462807,
    longitude: 4.3547273,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Ghent',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.45.5298.23079',
    parentId: 5298,
    timeZone: 'Europe/Brussels',
    iataCode: 'GNE',
    destinationType: 'CITY',
    destinationName: 'Ghent',
    destinationId: 23079,
    latitude: 51.054342,
    longitude: 3.717424,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Liege',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.45.24029.25978',
    parentId: 24029,
    timeZone: 'Europe/Brussels',
    iataCode: 'LGG',
    destinationType: 'CITY',
    destinationName: 'Liège',
    destinationId: 25978,
    latitude: 50.632505,
    longitude: 5.581828,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Mechelen',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.45.5298.50818',
    parentId: 5298,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mechelen',
    destinationId: 50818,
    latitude: 51.0551234743,
    longitude: 4.4669797969,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Ypres',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.45.5298.22129',
    parentId: 5298,
    timeZone: 'Europe/Brussels',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ypres',
    destinationId: 22129,
    latitude: 50.86913,
    longitude: 2.98128,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Zaventem',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.45.5298.50493',
    parentId: 5298,
    timeZone: 'Europe/Brussels',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Zaventem',
    destinationId: 50493,
    latitude: 50.887691,
    longitude: 4.47013,
  },
  {
    sortOrder: 25,
    selectable: true,
    destinationUrlName: 'Belize',
    defaultCurrencyCode: 'USD',
    lookupId: '9.746',
    parentId: 9,
    timeZone: 'America/Belize',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Belize',
    destinationId: 746,
    latitude: 17.189877,
    longitude: -88.49765,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'The-Cayes',
    defaultCurrencyCode: 'USD',
    lookupId: '9.746.5102',
    parentId: 746,
    timeZone: 'America/Belize',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'The Cayes',
    destinationId: 5102,
    latitude: 17.7624037,
    longitude: -88.0045062,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Ambergris-Caye',
    defaultCurrencyCode: 'USD',
    lookupId: '9.746.5102.5072',
    parentId: 5102,
    timeZone: 'America/Belize',
    iataCode: 'SPR',
    destinationType: 'CITY',
    destinationName: 'Ambergris Caye',
    destinationId: 5072,
    latitude: 18.001592,
    longitude: -87.9432837,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Belize-City',
    defaultCurrencyCode: 'USD',
    lookupId: '9.746.5094',
    parentId: 746,
    timeZone: 'America/Belize',
    iataCode: 'BZE',
    destinationType: 'CITY',
    destinationName: 'Belize City',
    destinationId: 5094,
    latitude: 17.497713,
    longitude: -88.186654,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Dangriga',
    defaultCurrencyCode: 'USD',
    lookupId: '9.746.25877',
    parentId: 746,
    timeZone: 'America/Belize',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Dangriga',
    destinationId: 25877,
    latitude: 16.969441,
    longitude: -88.230906,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Hopkins',
    defaultCurrencyCode: 'USD',
    lookupId: '9.746.24531',
    parentId: 746,
    timeZone: 'America/Belize',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Hopkins',
    destinationId: 24531,
    latitude: 16.853442,
    longitude: -88.281412,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Placencia',
    defaultCurrencyCode: 'USD',
    lookupId: '9.746.23725',
    parentId: 746,
    timeZone: 'America/Belize',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Placencia',
    destinationId: 23725,
    latitude: 16.521055,
    longitude: -88.370202,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Punta-Gorda',
    defaultCurrencyCode: 'USD',
    lookupId: '9.746.24112',
    parentId: 746,
    timeZone: 'America/Belize',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Punta Gorda',
    destinationId: 24112,
    latitude: 16.098866,
    longitude: -88.809153,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'San-Ignacio',
    defaultCurrencyCode: 'USD',
    lookupId: '9.746.5083',
    parentId: 746,
    timeZone: 'America/Belize',
    iataCode: 'SQS',
    destinationType: 'CITY',
    destinationName: 'San Ignacio',
    destinationId: 5083,
    latitude: 17.1522786,
    longitude: -89.0800227,
  },
  {
    sortOrder: 26,
    selectable: true,
    destinationUrlName: 'Benin',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4444',
    parentId: 1,
    timeZone: 'Africa/Porto-Novo',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Benin',
    destinationId: 4444,
    latitude: 9.3077,
    longitude: 2.3158,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Cotonou',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4444.4446',
    parentId: 4444,
    timeZone: 'Africa/Porto-Novo',
    iataCode: 'COO',
    destinationType: 'CITY',
    destinationName: 'Cotonou',
    destinationId: 4446,
    latitude: 6.4,
    longitude: 2.52,
  },
  {
    sortOrder: 27,
    selectable: true,
    destinationUrlName: 'Bermuda',
    defaultCurrencyCode: 'USD',
    lookupId: '4.966',
    parentId: 4,
    timeZone: 'Atlantic/Bermuda',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Bermuda',
    destinationId: 966,
    latitude: 32.321384,
    longitude: -64.75737,
  },
  {
    sortOrder: 28,
    selectable: true,
    destinationUrlName: 'Bhutan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21472',
    parentId: 2,
    timeZone: 'Asia/Thimphu',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Bhutan',
    destinationId: 21472,
    latitude: 27.5142,
    longitude: 90.4336,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Bumthang-District',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21472.51871',
    parentId: 21472,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Bumthang District',
    destinationId: 51871,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Trongsa-District',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21472.51962',
    parentId: 21472,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Trongsa District',
    destinationId: 51962,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Wangdue',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21472.51869',
    parentId: 21472,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Wangdue',
    destinationId: 51869,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Paro',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21472.22308',
    parentId: 21472,
    timeZone: 'Asia/Thimphu',
    iataCode: 'PBH',
    destinationType: 'CITY',
    destinationName: 'Paro',
    destinationId: 22308,
    latitude: 27.4295,
    longitude: 89.415275,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Thimphu',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21472.22284',
    parentId: 21472,
    timeZone: 'Asia/Thimphu',
    iataCode: 'QJC',
    destinationType: 'CITY',
    destinationName: 'Thimphu',
    destinationId: 22284,
    latitude: 27.473,
    longitude: 89.639,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Trongsa',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21472.51962.52187',
    parentId: 51962,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Trongsa',
    destinationId: 52187,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 29,
    selectable: true,
    destinationUrlName: 'Bolivia',
    defaultCurrencyCode: 'USD',
    lookupId: '9.5026',
    parentId: 9,
    timeZone: 'America/La_Paz',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Bolivia',
    destinationId: 5026,
    latitude: -16.290154,
    longitude: -63.588653,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Altiplano',
    defaultCurrencyCode: 'USD',
    lookupId: '9.5026.22255',
    parentId: 5026,
    timeZone: 'America/La_Paz',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Altiplano',
    destinationId: 22255,
    latitude: -17.287709,
    longitude: -68.455811,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Cochabamba',
    defaultCurrencyCode: 'USD',
    lookupId: '9.5026.50383',
    parentId: 5026,
    timeZone: 'America/La_Paz',
    iataCode: 'CBB',
    destinationType: 'CITY',
    destinationName: 'Cochabamba',
    destinationId: 50383,
    latitude: -17.414,
    longitude: -66.1653,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Copacabana',
    defaultCurrencyCode: 'USD',
    lookupId: '9.5026.50219',
    parentId: 5026,
    timeZone: 'America/La_Paz',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Copacabana',
    destinationId: 50219,
    latitude: -16.1663,
    longitude: -69.0862,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'El-Alto',
    defaultCurrencyCode: 'USD',
    lookupId: '9.5026.51306',
    parentId: 5026,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'El Alto',
    destinationId: 51306,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'La-Paz',
    defaultCurrencyCode: 'USD',
    lookupId: '9.5026.22255.5027',
    parentId: 22255,
    timeZone: 'America/La_Paz',
    iataCode: 'LPB',
    destinationType: 'CITY',
    destinationName: 'La Paz',
    destinationId: 5027,
    latitude: -16.4990099,
    longitude: -68.146248,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Potosi',
    defaultCurrencyCode: 'USD',
    lookupId: '9.5026.22255.23772',
    parentId: 22255,
    timeZone: 'America/La_Paz',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Potosí',
    destinationId: 23772,
    latitude: -19.573115,
    longitude: -65.755825,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Rurrenabaque',
    defaultCurrencyCode: 'USD',
    lookupId: '9.5026.51259',
    parentId: 5026,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Rurrenabaque',
    destinationId: 51259,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Sucre',
    defaultCurrencyCode: 'USD',
    lookupId: '9.5026.23958',
    parentId: 5026,
    timeZone: 'America/La_Paz',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sucre',
    destinationId: 23958,
    latitude: -19.019663,
    longitude: -65.265976,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Uyuni',
    defaultCurrencyCode: 'USD',
    lookupId: '9.5026.22255.22256',
    parentId: 22255,
    timeZone: 'America/La_Paz',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Uyuni',
    destinationId: 22256,
    latitude: -20.461027,
    longitude: -66.825071,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Vallegrande',
    defaultCurrencyCode: 'USD',
    lookupId: '9.5026.32805',
    parentId: 5026,
    timeZone: 'America/La_Paz',
    iataCode: 'VAH',
    destinationType: 'CITY',
    destinationName: 'Vallegrande',
    destinationId: 32805,
    latitude: -18.490189,
    longitude: -64.11089,
  },
  {
    sortOrder: 30,
    selectable: true,
    destinationUrlName: 'Bonaire',
    defaultCurrencyCode: 'USD',
    lookupId: '4.4308',
    parentId: 4,
    timeZone: 'America/Curacao',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Bonaire',
    destinationId: 4308,
    latitude: 12.17836,
    longitude: -68.23853,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Kralendijk',
    defaultCurrencyCode: 'USD',
    lookupId: '4.4308.4309',
    parentId: 4308,
    timeZone: 'America/Curacao',
    iataCode: 'BON',
    destinationType: 'CITY',
    destinationName: 'Kralendijk',
    destinationId: 4309,
    latitude: 12.144339,
    longitude: -68.267956,
  },
  {
    sortOrder: 31,
    selectable: true,
    destinationUrlName: 'Bosnia-and-Herzegovina',
    defaultCurrencyCode: 'USD',
    lookupId: '6.22158',
    parentId: 6,
    timeZone: 'Europe/Sarajevo',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Bosnia and Herzegovina',
    destinationId: 22158,
    latitude: 43.91589,
    longitude: 17.67908,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Banja-Luka',
    defaultCurrencyCode: 'USD',
    lookupId: '6.22158.51563',
    parentId: 22158,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Banja Luka',
    destinationId: 51563,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Trebinje',
    defaultCurrencyCode: 'USD',
    lookupId: '6.22158.51588',
    parentId: 22158,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Trebinje',
    destinationId: 51588,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Mostar',
    defaultCurrencyCode: 'USD',
    lookupId: '6.22158.22322',
    parentId: 22158,
    timeZone: 'Europe/Sarajevo',
    iataCode: 'OMO',
    destinationType: 'CITY',
    destinationName: 'Mostar',
    destinationId: 22322,
    latitude: 43.34377,
    longitude: 17.80776,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Sarajevo',
    defaultCurrencyCode: 'USD',
    lookupId: '6.22158.22427',
    parentId: 22158,
    timeZone: 'Europe/Sarajevo',
    iataCode: 'SJJ',
    destinationType: 'CITY',
    destinationName: 'Sarajevo',
    destinationId: 22427,
    latitude: 43.85626,
    longitude: 18.41308,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Visoko',
    defaultCurrencyCode: 'USD',
    lookupId: '6.22158.50488',
    parentId: 22158,
    timeZone: 'Europe/Sarajevo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Visoko',
    destinationId: 50488,
    latitude: 43.988766,
    longitude: 18.179884,
  },
  {
    sortOrder: 32,
    selectable: true,
    destinationUrlName: 'Botswana',
    defaultCurrencyCode: 'USD',
    lookupId: '1.780',
    parentId: 1,
    timeZone: 'Africa/Maputo',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Botswana',
    destinationId: 780,
    latitude: -22.328474,
    longitude: 24.684866,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Gaborone',
    defaultCurrencyCode: 'USD',
    lookupId: '1.780.50578',
    parentId: 780,
    timeZone: 'Africa/Gaborone',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Gaborone',
    destinationId: 50578,
    latitude: -24.66118,
    longitude: 25.911751,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Kasane',
    defaultCurrencyCode: 'USD',
    lookupId: '1.780.24110',
    parentId: 780,
    timeZone: 'Africa/Gaborone',
    iataCode: 'BBK',
    destinationType: 'CITY',
    destinationName: 'Kasane',
    destinationId: 24110,
    latitude: -17.795369,
    longitude: 25.17164,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Makgadikgadi-Pans-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '1.780.51303',
    parentId: 780,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Makgadikgadi Pans National Park',
    destinationId: 51303,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Maun',
    defaultCurrencyCode: 'USD',
    lookupId: '1.780.25875',
    parentId: 780,
    timeZone: 'Africa/Gaborone',
    iataCode: 'MUB',
    destinationType: 'CITY',
    destinationName: 'Maun',
    destinationId: 25875,
    latitude: -19.99528,
    longitude: 23.418602,
  },
  {
    sortOrder: 33,
    selectable: true,
    destinationUrlName: 'Brazil',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79',
    parentId: 9,
    timeZone: 'America/Sao_Paulo',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Brazil',
    destinationId: 79,
    latitude: -14.235004,
    longitude: -51.92528,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Amazon',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.5489',
    parentId: 79,
    timeZone: 'America/Manaus',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Amazon',
    destinationId: 5489,
    latitude: -3.250209,
    longitude: -61.303711,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Central-Brazil',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.37222',
    parentId: 79,
    timeZone: 'America/Bahia',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Central Brazil',
    destinationId: 37222,
    latitude: -11.1327,
    longitude: -42.0961,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'North-Brazil',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.29097',
    parentId: 79,
    timeZone: 'America/Cuiaba',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'North Brazil',
    destinationId: 29097,
    latitude: -14.235,
    longitude: -51.92528,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Northeast-Brazil',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22964',
    parentId: 79,
    timeZone: 'America/Sao_Paulo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Northeast Brazil',
    destinationId: 22964,
    latitude: -6.227934,
    longitude: -37.924805,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'South-Brazil',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22386',
    parentId: 79,
    timeZone: 'America/Sao_Paulo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'South Brazil',
    destinationId: 22386,
    latitude: -30.789037,
    longitude: -53.415527,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Southeast-Brazil',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22967',
    parentId: 79,
    timeZone: 'America/Sao_Paulo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Southeast Brazil',
    destinationId: 22967,
    latitude: -20.220966,
    longitude: -50.515137,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Arraial-do-Cabo',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22967.31321',
    parentId: 22967,
    timeZone: 'America/Sao_Paulo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Arraial do Cabo',
    destinationId: 31321,
    latitude: -22.96574,
    longitude: -42.02799,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Balneario-Camboriu',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22386.28407',
    parentId: 22386,
    timeZone: 'America/Sao_Paulo',
    iataCode: 'NVT',
    destinationType: 'CITY',
    destinationName: 'Balneario Camboriu',
    destinationId: 28407,
    latitude: -26.99309,
    longitude: -48.63563,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Barreirinhas',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22964.50220',
    parentId: 22964,
    timeZone: 'America/Fortaleza',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Barreirinhas',
    destinationId: 50220,
    latitude: -2.759,
    longitude: -42.8236,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Belem',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.29097.4420',
    parentId: 29097,
    timeZone: 'America/Santarem',
    iataCode: 'BEL',
    destinationType: 'CITY',
    destinationName: 'Belem',
    destinationId: 4420,
    latitude: -1.45575,
    longitude: -48.49018,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Belo-Horizonte',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22967.26539',
    parentId: 22967,
    timeZone: 'America/Sao_Paulo',
    iataCode: 'BHZ',
    destinationType: 'CITY',
    destinationName: 'Belo Horizonte',
    destinationId: 26539,
    latitude: -19.80307,
    longitude: -43.94651,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Bento-Goncalves',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22386.50226',
    parentId: 22386,
    timeZone: 'America/Sao_Paulo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bento Goncalves',
    destinationId: 50226,
    latitude: -29.17139,
    longitude: -51.51917,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Bonito',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.28016',
    parentId: 79,
    timeZone: 'America/Recife',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bonito',
    destinationId: 28016,
    latitude: -8.48939,
    longitude: -35.71885,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Brasilia',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.37222.37223',
    parentId: 37222,
    timeZone: 'America/Cuiaba',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Brasilia',
    destinationId: 37223,
    latitude: -15.721751,
    longitude: -56.9022031,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Brotas',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.50307',
    parentId: 79,
    timeZone: 'America/Sao_Paulo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Brotas',
    destinationId: 50307,
    latitude: -22.2808,
    longitude: -48.1255,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Buzios',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22967.23057',
    parentId: 22967,
    timeZone: 'America/Sao_Paulo',
    iataCode: 'BZC',
    destinationType: 'CITY',
    destinationName: 'Búzios',
    destinationId: 23057,
    latitude: -22.758323,
    longitude: -41.889726,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Campos-Do-Jordao',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22967.50386',
    parentId: 22967,
    timeZone: 'America/Sao_Paulo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Campos Do Jordao',
    destinationId: 50386,
    latitude: -22.7429,
    longitude: -45.5964,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Canela',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22386.50222',
    parentId: 22386,
    timeZone: 'America/Sao_Paulo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Canela',
    destinationId: 50222,
    latitude: -29.3565,
    longitude: -50.8124,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Chapada-Diamantina-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22964.51247',
    parentId: 22964,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Chapada Diamantina National Park',
    destinationId: 51247,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Cuiaba',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.25798',
    parentId: 79,
    timeZone: 'America/Cuiaba',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cuiabá',
    destinationId: 25798,
    latitude: -15.5696,
    longitude: -56.085,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Curitiba',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22386.23058',
    parentId: 22386,
    timeZone: 'America/Sao_Paulo',
    iataCode: 'CWB',
    destinationType: 'CITY',
    destinationName: 'Curitiba',
    destinationId: 23058,
    latitude: -25.42895,
    longitude: -49.26714,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Fernando-de-Noronha',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22964.29719',
    parentId: 22964,
    timeZone: 'America/Noronha',
    iataCode: 'FEN',
    destinationType: 'CITY',
    destinationName: 'Fernando de Noronha',
    destinationId: 29719,
    latitude: -3.85461,
    longitude: -32.42439,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Florianopolis',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22386.22387',
    parentId: 22386,
    timeZone: 'America/Sao_Paulo',
    iataCode: 'FLN',
    destinationType: 'CITY',
    destinationName: 'Florianopolis',
    destinationId: 22387,
    latitude: -27.595716,
    longitude: -48.553643,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Fortaleza',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22964.830',
    parentId: 22964,
    timeZone: 'America/Fortaleza',
    iataCode: 'FOR',
    destinationType: 'CITY',
    destinationName: 'Fortaleza',
    destinationId: 830,
    latitude: -3.7183943,
    longitude: -38.5433948,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Foz-do-Iguacu',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22386.970',
    parentId: 22386,
    timeZone: 'America/Sao_Paulo',
    iataCode: 'IGU',
    destinationType: 'CITY',
    destinationName: 'Foz do Iguacu',
    destinationId: 970,
    latitude: -25.5468978,
    longitude: -54.5881716,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Gramado',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22386.25799',
    parentId: 22386,
    timeZone: 'America/Sao_Paulo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Gramado',
    destinationId: 25799,
    latitude: -29.37522,
    longitude: -50.875141,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Guarulhos',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22967.50224',
    parentId: 22967,
    timeZone: 'America/Araguaina',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Guarulhos',
    destinationId: 50224,
    latitude: -10.18451,
    longitude: -48.33466,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'Ilha-Grande',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22967.32999',
    parentId: 22967,
    timeZone: 'America/Sao_Paulo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ilha Grande',
    destinationId: 32999,
    latitude: -23.150635,
    longitude: -44.229099,
  },
  {
    sortOrder: 23,
    selectable: true,
    destinationUrlName: 'Itajai',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22386.25872',
    parentId: 22386,
    timeZone: 'America/Sao_Paulo',
    iataCode: 'ITJ',
    destinationType: 'CITY',
    destinationName: 'Itajai',
    destinationId: 25872,
    latitude: -26.910472,
    longitude: -48.669788,
  },
  {
    sortOrder: 24,
    selectable: true,
    destinationUrlName: 'Jericoacoara',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22964.33466',
    parentId: 22964,
    timeZone: 'America/Sao_Paulo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Jericoacoara',
    destinationId: 33466,
    latitude: -2.795917,
    longitude: -40.513403,
  },
  {
    sortOrder: 25,
    selectable: true,
    destinationUrlName: 'Joao-Pessoa',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22964.30974',
    parentId: 22964,
    timeZone: 'America/Fortaleza',
    iataCode: 'JPA',
    destinationType: 'CITY',
    destinationName: 'João Pessoa',
    destinationId: 30974,
    latitude: -7.1195,
    longitude: -34.84501,
  },
  {
    sortOrder: 26,
    selectable: true,
    destinationUrlName: 'Lencois',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22964.29329',
    parentId: 22964,
    timeZone: 'America/Bahia',
    iataCode: 'LEC',
    destinationType: 'CITY',
    destinationName: 'Lencois',
    destinationId: 29329,
    latitude: -12.56173,
    longitude: -41.38988,
  },
  {
    sortOrder: 27,
    selectable: true,
    destinationUrlName: 'Maceio',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22964.4432',
    parentId: 22964,
    timeZone: 'America/Maceio',
    iataCode: 'MCZ',
    destinationType: 'CITY',
    destinationName: 'Maceió',
    destinationId: 4432,
    latitude: -9.64985,
    longitude: -35.70895,
  },
  {
    sortOrder: 28,
    selectable: true,
    destinationUrlName: 'Manaus',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.5489.4441',
    parentId: 5489,
    timeZone: 'America/Manaus',
    iataCode: 'MAO',
    destinationType: 'CITY',
    destinationName: 'Manaus',
    destinationId: 4441,
    latitude: -3.1064093,
    longitude: -60.0264297,
  },
  {
    sortOrder: 29,
    selectable: true,
    destinationUrlName: 'Mangaratiba',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22967.50385',
    parentId: 22967,
    timeZone: 'America/Sao_Paulo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mangaratiba',
    destinationId: 50385,
    latitude: -22.9162,
    longitude: -44.039,
  },
  {
    sortOrder: 30,
    selectable: true,
    destinationUrlName: 'Maragogi',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22964.50304',
    parentId: 22964,
    timeZone: 'America/Maceio',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Maragogi',
    destinationId: 50304,
    latitude: -9.0104,
    longitude: -35.2208,
  },
  {
    sortOrder: 31,
    selectable: true,
    destinationUrlName: 'Munhoz',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22967.51369',
    parentId: 22967,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Munhoz',
    destinationId: 51369,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 32,
    selectable: true,
    destinationUrlName: 'Natal',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22964.820',
    parentId: 22964,
    timeZone: 'America/Fortaleza',
    iataCode: 'NAT',
    destinationType: 'CITY',
    destinationName: 'Natal',
    destinationId: 820,
    latitude: -5.7944785,
    longitude: -35.2109531,
  },
  {
    sortOrder: 33,
    selectable: true,
    destinationUrlName: 'Olinda',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22964.25686',
    parentId: 22964,
    timeZone: 'America/Recife',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Olinda',
    destinationId: 25686,
    latitude: -7.99144,
    longitude: -34.840657,
  },
  {
    sortOrder: 34,
    selectable: true,
    destinationUrlName: 'Palmas',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.37222.50221',
    parentId: 37222,
    timeZone: 'America/Araguaina',
    iataCode: 'PMW',
    destinationType: 'CITY',
    destinationName: 'Palmas',
    destinationId: 50221,
    latitude: -10.18451,
    longitude: -48.33466,
  },
  {
    sortOrder: 35,
    selectable: true,
    destinationUrlName: 'Palmeiras',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.50384',
    parentId: 79,
    timeZone: 'America/Bahia',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Palmeiras',
    destinationId: 50384,
    latitude: -12.5151,
    longitude: -41.5778,
  },
  {
    sortOrder: 36,
    selectable: true,
    destinationUrlName: 'Paraty',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22967.5426',
    parentId: 22967,
    timeZone: 'Brazil/East',
    iataCode: 'GIG',
    destinationType: 'CITY',
    destinationName: 'Paraty',
    destinationId: 5426,
    latitude: -23.2158995,
    longitude: -44.7116881,
  },
  {
    sortOrder: 37,
    selectable: true,
    destinationUrlName: 'Porto-Alegre',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22386.29098',
    parentId: 22386,
    timeZone: 'America/Sao_Paulo',
    iataCode: 'POA',
    destinationType: 'CITY',
    destinationName: 'Porto Alegre',
    destinationId: 29098,
    latitude: -30.03465,
    longitude: -51.21766,
  },
  {
    sortOrder: 38,
    selectable: true,
    destinationUrlName: 'Porto-Belo',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.4445',
    parentId: 79,
    timeZone: 'America/Sao_Paulo',
    iataCode: 'NVT',
    destinationType: 'CITY',
    destinationName: 'Porto Belo',
    destinationId: 4445,
    latitude: -27.154703,
    longitude: -48.575912,
  },
  {
    sortOrder: 39,
    selectable: true,
    destinationUrlName: 'Porto-de-Galinhas',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22964.25314',
    parentId: 22964,
    timeZone: 'America/Recife',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Porto de Galinhas',
    destinationId: 25314,
    latitude: -8.5011,
    longitude: -35.005,
  },
  {
    sortOrder: 40,
    selectable: true,
    destinationUrlName: 'Porto-Seguro',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22964.29262',
    parentId: 22964,
    timeZone: 'America/Bahia',
    iataCode: 'BPS',
    destinationType: 'CITY',
    destinationName: 'Porto Seguro',
    destinationId: 29262,
    latitude: -16.44435,
    longitude: -39.06537,
  },
  {
    sortOrder: 41,
    selectable: true,
    destinationUrlName: 'Recife',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22964.4456',
    parentId: 22964,
    timeZone: 'America/Recife',
    iataCode: 'REC',
    destinationType: 'CITY',
    destinationName: 'Recife',
    destinationId: 4456,
    latitude: -11.010933,
    longitude: -41.88968,
  },
  {
    sortOrder: 42,
    selectable: true,
    destinationUrlName: 'Rio-de-Janeiro',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22967.712',
    parentId: 22967,
    timeZone: 'America/Sao_Paulo',
    iataCode: 'RIO',
    destinationType: 'CITY',
    destinationName: 'Rio de Janeiro',
    destinationId: 712,
    latitude: -22.9035393,
    longitude: -43.2095869,
  },
  {
    sortOrder: 43,
    selectable: true,
    destinationUrlName: 'Salvador-da-Bahia',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22964.818',
    parentId: 22964,
    timeZone: 'America/Bahia',
    iataCode: 'SSA',
    destinationType: 'CITY',
    destinationName: 'Salvador da Bahia',
    destinationId: 818,
    latitude: -12.9703817,
    longitude: -38.512382,
  },
  {
    sortOrder: 44,
    selectable: true,
    destinationUrlName: 'Santarem',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.4419',
    parentId: 79,
    timeZone: 'America/Santarem',
    iataCode: 'STM',
    destinationType: 'CITY',
    destinationName: 'Santarem',
    destinationId: 4419,
    latitude: -2.44306,
    longitude: -54.708328,
  },
  {
    sortOrder: 45,
    selectable: true,
    destinationUrlName: 'Santo-Amaro-do-Maranhao',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22964.51297',
    parentId: 22964,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Santo Amaro do Maranhao',
    destinationId: 51297,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 46,
    selectable: true,
    destinationUrlName: 'Santos',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22967.4450',
    parentId: 22967,
    timeZone: 'America/Sao_Paulo',
    iataCode: 'SSZ',
    destinationType: 'CITY',
    destinationName: 'Santos',
    destinationId: 4450,
    latitude: -23.967765,
    longitude: -46.327631,
  },
  {
    sortOrder: 47,
    selectable: true,
    destinationUrlName: 'Sao-Luis-do-Maranhao',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.29097.37752',
    parentId: 29097,
    timeZone: 'America/Fortaleza',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'São Luis do Maranhão',
    destinationId: 37752,
    latitude: -2.5606303,
    longitude: -44.3281626,
  },
  {
    sortOrder: 48,
    selectable: true,
    destinationUrlName: 'Sao-Paulo',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.22967.5112',
    parentId: 22967,
    timeZone: 'America/Sao_Paulo',
    iataCode: 'GRU',
    destinationType: 'CITY',
    destinationName: 'Sao Paulo',
    destinationId: 5112,
    latitude: -23.5489433,
    longitude: -46.6388182,
  },
  {
    sortOrder: 49,
    selectable: true,
    destinationUrlName: 'Vitoria',
    defaultCurrencyCode: 'USD',
    lookupId: '9.79.4454',
    parentId: 79,
    timeZone: 'America/Sao_Paulo',
    iataCode: 'VIX',
    destinationType: 'CITY',
    destinationName: 'Vitoria',
    destinationId: 4454,
    latitude: -20.297618,
    longitude: -40.295777,
  },
  {
    sortOrder: 34,
    selectable: true,
    destinationUrlName: 'British-Virgin-Islands',
    defaultCurrencyCode: 'USD',
    lookupId: '4.809',
    parentId: 4,
    timeZone: 'America/Tortola',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'British Virgin Islands',
    destinationId: 809,
    latitude: 18.420695,
    longitude: -64.639968,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Tortola',
    defaultCurrencyCode: 'USD',
    lookupId: '4.809.50314',
    parentId: 809,
    timeZone: 'America/Tortola',
    iataCode: 'TOV',
    destinationType: 'CITY',
    destinationName: 'Tortola',
    destinationId: 50314,
    latitude: 18.435955,
    longitude: -64.633226,
  },
  {
    sortOrder: 35,
    selectable: true,
    destinationUrlName: 'Brunei',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4616',
    parentId: 2,
    timeZone: 'Asia/Brunei',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Brunei',
    destinationId: 4616,
    latitude: 4.5353,
    longitude: 114.7277,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Bandar-Seri-Begawan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4616.4617',
    parentId: 4616,
    timeZone: 'Asia/Brunei',
    iataCode: 'BWN',
    destinationType: 'CITY',
    destinationName: 'Bandar Seri Begawan',
    destinationId: 4617,
    latitude: 4.904955,
    longitude: 114.936971,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Kampong-Jerudong',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4616.50576',
    parentId: 4616,
    timeZone: 'Asia/Brunei',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kampong Jerudong',
    destinationId: 50576,
    latitude: 4.92822,
    longitude: 114.82331,
  },
  {
    sortOrder: 36,
    selectable: true,
    destinationUrlName: 'Bulgaria',
    defaultCurrencyCode: 'USD',
    lookupId: '6.46',
    parentId: 6,
    timeZone: 'Europe/Sofia',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Bulgaria',
    destinationId: 46,
    latitude: 42.733883,
    longitude: 25.48583,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Black-Sea-Coast',
    defaultCurrencyCode: 'USD',
    lookupId: '6.46.22429',
    parentId: 46,
    timeZone: 'Europe/Sofia',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Black Sea Coast',
    destinationId: 22429,
    latitude: 42.49103,
    longitude: 27.47392,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Gela',
    defaultCurrencyCode: 'USD',
    lookupId: '6.46.51978',
    parentId: 46,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Gela',
    destinationId: 51978,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Plovdiv-Province',
    defaultCurrencyCode: 'USD',
    lookupId: '6.46.51668',
    parentId: 46,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Plovdiv Province',
    destinationId: 51668,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Ruse',
    defaultCurrencyCode: 'USD',
    lookupId: '6.46.51627',
    parentId: 46,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Ruse',
    destinationId: 51627,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Shipka',
    defaultCurrencyCode: 'USD',
    lookupId: '6.46.51773',
    parentId: 46,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Shipka',
    destinationId: 51773,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Smolyan-Province',
    defaultCurrencyCode: 'USD',
    lookupId: '6.46.51868',
    parentId: 46,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Smolyan Province',
    destinationId: 51868,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Stara-Zagora',
    defaultCurrencyCode: 'USD',
    lookupId: '6.46.51698',
    parentId: 46,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Stara Zagora',
    destinationId: 51698,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Teteven',
    defaultCurrencyCode: 'USD',
    lookupId: '6.46.51724',
    parentId: 46,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Teteven',
    destinationId: 51724,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Trigrad',
    defaultCurrencyCode: 'USD',
    lookupId: '6.46.51764',
    parentId: 46,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Trigrad',
    destinationId: 51764,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Vidin',
    defaultCurrencyCode: 'USD',
    lookupId: '6.46.51726',
    parentId: 46,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Vidin',
    destinationId: 51726,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Albena',
    defaultCurrencyCode: 'USD',
    lookupId: '6.46.22429.50954',
    parentId: 22429,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Albena',
    destinationId: 50954,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Bansko',
    defaultCurrencyCode: 'USD',
    lookupId: '6.46.31481',
    parentId: 46,
    timeZone: 'Europe/Sofia',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bansko',
    destinationId: 31481,
    latitude: 41.84042,
    longitude: 23.48565,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Belogradchik',
    defaultCurrencyCode: 'USD',
    lookupId: '6.46.50389',
    parentId: 46,
    timeZone: 'Europe/Sofia',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Belogradchik',
    destinationId: 50389,
    latitude: 43.6278,
    longitude: 22.683,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Borovets',
    defaultCurrencyCode: 'USD',
    lookupId: '6.46.36672',
    parentId: 46,
    timeZone: 'Europe/Sofia',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Borovets',
    destinationId: 36672,
    latitude: 42.272488,
    longitude: 23.5886734,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Burgas',
    defaultCurrencyCode: 'USD',
    lookupId: '6.46.22429.50308',
    parentId: 22429,
    timeZone: 'Europe/Sofia',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Burgas',
    destinationId: 50308,
    latitude: 42.5048,
    longitude: 27.4626,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Golden-Sands',
    defaultCurrencyCode: 'USD',
    lookupId: '6.46.22429.50906',
    parentId: 22429,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Golden Sands',
    destinationId: 50906,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Karlovo',
    defaultCurrencyCode: 'USD',
    lookupId: '6.46.22041.51799',
    parentId: 22041,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Karlovo',
    destinationId: 51799,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Nessebar',
    defaultCurrencyCode: 'USD',
    lookupId: '6.46.50387',
    parentId: 46,
    timeZone: 'Europe/Sofia',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nessebar',
    destinationId: 50387,
    latitude: 42.6601,
    longitude: 27.7206,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Plovdiv',
    defaultCurrencyCode: 'USD',
    lookupId: '6.46.22041',
    parentId: 46,
    timeZone: 'Europe/Sofia',
    iataCode: 'PDV',
    destinationType: 'CITY',
    destinationName: 'Plovdiv',
    destinationId: 22041,
    latitude: 42.137417,
    longitude: 24.744047,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Ruse-Province',
    defaultCurrencyCode: 'USD',
    lookupId: '6.46.51147',
    parentId: 46,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ruse Province',
    destinationId: 51147,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Sliven',
    defaultCurrencyCode: 'USD',
    lookupId: '6.46.25615',
    parentId: 46,
    timeZone: 'Europe/Sofia',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sliven',
    destinationId: 25615,
    latitude: 42.682145,
    longitude: 26.323043,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Sofia',
    defaultCurrencyCode: 'USD',
    lookupId: '6.46.5630',
    parentId: 46,
    timeZone: 'Europe/Sofia',
    iataCode: 'SOF',
    destinationType: 'CITY',
    destinationName: 'Sofia',
    destinationId: 5630,
    latitude: 42.697708,
    longitude: 23.321868,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Starosel',
    defaultCurrencyCode: 'USD',
    lookupId: '6.46.22041.51958',
    parentId: 22041,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Starosel',
    destinationId: 51958,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Varna',
    defaultCurrencyCode: 'USD',
    lookupId: '6.46.22429.4286',
    parentId: 22429,
    timeZone: 'Europe/Sofia',
    iataCode: 'VAR',
    destinationType: 'CITY',
    destinationName: 'Varna',
    destinationId: 4286,
    latitude: 43.21405,
    longitude: 27.91473,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Veliko-Tarnovo',
    defaultCurrencyCode: 'USD',
    lookupId: '6.46.50388',
    parentId: 46,
    timeZone: 'Europe/Sofia',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Veliko Tarnovo',
    destinationId: 50388,
    latitude: 43.0757,
    longitude: 25.6172,
  },
  {
    sortOrder: 37,
    selectable: true,
    destinationUrlName: 'Burkina-Faso',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21805',
    parentId: 1,
    timeZone: 'Africa/Ouagadougou',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Burkina Faso',
    destinationId: 21805,
    latitude: 12.2383,
    longitude: -1.5616,
  },
  {
    sortOrder: 38,
    selectable: true,
    destinationUrlName: 'Burundi',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21806',
    parentId: 1,
    timeZone: 'Africa/Bujumbura',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Burundi',
    destinationId: 21806,
    latitude: -3.3731,
    longitude: 29.9189,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Bujumbura',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21806.25796',
    parentId: 21806,
    timeZone: 'Africa/Bujumbura',
    iataCode: 'BJM',
    destinationType: 'CITY',
    destinationName: 'Bujumbura',
    destinationId: 25796,
    latitude: -3.361932,
    longitude: 29.360271,
  },
  {
    sortOrder: 39,
    selectable: true,
    destinationUrlName: 'Cambodia',
    defaultCurrencyCode: 'USD',
    lookupId: '2.12',
    parentId: 2,
    timeZone: 'Asia/Phnom_Penh',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Cambodia',
    destinationId: 12,
    latitude: 12.565679,
    longitude: 104.990963,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Eastern-Cambodia',
    defaultCurrencyCode: 'USD',
    lookupId: '2.12.24407',
    parentId: 12,
    timeZone: 'Asia/Phnom_Penh',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Eastern Cambodia',
    destinationId: 24407,
    latitude: 10.60707,
    longitude: 104.18026,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Preah-Vihear-Province',
    defaultCurrencyCode: 'USD',
    lookupId: '2.12.51655',
    parentId: 12,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Preah Vihear Province',
    destinationId: 51655,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'South-Coast',
    defaultCurrencyCode: 'USD',
    lookupId: '2.12.24292',
    parentId: 12,
    timeZone: 'America/Lima',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'South Coast',
    destinationId: 24292,
    latitude: -16.409,
    longitude: -71.5375,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Angkor-Wat',
    defaultCurrencyCode: 'USD',
    lookupId: '2.12.751',
    parentId: 12,
    timeZone: 'Asia/Phnom_Penh',
    iataCode: 'REP',
    destinationType: 'CITY',
    destinationName: 'Angkor Wat',
    destinationId: 751,
    latitude: 13.4256,
    longitude: 103.86,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Battambang',
    defaultCurrencyCode: 'USD',
    lookupId: '2.12.27515',
    parentId: 12,
    timeZone: 'Asia/Phnom_Penh',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Battambang',
    destinationId: 27515,
    latitude: 13.09573,
    longitude: 103.20221,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Kampong-Thom',
    defaultCurrencyCode: 'USD',
    lookupId: '2.12.50391',
    parentId: 12,
    timeZone: 'Asia/Phnom_Penh',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kampong Thom',
    destinationId: 50391,
    latitude: 12.8222,
    longitude: 105.1259,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Kratie',
    defaultCurrencyCode: 'USD',
    lookupId: '2.12.24407.24521',
    parentId: 24407,
    timeZone: 'Asia/Phnom_Penh',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kratie',
    destinationId: 24521,
    latitude: 12.494099,
    longitude: 106.033857,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Krong-Kaeb',
    defaultCurrencyCode: 'USD',
    lookupId: '2.12.50390',
    parentId: 12,
    timeZone: 'Asia/Phnom_Penh',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Krong Kaeb',
    destinationId: 50390,
    latitude: 10.5432,
    longitude: 104.3191,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Phnom-Penh',
    defaultCurrencyCode: 'USD',
    lookupId: '2.12.5425',
    parentId: 12,
    timeZone: 'Asia/Phnom_Penh',
    iataCode: 'PNH',
    destinationType: 'CITY',
    destinationName: 'Phnom Penh',
    destinationId: 5425,
    latitude: 11.558831,
    longitude: 104.9174449977,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Siem-Reap',
    defaultCurrencyCode: 'USD',
    lookupId: '2.12.5480',
    parentId: 12,
    timeZone: 'Asia/Phnom_Penh',
    iataCode: 'REP',
    destinationType: 'CITY',
    destinationName: 'Siem Reap',
    destinationId: 5480,
    latitude: 13.6915376984,
    longitude: 104.1001326026,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Sihanoukville',
    defaultCurrencyCode: 'USD',
    lookupId: '2.12.24292.24634',
    parentId: 24292,
    timeZone: 'Asia/Phnom_Penh',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sihanoukville',
    destinationId: 24634,
    latitude: 10.62541,
    longitude: 103.523386,
  },
  {
    sortOrder: 40,
    selectable: true,
    destinationUrlName: 'Cameroon',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21885',
    parentId: 1,
    timeZone: 'Africa/Douala',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Cameroon',
    destinationId: 21885,
    latitude: 7.3697,
    longitude: 12.3547,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Douala',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21885.51626',
    parentId: 21885,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Douala',
    destinationId: 51626,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Yaounde',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21885.36694',
    parentId: 21885,
    timeZone: 'Africa/Douala',
    iataCode: 'YAO',
    destinationType: 'CITY',
    destinationName: 'Yaounde',
    destinationId: 36694,
    latitude: 3.8303023,
    longitude: 11.440413,
  },
  {
    sortOrder: 41,
    selectable: true,
    destinationUrlName: 'Canada',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75',
    parentId: 8,
    timeZone: 'America/Toronto',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Canada',
    destinationId: 75,
    latitude: 56.130366,
    longitude: -106.346771,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Alberta',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.260',
    parentId: 75,
    timeZone: 'America/Edmonton',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Alberta',
    destinationId: 260,
    latitude: 53.9332706,
    longitude: -116.5765035,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'British-Columbia',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.261',
    parentId: 75,
    timeZone: 'America/Vancouver',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'British Columbia',
    destinationId: 261,
    latitude: 53.7266683,
    longitude: -127.6476206,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Manitoba',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.25663',
    parentId: 75,
    timeZone: 'America/Winnipeg',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Manitoba',
    destinationId: 25663,
    latitude: 55.1232,
    longitude: -97.3832,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'New-Brunswick',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.22870',
    parentId: 75,
    timeZone: 'America/Moncton',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'New Brunswick',
    destinationId: 22870,
    latitude: 46.56532,
    longitude: -66.46192,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Newfoundland-and-Labrador',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.25871',
    parentId: 75,
    timeZone: 'America/Toronto',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Newfoundland & Labrador',
    destinationId: 25871,
    latitude: 52.734292,
    longitude: -68.8695401,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Northwest-Territories',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.23636',
    parentId: 75,
    timeZone: 'America/Goose_Bay',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Northwest Territories',
    destinationId: 23636,
    latitude: 52.9941,
    longitude: -66.9445,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Nova-Scotia',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.262',
    parentId: 75,
    timeZone: 'America/Halifax',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Nova Scotia',
    destinationId: 262,
    latitude: 44.694441,
    longitude: -63.513004,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Ontario',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.263',
    parentId: 75,
    timeZone: 'America/Toronto',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Ontario',
    destinationId: 263,
    latitude: 51.253775,
    longitude: -85.3232139,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Prince-Edward-Island',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.5643',
    parentId: 75,
    timeZone: 'Canada/Eastern',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Prince Edward Island',
    destinationId: 5643,
    latitude: 46.384833,
    longitude: -63.461151,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Quebec',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.264',
    parentId: 75,
    timeZone: 'America/Montreal',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Quebec',
    destinationId: 264,
    latitude: 52.9399159,
    longitude: -73.5491361,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Yukon',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.5419',
    parentId: 75,
    timeZone: 'Canada/Yukon',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Yukon',
    destinationId: 5419,
    latitude: 64.0,
    longitude: -135.0,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Algonquin-Provincial-Park',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.263.50582',
    parentId: 263,
    timeZone: 'America/Vancouver',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Algonquin Provincial Park',
    destinationId: 50582,
    latitude: 54.023991,
    longitude: -123.164436,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Banff',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.260.611',
    parentId: 260,
    timeZone: 'America/Edmonton',
    iataCode: 'YBA',
    destinationType: 'CITY',
    destinationName: 'Banff',
    destinationId: 611,
    latitude: 51.1780556,
    longitude: -115.5719444,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Bonne-Bay',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.4397',
    parentId: 75,
    timeZone: 'America/St_Johns',
    iataCode: 'YDF',
    destinationType: 'CITY',
    destinationName: 'Bonne Bay',
    destinationId: 4397,
    latitude: 49.5006,
    longitude: -57.9177,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Calgary',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.260.817',
    parentId: 260,
    timeZone: 'America/Edmonton',
    iataCode: 'YYC',
    destinationType: 'CITY',
    destinationName: 'Calgary',
    destinationId: 817,
    latitude: 51.045,
    longitude: -114.0572222,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Canmore',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.260.50891',
    parentId: 260,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Canmore',
    destinationId: 50891,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Cape-Breton-Island',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.262.50647',
    parentId: 262,
    timeZone: 'America/Halifax',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cape Breton Island',
    destinationId: 50647,
    latitude: 46.286049,
    longitude: -62.877701,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Charlottetown',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.4401',
    parentId: 75,
    timeZone: 'America/Halifax',
    iataCode: 'YHG',
    destinationType: 'CITY',
    destinationName: 'Charlottetown',
    destinationId: 4401,
    latitude: 46.2619398,
    longitude: -63.2059297,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Churchill',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.25663.25664',
    parentId: 25663,
    timeZone: 'America/Winnipeg',
    iataCode: 'YYQ',
    destinationType: 'CITY',
    destinationName: 'Churchill',
    destinationId: 25664,
    latitude: 58.766,
    longitude: -94.166,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Collingwood',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.263.50915',
    parentId: 263,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Collingwood',
    destinationId: 50915,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Edmonton',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.260.28470',
    parentId: 260,
    timeZone: 'America/Edmonton',
    iataCode: 'YEA',
    destinationType: 'CITY',
    destinationName: 'Edmonton',
    destinationId: 28470,
    latitude: 53.54439,
    longitude: -113.49093,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Fort-Smith',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.23636.51851',
    parentId: 23636,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Fort Smith',
    destinationId: 51851,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Fraser-Valley',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.261.29722',
    parentId: 261,
    timeZone: 'America/Vancouver',
    iataCode: 'YXX',
    destinationType: 'CITY',
    destinationName: 'Fraser Valley',
    destinationId: 29722,
    latitude: 49.37641,
    longitude: -121.81593,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Gravenhurst',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.263.51578',
    parentId: 263,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Gravenhurst',
    destinationId: 51578,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Halifax',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.262.4403',
    parentId: 262,
    timeZone: 'America/Halifax',
    iataCode: 'YHZ',
    destinationType: 'CITY',
    destinationName: 'Halifax',
    destinationId: 4403,
    latitude: 44.854444,
    longitude: -63.199167,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Hopewell-Cape',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.22870.51622',
    parentId: 22870,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Hopewell Cape',
    destinationId: 51622,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Huntsville',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.263.51539',
    parentId: 263,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Huntsville',
    destinationId: 51539,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Jasper',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.260.5421',
    parentId: 260,
    timeZone: 'Canada/Mountain',
    iataCode: 'YJA',
    destinationType: 'CITY',
    destinationName: 'Jasper',
    destinationId: 5421,
    latitude: 52.873056,
    longitude: -118.082222,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Kamloops',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.261.22562',
    parentId: 261,
    timeZone: 'America/Vancouver',
    iataCode: 'YKA',
    destinationType: 'CITY',
    destinationName: 'Kamloops',
    destinationId: 22562,
    latitude: 50.673365,
    longitude: -120.33696,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Kejimkujik-National-Park',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.262.50645',
    parentId: 262,
    timeZone: 'America/Moncton',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kejimkujik National Park',
    destinationId: 50645,
    latitude: 45.61538,
    longitude: -65.02487,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Kelowna-and-Okanagan-Valley',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.261.22366',
    parentId: 261,
    timeZone: 'America/Vancouver',
    iataCode: 'YLW',
    destinationType: 'CITY',
    destinationName: 'Kelowna & Okanagan Valley',
    destinationId: 22366,
    latitude: 49.882114,
    longitude: -119.477829,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Kingston',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.263.50495',
    parentId: 263,
    timeZone: 'America/Toronto',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kingston',
    destinationId: 50495,
    latitude: 44.2333,
    longitude: -76.5,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'Kootenay-Rockies',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.261.22363',
    parentId: 261,
    timeZone: 'America/Edmonton',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kootenay Rockies',
    destinationId: 22363,
    latitude: 49.61456,
    longitude: -115.78647,
  },
  {
    sortOrder: 23,
    selectable: true,
    destinationUrlName: 'London',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.263.50648',
    parentId: 263,
    timeZone: 'America/Toronto',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'London',
    destinationId: 50648,
    latitude: 42.984268,
    longitude: -81.247528,
  },
  {
    sortOrder: 24,
    selectable: true,
    destinationUrlName: 'Montreal',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.264.625',
    parentId: 264,
    timeZone: 'America/Montreal',
    iataCode: 'YMQ',
    destinationType: 'CITY',
    destinationName: 'Montreal',
    destinationId: 625,
    latitude: 45.508867,
    longitude: -73.554242,
  },
  {
    sortOrder: 25,
    selectable: true,
    destinationUrlName: 'Mont-Tremblant',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.264.28611',
    parentId: 264,
    timeZone: 'America/Toronto',
    iataCode: 'YTM',
    destinationType: 'CITY',
    destinationName: 'Mont Tremblant',
    destinationId: 28611,
    latitude: 46.11846,
    longitude: -74.59619,
  },
  {
    sortOrder: 26,
    selectable: true,
    destinationUrlName: 'Muskoka-Lakes',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.263.51749',
    parentId: 263,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Muskoka Lakes',
    destinationId: 51749,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 27,
    selectable: true,
    destinationUrlName: 'Niagara-Falls-and-Around',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.263.773',
    parentId: 263,
    timeZone: 'America/Toronto',
    iataCode: 'IAG',
    destinationType: 'CITY',
    destinationName: 'Niagara Falls & Around',
    destinationId: 773,
    latitude: 43.086007,
    longitude: -79.097866,
  },
  {
    sortOrder: 28,
    selectable: true,
    destinationUrlName: 'Ottawa',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.263.622',
    parentId: 263,
    timeZone: 'America/Toronto',
    iataCode: 'YOW',
    destinationType: 'CITY',
    destinationName: 'Ottawa',
    destinationId: 622,
    latitude: 45.411572,
    longitude: -75.698194,
  },
  {
    sortOrder: 29,
    selectable: true,
    destinationUrlName: 'Pemberton',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.261.50579',
    parentId: 261,
    timeZone: 'America/Vancouver',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Pemberton',
    destinationId: 50579,
    latitude: 50.317169,
    longitude: -122.798439,
  },
  {
    sortOrder: 30,
    selectable: true,
    destinationUrlName: 'Peterborough-and-the-Kawarthas',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.263.28610',
    parentId: 263,
    timeZone: 'America/Toronto',
    iataCode: 'YPQ',
    destinationType: 'CITY',
    destinationName: 'Peterborough & the Kawarthas',
    destinationId: 28610,
    latitude: 44.30906,
    longitude: -78.31975,
  },
  {
    sortOrder: 31,
    selectable: true,
    destinationUrlName: 'Quebec-City',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.264.626',
    parentId: 264,
    timeZone: 'America/Montreal',
    iataCode: 'YQB',
    destinationType: 'CITY',
    destinationName: 'Quebec City',
    destinationId: 626,
    latitude: 46.802071,
    longitude: -71.244926,
  },
  {
    sortOrder: 32,
    selectable: true,
    destinationUrlName: 'Revelstoke',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.261.50914',
    parentId: 261,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Revelstoke',
    destinationId: 50914,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 33,
    selectable: true,
    destinationUrlName: 'Saint-John',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.22870.22871',
    parentId: 22870,
    timeZone: 'America/Moncton',
    iataCode: 'YSJ',
    destinationType: 'CITY',
    destinationName: 'Saint John',
    destinationId: 22871,
    latitude: 45.27332,
    longitude: -66.06331,
  },
  {
    sortOrder: 34,
    selectable: true,
    destinationUrlName: 'Squamish',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.261.22365',
    parentId: 261,
    timeZone: 'US/Pacific',
    iataCode: 'YVR',
    destinationType: 'CITY',
    destinationName: 'Squamish',
    destinationId: 22365,
    latitude: 49.701634,
    longitude: -123.155812,
  },
  {
    sortOrder: 35,
    selectable: true,
    destinationUrlName: 'St-Johns',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.25871.28792',
    parentId: 25871,
    timeZone: 'America/St_Johns',
    iataCode: 'YYT',
    destinationType: 'CITY',
    destinationName: "St John's",
    destinationId: 28792,
    latitude: 47.56054,
    longitude: -52.71283,
  },
  {
    sortOrder: 36,
    selectable: true,
    destinationUrlName: 'Sunshine-Coast',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.261.23789',
    parentId: 261,
    timeZone: 'America/Vancouver',
    iataCode: 'MCY',
    destinationType: 'CITY',
    destinationName: 'Sunshine Coast',
    destinationId: 23789,
    latitude: 49.83,
    longitude: -124.513,
  },
  {
    sortOrder: 37,
    selectable: true,
    destinationUrlName: 'Tadoussac',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.264.50497',
    parentId: 264,
    timeZone: 'America/Toronto',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tadoussac',
    destinationId: 50497,
    latitude: 48.148312,
    longitude: -69.717957,
  },
  {
    sortOrder: 38,
    selectable: true,
    destinationUrlName: 'Toronto',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.263.623',
    parentId: 263,
    timeZone: 'America/Toronto',
    iataCode: 'YTO',
    destinationType: 'CITY',
    destinationName: 'Toronto',
    destinationId: 623,
    latitude: 43.6525,
    longitude: -79.3816667,
  },
  {
    sortOrder: 39,
    selectable: true,
    destinationUrlName: 'Vancouver',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.261.616',
    parentId: 261,
    timeZone: 'America/Vancouver',
    iataCode: 'YVR',
    destinationType: 'CITY',
    destinationName: 'Vancouver',
    destinationId: 616,
    latitude: 49.2874029705,
    longitude: -123.0845546722,
  },
  {
    sortOrder: 40,
    selectable: true,
    destinationUrlName: 'Vancouver-Island',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.261.30423',
    parentId: 261,
    timeZone: 'America/Vancouver',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Vancouver Island',
    destinationId: 30423,
    latitude: 49.65064,
    longitude: -125.44939,
  },
  {
    sortOrder: 41,
    selectable: true,
    destinationUrlName: 'Victoria',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.261.617',
    parentId: 261,
    timeZone: 'America/Vancouver',
    iataCode: 'YYJ',
    destinationType: 'CITY',
    destinationName: 'Victoria',
    destinationId: 617,
    latitude: 48.4252137224,
    longitude: -123.382730484,
  },
  {
    sortOrder: 42,
    selectable: true,
    destinationUrlName: 'Whistler',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.261.618',
    parentId: 261,
    timeZone: 'America/Vancouver',
    iataCode: 'YWS',
    destinationType: 'CITY',
    destinationName: 'Whistler',
    destinationId: 618,
    latitude: 50.116168,
    longitude: -122.959423,
  },
  {
    sortOrder: 43,
    selectable: true,
    destinationUrlName: 'Whitehorse',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.5419.5420',
    parentId: 5419,
    timeZone: 'Canada/Yukon',
    iataCode: 'YXY',
    destinationType: 'CITY',
    destinationName: 'Whitehorse',
    destinationId: 5420,
    latitude: 60.716667,
    longitude: -135.05,
  },
  {
    sortOrder: 44,
    selectable: true,
    destinationUrlName: 'Windsor',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.263.28773',
    parentId: 263,
    timeZone: 'America/Toronto',
    iataCode: 'YQG',
    destinationType: 'CITY',
    destinationName: 'Windsor',
    destinationId: 28773,
    latitude: 42.31494,
    longitude: -83.03636,
  },
  {
    sortOrder: 45,
    selectable: true,
    destinationUrlName: 'Winnipeg',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.25663.50494',
    parentId: 25663,
    timeZone: 'America/Winnipeg',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Winnipeg',
    destinationId: 50494,
    latitude: 49.895138,
    longitude: -97.138374,
  },
  {
    sortOrder: 46,
    selectable: true,
    destinationUrlName: 'Yellowknife',
    defaultCurrencyCode: 'CAD',
    lookupId: '8.75.23636.23637',
    parentId: 23636,
    timeZone: 'America/Yellowknife',
    iataCode: 'YZF',
    destinationType: 'CITY',
    destinationName: 'Yellowknife',
    destinationId: 23637,
    latitude: 62.454053,
    longitude: -114.371151,
  },
  {
    sortOrder: 42,
    selectable: true,
    destinationUrlName: 'Cape-Verde',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4461',
    parentId: 1,
    timeZone: 'Atlantic/Cape_Verde',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Cape Verde',
    destinationId: 4461,
    latitude: 16.0202138,
    longitude: -25.1099868,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Boa-Vista',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4461.28617',
    parentId: 4461,
    timeZone: 'Atlantic/Cape_Verde',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Boa Vista',
    destinationId: 28617,
    latitude: 16.13725,
    longitude: -22.85822,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Sal',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4461.28618',
    parentId: 4461,
    timeZone: 'Atlantic/Cape_Verde',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Sal',
    destinationId: 28618,
    latitude: 16.72662,
    longitude: -22.92971,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Santiago',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4461.50852',
    parentId: 4461,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Santiago',
    destinationId: 50852,
    latitude: 15.1002186276,
    longitude: -23.6196009703,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Santo-Antao',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4461.50854',
    parentId: 4461,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Santo Antao',
    destinationId: 50854,
    latitude: 17.1134878667,
    longitude: -25.1429391569,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Brava',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4461.51447',
    parentId: 4461,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Brava',
    destinationId: 51447,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Espargos',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4461.28618.50997',
    parentId: 28618,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Espargos',
    destinationId: 50997,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Ilha-do-Fogo',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4461.51449',
    parentId: 4461,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ilha do Fogo',
    destinationId: 51449,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Mindelo',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4461.50310',
    parentId: 4461,
    timeZone: 'Atlantic/Cape_Verde',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mindelo',
    destinationId: 50310,
    latitude: 16.8765,
    longitude: -24.9813,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Nova-Sintra',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4461.51447.52167',
    parentId: 51447,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nova Sintra',
    destinationId: 52167,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Praia',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4461.50225',
    parentId: 4461,
    timeZone: 'Atlantic/Cape_Verde',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Praia',
    destinationId: 50225,
    latitude: 14.933,
    longitude: -23.5133,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Sal-Rei',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4461.28617.50851',
    parentId: 28617,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sal Rei',
    destinationId: 50851,
    latitude: 16.1845485135,
    longitude: -22.9149645908,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Santa-Maria',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4461.28618.50200',
    parentId: 28618,
    timeZone: 'Atlantic/Cape_Verde',
    iataCode: 'SMA',
    destinationType: 'CITY',
    destinationName: 'Santa Maria',
    destinationId: 50200,
    latitude: 16.600019,
    longitude: -22.905769,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Sao-Filipe',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4461.51449.52165',
    parentId: 51449,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sao Filipe',
    destinationId: 52165,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Sao-Vicente',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4461.50392',
    parentId: 4461,
    timeZone: 'Atlantic/Cape_Verde',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sao Vicente',
    destinationId: 50392,
    latitude: 16.828,
    longitude: -24.9754,
  },
  {
    sortOrder: 43,
    selectable: true,
    destinationUrlName: 'Cayman-Islands',
    defaultCurrencyCode: 'USD',
    lookupId: '4.31',
    parentId: 4,
    timeZone: 'America/Cayman',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Cayman Islands',
    destinationId: 31,
    latitude: 19.2897575435,
    longitude: -81.3729858398,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'George-Town',
    defaultCurrencyCode: 'USD',
    lookupId: '4.31.50496',
    parentId: 31,
    timeZone: 'America/Cayman',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'George Town',
    destinationId: 50496,
    latitude: 19.28434,
    longitude: -81.336372,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Grand-Cayman',
    defaultCurrencyCode: 'USD',
    lookupId: '4.31.50485',
    parentId: 31,
    timeZone: 'America/Cayman',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Grand Cayman',
    destinationId: 50485,
    latitude: 19.32217,
    longitude: -81.240868,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Seven-Mile-Beach',
    defaultCurrencyCode: 'USD',
    lookupId: '4.31.50498',
    parentId: 31,
    timeZone: 'Australia/Hobart',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Seven Mile Beach',
    destinationId: 50498,
    latitude: -42.859379,
    longitude: 147.507034,
  },
  {
    sortOrder: 44,
    selectable: true,
    destinationUrlName: 'Chad',
    defaultCurrencyCode: 'USD',
    lookupId: '1.22159',
    parentId: 1,
    timeZone: 'Africa/Niamey',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Chad',
    destinationId: 22159,
    latitude: 15.263302,
    longitude: 9.6964172,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'NDjamena',
    defaultCurrencyCode: 'USD',
    lookupId: '1.22159.36393',
    parentId: 22159,
    timeZone: 'Africa/Douala',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: "N'Djamena",
    destinationId: 36393,
    latitude: 12.1201831,
    longitude: 14.9173724,
  },
  {
    sortOrder: 45,
    selectable: true,
    destinationUrlName: 'Channel-Islands',
    defaultCurrencyCode: 'USD',
    lookupId: '6.32314',
    parentId: 6,
    timeZone: 'Europe/Guernsey',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Channel Islands',
    destinationId: 32314,
    latitude: 49.418491,
    longitude: -2.333276,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Guernsey',
    defaultCurrencyCode: 'USD',
    lookupId: '6.32314.4329',
    parentId: 32314,
    timeZone: 'Europe/Guernsey',
    iataCode: 'GCI',
    destinationType: 'CITY',
    destinationName: 'Guernsey',
    destinationId: 4329,
    latitude: 49.45,
    longitude: -2.58,
  },
  {
    sortOrder: 46,
    selectable: true,
    destinationUrlName: 'Chile',
    defaultCurrencyCode: 'USD',
    lookupId: '9.80',
    parentId: 9,
    timeZone: 'America/Santiago',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Chile',
    destinationId: 80,
    latitude: -35.675147,
    longitude: -71.542969,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Easter-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '9.80.306',
    parentId: 80,
    timeZone: 'Chile/EasterIsland',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Easter Island',
    destinationId: 306,
    latitude: -27.1211919,
    longitude: -109.3664237,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'North-Chile',
    defaultCurrencyCode: 'USD',
    lookupId: '9.80.307',
    parentId: 80,
    timeZone: 'America/Santiago',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'North Chile',
    destinationId: 307,
    latitude: -35.675147,
    longitude: -71.542969,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Patagonia',
    defaultCurrencyCode: 'USD',
    lookupId: '9.80.308',
    parentId: 80,
    timeZone: 'America/Argentina/Salta',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Patagonia',
    destinationId: 308,
    latitude: -41.8101472,
    longitude: -68.9062689,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Antofagasta',
    defaultCurrencyCode: 'USD',
    lookupId: '9.80.307.4502',
    parentId: 307,
    timeZone: 'America/Santiago',
    iataCode: 'ANF',
    destinationType: 'CITY',
    destinationName: 'Antofagasta',
    destinationId: 4502,
    latitude: -23.63006,
    longitude: -70.390381,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Arica',
    defaultCurrencyCode: 'USD',
    lookupId: '9.80.307.4503',
    parentId: 307,
    timeZone: 'America/Santiago',
    iataCode: 'ARI',
    destinationType: 'CITY',
    destinationName: 'Arica',
    destinationId: 4503,
    latitude: -18.478244,
    longitude: -70.311339,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Calama',
    defaultCurrencyCode: 'USD',
    lookupId: '9.80.307.50581',
    parentId: 307,
    timeZone: 'America/Santiago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Calama',
    destinationId: 50581,
    latitude: -22.4513,
    longitude: -68.923798,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Castro',
    defaultCurrencyCode: 'USD',
    lookupId: '9.80.308.25897',
    parentId: 308,
    timeZone: 'America/Santiago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Castro',
    destinationId: 25897,
    latitude: -42.480269,
    longitude: -73.762213,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Concepcion',
    defaultCurrencyCode: 'USD',
    lookupId: '9.80.50580',
    parentId: 80,
    timeZone: 'America/Santiago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Concepcion',
    destinationId: 50580,
    latitude: -36.817371,
    longitude: -73.063629,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Hanga-Roa',
    defaultCurrencyCode: 'USD',
    lookupId: '9.80.306.5099',
    parentId: 306,
    timeZone: 'Pacific/Easter',
    iataCode: 'IPC',
    destinationType: 'CITY',
    destinationName: 'Hanga Roa',
    destinationId: 5099,
    latitude: -27.15,
    longitude: -109.4333,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Iquique',
    defaultCurrencyCode: 'USD',
    lookupId: '9.80.307.22811',
    parentId: 307,
    timeZone: 'America/Santiago',
    iataCode: 'IQQ',
    destinationType: 'CITY',
    destinationName: 'Iquique',
    destinationId: 22811,
    latitude: -20.2448127,
    longitude: -70.1738689,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Isla-Chiloe',
    defaultCurrencyCode: 'USD',
    lookupId: '9.80.50924',
    parentId: 80,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Isla Chiloe',
    destinationId: 50924,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'La-Serena',
    defaultCurrencyCode: 'USD',
    lookupId: '9.80.307.4504',
    parentId: 307,
    timeZone: 'America/Santiago',
    iataCode: 'LSC',
    destinationType: 'CITY',
    destinationName: 'La Serena',
    destinationId: 4504,
    latitude: -29.902859,
    longitude: -71.252499,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Pisco-Elqui',
    defaultCurrencyCode: 'USD',
    lookupId: '9.80.50652',
    parentId: 80,
    timeZone: 'America/Santiago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Pisco Elqui',
    destinationId: 50652,
    latitude: -30.1217,
    longitude: -70.4927,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Pucon',
    defaultCurrencyCode: 'USD',
    lookupId: '9.80.308.25034',
    parentId: 308,
    timeZone: 'America/Santiago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Pucón',
    destinationId: 25034,
    latitude: -39.2731,
    longitude: -71.9778,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Puerto-Chacabuco',
    defaultCurrencyCode: 'USD',
    lookupId: '9.80.308.4505',
    parentId: 308,
    timeZone: 'America/Santiago',
    iataCode: 'WPA',
    destinationType: 'CITY',
    destinationName: 'Puerto Chacabuco',
    destinationId: 4505,
    latitude: -45.463219,
    longitude: -72.819125,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Puerto-Montt',
    defaultCurrencyCode: 'USD',
    lookupId: '9.80.308.4415',
    parentId: 308,
    timeZone: 'America/Santiago',
    iataCode: 'PMC',
    destinationType: 'CITY',
    destinationName: 'Puerto Montt',
    destinationId: 4415,
    latitude: -41.468917,
    longitude: -72.941136,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Puerto-Natales',
    defaultCurrencyCode: 'USD',
    lookupId: '9.80.308.23619',
    parentId: 308,
    timeZone: 'America/Santiago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Puerto Natales',
    destinationId: 23619,
    latitude: -51.730894,
    longitude: -72.497741,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Puerto-Varas',
    defaultCurrencyCode: 'USD',
    lookupId: '9.80.308.24025',
    parentId: 308,
    timeZone: 'America/Santiago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Puerto Varas',
    destinationId: 24025,
    latitude: -41.3167,
    longitude: -72.9833,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Punta-Arenas',
    defaultCurrencyCode: 'USD',
    lookupId: '9.80.308.4416',
    parentId: 308,
    timeZone: 'America/Santiago',
    iataCode: 'PUQ',
    destinationType: 'CITY',
    destinationName: 'Punta Arenas',
    destinationId: 4416,
    latitude: -53.154478,
    longitude: -70.916476,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'San-Antonio',
    defaultCurrencyCode: 'USD',
    lookupId: '9.80.50583',
    parentId: 80,
    timeZone: 'America/Santiago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'San Antonio',
    destinationId: 50583,
    latitude: -33.58865,
    longitude: -71.608994,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'San-Pedro-de-Atacama',
    defaultCurrencyCode: 'USD',
    lookupId: '9.80.307.5499',
    parentId: 307,
    timeZone: 'America/Santiago',
    iataCode: 'CJC',
    destinationType: 'CITY',
    destinationName: 'San Pedro de Atacama',
    destinationId: 5499,
    latitude: -22.908707,
    longitude: -68.199716,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Santiago',
    defaultCurrencyCode: 'USD',
    lookupId: '9.80.713',
    parentId: 80,
    timeZone: 'America/Santiago',
    iataCode: 'SCL',
    destinationType: 'CITY',
    destinationName: 'Santiago',
    destinationId: 713,
    latitude: -33.4253598,
    longitude: -70.5664659,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Talcahuano',
    defaultCurrencyCode: 'USD',
    lookupId: '9.80.50649',
    parentId: 80,
    timeZone: 'America/Santiago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Talcahuano',
    destinationId: 50649,
    latitude: -36.723598,
    longitude: -73.112396,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Tarrafal',
    defaultCurrencyCode: 'USD',
    lookupId: '9.80.713.51430',
    parentId: 713,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tarrafal',
    destinationId: 51430,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'Temuco',
    defaultCurrencyCode: 'USD',
    lookupId: '9.80.50650',
    parentId: 80,
    timeZone: 'America/Santiago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Temuco',
    destinationId: 50650,
    latitude: -38.739922,
    longitude: -72.590157,
  },
  {
    sortOrder: 23,
    selectable: true,
    destinationUrlName: 'Valdivia',
    defaultCurrencyCode: 'USD',
    lookupId: '9.80.50895',
    parentId: 80,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Valdivia',
    destinationId: 50895,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 24,
    selectable: true,
    destinationUrlName: 'Valparaiso',
    defaultCurrencyCode: 'USD',
    lookupId: '9.80.22148',
    parentId: 80,
    timeZone: 'America/Santiago',
    iataCode: 'VAP',
    destinationType: 'CITY',
    destinationName: 'Valparaíso',
    destinationId: 22148,
    latitude: -33.047238,
    longitude: -71.612688,
  },
  {
    sortOrder: 25,
    selectable: true,
    destinationUrlName: 'Villa-La-Angostura',
    defaultCurrencyCode: 'USD',
    lookupId: '9.80.308.51200',
    parentId: 308,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Villa La Angostura',
    destinationId: 51200,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 26,
    selectable: true,
    destinationUrlName: 'Vina-del-Mar',
    defaultCurrencyCode: 'USD',
    lookupId: '9.80.50627',
    parentId: 80,
    timeZone: 'America/Santiago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Vina del Mar',
    destinationId: 50627,
    latitude: -33.02463,
    longitude: -71.55181,
  },
  {
    sortOrder: 47,
    selectable: true,
    destinationUrlName: 'China',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13',
    parentId: 2,
    timeZone: 'Asia/Shanghai',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'China',
    destinationId: 13,
    latitude: 35.86166,
    longitude: 104.195397,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Eastern-China',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4436',
    parentId: 13,
    timeZone: 'Asia/Shanghai',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Eastern China',
    destinationId: 4436,
    latitude: 31.2221970321,
    longitude: 121.2451171875,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Guangxi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.27540',
    parentId: 13,
    timeZone: 'Asia/Shanghai',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Guangxi',
    destinationId: 27540,
    latitude: 22.81548,
    longitude: 108.32755,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Hong-Kong-SAR',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.35959',
    parentId: 13,
    timeZone: 'Asia/Hong_Kong',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Hong Kong SAR',
    destinationId: 35959,
    latitude: 22.396428,
    longitude: 114.109497,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Northern-China',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4431',
    parentId: 13,
    timeZone: 'Asia/Chongqing',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Northern China',
    destinationId: 4431,
    latitude: 39.9771200984,
    longitude: 116.89453125,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Northwest-China',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4434',
    parentId: 13,
    timeZone: 'Asia/Chongqing',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Northwest China',
    destinationId: 4434,
    latitude: 34.3434360685,
    longitude: 109.2919921875,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Southern-China',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4443',
    parentId: 13,
    timeZone: 'Asia/Chongqing',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Southern China',
    destinationId: 4443,
    latitude: 25.3043037644,
    longitude: 110.4565429688,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Southwest-China',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4438',
    parentId: 13,
    timeZone: 'Asia/Chongqing',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Southwest China',
    destinationId: 4438,
    latitude: 30.6757154042,
    longitude: 104.4140625,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Tibet',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.22445',
    parentId: 13,
    timeZone: 'Asia/Kathmandu',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Tibet',
    destinationId: 22445,
    latitude: 29.646923,
    longitude: 91.117212,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Western-China',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.24681',
    parentId: 13,
    timeZone: 'Asia/Shanghai',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Western China',
    destinationId: 24681,
    latitude: 43.88891,
    longitude: 125.28384,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Xinjiang',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.24849',
    parentId: 13,
    timeZone: 'Asia/Samarkand',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Xinjiang',
    destinationId: 24849,
    latitude: 40.3384725,
    longitude: 66.9682,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Beijing',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4431.321',
    parentId: 4431,
    timeZone: 'Asia/Shanghai',
    iataCode: 'BJS',
    destinationType: 'CITY',
    destinationName: 'Beijing',
    destinationId: 321,
    latitude: 39.904667,
    longitude: 116.408198,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Changchun',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4431.36671',
    parentId: 4431,
    timeZone: 'Asia/Shanghai',
    iataCode: 'CGQ',
    destinationType: 'CITY',
    destinationName: 'Changchun',
    destinationId: 36671,
    latitude: 43.6659276,
    longitude: 120.9207054,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Changsha',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4443.37507',
    parentId: 4443,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Changsha',
    destinationId: 37507,
    latitude: 26.5052013,
    longitude: 102.6372373,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Changzhou',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4436.40043',
    parentId: 4436,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Changzhou',
    destinationId: 40043,
    latitude: 31.8212157,
    longitude: 117.701587,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Chengdu',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4438.322',
    parentId: 4438,
    timeZone: 'Asia/Chongqing',
    iataCode: 'CTU',
    destinationType: 'CITY',
    destinationName: 'Chengdu',
    destinationId: 322,
    latitude: 30.658602,
    longitude: 104.064857,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Chongqing',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4438.24779',
    parentId: 4438,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Chongqing',
    destinationId: 24779,
    latitude: 29.56301,
    longitude: 106.55156,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Dali',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4438.22199',
    parentId: 4438,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Dali',
    destinationId: 22199,
    latitude: 25.60649,
    longitude: 100.26764,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Dalian',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4431.4621',
    parentId: 4431,
    timeZone: 'Asia/Shanghai',
    iataCode: 'DLC',
    destinationType: 'CITY',
    destinationName: 'Dalian',
    destinationId: 4621,
    latitude: 38.914,
    longitude: 121.61468,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Datong',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4431.24501',
    parentId: 4431,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Datong',
    destinationId: 24501,
    latitude: 40.077999,
    longitude: 113.302429,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Dujiangyan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.50315',
    parentId: 13,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Dujiangyan',
    destinationId: 50315,
    latitude: 30.994432,
    longitude: 103.643214,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Dunhuang',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.24681.24682',
    parentId: 24681,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Dunhuang',
    destinationId: 24682,
    latitude: 40.147612,
    longitude: 94.702795,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Emeishan-City',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4438.39467',
    parentId: 4438,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Emeishan City',
    destinationId: 39467,
    latitude: 29.496592,
    longitude: 102.2789662,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Fenghuang-County',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4443.51587',
    parentId: 4443,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Fenghuang County',
    destinationId: 51587,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Foshan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4443.50918',
    parentId: 4443,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Foshan',
    destinationId: 50918,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Guangzhou',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4443.4451',
    parentId: 4443,
    timeZone: 'Asia/Shanghai',
    iataCode: 'CAN',
    destinationType: 'CITY',
    destinationName: 'Guangzhou',
    destinationId: 4451,
    latitude: 23.129163,
    longitude: 113.264435,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Guilin',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4443.323',
    parentId: 4443,
    timeZone: 'Asia/Chongqing',
    iataCode: 'KWL',
    destinationType: 'CITY',
    destinationName: 'Guilin',
    destinationId: 323,
    latitude: 25.273567,
    longitude: 110.290195,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Guiyang',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4438.36665',
    parentId: 4438,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Guiyang',
    destinationId: 36665,
    latitude: 26.5960373,
    longitude: 106.646345,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Hangzhou',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4436.4437',
    parentId: 4436,
    timeZone: 'Asia/Shanghai',
    iataCode: 'HGH',
    destinationType: 'CITY',
    destinationName: 'Hangzhou',
    destinationId: 4437,
    latitude: 30.334953882,
    longitude: 120.3002929688,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Harbin',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4431.27431',
    parentId: 4431,
    timeZone: 'Asia/Shanghai',
    iataCode: 'HRB',
    destinationType: 'CITY',
    destinationName: 'Harbin',
    destinationId: 27431,
    latitude: 45.80378,
    longitude: 126.53497,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Hefei',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4436.36794',
    parentId: 4436,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Hefei',
    destinationId: 36794,
    latitude: 31.8554479,
    longitude: 112.8038332,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Hohhot',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4431.40036',
    parentId: 4431,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Hohhot',
    destinationId: 40036,
    latitude: 42.7596277,
    longitude: 112.7510384,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'Huangshan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4436.23162',
    parentId: 4436,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Huangshan',
    destinationId: 23162,
    latitude: 29.71475,
    longitude: 118.33762,
  },
  {
    sortOrder: 23,
    selectable: true,
    destinationUrlName: 'Jiayuguan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4434.36670',
    parentId: 4434,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Jiayuguan',
    destinationId: 36670,
    latitude: 39.7853894,
    longitude: 93.7871919,
  },
  {
    sortOrder: 24,
    selectable: true,
    destinationUrlName: 'Jinan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4436.36679',
    parentId: 4436,
    timeZone: 'Asia/Shanghai',
    iataCode: 'TNA',
    destinationType: 'CITY',
    destinationName: 'Jinan',
    destinationId: 36679,
    latitude: 36.6428393,
    longitude: 115.908501,
  },
  {
    sortOrder: 25,
    selectable: true,
    destinationUrlName: 'Jinghong',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4438.36945',
    parentId: 4438,
    timeZone: 'Asia/Vientiane',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Jinghong',
    destinationId: 36945,
    latitude: 22.194277,
    longitude: 101.8489795,
  },
  {
    sortOrder: 26,
    selectable: true,
    destinationUrlName: 'Jiuzhaigou-County',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4438.51585',
    parentId: 4438,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Jiuzhaigou County',
    destinationId: 51585,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 27,
    selectable: true,
    destinationUrlName: 'Kaili',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4443.51762',
    parentId: 4443,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kaili',
    destinationId: 51762,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 28,
    selectable: true,
    destinationUrlName: 'Kashgar',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.24849.36669',
    parentId: 24849,
    timeZone: 'Asia/Dushanbe',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kashgar',
    destinationId: 36669,
    latitude: 37.8316651,
    longitude: 68.1966667,
  },
  {
    sortOrder: 29,
    selectable: true,
    destinationUrlName: 'Kunming',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4438.22633',
    parentId: 4438,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kunming',
    destinationId: 22633,
    latitude: 24.88763,
    longitude: 102.854847,
  },
  {
    sortOrder: 30,
    selectable: true,
    destinationUrlName: 'Lanzhou',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4434.36793',
    parentId: 4434,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lanzhou',
    destinationId: 36793,
    latitude: 36.0780486,
    longitude: 103.4808756,
  },
  {
    sortOrder: 31,
    selectable: true,
    destinationUrlName: 'Leshan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.50393',
    parentId: 13,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Leshan',
    destinationId: 50393,
    latitude: 29.5521,
    longitude: 103.7657,
  },
  {
    sortOrder: 32,
    selectable: true,
    destinationUrlName: 'Lhasa',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.22445.22453',
    parentId: 22445,
    timeZone: 'Asia/Kathmandu',
    iataCode: 'LXA',
    destinationType: 'CITY',
    destinationName: 'Lhasa',
    destinationId: 22453,
    latitude: 29.652491,
    longitude: 91.17211,
  },
  {
    sortOrder: 33,
    selectable: true,
    destinationUrlName: 'Lijiang',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4438.4647',
    parentId: 4438,
    timeZone: 'Asia/Chongqing',
    iataCode: 'LJG',
    destinationType: 'CITY',
    destinationName: 'Lijiang',
    destinationId: 4647,
    latitude: 26.855047,
    longitude: 100.227751,
  },
  {
    sortOrder: 34,
    selectable: true,
    destinationUrlName: 'Lingui-County',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.27540.50230',
    parentId: 27540,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lingui County',
    destinationId: 50230,
    latitude: 25.2386,
    longitude: 110.2125,
  },
  {
    sortOrder: 35,
    selectable: true,
    destinationUrlName: 'Longsheng-County',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.27540.51601',
    parentId: 27540,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Longsheng County',
    destinationId: 51601,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 36,
    selectable: true,
    destinationUrlName: 'Luoyang',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4434.23849',
    parentId: 4434,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Luoyang',
    destinationId: 23849,
    latitude: 34.623511,
    longitude: 112.458748,
  },
  {
    sortOrder: 37,
    selectable: true,
    destinationUrlName: 'Macau-SAR',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4460',
    parentId: 13,
    timeZone: 'Asia/Macau',
    iataCode: 'MFM',
    destinationType: 'CITY',
    destinationName: 'Macau SAR',
    destinationId: 4460,
    latitude: 22.198745,
    longitude: 113.543873,
  },
  {
    sortOrder: 38,
    selectable: true,
    destinationUrlName: 'Nanchang',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4436.36944',
    parentId: 4436,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nanchang',
    destinationId: 36944,
    latitude: 28.6808569,
    longitude: 113.6631696,
  },
  {
    sortOrder: 39,
    selectable: true,
    destinationUrlName: 'Nanjing',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4436.25496',
    parentId: 4436,
    timeZone: 'Asia/Shanghai',
    iataCode: 'NKG',
    destinationType: 'CITY',
    destinationName: 'Nanjing',
    destinationId: 25496,
    latitude: 32.063121,
    longitude: 118.812029,
  },
  {
    sortOrder: 40,
    selectable: true,
    destinationUrlName: 'Nanning',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.27540.27541',
    parentId: 27540,
    timeZone: 'Asia/Shanghai',
    iataCode: 'NNG',
    destinationType: 'CITY',
    destinationName: 'Nanning',
    destinationId: 27541,
    latitude: 22.817,
    longitude: 108.36654,
  },
  {
    sortOrder: 41,
    selectable: true,
    destinationUrlName: 'Ningbo',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4436.40038',
    parentId: 4436,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ningbo',
    destinationId: 40038,
    latitude: 29.9714975,
    longitude: 112.5874494,
  },
  {
    sortOrder: 42,
    selectable: true,
    destinationUrlName: 'Pingyao',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4431.27517',
    parentId: 4431,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Pingyao',
    destinationId: 27517,
    latitude: 37.18956,
    longitude: 112.17627,
  },
  {
    sortOrder: 43,
    selectable: true,
    destinationUrlName: 'Putian',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4436.38684',
    parentId: 4436,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Putian',
    destinationId: 38684,
    latitude: 22.4649542,
    longitude: 113.5673771,
  },
  {
    sortOrder: 44,
    selectable: true,
    destinationUrlName: 'Qingdao',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.324',
    parentId: 13,
    timeZone: 'Asia/Shanghai',
    iataCode: 'TAO',
    destinationType: 'CITY',
    destinationName: 'Qingdao',
    destinationId: 324,
    latitude: 36.067117,
    longitude: 120.382612,
  },
  {
    sortOrder: 45,
    selectable: true,
    destinationUrlName: 'Quanzhou',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4443.39841',
    parentId: 4443,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Quanzhou',
    destinationId: 39841,
    latitude: 27.5385152,
    longitude: 109.7602135,
  },
  {
    sortOrder: 46,
    selectable: true,
    destinationUrlName: 'Qufu',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.36722',
    parentId: 13,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Qufu ',
    destinationId: 36722,
    latitude: 35.6280308,
    longitude: 116.7689465,
  },
  {
    sortOrder: 47,
    selectable: true,
    destinationUrlName: 'Sanjiang',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4443.51656',
    parentId: 4443,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sanjiang',
    destinationId: 51656,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 48,
    selectable: true,
    destinationUrlName: 'Sanya',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4443.4620',
    parentId: 4443,
    timeZone: 'Asia/Chongqing',
    iataCode: 'SYX',
    destinationType: 'CITY',
    destinationName: 'Sanya',
    destinationId: 4620,
    latitude: 18.25285,
    longitude: 109.51191,
  },
  {
    sortOrder: 49,
    selectable: true,
    destinationUrlName: 'Shanghai',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4436.325',
    parentId: 4436,
    timeZone: 'Asia/Shanghai',
    iataCode: 'SHA',
    destinationType: 'CITY',
    destinationName: 'Shanghai',
    destinationId: 325,
    latitude: 31.230708,
    longitude: 121.472916,
  },
  {
    sortOrder: 50,
    selectable: true,
    destinationUrlName: 'Shangri-La',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4438.23014',
    parentId: 4438,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Shangri-La',
    destinationId: 23014,
    latitude: 27.82974,
    longitude: 99.70084,
  },
  {
    sortOrder: 51,
    selectable: true,
    destinationUrlName: 'Shaoxing',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4436.51645',
    parentId: 4436,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Shaoxing',
    destinationId: 51645,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 52,
    selectable: true,
    destinationUrlName: 'Shenyang',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4431.39808',
    parentId: 4431,
    timeZone: 'Asia/Shanghai',
    iataCode: 'SHE',
    destinationType: 'CITY',
    destinationName: 'Shenyang',
    destinationId: 39808,
    latitude: 42.0620551,
    longitude: 118.4987504,
  },
  {
    sortOrder: 53,
    selectable: true,
    destinationUrlName: 'Shenzhen',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4443.27516',
    parentId: 4443,
    timeZone: 'Asia/Shanghai',
    iataCode: 'SZX',
    destinationType: 'CITY',
    destinationName: 'Shenzhen',
    destinationId: 27516,
    latitude: 22.5431,
    longitude: 114.05787,
  },
  {
    sortOrder: 54,
    selectable: true,
    destinationUrlName: 'Shijiazhuang',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4431.40040',
    parentId: 4431,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Shijiazhuang',
    destinationId: 40040,
    latitude: 38.0721101,
    longitude: 110.0172835,
  },
  {
    sortOrder: 55,
    selectable: true,
    destinationUrlName: 'Suzhou',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4436.28824',
    parentId: 4436,
    timeZone: 'Asia/Shanghai',
    iataCode: 'SZV',
    destinationType: 'CITY',
    destinationName: 'Suzhou',
    destinationId: 28824,
    latitude: 31.29898,
    longitude: 120.58529,
  },
  {
    sortOrder: 56,
    selectable: true,
    destinationUrlName: 'Taian',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4436.39842',
    parentId: 4436,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: "Tai'an",
    destinationId: 39842,
    latitude: 34.6725585,
    longitude: 112.0414233,
  },
  {
    sortOrder: 57,
    selectable: true,
    destinationUrlName: 'Taiyuan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4431.37506',
    parentId: 4431,
    timeZone: 'Asia/Shanghai',
    iataCode: 'TYN',
    destinationType: 'CITY',
    destinationName: 'Taiyuan',
    destinationId: 37506,
    latitude: 36.7270655,
    longitude: 111.8174675,
  },
  {
    sortOrder: 58,
    selectable: true,
    destinationUrlName: 'Tianjin',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4431.25272',
    parentId: 4431,
    timeZone: 'Asia/Shanghai',
    iataCode: 'TSN',
    destinationType: 'CITY',
    destinationName: 'Tianjin',
    destinationId: 25272,
    latitude: 39.351305,
    longitude: 117.368803,
  },
  {
    sortOrder: 59,
    selectable: true,
    destinationUrlName: 'Tianshui',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4434.36666',
    parentId: 4434,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tianshui',
    destinationId: 36666,
    latitude: 34.5793397,
    longitude: 101.2455367,
  },
  {
    sortOrder: 60,
    selectable: true,
    destinationUrlName: 'Urumqi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.24849.24850',
    parentId: 24849,
    timeZone: 'Asia/Shanghai',
    iataCode: 'URC',
    destinationType: 'CITY',
    destinationName: 'Urumqi',
    destinationId: 24850,
    latitude: 43.826397,
    longitude: 87.617939,
  },
  {
    sortOrder: 61,
    selectable: true,
    destinationUrlName: 'Wenzhou',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4436.39843',
    parentId: 4436,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Wenzhou',
    destinationId: 39843,
    latitude: 27.7760487,
    longitude: 111.7927699,
  },
  {
    sortOrder: 62,
    selectable: true,
    destinationUrlName: 'Wuhan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4436.36668',
    parentId: 4436,
    timeZone: 'Asia/Shanghai',
    iataCode: 'WUH',
    destinationType: 'CITY',
    destinationName: 'Wuhan',
    destinationId: 36668,
    latitude: 30.568041,
    longitude: 109.8179551,
  },
  {
    sortOrder: 63,
    selectable: true,
    destinationUrlName: 'Wuxi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4436.37505',
    parentId: 4436,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Wuxi',
    destinationId: 37505,
    latitude: 31.5701935,
    longitude: 120.1725691,
  },
  {
    sortOrder: 64,
    selectable: true,
    destinationUrlName: 'Wuyishan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4436.38105',
    parentId: 4436,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Wuyishan',
    destinationId: 38105,
    latitude: 27.7648267,
    longitude: 115.7435087,
  },
  {
    sortOrder: 65,
    selectable: true,
    destinationUrlName: 'Xiamen',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4443.4622',
    parentId: 4443,
    timeZone: 'Asia/Shanghai',
    iataCode: 'XMN',
    destinationType: 'CITY',
    destinationName: 'Xiamen',
    destinationId: 4622,
    latitude: 24.48132,
    longitude: 118.09074,
  },
  {
    sortOrder: 66,
    selectable: true,
    destinationUrlName: 'Xian',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4434.326',
    parentId: 4434,
    timeZone: 'Asia/Chongqing',
    iataCode: 'SIA',
    destinationType: 'CITY',
    destinationName: 'Xian',
    destinationId: 326,
    latitude: 34.26488,
    longitude: 108.944265,
  },
  {
    sortOrder: 67,
    selectable: true,
    destinationUrlName: 'Xingyi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4443.51763',
    parentId: 4443,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Xingyi',
    destinationId: 51763,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 68,
    selectable: true,
    destinationUrlName: 'Xining',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4434.28057',
    parentId: 4434,
    timeZone: 'Asia/Shanghai',
    iataCode: 'XNN',
    destinationType: 'CITY',
    destinationName: 'Xining',
    destinationId: 28057,
    latitude: 36.61713,
    longitude: 101.77822,
  },
  {
    sortOrder: 69,
    selectable: true,
    destinationUrlName: 'Xuzhou',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4436.40042',
    parentId: 4436,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Xuzhou',
    destinationId: 40042,
    latitude: 34.3675543,
    longitude: 108.2230305,
  },
  {
    sortOrder: 70,
    selectable: true,
    destinationUrlName: 'Yangshuo',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4443.4447',
    parentId: 4443,
    timeZone: 'Asia/Chongqing',
    iataCode: 'KWL',
    destinationType: 'CITY',
    destinationName: 'Yangshuo',
    destinationId: 4447,
    latitude: 24.778481,
    longitude: 110.496593,
  },
  {
    sortOrder: 71,
    selectable: true,
    destinationUrlName: 'Yangzhou',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4436.29046',
    parentId: 4436,
    timeZone: 'Asia/Shanghai',
    iataCode: 'YTY',
    destinationType: 'CITY',
    destinationName: 'Yangzhou',
    destinationId: 29046,
    latitude: 32.39421,
    longitude: 119.41295,
  },
  {
    sortOrder: 72,
    selectable: true,
    destinationUrlName: 'Yichang',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4438.25312',
    parentId: 4438,
    timeZone: 'Asia/Shanghai',
    iataCode: 'YIH',
    destinationType: 'CITY',
    destinationName: 'Yichang',
    destinationId: 25312,
    latitude: 30.693192,
    longitude: 111.287112,
  },
  {
    sortOrder: 73,
    selectable: true,
    destinationUrlName: 'Yinchuan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4434.40041',
    parentId: 4434,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Yinchuan',
    destinationId: 40041,
    latitude: 38.8005236,
    longitude: 99.0510598,
  },
  {
    sortOrder: 74,
    selectable: true,
    destinationUrlName: 'Zhangjiajie',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4443.24683',
    parentId: 4443,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Zhangjiajie',
    destinationId: 24683,
    latitude: 29.118771,
    longitude: 110.487263,
  },
  {
    sortOrder: 75,
    selectable: true,
    destinationUrlName: 'Zhangye',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4434.36667',
    parentId: 4434,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Zhangye',
    destinationId: 36667,
    latitude: 38.9177536,
    longitude: 100.3312612,
  },
  {
    sortOrder: 76,
    selectable: true,
    destinationUrlName: 'Zhanjiang',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4443.40037',
    parentId: 4443,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Zhanjiang',
    destinationId: 40037,
    latitude: 21.0980044,
    longitude: 110.2018895,
  },
  {
    sortOrder: 77,
    selectable: true,
    destinationUrlName: 'Zhengzhou',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4434.29047',
    parentId: 4434,
    timeZone: 'Asia/Shanghai',
    iataCode: 'CGO',
    destinationType: 'CITY',
    destinationName: 'Zhengzhou',
    destinationId: 29047,
    latitude: 34.74661,
    longitude: 113.62533,
  },
  {
    sortOrder: 78,
    selectable: true,
    destinationUrlName: 'Zhuhai',
    defaultCurrencyCode: 'USD',
    lookupId: '2.13.4443.39468',
    parentId: 4443,
    timeZone: 'Asia/Shanghai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Zhuhai',
    destinationId: 39468,
    latitude: 22.181609,
    longitude: 108.9040905,
  },
  {
    sortOrder: 48,
    selectable: true,
    destinationUrlName: 'Colombia',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4497',
    parentId: 9,
    timeZone: 'America/Bogota',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Colombia',
    destinationId: 4497,
    latitude: 4.570868,
    longitude: -74.297333,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Andes',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4497.29966',
    parentId: 4497,
    timeZone: 'America/Bogota',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Andes',
    destinationId: 29966,
    latitude: 5.65642,
    longitude: -75.87965,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Caribbean-Coast',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4497.25190',
    parentId: 4497,
    timeZone: 'America/Bogota',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Caribbean Coast',
    destinationId: 25190,
    latitude: 10.872848,
    longitude: -74.529689,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Armenia',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4497.29966.29967',
    parentId: 29966,
    timeZone: 'America/Bogota',
    iataCode: 'AXM',
    destinationType: 'CITY',
    destinationName: 'Armenia',
    destinationId: 29967,
    latitude: 4.535,
    longitude: -75.67569,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Barichara',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4497.51235',
    parentId: 4497,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Barichara',
    destinationId: 51235,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Barranquilla',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4497.25190.50228',
    parentId: 25190,
    timeZone: 'America/Bogota',
    iataCode: 'BAQ',
    destinationType: 'CITY',
    destinationName: 'Barranquilla',
    destinationId: 50228,
    latitude: 11.0041,
    longitude: -74.807,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Bogota',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4497.4560',
    parentId: 4497,
    timeZone: 'America/Bogota',
    iataCode: 'BOG',
    destinationType: 'CITY',
    destinationName: 'Bogotá',
    destinationId: 4560,
    latitude: 4.5980556,
    longitude: -74.0758333,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Bucaramanga',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4497.33622',
    parentId: 4497,
    timeZone: 'America/Bogota',
    iataCode: 'BGA',
    destinationType: 'CITY',
    destinationName: 'Bucaramanga',
    destinationId: 33622,
    latitude: 7.11912,
    longitude: -73.118645,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Cali',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4497.5562',
    parentId: 4497,
    timeZone: 'America/Bogota',
    iataCode: 'CLO',
    destinationType: 'CITY',
    destinationName: 'Cali',
    destinationId: 5562,
    latitude: 3.420556,
    longitude: -76.522222,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Cartagena',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4497.25190.4498',
    parentId: 25190,
    timeZone: 'America/Bogota',
    iataCode: 'CTG',
    destinationType: 'CITY',
    destinationName: 'Cartagena',
    destinationId: 4498,
    latitude: 10.3873369,
    longitude: -75.5196631,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Dagua',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4497.51162',
    parentId: 4497,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Dagua',
    destinationId: 51162,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Ibague',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4497.36192',
    parentId: 4497,
    timeZone: 'America/Bogota',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ibague',
    destinationId: 36192,
    latitude: 4.4122862,
    longitude: -75.2568182,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Isla-Baru',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4497.50395',
    parentId: 4497,
    timeZone: 'America/Bogota',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Isla Baru',
    destinationId: 50395,
    latitude: 10.1697,
    longitude: -75.6573,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Jardin',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4497.50394',
    parentId: 4497,
    timeZone: 'America/Bogota',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Jardin',
    destinationId: 50394,
    latitude: 5.5968,
    longitude: -75.8194,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Leticia',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4497.51209',
    parentId: 4497,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Leticia',
    destinationId: 51209,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Manizales',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4497.29966.50311',
    parentId: 29966,
    timeZone: 'America/Bogota',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Manizales',
    destinationId: 50311,
    latitude: 5.063,
    longitude: -75.5028,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Medellin',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4497.4563',
    parentId: 4497,
    timeZone: 'America/Bogota',
    iataCode: 'MDE',
    destinationType: 'CITY',
    destinationName: 'Medellín',
    destinationId: 4563,
    latitude: 6.235925,
    longitude: -75.575137,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Neiva',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4497.50398',
    parentId: 4497,
    timeZone: 'America/Bogota',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Neiva',
    destinationId: 50398,
    latitude: 2.9345,
    longitude: -75.2809,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Pasto',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4497.50400',
    parentId: 4497,
    timeZone: 'America/Bogota',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Pasto',
    destinationId: 50400,
    latitude: 1.2059,
    longitude: -77.2858,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Pereira',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4497.28161',
    parentId: 4497,
    timeZone: 'America/Bogota',
    iataCode: 'PEI',
    destinationType: 'CITY',
    destinationName: 'Pereira',
    destinationId: 28161,
    latitude: 4.80872,
    longitude: -75.6906,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Riohacha',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4497.25190.50229',
    parentId: 25190,
    timeZone: 'America/Bogota',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Riohacha',
    destinationId: 50229,
    latitude: 11.5384,
    longitude: -72.9168,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Salento',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4497.26165',
    parentId: 4497,
    timeZone: 'Europe/Rome',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Salento',
    destinationId: 26165,
    latitude: 40.250401,
    longitude: 15.197395,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'San-Agustin',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4497.51261',
    parentId: 4497,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'San Agustin',
    destinationId: 51261,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'San-Andres',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4497.28673',
    parentId: 4497,
    timeZone: 'America/Bogota',
    iataCode: 'ADZ',
    destinationType: 'CITY',
    destinationName: 'San Andrés',
    destinationId: 28673,
    latitude: 12.57685,
    longitude: -81.70505,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'San-Gil',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4497.50399',
    parentId: 4497,
    timeZone: 'America/Bogota',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'San Gil',
    destinationId: 50399,
    latitude: 6.5548,
    longitude: -73.1341,
  },
  {
    sortOrder: 23,
    selectable: true,
    destinationUrlName: 'Santa-Marta',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4497.25190.4520',
    parentId: 25190,
    timeZone: 'America/Bogota',
    iataCode: 'SMR',
    destinationType: 'CITY',
    destinationName: 'Santa Marta',
    destinationId: 4520,
    latitude: 11.241944,
    longitude: -74.205278,
  },
  {
    sortOrder: 24,
    selectable: true,
    destinationUrlName: 'Villa-de-Leyva',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4497.50397',
    parentId: 4497,
    timeZone: 'America/Bogota',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Villa de Leyva',
    destinationId: 50397,
    latitude: 5.6365,
    longitude: -73.5271,
  },
  {
    sortOrder: 49,
    selectable: true,
    destinationUrlName: 'Comoros',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21935',
    parentId: 1,
    timeZone: 'Indian/Comoro',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Comoros',
    destinationId: 21935,
    latitude: -11.875,
    longitude: 43.8722,
  },
  {
    sortOrder: 50,
    selectable: true,
    destinationUrlName: 'Congo',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21888',
    parentId: 1,
    timeZone: 'Africa/Brazzaville',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Congo',
    destinationId: 21888,
    latitude: -0.228,
    longitude: 15.8277,
  },
  {
    sortOrder: 51,
    selectable: true,
    destinationUrlName: 'Cook-Islands',
    defaultCurrencyCode: 'USD',
    lookupId: '3.4788',
    parentId: 3,
    timeZone: 'Pacific/Rarotonga',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Cook Islands',
    destinationId: 4788,
    latitude: -21.2367,
    longitude: -159.7777,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Rarotonga',
    defaultCurrencyCode: 'USD',
    lookupId: '3.4788.22128',
    parentId: 4788,
    timeZone: 'Pacific/Rarotonga',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Rarotonga',
    destinationId: 22128,
    latitude: -21.2357288,
    longitude: -159.8477664,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Avarua',
    defaultCurrencyCode: 'USD',
    lookupId: '3.4788.22128.22211',
    parentId: 22128,
    timeZone: 'Pacific/Rarotonga',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Avarua',
    destinationId: 22211,
    latitude: -21.212495,
    longitude: -159.777733,
  },
  {
    sortOrder: 52,
    selectable: true,
    destinationUrlName: 'Costa-Rica',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747',
    parentId: 9,
    timeZone: 'America/Costa_Rica',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Costa Rica',
    destinationId: 747,
    latitude: 9.748917,
    longitude: -83.753428,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Caribbean-Coast',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747.22694',
    parentId: 747,
    timeZone: 'America/Costa_Rica',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Caribbean Coast',
    destinationId: 22694,
    latitude: 9.771669,
    longitude: -82.892532,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Central-Pacific',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747.4139',
    parentId: 747,
    timeZone: 'America/Costa_Rica',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Central Pacific',
    destinationId: 4139,
    latitude: 9.6183522091,
    longitude: -84.6276855469,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Central-Valley',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747.22695',
    parentId: 747,
    timeZone: 'America/Costa_Rica',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Central Valley',
    destinationId: 22695,
    latitude: 9.732648,
    longitude: -83.701358,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Guanacaste-and-Northwest',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747.4137',
    parentId: 747,
    timeZone: 'America/Costa_Rica',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Guanacaste and Northwest',
    destinationId: 4137,
    latitude: 10.4957971,
    longitude: -85.354965,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Nicoya-Peninsula',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747.22697',
    parentId: 747,
    timeZone: 'America/Costa_Rica',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Nicoya Peninsula',
    destinationId: 22697,
    latitude: 9.9453082,
    longitude: -85.9345109,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Osa-Peninsula-and-Gulfo-Dulce',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747.22696',
    parentId: 747,
    timeZone: 'America/Costa_Rica',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Osa Peninsula & Gulfo Dulce',
    destinationId: 22696,
    latitude: 8.55,
    longitude: -83.5,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Alajuela',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747.22695.50231',
    parentId: 22695,
    timeZone: 'America/Costa_Rica',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Alajuela',
    destinationId: 50231,
    latitude: 10.0159,
    longitude: -84.2142,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Corcovado-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747.51431',
    parentId: 747,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Corcovado National Park',
    destinationId: 51431,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Drake-Bay',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747.22696.762',
    parentId: 22696,
    timeZone: 'America/Costa_Rica',
    iataCode: 'DRK',
    destinationType: 'CITY',
    destinationName: 'Drake Bay',
    destinationId: 762,
    latitude: 8.703688,
    longitude: -83.648432,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Jaco',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747.4139.4144',
    parentId: 4139,
    timeZone: 'America/Costa_Rica',
    iataCode: 'XQP',
    destinationType: 'CITY',
    destinationName: 'Jaco',
    destinationId: 4144,
    latitude: 9.6166667,
    longitude: -84.6333333,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'La-Fortuna',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747.22695.821',
    parentId: 22695,
    timeZone: 'America/Guatemala',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'La Fortuna',
    destinationId: 821,
    latitude: 10.4699398,
    longitude: -84.657898,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'La-Fortuna-de-San-Carlos',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747.50401',
    parentId: 747,
    timeZone: 'America/Costa_Rica',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'La Fortuna de San Carlos',
    destinationId: 50401,
    latitude: 10.4678,
    longitude: -84.6427,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Liberia',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747.4137.22740',
    parentId: 4137,
    timeZone: 'America/Costa_Rica',
    iataCode: 'LIR',
    destinationType: 'CITY',
    destinationName: 'Liberia',
    destinationId: 22740,
    latitude: 10.634982,
    longitude: -85.440589,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Limon',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747.22694.4513',
    parentId: 22694,
    timeZone: 'America/Costa_Rica',
    iataCode: 'LIO',
    destinationType: 'CITY',
    destinationName: 'Limon',
    destinationId: 4513,
    latitude: 9.99131,
    longitude: -83.04151,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Miramar',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747.4139.50313',
    parentId: 4139,
    timeZone: 'America/Costa_Rica',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Miramar',
    destinationId: 50313,
    latitude: 10.0833,
    longitude: -84.7293,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Monteverde',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747.4139.24783',
    parentId: 4139,
    timeZone: 'America/Costa_Rica',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Monteverde',
    destinationId: 24783,
    latitude: 10.27497,
    longitude: -84.82551,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Orotina',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747.22695.51135',
    parentId: 22695,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Orotina',
    destinationId: 51135,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Playa-Flamingo',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747.4137.24471',
    parentId: 4137,
    timeZone: 'America/Costa_Rica',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Playa Flamingo',
    destinationId: 24471,
    latitude: 10.4314,
    longitude: -85.784265,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Playa-Hermosa',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747.4137.24946',
    parentId: 4137,
    timeZone: 'America/Costa_Rica',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Playa Hermosa',
    destinationId: 24946,
    latitude: 10.570298,
    longitude: -85.675284,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Puerto-Jimenez',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747.22696.23316',
    parentId: 22696,
    timeZone: 'America/Costa_Rica',
    iataCode: 'PJM',
    destinationType: 'CITY',
    destinationName: 'Puerto Jiménez',
    destinationId: 23316,
    latitude: 8.527274,
    longitude: -83.303112,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Puntarenas',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747.4139.4506',
    parentId: 4139,
    timeZone: 'America/Costa_Rica',
    iataCode: 'NCT',
    destinationType: 'CITY',
    destinationName: 'Puntarenas',
    destinationId: 4506,
    latitude: 9.97784,
    longitude: -84.82942,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Quepos',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747.4139.4507',
    parentId: 4139,
    timeZone: 'America/Costa_Rica',
    iataCode: 'XQP',
    destinationType: 'CITY',
    destinationName: 'Quepos',
    destinationId: 4507,
    latitude: 9.43183,
    longitude: -84.161018,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Samara',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747.4137.24505',
    parentId: 4137,
    timeZone: 'America/Costa_Rica',
    iataCode: 'KUF',
    destinationType: 'CITY',
    destinationName: 'Sámara',
    destinationId: 24505,
    latitude: 9.881815,
    longitude: -85.528618,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'San-Antonio-De-Belen',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747.50316',
    parentId: 747,
    timeZone: 'America/Costa_Rica',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'San Antonio De Belen',
    destinationId: 50316,
    latitude: 9.98,
    longitude: -84.1853,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'San-Jose',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747.22695.793',
    parentId: 22695,
    timeZone: 'America/Costa_Rica',
    iataCode: 'SJO',
    destinationType: 'CITY',
    destinationName: 'San Jose',
    destinationId: 793,
    latitude: 9.9333333,
    longitude: -84.0833333,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Santa-Cruz',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747.4137.50483',
    parentId: 4137,
    timeZone: 'America/Costa_Rica',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Santa Cruz',
    destinationId: 50483,
    latitude: 10.26532,
    longitude: -85.580193,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Santa-Teresa',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747.4139.25896',
    parentId: 4139,
    timeZone: 'America/Costa_Rica',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Santa Teresa',
    destinationId: 25896,
    latitude: 9.646044,
    longitude: -85.167132,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'Sarapiqui',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747.22695.51428',
    parentId: 22695,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sarapiqui',
    destinationId: 51428,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 23,
    selectable: true,
    destinationUrlName: 'Sierpe',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747.4139.51432',
    parentId: 4139,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sierpe',
    destinationId: 51432,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 24,
    selectable: true,
    destinationUrlName: 'Siquirres',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747.50396',
    parentId: 747,
    timeZone: 'America/Costa_Rica',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Siquirres',
    destinationId: 50396,
    latitude: 10.0981,
    longitude: -83.5097,
  },
  {
    sortOrder: 25,
    selectable: true,
    destinationUrlName: 'Tamarindo',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747.4137.24763',
    parentId: 4137,
    timeZone: 'America/Costa_Rica',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tamarindo',
    destinationId: 24763,
    latitude: 10.299284,
    longitude: -85.837609,
  },
  {
    sortOrder: 26,
    selectable: true,
    destinationUrlName: 'Tortuguero',
    defaultCurrencyCode: 'USD',
    lookupId: '9.747.22694.50227',
    parentId: 22694,
    timeZone: 'America/Costa_Rica',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tortuguero',
    destinationId: 50227,
    latitude: 10.5425,
    longitude: -83.5024,
  },
  {
    sortOrder: 53,
    selectable: true,
    destinationUrlName: 'Croatia',
    defaultCurrencyCode: 'USD',
    lookupId: '6.730',
    parentId: 6,
    timeZone: 'Europe/Zagreb',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Croatia',
    destinationId: 730,
    latitude: 45.1,
    longitude: 15.2,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Central-Croatia',
    defaultCurrencyCode: 'USD',
    lookupId: '6.730.27085',
    parentId: 730,
    timeZone: 'Europe/Zagreb',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Central Croatia',
    destinationId: 27085,
    latitude: 45.13639,
    longitude: 14.165,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Dalmatia',
    defaultCurrencyCode: 'USD',
    lookupId: '6.730.28790',
    parentId: 730,
    timeZone: 'Europe/Zagreb',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Dalmatia',
    destinationId: 28790,
    latitude: 43.52403,
    longitude: 16.81784,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Istria',
    defaultCurrencyCode: 'USD',
    lookupId: '6.730.22139',
    parentId: 730,
    timeZone: 'Europe/Zagreb',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Istria',
    destinationId: 22139,
    latitude: 45.1870329,
    longitude: 13.3486117,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Kvarner',
    defaultCurrencyCode: 'USD',
    lookupId: '6.730.22827',
    parentId: 730,
    timeZone: 'Europe/Zagreb',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Kvarner',
    destinationId: 22827,
    latitude: 45.1818,
    longitude: 14.6839,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Brac-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '6.730.28790.50330',
    parentId: 28790,
    timeZone: 'Europe/Zagreb',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Brac Island',
    destinationId: 50330,
    latitude: 43.3049,
    longitude: 16.6527,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Ciovo-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '6.730.28790.50402',
    parentId: 28790,
    timeZone: 'Europe/Zagreb',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ciovo Island',
    destinationId: 50402,
    latitude: 43.4997,
    longitude: 16.2875,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Dubrovnik',
    defaultCurrencyCode: 'USD',
    lookupId: '6.730.28790.904',
    parentId: 28790,
    timeZone: 'Europe/Zagreb',
    iataCode: 'DBV',
    destinationType: 'CITY',
    destinationName: 'Dubrovnik',
    destinationId: 904,
    latitude: 42.6590223479,
    longitude: 18.083024025,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Hvar',
    defaultCurrencyCode: 'USD',
    lookupId: '6.730.28790.22146',
    parentId: 28790,
    timeZone: 'Europe/Zagreb',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Hvar',
    destinationId: 22146,
    latitude: 43.17295,
    longitude: 16.44111,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Korcula',
    defaultCurrencyCode: 'USD',
    lookupId: '6.730.28790.22559',
    parentId: 28790,
    timeZone: 'Europe/Zagreb',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Korcula',
    destinationId: 22559,
    latitude: 42.96005,
    longitude: 17.13799,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Korcula-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '6.730.50232',
    parentId: 730,
    timeZone: 'Europe/Zagreb',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Korcula Island',
    destinationId: 50232,
    latitude: 42.9297,
    longitude: 16.8886,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Krka-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '6.730.28790.51287',
    parentId: 28790,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Krka National Park',
    destinationId: 51287,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Krk-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '6.730.22827.50234',
    parentId: 22827,
    timeZone: 'Europe/Zagreb',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Krk Island',
    destinationId: 50234,
    latitude: 45.026199,
    longitude: 14.57334,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Makarska',
    defaultCurrencyCode: 'USD',
    lookupId: '6.730.28790.31483',
    parentId: 28790,
    timeZone: 'Europe/Zagreb',
    iataCode: 'BWK',
    destinationType: 'CITY',
    destinationName: 'Makarska',
    destinationId: 31483,
    latitude: 43.29378,
    longitude: 17.02152,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Osijek',
    defaultCurrencyCode: 'USD',
    lookupId: '6.730.51270',
    parentId: 730,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Osijek',
    destinationId: 51270,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Plitvice-Lakes-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '6.730.27085.27086',
    parentId: 27085,
    timeZone: 'Europe/Zagreb',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Plitvice Lakes National Park',
    destinationId: 27086,
    latitude: 44.8654,
    longitude: 15.58201,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Porec',
    defaultCurrencyCode: 'USD',
    lookupId: '6.730.22139.33603',
    parentId: 22139,
    timeZone: 'Europe/Zagreb',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Porec',
    destinationId: 33603,
    latitude: 45.227029,
    longitude: 13.595098,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Pula',
    defaultCurrencyCode: 'USD',
    lookupId: '6.730.22139.22140',
    parentId: 22139,
    timeZone: 'Europe/Zagreb',
    iataCode: 'PUY',
    destinationType: 'CITY',
    destinationName: 'Pula',
    destinationId: 22140,
    latitude: 44.866413,
    longitude: 13.850551,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Rab',
    defaultCurrencyCode: 'USD',
    lookupId: '6.730.22827.22836',
    parentId: 22827,
    timeZone: 'Europe/Zagreb',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Rab',
    destinationId: 22836,
    latitude: 44.756862,
    longitude: 14.759726,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Rovinj',
    defaultCurrencyCode: 'USD',
    lookupId: '6.730.22139.32799',
    parentId: 22139,
    timeZone: 'Europe/Zagreb',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Rovinj',
    destinationId: 32799,
    latitude: 45.081023,
    longitude: 13.639539,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Sibenik',
    defaultCurrencyCode: 'USD',
    lookupId: '6.730.28790.28791',
    parentId: 28790,
    timeZone: 'Europe/Zagreb',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Šibenik',
    destinationId: 28791,
    latitude: 43.73502,
    longitude: 15.8952,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Split',
    defaultCurrencyCode: 'USD',
    lookupId: '6.730.28790.4185',
    parentId: 28790,
    timeZone: 'Europe/Zagreb',
    iataCode: 'SPU',
    destinationType: 'CITY',
    destinationName: 'Split',
    destinationId: 4185,
    latitude: 43.5139,
    longitude: 16.4558,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Trogir',
    defaultCurrencyCode: 'USD',
    lookupId: '6.730.28790.36946',
    parentId: 28790,
    timeZone: 'Europe/Zagreb',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Trogir',
    destinationId: 36946,
    latitude: 43.5279735,
    longitude: 16.2414168,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Zadar',
    defaultCurrencyCode: 'USD',
    lookupId: '6.730.28790.22433',
    parentId: 28790,
    timeZone: 'Europe/Zagreb',
    iataCode: 'ZAD',
    destinationType: 'CITY',
    destinationName: 'Zadar',
    destinationId: 22433,
    latitude: 44.11937,
    longitude: 15.23136,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Zagreb',
    defaultCurrencyCode: 'USD',
    lookupId: '6.730.5391',
    parentId: 730,
    timeZone: 'Europe/Zagreb',
    iataCode: 'ZAG',
    destinationType: 'CITY',
    destinationName: 'Zagreb',
    destinationId: 5391,
    latitude: 45.8167,
    longitude: 15.9833,
  },
  {
    sortOrder: 54,
    selectable: true,
    destinationUrlName: 'Curacao',
    defaultCurrencyCode: 'USD',
    lookupId: '4.725',
    parentId: 4,
    timeZone: 'America/Curacao',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Curacao',
    destinationId: 725,
    latitude: 12.1224221,
    longitude: -68.8824233,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Willemstad',
    defaultCurrencyCode: 'USD',
    lookupId: '4.725.50233',
    parentId: 725,
    timeZone: 'America/Curacao',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Willemstad',
    destinationId: 50233,
    latitude: 12.1224,
    longitude: -68.8824,
  },
  {
    sortOrder: 55,
    selectable: true,
    destinationUrlName: 'Cyprus',
    defaultCurrencyCode: 'USD',
    lookupId: '6.47',
    parentId: 6,
    timeZone: 'Asia/Nicosia',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Cyprus',
    destinationId: 47,
    latitude: 35.126413,
    longitude: 33.429859,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Famagusta-District',
    defaultCurrencyCode: 'USD',
    lookupId: '6.47.31180',
    parentId: 47,
    timeZone: 'Asia/Famagusta',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Famagusta District',
    destinationId: 31180,
    latitude: 35.2857,
    longitude: 33.84113,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Ayia-Napa',
    defaultCurrencyCode: 'USD',
    lookupId: '6.47.31180.31182',
    parentId: 31180,
    timeZone: 'Asia/Famagusta',
    iataCode: 'QNP',
    destinationType: 'CITY',
    destinationName: 'Ayia Napa',
    destinationId: 31182,
    latitude: 34.99228,
    longitude: 34.01401,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Famagusta',
    defaultCurrencyCode: 'USD',
    lookupId: '6.47.31180.27236',
    parentId: 31180,
    timeZone: 'Asia/Famagusta',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Famagusta',
    destinationId: 27236,
    latitude: 35.2857,
    longitude: 33.84113,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Kyrenia',
    defaultCurrencyCode: 'USD',
    lookupId: '6.47.27760',
    parentId: 47,
    timeZone: 'Asia/Famagusta',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kyrenia',
    destinationId: 27760,
    latitude: 35.29919,
    longitude: 33.23632,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Larnaca',
    defaultCurrencyCode: 'USD',
    lookupId: '6.47.22376',
    parentId: 47,
    timeZone: 'Asia/Nicosia',
    iataCode: 'LCA',
    destinationType: 'CITY',
    destinationName: 'Larnaca',
    destinationId: 22376,
    latitude: 34.902708,
    longitude: 33.624044,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Limassol',
    defaultCurrencyCode: 'USD',
    lookupId: '6.47.4429',
    parentId: 47,
    timeZone: 'Asia/Nicosia',
    iataCode: 'QLI',
    destinationType: 'CITY',
    destinationName: 'Limassol',
    destinationId: 4429,
    latitude: 34.70713,
    longitude: 33.02262,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Nicosia',
    defaultCurrencyCode: 'USD',
    lookupId: '6.47.26434',
    parentId: 47,
    timeZone: 'Asia/Nicosia',
    iataCode: 'NIC',
    destinationType: 'CITY',
    destinationName: 'Nicosia',
    destinationId: 26434,
    latitude: 35.186621,
    longitude: 33.382893,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Paphos',
    defaultCurrencyCode: 'USD',
    lookupId: '6.47.5629',
    parentId: 47,
    timeZone: 'Europe/Athens',
    iataCode: 'PFO',
    destinationType: 'CITY',
    destinationName: 'Paphos',
    destinationId: 5629,
    latitude: 34.772013,
    longitude: 32.429737,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Protaras',
    defaultCurrencyCode: 'USD',
    lookupId: '6.47.31180.31181',
    parentId: 31180,
    timeZone: 'Asia/Famagusta',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Protaras',
    destinationId: 31181,
    latitude: 35.00118,
    longitude: 34.04743,
  },
  {
    sortOrder: 56,
    selectable: true,
    destinationUrlName: 'Czech-Republic',
    defaultCurrencyCode: 'USD',
    lookupId: '6.48',
    parentId: 6,
    timeZone: 'Europe/Prague',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Czech Republic',
    destinationId: 48,
    latitude: 49.817492,
    longitude: 15.472962,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Bohemia',
    defaultCurrencyCode: 'USD',
    lookupId: '6.48.22153',
    parentId: 48,
    timeZone: 'Europe/Prague',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Bohemia',
    destinationId: 22153,
    latitude: 50.08507,
    longitude: 14.43287,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Moravia',
    defaultCurrencyCode: 'USD',
    lookupId: '6.48.26300',
    parentId: 48,
    timeZone: 'Europe/Prague',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Moravia',
    destinationId: 26300,
    latitude: 49.194918,
    longitude: 16.60945,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Brno',
    defaultCurrencyCode: 'USD',
    lookupId: '6.48.26300.26301',
    parentId: 26300,
    timeZone: 'Europe/Prague',
    iataCode: 'BRQ',
    destinationType: 'CITY',
    destinationName: 'Brno',
    destinationId: 26301,
    latitude: 49.2004,
    longitude: 16.61,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Cesky-Krumlov',
    defaultCurrencyCode: 'USD',
    lookupId: '6.48.22153.22456',
    parentId: 22153,
    timeZone: 'Europe/Prague',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cesky Krumlov',
    destinationId: 22456,
    latitude: 48.813037,
    longitude: 14.324287,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Karlovy-Vary',
    defaultCurrencyCode: 'USD',
    lookupId: '6.48.22153.32983',
    parentId: 22153,
    timeZone: 'Europe/Prague',
    iataCode: 'KLV',
    destinationType: 'CITY',
    destinationName: 'Karlovy Vary',
    destinationId: 32983,
    latitude: 50.231701,
    longitude: 12.870063,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Pilsen',
    defaultCurrencyCode: 'USD',
    lookupId: '6.48.22153.31166',
    parentId: 22153,
    timeZone: 'Europe/Prague',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Pilsen',
    destinationId: 31166,
    latitude: 49.738808,
    longitude: 13.374148,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Prague',
    defaultCurrencyCode: 'USD',
    lookupId: '6.48.462',
    parentId: 48,
    timeZone: 'Europe/Prague',
    iataCode: 'PRG',
    destinationType: 'CITY',
    destinationName: 'Prague',
    destinationId: 462,
    latitude: 50.0878114,
    longitude: 14.4204598,
  },
  {
    sortOrder: 57,
    selectable: true,
    destinationUrlName: 'Cote-dIvoire',
    defaultCurrencyCode: 'USD',
    lookupId: '1.26731',
    parentId: 1,
    timeZone: 'Africa/Abidjan',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Côte d’Ivoire',
    destinationId: 26731,
    latitude: 7.53999,
    longitude: -5.54708,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Abidjan',
    defaultCurrencyCode: 'USD',
    lookupId: '1.26731.26753',
    parentId: 26731,
    timeZone: 'Africa/Abidjan',
    iataCode: 'ABJ',
    destinationType: 'CITY',
    destinationName: 'Abidjan',
    destinationId: 26753,
    latitude: 5.35995,
    longitude: -4.00826,
  },
  {
    sortOrder: 58,
    selectable: true,
    destinationUrlName: 'Democratic-Republic-of-Congo',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21933',
    parentId: 1,
    timeZone: 'Africa/Lubumbashi',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Democratic Republic of Congo',
    destinationId: 21933,
    latitude: -4.0383,
    longitude: 21.7587,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Goma',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21933.51605',
    parentId: 21933,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Goma',
    destinationId: 51605,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Lubumbashi',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21933.51760',
    parentId: 21933,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Lubumbashi',
    destinationId: 51760,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Kinshasa',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21933.34417',
    parentId: 21933,
    timeZone: 'Africa/Kinshasa',
    iataCode: 'FIH',
    destinationType: 'CITY',
    destinationName: 'Kinshasa',
    destinationId: 34417,
    latitude: -4.443117,
    longitude: 15.262688,
  },
  {
    sortOrder: 59,
    selectable: true,
    destinationUrlName: 'Denmark',
    defaultCurrencyCode: 'USD',
    lookupId: '6.49',
    parentId: 6,
    timeZone: 'Europe/Copenhagen',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Denmark',
    destinationId: 49,
    latitude: 56.26392,
    longitude: 9.501785,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Aalborg',
    defaultCurrencyCode: 'USD',
    lookupId: '6.49.4186',
    parentId: 49,
    timeZone: 'Europe/Copenhagen',
    iataCode: 'AAL',
    destinationType: 'CITY',
    destinationName: 'Aalborg',
    destinationId: 4186,
    latitude: 57.04882,
    longitude: 9.921747,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Aarhus',
    defaultCurrencyCode: 'USD',
    lookupId: '6.49.4187',
    parentId: 49,
    timeZone: 'Europe/Copenhagen',
    iataCode: 'AAR',
    destinationType: 'CITY',
    destinationName: 'Aarhus',
    destinationId: 4187,
    latitude: 56.16294,
    longitude: 10.20392,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Aeroskobing',
    defaultCurrencyCode: 'USD',
    lookupId: '6.49.4946',
    parentId: 49,
    timeZone: 'Europe/Copenhagen',
    iataCode: 'ODE',
    destinationType: 'CITY',
    destinationName: 'Aeroskobing',
    destinationId: 4946,
    latitude: 54.891456,
    longitude: 10.404684,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Billund',
    defaultCurrencyCode: 'USD',
    lookupId: '6.49.33140',
    parentId: 49,
    timeZone: 'Europe/Copenhagen',
    iataCode: 'BLL',
    destinationType: 'CITY',
    destinationName: 'Billund',
    destinationId: 33140,
    latitude: 55.728635,
    longitude: 9.112189,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Copenhagen',
    defaultCurrencyCode: 'USD',
    lookupId: '6.49.463',
    parentId: 49,
    timeZone: 'Europe/Copenhagen',
    iataCode: 'CPH',
    destinationType: 'CITY',
    destinationName: 'Copenhagen',
    destinationId: 463,
    latitude: 55.686004333,
    longitude: 12.6007175446,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Helsingor',
    defaultCurrencyCode: 'USD',
    lookupId: '6.49.25614',
    parentId: 49,
    timeZone: 'Europe/Copenhagen',
    iataCode: 'AGH',
    destinationType: 'CITY',
    destinationName: 'Helsingør',
    destinationId: 25614,
    latitude: 56.0345,
    longitude: 12.6136,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Torshavn',
    defaultCurrencyCode: 'USD',
    lookupId: '6.49.4191',
    parentId: 49,
    timeZone: 'Etc/GMT',
    iataCode: 'FAE',
    destinationType: 'CITY',
    destinationName: 'Torshavn',
    destinationId: 4191,
    latitude: 62.007864,
    longitude: -6.790982,
  },
  {
    sortOrder: 60,
    selectable: true,
    destinationUrlName: 'Djibouti',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4580',
    parentId: 1,
    timeZone: 'Africa/Djibouti',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Djibouti',
    destinationId: 4580,
    latitude: 11.8251,
    longitude: 42.5903,
  },
  {
    sortOrder: 61,
    selectable: true,
    destinationUrlName: 'Dominica',
    defaultCurrencyCode: 'USD',
    lookupId: '4.814',
    parentId: 4,
    timeZone: 'America/Dominica',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Dominica',
    destinationId: 814,
    latitude: 15.414999,
    longitude: -61.370976,
  },
  {
    sortOrder: 62,
    selectable: true,
    destinationUrlName: 'Dominican-Republic',
    defaultCurrencyCode: 'USD',
    lookupId: '4.32',
    parentId: 4,
    timeZone: 'America/Santo_Domingo',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Dominican Republic',
    destinationId: 32,
    latitude: 18.735693,
    longitude: -70.162651,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Barahona',
    defaultCurrencyCode: 'USD',
    lookupId: '4.32.50403',
    parentId: 32,
    timeZone: 'America/Santo_Domingo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Barahona',
    destinationId: 50403,
    latitude: 18.2121,
    longitude: -71.1024,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Cabarete',
    defaultCurrencyCode: 'USD',
    lookupId: '4.32.31317',
    parentId: 32,
    timeZone: 'America/Santo_Domingo',
    iataCode: 'POP',
    destinationType: 'CITY',
    destinationName: 'Cabarete',
    destinationId: 31317,
    latitude: 19.75092,
    longitude: -70.41442,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'La-Romana',
    defaultCurrencyCode: 'USD',
    lookupId: '4.32.4176',
    parentId: 32,
    timeZone: 'America/Santo_Domingo',
    iataCode: 'LRM',
    destinationType: 'CITY',
    destinationName: 'La Romana',
    destinationId: 4176,
    latitude: 18.4300000017,
    longitude: -68.97,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Las-Terrenas',
    defaultCurrencyCode: 'USD',
    lookupId: '4.32.24290',
    parentId: 32,
    timeZone: 'America/Santo_Domingo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Las Terrenas',
    destinationId: 24290,
    latitude: 19.299599,
    longitude: -69.556049,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Puerto-Plata',
    defaultCurrencyCode: 'USD',
    lookupId: '4.32.795',
    parentId: 32,
    timeZone: 'America/Santo_Domingo',
    iataCode: 'POP',
    destinationType: 'CITY',
    destinationName: 'Puerto Plata',
    destinationId: 795,
    latitude: 19.7807686,
    longitude: -70.6871091,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Punta-Cana',
    defaultCurrencyCode: 'USD',
    lookupId: '4.32.794',
    parentId: 32,
    timeZone: 'America/Santo_Domingo',
    iataCode: 'PUJ',
    destinationType: 'CITY',
    destinationName: 'Punta Cana',
    destinationId: 794,
    latitude: 18.5333333,
    longitude: -68.3666667,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Samana',
    defaultCurrencyCode: 'USD',
    lookupId: '4.32.4177',
    parentId: 32,
    timeZone: 'America/Santo_Domingo',
    iataCode: 'EPS',
    destinationType: 'CITY',
    destinationName: 'Samaná',
    destinationId: 4177,
    latitude: 19.2116599,
    longitude: -69.332314,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Santo-Domingo',
    defaultCurrencyCode: 'USD',
    lookupId: '4.32.5622',
    parentId: 32,
    timeZone: 'America/Santo_Domingo',
    iataCode: 'SDQ',
    destinationType: 'CITY',
    destinationName: 'Santo Domingo',
    destinationId: 5622,
    latitude: 18.466667,
    longitude: -69.95,
  },
  {
    sortOrder: 63,
    selectable: true,
    destinationUrlName: 'East-Timor',
    defaultCurrencyCode: 'USD',
    lookupId: '3.27539',
    parentId: 3,
    timeZone: 'Asia/Dili',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'East Timor',
    destinationId: 27539,
    latitude: -8.87422,
    longitude: 125.72754,
  },
  {
    sortOrder: 64,
    selectable: true,
    destinationUrlName: 'Ecuador',
    defaultCurrencyCode: 'USD',
    lookupId: '9.727',
    parentId: 9,
    timeZone: 'America/Guayaquil',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Ecuador',
    destinationId: 727,
    latitude: -1.831239,
    longitude: -78.183406,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Amazon',
    defaultCurrencyCode: 'USD',
    lookupId: '9.727.24113',
    parentId: 727,
    timeZone: 'America/Guayaquil',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Amazon',
    destinationId: 24113,
    latitude: -1.83124,
    longitude: -78.18341,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Galapagos-Islands',
    defaultCurrencyCode: 'USD',
    lookupId: '9.727.936',
    parentId: 727,
    timeZone: 'Pacific/Galapagos',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Galapagos Islands',
    destinationId: 936,
    latitude: -0.833333,
    longitude: -89.4333,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Saquisili',
    defaultCurrencyCode: 'USD',
    lookupId: '9.727.51189.51519',
    parentId: 51189,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Saquisili',
    destinationId: 51519,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Banos',
    defaultCurrencyCode: 'USD',
    lookupId: '9.727.22150',
    parentId: 727,
    timeZone: 'America/Guayaquil',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Baños',
    destinationId: 22150,
    latitude: -1.39283,
    longitude: -78.42688,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Chimborazo-Province',
    defaultCurrencyCode: 'USD',
    lookupId: '9.727.51190',
    parentId: 727,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Chimborazo Province',
    destinationId: 51190,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Coca',
    defaultCurrencyCode: 'USD',
    lookupId: '9.727.51310',
    parentId: 727,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Coca',
    destinationId: 51310,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Cotopaxi-Province',
    defaultCurrencyCode: 'USD',
    lookupId: '9.727.51189',
    parentId: 727,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cotopaxi Province',
    destinationId: 51189,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Cotopaxi-Province',
    defaultCurrencyCode: 'USD',
    lookupId: '9.727.51236',
    parentId: 727,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cotopaxi Province',
    destinationId: 51236,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Cuenca',
    defaultCurrencyCode: 'USD',
    lookupId: '9.727.23726',
    parentId: 727,
    timeZone: 'America/Guayaquil',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cuenca',
    destinationId: 23726,
    latitude: -2.899939,
    longitude: -79.003589,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Guayaquil',
    defaultCurrencyCode: 'USD',
    lookupId: '9.727.4511',
    parentId: 727,
    timeZone: 'America/Guayaquil',
    iataCode: 'GYE',
    destinationType: 'CITY',
    destinationName: 'Guayaquil',
    destinationId: 4511,
    latitude: -2.152381,
    longitude: -80.1199484,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Isabela',
    defaultCurrencyCode: 'USD',
    lookupId: '9.727.50237',
    parentId: 727,
    timeZone: 'Pacific/Galapagos',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Isabela',
    destinationId: 50237,
    latitude: -0.8292,
    longitude: -91.1353,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Manta',
    defaultCurrencyCode: 'USD',
    lookupId: '9.727.4512',
    parentId: 727,
    timeZone: 'America/Guayaquil',
    iataCode: 'MEC',
    destinationType: 'CITY',
    destinationName: 'Manta',
    destinationId: 4512,
    latitude: -0.967451,
    longitude: -80.707928,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Mindo',
    defaultCurrencyCode: 'USD',
    lookupId: '9.727.33887',
    parentId: 727,
    timeZone: 'America/Guayaquil',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mindo',
    destinationId: 33887,
    latitude: -0.052043,
    longitude: -78.775992,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Nueva-Loja',
    defaultCurrencyCode: 'USD',
    lookupId: '9.727.50306',
    parentId: 727,
    timeZone: 'America/Guayaquil',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nueva Loja',
    destinationId: 50306,
    latitude: 0.0851,
    longitude: -76.894,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Otavalo',
    defaultCurrencyCode: 'USD',
    lookupId: '9.727.33748',
    parentId: 727,
    timeZone: 'America/Guayaquil',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Otavalo',
    destinationId: 33748,
    latitude: 0.234188,
    longitude: -78.260787,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Pastaza-Province',
    defaultCurrencyCode: 'USD',
    lookupId: '9.727.51393',
    parentId: 727,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Pastaza Province',
    destinationId: 51393,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Puerto-Ayora',
    defaultCurrencyCode: 'USD',
    lookupId: '9.727.50235',
    parentId: 727,
    timeZone: 'Pacific/Galapagos',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Puerto Ayora',
    destinationId: 50235,
    latitude: -0.7433,
    longitude: -90.3157,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Puerto-Lopez',
    defaultCurrencyCode: 'USD',
    lookupId: '9.727.36695',
    parentId: 727,
    timeZone: 'America/Guayaquil',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Puerto Lopez',
    destinationId: 36695,
    latitude: -1.5543746,
    longitude: -80.8162022,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Puerto-Villamil',
    defaultCurrencyCode: 'USD',
    lookupId: '9.727.936.50317',
    parentId: 936,
    timeZone: 'Pacific/Galapagos',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Puerto Villamil',
    destinationId: 50317,
    latitude: -0.9545,
    longitude: -90.9641,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Puyo',
    defaultCurrencyCode: 'USD',
    lookupId: '9.727.51393.52105',
    parentId: 51393,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Puyo',
    destinationId: 52105,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Quito',
    defaultCurrencyCode: 'USD',
    lookupId: '9.727.735',
    parentId: 727,
    timeZone: 'America/Guayaquil',
    iataCode: 'UIO',
    destinationType: 'CITY',
    destinationName: 'Quito',
    destinationId: 735,
    latitude: -0.229498,
    longitude: -78.524277,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Riobamba',
    defaultCurrencyCode: 'USD',
    lookupId: '9.727.51190.52103',
    parentId: 51190,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Riobamba',
    destinationId: 52103,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'San-Cristobal',
    defaultCurrencyCode: 'USD',
    lookupId: '9.727.50236',
    parentId: 727,
    timeZone: 'Pacific/Galapagos',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'San Cristobal',
    destinationId: 50236,
    latitude: -0.8675,
    longitude: -89.4364,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Santa-Cruz',
    defaultCurrencyCode: 'USD',
    lookupId: '9.727.936.50212',
    parentId: 936,
    timeZone: 'Pacific/Galapagos',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Santa Cruz',
    destinationId: 50212,
    latitude: -0.6394,
    longitude: -90.3372,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'Tena',
    defaultCurrencyCode: 'USD',
    lookupId: '9.727.24113.24270',
    parentId: 24113,
    timeZone: 'America/Guayaquil',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tena',
    destinationId: 24270,
    latitude: -0.996444,
    longitude: -77.812815,
  },
  {
    sortOrder: 23,
    selectable: true,
    destinationUrlName: 'Tungurahua-Province',
    defaultCurrencyCode: 'USD',
    lookupId: '9.727.51345',
    parentId: 727,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tungurahua Province',
    destinationId: 51345,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 65,
    selectable: true,
    destinationUrlName: 'Egypt',
    defaultCurrencyCode: 'USD',
    lookupId: '1.722',
    parentId: 1,
    timeZone: 'Africa/Cairo',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Egypt',
    destinationId: 722,
    latitude: 26.820553,
    longitude: 30.802498,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Red-Sea',
    defaultCurrencyCode: 'USD',
    lookupId: '1.722.24735',
    parentId: 722,
    timeZone: 'Africa/Cairo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Red Sea',
    destinationId: 24735,
    latitude: 28.13332,
    longitude: 33.928902,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Western-Desert',
    defaultCurrencyCode: 'USD',
    lookupId: '1.722.24114',
    parentId: 722,
    timeZone: 'Africa/Cairo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Western Desert',
    destinationId: 24114,
    latitude: 29.56963,
    longitude: 26.41939,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Abu-Simbel',
    defaultCurrencyCode: 'USD',
    lookupId: '1.722.50204',
    parentId: 722,
    timeZone: 'Africa/Cairo',
    iataCode: 'ABS',
    destinationType: 'CITY',
    destinationName: 'Abu Simbel',
    destinationId: 50204,
    latitude: 22.346,
    longitude: 31.6156,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Alexandria',
    defaultCurrencyCode: 'USD',
    lookupId: '1.722.4376',
    parentId: 722,
    timeZone: 'Africa/Cairo',
    iataCode: 'HBE',
    destinationType: 'CITY',
    destinationName: 'Alexandria',
    destinationId: 4376,
    latitude: 31.2455729,
    longitude: 29.9993086,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Aswan',
    defaultCurrencyCode: 'USD',
    lookupId: '1.722.796',
    parentId: 722,
    timeZone: 'Africa/Cairo',
    iataCode: 'ASW',
    destinationType: 'CITY',
    destinationName: 'Aswan',
    destinationId: 796,
    latitude: 24.0818,
    longitude: 32.9108,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Bawiti',
    defaultCurrencyCode: 'USD',
    lookupId: '1.722.50205',
    parentId: 722,
    timeZone: 'Africa/Cairo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bawiti',
    destinationId: 50205,
    latitude: 28.3497,
    longitude: 28.8631,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Cairo',
    defaultCurrencyCode: 'USD',
    lookupId: '1.722.782',
    parentId: 722,
    timeZone: 'Africa/Cairo',
    iataCode: 'CAI',
    destinationType: 'CITY',
    destinationName: 'Cairo',
    destinationId: 782,
    latitude: 30.064742,
    longitude: 31.249509,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Dahab',
    defaultCurrencyCode: 'USD',
    lookupId: '1.722.24528',
    parentId: 722,
    timeZone: 'Africa/Cairo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Dahab',
    destinationId: 24528,
    latitude: 28.50914,
    longitude: 34.51363,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Edfu',
    defaultCurrencyCode: 'USD',
    lookupId: '1.722.50238',
    parentId: 722,
    timeZone: 'Africa/Cairo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Edfu',
    destinationId: 50238,
    latitude: 24.9792,
    longitude: 32.8758,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'El-Alamein',
    defaultCurrencyCode: 'USD',
    lookupId: '1.722.50240',
    parentId: 722,
    timeZone: 'Africa/Cairo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'El Alamein',
    destinationId: 50240,
    latitude: 30.8225,
    longitude: 28.9543,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Giza',
    defaultCurrencyCode: 'USD',
    lookupId: '1.722.23032',
    parentId: 722,
    timeZone: 'Africa/Cairo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Giza',
    destinationId: 23032,
    latitude: 30.01306,
    longitude: 31.20885,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Hurghada',
    defaultCurrencyCode: 'USD',
    lookupId: '1.722.24735.800',
    parentId: 24735,
    timeZone: 'Africa/Cairo',
    iataCode: 'HRG',
    destinationType: 'CITY',
    destinationName: 'Hurghada',
    destinationId: 800,
    latitude: 27.2574,
    longitude: 33.8097,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Luxor',
    defaultCurrencyCode: 'USD',
    lookupId: '1.722.826',
    parentId: 722,
    timeZone: 'Africa/Cairo',
    iataCode: 'LXR',
    destinationType: 'CITY',
    destinationName: 'Luxor',
    destinationId: 826,
    latitude: 25.7006,
    longitude: 32.6392,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Marsa-Alam',
    defaultCurrencyCode: 'USD',
    lookupId: '1.722.24735.25556',
    parentId: 24735,
    timeZone: 'Africa/Cairo',
    iataCode: 'RMF',
    destinationType: 'CITY',
    destinationName: 'Marsa Alam',
    destinationId: 25556,
    latitude: 25.068096,
    longitude: 34.88114,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Port-Said',
    defaultCurrencyCode: 'USD',
    lookupId: '1.722.4378',
    parentId: 722,
    timeZone: 'Africa/Cairo',
    iataCode: 'PSD',
    destinationType: 'CITY',
    destinationName: 'Port Said',
    destinationId: 4378,
    latitude: 31.268302,
    longitude: 32.309885,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Safaga',
    defaultCurrencyCode: 'USD',
    lookupId: '1.722.24735.24846',
    parentId: 24735,
    timeZone: 'Africa/Cairo',
    iataCode: 'HRG',
    destinationType: 'CITY',
    destinationName: 'Safaga',
    destinationId: 24846,
    latitude: 26.750584,
    longitude: 33.93739,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Saint-Catherine',
    defaultCurrencyCode: 'USD',
    lookupId: '1.722.50239',
    parentId: 722,
    timeZone: 'Africa/Cairo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Saint Catherine',
    destinationId: 50239,
    latitude: 28.5609,
    longitude: 33.948,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Sharm-el-Sheikh',
    defaultCurrencyCode: 'USD',
    lookupId: '1.722.24735.827',
    parentId: 24735,
    timeZone: 'Africa/Cairo',
    iataCode: 'SSH',
    destinationType: 'CITY',
    destinationName: 'Sharm el Sheikh',
    destinationId: 827,
    latitude: 27.935877251,
    longitude: 34.3686676025,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Sohag',
    defaultCurrencyCode: 'USD',
    lookupId: '1.722.50404',
    parentId: 722,
    timeZone: 'Africa/Cairo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sohag',
    destinationId: 50404,
    latitude: 26.56275,
    longitude: 31.690861,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Suez',
    defaultCurrencyCode: 'USD',
    lookupId: '1.722.4533',
    parentId: 722,
    timeZone: 'Africa/Cairo',
    iataCode: 'PSD',
    destinationType: 'CITY',
    destinationName: 'Suez',
    destinationId: 4533,
    latitude: 29.967967,
    longitude: 32.550802,
  },
  {
    sortOrder: 66,
    selectable: true,
    destinationUrlName: 'El-Salvador',
    defaultCurrencyCode: 'USD',
    lookupId: '9.5069',
    parentId: 9,
    timeZone: 'America/El_Salvador',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'El Salvador',
    destinationId: 5069,
    latitude: 13.794185,
    longitude: -88.89653,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Acajutla',
    defaultCurrencyCode: 'USD',
    lookupId: '9.5069.5070',
    parentId: 5069,
    timeZone: 'America/El_Salvador',
    iataCode: 'SAL',
    destinationType: 'CITY',
    destinationName: 'Acajutla',
    destinationId: 5070,
    latitude: 13.58824,
    longitude: -89.832397,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'La-Libertad',
    defaultCurrencyCode: 'USD',
    lookupId: '9.5069.22202',
    parentId: 5069,
    timeZone: 'America/El_Salvador',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'La Libertad',
    destinationId: 22202,
    latitude: 13.490459,
    longitude: -89.297205,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'San-Luis-Talpa',
    defaultCurrencyCode: 'USD',
    lookupId: '9.5069.50467',
    parentId: 5069,
    timeZone: 'America/El_Salvador',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'San Luis Talpa',
    destinationId: 50467,
    latitude: 13.47444,
    longitude: -89.087563,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'San-Salvador',
    defaultCurrencyCode: 'USD',
    lookupId: '9.5069.5585',
    parentId: 5069,
    timeZone: 'America/El_Salvador',
    iataCode: 'SAL',
    destinationType: 'CITY',
    destinationName: 'San Salvador',
    destinationId: 5585,
    latitude: 13.69294,
    longitude: -89.218191,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Santa-Ana',
    defaultCurrencyCode: 'USD',
    lookupId: '9.5069.25291',
    parentId: 5069,
    timeZone: 'America/El_Salvador',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Santa Ana',
    destinationId: 25291,
    latitude: 13.97783,
    longitude: -89.56391,
  },
  {
    sortOrder: 67,
    selectable: true,
    destinationUrlName: 'Equatorial-Guinea',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21890',
    parentId: 1,
    timeZone: 'Africa/Malabo',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Equatorial Guinea',
    destinationId: 21890,
    latitude: 1.6508,
    longitude: 10.2679,
  },
  {
    sortOrder: 68,
    selectable: true,
    destinationUrlName: 'Eritrea',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4583',
    parentId: 1,
    timeZone: 'Africa/Asmara',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Eritrea',
    destinationId: 4583,
    latitude: 15.1794,
    longitude: 39.7823,
  },
  {
    sortOrder: 69,
    selectable: true,
    destinationUrlName: 'Estonia',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.4146',
    parentId: 6,
    timeZone: 'Europe/Tallinn',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Estonia',
    destinationId: 4146,
    latitude: 58.595272,
    longitude: 25.013607,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Paernu',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.4146.25816',
    parentId: 4146,
    timeZone: 'Europe/Tallinn',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Pärnu',
    destinationId: 25816,
    latitude: 58.385733,
    longitude: 24.496666,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Tallinn',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.4146.4147',
    parentId: 4146,
    timeZone: 'Europe/Tallinn',
    iataCode: 'TLL',
    destinationType: 'CITY',
    destinationName: 'Tallinn',
    destinationId: 4147,
    latitude: 59.4473003211,
    longitude: 24.7710800171,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Tartu',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.4146.25554',
    parentId: 4146,
    timeZone: 'Europe/Tallinn',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tartu',
    destinationId: 25554,
    latitude: 58.3839,
    longitude: 26.7099,
  },
  {
    sortOrder: 70,
    selectable: true,
    destinationUrlName: 'Eswatini-Swaziland',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21916',
    parentId: 1,
    timeZone: 'Africa/Mbabane',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Eswatini (Swaziland)',
    destinationId: 21916,
    latitude: -26.5225,
    longitude: 31.4659,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Mbabane',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21916.50961',
    parentId: 21916,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mbabane',
    destinationId: 50961,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 71,
    selectable: true,
    destinationUrlName: 'Ethiopia',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21891',
    parentId: 1,
    timeZone: 'Africa/Addis_Ababa',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Ethiopia',
    destinationId: 21891,
    latitude: 8.617677,
    longitude: 39.60794,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Debark',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21891.51756',
    parentId: 21891,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Debark',
    destinationId: 51756,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Dire-Dawa',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21891.51853',
    parentId: 21891,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Dire Dawa',
    destinationId: 51853,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Harar',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21891.51735',
    parentId: 21891,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Harar',
    destinationId: 51735,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Tigray-Region',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21891.51743',
    parentId: 21891,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Tigray Region',
    destinationId: 51743,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Addis-Ababa',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21891.24099',
    parentId: 21891,
    timeZone: 'Africa/Addis_Ababa',
    iataCode: 'ADD',
    destinationType: 'CITY',
    destinationName: 'Addis Ababa',
    destinationId: 24099,
    latitude: 8.982396,
    longitude: 38.762594,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Arba-Minch',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21891.50319',
    parentId: 21891,
    timeZone: 'Africa/Addis_Ababa',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Arba Minch',
    destinationId: 50319,
    latitude: 6.0206,
    longitude: 37.5641,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Axum',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21891.50408',
    parentId: 21891,
    timeZone: 'Africa/Addis_Ababa',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Axum',
    destinationId: 50408,
    latitude: 14.1208,
    longitude: 38.7278,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Bahir-Dar',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21891.50318',
    parentId: 21891,
    timeZone: 'Africa/Addis_Ababa',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bahir Dar',
    destinationId: 50318,
    latitude: 11.5742,
    longitude: 37.3614,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Gonder',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21891.50243',
    parentId: 21891,
    timeZone: 'Africa/Addis_Ababa',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Gonder',
    destinationId: 50243,
    latitude: 12.603,
    longitude: 37.4521,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Hawzen',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21891.51743.52184',
    parentId: 51743,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Hawzen',
    destinationId: 52184,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Jinka',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21891.50967',
    parentId: 21891,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Jinka',
    destinationId: 50967,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Lalibela',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21891.40601',
    parentId: 21891,
    timeZone: 'Africa/Addis_Ababa',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lalibela',
    destinationId: 40601,
    latitude: 12.0319748,
    longitude: 39.0292095,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Mekele',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21891.50242',
    parentId: 21891,
    timeZone: 'Africa/Addis_Ababa',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: "Mek'ele",
    destinationId: 50242,
    latitude: 13.4936,
    longitude: 39.4657,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Turmi',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21891.51148',
    parentId: 21891,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Turmi',
    destinationId: 51148,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 72,
    selectable: true,
    destinationUrlName: 'Falkland-Islands',
    defaultCurrencyCode: 'USD',
    lookupId: '9.25958',
    parentId: 9,
    timeZone: 'Atlantic/Stanley',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Falkland Islands',
    destinationId: 25958,
    latitude: -51.7063169,
    longitude: -61.7705207,
  },
  {
    sortOrder: 73,
    selectable: true,
    destinationUrlName: 'Faroe-Islands',
    defaultCurrencyCode: 'USD',
    lookupId: '6.37756',
    parentId: 6,
    timeZone: 'Atlantic/Faroe',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Faroe Islands',
    destinationId: 37756,
    latitude: 61.8926,
    longitude: -6.9118,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Streymoy',
    defaultCurrencyCode: 'USD',
    lookupId: '6.37756.50244',
    parentId: 37756,
    timeZone: 'Europe/Oslo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Streymoy',
    destinationId: 50244,
    latitude: 62.1525,
    longitude: 7.0754,
  },
  {
    sortOrder: 74,
    selectable: true,
    destinationUrlName: 'Fiji',
    defaultCurrencyCode: 'USD',
    lookupId: '3.23',
    parentId: 3,
    timeZone: 'Pacific/Fiji',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Fiji',
    destinationId: 23,
    latitude: -17.713371,
    longitude: 178.065032,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Coral-Coast',
    defaultCurrencyCode: 'USD',
    lookupId: '3.23.24288',
    parentId: 23,
    timeZone: 'America/New_York',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Coral Coast',
    destinationId: 24288,
    latitude: 26.6274,
    longitude: -81.9722,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Denarau-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '3.23.22972',
    parentId: 23,
    timeZone: 'Pacific/Fiji',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Denarau Island',
    destinationId: 22972,
    latitude: -17.772889,
    longitude: 177.374761,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Lautoka',
    defaultCurrencyCode: 'USD',
    lookupId: '3.23.4794',
    parentId: 23,
    timeZone: 'Pacific/Fiji',
    iataCode: 'NAN',
    destinationType: 'CITY',
    destinationName: 'Lautoka',
    destinationId: 4794,
    latitude: -17.617,
    longitude: 177.45049,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Momi',
    defaultCurrencyCode: 'USD',
    lookupId: '3.23.24288.50320',
    parentId: 24288,
    timeZone: 'Pacific/Fiji',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Momi',
    destinationId: 50320,
    latitude: -17.915201,
    longitude: 177.257985,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Nadi',
    defaultCurrencyCode: 'USD',
    lookupId: '3.23.4795',
    parentId: 23,
    timeZone: 'Pacific/Fiji',
    iataCode: 'NAN',
    destinationType: 'CITY',
    destinationName: 'Nadi',
    destinationId: 4795,
    latitude: -17.77654,
    longitude: 177.43562,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Pacific-Harbour',
    defaultCurrencyCode: 'USD',
    lookupId: '3.23.24288.24348',
    parentId: 24288,
    timeZone: 'Pacific/Fiji',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Pacific Harbour',
    destinationId: 24348,
    latitude: -18.234786,
    longitude: 178.086372,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Suva',
    defaultCurrencyCode: 'USD',
    lookupId: '3.23.4797',
    parentId: 23,
    timeZone: 'Pacific/Fiji',
    iataCode: 'SUV',
    destinationType: 'CITY',
    destinationName: 'Suva',
    destinationId: 4797,
    latitude: -18.124649,
    longitude: 178.450345,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Viti-Levu',
    defaultCurrencyCode: 'USD',
    lookupId: '3.23.50206',
    parentId: 23,
    timeZone: 'Pacific/Fiji',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Viti Levu',
    destinationId: 50206,
    latitude: -18.24152,
    longitude: 178.081085,
  },
  {
    sortOrder: 75,
    selectable: true,
    destinationUrlName: 'Finland',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.50',
    parentId: 6,
    timeZone: 'Europe/Helsinki',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Finland',
    destinationId: 50,
    latitude: 61.92411,
    longitude: 25.748151,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Lapland',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.50.5581',
    parentId: 50,
    timeZone: 'Europe/Helsinki',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Lapland',
    destinationId: 5581,
    latitude: 67.92223,
    longitude: 26.504644,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Helsinki',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.50.803',
    parentId: 50,
    timeZone: 'Europe/Helsinki',
    iataCode: 'HEL',
    destinationType: 'CITY',
    destinationName: 'Helsinki',
    destinationId: 803,
    latitude: 60.1655965488,
    longitude: 24.9559593201,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Levi',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.50.5581.50499',
    parentId: 5581,
    timeZone: 'Africa/Lusaka',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Levi',
    destinationId: 50499,
    latitude: -13.17191,
    longitude: 24.942989,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Luosto',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.50.5581.50655',
    parentId: 5581,
    timeZone: 'Europe/Helsinki',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Luosto',
    destinationId: 50655,
    latitude: 67.15709,
    longitude: 26.91572,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Rovaniemi',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.50.5581.22130',
    parentId: 5581,
    timeZone: 'Europe/Oslo',
    iataCode: 'RVN',
    destinationType: 'CITY',
    destinationName: 'Rovaniemi',
    destinationId: 22130,
    latitude: 66.497022,
    longitude: 25.724999,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Saariselka',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.50.5581.50501',
    parentId: 5581,
    timeZone: 'Europe/Helsinki',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Saariselka',
    destinationId: 50501,
    latitude: 61.916061,
    longitude: 27.85813,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Tampere',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.50.50903',
    parentId: 50,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tampere',
    destinationId: 50903,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Turku',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.50.50907',
    parentId: 50,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Turku',
    destinationId: 50907,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 76,
    selectable: true,
    destinationUrlName: 'French-Guiana',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4508',
    parentId: 9,
    timeZone: 'America/Cayenne',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'French Guiana',
    destinationId: 4508,
    latitude: 3.9339,
    longitude: -53.1258,
  },
  {
    sortOrder: 77,
    selectable: true,
    destinationUrlName: 'French-Polynesia',
    defaultCurrencyCode: 'USD',
    lookupId: '3.5212',
    parentId: 3,
    timeZone: 'Pacific/Tahiti',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'French Polynesia',
    destinationId: 5212,
    latitude: -17.3362715,
    longitude: -153.6261935,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Bora-Bora',
    defaultCurrencyCode: 'USD',
    lookupId: '3.5212.5180',
    parentId: 5212,
    timeZone: 'Pacific/Tahiti',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Bora Bora',
    destinationId: 5180,
    latitude: -16.5004126,
    longitude: -151.7414904,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Commune-of-Rangiroa',
    defaultCurrencyCode: 'USD',
    lookupId: '3.5212.26153',
    parentId: 5212,
    timeZone: 'Pacific/Tahiti',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Commune of Rangiroa',
    destinationId: 26153,
    latitude: -15.1218,
    longitude: -147.6405,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Moorea',
    defaultCurrencyCode: 'USD',
    lookupId: '3.5212.5182',
    parentId: 5212,
    timeZone: 'Pacific/Tahiti',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Moorea',
    destinationId: 5182,
    latitude: -17.5388435,
    longitude: -149.8295234,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Raiatea',
    defaultCurrencyCode: 'USD',
    lookupId: '3.5212.24848',
    parentId: 5212,
    timeZone: 'Pacific/Tahiti',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Raiatea',
    destinationId: 24848,
    latitude: -16.8194068,
    longitude: -151.4926677,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Tahiti',
    defaultCurrencyCode: 'USD',
    lookupId: '3.5212.25',
    parentId: 5212,
    timeZone: 'Pacific/Tahiti',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Tahiti',
    destinationId: 25,
    latitude: -17.679742,
    longitude: -149.406843,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Avatoru',
    defaultCurrencyCode: 'USD',
    lookupId: '3.5212.26153.50965',
    parentId: 26153,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Avatoru',
    destinationId: 50965,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Papeete',
    defaultCurrencyCode: 'USD',
    lookupId: '3.5212.25.5181',
    parentId: 25,
    timeZone: 'Pacific/Tahiti',
    iataCode: 'PPT',
    destinationType: 'CITY',
    destinationName: 'Papeete',
    destinationId: 5181,
    latitude: -17.535021,
    longitude: -149.569595,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Rangiroa',
    defaultCurrencyCode: 'USD',
    lookupId: '3.5212.26153.50584',
    parentId: 26153,
    timeZone: 'Pacific/Tahiti',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Rangiroa',
    destinationId: 50584,
    latitude: -17.53336,
    longitude: -149.566666,
  },
  {
    sortOrder: 78,
    selectable: true,
    destinationUrlName: 'Gabon',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21899',
    parentId: 1,
    timeZone: 'Africa/Libreville',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Gabon',
    destinationId: 21899,
    latitude: -0.8037,
    longitude: 11.6094,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Libreville',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21899.51613',
    parentId: 21899,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Libreville',
    destinationId: 51613,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 79,
    selectable: true,
    destinationUrlName: 'Gambia',
    defaultCurrencyCode: 'USD',
    lookupId: '1.22232',
    parentId: 1,
    timeZone: 'Africa/Banjul',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Gambia',
    destinationId: 22232,
    latitude: 13.4432,
    longitude: -15.3101,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Banjul',
    defaultCurrencyCode: 'USD',
    lookupId: '1.22232.27409',
    parentId: 22232,
    timeZone: 'Africa/Banjul',
    iataCode: 'BJL',
    destinationType: 'CITY',
    destinationName: 'Banjul',
    destinationId: 27409,
    latitude: 13.45488,
    longitude: -16.57903,
  },
  {
    sortOrder: 80,
    selectable: true,
    destinationUrlName: 'Georgia',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21901',
    parentId: 6,
    timeZone: 'Asia/Tbilisi',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Georgia',
    destinationId: 21901,
    latitude: 42.176341,
    longitude: 43.51601,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Borjomi-Kharagauli-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21901.51989',
    parentId: 21901,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Borjomi-Kharagauli National Park',
    destinationId: 51989,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Samtskhe-Javakheti-Region',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21901.51874',
    parentId: 21901,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Samtskhe-Javakheti Region',
    destinationId: 51874,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Akhaltsikhe',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21901.51874.52182',
    parentId: 51874,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Akhaltsikhe',
    destinationId: 52182,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Batumi',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21901.24045',
    parentId: 21901,
    timeZone: 'Asia/Tbilisi',
    iataCode: 'BUS',
    destinationType: 'CITY',
    destinationName: 'Batumi',
    destinationId: 24045,
    latitude: 41.618598,
    longitude: 41.639566,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Gudauri',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21901.50328',
    parentId: 21901,
    timeZone: 'Asia/Tbilisi',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Gudauri',
    destinationId: 50328,
    latitude: 42.4755,
    longitude: 44.4805,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Kutaisi',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21901.50207',
    parentId: 21901,
    timeZone: 'Asia/Tbilisi',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kutaisi',
    destinationId: 50207,
    latitude: 42.266243,
    longitude: 42.718002,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Mestia',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21901.50248',
    parentId: 21901,
    timeZone: 'Asia/Tbilisi',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mestia',
    destinationId: 50248,
    latitude: 43.034199,
    longitude: 42.687512,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Signagi',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21901.50247',
    parentId: 21901,
    timeZone: 'Asia/Tbilisi',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Signagi',
    destinationId: 50247,
    latitude: 41.61075,
    longitude: 45.927529,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Stepantsminda',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21901.50246',
    parentId: 21901,
    timeZone: 'Asia/Tbilisi',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Stepantsminda',
    destinationId: 50246,
    latitude: 42.6603,
    longitude: 44.6411,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Tbilisi',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21901.22516',
    parentId: 21901,
    timeZone: 'Asia/Tbilisi',
    iataCode: 'TBS',
    destinationType: 'CITY',
    destinationName: 'Tbilisi',
    destinationId: 22516,
    latitude: 41.71514,
    longitude: 44.8271,
  },
  {
    sortOrder: 81,
    selectable: true,
    destinationUrlName: 'Germany',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52',
    parentId: 6,
    timeZone: 'Europe/Berlin',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Germany',
    destinationId: 52,
    latitude: 51.165691,
    longitude: 10.451526,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Baden-Wuerttemberg',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.25740',
    parentId: 52,
    timeZone: 'Europe/Berlin',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Baden-Württemberg',
    destinationId: 25740,
    latitude: 49.3281,
    longitude: 8.5647,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Bavaria',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.5203',
    parentId: 52,
    timeZone: 'Europe/Berlin',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Bavaria',
    destinationId: 5203,
    latitude: 48.9175,
    longitude: 11.4078,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Lower-Saxony',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.30446',
    parentId: 52,
    timeZone: 'Europe/Berlin',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Lower Saxony',
    destinationId: 30446,
    latitude: 52.6267,
    longitude: 8.9537,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Mecklenburg-Vorpommern',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.22777',
    parentId: 52,
    timeZone: 'Europe/Berlin',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Mecklenburg-Vorpommern',
    destinationId: 22777,
    latitude: 53.61265,
    longitude: 12.4296,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Moselle-Valley',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.25743',
    parentId: 52,
    timeZone: 'Europe/Berlin',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Moselle Valley',
    destinationId: 25743,
    latitude: 50.71476,
    longitude: 7.11555,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Northern-Germany',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.22383',
    parentId: 52,
    timeZone: 'Europe/Berlin',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Northern Germany',
    destinationId: 22383,
    latitude: 53.765982,
    longitude: 11.453996,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Rhine-River',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.767',
    parentId: 52,
    timeZone: 'Europe/Berlin',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Rhine River',
    destinationId: 767,
    latitude: 50.3566962,
    longitude: 7.5996166,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Romantic-Road',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.21519',
    parentId: 52,
    timeZone: 'Europe/Berlin',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Romantic Road',
    destinationId: 21519,
    latitude: 49.380183,
    longitude: 10.186739,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Saxony',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.22374',
    parentId: 52,
    timeZone: 'Europe/Berlin',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Saxony',
    destinationId: 22374,
    latitude: 50.8412,
    longitude: 13.4731,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Augsburg',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.5203.34164',
    parentId: 5203,
    timeZone: 'Europe/Berlin',
    iataCode: 'AGB',
    destinationType: 'CITY',
    destinationName: 'Augsburg',
    destinationId: 34164,
    latitude: 48.371316,
    longitude: 10.902288,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Bamberg',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.4964',
    parentId: 52,
    timeZone: 'Europe/Berlin',
    iataCode: 'NUE',
    destinationType: 'CITY',
    destinationName: 'Bamberg',
    destinationId: 4964,
    latitude: 49.891861,
    longitude: 10.89353,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Berchtesgaden',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.5203.50870',
    parentId: 5203,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Berchtesgaden',
    destinationId: 50870,
    latitude: 47.6365255086,
    longitude: 13.000035201,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Berlin',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.488',
    parentId: 52,
    timeZone: 'Europe/Berlin',
    iataCode: 'BER',
    destinationType: 'CITY',
    destinationName: 'Berlin',
    destinationId: 488,
    latitude: 52.5234051,
    longitude: 13.4113999,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Bonn',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.767.27429',
    parentId: 767,
    timeZone: 'Europe/Berlin',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bonn',
    destinationId: 27429,
    latitude: 50.73743,
    longitude: 7.09821,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Bremen',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.22383.25165',
    parentId: 22383,
    timeZone: 'Europe/Berlin',
    iataCode: 'BRE',
    destinationType: 'CITY',
    destinationName: 'Bremen',
    destinationId: 25165,
    latitude: 53.07874,
    longitude: 8.802027,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Cologne',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.767.923',
    parentId: 767,
    timeZone: 'Europe/Berlin',
    iataCode: 'CGN',
    destinationType: 'CITY',
    destinationName: 'Cologne',
    destinationId: 923,
    latitude: 50.9406645,
    longitude: 6.9599115,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Dortmund',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.34197',
    parentId: 52,
    timeZone: 'Europe/Berlin',
    iataCode: 'DTM',
    destinationType: 'CITY',
    destinationName: 'Dortmund',
    destinationId: 34197,
    latitude: 51.512502,
    longitude: 7.47094,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Dresden',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.22374.22375',
    parentId: 22374,
    timeZone: 'Europe/Berlin',
    iataCode: 'DRS',
    destinationType: 'CITY',
    destinationName: 'Dresden',
    destinationId: 22375,
    latitude: 51.05041,
    longitude: 13.73726,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Duesseldorf',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.767.5631',
    parentId: 767,
    timeZone: 'Europe/Berlin',
    iataCode: 'DUS',
    destinationType: 'CITY',
    destinationName: 'Düsseldorf',
    destinationId: 5631,
    latitude: 51.227741,
    longitude: 6.773456,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Frankfurt',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.489',
    parentId: 52,
    timeZone: 'Europe/Berlin',
    iataCode: 'FRA',
    destinationType: 'CITY',
    destinationName: 'Frankfurt',
    destinationId: 489,
    latitude: 50.1115118,
    longitude: 8.6805059,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Freiburg',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.25740.34163',
    parentId: 25740,
    timeZone: 'Europe/Berlin',
    iataCode: 'MLH',
    destinationType: 'CITY',
    destinationName: 'Freiburg',
    destinationId: 34163,
    latitude: 47.999633,
    longitude: 7.845849,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Friedrichshafen',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.25740.51207',
    parentId: 25740,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Friedrichshafen',
    destinationId: 51207,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Fuessen',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.5203.23184',
    parentId: 5203,
    timeZone: 'Europe/Berlin',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Füssen',
    destinationId: 23184,
    latitude: 47.569553,
    longitude: 10.700857,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Garmisch-Partenkirchen',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.5203.22133',
    parentId: 5203,
    timeZone: 'Europe/Berlin',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Garmisch-Partenkirchen',
    destinationId: 22133,
    latitude: 47.491944,
    longitude: 11.121738,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Gengenbach',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.25740.51272',
    parentId: 25740,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Gengenbach',
    destinationId: 51272,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Hamburg',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.22383.777',
    parentId: 22383,
    timeZone: 'Europe/Berlin',
    iataCode: 'HAM',
    destinationType: 'CITY',
    destinationName: 'Hamburg',
    destinationId: 777,
    latitude: 53.5420415429,
    longitude: 9.9788475037,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Hannover',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.30446.28614',
    parentId: 30446,
    timeZone: 'Europe/Berlin',
    iataCode: 'HAJ',
    destinationType: 'CITY',
    destinationName: 'Hannover',
    destinationId: 28614,
    latitude: 52.37589,
    longitude: 9.73201,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Heidelberg',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.25740.24030',
    parentId: 25740,
    timeZone: 'Europe/Berlin',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Heidelberg',
    destinationId: 24030,
    latitude: 49.39875,
    longitude: 8.67243,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Hohenschwangau',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.5203.50586',
    parentId: 5203,
    timeZone: 'Europe/Berlin',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Hohenschwangau',
    destinationId: 50586,
    latitude: 47.558659,
    longitude: 10.74124,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Karlsruhe',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.25740.25741',
    parentId: 25740,
    timeZone: 'Europe/Berlin',
    iataCode: 'FKB',
    destinationType: 'CITY',
    destinationName: 'Karlsruhe',
    destinationId: 25741,
    latitude: 49.008108,
    longitude: 8.40185,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'Kiel',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.22383.4203',
    parentId: 22383,
    timeZone: 'Europe/Berlin',
    iataCode: 'KEL',
    destinationType: 'CITY',
    destinationName: 'Kiel',
    destinationId: 4203,
    latitude: 54.32329,
    longitude: 10.12277,
  },
  {
    sortOrder: 23,
    selectable: true,
    destinationUrlName: 'Koblenz',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.767.22373',
    parentId: 767,
    timeZone: 'Europe/Berlin',
    iataCode: 'ZNV',
    destinationType: 'CITY',
    destinationName: 'Koblenz',
    destinationId: 22373,
    latitude: 50.35694,
    longitude: 7.589,
  },
  {
    sortOrder: 24,
    selectable: true,
    destinationUrlName: 'Konstanz',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.25740.50871',
    parentId: 25740,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Konstanz',
    destinationId: 50871,
    latitude: 47.6863861867,
    longitude: 9.1723032108,
  },
  {
    sortOrder: 25,
    selectable: true,
    destinationUrlName: 'Leipzig',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.22374.29263',
    parentId: 22374,
    timeZone: 'Europe/Berlin',
    iataCode: 'LEJ',
    destinationType: 'CITY',
    destinationName: 'Leipzig',
    destinationId: 29263,
    latitude: 51.3397,
    longitude: 12.37307,
  },
  {
    sortOrder: 26,
    selectable: true,
    destinationUrlName: 'Lindau',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.5203.50657',
    parentId: 5203,
    timeZone: 'Europe/Berlin',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lindau',
    destinationId: 50657,
    latitude: 54.38529,
    longitude: 9.90464,
  },
  {
    sortOrder: 27,
    selectable: true,
    destinationUrlName: 'Mainz',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.767.28883',
    parentId: 767,
    timeZone: 'Europe/Berlin',
    iataCode: 'QMZ',
    destinationType: 'CITY',
    destinationName: 'Mainz',
    destinationId: 28883,
    latitude: 49.99286,
    longitude: 8.24725,
  },
  {
    sortOrder: 28,
    selectable: true,
    destinationUrlName: 'Mannheim',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.25740.50892',
    parentId: 25740,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mannheim',
    destinationId: 50892,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 29,
    selectable: true,
    destinationUrlName: 'Meersburg-Bodensee',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.25740.51217',
    parentId: 25740,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Meersburg (Bodensee)',
    destinationId: 51217,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 30,
    selectable: true,
    destinationUrlName: 'Munich',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.5203.487',
    parentId: 5203,
    timeZone: 'Europe/Berlin',
    iataCode: 'MUC',
    destinationType: 'CITY',
    destinationName: 'Munich',
    destinationId: 487,
    latitude: 48.1391265,
    longitude: 11.5801863,
  },
  {
    sortOrder: 31,
    selectable: true,
    destinationUrlName: 'Nuremberg',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.5203.5628',
    parentId: 5203,
    timeZone: 'Europe/Berlin',
    iataCode: 'NUE',
    destinationType: 'CITY',
    destinationName: 'Nuremberg',
    destinationId: 5628,
    latitude: 49.45203,
    longitude: 11.07675,
  },
  {
    sortOrder: 32,
    selectable: true,
    destinationUrlName: 'Oberstaufen',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.5203.51250',
    parentId: 5203,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Oberstaufen',
    destinationId: 51250,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 33,
    selectable: true,
    destinationUrlName: 'Passau',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.5203.25665',
    parentId: 5203,
    timeZone: 'Europe/Berlin',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Passau',
    destinationId: 25665,
    latitude: 48.566583,
    longitude: 13.430078,
  },
  {
    sortOrder: 34,
    selectable: true,
    destinationUrlName: 'Potsdam',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.28717',
    parentId: 52,
    timeZone: 'Europe/Berlin',
    iataCode: 'XXP',
    destinationType: 'CITY',
    destinationName: 'Potsdam',
    destinationId: 28717,
    latitude: 52.39057,
    longitude: 13.06447,
  },
  {
    sortOrder: 35,
    selectable: true,
    destinationUrlName: 'Regensburg',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.5203.24098',
    parentId: 5203,
    timeZone: 'Europe/Berlin',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Regensburg',
    destinationId: 24098,
    latitude: 49.01343,
    longitude: 12.10162,
  },
  {
    sortOrder: 36,
    selectable: true,
    destinationUrlName: 'Rostock',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.22777.22778',
    parentId: 22777,
    timeZone: 'Europe/Berlin',
    iataCode: 'RLG',
    destinationType: 'CITY',
    destinationName: 'Rostock',
    destinationId: 22778,
    latitude: 54.092789,
    longitude: 12.103599,
  },
  {
    sortOrder: 37,
    selectable: true,
    destinationUrlName: 'Rothenburg',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.5203.36690',
    parentId: 5203,
    timeZone: 'Europe/Berlin',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Rothenburg',
    destinationId: 36690,
    latitude: 49.3658091,
    longitude: 10.1274898,
  },
  {
    sortOrder: 38,
    selectable: true,
    destinationUrlName: 'Rust',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.25740.36288',
    parentId: 25740,
    timeZone: 'Europe/Paris',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Rust',
    destinationId: 36288,
    latitude: 48.261208,
    longitude: 7.6824331,
  },
  {
    sortOrder: 39,
    selectable: true,
    destinationUrlName: 'Schonefeld',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.50659',
    parentId: 52,
    timeZone: 'Europe/Berlin',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Schonefeld',
    destinationId: 50659,
    latitude: 52.38765,
    longitude: 13.50652,
  },
  {
    sortOrder: 40,
    selectable: true,
    destinationUrlName: 'Stuttgart',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.25740.28716',
    parentId: 25740,
    timeZone: 'Europe/Berlin',
    iataCode: 'STR',
    destinationType: 'CITY',
    destinationName: 'Stuttgart',
    destinationId: 28716,
    latitude: 48.77585,
    longitude: 9.18293,
  },
  {
    sortOrder: 41,
    selectable: true,
    destinationUrlName: 'Trier',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.25743.25744',
    parentId: 25743,
    timeZone: 'Europe/Berlin',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Trier',
    destinationId: 25744,
    latitude: 49.74999,
    longitude: 6.63714,
  },
  {
    sortOrder: 42,
    selectable: true,
    destinationUrlName: 'Wurzburg',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.52.5203.31761',
    parentId: 5203,
    timeZone: 'Europe/Berlin',
    iataCode: 'QWU',
    destinationType: 'CITY',
    destinationName: 'Wurzburg',
    destinationId: 31761,
    latitude: 49.79246,
    longitude: 9.955387,
  },
  {
    sortOrder: 82,
    selectable: true,
    destinationUrlName: 'Ghana',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4439',
    parentId: 1,
    timeZone: 'Africa/Accra',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Ghana',
    destinationId: 4439,
    latitude: 7.9465270008,
    longitude: -1.0231940023,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Mole-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4439.51965',
    parentId: 4439,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Mole National Park',
    destinationId: 51965,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Accra',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4439.5517',
    parentId: 4439,
    timeZone: 'Africa/Accra',
    iataCode: 'ACC',
    destinationType: 'CITY',
    destinationName: 'Accra',
    destinationId: 5517,
    latitude: 5.5500000001,
    longitude: -0.1999999996,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Cape-Coast',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4439.50502',
    parentId: 4439,
    timeZone: 'Australia/Currie',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cape Coast',
    destinationId: 50502,
    latitude: -38.370731,
    longitude: 141.401505,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Kumasi',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4439.5535',
    parentId: 4439,
    timeZone: 'Africa/Accra',
    iataCode: 'KMS',
    destinationType: 'CITY',
    destinationName: 'Kumasi',
    destinationId: 5535,
    latitude: 6.688831287,
    longitude: -1.6183833126,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Tamale',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4439.50660',
    parentId: 4439,
    timeZone: 'Africa/Bangui',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tamale',
    destinationId: 50660,
    latitude: 5.84979,
    longitude: 20.72962,
  },
  {
    sortOrder: 83,
    selectable: true,
    destinationUrlName: 'Gibraltar',
    defaultCurrencyCode: 'USD',
    lookupId: '6.50813',
    parentId: 6,
    timeZone: 'Europe/Gibraltar',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Gibraltar',
    destinationId: 50813,
    latitude: 36.1295043,
    longitude: -5.3883195,
  },
  {
    sortOrder: 84,
    selectable: true,
    destinationUrlName: 'Greece',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53',
    parentId: 6,
    timeZone: 'Europe/Athens',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Greece',
    destinationId: 53,
    latitude: 39.074208,
    longitude: 21.824312,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Aegean-Islands',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.26733',
    parentId: 53,
    timeZone: 'Europe/Athens',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Aegean Islands',
    destinationId: 26733,
    latitude: 38.0,
    longitude: 25.0,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Crete',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.960',
    parentId: 53,
    timeZone: 'Europe/Athens',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Crete',
    destinationId: 960,
    latitude: 35.240117,
    longitude: 24.8092691,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Cyclades-Islands',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.957',
    parentId: 53,
    timeZone: 'Europe/Athens',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Cyclades Islands',
    destinationId: 957,
    latitude: 37.0,
    longitude: 25.16666667,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Dodecanese',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.24033',
    parentId: 53,
    timeZone: 'Europe/Athens',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Dodecanese',
    destinationId: 24033,
    latitude: 36.031332,
    longitude: 27.814636,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Epirus',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.51394',
    parentId: 53,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Epirus',
    destinationId: 51394,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Ionian-Islands',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.4277',
    parentId: 53,
    timeZone: 'Europe/Athens',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Ionian Islands',
    destinationId: 4277,
    latitude: 39.743098,
    longitude: 19.743118,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Macedonia',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.23573',
    parentId: 53,
    timeZone: 'Europe/Athens',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Macedonia',
    destinationId: 23573,
    latitude: 40.81768,
    longitude: 22.85271,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Northeast-Aegean-Islands',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.50329',
    parentId: 53,
    timeZone: 'Europe/Athens',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Northeast Aegean Islands',
    destinationId: 50329,
    latitude: 38.077162,
    longitude: 24.987217,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Peloponnese',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.4135',
    parentId: 53,
    timeZone: 'Europe/Athens',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Peloponnese',
    destinationId: 4135,
    latitude: 36.9915846597,
    longitude: 22.3297119141,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Adelianos-Kampos',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.960.50419',
    parentId: 960,
    timeZone: 'Europe/Athens',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Adelianos Kampos',
    destinationId: 50419,
    latitude: 35.37372,
    longitude: 24.54646,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Agios-Nikolaos',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.960.50331',
    parentId: 960,
    timeZone: 'Europe/Athens',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Agios Nikolaos',
    destinationId: 50331,
    latitude: 35.19,
    longitude: 25.7164,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Andros',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.957.51219',
    parentId: 957,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Andros',
    destinationId: 51219,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Antiparos',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.957.51216',
    parentId: 957,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Antiparos',
    destinationId: 51216,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Athens',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.496',
    parentId: 53,
    timeZone: 'Europe/Athens',
    iataCode: 'ATH',
    destinationType: 'CITY',
    destinationName: 'Athens',
    destinationId: 496,
    latitude: 37.9439267525,
    longitude: 23.695192337,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Bali',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.960.50944',
    parentId: 960,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bali',
    destinationId: 50944,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Cephalonia',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.4277.25033',
    parentId: 4277,
    timeZone: 'Europe/Athens',
    iataCode: 'EFL',
    destinationType: 'CITY',
    destinationName: 'Cephalonia',
    destinationId: 25033,
    latitude: 38.174845,
    longitude: 20.572279,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Chania',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.4251',
    parentId: 53,
    timeZone: 'Europe/Athens',
    iataCode: 'CHQ',
    destinationType: 'CITY',
    destinationName: 'Chania',
    destinationId: 4251,
    latitude: 35.51383,
    longitude: 24.01804,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Corfu',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.4277.4279',
    parentId: 4277,
    timeZone: 'Europe/Athens',
    iataCode: 'CFU',
    destinationType: 'CITY',
    destinationName: 'Corfu',
    destinationId: 4279,
    latitude: 39.624984,
    longitude: 19.922346,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Corinth',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.4135.4613',
    parentId: 4135,
    timeZone: 'Europe/Athens',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Corinth',
    destinationId: 4613,
    latitude: 37.93864,
    longitude: 22.93224,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Delphi',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.50420',
    parentId: 53,
    timeZone: 'Europe/Athens',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Delphi',
    destinationId: 50420,
    latitude: 38.481154,
    longitude: 22.500549,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Halkidiki',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.23573.27334',
    parentId: 23573,
    timeZone: 'Europe/Athens',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Halkidiki',
    destinationId: 27334,
    latitude: 40.3695,
    longitude: 23.28708,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Heraklion',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.960.961',
    parentId: 960,
    timeZone: 'Europe/Athens',
    iataCode: 'HER',
    destinationType: 'CITY',
    destinationName: 'Heraklion',
    destinationId: 961,
    latitude: 35.329162,
    longitude: 25.138526,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Ioannina',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.51394.51530',
    parentId: 51394,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ioannina',
    destinationId: 51530,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Ios',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.957.22031',
    parentId: 957,
    timeZone: 'Europe/Athens',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ios',
    destinationId: 22031,
    latitude: 36.7173,
    longitude: 25.3331,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Ithaca',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.4277.51238',
    parentId: 4277,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ithaca',
    destinationId: 51238,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Kalamata',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.4135.30156',
    parentId: 4135,
    timeZone: 'Europe/Athens',
    iataCode: 'KLX',
    destinationType: 'CITY',
    destinationName: 'Kalamata',
    destinationId: 30156,
    latitude: 37.04224,
    longitude: 22.11413,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Katakolo',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.50251',
    parentId: 53,
    timeZone: 'Europe/Athens',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Katakolo',
    destinationId: 50251,
    latitude: 37.646318,
    longitude: 21.316738,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Kos',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.24033.24036',
    parentId: 24033,
    timeZone: 'Europe/Athens',
    iataCode: 'KGS',
    destinationType: 'CITY',
    destinationName: 'Kos',
    destinationId: 24036,
    latitude: 36.889924,
    longitude: 27.284936,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Lefkada',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.4277.50334',
    parentId: 4277,
    timeZone: 'Europe/Athens',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lefkada',
    destinationId: 50334,
    latitude: 38.7066,
    longitude: 20.6407,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Loutraki',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.50421',
    parentId: 53,
    timeZone: 'Europe/Athens',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Loutraki',
    destinationId: 50421,
    latitude: 37.975651,
    longitude: 22.97735,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'Meteora',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.28822',
    parentId: 53,
    timeZone: 'Europe/Athens',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Meteora',
    destinationId: 28822,
    latitude: 39.7218776547,
    longitude: 21.6305788763,
  },
  {
    sortOrder: 23,
    selectable: true,
    destinationUrlName: 'Milos',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.957.22323',
    parentId: 957,
    timeZone: 'Europe/Athens',
    iataCode: 'MLO',
    destinationType: 'CITY',
    destinationName: 'Milos',
    destinationId: 22323,
    latitude: 36.691767,
    longitude: 24.395908,
  },
  {
    sortOrder: 24,
    selectable: true,
    destinationUrlName: 'Mykonos',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.957.958',
    parentId: 957,
    timeZone: 'Europe/Athens',
    iataCode: 'JMK',
    destinationType: 'CITY',
    destinationName: 'Mykonos',
    destinationId: 958,
    latitude: 37.4469973049,
    longitude: 25.3280246258,
  },
  {
    sortOrder: 25,
    selectable: true,
    destinationUrlName: 'Naxos',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.50250',
    parentId: 53,
    timeZone: 'Europe/Athens',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Naxos',
    destinationId: 50250,
    latitude: 37.102248,
    longitude: 25.376401,
  },
  {
    sortOrder: 26,
    selectable: true,
    destinationUrlName: 'Olympia',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.4135.50252',
    parentId: 4135,
    timeZone: 'Europe/Athens',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Olympia',
    destinationId: 50252,
    latitude: 37.6393,
    longitude: 21.6332,
  },
  {
    sortOrder: 27,
    selectable: true,
    destinationUrlName: 'Paros',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.957.50333',
    parentId: 957,
    timeZone: 'Europe/Athens',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Paros',
    destinationId: 50333,
    latitude: 37.085212,
    longitude: 25.1487,
  },
  {
    sortOrder: 28,
    selectable: true,
    destinationUrlName: 'Patmos',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.4268',
    parentId: 53,
    timeZone: 'Europe/Athens',
    iataCode: 'PMS',
    destinationType: 'CITY',
    destinationName: 'Patmos',
    destinationId: 4268,
    latitude: 37.309302,
    longitude: 26.546691,
  },
  {
    sortOrder: 29,
    selectable: true,
    destinationUrlName: 'Patras',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.4135.51222',
    parentId: 4135,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Patras',
    destinationId: 51222,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 30,
    selectable: true,
    destinationUrlName: 'Plaka',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.496.51484',
    parentId: 496,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Plaka',
    destinationId: 51484,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 31,
    selectable: true,
    destinationUrlName: 'Pylos',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.4270',
    parentId: 53,
    timeZone: 'Europe/Athens',
    iataCode: 'PYL',
    destinationType: 'CITY',
    destinationName: 'Pylos',
    destinationId: 4270,
    latitude: 36.913441,
    longitude: 21.69639,
  },
  {
    sortOrder: 32,
    selectable: true,
    destinationUrlName: 'Rhodes',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.24033.4272',
    parentId: 24033,
    timeZone: 'Europe/Athens',
    iataCode: 'RHO',
    destinationType: 'CITY',
    destinationName: 'Rhodes',
    destinationId: 4272,
    latitude: 36.4349630984,
    longitude: 28.2174829021,
  },
  {
    sortOrder: 33,
    selectable: true,
    destinationUrlName: 'Samos',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.26733.27412',
    parentId: 26733,
    timeZone: 'Europe/Athens',
    iataCode: 'SMI',
    destinationType: 'CITY',
    destinationName: 'Samos',
    destinationId: 27412,
    latitude: 37.75479,
    longitude: 26.97777,
  },
  {
    sortOrder: 34,
    selectable: true,
    destinationUrlName: 'Santorini',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.957.959',
    parentId: 957,
    timeZone: 'Europe/Athens',
    iataCode: 'JTR',
    destinationType: 'CITY',
    destinationName: 'Santorini',
    destinationId: 959,
    latitude: 36.3931562,
    longitude: 25.4615092,
  },
  {
    sortOrder: 35,
    selectable: true,
    destinationUrlName: 'Saronic-Gulf-Islands',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.51324',
    parentId: 53,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Saronic Gulf Islands',
    destinationId: 51324,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 36,
    selectable: true,
    destinationUrlName: 'Skiathos',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.26733.50332',
    parentId: 26733,
    timeZone: 'Europe/Athens',
    iataCode: 'JSI',
    destinationType: 'CITY',
    destinationName: 'Skiathos',
    destinationId: 50332,
    latitude: 39.1635,
    longitude: 23.4902,
  },
  {
    sortOrder: 37,
    selectable: true,
    destinationUrlName: 'Spetses',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.51324.52104',
    parentId: 51324,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Spetses',
    destinationId: 52104,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 38,
    selectable: true,
    destinationUrlName: 'Syros',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.957.51220',
    parentId: 957,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Syros',
    destinationId: 51220,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 39,
    selectable: true,
    destinationUrlName: 'Thessaloniki',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.23573.23853',
    parentId: 23573,
    timeZone: 'Europe/Athens',
    iataCode: 'SKG',
    destinationType: 'CITY',
    destinationName: 'Thessaloniki',
    destinationId: 23853,
    latitude: 40.64006,
    longitude: 22.94442,
  },
  {
    sortOrder: 40,
    selectable: true,
    destinationUrlName: 'Tinos',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.957.51218',
    parentId: 957,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tinos',
    destinationId: 51218,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 41,
    selectable: true,
    destinationUrlName: 'Tyros',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.4135.51119',
    parentId: 4135,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tyros',
    destinationId: 51119,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 42,
    selectable: true,
    destinationUrlName: 'Volos',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.4274',
    parentId: 53,
    timeZone: 'Europe/Athens',
    iataCode: 'VOL',
    destinationType: 'CITY',
    destinationName: 'Volos',
    destinationId: 4274,
    latitude: 39.37,
    longitude: 22.95,
  },
  {
    sortOrder: 43,
    selectable: true,
    destinationUrlName: 'Zakynthos',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.53.4277.23524',
    parentId: 4277,
    timeZone: 'Europe/Athens',
    iataCode: 'ZTH',
    destinationType: 'CITY',
    destinationName: 'Zakynthos',
    destinationId: 23524,
    latitude: 37.78816,
    longitude: 20.89883,
  },
  {
    sortOrder: 85,
    selectable: true,
    destinationUrlName: 'Greenland',
    defaultCurrencyCode: 'USD',
    lookupId: '6.4492',
    parentId: 6,
    timeZone: 'America/Godthab',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Greenland',
    destinationId: 4492,
    latitude: 71.7069,
    longitude: -42.6043,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Ilulissat',
    defaultCurrencyCode: 'USD',
    lookupId: '6.4492.4493',
    parentId: 4492,
    timeZone: 'America/Godthab',
    iataCode: 'JAV',
    destinationType: 'CITY',
    destinationName: 'Ilulissat',
    destinationId: 4493,
    latitude: 69.22302,
    longitude: -51.09624,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Nuuk',
    defaultCurrencyCode: 'USD',
    lookupId: '6.4492.4495',
    parentId: 4492,
    timeZone: 'America/Godthab',
    iataCode: 'GOH',
    destinationType: 'CITY',
    destinationName: 'Nuuk',
    destinationId: 4495,
    latitude: 64.181305,
    longitude: -51.693658,
  },
  {
    sortOrder: 86,
    selectable: true,
    destinationUrlName: 'Grenada',
    defaultCurrencyCode: 'USD',
    lookupId: '4.967',
    parentId: 4,
    timeZone: 'America/Grenada',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Grenada',
    destinationId: 967,
    latitude: 12.0661809147,
    longitude: -61.7596435547,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Grand-Anse',
    defaultCurrencyCode: 'USD',
    lookupId: '4.967.50253',
    parentId: 967,
    timeZone: 'America/Grenada',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Grand Anse',
    destinationId: 50253,
    latitude: 12.024149,
    longitude: -61.762108,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'St-Georges',
    defaultCurrencyCode: 'USD',
    lookupId: '4.967.50254',
    parentId: 967,
    timeZone: 'America/Grenada',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: "St. George's",
    destinationId: 50254,
    latitude: 12.056297,
    longitude: -61.748374,
  },
  {
    sortOrder: 87,
    selectable: true,
    destinationUrlName: 'Guadeloupe',
    defaultCurrencyCode: 'USD',
    lookupId: '4.4311',
    parentId: 4,
    timeZone: 'America/Guadeloupe',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Guadeloupe',
    destinationId: 4311,
    latitude: 16.256218,
    longitude: -61.571405,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Basse-Terre-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '4.4311.50256',
    parentId: 4311,
    timeZone: 'America/Guadeloupe',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Basse-Terre Island',
    destinationId: 50256,
    latitude: 15.9985,
    longitude: -61.7254,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Grande-Terre-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '4.4311.50274',
    parentId: 4311,
    timeZone: 'America/Guadeloupe',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Grande-Terre Island',
    destinationId: 50274,
    latitude: 16.2732,
    longitude: -61.4669,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Pointe-a-Pitre',
    defaultCurrencyCode: 'USD',
    lookupId: '4.4311.50274.51228',
    parentId: 50274,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Pointe-a-Pitre',
    destinationId: 51228,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 88,
    selectable: true,
    destinationUrlName: 'Guam',
    defaultCurrencyCode: 'USD',
    lookupId: '3.4774',
    parentId: 3,
    timeZone: 'Pacific/Guam',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Guam',
    destinationId: 4774,
    latitude: 13.4506574,
    longitude: 144.508623,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Tumon',
    defaultCurrencyCode: 'USD',
    lookupId: '3.4774.50255',
    parentId: 4774,
    timeZone: 'Pacific/Guam',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tumon',
    destinationId: 50255,
    latitude: 13.5005,
    longitude: 144.7956,
  },
  {
    sortOrder: 89,
    selectable: true,
    destinationUrlName: 'Guatemala',
    defaultCurrencyCode: 'USD',
    lookupId: '9.748',
    parentId: 9,
    timeZone: 'America/Guatemala',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Guatemala',
    destinationId: 748,
    latitude: 15.783471,
    longitude: -90.230759,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Central-Highlands',
    defaultCurrencyCode: 'USD',
    lookupId: '9.748.26422',
    parentId: 748,
    timeZone: 'America/Guatemala',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Central Highlands',
    destinationId: 26422,
    latitude: 15.78347,
    longitude: -90.23076,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Pacific-Highlands',
    defaultCurrencyCode: 'USD',
    lookupId: '9.748.26424',
    parentId: 748,
    timeZone: 'America/Guatemala',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Pacific Highlands',
    destinationId: 26424,
    latitude: 15.78347,
    longitude: -90.23076,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Peten',
    defaultCurrencyCode: 'USD',
    lookupId: '9.748.26421',
    parentId: 748,
    timeZone: 'America/Guatemala',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Petén',
    destinationId: 26421,
    latitude: 16.912033,
    longitude: -90.299578,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Western-Highlands',
    defaultCurrencyCode: 'USD',
    lookupId: '9.748.26423',
    parentId: 748,
    timeZone: 'Pacific/Port_Moresby',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Western Highlands',
    destinationId: 26423,
    latitude: -5.745,
    longitude: 144.414,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Antigua',
    defaultCurrencyCode: 'USD',
    lookupId: '9.748.26422.4599',
    parentId: 26422,
    timeZone: 'America/Guatemala',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Antigua',
    destinationId: 4599,
    latitude: 14.553405,
    longitude: -90.735255,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Coban',
    defaultCurrencyCode: 'USD',
    lookupId: '9.748.26422.50662',
    parentId: 26422,
    timeZone: 'America/Guatemala',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Coban',
    destinationId: 50662,
    latitude: 15.47004,
    longitude: -90.372879,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Flores',
    defaultCurrencyCode: 'USD',
    lookupId: '9.748.26421.5374',
    parentId: 26421,
    timeZone: 'America/Guatemala',
    iataCode: 'FRS',
    destinationType: 'CITY',
    destinationName: 'Flores',
    destinationId: 5374,
    latitude: 16.93333,
    longitude: -89.88333,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Guatemala-City',
    defaultCurrencyCode: 'USD',
    lookupId: '9.748.26422.4595',
    parentId: 26422,
    timeZone: 'America/Guatemala',
    iataCode: 'GUA',
    destinationType: 'CITY',
    destinationName: 'Guatemala City',
    destinationId: 4595,
    latitude: 14.624795,
    longitude: -90.532818,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Panajachel',
    defaultCurrencyCode: 'USD',
    lookupId: '9.748.26423.22279',
    parentId: 26423,
    timeZone: 'America/Guatemala',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Panajachel',
    destinationId: 22279,
    latitude: 14.740636,
    longitude: -91.150154,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Puerto-Quetzal',
    defaultCurrencyCode: 'USD',
    lookupId: '9.748.26424.5176',
    parentId: 26424,
    timeZone: 'America/Guatemala',
    iataCode: 'PBR',
    destinationType: 'CITY',
    destinationName: 'Puerto Quetzal',
    destinationId: 5176,
    latitude: 13.9330376,
    longitude: -90.7942045,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Quetzaltenango',
    defaultCurrencyCode: 'USD',
    lookupId: '9.748.26423.25292',
    parentId: 26423,
    timeZone: 'America/Guatemala',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Quetzaltenango',
    destinationId: 25292,
    latitude: 14.851577,
    longitude: -91.523542,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'San-Pedro-La-Laguna',
    defaultCurrencyCode: 'USD',
    lookupId: '9.748.26423.24370',
    parentId: 26423,
    timeZone: 'America/Guatemala',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'San Pedro La Laguna',
    destinationId: 24370,
    latitude: 14.68886,
    longitude: -91.26864,
  },
  {
    sortOrder: 90,
    selectable: true,
    destinationUrlName: 'Guinea',
    defaultCurrencyCode: 'USD',
    lookupId: '1.22160',
    parentId: 1,
    timeZone: 'Africa/Conakry',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Guinea',
    destinationId: 22160,
    latitude: 11.0,
    longitude: -10.0,
  },
  {
    sortOrder: 91,
    selectable: true,
    destinationUrlName: 'Guyana',
    defaultCurrencyCode: 'USD',
    lookupId: '9.22314',
    parentId: 9,
    timeZone: 'America/Guyana',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Guyana',
    destinationId: 22314,
    latitude: 4.8604,
    longitude: -58.9302,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Georgetown',
    defaultCurrencyCode: 'USD',
    lookupId: '9.22314.28060',
    parentId: 22314,
    timeZone: 'America/Guyana',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Georgetown',
    destinationId: 28060,
    latitude: 6.80128,
    longitude: -58.15513,
  },
  {
    sortOrder: 92,
    selectable: true,
    destinationUrlName: 'Haiti',
    defaultCurrencyCode: 'USD',
    lookupId: '4.4324',
    parentId: 4,
    timeZone: 'America/Port-au-Prince',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Haiti',
    destinationId: 4324,
    latitude: 19.0216489,
    longitude: -75.3592525,
  },
  {
    sortOrder: 93,
    selectable: true,
    destinationUrlName: 'Honduras',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4131',
    parentId: 9,
    timeZone: 'America/Tegucigalpa',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Honduras',
    destinationId: 4131,
    latitude: 15.199999,
    longitude: -86.241905,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Copan',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4131.5199',
    parentId: 4131,
    timeZone: 'America/Tegucigalpa',
    iataCode: 'SDH',
    destinationType: 'CITY',
    destinationName: 'Copan',
    destinationId: 5199,
    latitude: 14.766667,
    longitude: -88.783333,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'La-Ceiba',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4131.24830',
    parentId: 4131,
    timeZone: 'America/Tegucigalpa',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'La Ceiba',
    destinationId: 24830,
    latitude: 15.770643,
    longitude: -86.795491,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Roatan',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4131.4132',
    parentId: 4131,
    timeZone: 'America/Tegucigalpa',
    iataCode: 'RTB',
    destinationType: 'CITY',
    destinationName: 'Roatan',
    destinationId: 4132,
    latitude: 16.3240932824,
    longitude: -86.5145874023,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'San-Pedro-Sula',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4131.28423',
    parentId: 4131,
    timeZone: 'America/Tegucigalpa',
    iataCode: 'SAP',
    destinationType: 'CITY',
    destinationName: 'San Pedro Sula',
    destinationId: 28423,
    latitude: 15.51492,
    longitude: -87.99227,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Tegucigalpa',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4131.23163',
    parentId: 4131,
    timeZone: 'America/Tegucigalpa',
    iataCode: 'TGU',
    destinationType: 'CITY',
    destinationName: 'Tegucigalpa',
    destinationId: 23163,
    latitude: 14.072275,
    longitude: -87.192136,
  },
  {
    sortOrder: 94,
    selectable: true,
    destinationUrlName: 'Hungary',
    defaultCurrencyCode: 'USD',
    lookupId: '6.54',
    parentId: 6,
    timeZone: 'Europe/Budapest',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Hungary',
    destinationId: 54,
    latitude: 47.162494,
    longitude: 19.503304,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Great-Plain',
    defaultCurrencyCode: 'USD',
    lookupId: '6.54.26666',
    parentId: 54,
    timeZone: 'Europe/Budapest',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Great Plain',
    destinationId: 26666,
    latitude: 47.5523,
    longitude: 21.1162,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Lake-Balaton',
    defaultCurrencyCode: 'USD',
    lookupId: '6.54.23185',
    parentId: 54,
    timeZone: 'Europe/Budapest',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Lake Balaton',
    destinationId: 23185,
    latitude: 46.83027,
    longitude: 17.73404,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Northern-Hungary',
    defaultCurrencyCode: 'USD',
    lookupId: '6.54.26106',
    parentId: 54,
    timeZone: 'Europe/Budapest',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Northern Hungary',
    destinationId: 26106,
    latitude: 48.1,
    longitude: 20.7667,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Transdanubia',
    defaultCurrencyCode: 'USD',
    lookupId: '6.54.25939',
    parentId: 54,
    timeZone: 'Europe/Vienna',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Transdanubia',
    destinationId: 25939,
    latitude: 48.2405,
    longitude: 14.23,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Budapest',
    defaultCurrencyCode: 'USD',
    lookupId: '6.54.499',
    parentId: 54,
    timeZone: 'Europe/Budapest',
    iataCode: 'BUD',
    destinationType: 'CITY',
    destinationName: 'Budapest',
    destinationId: 499,
    latitude: 47.4984056,
    longitude: 19.0407578,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Debrecen',
    defaultCurrencyCode: 'USD',
    lookupId: '6.54.26666.26894',
    parentId: 26666,
    timeZone: 'Europe/Budapest',
    iataCode: 'DEB',
    destinationType: 'CITY',
    destinationName: 'Debrecen',
    destinationId: 26894,
    latitude: 47.5316,
    longitude: 21.62731,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Miskolc',
    defaultCurrencyCode: 'USD',
    lookupId: '6.54.26106.26107',
    parentId: 26106,
    timeZone: 'Europe/Budapest',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Miskolc',
    destinationId: 26107,
    latitude: 48.102827,
    longitude: 20.77925,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Pecs',
    defaultCurrencyCode: 'USD',
    lookupId: '6.54.25939.26474',
    parentId: 25939,
    timeZone: 'Europe/Budapest',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Pécs',
    destinationId: 26474,
    latitude: 46.0804,
    longitude: 18.22,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Sopron',
    defaultCurrencyCode: 'USD',
    lookupId: '6.54.25645',
    parentId: 54,
    timeZone: 'Europe/Budapest',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sopron',
    destinationId: 25645,
    latitude: 47.6864,
    longitude: 16.5906,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Szentendre',
    defaultCurrencyCode: 'USD',
    lookupId: '6.54.25268',
    parentId: 54,
    timeZone: 'Europe/Budapest',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Szentendre',
    destinationId: 25268,
    latitude: 47.67953,
    longitude: 19.06686,
  },
  {
    sortOrder: 95,
    selectable: true,
    destinationUrlName: 'Iceland',
    defaultCurrencyCode: 'USD',
    lookupId: '6.55',
    parentId: 6,
    timeZone: 'Atlantic/Reykjavik',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Iceland',
    destinationId: 55,
    latitude: 64.963051,
    longitude: -19.020835,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'East-Iceland',
    defaultCurrencyCode: 'USD',
    lookupId: '6.55.22630',
    parentId: 55,
    timeZone: 'Atlantic/Reykjavik',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'East Iceland',
    destinationId: 22630,
    latitude: 64.833,
    longitude: -15.7434,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'North-Iceland',
    defaultCurrencyCode: 'USD',
    lookupId: '6.55.24271',
    parentId: 55,
    timeZone: 'Europe/London',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'North Iceland',
    destinationId: 24271,
    latitude: 65.886662,
    longitude: -16.89073,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Reykjanes',
    defaultCurrencyCode: 'USD',
    lookupId: '6.55.32804',
    parentId: 55,
    timeZone: 'Atlantic/Reykjavik',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Reykjanes',
    destinationId: 32804,
    latitude: 63.999313,
    longitude: -22.544315,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Snaefellsnes-Peninsula',
    defaultCurrencyCode: 'USD',
    lookupId: '6.55.33433',
    parentId: 55,
    timeZone: 'Atlantic/Reykjavik',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Snaefellsnes Peninsula',
    destinationId: 33433,
    latitude: 64.9269,
    longitude: -23.257,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'South-Iceland',
    defaultCurrencyCode: 'USD',
    lookupId: '6.55.24828',
    parentId: 55,
    timeZone: 'Atlantic/Reykjavik',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'South Iceland',
    destinationId: 24828,
    latitude: 64.0647834,
    longitude: -21.8356066,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Vatnajokull-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '6.55.51569',
    parentId: 55,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Vatnajokull National Park',
    destinationId: 51569,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Western-Region',
    defaultCurrencyCode: 'USD',
    lookupId: '6.55.50969',
    parentId: 55,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Western Region',
    destinationId: 50969,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Akureyri',
    defaultCurrencyCode: 'USD',
    lookupId: '6.55.24271.4341',
    parentId: 24271,
    timeZone: 'Atlantic/Reykjavik',
    iataCode: 'AEY',
    destinationType: 'CITY',
    destinationName: 'Akureyri',
    destinationId: 4341,
    latitude: 65.6833333,
    longitude: -18.1,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Djupivogur',
    defaultCurrencyCode: 'USD',
    lookupId: '6.55.4343',
    parentId: 55,
    timeZone: 'Atlantic/Reykjavik',
    iataCode: 'RKV',
    destinationType: 'CITY',
    destinationName: 'Djupivogur',
    destinationId: 4343,
    latitude: 64.656888,
    longitude: -14.290051,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Fludir',
    defaultCurrencyCode: 'USD',
    lookupId: '6.55.24828.50335',
    parentId: 24828,
    timeZone: 'Atlantic/Reykjavik',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Fludir',
    destinationId: 50335,
    latitude: 64.135,
    longitude: -20.3221,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Heimaey-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '6.55.24828.50336',
    parentId: 24828,
    timeZone: 'Atlantic/Reykjavik',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Heimaey Island',
    destinationId: 50336,
    latitude: 63.4277,
    longitude: -20.2674,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Hofn',
    defaultCurrencyCode: 'USD',
    lookupId: '6.55.50257',
    parentId: 55,
    timeZone: 'Atlantic/Reykjavik',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Hofn',
    destinationId: 50257,
    latitude: 64.2497,
    longitude: -15.202,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Isafjordur',
    defaultCurrencyCode: 'USD',
    lookupId: '6.55.4349',
    parentId: 55,
    timeZone: 'Atlantic/Reykjavik',
    iataCode: 'IFJ',
    destinationType: 'CITY',
    destinationName: 'Isafjordur',
    destinationId: 4349,
    latitude: 66.075833,
    longitude: -23.126667,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Reykjahlid',
    defaultCurrencyCode: 'USD',
    lookupId: '6.55.24271.36399',
    parentId: 24271,
    timeZone: 'Atlantic/Reykjavik',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Reykjahlíð ',
    destinationId: 36399,
    latitude: 65.6428131,
    longitude: -16.9233873,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Reykjavik',
    defaultCurrencyCode: 'USD',
    lookupId: '6.55.905',
    parentId: 55,
    timeZone: 'Atlantic/Reykjavik',
    iataCode: 'REK',
    destinationType: 'CITY',
    destinationName: 'Reykjavik',
    destinationId: 905,
    latitude: 64.141391017,
    longitude: -21.893863678,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Skaftafell',
    defaultCurrencyCode: 'USD',
    lookupId: '6.55.22630.25390',
    parentId: 22630,
    timeZone: 'Atlantic/Reykjavik',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Skaftafell',
    destinationId: 25390,
    latitude: 64.071823,
    longitude: -16.977832,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Stykkisholmur',
    defaultCurrencyCode: 'USD',
    lookupId: '6.55.33433.51426',
    parentId: 33433,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Stykkisholmur',
    destinationId: 51426,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Vik',
    defaultCurrencyCode: 'USD',
    lookupId: '6.55.24828.25269',
    parentId: 24828,
    timeZone: 'Atlantic/Reykjavik',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Vik',
    destinationId: 25269,
    latitude: 63.41863,
    longitude: -19.00605,
  },
  {
    sortOrder: 96,
    selectable: true,
    destinationUrlName: 'India',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723',
    parentId: 2,
    timeZone: 'Asia/Kolkata',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'India',
    destinationId: 723,
    latitude: 20.593684,
    longitude: 78.96288,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Andaman-and-Nicobar-Islands',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.23571',
    parentId: 723,
    timeZone: 'Asia/Kolkata',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Andaman and Nicobar Islands',
    destinationId: 23571,
    latitude: 12.6982,
    longitude: 92.8577,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Arunachal-Pradesh',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.51544',
    parentId: 723,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Arunachal Pradesh',
    destinationId: 51544,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Assam',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.24306',
    parentId: 723,
    timeZone: 'Asia/Kolkata',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Assam',
    destinationId: 24306,
    latitude: 26.39,
    longitude: 92.7687,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Bihar',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.26562',
    parentId: 723,
    timeZone: 'Asia/Kolkata',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Bihar',
    destinationId: 26562,
    latitude: 25.09607,
    longitude: 85.31312,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Gujarat',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.24557',
    parentId: 723,
    timeZone: 'Asia/Kolkata',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Gujarat',
    destinationId: 24557,
    latitude: 23.0,
    longitude: 72.0,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Himachal-Pradesh-and-Uttarakhand',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22732',
    parentId: 723,
    timeZone: 'Asia/Kolkata',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Himachal Pradesh & Uttarakhand',
    destinationId: 22732,
    latitude: 31.9145,
    longitude: 77.2478,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Jammu-and-Kashmir',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22620',
    parentId: 723,
    timeZone: 'Asia/Kolkata',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Jammu and Kashmir',
    destinationId: 22620,
    latitude: 33.5327,
    longitude: 75.2601,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Karnataka',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.24948',
    parentId: 723,
    timeZone: 'Asia/Kolkata',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Karnataka',
    destinationId: 24948,
    latitude: 15.0062601,
    longitude: 74.0734067,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Kerala',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.964',
    parentId: 723,
    timeZone: 'Asia/Kolkata',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Kerala',
    destinationId: 964,
    latitude: 10.850516,
    longitude: 76.271083,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Madhya-Pradesh',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.23970',
    parentId: 723,
    timeZone: 'Asia/Kolkata',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Madhya Pradesh',
    destinationId: 23970,
    latitude: 22.896,
    longitude: 77.7578,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Maharashtra',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.25170',
    parentId: 723,
    timeZone: 'Asia/Kolkata',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Maharashtra',
    destinationId: 25170,
    latitude: 19.4994,
    longitude: 75.831,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Nagaland',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.51543',
    parentId: 723,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Nagaland',
    destinationId: 51543,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Odisha',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.5615',
    parentId: 723,
    timeZone: 'Asia/Kolkata',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Odisha',
    destinationId: 5615,
    latitude: 20.4874,
    longitude: 84.734,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Punjab',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22305',
    parentId: 723,
    timeZone: 'Asia/Kolkata',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Punjab',
    destinationId: 22305,
    latitude: 30.8493,
    longitude: 75.4187,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Rajasthan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.4982',
    parentId: 723,
    timeZone: 'Asia/Kolkata',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Rajasthan',
    destinationId: 4982,
    latitude: 27.0238036,
    longitude: 74.2179326,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Sikkim',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.23771',
    parentId: 723,
    timeZone: 'Asia/Kolkata',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Sikkim',
    destinationId: 23771,
    latitude: 27.5579,
    longitude: 88.4684,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Tamil-Nadu',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.4981',
    parentId: 723,
    timeZone: 'Asia/Kolkata',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Tamil Nadu',
    destinationId: 4981,
    latitude: 11.1271225,
    longitude: 78.6568942,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Uttar-Pradesh',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22014',
    parentId: 723,
    timeZone: 'Asia/Kolkata',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Uttar Pradesh',
    destinationId: 22014,
    latitude: 27.874669,
    longitude: 79.777021,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'West-Bengal',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.4923',
    parentId: 723,
    timeZone: 'Asia/Kolkata',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'West Bengal',
    destinationId: 4923,
    latitude: 22.9867569,
    longitude: 87.8549755,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Agra',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22014.4547',
    parentId: 22014,
    timeZone: 'Asia/Kolkata',
    iataCode: 'AGR',
    destinationType: 'CITY',
    destinationName: 'Agra',
    destinationId: 4547,
    latitude: 27.176034,
    longitude: 78.006241,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Ahmedabad',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.24557.24558',
    parentId: 24557,
    timeZone: 'Asia/Kolkata',
    iataCode: 'AMD',
    destinationType: 'CITY',
    destinationName: 'Ahmedabad',
    destinationId: 24558,
    latitude: 23.021445,
    longitude: 72.572353,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Ajmer',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.4982.51525',
    parentId: 4982,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ajmer',
    destinationId: 51525,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Allahabad',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22014.50898',
    parentId: 22014,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Allahabad',
    destinationId: 50898,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Alwar',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.50429',
    parentId: 723,
    timeZone: 'Asia/Kolkata',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Alwar',
    destinationId: 50429,
    latitude: 27.56109,
    longitude: 76.621468,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Amritsar',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22305.22306',
    parentId: 22305,
    timeZone: 'Asia/Kolkata',
    iataCode: 'ATQ',
    destinationType: 'CITY',
    destinationName: 'Amritsar',
    destinationId: 22306,
    latitude: 31.63398,
    longitude: 74.87226,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Andhra-Pradesh',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.51191',
    parentId: 723,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Andhra Pradesh',
    destinationId: 51191,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Aurangabad',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.23226',
    parentId: 723,
    timeZone: 'Asia/Kolkata',
    iataCode: 'IXU',
    destinationType: 'CITY',
    destinationName: 'Aurangabad',
    destinationId: 23226,
    latitude: 19.87545,
    longitude: 75.345016,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Bagdogra',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.4923.50262',
    parentId: 4923,
    timeZone: 'Asia/Kolkata',
    iataCode: 'IXB',
    destinationType: 'CITY',
    destinationName: 'Bagdogra',
    destinationId: 50262,
    latitude: 26.6986,
    longitude: 88.3117,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Bandhavgarh-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.23970.51647',
    parentId: 23970,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bandhavgarh National Park',
    destinationId: 51647,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Bangalore',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.5310',
    parentId: 723,
    timeZone: 'Asia/Kolkata',
    iataCode: 'BLR',
    destinationType: 'CITY',
    destinationName: 'Bangalore',
    destinationId: 5310,
    latitude: 12.9715987,
    longitude: 77.5945627,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Bhopal',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.23970.24530',
    parentId: 23970,
    timeZone: 'Asia/Kolkata',
    iataCode: 'BHO',
    destinationType: 'CITY',
    destinationName: 'Bhopal',
    destinationId: 24530,
    latitude: 23.260126,
    longitude: 77.416618,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Bhubaneswar',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.5615.25191',
    parentId: 5615,
    timeZone: 'Asia/Kolkata',
    iataCode: 'BBI',
    destinationType: 'CITY',
    destinationName: 'Bhubaneswar',
    destinationId: 25191,
    latitude: 20.295676,
    longitude: 85.826875,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Bhuj',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.24557.51537',
    parentId: 24557,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bhuj',
    destinationId: 51537,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Bikaner',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.4982.50339',
    parentId: 4982,
    timeZone: 'Asia/Kolkata',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bikaner',
    destinationId: 50339,
    latitude: 28.0229,
    longitude: 73.3119,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Bir',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22732.51599',
    parentId: 22732,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bir',
    destinationId: 51599,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Bodh-Gaya',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.26562.50423',
    parentId: 26562,
    timeZone: 'Asia/Kolkata',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bodh Gaya',
    destinationId: 50423,
    latitude: 24.7085,
    longitude: 84.9659,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Bundi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.4982.51594',
    parentId: 4982,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bundi',
    destinationId: 51594,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Chandigarh',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22732.24420',
    parentId: 22732,
    timeZone: 'Asia/Kolkata',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Chandigarh',
    destinationId: 24420,
    latitude: 30.72,
    longitude: 76.78,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Chennai',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.4981.4624',
    parentId: 4981,
    timeZone: 'Asia/Kolkata',
    iataCode: 'MAA',
    destinationType: 'CITY',
    destinationName: 'Chennai',
    destinationId: 4624,
    latitude: 13.060422,
    longitude: 80.249583,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Chittaurgarh',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.4982.50428',
    parentId: 4982,
    timeZone: 'Asia/Kolkata',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Chittaurgarh',
    destinationId: 50428,
    latitude: 24.875299,
    longitude: 74.622902,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'Chopta',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22732.51804',
    parentId: 22732,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Chopta',
    destinationId: 51804,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 23,
    selectable: true,
    destinationUrlName: 'Coimbatore',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.4981.26228',
    parentId: 4981,
    timeZone: 'Asia/Kolkata',
    iataCode: 'CJB',
    destinationType: 'CITY',
    destinationName: 'Coimbatore',
    destinationId: 26228,
    latitude: 11.017406,
    longitude: 76.964301,
  },
  {
    sortOrder: 24,
    selectable: true,
    destinationUrlName: 'Dalhousie',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22732.51532',
    parentId: 22732,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Dalhousie',
    destinationId: 51532,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 25,
    selectable: true,
    destinationUrlName: 'Darjeeling',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.4923.22035',
    parentId: 4923,
    timeZone: 'Asia/Kolkata',
    iataCode: 'IXB',
    destinationType: 'CITY',
    destinationName: 'Darjeeling',
    destinationId: 22035,
    latitude: 27.035752,
    longitude: 88.264717,
  },
  {
    sortOrder: 26,
    selectable: true,
    destinationUrlName: 'Dharmasala',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22732.25979',
    parentId: 22732,
    timeZone: 'Asia/Kolkata',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Dharmasala',
    destinationId: 25979,
    latitude: 11.983502,
    longitude: 75.378319,
  },
  {
    sortOrder: 27,
    selectable: true,
    destinationUrlName: 'Dibrugarh',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.24306.51678',
    parentId: 24306,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Dibrugarh',
    destinationId: 51678,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 28,
    selectable: true,
    destinationUrlName: 'Dimapur',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.51543.52181',
    parentId: 51543,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Dimapur',
    destinationId: 52181,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 29,
    selectable: true,
    destinationUrlName: 'Gaya',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.26562.51535',
    parentId: 26562,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Gaya',
    destinationId: 51535,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 30,
    selectable: true,
    destinationUrlName: 'Goa',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.4594',
    parentId: 723,
    timeZone: 'Asia/Kolkata',
    iataCode: 'GOI',
    destinationType: 'CITY',
    destinationName: 'Goa',
    destinationId: 4594,
    latitude: 15.2993265,
    longitude: 74.123996,
  },
  {
    sortOrder: 31,
    selectable: true,
    destinationUrlName: 'Guwahati',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.24306.24307',
    parentId: 24306,
    timeZone: 'Asia/Kolkata',
    iataCode: 'GAU',
    destinationType: 'CITY',
    destinationName: 'Guwahati',
    destinationId: 24307,
    latitude: 26.144059,
    longitude: 91.730506,
  },
  {
    sortOrder: 32,
    selectable: true,
    destinationUrlName: 'Gwalior',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.23970.24829',
    parentId: 23970,
    timeZone: 'Asia/Kolkata',
    iataCode: 'GWL',
    destinationType: 'CITY',
    destinationName: 'Gwalior',
    destinationId: 24829,
    latitude: 26.217527,
    longitude: 78.185318,
  },
  {
    sortOrder: 33,
    selectable: true,
    destinationUrlName: 'Hampi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.24948.50426',
    parentId: 24948,
    timeZone: 'Asia/Kolkata',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Hampi',
    destinationId: 50426,
    latitude: 15.33488,
    longitude: 76.462044,
  },
  {
    sortOrder: 34,
    selectable: true,
    destinationUrlName: 'Haridwar',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22303',
    parentId: 723,
    timeZone: 'Asia/Kolkata',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Haridwar',
    destinationId: 22303,
    latitude: 29.94569,
    longitude: 78.16425,
  },
  {
    sortOrder: 35,
    selectable: true,
    destinationUrlName: 'Havelock-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.23571.50422',
    parentId: 23571,
    timeZone: 'Pacific/Auckland',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Havelock Island',
    destinationId: 50422,
    latitude: -41.279099,
    longitude: 173.766998,
  },
  {
    sortOrder: 36,
    selectable: true,
    destinationUrlName: 'Hyderabad',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22442',
    parentId: 723,
    timeZone: 'Asia/Kolkata',
    iataCode: 'HYD',
    destinationType: 'CITY',
    destinationName: 'Hyderabad',
    destinationId: 22442,
    latitude: 17.38504,
    longitude: 78.48667,
  },
  {
    sortOrder: 37,
    selectable: true,
    destinationUrlName: 'Imphal',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22289',
    parentId: 723,
    timeZone: 'Asia/Kolkata',
    iataCode: 'IMF',
    destinationType: 'CITY',
    destinationName: 'Imphal',
    destinationId: 22289,
    latitude: 24.817431,
    longitude: 93.937522,
  },
  {
    sortOrder: 38,
    selectable: true,
    destinationUrlName: 'Indore',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.23970.24026',
    parentId: 23970,
    timeZone: 'Asia/Kolkata',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Indore',
    destinationId: 24026,
    latitude: 22.7151,
    longitude: 75.865,
  },
  {
    sortOrder: 39,
    selectable: true,
    destinationUrlName: 'Jabalpur',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.23970.50921',
    parentId: 23970,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Jabalpur',
    destinationId: 50921,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 40,
    selectable: true,
    destinationUrlName: 'Jaipur',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.4982.4627',
    parentId: 4982,
    timeZone: 'Asia/Kolkata',
    iataCode: 'JAI',
    destinationType: 'CITY',
    destinationName: 'Jaipur',
    destinationId: 4627,
    latitude: 26.9124165,
    longitude: 75.7872879,
  },
  {
    sortOrder: 41,
    selectable: true,
    destinationUrlName: 'Jaisalmer',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.4982.24761',
    parentId: 4982,
    timeZone: 'Asia/Kolkata',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Jaisalmer',
    destinationId: 24761,
    latitude: 26.915667,
    longitude: 70.909793,
  },
  {
    sortOrder: 42,
    selectable: true,
    destinationUrlName: 'Jhansi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22014.50261',
    parentId: 22014,
    timeZone: 'Asia/Kolkata',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Jhansi',
    destinationId: 50261,
    latitude: 25.4484,
    longitude: 78.5685,
  },
  {
    sortOrder: 43,
    selectable: true,
    destinationUrlName: 'Jim-Corbett-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22732.51558',
    parentId: 22732,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Jim Corbett National Park',
    destinationId: 51558,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 44,
    selectable: true,
    destinationUrlName: 'Jodhpur',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.4982.22142',
    parentId: 4982,
    timeZone: 'Asia/Kolkata',
    iataCode: 'JDH',
    destinationType: 'CITY',
    destinationName: 'Jodhpur',
    destinationId: 22142,
    latitude: 26.23895,
    longitude: 73.02431,
  },
  {
    sortOrder: 45,
    selectable: true,
    destinationUrlName: 'Kanha-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.23970.51798',
    parentId: 23970,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kanha National Park',
    destinationId: 51798,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 46,
    selectable: true,
    destinationUrlName: 'Kannur',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.964.23640',
    parentId: 964,
    timeZone: 'Asia/Kolkata',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kannur',
    destinationId: 23640,
    latitude: 11.874198,
    longitude: 75.371499,
  },
  {
    sortOrder: 47,
    selectable: true,
    destinationUrlName: 'Kasol',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22732.51700',
    parentId: 22732,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kasol',
    destinationId: 51700,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 48,
    selectable: true,
    destinationUrlName: 'Kaza',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22732.51654',
    parentId: 22732,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kaza',
    destinationId: 51654,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 49,
    selectable: true,
    destinationUrlName: 'Khajjiar',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22732.51776',
    parentId: 22732,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Khajjiar',
    destinationId: 51776,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 50,
    selectable: true,
    destinationUrlName: 'Khajuraho',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.23970.25032',
    parentId: 23970,
    timeZone: 'Asia/Kolkata',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Khajuraho',
    destinationId: 25032,
    latitude: 24.831752,
    longitude: 79.920129,
  },
  {
    sortOrder: 51,
    selectable: true,
    destinationUrlName: 'Kibber',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22732.52032',
    parentId: 22732,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kibber',
    destinationId: 52032,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 52,
    selectable: true,
    destinationUrlName: 'Kochi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.964.952',
    parentId: 964,
    timeZone: 'Asia/Kolkata',
    iataCode: 'COK',
    destinationType: 'CITY',
    destinationName: 'Kochi',
    destinationId: 952,
    latitude: 9.939248,
    longitude: 76.259625,
  },
  {
    sortOrder: 53,
    selectable: true,
    destinationUrlName: 'Kodagu-Coorg',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.24948.50886',
    parentId: 24948,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kodagu (Coorg)',
    destinationId: 50886,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 54,
    selectable: true,
    destinationUrlName: 'Kodaikanal',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.4981.50888',
    parentId: 4981,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kodaikanal',
    destinationId: 50888,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 55,
    selectable: true,
    destinationUrlName: 'Kohima',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.51543.52180',
    parentId: 51543,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kohima',
    destinationId: 52180,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 56,
    selectable: true,
    destinationUrlName: 'Kolkata',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.4923.4924',
    parentId: 4923,
    timeZone: 'Asia/Kolkata',
    iataCode: 'CCU',
    destinationType: 'CITY',
    destinationName: 'Kolkata',
    destinationId: 4924,
    latitude: 22.572646,
    longitude: 88.363895,
  },
  {
    sortOrder: 57,
    selectable: true,
    destinationUrlName: 'Kushinagar',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22014.51646',
    parentId: 22014,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kushinagar',
    destinationId: 51646,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 58,
    selectable: true,
    destinationUrlName: 'Ladakh',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22620.51562',
    parentId: 22620,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ladakh',
    destinationId: 51562,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 59,
    selectable: true,
    destinationUrlName: 'Leh',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22620.22569',
    parentId: 22620,
    timeZone: 'Asia/Kolkata',
    iataCode: 'IXL',
    destinationType: 'CITY',
    destinationName: 'Leh',
    destinationId: 22569,
    latitude: 31.579695,
    longitude: 77.167371,
  },
  {
    sortOrder: 60,
    selectable: true,
    destinationUrlName: 'Lucknow',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22014.23770',
    parentId: 22014,
    timeZone: 'Asia/Kolkata',
    iataCode: 'LKO',
    destinationType: 'CITY',
    destinationName: 'Lucknow',
    destinationId: 23770,
    latitude: 26.845406,
    longitude: 80.955373,
  },
  {
    sortOrder: 61,
    selectable: true,
    destinationUrlName: 'Madikeri',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.24948.50904',
    parentId: 24948,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Madikeri',
    destinationId: 50904,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 62,
    selectable: true,
    destinationUrlName: 'Madurai',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.4981.26847',
    parentId: 4981,
    timeZone: 'Asia/Kolkata',
    iataCode: 'IXM',
    destinationType: 'CITY',
    destinationName: 'Madurai',
    destinationId: 26847,
    latitude: 9.9252,
    longitude: 78.11978,
  },
  {
    sortOrder: 63,
    selectable: true,
    destinationUrlName: 'Manali',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22496',
    parentId: 723,
    timeZone: 'Asia/Kolkata',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Manali',
    destinationId: 22496,
    latitude: 32.23963,
    longitude: 77.18871,
  },
  {
    sortOrder: 64,
    selectable: true,
    destinationUrlName: 'Mandi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22732.51536',
    parentId: 22732,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mandi',
    destinationId: 51536,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 65,
    selectable: true,
    destinationUrlName: 'Mangalore',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.24948.4625',
    parentId: 24948,
    timeZone: 'Asia/Kolkata',
    iataCode: 'IXE',
    destinationType: 'CITY',
    destinationName: 'Mangalore',
    destinationId: 4625,
    latitude: 12.91329,
    longitude: 74.853975,
  },
  {
    sortOrder: 66,
    selectable: true,
    destinationUrlName: 'Meghalaya',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.51192',
    parentId: 723,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Meghalaya',
    destinationId: 51192,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 67,
    selectable: true,
    destinationUrlName: 'Mount-Abu',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.4982.50337',
    parentId: 4982,
    timeZone: 'Asia/Kolkata',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mount Abu',
    destinationId: 50337,
    latitude: 24.5926,
    longitude: 72.7156,
  },
  {
    sortOrder: 68,
    selectable: true,
    destinationUrlName: 'Mumbai',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.953',
    parentId: 723,
    timeZone: 'Asia/Kolkata',
    iataCode: 'BOM',
    destinationType: 'CITY',
    destinationName: 'Mumbai',
    destinationId: 953,
    latitude: 19.017615,
    longitude: 72.856164,
  },
  {
    sortOrder: 69,
    selectable: true,
    destinationUrlName: 'Munnar',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.964.25293',
    parentId: 964,
    timeZone: 'Asia/Kolkata',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Munnar',
    destinationId: 25293,
    latitude: 10.0806491,
    longitude: 77.0466683,
  },
  {
    sortOrder: 70,
    selectable: true,
    destinationUrlName: 'Mysore',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.24948.25746',
    parentId: 24948,
    timeZone: 'Asia/Kolkata',
    iataCode: 'MYQ',
    destinationType: 'CITY',
    destinationName: 'Mysore',
    destinationId: 25746,
    latitude: 12.296381,
    longitude: 76.637145,
  },
  {
    sortOrder: 71,
    selectable: true,
    destinationUrlName: 'Mysore-District',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.24948.51717',
    parentId: 24948,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mysore District',
    destinationId: 51717,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 72,
    selectable: true,
    destinationUrlName: 'Nagpur',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.25170.50881',
    parentId: 25170,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nagpur',
    destinationId: 50881,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 73,
    selectable: true,
    destinationUrlName: 'Nainital',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22732.50425',
    parentId: 22732,
    timeZone: 'Asia/Kolkata',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nainital',
    destinationId: 50425,
    latitude: 29.38526,
    longitude: 79.468361,
  },
  {
    sortOrder: 74,
    selectable: true,
    destinationUrlName: 'Nanded',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.25170.51551',
    parentId: 25170,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nanded',
    destinationId: 51551,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 75,
    selectable: true,
    destinationUrlName: 'Nashik',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.25170.50879',
    parentId: 25170,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nashik',
    destinationId: 50879,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 76,
    selectable: true,
    destinationUrlName: 'Neil-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.23571.51618',
    parentId: 23571,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Neil Island',
    destinationId: 51618,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 77,
    selectable: true,
    destinationUrlName: 'New-Delhi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.804',
    parentId: 723,
    timeZone: 'Asia/Kolkata',
    iataCode: 'DEL',
    destinationType: 'CITY',
    destinationName: 'New Delhi',
    destinationId: 804,
    latitude: 28.635308,
    longitude: 77.22496,
  },
  {
    sortOrder: 78,
    selectable: true,
    destinationUrlName: 'North-Goa-District',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.4594.51584',
    parentId: 4594,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'North Goa District',
    destinationId: 51584,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 79,
    selectable: true,
    destinationUrlName: 'Orccha',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.23970.50857',
    parentId: 23970,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Orccha',
    destinationId: 50857,
    latitude: 25.3734587385,
    longitude: 78.6277278422,
  },
  {
    sortOrder: 80,
    selectable: true,
    destinationUrlName: 'Patna',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.26562.50874',
    parentId: 26562,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Patna',
    destinationId: 50874,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 81,
    selectable: true,
    destinationUrlName: 'Pelling',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.23771.50858',
    parentId: 23771,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Pelling',
    destinationId: 50858,
    latitude: 27.320258188,
    longitude: 88.2399558831,
  },
  {
    sortOrder: 82,
    selectable: true,
    destinationUrlName: 'Pondicherry',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22690',
    parentId: 723,
    timeZone: 'Asia/Kolkata',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Pondicherry',
    destinationId: 22690,
    latitude: 11.913945,
    longitude: 79.815714,
  },
  {
    sortOrder: 83,
    selectable: true,
    destinationUrlName: 'Port-Blair',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.23571.50896',
    parentId: 23571,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Port Blair',
    destinationId: 50896,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 84,
    selectable: true,
    destinationUrlName: 'Pune',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.25170.26473',
    parentId: 25170,
    timeZone: 'Asia/Kolkata',
    iataCode: 'PNQ',
    destinationType: 'CITY',
    destinationName: 'Pune',
    destinationId: 26473,
    latitude: 18.520333,
    longitude: 73.860377,
  },
  {
    sortOrder: 85,
    selectable: true,
    destinationUrlName: 'Pushkar',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.4982.50259',
    parentId: 4982,
    timeZone: 'Asia/Kolkata',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Pushkar',
    destinationId: 50259,
    latitude: 26.4886,
    longitude: 74.5509,
  },
  {
    sortOrder: 86,
    selectable: true,
    destinationUrlName: 'Rajgir',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.26562.51576',
    parentId: 26562,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Rajgir',
    destinationId: 51576,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 87,
    selectable: true,
    destinationUrlName: 'Rajkot',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.24557.50913',
    parentId: 24557,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Rajkot',
    destinationId: 50913,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 88,
    selectable: true,
    destinationUrlName: 'Ranthambore-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.4982.50260',
    parentId: 4982,
    timeZone: 'Asia/Kolkata',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ranthambore National Park',
    destinationId: 50260,
    latitude: 26.0173,
    longitude: 76.5026,
  },
  {
    sortOrder: 89,
    selectable: true,
    destinationUrlName: 'Ratnagiri',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.25170.51529',
    parentId: 25170,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ratnagiri',
    destinationId: 51529,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 90,
    selectable: true,
    destinationUrlName: 'Rishikesh',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22732.22733',
    parentId: 22732,
    timeZone: 'Asia/Kolkata',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Rishikesh',
    destinationId: 22733,
    latitude: 30.086732,
    longitude: 78.268159,
  },
  {
    sortOrder: 91,
    selectable: true,
    destinationUrlName: 'Sam',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.4982.51907',
    parentId: 4982,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sam',
    destinationId: 51907,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 92,
    selectable: true,
    destinationUrlName: 'Sangla',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22732.51593',
    parentId: 22732,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sangla',
    destinationId: 51593,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 93,
    selectable: true,
    destinationUrlName: 'Sankri',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22732.51941',
    parentId: 22732,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sankri',
    destinationId: 51941,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 94,
    selectable: true,
    destinationUrlName: 'Sasan-Gir',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.24557.50424',
    parentId: 24557,
    timeZone: 'Asia/Kolkata',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sasan Gir',
    destinationId: 50424,
    latitude: 21.09052,
    longitude: 70.83582,
  },
  {
    sortOrder: 95,
    selectable: true,
    destinationUrlName: 'Sawai-Madhopur',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.4982.50258',
    parentId: 4982,
    timeZone: 'Asia/Kolkata',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sawai Madhopur',
    destinationId: 50258,
    latitude: 26.0124,
    longitude: 76.356,
  },
  {
    sortOrder: 96,
    selectable: true,
    destinationUrlName: 'Shillong',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.51192.51511',
    parentId: 51192,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Shillong',
    destinationId: 51511,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 97,
    selectable: true,
    destinationUrlName: 'Shimla',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22732.25944',
    parentId: 22732,
    timeZone: 'Asia/Kolkata',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Shimla',
    destinationId: 25944,
    latitude: 31.104955,
    longitude: 77.173523,
  },
  {
    sortOrder: 98,
    selectable: true,
    destinationUrlName: 'Shirdi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.25170.50890',
    parentId: 25170,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Shirdi',
    destinationId: 50890,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 99,
    selectable: true,
    destinationUrlName: 'Srinagar',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22620.23017',
    parentId: 22620,
    timeZone: 'Asia/Kolkata',
    iataCode: 'SXR',
    destinationType: 'CITY',
    destinationName: 'Srinagar',
    destinationId: 23017,
    latitude: 34.083752,
    longitude: 74.79833,
  },
  {
    sortOrder: 100,
    selectable: true,
    destinationUrlName: 'Tawang',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.51544.52179',
    parentId: 51544,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tawang',
    destinationId: 52179,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 101,
    selectable: true,
    destinationUrlName: 'Thanjavur',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.4981.27741',
    parentId: 4981,
    timeZone: 'Asia/Kolkata',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Thanjavur',
    destinationId: 27741,
    latitude: 10.787,
    longitude: 79.13783,
  },
  {
    sortOrder: 102,
    selectable: true,
    destinationUrlName: 'Thekkady',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.964.50427',
    parentId: 964,
    timeZone: 'Asia/Kolkata',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Thekkady',
    destinationId: 50427,
    latitude: 9.60177,
    longitude: 77.170822,
  },
  {
    sortOrder: 103,
    selectable: true,
    destinationUrlName: 'Tiruvannamalai',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.4981.51534',
    parentId: 4981,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tiruvannamalai',
    destinationId: 51534,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 104,
    selectable: true,
    destinationUrlName: 'Trivandrum',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.964.4629',
    parentId: 964,
    timeZone: 'Asia/Kolkata',
    iataCode: 'TRV',
    destinationType: 'CITY',
    destinationName: 'Trivandrum',
    destinationId: 4629,
    latitude: 8.522797,
    longitude: 76.947521,
  },
  {
    sortOrder: 105,
    selectable: true,
    destinationUrlName: 'Tuticorin',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.4589',
    parentId: 723,
    timeZone: 'Asia/Kolkata',
    iataCode: 'TCR',
    destinationType: 'CITY',
    destinationName: 'Tuticorin',
    destinationId: 4589,
    latitude: 8.764166,
    longitude: 78.134836,
  },
  {
    sortOrder: 106,
    selectable: true,
    destinationUrlName: 'Udaipur',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.4982.5106',
    parentId: 4982,
    timeZone: 'Asia/Kolkata',
    iataCode: 'UDR',
    destinationType: 'CITY',
    destinationName: 'Udaipur',
    destinationId: 5106,
    latitude: 24.5712699,
    longitude: 73.6915439,
  },
  {
    sortOrder: 107,
    selectable: true,
    destinationUrlName: 'Uttarkashi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22732.51600',
    parentId: 22732,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Uttarkashi',
    destinationId: 51600,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 108,
    selectable: true,
    destinationUrlName: 'Vadodara',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.24557.50883',
    parentId: 24557,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Vadodara',
    destinationId: 50883,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 109,
    selectable: true,
    destinationUrlName: 'Varanasi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22014.22015',
    parentId: 22014,
    timeZone: 'Asia/Kolkata',
    iataCode: 'VNS',
    destinationType: 'CITY',
    destinationName: 'Varanasi',
    destinationId: 22015,
    latitude: 25.31765,
    longitude: 82.97391,
  },
  {
    sortOrder: 110,
    selectable: true,
    destinationUrlName: 'Varanasi-District',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.22014.51752',
    parentId: 22014,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Varanasi District',
    destinationId: 51752,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 111,
    selectable: true,
    destinationUrlName: 'Visakhapatnam',
    defaultCurrencyCode: 'USD',
    lookupId: '2.723.51191.51509',
    parentId: 51191,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Visakhapatnam',
    destinationId: 51509,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 97,
    selectable: true,
    destinationUrlName: 'Indonesia',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15',
    parentId: 2,
    timeZone: 'Asia/Jakarta',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Indonesia',
    destinationId: 15,
    latitude: -0.789275,
    longitude: 113.921327,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Bali',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.98',
    parentId: 15,
    timeZone: 'Asia/Makassar',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Bali',
    destinationId: 98,
    latitude: -8.4095178,
    longitude: 115.188916,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Bintan-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.51526',
    parentId: 15,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Bintan Island',
    destinationId: 51526,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Central-Java',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.807',
    parentId: 15,
    timeZone: 'Asia/Jakarta',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Central Java',
    destinationId: 807,
    latitude: -7.150832,
    longitude: 110.140872,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'East-Java',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.24869',
    parentId: 15,
    timeZone: 'Asia/Jakarta',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'East Java',
    destinationId: 24869,
    latitude: -7.537386,
    longitude: 112.239184,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'East-Nusa-Tenggara',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.23784',
    parentId: 15,
    timeZone: 'Asia/Makassar',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'East Nusa Tenggara',
    destinationId: 23784,
    latitude: -8.6574,
    longitude: 121.0794,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Gili-Islands',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.32622',
    parentId: 15,
    timeZone: 'Asia/Makassar',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Gili Islands',
    destinationId: 32622,
    latitude: -8.351581,
    longitude: 116.056176,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Maluku-Islands',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.5084',
    parentId: 15,
    timeZone: 'Asia/Jayapura',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Maluku Islands',
    destinationId: 5084,
    latitude: -2.8465,
    longitude: 128.9735,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'South-Sulawesi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.25687',
    parentId: 15,
    timeZone: 'Asia/Makassar',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'South Sulawesi',
    destinationId: 25687,
    latitude: -3.9127,
    longitude: 120.043,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Sumatra',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.4865',
    parentId: 15,
    timeZone: 'Europe/Moscow',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Sumatra',
    destinationId: 4865,
    latitude: 55.7296,
    longitude: 37.6452,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'West-Java',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.24416',
    parentId: 15,
    timeZone: 'Asia/Jakarta',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'West Java',
    destinationId: 24416,
    latitude: -6.8362,
    longitude: 107.7391,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'West-Papua',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.22660',
    parentId: 15,
    timeZone: 'Asia/Jayapura',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'West Papua',
    destinationId: 22660,
    latitude: -2.1096,
    longitude: 133.1535,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Aceh',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.4865.24524',
    parentId: 4865,
    timeZone: 'Asia/Jakarta',
    iataCode: 'BTJ',
    destinationType: 'CITY',
    destinationName: 'Aceh',
    destinationId: 24524,
    latitude: 4.63713,
    longitude: 96.801979,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Ambon',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.5084.5085',
    parentId: 5084,
    timeZone: 'Asia/Jayapura',
    iataCode: 'AMQ',
    destinationType: 'CITY',
    destinationName: 'Ambon',
    destinationId: 5085,
    latitude: -3.711992,
    longitude: 128.16747,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Bandung',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.24416.24417',
    parentId: 24416,
    timeZone: 'Asia/Jakarta',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bandung',
    destinationId: 24417,
    latitude: -6.91746,
    longitude: 107.61912,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Banyuwangi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.24869.50506',
    parentId: 24869,
    timeZone: 'Asia/Jakarta',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Banyuwangi',
    destinationId: 50506,
    latitude: -8.21029,
    longitude: 114.373528,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Batam',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.50587',
    parentId: 15,
    timeZone: 'Asia/Jakarta',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Batam',
    destinationId: 50587,
    latitude: 1.12878,
    longitude: 104.040337,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Batam-Center',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.50588',
    parentId: 15,
    timeZone: 'Asia/Jakarta',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Batam Center',
    destinationId: 50588,
    latitude: 1.10982,
    longitude: 104.04165,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Borobudur',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.807.51531',
    parentId: 807,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Borobudur',
    destinationId: 51531,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Bukittinggi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.4865.51575',
    parentId: 4865,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bukittinggi',
    destinationId: 51575,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Candidasa',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.98.42862',
    parentId: 98,
    timeZone: 'Asia/Makassar',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Candidasa',
    destinationId: 42862,
    latitude: -8.4993763,
    longitude: 115.5652961,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Gili-Trawangan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.32622.50505',
    parentId: 32622,
    timeZone: 'Asia/Makassar',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Gili Trawangan',
    destinationId: 50505,
    latitude: -8.35097,
    longitude: 116.037292,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Jakarta',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.24416.4633',
    parentId: 24416,
    timeZone: 'Asia/Makassar',
    iataCode: 'JKT',
    destinationType: 'CITY',
    destinationName: 'Jakarta',
    destinationId: 4633,
    latitude: -6.20876,
    longitude: 106.8456,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Jimbaran',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.98.35681',
    parentId: 98,
    timeZone: 'Asia/Makassar',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Jimbaran',
    destinationId: 35681,
    latitude: -8.781787,
    longitude: 115.165214,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Komodo',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.4631',
    parentId: 15,
    timeZone: 'Asia/Makassar',
    iataCode: 'LBJ',
    destinationType: 'CITY',
    destinationName: 'Komodo',
    destinationId: 4631,
    latitude: -8.582571,
    longitude: 119.489866,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Kuta',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.98.22290',
    parentId: 98,
    timeZone: 'Asia/Makassar',
    iataCode: 'DPS',
    destinationType: 'CITY',
    destinationName: 'Kuta',
    destinationId: 22290,
    latitude: -8.7238,
    longitude: 115.17523,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Labuan-Bajo',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.23784.50484',
    parentId: 23784,
    timeZone: 'Asia/Makassar',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Labuan Bajo',
    destinationId: 50484,
    latitude: -8.46292,
    longitude: 119.873619,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Lagoi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.50593',
    parentId: 15,
    timeZone: 'Asia/Jakarta',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lagoi',
    destinationId: 50593,
    latitude: 1.172365,
    longitude: 104.377526,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Lombok',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.22869',
    parentId: 15,
    timeZone: 'Asia/Makassar',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lombok',
    destinationId: 22869,
    latitude: -8.642452,
    longitude: 116.355139,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Makassar',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.25687.50590',
    parentId: 25687,
    timeZone: 'Asia/Makassar',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Makassar',
    destinationId: 50590,
    latitude: -5.13732,
    longitude: 119.428238,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Malang',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.24869.50503',
    parentId: 24869,
    timeZone: 'Asia/Jakarta',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Malang',
    destinationId: 50503,
    latitude: -7.96662,
    longitude: 112.632629,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Manado',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.50663',
    parentId: 15,
    timeZone: 'Asia/Makassar',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Manado',
    destinationId: 50663,
    latitude: 1.46938,
    longitude: 124.84433,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Medan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.4865.4866',
    parentId: 4865,
    timeZone: 'Asia/Jakarta',
    iataCode: 'MES',
    destinationType: 'CITY',
    destinationName: 'Medan',
    destinationId: 4866,
    latitude: 3.594306,
    longitude: 98.679263,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'Nusa-Dua',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.98.22287',
    parentId: 98,
    timeZone: 'Asia/Makassar',
    iataCode: 'DPS',
    destinationType: 'CITY',
    destinationName: 'Nusa Dua',
    destinationId: 22287,
    latitude: -8.819412,
    longitude: 115.222332,
  },
  {
    sortOrder: 23,
    selectable: true,
    destinationUrlName: 'Nusa-Lembongan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.98.23621',
    parentId: 98,
    timeZone: 'Asia/Makassar',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nusa Lembongan',
    destinationId: 23621,
    latitude: -8.677027,
    longitude: 115.457999,
  },
  {
    sortOrder: 24,
    selectable: true,
    destinationUrlName: 'Padang',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.4865.50844',
    parentId: 4865,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Padang',
    destinationId: 50844,
    latitude: -0.9452244693,
    longitude: 100.4211366013,
  },
  {
    sortOrder: 25,
    selectable: true,
    destinationUrlName: 'Pangkalan-Bun',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.50589',
    parentId: 15,
    timeZone: 'Asia/Pontianak',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Pangkalan Bun',
    destinationId: 50589,
    latitude: -2.688962,
    longitude: 111.622398,
  },
  {
    sortOrder: 26,
    selectable: true,
    destinationUrlName: 'Pemuteran',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.98.51549',
    parentId: 98,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Pemuteran',
    destinationId: 51549,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 27,
    selectable: true,
    destinationUrlName: 'Semarang',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.807.24870',
    parentId: 807,
    timeZone: 'Asia/Jakarta',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Semarang',
    destinationId: 24870,
    latitude: -7.004836,
    longitude: 110.442278,
  },
  {
    sortOrder: 28,
    selectable: true,
    destinationUrlName: 'Seminyak',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.98.34198',
    parentId: 98,
    timeZone: 'Asia/Makassar',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Seminyak',
    destinationId: 34198,
    latitude: -8.68877,
    longitude: 115.161267,
  },
  {
    sortOrder: 29,
    selectable: true,
    destinationUrlName: 'Surabaya',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.24869.23060',
    parentId: 24869,
    timeZone: 'Asia/Jakarta',
    iataCode: 'SUB',
    destinationType: 'CITY',
    destinationName: 'Surabaya',
    destinationId: 23060,
    latitude: -7.257927,
    longitude: 112.762149,
  },
  {
    sortOrder: 30,
    selectable: true,
    destinationUrlName: 'Tanjung-Benoa',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.98.35829',
    parentId: 98,
    timeZone: 'Asia/Makassar',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tanjung Benoa',
    destinationId: 35829,
    latitude: -8.770584,
    longitude: 115.22163,
  },
  {
    sortOrder: 31,
    selectable: true,
    destinationUrlName: 'Tetebatu',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.22869.50993',
    parentId: 22869,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tetebatu',
    destinationId: 50993,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 32,
    selectable: true,
    destinationUrlName: 'Ubud',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.98.5467',
    parentId: 98,
    timeZone: 'Asia/Makassar',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ubud',
    destinationId: 5467,
    latitude: -8.5192680019,
    longitude: 115.2632979979,
  },
  {
    sortOrder: 33,
    selectable: true,
    destinationUrlName: 'Yogyakarta',
    defaultCurrencyCode: 'USD',
    lookupId: '2.15.807.22560',
    parentId: 807,
    timeZone: 'Asia/Jakarta',
    iataCode: 'JOG',
    destinationType: 'CITY',
    destinationName: 'Yogyakarta',
    destinationId: 22560,
    latitude: -7.79558,
    longitude: 110.36949,
  },
  {
    sortOrder: 98,
    selectable: true,
    destinationUrlName: 'Ireland',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.56',
    parentId: 6,
    timeZone: 'Europe/Dublin',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Ireland',
    destinationId: 56,
    latitude: 53.41291,
    longitude: -8.24389,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'South-East-Ireland',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.56.23236',
    parentId: 56,
    timeZone: 'Europe/Dublin',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'South East Ireland',
    destinationId: 23236,
    latitude: 53.41291,
    longitude: -8.24389,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'South-West-Ireland',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.56.22038',
    parentId: 56,
    timeZone: 'Europe/Dublin',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'South West Ireland',
    destinationId: 22038,
    latitude: 52.451806,
    longitude: -9.021641,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Western-Ireland',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.56.23308',
    parentId: 56,
    timeZone: 'Europe/Dublin',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Western Ireland',
    destinationId: 23308,
    latitude: 53.590319,
    longitude: -9.507106,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Aran-Islands',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.56.23308.51288',
    parentId: 23308,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Aran Islands',
    destinationId: 51288,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Athlone',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.56.5042',
    parentId: 56,
    timeZone: 'Europe/Dublin',
    iataCode: 'NOC',
    destinationType: 'CITY',
    destinationName: 'Athlone',
    destinationId: 5042,
    latitude: 53.428195,
    longitude: -7.926866,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Clifden',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.56.23308.24338',
    parentId: 23308,
    timeZone: 'Europe/Dublin',
    iataCode: 'NNR',
    destinationType: 'CITY',
    destinationName: 'Clifden',
    destinationId: 24338,
    latitude: 53.489191,
    longitude: -10.019275,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Cobh',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.56.22038.23241',
    parentId: 22038,
    timeZone: 'Europe/Dublin',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cobh',
    destinationId: 23241,
    latitude: 51.85034,
    longitude: -8.29429,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Cork',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.56.22038.22039',
    parentId: 22038,
    timeZone: 'Europe/Dublin',
    iataCode: 'ORK',
    destinationType: 'CITY',
    destinationName: 'Cork',
    destinationId: 22039,
    latitude: 51.96926,
    longitude: -8.46469,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Dingle',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.56.22038.25813',
    parentId: 22038,
    timeZone: 'Europe/Dublin',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Dingle',
    destinationId: 25813,
    latitude: 52.140856,
    longitude: -10.264384,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Donegal',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.56.25795',
    parentId: 56,
    timeZone: 'Europe/Dublin',
    iataCode: 'CFN',
    destinationType: 'CITY',
    destinationName: 'Donegal',
    destinationId: 25795,
    latitude: 54.65,
    longitude: -8.1167,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Dublin',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.56.503',
    parentId: 56,
    timeZone: 'Europe/Dublin',
    iataCode: 'DUB',
    destinationType: 'CITY',
    destinationName: 'Dublin',
    destinationId: 503,
    latitude: 53.3481944965,
    longitude: -6.2237548828,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Ennis',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.56.22038.50939',
    parentId: 22038,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ennis',
    destinationId: 50939,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Galway',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.56.23308.5156',
    parentId: 23308,
    timeZone: 'Europe/Dublin',
    iataCode: 'GWY',
    destinationType: 'CITY',
    destinationName: 'Galway',
    destinationId: 5156,
    latitude: 53.2705588,
    longitude: -9.0566677,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Kenmare',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.56.22038.22432',
    parentId: 22038,
    timeZone: 'Europe/Dublin',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kenmare',
    destinationId: 22432,
    latitude: 51.8801,
    longitude: -9.58352,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Kilkenny',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.56.23236.24499',
    parentId: 23236,
    timeZone: 'Europe/Dublin',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kilkenny',
    destinationId: 24499,
    latitude: 52.654096,
    longitude: -7.244014,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Killarney',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.56.22038.911',
    parentId: 22038,
    timeZone: 'Europe/Dublin',
    iataCode: 'KIR',
    destinationType: 'CITY',
    destinationName: 'Killarney',
    destinationId: 911,
    latitude: 52.0597857,
    longitude: -9.5069352,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Limerick',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.56.22038.23186',
    parentId: 22038,
    timeZone: 'Europe/Dublin',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Limerick',
    destinationId: 23186,
    latitude: 52.66802,
    longitude: -8.6305,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Liscannor',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.56.23308.39179',
    parentId: 23308,
    timeZone: 'Europe/Dublin',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Liscannor',
    destinationId: 39179,
    latitude: 52.9383649,
    longitude: -9.4097977,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Ring-of-Kerry',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.56.22038.22378',
    parentId: 22038,
    timeZone: 'Europe/Dublin',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ring of Kerry',
    destinationId: 22378,
    latitude: 51.83872,
    longitude: -9.90085,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Shannon',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.56.22038.32670',
    parentId: 22038,
    timeZone: 'Europe/Dublin',
    iataCode: 'SNN',
    destinationType: 'CITY',
    destinationName: 'Shannon',
    destinationId: 32670,
    latitude: 52.71259,
    longitude: -8.873214,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Sligo',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.56.23308.24337',
    parentId: 23308,
    timeZone: 'Europe/Dublin',
    iataCode: 'SXL',
    destinationType: 'CITY',
    destinationName: 'Sligo',
    destinationId: 24337,
    latitude: 54.27679,
    longitude: -8.476439,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Tralee',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.56.22038.24332',
    parentId: 22038,
    timeZone: 'Europe/Dublin',
    iataCode: 'KIR',
    destinationType: 'CITY',
    destinationName: 'Tralee',
    destinationId: 24332,
    latitude: 52.271288,
    longitude: -9.699363,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Waterford',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.56.23236.23237',
    parentId: 23236,
    timeZone: 'Europe/Dublin',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Waterford',
    destinationId: 23237,
    latitude: 52.25932,
    longitude: -7.11007,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Westport',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.56.23308.23309',
    parentId: 23308,
    timeZone: 'Europe/Dublin',
    iataCode: 'NOC',
    destinationType: 'CITY',
    destinationName: 'Westport',
    destinationId: 23309,
    latitude: 53.802174,
    longitude: -9.513925,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'Wicklow',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.56.25317',
    parentId: 56,
    timeZone: 'Europe/Dublin',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Wicklow',
    destinationId: 25317,
    latitude: 52.980845,
    longitude: -6.033392,
  },
  {
    sortOrder: 99,
    selectable: true,
    destinationUrlName: 'Israel',
    defaultCurrencyCode: 'USD',
    lookupId: '1.919',
    parentId: 1,
    timeZone: 'Asia/Jerusalem',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Israel',
    destinationId: 919,
    latitude: 31.046051,
    longitude: 34.851612,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Dead-Sea',
    defaultCurrencyCode: 'USD',
    lookupId: '1.919.25878',
    parentId: 919,
    timeZone: 'Asia/Jerusalem',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Dead Sea',
    destinationId: 25878,
    latitude: 31.4587,
    longitude: 35.399,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Galilee',
    defaultCurrencyCode: 'USD',
    lookupId: '1.919.24328',
    parentId: 919,
    timeZone: 'Asia/Jerusalem',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Galilee',
    destinationId: 24328,
    latitude: 32.9114,
    longitude: 35.5538,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Ashdod',
    defaultCurrencyCode: 'USD',
    lookupId: '1.919.4470',
    parentId: 919,
    timeZone: 'Asia/Jerusalem',
    iataCode: 'ASH',
    destinationType: 'CITY',
    destinationName: 'Ashdod',
    destinationId: 4470,
    latitude: 31.804381,
    longitude: 34.655314,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Eilat',
    defaultCurrencyCode: 'USD',
    lookupId: '1.919.23242',
    parentId: 919,
    timeZone: 'Asia/Jerusalem',
    iataCode: 'ETH',
    destinationType: 'CITY',
    destinationName: 'Eilat',
    destinationId: 23242,
    latitude: 29.557131,
    longitude: 34.952348,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Haifa',
    defaultCurrencyCode: 'USD',
    lookupId: '1.919.4472',
    parentId: 919,
    timeZone: 'Asia/Jerusalem',
    iataCode: 'HFA',
    destinationType: 'CITY',
    destinationName: 'Haifa',
    destinationId: 4472,
    latitude: 32.794264,
    longitude: 34.990766,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Herzliya',
    defaultCurrencyCode: 'USD',
    lookupId: '1.919.26384',
    parentId: 919,
    timeZone: 'Asia/Jerusalem',
    iataCode: 'HRZ',
    destinationType: 'CITY',
    destinationName: 'Herzliya',
    destinationId: 26384,
    latitude: 32.162627,
    longitude: 34.843103,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Jerusalem',
    defaultCurrencyCode: 'USD',
    lookupId: '1.919.921',
    parentId: 919,
    timeZone: 'Asia/Jerusalem',
    iataCode: 'JRS',
    destinationType: 'CITY',
    destinationName: 'Jerusalem',
    destinationId: 921,
    latitude: 31.7857,
    longitude: 35.2007,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Nazareth',
    defaultCurrencyCode: 'USD',
    lookupId: '1.919.24328.36686',
    parentId: 24328,
    timeZone: 'Asia/Jerusalem',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nazareth',
    destinationId: 36686,
    latitude: 32.7141741,
    longitude: 35.2547979,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Sde-Boker',
    defaultCurrencyCode: 'USD',
    lookupId: '1.919.29363',
    parentId: 919,
    timeZone: 'Asia/Jerusalem',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sde Boker',
    destinationId: 29363,
    latitude: 30.87361,
    longitude: 34.7931,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Tel-Aviv',
    defaultCurrencyCode: 'USD',
    lookupId: '1.919.920',
    parentId: 919,
    timeZone: 'Asia/Jerusalem',
    iataCode: 'TLV',
    destinationType: 'CITY',
    destinationName: 'Tel Aviv',
    destinationId: 920,
    latitude: 32.066157,
    longitude: 34.777821,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Tiberias',
    defaultCurrencyCode: 'USD',
    lookupId: '1.919.24328.24329',
    parentId: 24328,
    timeZone: 'Asia/Jerusalem',
    iataCode: 'RPN',
    destinationType: 'CITY',
    destinationName: 'Tiberias',
    destinationId: 24329,
    latitude: 32.7939,
    longitude: 35.5329,
  },
  {
    sortOrder: 100,
    selectable: true,
    destinationUrlName: 'Jamaica',
    defaultCurrencyCode: 'USD',
    lookupId: '4.34',
    parentId: 4,
    timeZone: 'America/Jamaica',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Jamaica',
    destinationId: 34,
    latitude: 18.109581,
    longitude: -77.297508,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Black-River',
    defaultCurrencyCode: 'USD',
    lookupId: '4.34.50120',
    parentId: 34,
    timeZone: 'America/Jamaica',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Black River',
    destinationId: 50120,
    latitude: 18.0346879,
    longitude: -77.8676606,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Boscobel',
    defaultCurrencyCode: 'USD',
    lookupId: '4.34.50430',
    parentId: 34,
    timeZone: 'America/Jamaica',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Boscobel',
    destinationId: 50430,
    latitude: 17.97338,
    longitude: -76.75867,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Falmouth',
    defaultCurrencyCode: 'USD',
    lookupId: '4.34.4154',
    parentId: 34,
    timeZone: 'America/Jamaica',
    iataCode: 'MBJ',
    destinationType: 'CITY',
    destinationName: 'Falmouth',
    destinationId: 4154,
    latitude: 18.4886209,
    longitude: -77.655457,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Kingston',
    defaultCurrencyCode: 'USD',
    lookupId: '4.34.22634',
    parentId: 34,
    timeZone: 'America/Jamaica',
    iataCode: 'ISO',
    destinationType: 'CITY',
    destinationName: 'Kingston',
    destinationId: 22634,
    latitude: 18.018593,
    longitude: -76.80874,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Lucea',
    defaultCurrencyCode: 'USD',
    lookupId: '4.34.50341',
    parentId: 34,
    timeZone: 'America/Jamaica',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lucea',
    destinationId: 50341,
    latitude: 18.4504,
    longitude: -78.1764,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Montego-Bay',
    defaultCurrencyCode: 'USD',
    lookupId: '4.34.432',
    parentId: 34,
    timeZone: 'America/Jamaica',
    iataCode: 'MBJ',
    destinationType: 'CITY',
    destinationName: 'Montego Bay',
    destinationId: 432,
    latitude: 18.46936,
    longitude: -77.921387,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Negril',
    defaultCurrencyCode: 'USD',
    lookupId: '4.34.433',
    parentId: 34,
    timeZone: 'America/Jamaica',
    iataCode: 'NEG',
    destinationType: 'CITY',
    destinationName: 'Negril',
    destinationId: 433,
    latitude: 18.311018,
    longitude: -78.339386,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Ocho-Rios',
    defaultCurrencyCode: 'USD',
    lookupId: '4.34.434',
    parentId: 34,
    timeZone: 'America/Jamaica',
    iataCode: 'OCJ',
    destinationType: 'CITY',
    destinationName: 'Ocho Rios',
    destinationId: 434,
    latitude: 18.4076319856,
    longitude: -77.0749282837,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Port-Antonio',
    defaultCurrencyCode: 'USD',
    lookupId: '4.34.50121',
    parentId: 34,
    timeZone: 'America/Jamaica',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Port Antonio',
    destinationId: 50121,
    latitude: 18.178136,
    longitude: -76.4618185,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Runaway-Bay',
    defaultCurrencyCode: 'USD',
    lookupId: '4.34.24979',
    parentId: 34,
    timeZone: 'America/Jamaica',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Runaway Bay',
    destinationId: 24979,
    latitude: 18.456366,
    longitude: -77.324653,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Trelawny',
    defaultCurrencyCode: 'USD',
    lookupId: '4.34.435',
    parentId: 34,
    timeZone: 'America/Jamaica',
    iataCode: 'MBJ',
    destinationType: 'CITY',
    destinationName: 'Trelawny',
    destinationId: 435,
    latitude: 18.3526143,
    longitude: -77.6077865,
  },
  {
    sortOrder: 101,
    selectable: true,
    destinationUrlName: 'Japan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16',
    parentId: 2,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Japan',
    destinationId: 16,
    latitude: 36.204824,
    longitude: 138.252924,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Aichi-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50167',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Aichi Prefecture',
    destinationId: 50167,
    latitude: 34.9978316,
    longitude: 136.6940912,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Akita-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50149',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Akita Prefecture',
    destinationId: 50149,
    latitude: 39.6566544,
    longitude: 139.9942819,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Aomori-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50146',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Aomori Prefecture',
    destinationId: 50146,
    latitude: 40.8815027,
    longitude: 139.4690943,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Chiba-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50156',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Chiba Prefecture',
    destinationId: 50156,
    latitude: 35.6037799,
    longitude: 140.0212555,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Ehime-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50182',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Ehime Prefecture',
    destinationId: 50182,
    latitude: 33.5882331,
    longitude: 131.7311399,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Fukui-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50162',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Fukui Prefecture',
    destinationId: 50162,
    latitude: 36.0465735,
    longitude: 136.0752922,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Fukuoka-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50184',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Fukuoka Prefecture',
    destinationId: 50184,
    latitude: 33.6496589,
    longitude: 129.9837709,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Fukushima-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50151',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Fukushima Prefecture',
    destinationId: 50151,
    latitude: 37.3786762,
    longitude: 138.9827857,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Gifu-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50165',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Gifu Prefecture',
    destinationId: 50165,
    latitude: 35.447096,
    longitude: 136.6423476,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Gunma-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50154',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Gunma Prefecture',
    destinationId: 50154,
    latitude: 36.5206802,
    longitude: 138.4730041,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Hiroshima-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50178',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Hiroshima Prefecture',
    destinationId: 50178,
    latitude: 34.4554459,
    longitude: 132.1571108,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Hokkaido',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.5558',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Hokkaido',
    destinationId: 5558,
    latitude: 43.064615,
    longitude: 141.346807,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Hyogo-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50172',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Hyogo Prefecture',
    destinationId: 50172,
    latitude: 34.9097961,
    longitude: 133.739204,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Ibaraki-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50152',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Ibaraki Prefecture',
    destinationId: 50152,
    latitude: 36.33715,
    longitude: 139.1465515,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Ishikawa-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50161',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Ishikawa Prefecture',
    destinationId: 50161,
    latitude: 36.9574367,
    longitude: 135.6830857,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Iwate-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50147',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Iwate Prefecture',
    destinationId: 50147,
    latitude: 39.5935368,
    longitude: 140.2414165,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Kagawa-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50181',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Kagawa Prefecture',
    destinationId: 50181,
    latitude: 34.2881419,
    longitude: 133.6668003,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Kagoshima-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50190',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Kagoshima Prefecture',
    destinationId: 50190,
    latitude: 31.5226366,
    longitude: 130.277961,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Kanagawa-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50158',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Kanagawa Prefecture',
    destinationId: 50158,
    latitude: 35.4004424,
    longitude: 139.0951482,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Kansai-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.25611',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Kansai Prefecture',
    destinationId: 25611,
    latitude: 34.88442,
    longitude: 135.640734,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Kanto',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.23404',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Kanto',
    destinationId: 23404,
    latitude: 35.806677,
    longitude: 139.354706,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'Kochi-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50183',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Kochi Prefecture',
    destinationId: 50183,
    latitude: 33.2916369,
    longitude: 132.8327157,
  },
  {
    sortOrder: 23,
    selectable: true,
    destinationUrlName: 'Kumamoto-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50187',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Kumamoto Prefecture',
    destinationId: 50187,
    latitude: 32.8197835,
    longitude: 130.4201292,
  },
  {
    sortOrder: 24,
    selectable: true,
    destinationUrlName: 'Kyoto-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50170',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Kyoto Prefecture',
    destinationId: 50170,
    latitude: 35.0979177,
    longitude: 135.4386738,
  },
  {
    sortOrder: 25,
    selectable: true,
    destinationUrlName: 'Mie-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50168',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Mie Prefecture',
    destinationId: 50168,
    latitude: 34.4851431,
    longitude: 135.2991802,
  },
  {
    sortOrder: 26,
    selectable: true,
    destinationUrlName: 'Miyagi-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50148',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Miyagi Prefecture',
    destinationId: 50148,
    latitude: 38.35,
    longitude: 140.9667,
  },
  {
    sortOrder: 27,
    selectable: true,
    destinationUrlName: 'Nagano-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50164',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Nagano Prefecture',
    destinationId: 50164,
    latitude: 36.6476164,
    longitude: 137.8343083,
  },
  {
    sortOrder: 28,
    selectable: true,
    destinationUrlName: 'Nagasaki-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50186',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Nagasaki Prefecture',
    destinationId: 50186,
    latitude: 32.7583457,
    longitude: 129.4871702,
  },
  {
    sortOrder: 29,
    selectable: true,
    destinationUrlName: 'Nara-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50173',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Nara Prefecture',
    destinationId: 50173,
    latitude: 34.6578714,
    longitude: 135.7520025,
  },
  {
    sortOrder: 30,
    selectable: true,
    destinationUrlName: 'Niigata-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50159',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Niigata Prefecture',
    destinationId: 50159,
    latitude: 37.8400346,
    longitude: 138.7454126,
  },
  {
    sortOrder: 31,
    selectable: true,
    destinationUrlName: 'Oita-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50188',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Oita Prefecture',
    destinationId: 50188,
    latitude: 33.1795783,
    longitude: 131.4107741,
  },
  {
    sortOrder: 32,
    selectable: true,
    destinationUrlName: 'Okayama-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50177',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Okayama Prefecture',
    destinationId: 50177,
    latitude: 34.7334327,
    longitude: 133.6510934,
  },
  {
    sortOrder: 33,
    selectable: true,
    destinationUrlName: 'Okinawa',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.5614',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Okinawa',
    destinationId: 5614,
    latitude: 26.212401,
    longitude: 127.680932,
  },
  {
    sortOrder: 34,
    selectable: true,
    destinationUrlName: 'Osaka-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50171',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Osaka Prefecture',
    destinationId: 50171,
    latitude: 34.677563,
    longitude: 135.3459764,
  },
  {
    sortOrder: 35,
    selectable: true,
    destinationUrlName: 'Saga-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50185',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Saga Prefecture',
    destinationId: 50185,
    latitude: 33.311309,
    longitude: 129.9787927,
  },
  {
    sortOrder: 36,
    selectable: true,
    destinationUrlName: 'Saitama-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50155',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Saitama Prefecture',
    destinationId: 50155,
    latitude: 35.9154766,
    longitude: 139.5088017,
  },
  {
    sortOrder: 37,
    selectable: true,
    destinationUrlName: 'Shiga-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50169',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Shiga Prefecture',
    destinationId: 50169,
    latitude: 35.2458678,
    longitude: 135.5488017,
  },
  {
    sortOrder: 38,
    selectable: true,
    destinationUrlName: 'Shimane-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50176',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Shimane Prefecture',
    destinationId: 50176,
    latitude: 35.3241327,
    longitude: 131.4078673,
  },
  {
    sortOrder: 39,
    selectable: true,
    destinationUrlName: 'Shizuoka-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50166',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Shizuoka Prefecture',
    destinationId: 50166,
    latitude: 35.108227,
    longitude: 137.764894,
  },
  {
    sortOrder: 40,
    selectable: true,
    destinationUrlName: 'Tochigi-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50153',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Tochigi Prefecture',
    destinationId: 50153,
    latitude: 36.6749982,
    longitude: 139.2489458,
  },
  {
    sortOrder: 41,
    selectable: true,
    destinationUrlName: 'Tokushima-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50180',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Tokushima Prefecture',
    destinationId: 50180,
    latitude: 34.0427041,
    longitude: 134.386856,
  },
  {
    sortOrder: 42,
    selectable: true,
    destinationUrlName: 'Tokyo-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50157',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Tokyo Prefecture',
    destinationId: 50157,
    latitude: 35.5040518,
    longitude: 138.6484296,
  },
  {
    sortOrder: 43,
    selectable: true,
    destinationUrlName: 'Tottori-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50175',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Tottori Prefecture',
    destinationId: 50175,
    latitude: 35.4220364,
    longitude: 133.913213,
  },
  {
    sortOrder: 44,
    selectable: true,
    destinationUrlName: 'Toyama-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50160',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Toyama Prefecture',
    destinationId: 50160,
    latitude: 36.5674817,
    longitude: 137.0865497,
  },
  {
    sortOrder: 45,
    selectable: true,
    destinationUrlName: 'Wakayama-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50174',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Wakayama Prefecture',
    destinationId: 50174,
    latitude: 34.2329348,
    longitude: 135.0167868,
  },
  {
    sortOrder: 46,
    selectable: true,
    destinationUrlName: 'Yamagata-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50150',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Yamagata Prefecture',
    destinationId: 50150,
    latitude: 38.4693494,
    longitude: 138.9618837,
  },
  {
    sortOrder: 47,
    selectable: true,
    destinationUrlName: 'Yamaguchi-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50179',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Yamaguchi Prefecture',
    destinationId: 50179,
    latitude: 34.2547828,
    longitude: 131.072939,
  },
  {
    sortOrder: 48,
    selectable: true,
    destinationUrlName: 'Yamanashi-Prefecture',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50163',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Yamanashi Prefecture',
    destinationId: 50163,
    latitude: 35.568751,
    longitude: 138.0967919,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Aizuwakamatsu',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50151.50831',
    parentId: 50151,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Aizuwakamatsu',
    destinationId: 50831,
    latitude: 37.4483795426,
    longitude: 139.9731891025,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Aomori',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50146.50829',
    parentId: 50146,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Aomori',
    destinationId: 50829,
    latitude: 40.7713566005,
    longitude: 140.7557922112,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Aso',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50187.50826',
    parentId: 50187,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Aso',
    destinationId: 50826,
    latitude: 32.9561327655,
    longitude: 131.0982277421,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Beppu',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.4659',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: 'BPU',
    destinationType: 'CITY',
    destinationName: 'Beppu',
    destinationId: 4659,
    latitude: 33.2845,
    longitude: 131.4907,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Chatan-cho',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.5614.50599',
    parentId: 5614,
    timeZone: 'Asia/Kuala_Lumpur',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Chatan-cho',
    destinationId: 50599,
    latitude: 2.01437,
    longitude: 103.06132,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Chiba',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50156.27171',
    parentId: 50156,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Chiba',
    destinationId: 27171,
    latitude: 35.60727,
    longitude: 140.10629,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Chitose',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.5558.50511',
    parentId: 5558,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Chitose',
    destinationId: 50511,
    latitude: 42.823132,
    longitude: 141.650436,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Fuji',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50166.50602',
    parentId: 50166,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Fuji',
    destinationId: 50602,
    latitude: 35.17049,
    longitude: 138.68103,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Fujikawaguchiko-machi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50163.50515',
    parentId: 50163,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Fujikawaguchiko-machi',
    destinationId: 50515,
    latitude: 38.42548,
    longitude: 140.31229,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Fujinomiya',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50166.50885',
    parentId: 50166,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Fujinomiya',
    destinationId: 50885,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Fujiyoshida',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50163.50516',
    parentId: 50163,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Fujiyoshida',
    destinationId: 50516,
    latitude: 35.488,
    longitude: 138.8072,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Fukuoka',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.4660',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: 'FUK',
    destinationType: 'CITY',
    destinationName: 'Fukuoka',
    destinationId: 4660,
    latitude: 33.59035,
    longitude: 130.40172,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Fukuyama',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50178.50825',
    parentId: 50178,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Fukuyama',
    destinationId: 50825,
    latitude: 34.5217424759,
    longitude: 133.3392359712,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Gero',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50165.50832',
    parentId: 50165,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Gero',
    destinationId: 50832,
    latitude: 35.8411635346,
    longitude: 137.2393471158,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Gifu',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50165.50673',
    parentId: 50165,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Gifu',
    destinationId: 50673,
    latitude: 35.423092,
    longitude: 136.762756,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Ginowan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.5614.50681',
    parentId: 5614,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ginowan',
    destinationId: 50681,
    latitude: 26.2815,
    longitude: 127.7785,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Hakodate',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.4697',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Hakodate',
    destinationId: 4697,
    latitude: 41.794979,
    longitude: 140.739975,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Hakone',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50158.25550',
    parentId: 50158,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Hakone',
    destinationId: 25550,
    latitude: 35.232822,
    longitude: 139.032424,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Himeji',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50172.50592',
    parentId: 50172,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Himeji',
    destinationId: 50592,
    latitude: 34.815147,
    longitude: 134.685349,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Hiroshima',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.4661',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: 'HIJ',
    destinationType: 'CITY',
    destinationName: 'Hiroshima',
    destinationId: 4661,
    latitude: 34.403462,
    longitude: 132.466588,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Imabari',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50182.50675',
    parentId: 50182,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Imabari',
    destinationId: 50675,
    latitude: 34.064968,
    longitude: 133.001373,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'Inuyama',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50167.50827',
    parentId: 50167,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Inuyama',
    destinationId: 50827,
    latitude: 35.3620079098,
    longitude: 136.9824066294,
  },
  {
    sortOrder: 23,
    selectable: true,
    destinationUrlName: 'Iriomote-jima',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.5614.50513',
    parentId: 5614,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Iriomote-jima',
    destinationId: 50513,
    latitude: 34.23889,
    longitude: 132.7013,
  },
  {
    sortOrder: 24,
    selectable: true,
    destinationUrlName: 'Ishigaki',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.5614.25315',
    parentId: 5614,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ishigaki',
    destinationId: 25315,
    latitude: 24.434925,
    longitude: 124.207897,
  },
  {
    sortOrder: 25,
    selectable: true,
    destinationUrlName: 'Ito',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50166.50143',
    parentId: 50166,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ito',
    destinationId: 50143,
    latitude: 34.9458426,
    longitude: 137.9704907,
  },
  {
    sortOrder: 26,
    selectable: true,
    destinationUrlName: 'Izumisano',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50171.50517',
    parentId: 50171,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Izumisano',
    destinationId: 50517,
    latitude: 34.39463,
    longitude: 135.322723,
  },
  {
    sortOrder: 27,
    selectable: true,
    destinationUrlName: 'Kadena-cho',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.5614.50608',
    parentId: 5614,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kadena-cho',
    destinationId: 50608,
    latitude: 26.360996,
    longitude: 127.770163,
  },
  {
    sortOrder: 28,
    selectable: true,
    destinationUrlName: 'Kagoshima',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.4663',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: 'KOJ',
    destinationType: 'CITY',
    destinationName: 'Kagoshima',
    destinationId: 4663,
    latitude: 31.59655,
    longitude: 130.55712,
  },
  {
    sortOrder: 29,
    selectable: true,
    destinationUrlName: 'Kamakura',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50158.26734',
    parentId: 50158,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kamakura',
    destinationId: 26734,
    latitude: 35.31923,
    longitude: 139.54669,
  },
  {
    sortOrder: 30,
    selectable: true,
    destinationUrlName: 'Kanazawa',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.4699',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: 'KMQ',
    destinationType: 'CITY',
    destinationName: 'Kanazawa',
    destinationId: 4699,
    latitude: 36.56133,
    longitude: 136.65621,
  },
  {
    sortOrder: 31,
    selectable: true,
    destinationUrlName: 'Karuizawa',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50164.50835',
    parentId: 50164,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Karuizawa',
    destinationId: 50835,
    latitude: 36.3565355581,
    longitude: 138.5903292665,
  },
  {
    sortOrder: 32,
    selectable: true,
    destinationUrlName: 'Kawagoe',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50155.50683',
    parentId: 50155,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kawagoe',
    destinationId: 50683,
    latitude: 35.91769,
    longitude: 139.491058,
  },
  {
    sortOrder: 33,
    selectable: true,
    destinationUrlName: 'Kawasaki',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50158.50833',
    parentId: 50158,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kawasaki',
    destinationId: 50833,
    latitude: 35.5680069969,
    longitude: 139.6282732627,
  },
  {
    sortOrder: 34,
    selectable: true,
    destinationUrlName: 'Kisarazu',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50156.50830',
    parentId: 50156,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kisarazu',
    destinationId: 50830,
    latitude: 35.3702227816,
    longitude: 139.9820582407,
  },
  {
    sortOrder: 35,
    selectable: true,
    destinationUrlName: 'Kobe',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50172.27432',
    parentId: 50172,
    timeZone: 'Asia/Tokyo',
    iataCode: 'UKB',
    destinationType: 'CITY',
    destinationName: 'Kobe',
    destinationId: 27432,
    latitude: 34.69008,
    longitude: 135.19551,
  },
  {
    sortOrder: 36,
    selectable: true,
    destinationUrlName: 'Kochi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.4691',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: 'KCZ',
    destinationType: 'CITY',
    destinationName: 'Kochi',
    destinationId: 4691,
    latitude: 33.5589,
    longitude: 133.5312,
  },
  {
    sortOrder: 37,
    selectable: true,
    destinationUrlName: 'Kumamoto',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50187.50823',
    parentId: 50187,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kumamoto',
    destinationId: 50823,
    latitude: 32.8847295949,
    longitude: 130.6832151558,
  },
  {
    sortOrder: 38,
    selectable: true,
    destinationUrlName: 'Kurashiki',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50177.50836',
    parentId: 50177,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kurashiki',
    destinationId: 50836,
    latitude: 34.5602800614,
    longitude: 133.7477091246,
  },
  {
    sortOrder: 39,
    selectable: true,
    destinationUrlName: 'Kushiro',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.4693',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: 'KUH',
    destinationType: 'CITY',
    destinationName: 'Kushiro',
    destinationId: 4693,
    latitude: 42.9849,
    longitude: 144.3818,
  },
  {
    sortOrder: 40,
    selectable: true,
    destinationUrlName: 'Kyoto',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.25611.332',
    parentId: 25611,
    timeZone: 'Asia/Tokyo',
    iataCode: 'UKY',
    destinationType: 'CITY',
    destinationName: 'Kyoto',
    destinationId: 332,
    latitude: 35.0116363,
    longitude: 135.7680294,
  },
  {
    sortOrder: 41,
    selectable: true,
    destinationUrlName: 'Matsue',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50176.50837',
    parentId: 50176,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Matsue',
    destinationId: 50837,
    latitude: 35.4665616105,
    longitude: 133.0672835442,
  },
  {
    sortOrder: 42,
    selectable: true,
    destinationUrlName: 'Matsumoto',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50164.50821',
    parentId: 50164,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Matsumoto',
    destinationId: 50821,
    latitude: 36.2013701444,
    longitude: 137.8144947508,
  },
  {
    sortOrder: 43,
    selectable: true,
    destinationUrlName: 'Matsushima-machi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50148.50679',
    parentId: 50148,
    timeZone: 'Africa/Lagos',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Matsushima-machi',
    destinationId: 50679,
    latitude: 9.49551,
    longitude: 8.69528,
  },
  {
    sortOrder: 44,
    selectable: true,
    destinationUrlName: 'Minakami-machi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50154.50598',
    parentId: 50154,
    timeZone: 'Africa/Lagos',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Minakami-machi',
    destinationId: 50598,
    latitude: 9.49551,
    longitude: 8.69528,
  },
  {
    sortOrder: 45,
    selectable: true,
    destinationUrlName: 'Miyajima',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50178.51239',
    parentId: 50178,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Miyajima',
    destinationId: 51239,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 46,
    selectable: true,
    destinationUrlName: 'Miyakojima',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.5614.50596',
    parentId: 5614,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Miyakojima',
    destinationId: 50596,
    latitude: 24.790583,
    longitude: 125.298004,
  },
  {
    sortOrder: 47,
    selectable: true,
    destinationUrlName: 'Miyoshi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50180.50689',
    parentId: 50180,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Miyoshi',
    destinationId: 50689,
    latitude: 34.81124,
    longitude: 132.84751,
  },
  {
    sortOrder: 48,
    selectable: true,
    destinationUrlName: 'Motobu-cho',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.5614.50512',
    parentId: 5614,
    timeZone: 'Asia/Ho_Chi_Minh',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Motobu-cho',
    destinationId: 50512,
    latitude: 10.34968,
    longitude: 106.46276,
  },
  {
    sortOrder: 49,
    selectable: true,
    destinationUrlName: 'Musashino',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50157.50604',
    parentId: 50157,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Musashino',
    destinationId: 50604,
    latitude: 35.7177,
    longitude: 139.5661,
  },
  {
    sortOrder: 50,
    selectable: true,
    destinationUrlName: 'Nagano',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50164.23523',
    parentId: 50164,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nagano',
    destinationId: 23523,
    latitude: 36.175158,
    longitude: 138.040184,
  },
  {
    sortOrder: 51,
    selectable: true,
    destinationUrlName: 'Nagasaki',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.4665',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: 'NGS',
    destinationType: 'CITY',
    destinationName: 'Nagasaki',
    destinationId: 4665,
    latitude: 32.75029,
    longitude: 129.87767,
  },
  {
    sortOrder: 52,
    selectable: true,
    destinationUrlName: 'Nago',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.5614.50518',
    parentId: 5614,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nago',
    destinationId: 50518,
    latitude: 26.59969,
    longitude: 127.97683,
  },
  {
    sortOrder: 53,
    selectable: true,
    destinationUrlName: 'Nagoya',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.4701',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: 'NGO',
    destinationType: 'CITY',
    destinationName: 'Nagoya',
    destinationId: 4701,
    latitude: 35.18145,
    longitude: 136.9064,
  },
  {
    sortOrder: 54,
    selectable: true,
    destinationUrlName: 'Naha',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.4666',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: 'OKA',
    destinationType: 'CITY',
    destinationName: 'Naha',
    destinationId: 4666,
    latitude: 26.212312,
    longitude: 127.679157,
  },
  {
    sortOrder: 55,
    selectable: true,
    destinationUrlName: 'Nakafurano-cho',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.5558.50677',
    parentId: 5558,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nakafurano-cho',
    destinationId: 50677,
    latitude: 43.40542,
    longitude: 142.425097,
  },
  {
    sortOrder: 56,
    selectable: true,
    destinationUrlName: 'Namba',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50171.51459',
    parentId: 50171,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Namba',
    destinationId: 51459,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 57,
    selectable: true,
    destinationUrlName: 'Nara',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50173.50510',
    parentId: 50173,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nara',
    destinationId: 50510,
    latitude: 34.685085,
    longitude: 135.804993,
  },
  {
    sortOrder: 58,
    selectable: true,
    destinationUrlName: 'Narita',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50156.50822',
    parentId: 50156,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Narita',
    destinationId: 50822,
    latitude: 35.8179234874,
    longitude: 140.3601963054,
  },
  {
    sortOrder: 59,
    selectable: true,
    destinationUrlName: 'Naruto',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50180.50838',
    parentId: 50180,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Naruto',
    destinationId: 50838,
    latitude: 34.1908728341,
    longitude: 134.5445005851,
  },
  {
    sortOrder: 60,
    selectable: true,
    destinationUrlName: 'Nasu-machi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50153.50688',
    parentId: 50153,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nasu-machi',
    destinationId: 50688,
    latitude: 38.42548,
    longitude: 140.31229,
  },
  {
    sortOrder: 61,
    selectable: true,
    destinationUrlName: 'Nikko',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50153.50514',
    parentId: 50153,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nikko',
    destinationId: 50514,
    latitude: 36.751862,
    longitude: 139.608002,
  },
  {
    sortOrder: 62,
    selectable: true,
    destinationUrlName: 'Nishio',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50167.50828',
    parentId: 50167,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nishio',
    destinationId: 50828,
    latitude: 34.8338507098,
    longitude: 137.0708675342,
  },
  {
    sortOrder: 63,
    selectable: true,
    destinationUrlName: 'Noboribetsu',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.5558.50676',
    parentId: 5558,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Noboribetsu',
    destinationId: 50676,
    latitude: 43.38376,
    longitude: 142.56696,
  },
  {
    sortOrder: 64,
    selectable: true,
    destinationUrlName: 'Odawara',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50158.50595',
    parentId: 50158,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Odawara',
    destinationId: 50595,
    latitude: 35.26024,
    longitude: 139.16823,
  },
  {
    sortOrder: 65,
    selectable: true,
    destinationUrlName: 'Oita',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50188.28080',
    parentId: 50188,
    timeZone: 'Asia/Tokyo',
    iataCode: 'OIT',
    destinationType: 'CITY',
    destinationName: 'Oita',
    destinationId: 28080,
    latitude: 33.23956,
    longitude: 131.60927,
  },
  {
    sortOrder: 66,
    selectable: true,
    destinationUrlName: 'Okayama',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50177.28079',
    parentId: 50177,
    timeZone: 'Asia/Tokyo',
    iataCode: 'OKJ',
    destinationType: 'CITY',
    destinationName: 'Okayama',
    destinationId: 28079,
    latitude: 34.65515,
    longitude: 133.9195,
  },
  {
    sortOrder: 67,
    selectable: true,
    destinationUrlName: 'Onna-son',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.5614.50489',
    parentId: 5614,
    timeZone: 'Europe/Madrid',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Onna-son',
    destinationId: 50489,
    latitude: 39.5743,
    longitude: 2.71506,
  },
  {
    sortOrder: 68,
    selectable: true,
    destinationUrlName: 'Onomichi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50178.50824',
    parentId: 50178,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Onomichi',
    destinationId: 50824,
    latitude: 34.4294904228,
    longitude: 133.1614875941,
  },
  {
    sortOrder: 69,
    selectable: true,
    destinationUrlName: 'Osaka',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.25611.333',
    parentId: 25611,
    timeZone: 'Asia/Tokyo',
    iataCode: 'OSA',
    destinationType: 'CITY',
    destinationName: 'Osaka',
    destinationId: 333,
    latitude: 34.6937378,
    longitude: 135.5021651,
  },
  {
    sortOrder: 70,
    selectable: true,
    destinationUrlName: 'Otaru',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.4667',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: 'WKJ',
    destinationType: 'CITY',
    destinationName: 'Otaru',
    destinationId: 4667,
    latitude: 43.1902,
    longitude: 140.9942,
  },
  {
    sortOrder: 71,
    selectable: true,
    destinationUrlName: 'Otsu',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50169.50684',
    parentId: 50169,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Otsu',
    destinationId: 50684,
    latitude: 35.0064,
    longitude: 135.86741,
  },
  {
    sortOrder: 72,
    selectable: true,
    destinationUrlName: 'Sakaiminato',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.4687',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: 'YGJ',
    destinationType: 'CITY',
    destinationName: 'Sakaiminato',
    destinationId: 4687,
    latitude: 35.5397,
    longitude: 133.2316,
  },
  {
    sortOrder: 73,
    selectable: true,
    destinationUrlName: 'Sapporo',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.5558.5559',
    parentId: 5558,
    timeZone: 'Asia/Tokyo',
    iataCode: 'SPK',
    destinationType: 'CITY',
    destinationName: 'Sapporo',
    destinationId: 5559,
    latitude: 43.062096,
    longitude: 141.354376,
  },
  {
    sortOrder: 74,
    selectable: true,
    destinationUrlName: 'Sendai',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50148.50597',
    parentId: 50148,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sendai',
    destinationId: 50597,
    latitude: 31.82209,
    longitude: 130.293488,
  },
  {
    sortOrder: 75,
    selectable: true,
    destinationUrlName: 'Shimonoseki',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50179.50840',
    parentId: 50179,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Shimonoseki',
    destinationId: 50840,
    latitude: 34.1711745172,
    longitude: 131.000906404,
  },
  {
    sortOrder: 76,
    selectable: true,
    destinationUrlName: 'Shizuoka',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50166.50686',
    parentId: 50166,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Shizuoka',
    destinationId: 50686,
    latitude: 34.985828,
    longitude: 138.385391,
  },
  {
    sortOrder: 77,
    selectable: true,
    destinationUrlName: 'Takamatsu',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50181.50594',
    parentId: 50181,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Takamatsu',
    destinationId: 50594,
    latitude: 34.344742,
    longitude: 134.044785,
  },
  {
    sortOrder: 78,
    selectable: true,
    destinationUrlName: 'Takashima',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50169.50685',
    parentId: 50169,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Takashima',
    destinationId: 50685,
    latitude: 33.94186,
    longitude: 134.667526,
  },
  {
    sortOrder: 79,
    selectable: true,
    destinationUrlName: 'Takayama',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50165.25943',
    parentId: 50165,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Takayama',
    destinationId: 25943,
    latitude: 36.161045,
    longitude: 137.253952,
  },
  {
    sortOrder: 80,
    selectable: true,
    destinationUrlName: 'Taketomi-jima',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.5614.51226',
    parentId: 5614,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Taketomi-jima',
    destinationId: 51226,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 81,
    selectable: true,
    destinationUrlName: 'Toba',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50168.50834',
    parentId: 50168,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Toba',
    destinationId: 50834,
    latitude: 34.4473585262,
    longitude: 136.8597720618,
  },
  {
    sortOrder: 82,
    selectable: true,
    destinationUrlName: 'Tokoname',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50167.50674',
    parentId: 50167,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tokoname',
    destinationId: 50674,
    latitude: 34.875439,
    longitude: 136.841415,
  },
  {
    sortOrder: 83,
    selectable: true,
    destinationUrlName: 'Tokushima',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50180.50839',
    parentId: 50180,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tokushima',
    destinationId: 50839,
    latitude: 34.0507157543,
    longitude: 134.5215463749,
  },
  {
    sortOrder: 84,
    selectable: true,
    destinationUrlName: 'Tokyo',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.23404.334',
    parentId: 23404,
    timeZone: 'Asia/Tokyo',
    iataCode: 'TYO',
    destinationType: 'CITY',
    destinationName: 'Tokyo',
    destinationId: 334,
    latitude: 35.6894875,
    longitude: 139.6917064,
  },
  {
    sortOrder: 85,
    selectable: true,
    destinationUrlName: 'Tomigusuku',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.5614.50687',
    parentId: 5614,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tomigusuku',
    destinationId: 50687,
    latitude: 26.177238,
    longitude: 127.686379,
  },
  {
    sortOrder: 86,
    selectable: true,
    destinationUrlName: 'Totsukawa-mura',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50173.51205',
    parentId: 50173,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Totsukawa-mura',
    destinationId: 51205,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 87,
    selectable: true,
    destinationUrlName: 'Tsuruoka',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50150.50690',
    parentId: 50150,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tsuruoka',
    destinationId: 50690,
    latitude: 38.72854,
    longitude: 139.82913,
  },
  {
    sortOrder: 88,
    selectable: true,
    destinationUrlName: 'Uji',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.50170.50678',
    parentId: 50170,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Uji',
    destinationId: 50678,
    latitude: 34.8844606,
    longitude: 135.7998544,
  },
  {
    sortOrder: 89,
    selectable: true,
    destinationUrlName: 'Uruma',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.5614.50600',
    parentId: 5614,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Uruma',
    destinationId: 50600,
    latitude: 26.49371,
    longitude: 127.95885,
  },
  {
    sortOrder: 90,
    selectable: true,
    destinationUrlName: 'Wakayama',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.4668',
    parentId: 16,
    timeZone: 'Asia/Tokyo',
    iataCode: 'KIX',
    destinationType: 'CITY',
    destinationName: 'Wakayama',
    destinationId: 4668,
    latitude: 34.2304,
    longitude: 135.1707,
  },
  {
    sortOrder: 91,
    selectable: true,
    destinationUrlName: 'Yokohama',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.23404.25747',
    parentId: 23404,
    timeZone: 'Asia/Tokyo',
    iataCode: 'YOK',
    destinationType: 'CITY',
    destinationName: 'Yokohama',
    destinationId: 25747,
    latitude: 35.462209,
    longitude: 139.578735,
  },
  {
    sortOrder: 92,
    selectable: true,
    destinationUrlName: 'Yomitan-son',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.5614.50682',
    parentId: 5614,
    timeZone: 'Asia/Kuala_Lumpur',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Yomitan-son',
    destinationId: 50682,
    latitude: 4.82814,
    longitude: 100.73802,
  },
  {
    sortOrder: 93,
    selectable: true,
    destinationUrlName: 'Zamami-son',
    defaultCurrencyCode: 'USD',
    lookupId: '2.16.5614.50680',
    parentId: 5614,
    timeZone: 'Asia/Tokyo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Zamami-son',
    destinationId: 50680,
    latitude: 26.232525,
    longitude: 127.305581,
  },
  {
    sortOrder: 102,
    selectable: true,
    destinationUrlName: 'Jordan',
    defaultCurrencyCode: 'USD',
    lookupId: '1.744',
    parentId: 1,
    timeZone: 'Asia/Amman',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Jordan',
    destinationId: 744,
    latitude: 30.585164,
    longitude: 36.238414,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Dead-Sea',
    defaultCurrencyCode: 'USD',
    lookupId: '1.744.25874',
    parentId: 744,
    timeZone: 'Asia/Hebron',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Dead Sea',
    destinationId: 25874,
    latitude: 31.55903,
    longitude: 35.47319,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Amman',
    defaultCurrencyCode: 'USD',
    lookupId: '1.744.5503',
    parentId: 744,
    timeZone: 'Asia/Amman',
    iataCode: 'AMM',
    destinationType: 'CITY',
    destinationName: 'Amman',
    destinationId: 5503,
    latitude: 31.949381,
    longitude: 35.932911,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Aqaba',
    defaultCurrencyCode: 'USD',
    lookupId: '1.744.4392',
    parentId: 744,
    timeZone: 'Asia/Amman',
    iataCode: 'AQJ',
    destinationType: 'CITY',
    destinationName: 'Aqaba',
    destinationId: 4392,
    latitude: 29.53192,
    longitude: 35.006084,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Madaba',
    defaultCurrencyCode: 'USD',
    lookupId: '1.744.28019',
    parentId: 744,
    timeZone: 'Asia/Amman',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Madaba',
    destinationId: 28019,
    latitude: 31.71954,
    longitude: 35.79411,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Petra',
    defaultCurrencyCode: 'USD',
    lookupId: '1.744.24520',
    parentId: 744,
    timeZone: 'Etc/GMT+2',
    iataCode: 'VDA',
    destinationType: 'CITY',
    destinationName: 'Petra',
    destinationId: 24520,
    latitude: 30.322135,
    longitude: 35.451604,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Sweimah',
    defaultCurrencyCode: 'USD',
    lookupId: '1.744.50263',
    parentId: 744,
    timeZone: 'Asia/Amman',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sweimah',
    destinationId: 50263,
    latitude: 31.6293,
    longitude: 35.5855,
  },
  {
    sortOrder: 103,
    selectable: true,
    destinationUrlName: 'Kazakhstan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21770',
    parentId: 2,
    timeZone: 'Asia/Atyrau',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Kazakhstan ',
    destinationId: 21770,
    latitude: 46.5940518,
    longitude: 49.0384383,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Shymkent',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21770.51582',
    parentId: 21770,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Shymkent',
    destinationId: 51582,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Almaty',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21770.32977',
    parentId: 21770,
    timeZone: 'Asia/Almaty',
    iataCode: 'ALA',
    destinationType: 'CITY',
    destinationName: 'Almaty',
    destinationId: 32977,
    latitude: 43.224137,
    longitude: 76.851951,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Nur-Sultan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21770.50520',
    parentId: 21770,
    timeZone: 'Asia/Almaty',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nur-Sultan',
    destinationId: 50520,
    latitude: 51.177601,
    longitude: 71.432999,
  },
  {
    sortOrder: 104,
    selectable: true,
    destinationUrlName: 'Kenya',
    defaultCurrencyCode: 'USD',
    lookupId: '1.801',
    parentId: 1,
    timeZone: 'Africa/Nairobi',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Kenya',
    destinationId: 801,
    latitude: -0.023559,
    longitude: 37.906193,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Central-Kenya',
    defaultCurrencyCode: 'USD',
    lookupId: '1.801.24331',
    parentId: 801,
    timeZone: 'Africa/Nairobi',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Central Kenya',
    destinationId: 24331,
    latitude: -1.79597,
    longitude: 37.70207,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Rift-Valley-Province',
    defaultCurrencyCode: 'USD',
    lookupId: '1.801.50980',
    parentId: 801,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Rift Valley Province',
    destinationId: 50980,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Tsavo',
    defaultCurrencyCode: 'USD',
    lookupId: '1.801.51338',
    parentId: 801,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Tsavo',
    destinationId: 51338,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Aberdare-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '1.801.51344',
    parentId: 801,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Aberdare National Park',
    destinationId: 51344,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Amboseli-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '1.801.50431',
    parentId: 801,
    timeZone: 'America/New_York',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Amboseli National Park',
    destinationId: 50431,
    latitude: 39.865952,
    longitude: -75.179733,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Diani-Beach',
    defaultCurrencyCode: 'USD',
    lookupId: '1.801.27403',
    parentId: 801,
    timeZone: 'Africa/Nairobi',
    iataCode: 'UKA',
    destinationType: 'CITY',
    destinationName: 'Diani Beach',
    destinationId: 27403,
    latitude: -4.27976,
    longitude: 39.5947,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Lake-Nakuru-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '1.801.50268',
    parentId: 801,
    timeZone: 'Africa/Nairobi',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lake Nakuru National Park',
    destinationId: 50268,
    latitude: -1.3719,
    longitude: 34.9381,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Maasai-Mara-National-Reserve',
    defaultCurrencyCode: 'USD',
    lookupId: '1.801.50267',
    parentId: 801,
    timeZone: 'Africa/Nairobi',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Maasai Mara National Reserve',
    destinationId: 50267,
    latitude: -1.3719,
    longitude: 34.9381,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Malindi',
    defaultCurrencyCode: 'USD',
    lookupId: '1.801.25668',
    parentId: 801,
    timeZone: 'Africa/Nairobi',
    iataCode: 'MYD',
    destinationType: 'CITY',
    destinationName: 'Malindi',
    destinationId: 25668,
    latitude: -3.21,
    longitude: 40.1,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Mombasa',
    defaultCurrencyCode: 'USD',
    lookupId: '1.801.22167',
    parentId: 801,
    timeZone: 'Africa/Nairobi',
    iataCode: 'MBA',
    destinationType: 'CITY',
    destinationName: 'Mombasa',
    destinationId: 22167,
    latitude: -4.043833,
    longitude: 39.67005,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Mount-Kenya-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '1.801.50432',
    parentId: 801,
    timeZone: 'Pacific/Auckland',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mount Kenya National Park',
    destinationId: 50432,
    latitude: -44.03967,
    longitude: 169.37924,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Nairobi',
    defaultCurrencyCode: 'USD',
    lookupId: '1.801.5280',
    parentId: 801,
    timeZone: 'Africa/Nairobi',
    iataCode: 'NBO',
    destinationType: 'CITY',
    destinationName: 'Nairobi',
    destinationId: 5280,
    latitude: -1.28333,
    longitude: 36.81667,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Naivasha',
    defaultCurrencyCode: 'USD',
    lookupId: '1.801.24331.50271',
    parentId: 24331,
    timeZone: 'Africa/Nairobi',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Naivasha',
    destinationId: 50271,
    latitude: -0.7172,
    longitude: 36.431,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Nanyuki',
    defaultCurrencyCode: 'USD',
    lookupId: '1.801.24331.50867',
    parentId: 24331,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nanyuki',
    destinationId: 50867,
    latitude: 0.0110077958,
    longitude: 37.0764531835,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Narok',
    defaultCurrencyCode: 'USD',
    lookupId: '1.801.50264',
    parentId: 801,
    timeZone: 'Africa/Nairobi',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Narok',
    destinationId: 50264,
    latitude: -1.087543,
    longitude: 35.877064,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Tsavo-National-Park-East',
    defaultCurrencyCode: 'USD',
    lookupId: '1.801.24331.50266',
    parentId: 24331,
    timeZone: 'Africa/Nairobi',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tsavo National Park East',
    destinationId: 50266,
    latitude: -2.1833,
    longitude: 38.4167,
  },
  {
    sortOrder: 105,
    selectable: true,
    destinationUrlName: 'Kosovo',
    defaultCurrencyCode: 'USD',
    lookupId: '6.26852',
    parentId: 6,
    timeZone: 'Europe/Belgrade',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Kosovo',
    destinationId: 26852,
    latitude: 42.60264,
    longitude: 20.90298,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Pristina',
    defaultCurrencyCode: 'USD',
    lookupId: '6.26852.26853',
    parentId: 26852,
    timeZone: 'Europe/Belgrade',
    iataCode: 'PRN',
    destinationType: 'CITY',
    destinationName: 'Pristina',
    destinationId: 26853,
    latitude: 42.66291,
    longitude: 21.1655,
  },
  {
    sortOrder: 106,
    selectable: true,
    destinationUrlName: 'Kuwait',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4917',
    parentId: 1,
    timeZone: 'Asia/Kuwait',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Kuwait',
    destinationId: 4917,
    latitude: 29.3117,
    longitude: 47.4818,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Kuwait-City',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4917.4918',
    parentId: 4917,
    timeZone: 'Asia/Kuwait',
    iataCode: 'KWI',
    destinationType: 'CITY',
    destinationName: 'Kuwait City',
    destinationId: 4918,
    latitude: 29.376961,
    longitude: 47.982443,
  },
  {
    sortOrder: 107,
    selectable: true,
    destinationUrlName: 'Kyrgyzstan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21902',
    parentId: 2,
    timeZone: 'Asia/Bishkek',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Kyrgyzstan',
    destinationId: 21902,
    latitude: 41.474764,
    longitude: 74.512132,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Cholpon-Ata',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21902.51671',
    parentId: 21902,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Cholpon Ata',
    destinationId: 51671,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Karakol',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21902.51564',
    parentId: 21902,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Karakol',
    destinationId: 51564,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Bishkek',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21902.50202',
    parentId: 21902,
    timeZone: 'Asia/Bishkek',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bishkek',
    destinationId: 50202,
    latitude: 42.874622,
    longitude: 74.569763,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Osh',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21902.50340',
    parentId: 21902,
    timeZone: 'Asia/Bishkek',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Osh',
    destinationId: 50340,
    latitude: 40.514,
    longitude: 72.8161,
  },
  {
    sortOrder: 108,
    selectable: true,
    destinationUrlName: 'Laos',
    defaultCurrencyCode: 'USD',
    lookupId: '2.5438',
    parentId: 2,
    timeZone: 'Asia/Vientiane',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Laos',
    destinationId: 5438,
    latitude: 19.8562699977,
    longitude: 102.4954959989,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Luang-Namtha',
    defaultCurrencyCode: 'USD',
    lookupId: '2.5438.51658',
    parentId: 5438,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Luang Namtha',
    destinationId: 51658,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Pak-Beng',
    defaultCurrencyCode: 'USD',
    lookupId: '2.5438.51758',
    parentId: 5438,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Pak Beng',
    destinationId: 51758,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Luang-Prabang',
    defaultCurrencyCode: 'USD',
    lookupId: '2.5438.5466',
    parentId: 5438,
    timeZone: 'Asia/Vientiane',
    iataCode: 'LPQ',
    destinationType: 'CITY',
    destinationName: 'Luang Prabang',
    destinationId: 5466,
    latitude: 19.8833959016,
    longitude: 102.1346874005,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Pakse',
    defaultCurrencyCode: 'USD',
    lookupId: '2.5438.28360',
    parentId: 5438,
    timeZone: 'Asia/Vientiane',
    iataCode: 'PKZ',
    destinationType: 'CITY',
    destinationName: 'Pakse',
    destinationId: 28360,
    latitude: 15.11051,
    longitude: 105.81729,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Phonsavan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.5438.26877',
    parentId: 5438,
    timeZone: 'Asia/Vientiane',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Phonsavan',
    destinationId: 26877,
    latitude: 19.45208,
    longitude: 103.18557,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Vang-Vieng',
    defaultCurrencyCode: 'USD',
    lookupId: '2.5438.24349',
    parentId: 5438,
    timeZone: 'Asia/Vientiane',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Vang Vieng',
    destinationId: 24349,
    latitude: 18.9194,
    longitude: 102.4477,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Vientiane',
    defaultCurrencyCode: 'USD',
    lookupId: '2.5438.5481',
    parentId: 5438,
    timeZone: 'Asia/Vientiane',
    iataCode: 'VTE',
    destinationType: 'CITY',
    destinationName: 'Vientiane',
    destinationId: 5481,
    latitude: 17.9666667,
    longitude: 102.6,
  },
  {
    sortOrder: 109,
    selectable: true,
    destinationUrlName: 'Latvia',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.4479',
    parentId: 6,
    timeZone: 'Europe/Riga',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Latvia',
    destinationId: 4479,
    latitude: 56.8796,
    longitude: 24.6032,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Kuldiga',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.4479.51666',
    parentId: 4479,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Kuldiga',
    destinationId: 51666,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Riga',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.4479.4480',
    parentId: 4479,
    timeZone: 'Europe/Riga',
    iataCode: 'RIX',
    destinationType: 'CITY',
    destinationName: 'Riga',
    destinationId: 4480,
    latitude: 56.94965,
    longitude: 24.10519,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Sigulda',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.4479.25642',
    parentId: 4479,
    timeZone: 'Europe/Riga',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sigulda',
    destinationId: 25642,
    latitude: 57.1538,
    longitude: 24.8595,
  },
  {
    sortOrder: 110,
    selectable: true,
    destinationUrlName: 'Lebanon',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4214',
    parentId: 1,
    timeZone: 'Asia/Beirut',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Lebanon',
    destinationId: 4214,
    latitude: 33.9593082104,
    longitude: 35.7357788086,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Beirut',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4214.4215',
    parentId: 4214,
    timeZone: 'Asia/Beirut',
    iataCode: 'BEY',
    destinationType: 'CITY',
    destinationName: 'Beirut',
    destinationId: 4215,
    latitude: 33.8925049145,
    longitude: 35.4976844788,
  },
  {
    sortOrder: 111,
    selectable: true,
    destinationUrlName: 'Lesotho',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21903',
    parentId: 1,
    timeZone: 'Africa/Maseru',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Lesotho',
    destinationId: 21903,
    latitude: -29.61,
    longitude: 28.2336,
  },
  {
    sortOrder: 112,
    selectable: true,
    destinationUrlName: 'Liechtenstein',
    defaultCurrencyCode: 'USD',
    lookupId: '6.1004',
    parentId: 6,
    timeZone: 'Europe/Vaduz',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Liechtenstein',
    destinationId: 1004,
    latitude: 47.144054,
    longitude: 9.551835,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Vaduz',
    defaultCurrencyCode: 'USD',
    lookupId: '6.1004.50933',
    parentId: 1004,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Vaduz',
    destinationId: 50933,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 113,
    selectable: true,
    destinationUrlName: 'Lithuania',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.58',
    parentId: 6,
    timeZone: 'Europe/Vilnius',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Lithuania',
    destinationId: 58,
    latitude: 55.169438,
    longitude: 23.881275,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Kaunas',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.58.24093',
    parentId: 58,
    timeZone: 'Europe/Vilnius',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kaunas',
    destinationId: 24093,
    latitude: 54.89852,
    longitude: 23.9036,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Klaipeda',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.58.4209',
    parentId: 58,
    timeZone: 'Etc/GMT',
    iataCode: 'PLQ',
    destinationType: 'CITY',
    destinationName: 'Klaipeda',
    destinationId: 4209,
    latitude: 55.703664,
    longitude: 21.145953,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Trakai',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.58.24827',
    parentId: 58,
    timeZone: 'Europe/Vilnius',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Trakai',
    destinationId: 24827,
    latitude: 54.637785,
    longitude: 24.935337,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Vilnius',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.58.5479',
    parentId: 58,
    timeZone: 'Europe/Vilnius',
    iataCode: 'VNO',
    destinationType: 'CITY',
    destinationName: 'Vilnius',
    destinationId: 5479,
    latitude: 54.6871554997,
    longitude: 25.2796514001,
  },
  {
    sortOrder: 114,
    selectable: true,
    destinationUrlName: 'Luxembourg',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21797',
    parentId: 6,
    timeZone: 'Europe/Luxembourg',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Luxembourg',
    destinationId: 21797,
    latitude: 49.8153,
    longitude: 6.1296,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Luxembourg-City',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21797.36689',
    parentId: 21797,
    timeZone: 'Europe/Luxembourg',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Luxembourg City',
    destinationId: 36689,
    latitude: 49.6075997,
    longitude: 6.1008508,
  },
  {
    sortOrder: 115,
    selectable: true,
    destinationUrlName: 'Macedonia',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21800',
    parentId: 6,
    timeZone: 'Europe/Skopje',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Macedonia',
    destinationId: 21800,
    latitude: 41.60863,
    longitude: 21.74527,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Ohrid',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21800.28588',
    parentId: 21800,
    timeZone: 'Europe/Skopje',
    iataCode: 'OHD',
    destinationType: 'CITY',
    destinationName: 'Ohrid',
    destinationId: 28588,
    latitude: 41.1231,
    longitude: 20.80165,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Skopje',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21800.26711',
    parentId: 21800,
    timeZone: 'Europe/Skopje',
    iataCode: 'SKP',
    destinationType: 'CITY',
    destinationName: 'Skopje',
    destinationId: 26711,
    latitude: 41.99735,
    longitude: 21.428,
  },
  {
    sortOrder: 116,
    selectable: true,
    destinationUrlName: 'Madagascar',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4733',
    parentId: 1,
    timeZone: 'Indian/Antananarivo',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Madagascar',
    destinationId: 4733,
    latitude: -18.7669,
    longitude: 46.8691,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Ambalavao',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4733.51727',
    parentId: 4733,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Ambalavao',
    destinationId: 51727,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Ivato',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4733.51909',
    parentId: 4733,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Ivato',
    destinationId: 51909,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Antananarivo',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4733.30760',
    parentId: 4733,
    timeZone: 'Indian/Antananarivo',
    iataCode: 'TNR',
    destinationType: 'CITY',
    destinationName: 'Antananarivo',
    destinationId: 30760,
    latitude: -18.87919,
    longitude: 47.50791,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Morondava',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4733.50691',
    parentId: 4733,
    timeZone: 'Indian/Antananarivo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Morondava',
    destinationId: 50691,
    latitude: -20.29673,
    longitude: 44.2814,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Nosy-Be',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4733.50692',
    parentId: 4733,
    timeZone: 'Europe/Warsaw',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nosy Be',
    destinationId: 50692,
    latitude: 51.98719,
    longitude: 20.796169,
  },
  {
    sortOrder: 117,
    selectable: true,
    destinationUrlName: 'Malawi',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21906',
    parentId: 1,
    timeZone: 'Africa/Blantyre',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Malawi',
    destinationId: 21906,
    latitude: -13.2543,
    longitude: 34.3015,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Lilongwe',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21906.25512',
    parentId: 21906,
    timeZone: 'Africa/Blantyre',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lilongwe',
    destinationId: 25512,
    latitude: -13.9833,
    longitude: 33.7833,
  },
  {
    sortOrder: 118,
    selectable: true,
    destinationUrlName: 'Malaysia',
    defaultCurrencyCode: 'USD',
    lookupId: '2.17',
    parentId: 2,
    timeZone: 'Asia/Kuala_Lumpur',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Malaysia',
    destinationId: 17,
    latitude: 4.210484,
    longitude: 101.975766,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Johor',
    defaultCurrencyCode: 'USD',
    lookupId: '2.17.34205',
    parentId: 17,
    timeZone: 'Asia/Kuala_Lumpur',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Johor',
    destinationId: 34205,
    latitude: 2.0505,
    longitude: 103.4176,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Kedah',
    defaultCurrencyCode: 'USD',
    lookupId: '2.17.24162',
    parentId: 17,
    timeZone: 'Asia/Kuala_Lumpur',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Kedah',
    destinationId: 24162,
    latitude: 5.8108,
    longitude: 100.678,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Kelantan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.17.23398',
    parentId: 17,
    timeZone: 'Asia/Kuala_Lumpur',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Kelantan',
    destinationId: 23398,
    latitude: 5.288,
    longitude: 102.0343,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Pahang',
    defaultCurrencyCode: 'USD',
    lookupId: '2.17.22204',
    parentId: 17,
    timeZone: 'Asia/Kuala_Lumpur',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Pahang',
    destinationId: 22204,
    latitude: 3.81263,
    longitude: 103.32562,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Perak',
    defaultCurrencyCode: 'USD',
    lookupId: '2.17.25510',
    parentId: 17,
    timeZone: 'Asia/Kuala_Lumpur',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Perak',
    destinationId: 25510,
    latitude: 4.7644,
    longitude: 101.1016,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Sabah',
    defaultCurrencyCode: 'USD',
    lookupId: '2.17.4169',
    parentId: 17,
    timeZone: 'Asia/Kuching',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Sabah',
    destinationId: 4169,
    latitude: 5.4204043,
    longitude: 116.7967849,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Sarawak',
    defaultCurrencyCode: 'USD',
    lookupId: '2.17.4168',
    parentId: 17,
    timeZone: 'Asia/Kuching',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Sarawak',
    destinationId: 4168,
    latitude: 2.5574285,
    longitude: 113.0011989,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Taman-Negara-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '2.17.52074',
    parentId: 17,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Taman Negara National Park',
    destinationId: 52074,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Cherating',
    defaultCurrencyCode: 'USD',
    lookupId: '2.17.22204.22205',
    parentId: 22204,
    timeZone: 'Asia/Kuala_Lumpur',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cherating',
    destinationId: 22205,
    latitude: 4.13028,
    longitude: 103.39365,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Gunung-Mulu-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '2.17.4168.50487',
    parentId: 4168,
    timeZone: 'America/Phoenix',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Gunung Mulu National Park',
    destinationId: 50487,
    latitude: 36.05555,
    longitude: -112.140823,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Ipoh',
    defaultCurrencyCode: 'USD',
    lookupId: '2.17.25510.25511',
    parentId: 25510,
    timeZone: 'Asia/Kuala_Lumpur',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ipoh',
    destinationId: 25511,
    latitude: 4.593513,
    longitude: 101.090046,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Johor-Bahru',
    defaultCurrencyCode: 'USD',
    lookupId: '2.17.34205.34206',
    parentId: 34205,
    timeZone: 'Asia/Kuala_Lumpur',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Johor Bahru',
    destinationId: 34206,
    latitude: 1.492855,
    longitude: 103.742403,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Kota-Kinabalu',
    defaultCurrencyCode: 'USD',
    lookupId: '2.17.4169.4171',
    parentId: 4169,
    timeZone: 'Asia/Kuching',
    iataCode: 'BKI',
    destinationType: 'CITY',
    destinationName: 'Kota Kinabalu',
    destinationId: 4171,
    latitude: 5.976474,
    longitude: 116.115777,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Kuala-Besut',
    defaultCurrencyCode: 'USD',
    lookupId: '2.17.50693',
    parentId: 17,
    timeZone: 'Asia/Kuala_Lumpur',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kuala Besut',
    destinationId: 50693,
    latitude: 5.82865,
    longitude: 102.56138,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Kuala-Lumpur',
    defaultCurrencyCode: 'USD',
    lookupId: '2.17.335',
    parentId: 17,
    timeZone: 'Asia/Kuala_Lumpur',
    iataCode: 'KUL',
    destinationType: 'CITY',
    destinationName: 'Kuala Lumpur',
    destinationId: 335,
    latitude: 3.139003,
    longitude: 101.686855,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Kuala-Terengganu',
    defaultCurrencyCode: 'USD',
    lookupId: '2.17.50606',
    parentId: 17,
    timeZone: 'Asia/Kuala_Lumpur',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kuala Terengganu',
    destinationId: 50606,
    latitude: 5.31965,
    longitude: 103.132103,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Kuantan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.17.4669',
    parentId: 17,
    timeZone: 'Asia/Tokyo',
    iataCode: 'KUA',
    destinationType: 'CITY',
    destinationName: 'Kuantan',
    destinationId: 4669,
    latitude: 3.83,
    longitude: 103.32,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Kuching',
    defaultCurrencyCode: 'USD',
    lookupId: '2.17.4168.4172',
    parentId: 4168,
    timeZone: 'Asia/Kuching',
    iataCode: 'KCH',
    destinationType: 'CITY',
    destinationName: 'Kuching',
    destinationId: 4172,
    latitude: 1.530976,
    longitude: 110.3442199,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Langkawi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.17.24162.338',
    parentId: 24162,
    timeZone: 'Asia/Kuala_Lumpur',
    iataCode: 'LGK',
    destinationType: 'CITY',
    destinationName: 'Langkawi',
    destinationId: 338,
    latitude: 6.3233,
    longitude: 99.8547239,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Melaka',
    defaultCurrencyCode: 'USD',
    lookupId: '2.17.36678',
    parentId: 17,
    timeZone: 'Asia/Kuala_Lumpur',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Melaka',
    destinationId: 36678,
    latitude: 2.2373723,
    longitude: 102.1114169,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Miri',
    defaultCurrencyCode: 'USD',
    lookupId: '2.17.4168.36685',
    parentId: 4168,
    timeZone: 'Asia/Kuching',
    iataCode: 'MYY',
    destinationType: 'CITY',
    destinationName: 'Miri',
    destinationId: 36685,
    latitude: 3.9495261,
    longitude: 113.2480741,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Penang',
    defaultCurrencyCode: 'USD',
    lookupId: '2.17.339',
    parentId: 17,
    timeZone: 'Asia/Kuala_Lumpur',
    iataCode: 'PEN',
    destinationType: 'CITY',
    destinationName: 'Penang',
    destinationId: 339,
    latitude: 5.2632341,
    longitude: 100.4846227,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Penang-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '2.17.339.50882',
    parentId: 339,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Penang Island',
    destinationId: 50882,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Petaling-Jaya',
    defaultCurrencyCode: 'USD',
    lookupId: '2.17.36684',
    parentId: 17,
    timeZone: 'Asia/Kuala_Lumpur',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Petaling Jaya',
    destinationId: 36684,
    latitude: 3.1379829,
    longitude: 101.5731591,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Sandakan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.17.4169.32652',
    parentId: 4169,
    timeZone: 'Asia/Kuching',
    iataCode: 'SDK',
    destinationType: 'CITY',
    destinationName: 'Sandakan',
    destinationId: 32652,
    latitude: 5.839538,
    longitude: 118.116712,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Semporna',
    defaultCurrencyCode: 'USD',
    lookupId: '2.17.4169.50605',
    parentId: 4169,
    timeZone: 'Asia/Kuching',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Semporna',
    destinationId: 50605,
    latitude: 4.47875,
    longitude: 118.61084,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Tanah-Rata',
    defaultCurrencyCode: 'USD',
    lookupId: '2.17.22204.50519',
    parentId: 22204,
    timeZone: 'Asia/Kuala_Lumpur',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tanah Rata',
    destinationId: 50519,
    latitude: 4.48326,
    longitude: 101.37663,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Tuaran',
    defaultCurrencyCode: 'USD',
    lookupId: '2.17.4169.51611',
    parentId: 4169,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tuaran',
    destinationId: 51611,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 119,
    selectable: true,
    destinationUrlName: 'Maldives',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4672',
    parentId: 2,
    timeZone: 'Indian/Maldives',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Maldives',
    destinationId: 4672,
    latitude: 3.2028,
    longitude: 73.2207,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Hulhule-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4672.50521',
    parentId: 4672,
    timeZone: 'Indian/Maldives',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Hulhule Island',
    destinationId: 50521,
    latitude: 4.18495,
    longitude: 73.53462,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Maafushi-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4672.50612',
    parentId: 4672,
    timeZone: 'Indian/Maldives',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Maafushi Island',
    destinationId: 50612,
    latitude: 3.94049,
    longitude: 73.49054,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Male',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4672.4673',
    parentId: 4672,
    timeZone: 'Indian/Maldives',
    iataCode: 'MLE',
    destinationType: 'CITY',
    destinationName: 'Malé',
    destinationId: 4673,
    latitude: 4.1755,
    longitude: 73.50935,
  },
  {
    sortOrder: 120,
    selectable: true,
    destinationUrlName: 'Mali',
    defaultCurrencyCode: 'USD',
    lookupId: '1.37745',
    parentId: 1,
    timeZone: 'Africa/Bamako',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Mali',
    destinationId: 37745,
    latitude: 17.5707,
    longitude: -3.9962,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Bamako',
    defaultCurrencyCode: 'USD',
    lookupId: '1.37745.37746',
    parentId: 37745,
    timeZone: 'Africa/Bamako',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bamako',
    destinationId: 37746,
    latitude: 12.6125547,
    longitude: -8.1355996,
  },
  {
    sortOrder: 121,
    selectable: true,
    destinationUrlName: 'Malta',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.4141',
    parentId: 6,
    timeZone: 'Europe/Malta',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Malta',
    destinationId: 4141,
    latitude: 35.937496,
    longitude: 14.375416,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Gozo',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.4141.28021',
    parentId: 4141,
    timeZone: 'Europe/Malta',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Gozo',
    destinationId: 28021,
    latitude: 36.0443,
    longitude: 14.25122,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Mellieha',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.4141.25688',
    parentId: 4141,
    timeZone: 'Europe/Malta',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mellieha',
    destinationId: 25688,
    latitude: 35.9564,
    longitude: 14.3622,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Mgarr',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.4141.4295',
    parentId: 4141,
    timeZone: 'Europe/Malta',
    iataCode: 'GZM',
    destinationType: 'CITY',
    destinationName: 'Mgarr',
    destinationId: 4295,
    latitude: 35.91893,
    longitude: 14.36173,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Valletta',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.4141.4142',
    parentId: 4141,
    timeZone: 'Europe/Malta',
    iataCode: 'MLA',
    destinationType: 'CITY',
    destinationName: 'Valletta',
    destinationId: 4142,
    latitude: 35.9009224695,
    longitude: 14.5093989372,
  },
  {
    sortOrder: 122,
    selectable: true,
    destinationUrlName: 'Martinique',
    defaultCurrencyCode: 'USD',
    lookupId: '4.4316',
    parentId: 4,
    timeZone: 'America/Martinique',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Martinique',
    destinationId: 4316,
    latitude: 14.6339221,
    longitude: -61.2939697,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Fort-de-France',
    defaultCurrencyCode: 'USD',
    lookupId: '4.4316.50911',
    parentId: 4316,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Fort-de-France',
    destinationId: 50911,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Le-Carbet',
    defaultCurrencyCode: 'USD',
    lookupId: '4.4316.50978',
    parentId: 4316,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Le Carbet',
    destinationId: 50978,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Trois-Ilets',
    defaultCurrencyCode: 'USD',
    lookupId: '4.4316.50929',
    parentId: 4316,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Trois-Ilets',
    destinationId: 50929,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 123,
    selectable: true,
    destinationUrlName: 'Mauritania',
    defaultCurrencyCode: 'USD',
    lookupId: '1.22157',
    parentId: 1,
    timeZone: 'Africa/Nouakchott',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Mauritania',
    destinationId: 22157,
    latitude: 21.0079,
    longitude: -10.9408,
  },
  {
    sortOrder: 124,
    selectable: true,
    destinationUrlName: 'Mauritius',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4463',
    parentId: 1,
    timeZone: 'Indian/Mauritius',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Mauritius',
    destinationId: 4463,
    latitude: -20.348404,
    longitude: 57.552152,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Balaclava',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4463.50694',
    parentId: 4463,
    timeZone: 'Africa/Johannesburg',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Balaclava',
    destinationId: 50694,
    latitude: -29.39633,
    longitude: 26.99087,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Chamarel',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4463.40690',
    parentId: 4463,
    timeZone: 'Indian/Mauritius',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Chamarel',
    destinationId: 40690,
    latitude: -20.4252935,
    longitude: 57.3892198,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Grand-Baie',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4463.23971',
    parentId: 4463,
    timeZone: 'Indian/Mauritius',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Grand Baie',
    destinationId: 23971,
    latitude: -20.007281,
    longitude: 57.586106,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Port-Louis',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4463.4464',
    parentId: 4463,
    timeZone: 'Indian/Mauritius',
    iataCode: 'MRU',
    destinationType: 'CITY',
    destinationName: 'Port Louis',
    destinationId: 4464,
    latitude: -20.160953,
    longitude: 57.503749,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Trou-dEau-Douce',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4463.24101',
    parentId: 4463,
    timeZone: 'Indian/Mauritius',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: "Trou d'Eau Douce",
    destinationId: 24101,
    latitude: -20.234975,
    longitude: 57.794769,
  },
  {
    sortOrder: 125,
    selectable: true,
    destinationUrlName: 'Mayotte',
    defaultCurrencyCode: 'USD',
    lookupId: '1.37758',
    parentId: 1,
    timeZone: 'Indian/Mayotte',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Mayotte',
    destinationId: 37758,
    latitude: -12.809645,
    longitude: 45.130741,
  },
  {
    sortOrder: 126,
    selectable: true,
    destinationUrlName: 'Mexico',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76',
    parentId: 8,
    timeZone: 'America/Mexico_City',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Mexico',
    destinationId: 76,
    latitude: 23.634501,
    longitude: -102.552784,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Baja-California',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.26132',
    parentId: 76,
    timeZone: 'America/Tijuana',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Baja California',
    destinationId: 26132,
    latitude: 30.84063,
    longitude: -115.28376,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Baja-California-Sur',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.4149',
    parentId: 76,
    timeZone: 'Mexico/BajaNorte',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Baja California Sur',
    destinationId: 4149,
    latitude: 30.8406338,
    longitude: -115.2837585,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Campeche',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.30876',
    parentId: 76,
    timeZone: 'America/Merida',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Campeche',
    destinationId: 30876,
    latitude: 19.83013,
    longitude: -90.53491,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Central-Mexico',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.5424',
    parentId: 76,
    timeZone: 'America/Mexico_City',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Central Mexico',
    destinationId: 5424,
    latitude: 19.4270499,
    longitude: -99.1275711,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Chiapas',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.5506',
    parentId: 76,
    timeZone: 'America/Mexico_City',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Chiapas',
    destinationId: 5506,
    latitude: 16.3224417005,
    longitude: -91.7910619016,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Chihuahua',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.28443',
    parentId: 76,
    timeZone: 'America/Chihuahua',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Chihuahua',
    destinationId: 28443,
    latitude: 28.633,
    longitude: -106.0691,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Colima',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.29507',
    parentId: 76,
    timeZone: 'America/Mexico_City',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Colima',
    destinationId: 29507,
    latitude: 19.24523,
    longitude: -103.72409,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Durango',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.51565',
    parentId: 76,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Durango',
    destinationId: 51565,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Guanajuato',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.26114',
    parentId: 76,
    timeZone: 'America/Mexico_City',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Guanajuato',
    destinationId: 26114,
    latitude: 21.017,
    longitude: -101.2545,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Guerrero',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.24408',
    parentId: 76,
    timeZone: 'America/Monterrey',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Guerrero',
    destinationId: 24408,
    latitude: 17.439193,
    longitude: -99.545097,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Jalisco',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.29721',
    parentId: 76,
    timeZone: 'America/Mexico_City',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Jalisco',
    destinationId: 29721,
    latitude: 20.65954,
    longitude: -103.34944,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Morelos',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.23884',
    parentId: 76,
    timeZone: 'America/Mexico_City',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Morelos',
    destinationId: 23884,
    latitude: 18.7561,
    longitude: -99.0653,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Nayarit',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.24339',
    parentId: 76,
    timeZone: 'America/Monterrey',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Nayarit',
    destinationId: 24339,
    latitude: 21.8286837,
    longitude: -107.4484827,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Oaxaca',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.23876',
    parentId: 76,
    timeZone: 'America/Mexico_City',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Oaxaca',
    destinationId: 23876,
    latitude: 17.059417,
    longitude: -96.721622,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Pacific-Coast',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.4148',
    parentId: 76,
    timeZone: 'America/Mazatlan',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Pacific Coast',
    destinationId: 4148,
    latitude: 20.6220182,
    longitude: -105.2284566,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Puebla',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.5222',
    parentId: 76,
    timeZone: 'America/Mexico_City',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Puebla',
    destinationId: 5222,
    latitude: 17.066944,
    longitude: -96.720278,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Queretaro',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.26155',
    parentId: 76,
    timeZone: 'America/Mexico_City',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Queretaro',
    destinationId: 26155,
    latitude: 20.5833,
    longitude: -100.3833,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Riviera-Maya-and-the-Yucatan',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.770',
    parentId: 76,
    timeZone: 'America/Cancun',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Riviera Maya & the Yucatan',
    destinationId: 770,
    latitude: 20.627623,
    longitude: -87.07828,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'San-Luis-Potosi',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.22826',
    parentId: 76,
    timeZone: 'America/Mexico_City',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'San Luis Potosí',
    destinationId: 22826,
    latitude: 22.1515,
    longitude: -100.9796,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Sinaloa',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.29809',
    parentId: 76,
    timeZone: 'America/Mazatlan',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Sinaloa',
    destinationId: 29809,
    latitude: 25.17211,
    longitude: -107.47952,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Tabasco',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.28446',
    parentId: 76,
    timeZone: 'America/Mexico_City',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Tabasco',
    destinationId: 28446,
    latitude: 17.84092,
    longitude: -92.61893,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'Zacatecas',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.32422',
    parentId: 76,
    timeZone: 'America/Monterrey',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Zacatecas',
    destinationId: 32422,
    latitude: 22.770732,
    longitude: -102.580208,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Acapulco',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.24408.629',
    parentId: 24408,
    timeZone: 'America/Mazatlan',
    iataCode: 'ACA',
    destinationType: 'CITY',
    destinationName: 'Acapulco',
    destinationId: 629,
    latitude: 16.8611856698,
    longitude: -99.8809146881,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Atlixco',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.5222.51598',
    parentId: 5222,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Atlixco',
    destinationId: 51598,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Bacalar',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.770.50524',
    parentId: 770,
    timeZone: 'America/Cancun',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bacalar',
    destinationId: 50524,
    latitude: 18.68251,
    longitude: -88.388153,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Bucerias',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.24339.27578',
    parentId: 24339,
    timeZone: 'America/Bahia_Banderas',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bucerias',
    destinationId: 27578,
    latitude: 20.75682,
    longitude: -105.33361,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Campeche',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.30876.51528',
    parentId: 30876,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Campeche',
    destinationId: 51528,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Cancun',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.770.631',
    parentId: 770,
    timeZone: 'US/Eastern',
    iataCode: 'CUN',
    destinationType: 'CITY',
    destinationName: 'Cancun',
    destinationId: 631,
    latitude: 21.158964,
    longitude: -86.845937,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Chichen-Itza',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.770.50526',
    parentId: 770,
    timeZone: 'America/Merida',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Chichen Itza',
    destinationId: 50526,
    latitude: 20.684284,
    longitude: -88.56778,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Chignahuapan',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.5222.51683',
    parentId: 5222,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Chignahuapan',
    destinationId: 51683,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Ciudad-Valles',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.22826.50609',
    parentId: 22826,
    timeZone: 'America/Mexico_City',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ciudad Valles',
    destinationId: 50609,
    latitude: 21.98641,
    longitude: -99.018349,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Costa-Maya',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.770.4345',
    parentId: 770,
    timeZone: 'America/Cancun',
    iataCode: 'CTM',
    destinationType: 'CITY',
    destinationName: 'Costa Maya',
    destinationId: 4345,
    latitude: 18.71788,
    longitude: -87.712753,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Cozumel',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.632',
    parentId: 76,
    timeZone: 'US/Eastern',
    iataCode: 'CZM',
    destinationType: 'CITY',
    destinationName: 'Cozumel',
    destinationId: 632,
    latitude: 20.4310062,
    longitude: -86.9080654,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Creel',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.28443.50696',
    parentId: 28443,
    timeZone: 'America/Monterrey',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Creel',
    destinationId: 50696,
    latitude: 27.754459,
    longitude: -107.63504,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Cuernavaca',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.23884.23885',
    parentId: 23884,
    timeZone: 'America/Mexico_City',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cuernavaca',
    destinationId: 23885,
    latitude: 18.923952,
    longitude: -99.220699,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Cuetzalan-del-Progreso',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.5222.51644',
    parentId: 5222,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cuetzalan del Progreso',
    destinationId: 51644,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Ensenada',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.26132.26218',
    parentId: 26132,
    timeZone: 'America/Tijuana',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ensenada',
    destinationId: 26218,
    latitude: 31.864706,
    longitude: -116.591901,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Guadalajara',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.29721.5299',
    parentId: 29721,
    timeZone: 'America/Mexico_City',
    iataCode: 'GDL',
    destinationType: 'CITY',
    destinationName: 'Guadalajara',
    destinationId: 5299,
    latitude: 20.67359,
    longitude: -103.343803,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Guanajuato-City',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.26114.50523',
    parentId: 26114,
    timeZone: 'America/Mexico_City',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Guanajuato City',
    destinationId: 50523,
    latitude: 21.29452,
    longitude: -100.52434,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Huatulco',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.23876.4334',
    parentId: 23876,
    timeZone: 'America/Mexico_City',
    iataCode: 'HUX',
    destinationType: 'CITY',
    destinationName: 'Huatulco',
    destinationId: 4334,
    latitude: 15.769209,
    longitude: -96.134695,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Isla-Holbox',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.770.24949',
    parentId: 770,
    timeZone: 'America/Cancun',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Isla Holbox',
    destinationId: 24949,
    latitude: 21.522384,
    longitude: -87.378754,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Isla-Mujeres',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.770.50820',
    parentId: 770,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Isla Mujeres',
    destinationId: 50820,
    latitude: 21.2463817853,
    longitude: -86.7369384477,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Ixtapa',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.24408.24409',
    parentId: 24408,
    timeZone: 'America/Mexico_City',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ixtapa',
    destinationId: 24409,
    latitude: 17.662223,
    longitude: -101.588032,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'La-Paz',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.4149.22173',
    parentId: 4149,
    timeZone: 'America/Mazatlan',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'La Paz',
    destinationId: 22173,
    latitude: 24.14264,
    longitude: -110.31275,
  },
  {
    sortOrder: 23,
    selectable: true,
    destinationUrlName: 'Loreto',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.4149.50695',
    parentId: 4149,
    timeZone: 'America/Mexico_City',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Loreto',
    destinationId: 50695,
    latitude: 22.272261,
    longitude: -101.988029,
  },
  {
    sortOrder: 24,
    selectable: true,
    destinationUrlName: 'Los-Cabos',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.4149.627',
    parentId: 4149,
    timeZone: 'America/Mazatlan',
    iataCode: 'SJD',
    destinationType: 'CITY',
    destinationName: 'Los Cabos',
    destinationId: 627,
    latitude: 22.8905327,
    longitude: -109.9167371,
  },
  {
    sortOrder: 25,
    selectable: true,
    destinationUrlName: 'Manzanillo',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.29507.4337',
    parentId: 29507,
    timeZone: 'America/Mexico_City',
    iataCode: 'ZLO',
    destinationType: 'CITY',
    destinationName: 'Manzanillo',
    destinationId: 4337,
    latitude: 19.11381,
    longitude: -104.33846,
  },
  {
    sortOrder: 26,
    selectable: true,
    destinationUrlName: 'Mazatlan',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.29809.4151',
    parentId: 29809,
    timeZone: 'America/Mazatlan',
    iataCode: 'MZT',
    destinationType: 'CITY',
    destinationName: 'Mazatlan',
    destinationId: 4151,
    latitude: 23.2247832989,
    longitude: -106.407618,
  },
  {
    sortOrder: 27,
    selectable: true,
    destinationUrlName: 'Merida',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.770.5195',
    parentId: 770,
    timeZone: 'America/Merida',
    iataCode: 'MID',
    destinationType: 'CITY',
    destinationName: 'Merida',
    destinationId: 5195,
    latitude: 20.97,
    longitude: -89.62,
  },
  {
    sortOrder: 28,
    selectable: true,
    destinationUrlName: 'Metepec',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.5424.51248',
    parentId: 5424,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Metepec',
    destinationId: 51248,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 29,
    selectable: true,
    destinationUrlName: 'Mexico-City',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.5424.628',
    parentId: 5424,
    timeZone: 'America/Mexico_City',
    iataCode: 'MEX',
    destinationType: 'CITY',
    destinationName: 'Mexico City',
    destinationId: 628,
    latitude: 19.4270499,
    longitude: -99.1275711,
  },
  {
    sortOrder: 30,
    selectable: true,
    destinationUrlName: 'Mismaloya',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.29721.51522',
    parentId: 29721,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mismaloya',
    destinationId: 51522,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 31,
    selectable: true,
    destinationUrlName: 'Monterrey',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.5504',
    parentId: 76,
    timeZone: 'America/Monterrey',
    iataCode: 'MTY',
    destinationType: 'CITY',
    destinationName: 'Monterrey',
    destinationId: 5504,
    latitude: 25.686614201,
    longitude: -100.3161125985,
  },
  {
    sortOrder: 32,
    selectable: true,
    destinationUrlName: 'Morelia',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.5424.50525',
    parentId: 5424,
    timeZone: 'America/Mexico_City',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Morelia',
    destinationId: 50525,
    latitude: 19.70187,
    longitude: -101.192337,
  },
  {
    sortOrder: 33,
    selectable: true,
    destinationUrlName: 'Oaxaca-City',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.23876.50491',
    parentId: 23876,
    timeZone: 'America/Mexico_City',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Oaxaca City',
    destinationId: 50491,
    latitude: 17.05423,
    longitude: -96.713226,
  },
  {
    sortOrder: 34,
    selectable: true,
    destinationUrlName: 'Palenque',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.5506.23479',
    parentId: 5506,
    timeZone: 'America/Mexico_City',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Palenque',
    destinationId: 23479,
    latitude: 17.511178,
    longitude: -91.993108,
  },
  {
    sortOrder: 35,
    selectable: true,
    destinationUrlName: 'Patzcuaro',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.5424.51231',
    parentId: 5424,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Patzcuaro',
    destinationId: 51231,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 36,
    selectable: true,
    destinationUrlName: 'Playa-del-Carmen',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.770.5501',
    parentId: 770,
    timeZone: 'US/Eastern',
    iataCode: 'PCM',
    destinationType: 'CITY',
    destinationName: 'Playa del Carmen',
    destinationId: 5501,
    latitude: 20.6295585978,
    longitude: -87.0738850994,
  },
  {
    sortOrder: 37,
    selectable: true,
    destinationUrlName: 'Progreso',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.770.4351',
    parentId: 770,
    timeZone: 'America/Cancun',
    iataCode: 'MID',
    destinationType: 'CITY',
    destinationName: 'Progreso',
    destinationId: 4351,
    latitude: 21.2811908,
    longitude: -89.6651628,
  },
  {
    sortOrder: 38,
    selectable: true,
    destinationUrlName: 'Puebla-City',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.5222.50490',
    parentId: 5222,
    timeZone: 'America/Mexico_City',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Puebla City',
    destinationId: 50490,
    latitude: 19.041439,
    longitude: -98.206276,
  },
  {
    sortOrder: 39,
    selectable: true,
    destinationUrlName: 'Puerto-Escondido',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.23876.23875',
    parentId: 23876,
    timeZone: 'America/Mexico_City',
    iataCode: 'PXM',
    destinationType: 'CITY',
    destinationName: 'Puerto Escondido',
    destinationId: 23875,
    latitude: 15.871418,
    longitude: -97.075966,
  },
  {
    sortOrder: 40,
    selectable: true,
    destinationUrlName: 'Puerto-Vallarta',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.29721.630',
    parentId: 29721,
    timeZone: 'America/Mexico_City',
    iataCode: 'PVR',
    destinationType: 'CITY',
    destinationName: 'Puerto Vallarta',
    destinationId: 630,
    latitude: 20.6237072161,
    longitude: -105.2309560776,
  },
  {
    sortOrder: 41,
    selectable: true,
    destinationUrlName: 'Punta-Sam',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.770.50863',
    parentId: 770,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Punta Sam',
    destinationId: 50863,
    latitude: 21.2363988048,
    longitude: -86.8038252093,
  },
  {
    sortOrder: 42,
    selectable: true,
    destinationUrlName: 'Rosarito',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.26132.26133',
    parentId: 26132,
    timeZone: 'America/Tijuana',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Rosarito',
    destinationId: 26133,
    latitude: 32.365858,
    longitude: -117.062985,
  },
  {
    sortOrder: 43,
    selectable: true,
    destinationUrlName: 'San-Cristobal-de-las-Casas',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.5506.23477',
    parentId: 5506,
    timeZone: 'America/Mexico_City',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'San Cristóbal de las Casas',
    destinationId: 23477,
    latitude: 16.73609,
    longitude: -92.637122,
  },
  {
    sortOrder: 44,
    selectable: true,
    destinationUrlName: 'San-Francisco',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.4148.51252',
    parentId: 4148,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'San Francisco',
    destinationId: 51252,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 45,
    selectable: true,
    destinationUrlName: 'San-Jose-del-Cabo',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.4149.50860',
    parentId: 4149,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'San Jose del Cabo',
    destinationId: 50860,
    latitude: 23.0686140743,
    longitude: -109.7024298083,
  },
  {
    sortOrder: 46,
    selectable: true,
    destinationUrlName: 'San-Luis-Potosi-City',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.22826.50607',
    parentId: 22826,
    timeZone: 'America/Mexico_City',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'San Luis Potosi City',
    destinationId: 50607,
    latitude: 22.151609,
    longitude: -100.974609,
  },
  {
    sortOrder: 47,
    selectable: true,
    destinationUrlName: 'San-Miguel-de-Allende',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.26114.26115',
    parentId: 26114,
    timeZone: 'America/Mexico_City',
    iataCode: 'BJX',
    destinationType: 'CITY',
    destinationName: 'San Miguel de Allende',
    destinationId: 26115,
    latitude: 20.913607,
    longitude: -100.74303,
  },
  {
    sortOrder: 48,
    selectable: true,
    destinationUrlName: 'Sayulita',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.24339.24342',
    parentId: 24339,
    timeZone: 'America/Bahia_Banderas',
    iataCode: 'PVR',
    destinationType: 'CITY',
    destinationName: 'Sayulita',
    destinationId: 24342,
    latitude: 20.868782,
    longitude: -105.440508,
  },
  {
    sortOrder: 49,
    selectable: true,
    destinationUrlName: 'Taxco',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.24408.50698',
    parentId: 24408,
    timeZone: 'America/Mexico_City',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Taxco',
    destinationId: 50698,
    latitude: 18.54857,
    longitude: -99.60853,
  },
  {
    sortOrder: 50,
    selectable: true,
    destinationUrlName: 'Tequisquiapan',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.5424.51224',
    parentId: 5424,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tequisquiapan',
    destinationId: 51224,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 51,
    selectable: true,
    destinationUrlName: 'Tijuana',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.26132.26217',
    parentId: 26132,
    timeZone: 'America/Tijuana',
    iataCode: 'TIJ',
    destinationType: 'CITY',
    destinationName: 'Tijuana',
    destinationId: 26217,
    latitude: 32.5,
    longitude: -117.08,
  },
  {
    sortOrder: 52,
    selectable: true,
    destinationUrlName: 'Todos-Santos',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.4149.24418',
    parentId: 4149,
    timeZone: 'America/Mazatlan',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Todos Santos',
    destinationId: 24418,
    latitude: 23.44636,
    longitude: -110.22651,
  },
  {
    sortOrder: 53,
    selectable: true,
    destinationUrlName: 'Tulum',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.770.23012',
    parentId: 770,
    timeZone: 'America/Cancun',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tulum',
    destinationId: 23012,
    latitude: 20.21142,
    longitude: -87.46535,
  },
  {
    sortOrder: 54,
    selectable: true,
    destinationUrlName: 'Tuxtla-Gutierrez',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.5506.23478',
    parentId: 5506,
    timeZone: 'America/Mexico_City',
    iataCode: 'TGZ',
    destinationType: 'CITY',
    destinationName: 'Tuxtla Gutiérrez',
    destinationId: 23478,
    latitude: 16.749849,
    longitude: -93.102022,
  },
  {
    sortOrder: 55,
    selectable: true,
    destinationUrlName: 'Valladolid',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.770.50533',
    parentId: 770,
    timeZone: 'America/Merida',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Valladolid',
    destinationId: 50533,
    latitude: 20.689659,
    longitude: -88.202217,
  },
  {
    sortOrder: 56,
    selectable: true,
    destinationUrlName: 'Veracruz',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.5424.5434',
    parentId: 5424,
    timeZone: 'America/Mexico_City',
    iataCode: 'VER',
    destinationType: 'CITY',
    destinationName: 'Veracruz',
    destinationId: 5434,
    latitude: 19.173773,
    longitude: -96.134224,
  },
  {
    sortOrder: 57,
    selectable: true,
    destinationUrlName: 'Villahermosa',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.28446.50611',
    parentId: 28446,
    timeZone: 'America/Mexico_City',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Villahermosa',
    destinationId: 50611,
    latitude: 17.98749,
    longitude: -92.919701,
  },
  {
    sortOrder: 58,
    selectable: true,
    destinationUrlName: 'Xilitla',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.22826.50610',
    parentId: 22826,
    timeZone: 'America/Mexico_City',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Xilitla',
    destinationId: 50610,
    latitude: 21.38509,
    longitude: -98.99038,
  },
  {
    sortOrder: 59,
    selectable: true,
    destinationUrlName: 'Zacatlan',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.5222.51552',
    parentId: 5222,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Zacatlan',
    destinationId: 51552,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 60,
    selectable: true,
    destinationUrlName: 'Zihuatanejo',
    defaultCurrencyCode: 'USD',
    lookupId: '8.76.24408.50697',
    parentId: 24408,
    timeZone: 'America/Mexico_City',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Zihuatanejo',
    destinationId: 50697,
    latitude: 17.63866,
    longitude: -101.558701,
  },
  {
    sortOrder: 127,
    selectable: true,
    destinationUrlName: 'Moldova',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21900',
    parentId: 6,
    timeZone: 'Europe/Chisinau',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Moldova',
    destinationId: 21900,
    latitude: 47.4116,
    longitude: 28.3699,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Chisinau',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21900.25271',
    parentId: 21900,
    timeZone: 'Europe/Chisinau',
    iataCode: 'KIV',
    destinationType: 'CITY',
    destinationName: 'Chisinau',
    destinationId: 25271,
    latitude: 47.010787,
    longitude: 28.873443,
  },
  {
    sortOrder: 128,
    selectable: true,
    destinationUrlName: 'Monaco',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.948',
    parentId: 6,
    timeZone: 'Europe/Paris',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Monaco',
    destinationId: 948,
    latitude: 43.7342668771,
    longitude: 7.4178314209,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Monaco-Ville',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.948.50270',
    parentId: 948,
    timeZone: 'Europe/Monaco',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Monaco-Ville',
    destinationId: 50270,
    latitude: 43.7308,
    longitude: 7.4226,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Monte-Carlo',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.948.50269',
    parentId: 948,
    timeZone: 'Europe/Monaco',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Monte-Carlo',
    destinationId: 50269,
    latitude: 43.7401,
    longitude: 7.4266,
  },
  {
    sortOrder: 129,
    selectable: true,
    destinationUrlName: 'Mongolia',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21767',
    parentId: 2,
    timeZone: 'Asia/Ulaanbaatar',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Mongolia',
    destinationId: 21767,
    latitude: 46.8625,
    longitude: 103.8467,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Bayan-Olgii-Province',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21767.51824',
    parentId: 21767,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Bayan-Olgii Province',
    destinationId: 51824,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Dalanzadgad',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21767.51759',
    parentId: 21767,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Dalanzadgad',
    destinationId: 51759,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Gorkhi-Terelj-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21767.52077',
    parentId: 21767,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Gorkhi Terelj National Park',
    destinationId: 52077,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Olgiy',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21767.51705',
    parentId: 21767,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Olgiy',
    destinationId: 51705,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Ulaanbaatar',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21767.22494',
    parentId: 21767,
    timeZone: 'Asia/Ulaanbaatar',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ulaanbaatar',
    destinationId: 22494,
    latitude: 47.888687,
    longitude: 106.915422,
  },
  {
    sortOrder: 130,
    selectable: true,
    destinationUrlName: 'Montenegro',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.4475',
    parentId: 6,
    timeZone: 'Europe/Podgorica',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Montenegro',
    destinationId: 4475,
    latitude: 42.889396,
    longitude: 19.288385,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Adriatic-Coast',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.4475.23077',
    parentId: 4475,
    timeZone: 'Europe/Podgorica',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Adriatic Coast',
    destinationId: 23077,
    latitude: 42.239425,
    longitude: 18.969878,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Lustica',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.4475.51857',
    parentId: 4475,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Lustica',
    destinationId: 51857,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Budva',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.4475.26540',
    parentId: 4475,
    timeZone: 'Europe/Podgorica',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Budva',
    destinationId: 26540,
    latitude: 42.29115,
    longitude: 18.84029,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Herceg-Novi-Municipality',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.4475.50433',
    parentId: 4475,
    timeZone: 'Europe/Podgorica',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Herceg-Novi Municipality',
    destinationId: 50433,
    latitude: 42.45306,
    longitude: 18.53724,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Igalo',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.4475.50434',
    parentId: 4475,
    timeZone: 'Europe/Podgorica',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Igalo',
    destinationId: 50434,
    latitude: 42.46097,
    longitude: 18.5157,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Kotor',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.4475.23077.23078',
    parentId: 23077,
    timeZone: 'Europe/Podgorica',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kotor',
    destinationId: 23078,
    latitude: 42.42466,
    longitude: 18.77123,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Kumbor',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.4475.50433.51915',
    parentId: 50433,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kumbor',
    destinationId: 51915,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Niksic',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.4475.25617',
    parentId: 4475,
    timeZone: 'Europe/Podgorica',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Niksic',
    destinationId: 25617,
    latitude: 42.780708,
    longitude: 18.957475,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Podgorica',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.4475.26108',
    parentId: 4475,
    timeZone: 'Europe/Podgorica',
    iataCode: 'TGD',
    destinationType: 'CITY',
    destinationName: 'Podgorica',
    destinationId: 26108,
    latitude: 42.430901,
    longitude: 19.260416,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Stari-Bar',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.4475.51140',
    parentId: 4475,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Stari Bar',
    destinationId: 51140,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Zabljak',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.4475.25643',
    parentId: 4475,
    timeZone: 'Europe/Podgorica',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Zabljak',
    destinationId: 25643,
    latitude: 43.15552,
    longitude: 19.1226,
  },
  {
    sortOrder: 131,
    selectable: true,
    destinationUrlName: 'Figtree',
    defaultCurrencyCode: 'USD',
    lookupId: '4.22164',
    parentId: 4,
    timeZone: 'America/Figtree',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Figtree',
    destinationId: 22164,
    latitude: 16.7425,
    longitude: -62.1874,
  },
  {
    sortOrder: 132,
    selectable: true,
    destinationUrlName: 'Morocco',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825',
    parentId: 1,
    timeZone: 'Africa/Casablanca',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Morocco',
    destinationId: 825,
    latitude: 31.791702,
    longitude: -7.09262,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Atlantic-Coast',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825.4130',
    parentId: 825,
    timeZone: 'Africa/Casablanca',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Atlantic Coast',
    destinationId: 4130,
    latitude: 33.0132698769,
    longitude: -7.1905517578,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Central-Morocco',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825.5407',
    parentId: 825,
    timeZone: 'Africa/Casablanca',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Central Morocco',
    destinationId: 5407,
    latitude: 31.633333,
    longitude: -8.0,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Morocco-Sahara',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825.22141',
    parentId: 825,
    timeZone: 'Africa/Casablanca',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Morocco Sahara',
    destinationId: 22141,
    latitude: 31.7917,
    longitude: -7.09262,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Northern-Morocco',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825.22137',
    parentId: 825,
    timeZone: 'Africa/Casablanca',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Northern Morocco',
    destinationId: 22137,
    latitude: 32.44794,
    longitude: -6.555717,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Zagora',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825.52177',
    parentId: 825,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Zagora',
    destinationId: 52177,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Agadir',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825.4130.4383',
    parentId: 4130,
    timeZone: 'Africa/Casablanca',
    iataCode: 'AGA',
    destinationType: 'CITY',
    destinationName: 'Agadir',
    destinationId: 4383,
    latitude: 30.4196722,
    longitude: -9.7178298,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Alnif',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825.22141.51440',
    parentId: 22141,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Alnif',
    destinationId: 51440,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Beni-Mellal-Khenifra',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825.5407.51429',
    parentId: 5407,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Beni Mellal-Khenifra',
    destinationId: 51429,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Boumalne-Dades',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825.50342',
    parentId: 825,
    timeZone: 'Africa/Casablanca',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Boumalne Dades',
    destinationId: 50342,
    latitude: 31.3689,
    longitude: -5.9885,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Casablanca',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825.4130.4396',
    parentId: 4130,
    timeZone: 'Africa/Casablanca',
    iataCode: 'CAS',
    destinationType: 'CITY',
    destinationName: 'Casablanca',
    destinationId: 4396,
    latitude: 33.534035,
    longitude: -7.585212,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Chefchaouen',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825.22137.50203',
    parentId: 22137,
    timeZone: 'Africa/Casablanca',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Chefchaouen',
    destinationId: 50203,
    latitude: 35.17072,
    longitude: -5.27059,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Dakhla',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825.22141.51256',
    parentId: 22141,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Dakhla',
    destinationId: 51256,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Erfoud',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825.22141.52172',
    parentId: 22141,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Erfoud',
    destinationId: 52172,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Erg-Chebbi',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825.50438',
    parentId: 825,
    timeZone: 'Africa/Casablanca',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Erg Chebbi',
    destinationId: 50438,
    latitude: 33.24831,
    longitude: -8.51974,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Errachidia',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825.22141.50872',
    parentId: 22141,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Errachidia',
    destinationId: 50872,
    latitude: 31.9309766137,
    longitude: -4.4288429515,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Essaouira',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825.4130.22822',
    parentId: 4130,
    timeZone: 'Africa/Casablanca',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Essaouira',
    destinationId: 22822,
    latitude: 31.50849,
    longitude: -9.7595,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Fez',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825.22137.22151',
    parentId: 22137,
    timeZone: 'Africa/Casablanca',
    iataCode: 'FEZ',
    destinationType: 'CITY',
    destinationName: 'Fez',
    destinationId: 22151,
    latitude: 34.033333,
    longitude: -5.0,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Guelmim',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825.22141.51445',
    parentId: 22141,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Guelmim',
    destinationId: 51445,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Hassilabied',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825.22141.50873',
    parentId: 22141,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Hassilabied',
    destinationId: 50873,
    latitude: 31.1589404167,
    longitude: -4.0251161061,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Larache',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825.4130.51433',
    parentId: 4130,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Larache',
    destinationId: 51433,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'MHamid',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825.50276',
    parentId: 825,
    timeZone: 'Africa/Algiers',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: "M'Hamid",
    destinationId: 50276,
    latitude: 29.8258,
    longitude: -5.7234,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Marrakech',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825.5407.5408',
    parentId: 5407,
    timeZone: 'Africa/Casablanca',
    iataCode: 'RAK',
    destinationType: 'CITY',
    destinationName: 'Marrakech',
    destinationId: 5408,
    latitude: 31.633333,
    longitude: -8.0,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Merzouga',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825.22141.50275',
    parentId: 22141,
    timeZone: 'Africa/Casablanca',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Merzouga',
    destinationId: 50275,
    latitude: 31.0802,
    longitude: -4.0134,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Mirleft',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825.4130.51434',
    parentId: 4130,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mirleft',
    destinationId: 51434,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Ouarzazate',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825.22141.23956',
    parentId: 22141,
    timeZone: 'Africa/Casablanca',
    iataCode: 'OZZ',
    destinationType: 'CITY',
    destinationName: 'Ouarzazate',
    destinationId: 23956,
    latitude: 30.93354,
    longitude: -6.93702,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Ouzoud',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825.50435',
    parentId: 825,
    timeZone: 'Africa/Casablanca',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ouzoud',
    destinationId: 50435,
    latitude: 30.93056,
    longitude: -6.90412,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'Rabat',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825.4130.26851',
    parentId: 4130,
    timeZone: 'Africa/Casablanca',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Rabat',
    destinationId: 26851,
    latitude: 33.97159,
    longitude: -6.84981,
  },
  {
    sortOrder: 23,
    selectable: true,
    destinationUrlName: 'Rissani',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825.22141.50986',
    parentId: 22141,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Rissani',
    destinationId: 50986,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 24,
    selectable: true,
    destinationUrlName: 'Tangier',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825.22137.4388',
    parentId: 22137,
    timeZone: 'Africa/Casablanca',
    iataCode: 'TNG',
    destinationType: 'CITY',
    destinationName: 'Tangier',
    destinationId: 4388,
    latitude: 35.75947,
    longitude: -5.83395,
  },
  {
    sortOrder: 25,
    selectable: true,
    destinationUrlName: 'Tazarine',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825.50436',
    parentId: 825,
    timeZone: 'Africa/Casablanca',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tazarine',
    destinationId: 50436,
    latitude: 33.93359,
    longitude: -4.19688,
  },
  {
    sortOrder: 26,
    selectable: true,
    destinationUrlName: 'Tetouan',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825.50439',
    parentId: 825,
    timeZone: 'Africa/Casablanca',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tetouan',
    destinationId: 50439,
    latitude: 35.567211,
    longitude: -5.37162,
  },
  {
    sortOrder: 27,
    selectable: true,
    destinationUrlName: 'Tinerhir',
    defaultCurrencyCode: 'USD',
    lookupId: '1.825.50437',
    parentId: 825,
    timeZone: 'Africa/Casablanca',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tinerhir',
    destinationId: 50437,
    latitude: 34.02199,
    longitude: -6.83762,
  },
  {
    sortOrder: 133,
    selectable: true,
    destinationUrlName: 'Mozambique',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4830',
    parentId: 1,
    timeZone: 'Africa/Maputo',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Mozambique',
    destinationId: 4830,
    latitude: -18.6657,
    longitude: 35.5296,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Maputo',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4830.30759',
    parentId: 4830,
    timeZone: 'Africa/Maputo',
    iataCode: 'MPM',
    destinationType: 'CITY',
    destinationName: 'Maputo',
    destinationId: 30759,
    latitude: -25.89197,
    longitude: 32.60514,
  },
  {
    sortOrder: 134,
    selectable: true,
    destinationUrlName: 'Myanmar',
    defaultCurrencyCode: 'USD',
    lookupId: '2.5411',
    parentId: 2,
    timeZone: 'Asia/Rangoon',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Myanmar',
    destinationId: 5411,
    latitude: 21.913965001,
    longitude: 95.956223,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Bagan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.5411.22965',
    parentId: 5411,
    timeZone: 'Asia/Yangon',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Bagan',
    destinationId: 22965,
    latitude: 21.1717,
    longitude: 94.8585,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Inle-Lake',
    defaultCurrencyCode: 'USD',
    lookupId: '2.5411.30026',
    parentId: 5411,
    timeZone: 'Asia/Yangon',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Inle Lake',
    destinationId: 30026,
    latitude: 20.58629,
    longitude: 96.91018,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Loikaw',
    defaultCurrencyCode: 'USD',
    lookupId: '2.5411.51718',
    parentId: 5411,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Loikaw',
    destinationId: 51718,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Hpa-An',
    defaultCurrencyCode: 'USD',
    lookupId: '2.5411.35710',
    parentId: 5411,
    timeZone: 'Asia/Yangon',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Hpa An',
    destinationId: 35710,
    latitude: 16.85,
    longitude: 97.6167,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Kalaw',
    defaultCurrencyCode: 'USD',
    lookupId: '2.5411.36943',
    parentId: 5411,
    timeZone: 'Asia/Yangon',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kalaw',
    destinationId: 36943,
    latitude: 20.6267376,
    longitude: 96.5450834,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Mandalay',
    defaultCurrencyCode: 'USD',
    lookupId: '2.5411.22815',
    parentId: 5411,
    timeZone: 'Asia/Yangon',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mandalay',
    destinationId: 22815,
    latitude: 21.95883,
    longitude: 96.0891,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Nyaungshwe',
    defaultCurrencyCode: 'USD',
    lookupId: '2.5411.27542',
    parentId: 5411,
    timeZone: 'Asia/Yangon',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nyaungshwe',
    destinationId: 27542,
    latitude: 20.65942,
    longitude: 96.93433,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Nyaung-U',
    defaultCurrencyCode: 'USD',
    lookupId: '2.5411.22965.50528',
    parentId: 22965,
    timeZone: 'Asia/Yangon',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nyaung U',
    destinationId: 50528,
    latitude: 16.93,
    longitude: 96.18599,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Yangon',
    defaultCurrencyCode: 'USD',
    lookupId: '2.5411.5412',
    parentId: 5411,
    timeZone: 'Asia/Rangoon',
    iataCode: 'RGN',
    destinationType: 'CITY',
    destinationName: 'Yangon',
    destinationId: 5412,
    latitude: 16.7999999982,
    longitude: 96.1500000022,
  },
  {
    sortOrder: 135,
    selectable: true,
    destinationUrlName: 'Namibia',
    defaultCurrencyCode: 'USD',
    lookupId: '1.10',
    parentId: 1,
    timeZone: 'Africa/Windhoek',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Namibia',
    destinationId: 10,
    latitude: -22.95764,
    longitude: 18.49041,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Rundu',
    defaultCurrencyCode: 'USD',
    lookupId: '1.10.51836',
    parentId: 10,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Rundu',
    destinationId: 51836,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Sesriem',
    defaultCurrencyCode: 'USD',
    lookupId: '1.10.51715',
    parentId: 10,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Sesriem',
    destinationId: 51715,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Etosha-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '1.10.50343',
    parentId: 10,
    timeZone: 'Africa/Windhoek',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Etosha National Park',
    destinationId: 50343,
    latitude: -18.8556,
    longitude: 16.3293,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Swakopmund',
    defaultCurrencyCode: 'USD',
    lookupId: '1.10.5541',
    parentId: 10,
    timeZone: 'Africa/Windhoek',
    iataCode: 'SWP',
    destinationType: 'CITY',
    destinationName: 'Swakopmund',
    destinationId: 5541,
    latitude: -22.68333,
    longitude: 14.53333,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Walvis-Bay',
    defaultCurrencyCode: 'USD',
    lookupId: '1.10.4467',
    parentId: 10,
    timeZone: 'Africa/Windhoek',
    iataCode: 'WVB',
    destinationType: 'CITY',
    destinationName: 'Walvis Bay',
    destinationId: 4467,
    latitude: -22.939369,
    longitude: 14.526119,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Windhoek',
    defaultCurrencyCode: 'USD',
    lookupId: '1.10.5574',
    parentId: 10,
    timeZone: 'Africa/Windhoek',
    iataCode: 'WDH',
    destinationType: 'CITY',
    destinationName: 'Windhoek',
    destinationId: 5574,
    latitude: -22.57,
    longitude: 17.083611,
  },
  {
    sortOrder: 136,
    selectable: true,
    destinationUrlName: 'Nepal',
    defaultCurrencyCode: 'USD',
    lookupId: '2.724',
    parentId: 2,
    timeZone: 'Asia/Katmandu',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Nepal',
    destinationId: 724,
    latitude: 28.394857,
    longitude: 84.124008,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Besisahar',
    defaultCurrencyCode: 'USD',
    lookupId: '2.724.51900',
    parentId: 724,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Besisahar',
    destinationId: 51900,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Chitwan-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '2.724.52061',
    parentId: 724,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Chitwan National Park',
    destinationId: 52061,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Dhading',
    defaultCurrencyCode: 'USD',
    lookupId: '2.724.51910',
    parentId: 724,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Dhading',
    destinationId: 51910,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Gandaki-Zone',
    defaultCurrencyCode: 'USD',
    lookupId: '2.724.51906',
    parentId: 724,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Gandaki Zone',
    destinationId: 51906,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Gorkha',
    defaultCurrencyCode: 'USD',
    lookupId: '2.724.51744',
    parentId: 724,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Gorkha',
    destinationId: 51744,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Khumbu',
    defaultCurrencyCode: 'USD',
    lookupId: '2.724.50998',
    parentId: 724,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Khumbu',
    destinationId: 50998,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Khumjung',
    defaultCurrencyCode: 'USD',
    lookupId: '2.724.51766',
    parentId: 724,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Khumjung',
    destinationId: 51766,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Lumbini',
    defaultCurrencyCode: 'USD',
    lookupId: '2.724.51631',
    parentId: 724,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Lumbini',
    destinationId: 51631,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Melamchi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.724.52005',
    parentId: 724,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Melamchi',
    destinationId: 52005,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Taplejung',
    defaultCurrencyCode: 'USD',
    lookupId: '2.724.51695',
    parentId: 724,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Taplejung',
    destinationId: 51695,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Balthali',
    defaultCurrencyCode: 'USD',
    lookupId: '2.724.5109.51947',
    parentId: 5109,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Balthali',
    destinationId: 51947,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Dingboche',
    defaultCurrencyCode: 'USD',
    lookupId: '2.724.51172',
    parentId: 724,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Dingboche',
    destinationId: 51172,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Kathmandu',
    defaultCurrencyCode: 'USD',
    lookupId: '2.724.5109',
    parentId: 724,
    timeZone: 'Asia/Kathmandu',
    iataCode: 'KTM',
    destinationType: 'CITY',
    destinationName: 'Kathmandu',
    destinationId: 5109,
    latitude: 27.7,
    longitude: 85.3333333,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Lukla',
    defaultCurrencyCode: 'USD',
    lookupId: '2.724.51133',
    parentId: 724,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lukla',
    destinationId: 51133,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Pokhara',
    defaultCurrencyCode: 'USD',
    lookupId: '2.724.22291',
    parentId: 724,
    timeZone: 'Asia/Kathmandu',
    iataCode: 'PKR',
    destinationType: 'CITY',
    destinationName: 'Pokhara',
    destinationId: 22291,
    latitude: 28.240086,
    longitude: 84.002438,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Sauraha',
    defaultCurrencyCode: 'USD',
    lookupId: '2.724.50699',
    parentId: 724,
    timeZone: 'Asia/Kathmandu',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sauraha',
    destinationId: 50699,
    latitude: 27.71202,
    longitude: 85.31295,
  },
  {
    sortOrder: 137,
    selectable: true,
    destinationUrlName: 'New-Caledonia',
    defaultCurrencyCode: 'USD',
    lookupId: '3.4776',
    parentId: 3,
    timeZone: 'Pacific/Noumea',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'New Caledonia',
    destinationId: 4776,
    latitude: -20.9043,
    longitude: 165.618,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Grande-Terre',
    defaultCurrencyCode: 'USD',
    lookupId: '3.4776.50289',
    parentId: 4776,
    timeZone: 'Pacific/Noumea',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Grande Terre',
    destinationId: 50289,
    latitude: -21.3109,
    longitude: 165.4345,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Noumea',
    defaultCurrencyCode: 'USD',
    lookupId: '3.4776.4780',
    parentId: 4776,
    timeZone: 'Pacific/Noumea',
    iataCode: 'GEA',
    destinationType: 'CITY',
    destinationName: 'Noumea',
    destinationId: 4780,
    latitude: -22.25582,
    longitude: 166.45052,
  },
  {
    sortOrder: 138,
    selectable: true,
    destinationUrlName: 'Nicaragua',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4499',
    parentId: 9,
    timeZone: 'America/Managua',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Nicaragua',
    destinationId: 4499,
    latitude: 12.865416,
    longitude: -85.207229,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Rivas-Department',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4499.51816',
    parentId: 4499,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Rivas Department',
    destinationId: 51816,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Granada',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4499.4853',
    parentId: 4499,
    timeZone: 'America/Managua',
    iataCode: 'GRA',
    destinationType: 'CITY',
    destinationName: 'Granada',
    destinationId: 4853,
    latitude: 11.934407,
    longitude: -85.956001,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Isla-de-Ometepe',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4499.50701',
    parentId: 4499,
    timeZone: 'America/Santiago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Isla de Ometepe',
    destinationId: 50701,
    latitude: -33.74828,
    longitude: -70.90366,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Leon',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4499.22384',
    parentId: 4499,
    timeZone: 'America/Managua',
    iataCode: 'BJX',
    destinationType: 'CITY',
    destinationName: 'León',
    destinationId: 22384,
    latitude: 12.430042,
    longitude: -86.868211,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Managua',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4499.4500',
    parentId: 4499,
    timeZone: 'America/Managua',
    iataCode: 'MGA',
    destinationType: 'CITY',
    destinationName: 'Managua',
    destinationId: 4500,
    latitude: 12.1363889,
    longitude: -86.2513889,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Ometepe',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4499.31318',
    parentId: 4499,
    timeZone: 'America/Managua',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ometepe',
    destinationId: 31318,
    latitude: 11.51414,
    longitude: -85.58179,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'San-Juan-del-Sur',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4499.23011',
    parentId: 4499,
    timeZone: 'America/Managua',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'San Juan del Sur',
    destinationId: 23011,
    latitude: 11.263938,
    longitude: -85.86271,
  },
  {
    sortOrder: 139,
    selectable: true,
    destinationUrlName: 'Niger',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21907',
    parentId: 1,
    timeZone: 'Africa/Niamey',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Niger',
    destinationId: 21907,
    latitude: 17.6078,
    longitude: 8.0817,
  },
  {
    sortOrder: 140,
    selectable: true,
    destinationUrlName: 'Nigeria',
    defaultCurrencyCode: 'USD',
    lookupId: '1.22316',
    parentId: 1,
    timeZone: 'Africa/Lagos',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Nigeria',
    destinationId: 22316,
    latitude: 9.082,
    longitude: 8.6753,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'South-West-Nigeria',
    defaultCurrencyCode: 'USD',
    lookupId: '1.22316.24048',
    parentId: 22316,
    timeZone: 'Africa/Lagos',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'South West Nigeria',
    destinationId: 24048,
    latitude: 9.082,
    longitude: 8.67528,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Abuja',
    defaultCurrencyCode: 'USD',
    lookupId: '1.22316.50443',
    parentId: 22316,
    timeZone: 'Africa/Lagos',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Abuja',
    destinationId: 50443,
    latitude: 9.076479,
    longitude: 7.398574,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Lagos',
    defaultCurrencyCode: 'USD',
    lookupId: '1.22316.24048.24049',
    parentId: 24048,
    timeZone: 'Africa/Lagos',
    iataCode: 'LOS',
    destinationType: 'CITY',
    destinationName: 'Lagos',
    destinationId: 24049,
    latitude: 6.522823,
    longitude: 3.382503,
  },
  {
    sortOrder: 141,
    selectable: true,
    destinationUrlName: 'Northern-Ireland',
    defaultCurrencyCode: 'USD',
    lookupId: '6.40330',
    parentId: 6,
    timeZone: 'Europe/Dublin',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Northern Ireland',
    destinationId: 40330,
    latitude: 55.036662,
    longitude: -6.714512,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Belfast',
    defaultCurrencyCode: 'USD',
    lookupId: '6.40330.738',
    parentId: 40330,
    timeZone: 'Europe/London',
    iataCode: 'BFS',
    destinationType: 'CITY',
    destinationName: 'Belfast',
    destinationId: 738,
    latitude: 54.5972686,
    longitude: -5.9301088,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Bushmills',
    defaultCurrencyCode: 'USD',
    lookupId: '6.40330.50444',
    parentId: 40330,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bushmills',
    destinationId: 50444,
    latitude: 55.20247,
    longitude: -6.52583,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Londonderry',
    defaultCurrencyCode: 'USD',
    lookupId: '6.40330.4207',
    parentId: 40330,
    timeZone: 'Etc/GMT',
    iataCode: 'LDY',
    destinationType: 'CITY',
    destinationName: 'Londonderry',
    destinationId: 4207,
    latitude: 54.997292,
    longitude: -7.305339,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Newry',
    defaultCurrencyCode: 'USD',
    lookupId: '6.40330.25934',
    parentId: 40330,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Newry',
    destinationId: 25934,
    latitude: 54.175999,
    longitude: -6.349,
  },
  {
    sortOrder: 142,
    selectable: true,
    destinationUrlName: 'Northern-Mariana-Islands',
    defaultCurrencyCode: 'USD',
    lookupId: '3.36290',
    parentId: 3,
    timeZone: 'Pacific/Saipan',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Northern Mariana Islands',
    destinationId: 36290,
    latitude: 17.3024466,
    longitude: 143.2421174,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Saipan',
    defaultCurrencyCode: 'USD',
    lookupId: '3.36290.36292',
    parentId: 36290,
    timeZone: 'Pacific/Saipan',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Saipan',
    destinationId: 36292,
    latitude: 15.1931853,
    longitude: 145.6903459,
  },
  {
    sortOrder: 143,
    selectable: true,
    destinationUrlName: 'Norway',
    defaultCurrencyCode: 'USD',
    lookupId: '6.61',
    parentId: 6,
    timeZone: 'Europe/Oslo',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Norway',
    destinationId: 61,
    latitude: 60.472024,
    longitude: 8.468946,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Central-Norway',
    defaultCurrencyCode: 'USD',
    lookupId: '6.61.23233',
    parentId: 61,
    timeZone: 'Europe/Oslo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Central Norway',
    destinationId: 23233,
    latitude: 59.9087,
    longitude: 10.7425,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Lofoten',
    defaultCurrencyCode: 'USD',
    lookupId: '6.61.33309',
    parentId: 61,
    timeZone: 'Europe/Oslo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Lofoten',
    destinationId: 33309,
    latitude: 68.2048279,
    longitude: 12.794983,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Senja',
    defaultCurrencyCode: 'USD',
    lookupId: '6.61.51568',
    parentId: 61,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Senja',
    destinationId: 51568,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Western-Norway',
    defaultCurrencyCode: 'USD',
    lookupId: '6.61.22278',
    parentId: 61,
    timeZone: 'America/New_York',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Western Norway',
    destinationId: 22278,
    latitude: 44.2099,
    longitude: -70.5326,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Alesund',
    defaultCurrencyCode: 'USD',
    lookupId: '6.61.22278.4312',
    parentId: 22278,
    timeZone: 'Europe/Oslo',
    iataCode: 'AES',
    destinationType: 'CITY',
    destinationName: 'Alesund',
    destinationId: 4312,
    latitude: 62.472128,
    longitude: 6.150203,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Alta',
    defaultCurrencyCode: 'USD',
    lookupId: '6.61.5168',
    parentId: 61,
    timeZone: 'Europe/Oslo',
    iataCode: 'ALF',
    destinationType: 'CITY',
    destinationName: 'Alta',
    destinationId: 5168,
    latitude: 69.9687,
    longitude: 23.2715,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Andalsnes',
    defaultCurrencyCode: 'USD',
    lookupId: '6.61.4314',
    parentId: 61,
    timeZone: 'Europe/Oslo',
    iataCode: 'AND',
    destinationType: 'CITY',
    destinationName: 'Andalsnes',
    destinationId: 4314,
    latitude: 62.567446,
    longitude: 7.68722,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Balestrand',
    defaultCurrencyCode: 'USD',
    lookupId: '6.61.22278.50963',
    parentId: 22278,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Balestrand',
    destinationId: 50963,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Bergen',
    defaultCurrencyCode: 'USD',
    lookupId: '6.61.22278.4318',
    parentId: 22278,
    timeZone: 'Europe/Oslo',
    iataCode: 'BGO',
    destinationType: 'CITY',
    destinationName: 'Bergen',
    destinationId: 4318,
    latitude: 60.391149,
    longitude: 5.322327,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Bodo',
    defaultCurrencyCode: 'USD',
    lookupId: '6.61.4526',
    parentId: 61,
    timeZone: 'Europe/Oslo',
    iataCode: 'BOO',
    destinationType: 'CITY',
    destinationName: 'Bodo',
    destinationId: 4526,
    latitude: 67.28653,
    longitude: 14.399212,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Orsta',
    defaultCurrencyCode: 'USD',
    lookupId: '6.61.4543',
    parentId: 61,
    timeZone: 'Europe/Oslo',
    iataCode: 'HOV',
    destinationType: 'CITY',
    destinationName: 'Orsta',
    destinationId: 4543,
    latitude: 62.976037,
    longitude: 8.018272,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Oslo',
    defaultCurrencyCode: 'USD',
    lookupId: '6.61.902',
    parentId: 61,
    timeZone: 'Europe/Oslo',
    iataCode: 'OSL',
    destinationType: 'CITY',
    destinationName: 'Oslo',
    destinationId: 902,
    latitude: 59.9012926321,
    longitude: 10.7359600067,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Rosendal',
    defaultCurrencyCode: 'USD',
    lookupId: '6.61.22278.51425',
    parentId: 22278,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Rosendal',
    destinationId: 51425,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Skjolden',
    defaultCurrencyCode: 'USD',
    lookupId: '6.61.4360',
    parentId: 61,
    timeZone: 'Europe/Oslo',
    iataCode: 'SOG',
    destinationType: 'CITY',
    destinationName: 'Skjolden',
    destinationId: 4360,
    latitude: 61.553944,
    longitude: 6.332588,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Stavanger',
    defaultCurrencyCode: 'USD',
    lookupId: '6.61.22278.4361',
    parentId: 22278,
    timeZone: 'Europe/Oslo',
    iataCode: 'SVG',
    destinationType: 'CITY',
    destinationName: 'Stavanger',
    destinationId: 4361,
    latitude: 58.969832,
    longitude: 5.733273,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Svolvaer',
    defaultCurrencyCode: 'USD',
    lookupId: '6.61.50279',
    parentId: 61,
    timeZone: 'Europe/Oslo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Svolvaer',
    destinationId: 50279,
    latitude: 68.2343,
    longitude: 14.5682,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Tromso',
    defaultCurrencyCode: 'USD',
    lookupId: '6.61.4362',
    parentId: 61,
    timeZone: 'Europe/Oslo',
    iataCode: 'TOS',
    destinationType: 'CITY',
    destinationName: 'Tromso',
    destinationId: 4362,
    latitude: 69.649205,
    longitude: 18.955324,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Trondheim',
    defaultCurrencyCode: 'USD',
    lookupId: '6.61.23233.4363',
    parentId: 23233,
    timeZone: 'Europe/Oslo',
    iataCode: 'TRD',
    destinationType: 'CITY',
    destinationName: 'Trondheim',
    destinationId: 4363,
    latitude: 63.4167,
    longitude: 10.4167,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Ulvik',
    defaultCurrencyCode: 'USD',
    lookupId: '6.61.4364',
    parentId: 61,
    timeZone: 'Europe/Oslo',
    iataCode: 'UVK',
    destinationType: 'CITY',
    destinationName: 'Ulvik',
    destinationId: 4364,
    latitude: 60.570354,
    longitude: 6.918297,
  },
  {
    sortOrder: 144,
    selectable: true,
    destinationUrlName: 'Oman',
    defaultCurrencyCode: 'USD',
    lookupId: '1.745',
    parentId: 1,
    timeZone: 'Asia/Muscat',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Oman',
    destinationId: 745,
    latitude: 21.512583,
    longitude: 55.923255,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Al-Hamra',
    defaultCurrencyCode: 'USD',
    lookupId: '1.745.51570',
    parentId: 745,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Al Hamra',
    destinationId: 51570,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Bahla',
    defaultCurrencyCode: 'USD',
    lookupId: '1.745.51913',
    parentId: 745,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: "Bahla'",
    destinationId: 51913,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Khasab',
    defaultCurrencyCode: 'USD',
    lookupId: '1.745.33746',
    parentId: 745,
    timeZone: 'Asia/Muscat',
    iataCode: 'KHS',
    destinationType: 'CITY',
    destinationName: 'Khasab',
    destinationId: 33746,
    latitude: 26.164916,
    longitude: 56.243536,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Misfat-al-Abriyyin',
    defaultCurrencyCode: 'USD',
    lookupId: '1.745.51170',
    parentId: 745,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Misfat al Abriyyin',
    destinationId: 51170,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Muscat',
    defaultCurrencyCode: 'USD',
    lookupId: '1.745.4389',
    parentId: 745,
    timeZone: 'Asia/Muscat',
    iataCode: 'MCT',
    destinationType: 'CITY',
    destinationName: 'Muscat',
    destinationId: 4389,
    latitude: 23.61,
    longitude: 58.54,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Nizwa',
    defaultCurrencyCode: 'USD',
    lookupId: '1.745.50446',
    parentId: 745,
    timeZone: 'Asia/Muscat',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nizwa',
    destinationId: 50446,
    latitude: 22.91745,
    longitude: 57.6325,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Salalah',
    defaultCurrencyCode: 'USD',
    lookupId: '1.745.4391',
    parentId: 745,
    timeZone: 'Asia/Muscat',
    iataCode: 'SLL',
    destinationType: 'CITY',
    destinationName: 'Salalah',
    destinationId: 4391,
    latitude: 17.0563199,
    longitude: 53.972339,
  },
  {
    sortOrder: 145,
    selectable: true,
    destinationUrlName: 'Pakistan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.22311',
    parentId: 2,
    timeZone: 'Asia/Karachi',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Pakistan',
    destinationId: 22311,
    latitude: 29.902,
    longitude: 69.386647,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Gilgit',
    defaultCurrencyCode: 'USD',
    lookupId: '2.22311.51672',
    parentId: 22311,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Gilgit',
    destinationId: 51672,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Hunza',
    defaultCurrencyCode: 'USD',
    lookupId: '2.22311.51921',
    parentId: 22311,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Hunza',
    destinationId: 51921,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Shigar',
    defaultCurrencyCode: 'USD',
    lookupId: '2.22311.51865',
    parentId: 22311,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Shigar',
    destinationId: 51865,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Skardu',
    defaultCurrencyCode: 'USD',
    lookupId: '2.22311.51603',
    parentId: 22311,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Skardu',
    destinationId: 51603,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Sost',
    defaultCurrencyCode: 'USD',
    lookupId: '2.22311.52014',
    parentId: 22311,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Sost',
    destinationId: 52014,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Swat',
    defaultCurrencyCode: 'USD',
    lookupId: '2.22311.51936',
    parentId: 22311,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Swat',
    destinationId: 51936,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Islamabad',
    defaultCurrencyCode: 'USD',
    lookupId: '2.22311.50280',
    parentId: 22311,
    timeZone: 'Asia/Karachi',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Islamabad',
    destinationId: 50280,
    latitude: 33.6844,
    longitude: 73.0479,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Karachi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.22311.50447',
    parentId: 22311,
    timeZone: 'Asia/Karachi',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Karachi',
    destinationId: 50447,
    latitude: 24.860735,
    longitude: 67.001137,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Lahore',
    defaultCurrencyCode: 'USD',
    lookupId: '2.22311.50344',
    parentId: 22311,
    timeZone: 'Asia/Karachi',
    iataCode: 'LHE',
    destinationType: 'CITY',
    destinationName: 'Lahore',
    destinationId: 50344,
    latitude: 31.5204,
    longitude: 74.3587,
  },
  {
    sortOrder: 146,
    selectable: true,
    destinationUrlName: 'Palau',
    defaultCurrencyCode: 'USD',
    lookupId: '3.22163',
    parentId: 3,
    timeZone: 'Pacific/Palau',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Palau',
    destinationId: 22163,
    latitude: 7.515,
    longitude: 134.5825,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Koror',
    defaultCurrencyCode: 'USD',
    lookupId: '3.22163.25560',
    parentId: 22163,
    timeZone: 'Pacific/Palau',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Koror',
    destinationId: 25560,
    latitude: 7.3643,
    longitude: 134.5329,
  },
  {
    sortOrder: 147,
    selectable: true,
    destinationUrlName: 'Palestinian-Territories',
    defaultCurrencyCode: 'USD',
    lookupId: '1.22417',
    parentId: 1,
    timeZone: 'Asia/Hebron',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Palestinian Territories',
    destinationId: 22417,
    latitude: 31.95216,
    longitude: 35.23315,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'West-Bank',
    defaultCurrencyCode: 'USD',
    lookupId: '1.22417.22418',
    parentId: 22417,
    timeZone: 'Asia/Hebron',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'West Bank',
    destinationId: 22418,
    latitude: 31.9447,
    longitude: 35.2578,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Bethlehem',
    defaultCurrencyCode: 'USD',
    lookupId: '1.22417.22418.22419',
    parentId: 22418,
    timeZone: 'Asia/Gaza',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bethlehem',
    destinationId: 22419,
    latitude: 31.70538,
    longitude: 35.20244,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Hebron',
    defaultCurrencyCode: 'USD',
    lookupId: '1.22417.22418.50988',
    parentId: 22418,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Hebron',
    destinationId: 50988,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 148,
    selectable: true,
    destinationUrlName: 'Panama',
    defaultCurrencyCode: 'USD',
    lookupId: '9.749',
    parentId: 9,
    timeZone: 'America/Panama',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Panama',
    destinationId: 749,
    latitude: 8.537981,
    longitude: -80.782127,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Bocas-del-Toro',
    defaultCurrencyCode: 'USD',
    lookupId: '9.749.28408',
    parentId: 749,
    timeZone: 'America/Panama',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Bocas del Toro',
    destinationId: 28408,
    latitude: 9.4048,
    longitude: -82.26919,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Boquete',
    defaultCurrencyCode: 'USD',
    lookupId: '9.749.33432',
    parentId: 749,
    timeZone: 'America/Panama',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Boquete',
    destinationId: 33432,
    latitude: 8.777346,
    longitude: -82.4466,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Colon',
    defaultCurrencyCode: 'USD',
    lookupId: '9.749.4510',
    parentId: 749,
    timeZone: 'America/Panama',
    iataCode: 'ONX',
    destinationType: 'CITY',
    destinationName: 'Colon',
    destinationId: 4510,
    latitude: 9.33529,
    longitude: -79.94165,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'El-Valle-de-Anton',
    defaultCurrencyCode: 'USD',
    lookupId: '9.749.51223',
    parentId: 749,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'El Valle de Anton',
    destinationId: 51223,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Gamboa',
    defaultCurrencyCode: 'USD',
    lookupId: '9.749.31319',
    parentId: 749,
    timeZone: 'America/Panama',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Gamboa',
    destinationId: 31319,
    latitude: 9.11646,
    longitude: -79.69651,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Gobernadora-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '9.749.50468',
    parentId: 749,
    timeZone: 'America/Panama',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Gobernadora Island',
    destinationId: 50468,
    latitude: 7.47049,
    longitude: -81.7577,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Panama-City',
    defaultCurrencyCode: 'USD',
    lookupId: '9.749.950',
    parentId: 749,
    timeZone: 'America/Panama',
    iataCode: 'PTY',
    destinationType: 'CITY',
    destinationName: 'Panama City',
    destinationId: 950,
    latitude: 8.983005,
    longitude: -79.515332,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'San-Blas-Islands',
    defaultCurrencyCode: 'USD',
    lookupId: '9.749.4516',
    parentId: 749,
    timeZone: 'America/Panama',
    iataCode: 'PVE',
    destinationType: 'CITY',
    destinationName: 'San Blas Islands',
    destinationId: 4516,
    latitude: 9.569397,
    longitude: -78.824165,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Santa-Catalina',
    defaultCurrencyCode: 'USD',
    lookupId: '9.749.24784',
    parentId: 749,
    timeZone: 'America/Panama',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Santa Catalina',
    destinationId: 24784,
    latitude: 7.639288,
    longitude: -81.261703,
  },
  {
    sortOrder: 149,
    selectable: true,
    destinationUrlName: 'Papua-New-Guinea',
    defaultCurrencyCode: 'USD',
    lookupId: '3.4782',
    parentId: 3,
    timeZone: 'Pacific/Port_Moresby',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Papua New Guinea',
    destinationId: 4782,
    latitude: -6.2975756,
    longitude: 141.3548333,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Port-Moresby',
    defaultCurrencyCode: 'USD',
    lookupId: '3.4782.50345',
    parentId: 4782,
    timeZone: 'Pacific/Port_Moresby',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Port Moresby',
    destinationId: 50345,
    latitude: -9.4438,
    longitude: 147.1803,
  },
  {
    sortOrder: 150,
    selectable: true,
    destinationUrlName: 'Paraguay',
    defaultCurrencyCode: 'USD',
    lookupId: '9.21940',
    parentId: 9,
    timeZone: 'America/Asuncion',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Paraguay',
    destinationId: 21940,
    latitude: -23.4425,
    longitude: -58.4438,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Asuncion',
    defaultCurrencyCode: 'USD',
    lookupId: '9.21940.22635',
    parentId: 21940,
    timeZone: 'America/Asuncion',
    iataCode: 'ASU',
    destinationType: 'CITY',
    destinationName: 'Asunción',
    destinationId: 22635,
    latitude: -25.263541,
    longitude: -57.573459,
  },
  {
    sortOrder: 151,
    selectable: true,
    destinationUrlName: 'Peru',
    defaultCurrencyCode: 'USD',
    lookupId: '9.927',
    parentId: 9,
    timeZone: 'America/Lima',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Peru',
    destinationId: 927,
    latitude: -9.189967,
    longitude: -75.015152,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Amazon',
    defaultCurrencyCode: 'USD',
    lookupId: '9.927.5488',
    parentId: 927,
    timeZone: 'America/Lima',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Amazon',
    destinationId: 5488,
    latitude: -3.743673,
    longitude: -73.251633,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Apurimac-Region',
    defaultCurrencyCode: 'USD',
    lookupId: '9.927.51750',
    parentId: 927,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Apurimac Region',
    destinationId: 51750,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'North-Coast',
    defaultCurrencyCode: 'USD',
    lookupId: '9.927.5462',
    parentId: 927,
    timeZone: 'America/Lima',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'North Coast',
    destinationId: 5462,
    latitude: -7.461394607,
    longitude: -79.5214115322,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'South-Coast',
    defaultCurrencyCode: 'USD',
    lookupId: '9.927.25558',
    parentId: 927,
    timeZone: 'America/New_York',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'South Coast',
    destinationId: 25558,
    latitude: 41.23942,
    longitude: -82.69311,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Arequipa',
    defaultCurrencyCode: 'USD',
    lookupId: '9.927.5020',
    parentId: 927,
    timeZone: 'America/Lima',
    iataCode: 'AQP',
    destinationType: 'CITY',
    destinationName: 'Arequipa',
    destinationId: 5020,
    latitude: -16.3988222,
    longitude: -71.5368861,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Ayacucho',
    defaultCurrencyCode: 'USD',
    lookupId: '9.927.50613',
    parentId: 927,
    timeZone: 'America/Lima',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ayacucho',
    destinationId: 50613,
    latitude: -13.16001,
    longitude: -74.223892,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Cachora',
    defaultCurrencyCode: 'USD',
    lookupId: '9.927.50702',
    parentId: 927,
    timeZone: 'America/Lima',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cachora',
    destinationId: 50702,
    latitude: -13.50916,
    longitude: -72.81139,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Cajamarca',
    defaultCurrencyCode: 'USD',
    lookupId: '9.927.28059',
    parentId: 927,
    timeZone: 'America/Lima',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cajamarca',
    destinationId: 28059,
    latitude: -7.16175,
    longitude: -78.51279,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Chachapoyas',
    defaultCurrencyCode: 'USD',
    lookupId: '9.927.5488.36402',
    parentId: 5488,
    timeZone: 'America/Lima',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Chachapoyas',
    destinationId: 36402,
    latitude: -6.2182486,
    longitude: -77.8831961,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Chiclayo',
    defaultCurrencyCode: 'USD',
    lookupId: '9.927.5462.5464',
    parentId: 5462,
    timeZone: 'America/Lima',
    iataCode: 'CIX',
    destinationType: 'CITY',
    destinationName: 'Chiclayo',
    destinationId: 5464,
    latitude: -6.7765973994,
    longitude: -79.8442978022,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Chivay',
    defaultCurrencyCode: 'USD',
    lookupId: '9.927.25558.50481',
    parentId: 25558,
    timeZone: 'America/Lima',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Chivay',
    destinationId: 50481,
    latitude: -15.63665,
    longitude: -71.60084,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Cusco',
    defaultCurrencyCode: 'USD',
    lookupId: '9.927.937',
    parentId: 927,
    timeZone: 'America/Lima',
    iataCode: 'CUZ',
    destinationType: 'CITY',
    destinationName: 'Cusco',
    destinationId: 937,
    latitude: -13.5183333,
    longitude: -71.9780556,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Huaraz',
    defaultCurrencyCode: 'USD',
    lookupId: '9.927.22813',
    parentId: 927,
    timeZone: 'America/Lima',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Huaraz',
    destinationId: 22813,
    latitude: -9.526519,
    longitude: -77.527536,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Ica',
    defaultCurrencyCode: 'USD',
    lookupId: '9.927.25558.23268',
    parentId: 25558,
    timeZone: 'America/Lima',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ica',
    destinationId: 23268,
    latitude: -14.0761,
    longitude: -75.732361,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Iquitos',
    defaultCurrencyCode: 'USD',
    lookupId: '9.927.5488.4725',
    parentId: 5488,
    timeZone: 'America/Lima',
    iataCode: 'IQT',
    destinationType: 'CITY',
    destinationName: 'Iquitos',
    destinationId: 4725,
    latitude: -3.75,
    longitude: -73.25,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Lamay',
    defaultCurrencyCode: 'USD',
    lookupId: '9.927.937.51357',
    parentId: 937,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lamay',
    destinationId: 51357,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Lima',
    defaultCurrencyCode: 'USD',
    lookupId: '9.927.928',
    parentId: 927,
    timeZone: 'America/Lima',
    iataCode: 'LIM',
    destinationType: 'CITY',
    destinationName: 'Lima',
    destinationId: 928,
    latitude: -12.0433333,
    longitude: -77.0283333,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Lunahuana',
    defaultCurrencyCode: 'USD',
    lookupId: '9.927.51245',
    parentId: 927,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lunahuana',
    destinationId: 51245,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Manu-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '9.927.5488.50616',
    parentId: 5488,
    timeZone: 'Pacific/Auckland',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Manu National Park',
    destinationId: 50616,
    latitude: -39.2117,
    longitude: 175.402267,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Mollepata',
    defaultCurrencyCode: 'USD',
    lookupId: '9.927.51155',
    parentId: 927,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mollepata',
    destinationId: 51155,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Nazca',
    defaultCurrencyCode: 'USD',
    lookupId: '9.927.25558.32679',
    parentId: 25558,
    timeZone: 'America/Lima',
    iataCode: 'NZC',
    destinationType: 'CITY',
    destinationName: 'Nazca',
    destinationId: 32679,
    latitude: -14.835947,
    longitude: -74.932645,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Paracas',
    defaultCurrencyCode: 'USD',
    lookupId: '9.927.25558.23785',
    parentId: 25558,
    timeZone: 'America/Lima',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Paracas',
    destinationId: 23785,
    latitude: -13.840787,
    longitude: -76.250173,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Pisco',
    defaultCurrencyCode: 'USD',
    lookupId: '9.927.25558.4517',
    parentId: 25558,
    timeZone: 'America/Lima',
    iataCode: 'PIO',
    destinationType: 'CITY',
    destinationName: 'Pisco',
    destinationId: 4517,
    latitude: -13.713238,
    longitude: -76.185088,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Puerto-Maldonado',
    defaultCurrencyCode: 'USD',
    lookupId: '9.927.5488.23267',
    parentId: 5488,
    timeZone: 'America/Lima',
    iataCode: 'PEM',
    destinationType: 'CITY',
    destinationName: 'Puerto Maldonado',
    destinationId: 23267,
    latitude: -12.591268,
    longitude: -69.195715,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Puno',
    defaultCurrencyCode: 'USD',
    lookupId: '9.927.4726',
    parentId: 927,
    timeZone: 'America/Lima',
    iataCode: 'JUL',
    destinationType: 'CITY',
    destinationName: 'Puno',
    destinationId: 4726,
    latitude: -15.8433333,
    longitude: -70.0236111,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'Sacred-Valley',
    defaultCurrencyCode: 'USD',
    lookupId: '9.927.4928',
    parentId: 927,
    timeZone: 'America/Lima',
    iataCode: 'CUZ',
    destinationType: 'CITY',
    destinationName: 'Sacred Valley',
    destinationId: 4928,
    latitude: -13.34414,
    longitude: -71.94458,
  },
  {
    sortOrder: 23,
    selectable: true,
    destinationUrlName: 'Tarapoto',
    defaultCurrencyCode: 'USD',
    lookupId: '9.927.50700',
    parentId: 927,
    timeZone: 'America/Lima',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tarapoto',
    destinationId: 50700,
    latitude: -6.482478,
    longitude: -76.372688,
  },
  {
    sortOrder: 24,
    selectable: true,
    destinationUrlName: 'Trujillo',
    defaultCurrencyCode: 'USD',
    lookupId: '9.927.5462.5463',
    parentId: 5462,
    timeZone: 'America/Lima',
    iataCode: 'TRU',
    destinationType: 'CITY',
    destinationName: 'Trujillo',
    destinationId: 5463,
    latitude: -8.1049736987,
    longitude: -79.0215336025,
  },
  {
    sortOrder: 152,
    selectable: true,
    destinationUrlName: 'Philippines',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4603',
    parentId: 2,
    timeZone: 'Asia/Manila',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Philippines',
    destinationId: 4603,
    latitude: 12.879721,
    longitude: 121.774017,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Bohol',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4603.4604',
    parentId: 4603,
    timeZone: 'Asia/Manila',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Bohol',
    destinationId: 4604,
    latitude: 9.84999,
    longitude: 124.14354,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Legazpi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4603.51547',
    parentId: 4603,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Legazpi',
    destinationId: 51547,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Luzon',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4603.26182',
    parentId: 4603,
    timeZone: 'America/Los_Angeles',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Luzon',
    destinationId: 26182,
    latitude: 36.0955,
    longitude: -115.1758,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Palawan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4603.25945',
    parentId: 4603,
    timeZone: 'Asia/Manila',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Palawan',
    destinationId: 25945,
    latitude: 9.446577,
    longitude: 118.39201,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Sorsogon',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4603.51596',
    parentId: 4603,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Sorsogon',
    destinationId: 51596,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Visayas',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4603.5171',
    parentId: 4603,
    timeZone: 'Asia/Manila',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Visayas',
    destinationId: 5171,
    latitude: 11.0,
    longitude: 123.5,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Anda',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4603.4604.51633',
    parentId: 4604,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Anda',
    destinationId: 51633,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Bacolod',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4603.5171.50708',
    parentId: 5171,
    timeZone: 'Asia/Manila',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bacolod',
    destinationId: 50708,
    latitude: 10.684005,
    longitude: 122.956299,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Balicasag-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4603.4604.51643',
    parentId: 4604,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Balicasag Island',
    destinationId: 51643,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Boracay',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4603.5171.4821',
    parentId: 5171,
    timeZone: 'Asia/Manila',
    iataCode: 'MPH',
    destinationType: 'CITY',
    destinationName: 'Boracay',
    destinationId: 4821,
    latitude: 11.969281,
    longitude: 121.8922095,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Busuanga-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4603.25945.50529',
    parentId: 25945,
    timeZone: 'Asia/Manila',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Busuanga Island',
    destinationId: 50529,
    latitude: 12.13221,
    longitude: 119.93598,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Cagayan-de-Oro',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4603.50905',
    parentId: 4603,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cagayan de Oro',
    destinationId: 50905,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Cebu',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4603.5171.5172',
    parentId: 5171,
    timeZone: 'Asia/Manila',
    iataCode: 'CEB',
    destinationType: 'CITY',
    destinationName: 'Cebu',
    destinationId: 5172,
    latitude: 10.3156992,
    longitude: 123.8854366,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Coron',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4603.25945.25947',
    parentId: 25945,
    timeZone: 'Asia/Manila',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Coron',
    destinationId: 25947,
    latitude: 12.048935,
    longitude: 120.176316,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Davao-City',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4603.50843',
    parentId: 4603,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Davao City',
    destinationId: 50843,
    latitude: 7.1885650236,
    longitude: 125.4414211002,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'El-Nido',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4603.25945.25946',
    parentId: 25945,
    timeZone: 'Asia/Manila',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'El Nido',
    destinationId: 25946,
    latitude: 11.209703,
    longitude: 119.4661,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Manila',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4603.4674',
    parentId: 4603,
    timeZone: 'Asia/Manila',
    iataCode: 'MNL',
    destinationType: 'CITY',
    destinationName: 'Manila',
    destinationId: 4674,
    latitude: 14.5995124,
    longitude: 120.9842195,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Negros-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4603.5171.50614',
    parentId: 5171,
    timeZone: 'Asia/Manila',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Negros Island',
    destinationId: 50614,
    latitude: 10.30544,
    longitude: 122.98453,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Panay-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4603.5171.50531',
    parentId: 5171,
    timeZone: 'Asia/Manila',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Panay Island',
    destinationId: 50531,
    latitude: 11.55526,
    longitude: 122.795174,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Panglao-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4603.4604.50534',
    parentId: 4604,
    timeZone: 'Pacific/Saipan',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Panglao Island',
    destinationId: 50534,
    latitude: 15.24923,
    longitude: 145.794724,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Puerto-Galera',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4603.50927',
    parentId: 4603,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Puerto Galera',
    destinationId: 50927,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Puerto-Princesa',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4603.25945.25948',
    parentId: 25945,
    timeZone: 'Asia/Manila',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Puerto Princesa',
    destinationId: 25948,
    latitude: 9.953175,
    longitude: 118.781289,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Siargao-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4603.50615',
    parentId: 4603,
    timeZone: 'Asia/Manila',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Siargao Island',
    destinationId: 50615,
    latitude: 18.85705,
    longitude: 121.416801,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Tagaytay',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4603.23558',
    parentId: 4603,
    timeZone: 'Asia/Manila',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tagaytay',
    destinationId: 23558,
    latitude: 14.115,
    longitude: 120.9636,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Tagbilaran-City',
    defaultCurrencyCode: 'USD',
    lookupId: '2.4603.4604.4605',
    parentId: 4604,
    timeZone: 'Asia/Manila',
    iataCode: 'TAG',
    destinationType: 'CITY',
    destinationName: 'Tagbilaran City',
    destinationId: 4605,
    latitude: 9.671149,
    longitude: 123.86997,
  },
  {
    sortOrder: 153,
    selectable: true,
    destinationUrlName: 'Poland',
    defaultCurrencyCode: 'USD',
    lookupId: '6.62',
    parentId: 6,
    timeZone: 'Europe/Warsaw',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Poland',
    destinationId: 62,
    latitude: 51.919438,
    longitude: 19.145136,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Gdansk',
    defaultCurrencyCode: 'USD',
    lookupId: '6.62.4213',
    parentId: 62,
    timeZone: 'Europe/Warsaw',
    iataCode: 'GDN',
    destinationType: 'CITY',
    destinationName: 'Gdansk',
    destinationId: 4213,
    latitude: 54.351858,
    longitude: 18.63957,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Krakow',
    defaultCurrencyCode: 'USD',
    lookupId: '6.62.529',
    parentId: 62,
    timeZone: 'Europe/Warsaw',
    iataCode: 'KRK',
    destinationType: 'CITY',
    destinationName: 'Krakow',
    destinationId: 529,
    latitude: 50.0646501,
    longitude: 19.9449799,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Lodz',
    defaultCurrencyCode: 'USD',
    lookupId: '6.62.32671',
    parentId: 62,
    timeZone: 'Europe/Warsaw',
    iataCode: 'LCJ',
    destinationType: 'CITY',
    destinationName: 'Lodz',
    destinationId: 32671,
    latitude: 51.759314,
    longitude: 19.455066,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Lublin',
    defaultCurrencyCode: 'USD',
    lookupId: '6.62.50901',
    parentId: 62,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lublin',
    destinationId: 50901,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Oswiecim',
    defaultCurrencyCode: 'USD',
    lookupId: '6.62.31001',
    parentId: 62,
    timeZone: 'Europe/Warsaw',
    iataCode: 'KRK',
    destinationType: 'CITY',
    destinationName: 'Oswiecim',
    destinationId: 31001,
    latitude: 50.0344,
    longitude: 19.20978,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Poznan',
    defaultCurrencyCode: 'USD',
    lookupId: '6.62.25742',
    parentId: 62,
    timeZone: 'Europe/Warsaw',
    iataCode: 'POZ',
    destinationType: 'CITY',
    destinationName: 'Poznan',
    destinationId: 25742,
    latitude: 52.40648,
    longitude: 16.927205,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Szczecin',
    defaultCurrencyCode: 'USD',
    lookupId: '6.62.4537',
    parentId: 62,
    timeZone: 'Europe/Warsaw',
    iataCode: 'SZZ',
    destinationType: 'CITY',
    destinationName: 'Szczecin',
    destinationId: 4537,
    latitude: 53.428982,
    longitude: 14.553775,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Torun',
    defaultCurrencyCode: 'USD',
    lookupId: '6.62.50865',
    parentId: 62,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Torun',
    destinationId: 50865,
    latitude: 53.0189485447,
    longitude: 18.5994871692,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Warsaw',
    defaultCurrencyCode: 'USD',
    lookupId: '6.62.528',
    parentId: 62,
    timeZone: 'Europe/Warsaw',
    iataCode: 'WAW',
    destinationType: 'CITY',
    destinationName: 'Warsaw',
    destinationId: 528,
    latitude: 52.2296756,
    longitude: 21.0122287,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Wroclaw',
    defaultCurrencyCode: 'USD',
    lookupId: '6.62.24500',
    parentId: 62,
    timeZone: 'Europe/Warsaw',
    iataCode: 'WRO',
    destinationType: 'CITY',
    destinationName: 'Wroclaw',
    destinationId: 24500,
    latitude: 51.107607,
    longitude: 17.038769,
  },
  {
    sortOrder: 154,
    selectable: true,
    destinationUrlName: 'Portugal',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63',
    parentId: 6,
    timeZone: 'Europe/Lisbon',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Portugal',
    destinationId: 63,
    latitude: 39.399872,
    longitude: -8.224454,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Alentejo',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.912',
    parentId: 63,
    timeZone: 'Europe/Lisbon',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Alentejo',
    destinationId: 912,
    latitude: 40.313352,
    longitude: -7.800708,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Azores',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.22379',
    parentId: 63,
    timeZone: 'Atlantic/Azores',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Azores',
    destinationId: 22379,
    latitude: 37.780772,
    longitude: -25.497149,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Beiras',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.23420',
    parentId: 63,
    timeZone: 'Africa/Maputo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Beiras',
    destinationId: 23420,
    latitude: -19.8436,
    longitude: 34.8389,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Estremadura',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.50452',
    parentId: 63,
    timeZone: 'Europe/Lisbon',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Estremadura',
    destinationId: 50452,
    latitude: 39.399872,
    longitude: -8.224454,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Madeira',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.5392',
    parentId: 63,
    timeZone: 'Europe/Lisbon',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Madeira',
    destinationId: 5392,
    latitude: 32.6511,
    longitude: 16.9097,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Northern-Portugal',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.219',
    parentId: 63,
    timeZone: 'Europe/Lisbon',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Northern Portugal',
    destinationId: 219,
    latitude: 41.149968,
    longitude: -8.6102426,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Sao-Miguel',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.50209',
    parentId: 63,
    timeZone: 'Atlantic/Azores',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Sao Miguel',
    destinationId: 50209,
    latitude: 37.806937,
    longitude: -25.501421,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'The-Algarve',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.774',
    parentId: 63,
    timeZone: 'Europe/Lisbon',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'The Algarve',
    destinationId: 774,
    latitude: 37.0169252,
    longitude: -7.9289621,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Albufeira',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.774.22497',
    parentId: 774,
    timeZone: 'Europe/Lisbon',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Albufeira',
    destinationId: 22497,
    latitude: 37.08907,
    longitude: -8.24788,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Alcobaca',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.50452.50453',
    parentId: 50452,
    timeZone: 'Europe/Lisbon',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Alcobaca',
    destinationId: 50453,
    latitude: 39.54997,
    longitude: -8.98293,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Baleal',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.51291',
    parentId: 63,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Baleal',
    destinationId: 51291,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Beja-District',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.912.51403',
    parentId: 912,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Beja District',
    destinationId: 51403,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Belem',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.50282',
    parentId: 63,
    timeZone: 'Europe/Lisbon',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Belem',
    destinationId: 50282,
    latitude: 38.6992,
    longitude: -9.2204,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Braga',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.219.27331',
    parentId: 219,
    timeZone: 'Europe/Lisbon',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Braga',
    destinationId: 27331,
    latitude: 41.54545,
    longitude: -8.42651,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Calheta',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.5392.50841',
    parentId: 5392,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Calheta',
    destinationId: 50841,
    latitude: 32.7372882361,
    longitude: -17.1824817316,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Cascais',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.28587',
    parentId: 63,
    timeZone: 'Europe/Lisbon',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cascais',
    destinationId: 28587,
    latitude: 38.69706,
    longitude: -9.42229,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Coimbra',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.23420.23421',
    parentId: 23420,
    timeZone: 'Europe/Lisbon',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Coimbra',
    destinationId: 23421,
    latitude: 40.20331,
    longitude: -8.41026,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Covilha',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.51232',
    parentId: 63,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Covilha',
    destinationId: 51232,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Evora-District',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.912.50869',
    parentId: 912,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Evora District',
    destinationId: 50869,
    latitude: 38.6323782166,
    longitude: -7.9102815268,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Faial-Island',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.22379.50347',
    parentId: 22379,
    timeZone: 'Atlantic/Azores',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Faial Island',
    destinationId: 50347,
    latitude: 38.5913,
    longitude: -28.6965,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Faro',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.774.23402',
    parentId: 774,
    timeZone: 'Europe/Lisbon',
    iataCode: 'FAO',
    destinationType: 'CITY',
    destinationName: 'Faro',
    destinationId: 23402,
    latitude: 37.01935,
    longitude: -7.93044,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Funchal',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.5392.22388',
    parentId: 5392,
    timeZone: 'Atlantic/Madeira',
    iataCode: 'FNC',
    destinationType: 'CITY',
    destinationName: 'Funchal',
    destinationId: 22388,
    latitude: 32.66693,
    longitude: -16.92406,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Horta',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.22379.50450',
    parentId: 22379,
    timeZone: 'Atlantic/Azores',
    iataCode: 'HOR',
    destinationType: 'CITY',
    destinationName: 'Horta',
    destinationId: 50450,
    latitude: 38.542381,
    longitude: -28.627649,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Lagoa',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.774.50454',
    parentId: 774,
    timeZone: 'Europe/Lisbon',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lagoa',
    destinationId: 50454,
    latitude: 37.134731,
    longitude: -8.45262,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Lagos',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.774.23572',
    parentId: 774,
    timeZone: 'Europe/Lisbon',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lagos',
    destinationId: 23572,
    latitude: 37.102601,
    longitude: -8.670905,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Lamego',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.219.50938',
    parentId: 219,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lamego',
    destinationId: 50938,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Lisbon',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.538',
    parentId: 63,
    timeZone: 'Europe/Lisbon',
    iataCode: 'LIS',
    destinationType: 'CITY',
    destinationName: 'Lisbon',
    destinationId: 538,
    latitude: 38.7252,
    longitude: -9.15,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Maia',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.219.50348',
    parentId: 219,
    timeZone: 'Europe/Lisbon',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Maia',
    destinationId: 50348,
    latitude: 41.2279,
    longitude: -8.621,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Manteigas',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.50960',
    parentId: 63,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Manteigas',
    destinationId: 50960,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'Mesao-Frio',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.219.51349',
    parentId: 219,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mesao Frio',
    destinationId: 51349,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 23,
    selectable: true,
    destinationUrlName: 'Nazare',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.50353',
    parentId: 63,
    timeZone: 'Europe/Lisbon',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nazare',
    destinationId: 50353,
    latitude: 39.6012,
    longitude: -9.0701,
  },
  {
    sortOrder: 24,
    selectable: true,
    destinationUrlName: 'Paco-de-Arcos',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.50281',
    parentId: 63,
    timeZone: 'Europe/Lisbon',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Paco de Arcos',
    destinationId: 50281,
    latitude: 38.6968,
    longitude: -9.2916,
  },
  {
    sortOrder: 25,
    selectable: true,
    destinationUrlName: 'Peso-Da-Regua',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.219.50451',
    parentId: 219,
    timeZone: 'Europe/Lisbon',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Peso Da Regua',
    destinationId: 50451,
    latitude: 41.16552,
    longitude: -7.78618,
  },
  {
    sortOrder: 26,
    selectable: true,
    destinationUrlName: 'Pico',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.22379.50346',
    parentId: 22379,
    timeZone: 'Atlantic/Azores',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Pico',
    destinationId: 50346,
    latitude: 38.458,
    longitude: -28.3228,
  },
  {
    sortOrder: 27,
    selectable: true,
    destinationUrlName: 'Pinhao',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.219.50868',
    parentId: 219,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Pinhao',
    destinationId: 50868,
    latitude: 41.1925263215,
    longitude: -7.5461082556,
  },
  {
    sortOrder: 28,
    selectable: true,
    destinationUrlName: 'Ponta-Delgada',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.22379.22380',
    parentId: 22379,
    timeZone: 'Atlantic/Azores',
    iataCode: 'PDL',
    destinationType: 'CITY',
    destinationName: 'Ponta Delgada',
    destinationId: 22380,
    latitude: 37.74283,
    longitude: -25.680587,
  },
  {
    sortOrder: 29,
    selectable: true,
    destinationUrlName: 'Portalegre-District',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.912.51402',
    parentId: 912,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Portalegre District',
    destinationId: 51402,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 30,
    selectable: true,
    destinationUrlName: 'Portimao',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.774.4478',
    parentId: 774,
    timeZone: 'Europe/Lisbon',
    iataCode: 'PRM',
    destinationType: 'CITY',
    destinationName: 'Portimao',
    destinationId: 4478,
    latitude: 37.136089,
    longitude: -8.535583,
  },
  {
    sortOrder: 31,
    selectable: true,
    destinationUrlName: 'Porto',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.219.26879',
    parentId: 219,
    timeZone: 'Europe/Lisbon',
    iataCode: 'OPO',
    destinationType: 'CITY',
    destinationName: 'Porto',
    destinationId: 26879,
    latitude: 41.15794,
    longitude: -8.62911,
  },
  {
    sortOrder: 32,
    selectable: true,
    destinationUrlName: 'Povoacao',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.22379.51281',
    parentId: 22379,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Povoação',
    destinationId: 51281,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 33,
    selectable: true,
    destinationUrlName: 'Provesende',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.219.51343',
    parentId: 219,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Provesende',
    destinationId: 51343,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 34,
    selectable: true,
    destinationUrlName: 'Querenca',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.774.51143',
    parentId: 774,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Querenca',
    destinationId: 51143,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 35,
    selectable: true,
    destinationUrlName: 'Santa-Cruz',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.50952',
    parentId: 63,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Santa Cruz',
    destinationId: 50952,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 36,
    selectable: true,
    destinationUrlName: 'Santa-Maria',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.22379.25876',
    parentId: 22379,
    timeZone: 'Europe/Rome',
    iataCode: 'SMA',
    destinationType: 'CITY',
    destinationName: 'Santa Maria',
    destinationId: 25876,
    latitude: 43.7198,
    longitude: 10.3973,
  },
  {
    sortOrder: 37,
    selectable: true,
    destinationUrlName: 'Sao-Martinho-do-Porto',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.50945',
    parentId: 63,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sao Martinho do Porto',
    destinationId: 50945,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 38,
    selectable: true,
    destinationUrlName: 'Serradas',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.50283',
    parentId: 63,
    timeZone: 'Europe/Lisbon',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Serradas',
    destinationId: 50283,
    latitude: 38.7692,
    longitude: -9.3363,
  },
  {
    sortOrder: 39,
    selectable: true,
    destinationUrlName: 'Setubal-District',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.912.5016',
    parentId: 912,
    timeZone: 'Europe/Lisbon',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Setubal District',
    destinationId: 5016,
    latitude: 38.52409,
    longitude: -8.89259,
  },
  {
    sortOrder: 40,
    selectable: true,
    destinationUrlName: 'Sintra',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.50861',
    parentId: 63,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sintra',
    destinationId: 50861,
    latitude: 38.8114131686,
    longitude: -9.3826139872,
  },
  {
    sortOrder: 41,
    selectable: true,
    destinationUrlName: 'Terceira',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.63.22379.4539',
    parentId: 22379,
    timeZone: 'Atlantic/Azores',
    iataCode: 'TER',
    destinationType: 'CITY',
    destinationName: 'Terceira',
    destinationId: 4539,
    latitude: 38.722602,
    longitude: -27.214643,
  },
  {
    sortOrder: 155,
    selectable: true,
    destinationUrlName: 'Puerto-Rico',
    defaultCurrencyCode: 'USD',
    lookupId: '4.36',
    parentId: 4,
    timeZone: 'America/Puerto_Rico',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Puerto Rico',
    destinationId: 36,
    latitude: 18.220833,
    longitude: -66.590149,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'San-Juan',
    defaultCurrencyCode: 'USD',
    lookupId: '4.36.903',
    parentId: 36,
    timeZone: 'America/Puerto_Rico',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'San Juan',
    destinationId: 903,
    latitude: 18.4663338,
    longitude: -66.1057217,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Arecibo',
    defaultCurrencyCode: 'USD',
    lookupId: '4.36.34207',
    parentId: 36,
    timeZone: 'America/Puerto_Rico',
    iataCode: 'ARE',
    destinationType: 'CITY',
    destinationName: 'Arecibo',
    destinationId: 34207,
    latitude: 18.460457,
    longitude: -66.748401,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Culebra',
    defaultCurrencyCode: 'USD',
    lookupId: '4.36.34162',
    parentId: 36,
    timeZone: 'America/Puerto_Rico',
    iataCode: 'CPX',
    destinationType: 'CITY',
    destinationName: 'Culebra',
    destinationId: 34162,
    latitude: 18.303091,
    longitude: -65.300321,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Fajardo',
    defaultCurrencyCode: 'USD',
    lookupId: '4.36.23854',
    parentId: 36,
    timeZone: 'America/Puerto_Rico',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Fajardo',
    destinationId: 23854,
    latitude: 18.325811,
    longitude: -65.652616,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Isla-Verde',
    defaultCurrencyCode: 'USD',
    lookupId: '4.36.50532',
    parentId: 36,
    timeZone: 'America/Puerto_Rico',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Isla Verde',
    destinationId: 50532,
    latitude: 18.48527,
    longitude: -66.41347,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Luquillo',
    defaultCurrencyCode: 'USD',
    lookupId: '4.36.36682',
    parentId: 36,
    timeZone: 'America/Puerto_Rico',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Luquillo',
    destinationId: 36682,
    latitude: 18.3387978,
    longitude: -65.7901637,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Rincon',
    defaultCurrencyCode: 'USD',
    lookupId: '4.36.25616',
    parentId: 36,
    timeZone: 'America/Puerto_Rico',
    iataCode: 'MAZ',
    destinationType: 'CITY',
    destinationName: 'Rincón',
    destinationId: 25616,
    latitude: 18.340289,
    longitude: -67.250843,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Utuado',
    defaultCurrencyCode: 'USD',
    lookupId: '4.36.36687',
    parentId: 36,
    timeZone: 'America/Puerto_Rico',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Utuado',
    destinationId: 36687,
    latitude: 18.2732913,
    longitude: -66.7124387,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Vieques',
    defaultCurrencyCode: 'USD',
    lookupId: '4.36.22812',
    parentId: 36,
    timeZone: 'America/Puerto_Rico',
    iataCode: 'VQS',
    destinationType: 'CITY',
    destinationName: 'Vieques',
    destinationId: 22812,
    latitude: 18.12629,
    longitude: -65.4401,
  },
  {
    sortOrder: 156,
    selectable: true,
    destinationUrlName: 'Qatar',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4452',
    parentId: 1,
    timeZone: 'Asia/Qatar',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Qatar',
    destinationId: 4452,
    latitude: 25.3548,
    longitude: 51.1839,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Doha',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4452.4453',
    parentId: 4452,
    timeZone: 'Asia/Qatar',
    iataCode: 'DOH',
    destinationType: 'CITY',
    destinationName: 'Doha',
    destinationId: 4453,
    latitude: 25.28545,
    longitude: 51.53104,
  },
  {
    sortOrder: 157,
    selectable: true,
    destinationUrlName: 'Romania',
    defaultCurrencyCode: 'USD',
    lookupId: '6.64',
    parentId: 6,
    timeZone: 'Europe/Bucharest',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Romania',
    destinationId: 64,
    latitude: 45.943161,
    longitude: 24.96676,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Black-Sea-Coast',
    defaultCurrencyCode: 'USD',
    lookupId: '6.64.23889',
    parentId: 64,
    timeZone: 'Europe/Bucharest',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Black Sea Coast',
    destinationId: 23889,
    latitude: 44.425443,
    longitude: 28.593177,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Lacu-Rosu',
    defaultCurrencyCode: 'USD',
    lookupId: '6.64.51693',
    parentId: 64,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Lacu Rosu',
    destinationId: 51693,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Maramures-County',
    defaultCurrencyCode: 'USD',
    lookupId: '6.64.51675',
    parentId: 64,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Maramures County',
    destinationId: 51675,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Transylvania',
    defaultCurrencyCode: 'USD',
    lookupId: '6.64.22042',
    parentId: 64,
    timeZone: 'Europe/Bucharest',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Transylvania',
    destinationId: 22042,
    latitude: 32.678467,
    longitude: -91.182609,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Wallachia',
    defaultCurrencyCode: 'USD',
    lookupId: '6.64.26151',
    parentId: 64,
    timeZone: 'Europe/Bucharest',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Wallachia',
    destinationId: 26151,
    latitude: 44.5,
    longitude: 26.0,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Western-Romania',
    defaultCurrencyCode: 'USD',
    lookupId: '6.64.23886',
    parentId: 64,
    timeZone: 'Europe/Bucharest',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Western Romania',
    destinationId: 23886,
    latitude: 45.75372,
    longitude: 21.22571,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Arad',
    defaultCurrencyCode: 'USD',
    lookupId: '6.64.22042.25907',
    parentId: 22042,
    timeZone: 'Europe/Bucharest',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Arad',
    destinationId: 25907,
    latitude: 46.186352,
    longitude: 21.313479,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Brasov',
    defaultCurrencyCode: 'USD',
    lookupId: '6.64.22042.23067',
    parentId: 22042,
    timeZone: 'Europe/Bucharest',
    iataCode: 'TBA',
    destinationType: 'CITY',
    destinationName: 'Brasov',
    destinationId: 23067,
    latitude: 45.666667,
    longitude: 25.616667,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Bucharest',
    defaultCurrencyCode: 'USD',
    lookupId: '6.64.26151.22134',
    parentId: 26151,
    timeZone: 'Europe/Bucharest',
    iataCode: 'BUH',
    destinationType: 'CITY',
    destinationName: 'Bucharest',
    destinationId: 22134,
    latitude: 44.42677,
    longitude: 26.10254,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Cluj-Napoca',
    defaultCurrencyCode: 'USD',
    lookupId: '6.64.22042.22043',
    parentId: 22042,
    timeZone: 'Europe/Bucharest',
    iataCode: 'CLJ',
    destinationType: 'CITY',
    destinationName: 'Cluj-Napoca',
    destinationId: 22043,
    latitude: 46.77121,
    longitude: 23.62364,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Constanta',
    defaultCurrencyCode: 'USD',
    lookupId: '6.64.23889.23890',
    parentId: 23889,
    timeZone: 'Europe/Bucharest',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Constanta',
    destinationId: 23890,
    latitude: 44.160076,
    longitude: 28.636966,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Iasi',
    defaultCurrencyCode: 'USD',
    lookupId: '6.64.25270',
    parentId: 64,
    timeZone: 'Europe/Bucharest',
    iataCode: 'IAS',
    destinationType: 'CITY',
    destinationName: 'Iasi',
    destinationId: 25270,
    latitude: 47.158153,
    longitude: 27.602323,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Miercurea-Ciuc',
    defaultCurrencyCode: 'USD',
    lookupId: '6.64.22042.51745',
    parentId: 22042,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Miercurea-Ciuc',
    destinationId: 51745,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Oradea',
    defaultCurrencyCode: 'USD',
    lookupId: '6.64.23886.23888',
    parentId: 23886,
    timeZone: 'Europe/Bucharest',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Oradea',
    destinationId: 23888,
    latitude: 47.046151,
    longitude: 21.921383,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Otopeni',
    defaultCurrencyCode: 'USD',
    lookupId: '6.64.50617',
    parentId: 64,
    timeZone: 'Europe/Bucharest',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Otopeni',
    destinationId: 50617,
    latitude: 44.54974,
    longitude: 26.07379,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Sibiu',
    defaultCurrencyCode: 'USD',
    lookupId: '6.64.22042.22624',
    parentId: 22042,
    timeZone: 'Europe/Bucharest',
    iataCode: 'SBZ',
    destinationType: 'CITY',
    destinationName: 'Sibiu',
    destinationId: 22624,
    latitude: 45.79833,
    longitude: 24.12558,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Sighetu-Marmatiei',
    defaultCurrencyCode: 'USD',
    lookupId: '6.64.51675.52183',
    parentId: 51675,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sighetu Marmatiei',
    destinationId: 52183,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Sighisoara',
    defaultCurrencyCode: 'USD',
    lookupId: '6.64.22042.22626',
    parentId: 22042,
    timeZone: 'Europe/Bucharest',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sighisoara',
    destinationId: 22626,
    latitude: 46.2197,
    longitude: 24.79639,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Sinaia',
    defaultCurrencyCode: 'USD',
    lookupId: '6.64.26151.26152',
    parentId: 26151,
    timeZone: 'Europe/Bucharest',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sinaia',
    destinationId: 26152,
    latitude: 45.3457,
    longitude: 25.5479,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Targu-Mures',
    defaultCurrencyCode: 'USD',
    lookupId: '6.64.22042.22693',
    parentId: 22042,
    timeZone: 'Europe/Bucharest',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Targu Mures',
    destinationId: 22693,
    latitude: 46.538742,
    longitude: 24.552466,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Timisoara',
    defaultCurrencyCode: 'USD',
    lookupId: '6.64.23886.23887',
    parentId: 23886,
    timeZone: 'Europe/Bucharest',
    iataCode: 'TSR',
    destinationType: 'CITY',
    destinationName: 'Timisoara',
    destinationId: 23887,
    latitude: 45.74887,
    longitude: 21.20868,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Tulcea',
    defaultCurrencyCode: 'USD',
    lookupId: '6.64.23889.25739',
    parentId: 23889,
    timeZone: 'Europe/Bucharest',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tulcea',
    destinationId: 25739,
    latitude: 45.17156,
    longitude: 28.79163,
  },
  {
    sortOrder: 158,
    selectable: true,
    destinationUrlName: 'Russia',
    defaultCurrencyCode: 'USD',
    lookupId: '6.65',
    parentId: 6,
    timeZone: 'Europe/Moscow',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Russia',
    destinationId: 65,
    latitude: 61.52401,
    longitude: 105.318756,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Northwest-Russia',
    defaultCurrencyCode: 'USD',
    lookupId: '6.65.25706',
    parentId: 65,
    timeZone: 'Europe/Moscow',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Northwest Russia',
    destinationId: 25706,
    latitude: 59.95,
    longitude: 30.3167,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Moscow',
    defaultCurrencyCode: 'USD',
    lookupId: '6.65.5066',
    parentId: 65,
    timeZone: 'Europe/Moscow',
    iataCode: 'MOW',
    destinationType: 'CITY',
    destinationName: 'Moscow',
    destinationId: 5066,
    latitude: 55.7427928,
    longitude: 37.6154009,
  },
  {
    sortOrder: 159,
    selectable: true,
    destinationUrlName: 'Rwanda',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21908',
    parentId: 1,
    timeZone: 'Africa/Kigali',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Rwanda',
    destinationId: 21908,
    latitude: -1.940278,
    longitude: 29.873888,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Akagera-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21908.52088',
    parentId: 21908,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Akagera National Park',
    destinationId: 52088,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Kinigi',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21908.51833',
    parentId: 21908,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Kinigi',
    destinationId: 51833,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Volcanoes-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21908.23351',
    parentId: 21908,
    timeZone: 'Africa/Kigali',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Volcanoes National Park',
    destinationId: 23351,
    latitude: -1.432028,
    longitude: 29.56663,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Gisenyi',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21908.50349',
    parentId: 21908,
    timeZone: 'Africa/Kigali',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Gisenyi',
    destinationId: 50349,
    latitude: -1.7028,
    longitude: 29.2564,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Kibuye',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21908.50456',
    parentId: 21908,
    timeZone: 'Africa/Kigali',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kibuye',
    destinationId: 50456,
    latitude: -2.05882,
    longitude: 29.34634,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Kigali',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21908.22362',
    parentId: 21908,
    timeZone: 'Africa/Kigali',
    iataCode: 'KGL',
    destinationType: 'CITY',
    destinationName: 'Kigali',
    destinationId: 22362,
    latitude: -1.970579,
    longitude: 30.104429,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Ruhengeri',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21908.50284',
    parentId: 21908,
    timeZone: 'Africa/Kigali',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ruhengeri',
    destinationId: 50284,
    latitude: -1.4998,
    longitude: 29.635,
  },
  {
    sortOrder: 160,
    selectable: true,
    destinationUrlName: 'Reunion-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4395',
    parentId: 1,
    timeZone: 'Indian/Reunion',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Réunion Island',
    destinationId: 4395,
    latitude: -21.1351121,
    longitude: 55.2471124,
  },
  {
    sortOrder: 161,
    selectable: true,
    destinationUrlName: 'Samoa',
    defaultCurrencyCode: 'USD',
    lookupId: '3.4770',
    parentId: 3,
    timeZone: 'Pacific/Apia',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Samoa',
    destinationId: 4770,
    latitude: -13.759,
    longitude: -172.1046,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Upolu',
    defaultCurrencyCode: 'USD',
    lookupId: '3.4770.50459',
    parentId: 4770,
    timeZone: 'Pacific/Apia',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Upolu',
    destinationId: 50459,
    latitude: -13.83282,
    longitude: -171.760056,
  },
  {
    sortOrder: 162,
    selectable: true,
    destinationUrlName: 'San-Marino',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21911',
    parentId: 6,
    timeZone: 'Europe/San_Marino',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'San Marino',
    destinationId: 21911,
    latitude: 43.9424,
    longitude: 12.4578,
  },
  {
    sortOrder: 163,
    selectable: true,
    destinationUrlName: 'Saudi-Arabia',
    defaultCurrencyCode: 'USD',
    lookupId: '1.22154',
    parentId: 1,
    timeZone: 'Asia/Riyadh',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Saudi Arabia',
    destinationId: 22154,
    latitude: 23.8859,
    longitude: 45.0792,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Tabouk',
    defaultCurrencyCode: 'USD',
    lookupId: '1.22154.51790',
    parentId: 22154,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Tabouk',
    destinationId: 51790,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Taif',
    defaultCurrencyCode: 'USD',
    lookupId: '1.22154.51555',
    parentId: 22154,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Taif',
    destinationId: 51555,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'AlUla',
    defaultCurrencyCode: 'USD',
    lookupId: '1.22154.51269',
    parentId: 22154,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'AlUla',
    destinationId: 51269,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Jeddah',
    defaultCurrencyCode: 'USD',
    lookupId: '1.22154.50462',
    parentId: 22154,
    timeZone: 'Asia/Riyadh',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Jeddah',
    destinationId: 50462,
    latitude: 21.485811,
    longitude: 39.192505,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Medina',
    defaultCurrencyCode: 'USD',
    lookupId: '1.22154.50350',
    parentId: 22154,
    timeZone: 'Asia/Riyadh',
    iataCode: 'MED',
    destinationType: 'CITY',
    destinationName: 'Medina',
    destinationId: 50350,
    latitude: 24.5247,
    longitude: 39.5692,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Riyadh',
    defaultCurrencyCode: 'USD',
    lookupId: '1.22154.50285',
    parentId: 22154,
    timeZone: 'Asia/Riyadh',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Riyadh',
    destinationId: 50285,
    latitude: 24.7136,
    longitude: 46.6753,
  },
  {
    sortOrder: 164,
    selectable: true,
    destinationUrlName: 'Scotland',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.732',
    parentId: 6,
    timeZone: 'Europe/London',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Scotland',
    destinationId: 732,
    latitude: 56.4906712,
    longitude: -4.2026458,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Central-Scotland',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.732.23269',
    parentId: 732,
    timeZone: 'Europe/London',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Central Scotland',
    destinationId: 23269,
    latitude: 56.11653,
    longitude: -3.93691,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Isle-of-Lewis',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.732.4978',
    parentId: 732,
    timeZone: 'Europe/London',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Isle of Lewis',
    destinationId: 4978,
    latitude: 58.2132,
    longitude: -6.5227,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Northeast-Scotland',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.732.26303',
    parentId: 732,
    timeZone: 'Europe/London',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Northeast Scotland',
    destinationId: 26303,
    latitude: 56.49067,
    longitude: -4.20265,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Shetland-Islands',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.732.33624',
    parentId: 732,
    timeZone: 'Europe/London',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Shetland Islands',
    destinationId: 33624,
    latitude: 60.7597,
    longitude: -0.895,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Southern-Scotland',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.732.26219',
    parentId: 732,
    timeZone: 'Europe/London',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Southern Scotland',
    destinationId: 26219,
    latitude: 55.07,
    longitude: -3.603,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'The-Scottish-Highlands',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.732.768',
    parentId: 732,
    timeZone: 'Europe/London',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'The Scottish Highlands',
    destinationId: 768,
    latitude: 57.471543087,
    longitude: -4.216003418,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Aberdeen',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.732.26303.26304',
    parentId: 26303,
    timeZone: 'Europe/London',
    iataCode: 'ABZ',
    destinationType: 'CITY',
    destinationName: 'Aberdeen',
    destinationId: 26304,
    latitude: 57.149865,
    longitude: -2.094372,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Aberfeldy',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.732.23269.23270',
    parentId: 23269,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Aberfeldy',
    destinationId: 23270,
    latitude: 56.621688,
    longitude: -3.865746,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Aviemore',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.732.768.25389',
    parentId: 768,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Aviemore',
    destinationId: 25389,
    latitude: 57.194296,
    longitude: -3.822197,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Ayr',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.732.26219.26220',
    parentId: 26219,
    timeZone: 'Europe/London',
    iataCode: 'AYR',
    destinationType: 'CITY',
    destinationName: 'Ayr',
    destinationId: 26220,
    latitude: 55.4585,
    longitude: -4.6292,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Dundee',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.732.26303.33093',
    parentId: 26303,
    timeZone: 'Europe/London',
    iataCode: 'DND',
    destinationType: 'CITY',
    destinationName: 'Dundee',
    destinationId: 33093,
    latitude: 56.461966,
    longitude: -2.971217,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Edinburgh',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.732.739',
    parentId: 732,
    timeZone: 'Europe/London',
    iataCode: 'EDI',
    destinationType: 'CITY',
    destinationName: 'Edinburgh',
    destinationId: 739,
    latitude: 55.9661128902,
    longitude: -3.1880950928,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Fort-William',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.732.768.22391',
    parentId: 768,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Fort William',
    destinationId: 22391,
    latitude: 56.819864,
    longitude: -5.103285,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Glasgow',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.732.740',
    parentId: 732,
    timeZone: 'Europe/London',
    iataCode: 'GLA',
    destinationType: 'CITY',
    destinationName: 'Glasgow',
    destinationId: 740,
    latitude: 55.8656274,
    longitude: -4.2572227,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Glencoe-Village',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.732.768.51577',
    parentId: 768,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Glencoe Village',
    destinationId: 51577,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Invergordon',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.732.768.4481',
    parentId: 768,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Invergordon',
    destinationId: 4481,
    latitude: 57.6864,
    longitude: -4.1693,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Inverness',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.732.768.5051',
    parentId: 768,
    timeZone: 'Europe/London',
    iataCode: 'INV',
    destinationType: 'CITY',
    destinationName: 'Inverness',
    destinationId: 5051,
    latitude: 57.477773,
    longitude: -4.224721,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Kirkwall',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.732.4252',
    parentId: 732,
    timeZone: 'Europe/London',
    iataCode: 'KOI',
    destinationType: 'CITY',
    destinationName: 'Kirkwall',
    destinationId: 4252,
    latitude: 58.982174,
    longitude: -2.960248,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Laggan',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.732.768.51779',
    parentId: 768,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Laggan',
    destinationId: 51779,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Lerwick',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.732.33624.4254',
    parentId: 33624,
    timeZone: 'Europe/London',
    iataCode: 'LWK',
    destinationType: 'CITY',
    destinationName: 'Lerwick',
    destinationId: 4254,
    latitude: 60.152985,
    longitude: -1.148303,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Loch-Ness-Region',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.732.768.50934',
    parentId: 768,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Loch Ness Region',
    destinationId: 50934,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Oban',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.732.4255',
    parentId: 732,
    timeZone: 'Europe/London',
    iataCode: 'OBN',
    destinationType: 'CITY',
    destinationName: 'Oban',
    destinationId: 4255,
    latitude: 56.41516,
    longitude: -5.47105,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Portree',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.732.4257',
    parentId: 732,
    timeZone: 'Europe/London',
    iataCode: 'SKL',
    destinationType: 'CITY',
    destinationName: 'Portree',
    destinationId: 4257,
    latitude: 57.412533,
    longitude: -6.195621,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'South-Queensferry',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.732.739.51423',
    parentId: 739,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'South Queensferry',
    destinationId: 51423,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'St-Andrews',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.732.26303.50621',
    parentId: 26303,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'St. Andrews',
    destinationId: 50621,
    latitude: 56.338909,
    longitude: -2.79893,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Stirling',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.732.22938',
    parentId: 732,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Stirling',
    destinationId: 22938,
    latitude: 56.11652,
    longitude: -3.9369,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Stornoway',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.732.4978.4979',
    parentId: 4978,
    timeZone: 'Europe/London',
    iataCode: 'SYY',
    destinationType: 'CITY',
    destinationName: 'Stornoway',
    destinationId: 4979,
    latitude: 58.209435,
    longitude: -6.384869,
  },
  {
    sortOrder: 165,
    selectable: true,
    destinationUrlName: 'Senegal',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4448',
    parentId: 1,
    timeZone: 'Africa/Dakar',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Senegal',
    destinationId: 4448,
    latitude: 14.4974,
    longitude: -14.4524,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Dakar',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4448.4449',
    parentId: 4448,
    timeZone: 'Africa/Dakar',
    iataCode: 'DKR',
    destinationType: 'CITY',
    destinationName: 'Dakar',
    destinationId: 4449,
    latitude: 14.764449,
    longitude: -17.364224,
  },
  {
    sortOrder: 166,
    selectable: true,
    destinationUrlName: 'Serbia',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21912',
    parentId: 6,
    timeZone: 'Europe/Belgrade',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Serbia',
    destinationId: 21912,
    latitude: 44.0165,
    longitude: 21.0059,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Subotica',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21912.51621',
    parentId: 21912,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Subotica',
    destinationId: 51621,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Belgrade',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21912.22817',
    parentId: 21912,
    timeZone: 'Europe/Belgrade',
    iataCode: 'BEG',
    destinationType: 'CITY',
    destinationName: 'Belgrade',
    destinationId: 22817,
    latitude: 44.78657,
    longitude: 20.44892,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Nis',
    defaultCurrencyCode: 'USD',
    lookupId: '6.21912.50941',
    parentId: 21912,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nis',
    destinationId: 50941,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 167,
    selectable: true,
    destinationUrlName: 'Seychelles',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4868',
    parentId: 1,
    timeZone: 'Indian/Mahe',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Seychelles',
    destinationId: 4868,
    latitude: -7.2519398,
    longitude: 46.6899646,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Mahe',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4868.23302',
    parentId: 4868,
    timeZone: 'Indian/Mahe',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Mahe',
    destinationId: 23302,
    latitude: 55.4334,
    longitude: -4.7078,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Anse-Volbert',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4868.50354',
    parentId: 4868,
    timeZone: 'Indian/Mahe',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Anse Volbert',
    destinationId: 50354,
    latitude: -4.3169,
    longitude: 55.7477,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Beau-Vallon',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4868.23302.50351',
    parentId: 23302,
    timeZone: 'Indian/Mahe',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Beau Vallon',
    destinationId: 50351,
    latitude: -4.6211,
    longitude: 55.4278,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Eden-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4868.23302.51783',
    parentId: 23302,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Eden Island',
    destinationId: 51783,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'La-Digue-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4868.50356',
    parentId: 4868,
    timeZone: 'Indian/Mahe',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'La Digue Island',
    destinationId: 50356,
    latitude: -4.3591,
    longitude: 55.8412,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Praslin-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4868.50352',
    parentId: 4868,
    timeZone: 'Indian/Mahe',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Praslin Island',
    destinationId: 50352,
    latitude: -4.3326,
    longitude: 55.7467,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Victoria',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4868.23302.23304',
    parentId: 23302,
    timeZone: 'Indian/Mahe',
    iataCode: 'SEZ',
    destinationType: 'CITY',
    destinationName: 'Victoria',
    destinationId: 23304,
    latitude: -4.619357,
    longitude: 55.451737,
  },
  {
    sortOrder: 168,
    selectable: true,
    destinationUrlName: 'Sierra-Leone',
    defaultCurrencyCode: 'USD',
    lookupId: '1.22155',
    parentId: 1,
    timeZone: 'Africa/Freetown',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Sierra Leone',
    destinationId: 22155,
    latitude: 8.4606,
    longitude: -11.7799,
  },
  {
    sortOrder: 169,
    selectable: true,
    destinationUrlName: 'Singapore',
    defaultCurrencyCode: 'USD',
    lookupId: '2.18',
    parentId: 2,
    timeZone: 'Asia/Singapore',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Singapore',
    destinationId: 18,
    latitude: 1.352083,
    longitude: 103.819836,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Pulau-Ubin',
    defaultCurrencyCode: 'USD',
    lookupId: '2.18.50463',
    parentId: 18,
    timeZone: 'Asia/Singapore',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Pulau Ubin',
    destinationId: 50463,
    latitude: 1.40292,
    longitude: 103.970734,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Sentosa-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '2.18.50208',
    parentId: 18,
    timeZone: 'Asia/Singapore',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sentosa Island',
    destinationId: 50208,
    latitude: 1.25035,
    longitude: 103.843689,
  },
  {
    sortOrder: 170,
    selectable: true,
    destinationUrlName: 'Slovakia',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.66',
    parentId: 6,
    timeZone: 'Europe/Bratislava',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Slovakia',
    destinationId: 66,
    latitude: 48.669026,
    longitude: 19.699024,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Banska-Bystrica',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.66.30636',
    parentId: 66,
    timeZone: 'Europe/Bratislava',
    iataCode: 'SLD',
    destinationType: 'CITY',
    destinationName: 'Banská Bystrica',
    destinationId: 30636,
    latitude: 48.73628,
    longitude: 19.14619,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Bratislava',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.66.5561',
    parentId: 66,
    timeZone: 'Europe/Bratislava',
    iataCode: 'BTS',
    destinationType: 'CITY',
    destinationName: 'Bratislava',
    destinationId: 5561,
    latitude: 48.145892,
    longitude: 17.107137,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Kosice',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.66.50912',
    parentId: 66,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kosice',
    destinationId: 50912,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Poprad',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.66.24205',
    parentId: 66,
    timeZone: 'Europe/Bratislava',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Poprad',
    destinationId: 24205,
    latitude: 49.050968,
    longitude: 20.296544,
  },
  {
    sortOrder: 171,
    selectable: true,
    destinationUrlName: 'Slovenia',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.734',
    parentId: 6,
    timeZone: 'Europe/Ljubljana',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Slovenia',
    destinationId: 734,
    latitude: 46.151241,
    longitude: 14.995463,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Slovenian-Istria',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.734.51780',
    parentId: 734,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Slovenian Istria',
    destinationId: 51780,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Bled',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.734.22044',
    parentId: 734,
    timeZone: 'Europe/Ljubljana',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bled',
    destinationId: 22044,
    latitude: 46.36833,
    longitude: 14.11458,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Bovec',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.734.24351',
    parentId: 734,
    timeZone: 'Europe/Ljubljana',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bovec',
    destinationId: 24351,
    latitude: 46.337559,
    longitude: 13.550918,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Koper',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.734.4170',
    parentId: 734,
    timeZone: 'Europe/Ljubljana',
    iataCode: 'TRS',
    destinationType: 'CITY',
    destinationName: 'Koper',
    destinationId: 4170,
    latitude: 45.5482731,
    longitude: 13.731213,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Ljubljana',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.734.5257',
    parentId: 734,
    timeZone: 'Europe/Ljubljana',
    iataCode: 'LJU',
    destinationType: 'CITY',
    destinationName: 'Ljubljana',
    destinationId: 5257,
    latitude: 46.05,
    longitude: 14.5,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Maribor',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.734.50920',
    parentId: 734,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Maribor',
    destinationId: 50920,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Piran',
    defaultCurrencyCode: 'EUR',
    lookupId: '6.734.28586',
    parentId: 734,
    timeZone: 'Europe/Ljubljana',
    iataCode: 'POW',
    destinationType: 'CITY',
    destinationName: 'Piran',
    destinationId: 28586,
    latitude: 45.52832,
    longitude: 13.56829,
  },
  {
    sortOrder: 172,
    selectable: true,
    destinationUrlName: 'Somalia',
    defaultCurrencyCode: 'USD',
    lookupId: '1.21932',
    parentId: 1,
    timeZone: 'Africa/Mogadishu',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Somalia',
    destinationId: 21932,
    latitude: 5.1521,
    longitude: 46.1996,
  },
  {
    sortOrder: 173,
    selectable: true,
    destinationUrlName: 'South-Africa',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11',
    parentId: 1,
    timeZone: 'Africa/Johannesburg',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'South Africa',
    destinationId: 11,
    latitude: -30.559482,
    longitude: 22.937506,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Eastern-Cape',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.51404',
    parentId: 11,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Eastern Cape',
    destinationId: 51404,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Garden-Route',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.5613',
    parentId: 11,
    timeZone: 'Africa/Johannesburg',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Garden Route',
    destinationId: 5613,
    latitude: -22.973102,
    longitude: 30.463519,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Gauteng',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.22818',
    parentId: 11,
    timeZone: 'Africa/Johannesburg',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Gauteng',
    destinationId: 22818,
    latitude: -26.270759,
    longitude: 28.112268,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Kruger-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.776',
    parentId: 11,
    timeZone: 'Africa/Johannesburg',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Kruger National Park',
    destinationId: 776,
    latitude: -23.8214244,
    longitude: 31.4456179,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'KwaZulu-Natal',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.23487',
    parentId: 11,
    timeZone: 'Africa/Johannesburg',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'KwaZulu-Natal',
    destinationId: 23487,
    latitude: -28.530554,
    longitude: 30.895824,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'North-West',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.23345',
    parentId: 11,
    timeZone: 'Africa/Johannesburg',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'North West',
    destinationId: 23345,
    latitude: -26.66386,
    longitude: 25.28376,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Western-Cape',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.23346',
    parentId: 11,
    timeZone: 'Africa/Johannesburg',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Western Cape',
    destinationId: 23346,
    latitude: -33.227792,
    longitude: 21.856859,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Bettys-Bay',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.23346.50962',
    parentId: 23346,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: "Betty's Bay",
    destinationId: 50962,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Cape-Town',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.23346.318',
    parentId: 23346,
    timeZone: 'Africa/Johannesburg',
    iataCode: 'CPT',
    destinationType: 'CITY',
    destinationName: 'Cape Town',
    destinationId: 318,
    latitude: -33.9237762,
    longitude: 18.4233455,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Ceres',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.23346.50972',
    parentId: 23346,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ceres',
    destinationId: 50972,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Durban',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.23487.315',
    parentId: 23487,
    timeZone: 'Africa/Johannesburg',
    iataCode: 'DUR',
    destinationType: 'CITY',
    destinationName: 'Durban',
    destinationId: 315,
    latitude: -29.8570032,
    longitude: 31.0247936,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'East-London',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.4476',
    parentId: 11,
    timeZone: 'Africa/Johannesburg',
    iataCode: 'ELS',
    destinationType: 'CITY',
    destinationName: 'East London',
    destinationId: 4476,
    latitude: -32.97,
    longitude: 27.87,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Franschhoek',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.23346.24379',
    parentId: 23346,
    timeZone: 'Africa/Johannesburg',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Franschhoek',
    destinationId: 24379,
    latitude: -33.89748,
    longitude: 19.15233,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Gansbaai',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.23346.50931',
    parentId: 23346,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Gansbaai',
    destinationId: 50931,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'George',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.23346.51212',
    parentId: 23346,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'George',
    destinationId: 51212,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Grabouw',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.23346.50984',
    parentId: 23346,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Grabouw',
    destinationId: 50984,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Graskop',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.51193.51515',
    parentId: 51193,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Graskop',
    destinationId: 51515,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Hazyview',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.776.50542',
    parentId: 776,
    timeZone: 'Africa/Johannesburg',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Hazyview',
    destinationId: 50542,
    latitude: -25.04435,
    longitude: 31.12696,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Hermanus',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.23346.23347',
    parentId: 23346,
    timeZone: 'Africa/Johannesburg',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Hermanus',
    destinationId: 23347,
    latitude: -34.409303,
    longitude: 19.250575,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Hluhluwe-Game-Reserve',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.23487.51284',
    parentId: 23487,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Hluhluwe Game Reserve',
    destinationId: 51284,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Johannesburg',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.22818.314',
    parentId: 22818,
    timeZone: 'Africa/Johannesburg',
    iataCode: 'JNB',
    destinationType: 'CITY',
    destinationName: 'Johannesburg',
    destinationId: 314,
    latitude: -26.201452,
    longitude: 28.045488,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Knysna',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.23346.50538',
    parentId: 23346,
    timeZone: 'Africa/Johannesburg',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Knysna',
    destinationId: 50538,
    latitude: -34.03577,
    longitude: 23.0519,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Montagu',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.23346.51240',
    parentId: 23346,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Montagu',
    destinationId: 51240,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Mossel-Bay',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.23346.50923',
    parentId: 23346,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mossel Bay',
    destinationId: 50923,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Mpumalanga',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.51193',
    parentId: 11,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mpumalanga',
    destinationId: 51193,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Nelspruit',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.776.50536',
    parentId: 776,
    timeZone: 'Africa/Johannesburg',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nelspruit',
    destinationId: 50536,
    latitude: -25.4701,
    longitude: 30.978081,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Pilanesberg-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.23345.51322',
    parentId: 23345,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Pilanesberg National Park',
    destinationId: 51322,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Plettenberg-Bay',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.23346.51198',
    parentId: 23346,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Plettenberg Bay',
    destinationId: 51198,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'Port-Elizabeth',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.313',
    parentId: 11,
    timeZone: 'Africa/Johannesburg',
    iataCode: 'PLZ',
    destinationType: 'CITY',
    destinationName: 'Port Elizabeth',
    destinationId: 313,
    latitude: -33.71392,
    longitude: 25.52074,
  },
  {
    sortOrder: 23,
    selectable: true,
    destinationUrlName: 'Pretoria',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.22818.22819',
    parentId: 22818,
    timeZone: 'Africa/Johannesburg',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Pretoria',
    destinationId: 22819,
    latitude: -25.74787,
    longitude: 28.22927,
  },
  {
    sortOrder: 24,
    selectable: true,
    destinationUrlName: 'Robertson',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.23346.51436',
    parentId: 23346,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Robertson',
    destinationId: 51436,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 25,
    selectable: true,
    destinationUrlName: 'Sedgefield',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.23346.50957',
    parentId: 23346,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sedgefield',
    destinationId: 50957,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 26,
    selectable: true,
    destinationUrlName: 'Skukuza',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.776.50714',
    parentId: 776,
    timeZone: 'Africa/Johannesburg',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Skukuza',
    destinationId: 50714,
    latitude: -24.9961,
    longitude: 31.59192,
  },
  {
    sortOrder: 27,
    selectable: true,
    destinationUrlName: 'Stellenbosch',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.23346.23419',
    parentId: 23346,
    timeZone: 'Africa/Johannesburg',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Stellenbosch',
    destinationId: 23419,
    latitude: -33.9321,
    longitude: 18.86015,
  },
  {
    sortOrder: 28,
    selectable: true,
    destinationUrlName: 'St-Lucia',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.23487.41314',
    parentId: 23487,
    timeZone: 'Africa/Johannesburg',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'St Lucia',
    destinationId: 41314,
    latitude: -28.3738127,
    longitude: 32.4052262,
  },
  {
    sortOrder: 29,
    selectable: true,
    destinationUrlName: 'Swellendam',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.23346.51237',
    parentId: 23346,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Swellendam',
    destinationId: 51237,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 30,
    selectable: true,
    destinationUrlName: 'Tsitsikamma-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.5613.51214',
    parentId: 5613,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tsitsikamma National Park',
    destinationId: 51214,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 31,
    selectable: true,
    destinationUrlName: 'Underberg',
    defaultCurrencyCode: 'USD',
    lookupId: '1.11.23487.51257',
    parentId: 23487,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Underberg',
    destinationId: 51257,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 174,
    selectable: true,
    destinationUrlName: 'South-Korea',
    defaultCurrencyCode: 'USD',
    lookupId: '2.972',
    parentId: 2,
    timeZone: 'Asia/Seoul',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'South Korea',
    destinationId: 972,
    latitude: 35.9077570004,
    longitude: 127.7669220016,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Gangwon',
    defaultCurrencyCode: 'USD',
    lookupId: '2.972.31950',
    parentId: 972,
    timeZone: 'Asia/Seoul',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Gangwon',
    destinationId: 31950,
    latitude: 37.843855,
    longitude: 128.129199,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Gapyeong-gun',
    defaultCurrencyCode: 'USD',
    lookupId: '2.972.51566',
    parentId: 972,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Gapyeong-gun',
    destinationId: 51566,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Busan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.972.4615',
    parentId: 972,
    timeZone: 'Etc/GMT+9',
    iataCode: 'PUS',
    destinationType: 'CITY',
    destinationName: 'Busan',
    destinationId: 4615,
    latitude: 35.1794,
    longitude: 129.0756,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Chuncheon',
    defaultCurrencyCode: 'USD',
    lookupId: '2.972.31950.50355',
    parentId: 31950,
    timeZone: 'Asia/Seoul',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Chuncheon',
    destinationId: 50355,
    latitude: 37.8813,
    longitude: 127.73,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Daegu',
    defaultCurrencyCode: 'USD',
    lookupId: '2.972.50878',
    parentId: 972,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Daegu',
    destinationId: 50878,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Gyeongju',
    defaultCurrencyCode: 'USD',
    lookupId: '2.972.22145',
    parentId: 972,
    timeZone: 'Asia/Seoul',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Gyeongju',
    destinationId: 22145,
    latitude: 35.8557,
    longitude: 129.2249,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Incheon',
    defaultCurrencyCode: 'USD',
    lookupId: '2.972.4623',
    parentId: 972,
    timeZone: 'Asia/Seoul',
    iataCode: 'ICN',
    destinationType: 'CITY',
    destinationName: 'Incheon',
    destinationId: 4623,
    latitude: 37.4761,
    longitude: 126.6422,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Jeju',
    defaultCurrencyCode: 'USD',
    lookupId: '2.972.22779',
    parentId: 972,
    timeZone: 'Asia/Seoul',
    iataCode: 'CJU',
    destinationType: 'CITY',
    destinationName: 'Jeju',
    destinationId: 22779,
    latitude: 33.5769613,
    longitude: 126.0125792,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Jeju-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '2.972.50286',
    parentId: 972,
    timeZone: 'Asia/Seoul',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Jeju Island',
    destinationId: 50286,
    latitude: 33.489,
    longitude: 126.4983,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Jeonju',
    defaultCurrencyCode: 'USD',
    lookupId: '2.972.22998',
    parentId: 972,
    timeZone: 'Asia/Seoul',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Jeonju',
    destinationId: 22998,
    latitude: 35.830212,
    longitude: 127.113401,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Pyeongchang',
    defaultCurrencyCode: 'USD',
    lookupId: '2.972.31742',
    parentId: 972,
    timeZone: 'Asia/Seoul',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Pyeongchang',
    destinationId: 31742,
    latitude: 37.5607,
    longitude: 128.489696,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Seogwipo',
    defaultCurrencyCode: 'USD',
    lookupId: '2.972.50287',
    parentId: 972,
    timeZone: 'Asia/Seoul',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Seogwipo',
    destinationId: 50287,
    latitude: 33.2541,
    longitude: 126.5601,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Seoul',
    defaultCurrencyCode: 'USD',
    lookupId: '2.972.973',
    parentId: 972,
    timeZone: 'Asia/Seoul',
    iataCode: 'SEL',
    destinationType: 'CITY',
    destinationName: 'Seoul',
    destinationId: 973,
    latitude: 37.566535,
    longitude: 126.9779692,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Sokcho',
    defaultCurrencyCode: 'USD',
    lookupId: '2.972.31950.50464',
    parentId: 31950,
    timeZone: 'Asia/Seoul',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sokcho',
    destinationId: 50464,
    latitude: 37.568291,
    longitude: 126.99778,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Suwon',
    defaultCurrencyCode: 'USD',
    lookupId: '2.972.25559',
    parentId: 972,
    timeZone: 'Asia/Seoul',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Suwon',
    destinationId: 25559,
    latitude: 37.280828,
    longitude: 127.00705,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Yongin',
    defaultCurrencyCode: 'USD',
    lookupId: '2.972.34950',
    parentId: 972,
    timeZone: 'Asia/Seoul',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Yongin',
    destinationId: 34950,
    latitude: 37.2839294,
    longitude: 127.07626,
  },
  {
    sortOrder: 175,
    selectable: true,
    destinationUrlName: 'Sri-Lanka',
    defaultCurrencyCode: 'USD',
    lookupId: '2.19',
    parentId: 2,
    timeZone: 'Asia/Colombo',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Sri Lanka',
    destinationId: 19,
    latitude: 7.873054,
    longitude: 80.771797,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Central-Sri-Lanka',
    defaultCurrencyCode: 'USD',
    lookupId: '2.19.28132',
    parentId: 19,
    timeZone: 'Asia/Colombo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Central Sri Lanka',
    destinationId: 28132,
    latitude: 7.2565,
    longitude: 80.72144,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Ingiriya',
    defaultCurrencyCode: 'USD',
    lookupId: '2.19.51948',
    parentId: 19,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Ingiriya',
    destinationId: 51948,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Kalpitiya',
    defaultCurrencyCode: 'USD',
    lookupId: '2.19.51635',
    parentId: 19,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Kalpitiya',
    destinationId: 51635,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Mahiyangana',
    defaultCurrencyCode: 'USD',
    lookupId: '2.19.51753',
    parentId: 19,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Mahiyangana',
    destinationId: 51753,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Northern-Sri-Lanka',
    defaultCurrencyCode: 'USD',
    lookupId: '2.19.27150',
    parentId: 19,
    timeZone: 'Asia/Colombo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Northern Sri Lanka',
    destinationId: 27150,
    latitude: 8.8855,
    longitude: 80.27673,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Puttalam',
    defaultCurrencyCode: 'USD',
    lookupId: '2.19.51721',
    parentId: 19,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Puttalam',
    destinationId: 51721,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Southern-Province',
    defaultCurrencyCode: 'USD',
    lookupId: '2.19.24381',
    parentId: 19,
    timeZone: 'Asia/Colombo',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Southern Province',
    destinationId: 24381,
    latitude: 6.118178,
    longitude: 80.530194,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Uva-Province',
    defaultCurrencyCode: 'USD',
    lookupId: '2.19.51742',
    parentId: 19,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Uva Province',
    destinationId: 51742,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Wasgamuwa-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '2.19.51959',
    parentId: 19,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Wasgamuwa National Park',
    destinationId: 51959,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Wilpattu-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '2.19.52062',
    parentId: 19,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Wilpattu National Park',
    destinationId: 52062,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Anuradhapura',
    defaultCurrencyCode: 'USD',
    lookupId: '2.19.27018',
    parentId: 19,
    timeZone: 'Asia/Colombo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Anuradhapura',
    destinationId: 27018,
    latitude: 8.34519,
    longitude: 80.38813,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Batticaloa',
    defaultCurrencyCode: 'USD',
    lookupId: '2.19.22443',
    parentId: 19,
    timeZone: 'Asia/Colombo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Batticaloa',
    destinationId: 22443,
    latitude: 7.717,
    longitude: 81.7,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Bentota',
    defaultCurrencyCode: 'USD',
    lookupId: '2.19.24381.24419',
    parentId: 24381,
    timeZone: 'Asia/Colombo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bentota',
    destinationId: 24419,
    latitude: 6.418631,
    longitude: 80.006976,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Colombo',
    defaultCurrencyCode: 'USD',
    lookupId: '2.19.4619',
    parentId: 19,
    timeZone: 'Asia/Colombo',
    iataCode: 'CMB',
    destinationType: 'CITY',
    destinationName: 'Colombo',
    destinationId: 4619,
    latitude: 6.9218374,
    longitude: 79.8211859,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Galle',
    defaultCurrencyCode: 'USD',
    lookupId: '2.19.22288',
    parentId: 19,
    timeZone: 'Asia/Colombo',
    iataCode: 'KCT',
    destinationType: 'CITY',
    destinationName: 'Galle',
    destinationId: 22288,
    latitude: 6.05352,
    longitude: 80.22098,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Hambantota',
    defaultCurrencyCode: 'USD',
    lookupId: '2.19.24381.50864',
    parentId: 24381,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Hambantota',
    destinationId: 50864,
    latitude: 6.1460151292,
    longitude: 81.1218986376,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Hikkaduwa',
    defaultCurrencyCode: 'USD',
    lookupId: '2.19.24381.27518',
    parentId: 24381,
    timeZone: 'Asia/Colombo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Hikkaduwa',
    destinationId: 27518,
    latitude: 6.14659,
    longitude: 80.11068,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Jaffna',
    defaultCurrencyCode: 'USD',
    lookupId: '2.19.27150.28058',
    parentId: 27150,
    timeZone: 'Asia/Colombo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Jaffna',
    destinationId: 28058,
    latitude: 9.6615,
    longitude: 80.02555,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Kadugannawa',
    defaultCurrencyCode: 'USD',
    lookupId: '2.19.22283.51823',
    parentId: 22283,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kadugannawa',
    destinationId: 51823,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Kalutara',
    defaultCurrencyCode: 'USD',
    lookupId: '2.19.36396',
    parentId: 19,
    timeZone: 'Asia/Colombo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kalutara',
    destinationId: 36396,
    latitude: 6.5874475,
    longitude: 79.9417155,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Kandy',
    defaultCurrencyCode: 'USD',
    lookupId: '2.19.22283',
    parentId: 19,
    timeZone: 'Asia/Colombo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kandy',
    destinationId: 22283,
    latitude: 7.29057,
    longitude: 80.63373,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Midigama',
    defaultCurrencyCode: 'USD',
    lookupId: '2.19.24381.51128',
    parentId: 24381,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Midigama',
    destinationId: 51128,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Nallathanniya',
    defaultCurrencyCode: 'USD',
    lookupId: '2.19.50975',
    parentId: 19,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nallathanniya',
    destinationId: 50975,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Negombo',
    defaultCurrencyCode: 'USD',
    lookupId: '2.19.33888',
    parentId: 19,
    timeZone: 'Asia/Colombo',
    iataCode: 'CMB',
    destinationType: 'CITY',
    destinationName: 'Negombo',
    destinationId: 33888,
    latitude: 7.202983,
    longitude: 79.872583,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Nuwara-Eliya',
    defaultCurrencyCode: 'USD',
    lookupId: '2.19.28132.33889',
    parentId: 28132,
    timeZone: 'Asia/Colombo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nuwara Eliya',
    destinationId: 33889,
    latitude: 6.950811,
    longitude: 80.790774,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Palatupana',
    defaultCurrencyCode: 'USD',
    lookupId: '2.19.24381.51137',
    parentId: 24381,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Palatupana',
    destinationId: 51137,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Sigiriya',
    defaultCurrencyCode: 'USD',
    lookupId: '2.19.25903',
    parentId: 19,
    timeZone: 'Asia/Colombo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sigiriya',
    destinationId: 25903,
    latitude: 7.954125,
    longitude: 80.755114,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Talpe',
    defaultCurrencyCode: 'USD',
    lookupId: '2.19.24381.51139',
    parentId: 24381,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Talpe',
    destinationId: 51139,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Yala-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '2.19.24381.24382',
    parentId: 24381,
    timeZone: 'Asia/Colombo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Yala National Park',
    destinationId: 24382,
    latitude: 6.4543259,
    longitude: 81.5630434,
  },
  {
    sortOrder: 176,
    selectable: true,
    destinationUrlName: 'St-Barthelemy',
    defaultCurrencyCode: 'USD',
    lookupId: '4.4326',
    parentId: 4,
    timeZone: 'America/St_Barthelemy',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'St Barthelemy',
    destinationId: 4326,
    latitude: 17.9139,
    longitude: -62.8339,
  },
  {
    sortOrder: 177,
    selectable: true,
    destinationUrlName: 'St-Kitts-and-Nevis',
    defaultCurrencyCode: 'USD',
    lookupId: '4.37',
    parentId: 4,
    timeZone: 'America/St_Kitts',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'St Kitts and Nevis',
    destinationId: 37,
    latitude: 17.3433796,
    longitude: -62.7559043,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Nevis',
    defaultCurrencyCode: 'USD',
    lookupId: '4.37.5500',
    parentId: 37,
    timeZone: 'America/St_Kitts',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Nevis',
    destinationId: 5500,
    latitude: 17.1553557996,
    longitude: -62.5796025986,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'St-Kitts',
    defaultCurrencyCode: 'USD',
    lookupId: '4.37.930',
    parentId: 37,
    timeZone: 'America/St_Kitts',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'St Kitts',
    destinationId: 930,
    latitude: 17.3433796,
    longitude: -62.7559043,
  },
  {
    sortOrder: 178,
    selectable: true,
    destinationUrlName: 'St-Lucia',
    defaultCurrencyCode: 'USD',
    lookupId: '4.38',
    parentId: 4,
    timeZone: 'America/St_Lucia',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'St Lucia',
    destinationId: 38,
    latitude: 13.909444,
    longitude: -60.978893,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Anse-La-Raye',
    defaultCurrencyCode: 'USD',
    lookupId: '4.38.52064',
    parentId: 38,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Anse La Raye',
    destinationId: 52064,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Cap-Estate',
    defaultCurrencyCode: 'USD',
    lookupId: '4.38.50210',
    parentId: 38,
    timeZone: 'America/St_Lucia',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cap Estate',
    destinationId: 50210,
    latitude: 14.0972,
    longitude: -60.9392,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Castries',
    defaultCurrencyCode: 'USD',
    lookupId: '4.38.50293',
    parentId: 38,
    timeZone: 'America/St_Lucia',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Castries',
    destinationId: 50293,
    latitude: 14.0101,
    longitude: -60.9875,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Choc',
    defaultCurrencyCode: 'USD',
    lookupId: '4.38.50470',
    parentId: 38,
    timeZone: 'America/St_Lucia',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Choc',
    destinationId: 50470,
    latitude: 14.0353436375,
    longitude: -60.9723078686,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Gros-Islet',
    defaultCurrencyCode: 'USD',
    lookupId: '4.38.50301',
    parentId: 38,
    timeZone: 'America/St_Lucia',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Gros Islet',
    destinationId: 50301,
    latitude: 14.0844,
    longitude: -60.9453,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Marigot-Bay',
    defaultCurrencyCode: 'USD',
    lookupId: '4.38.50361',
    parentId: 38,
    timeZone: 'America/St_Lucia',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Marigot Bay',
    destinationId: 50361,
    latitude: 13.9663,
    longitude: -61.0275,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Rodney-Bay',
    defaultCurrencyCode: 'USD',
    lookupId: '4.38.50295',
    parentId: 38,
    timeZone: 'America/St_Lucia',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Rodney Bay',
    destinationId: 50295,
    latitude: 14.0675,
    longitude: -60.9467,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Soufriere',
    defaultCurrencyCode: 'USD',
    lookupId: '4.38.50297',
    parentId: 38,
    timeZone: 'America/St_Lucia',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Soufriere',
    destinationId: 50297,
    latitude: 13.8571,
    longitude: -61.0573,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Vieux-Fort',
    defaultCurrencyCode: 'USD',
    lookupId: '4.38.50469',
    parentId: 38,
    timeZone: 'America/St_Lucia',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Vieux Fort',
    destinationId: 50469,
    latitude: 13.72986,
    longitude: -60.951618,
  },
  {
    sortOrder: 179,
    selectable: true,
    destinationUrlName: 'St-Maarten',
    defaultCurrencyCode: 'USD',
    lookupId: '4.728',
    parentId: 4,
    timeZone: 'America/Curacao',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'St Maarten',
    destinationId: 728,
    latitude: 18.0308266,
    longitude: -63.0736329,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'St-Maarten',
    defaultCurrencyCode: 'USD',
    lookupId: '4.728.5625',
    parentId: 728,
    timeZone: 'America/Anguilla',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'St Maarten',
    destinationId: 5625,
    latitude: 18.041215,
    longitude: -63.053073,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'St-Martin',
    defaultCurrencyCode: 'USD',
    lookupId: '4.728.5624',
    parentId: 728,
    timeZone: 'America/Anguilla',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'St Martin',
    destinationId: 5624,
    latitude: 18.101111,
    longitude: -63.051944,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Grand-Case',
    defaultCurrencyCode: 'USD',
    lookupId: '4.728.5624.5626',
    parentId: 5624,
    timeZone: 'America/Anguilla',
    iataCode: 'CCE',
    destinationType: 'CITY',
    destinationName: 'Grand Case',
    destinationId: 5626,
    latitude: 18.101111,
    longitude: -63.051944,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Philipsburg',
    defaultCurrencyCode: 'USD',
    lookupId: '4.728.5625.5627',
    parentId: 5625,
    timeZone: 'America/Anguilla',
    iataCode: 'SXM',
    destinationType: 'CITY',
    destinationName: 'Philipsburg',
    destinationId: 5627,
    latitude: 18.0237,
    longitude: -63.0458,
  },
  {
    sortOrder: 180,
    selectable: true,
    destinationUrlName: 'St-Vincent-and-the-Grenadines',
    defaultCurrencyCode: 'USD',
    lookupId: '4.4321',
    parentId: 4,
    timeZone: 'America/St_Vincent',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'St Vincent and the Grenadines',
    destinationId: 4321,
    latitude: 12.9843,
    longitude: -61.2872,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Kingstown',
    defaultCurrencyCode: 'USD',
    lookupId: '4.4321.4322',
    parentId: 4321,
    timeZone: 'America/St_Vincent',
    iataCode: 'SVD',
    destinationType: 'CITY',
    destinationName: 'Kingstown',
    destinationId: 4322,
    latitude: 13.160101,
    longitude: -61.224833,
  },
  {
    sortOrder: 181,
    selectable: true,
    destinationUrlName: 'Suriname',
    defaultCurrencyCode: 'USD',
    lookupId: '9.22165',
    parentId: 9,
    timeZone: 'America/Guyana',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Suriname',
    destinationId: 22165,
    latitude: 3.9193,
    longitude: -56.0278,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Paramaribo',
    defaultCurrencyCode: 'USD',
    lookupId: '9.22165.26849',
    parentId: 22165,
    timeZone: 'America/Paramaribo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Paramaribo',
    destinationId: 26849,
    latitude: 5.85204,
    longitude: -55.20383,
  },
  {
    sortOrder: 182,
    selectable: true,
    destinationUrlName: 'Sweden',
    defaultCurrencyCode: 'USD',
    lookupId: '6.68',
    parentId: 6,
    timeZone: 'Europe/Stockholm',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Sweden',
    destinationId: 68,
    latitude: 60.128161,
    longitude: 18.643501,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Central-Sweden',
    defaultCurrencyCode: 'USD',
    lookupId: '6.68.25555',
    parentId: 68,
    timeZone: 'Europe/Stockholm',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Central Sweden',
    destinationId: 25555,
    latitude: 67.8173,
    longitude: 21.60935,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Northern-Sweden',
    defaultCurrencyCode: 'USD',
    lookupId: '6.68.22564',
    parentId: 68,
    timeZone: 'Europe/Stockholm',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Northern Sweden',
    destinationId: 22564,
    latitude: 57.77532,
    longitude: 11.864,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Southern-Sweden',
    defaultCurrencyCode: 'USD',
    lookupId: '6.68.806',
    parentId: 68,
    timeZone: 'Europe/Stockholm',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Southern Sweden',
    destinationId: 806,
    latitude: 58.49213,
    longitude: 15.84631,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Bjorkliden',
    defaultCurrencyCode: 'USD',
    lookupId: '6.68.22564.51703',
    parentId: 22564,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bjorkliden',
    destinationId: 51703,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Gothenburg',
    defaultCurrencyCode: 'USD',
    lookupId: '6.68.4280',
    parentId: 68,
    timeZone: 'Europe/Stockholm',
    iataCode: 'GOT',
    destinationType: 'CITY',
    destinationName: 'Gothenburg',
    destinationId: 4280,
    latitude: 57.7088699989,
    longitude: 11.9745599991,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Kiruna',
    defaultCurrencyCode: 'USD',
    lookupId: '6.68.22564.50546',
    parentId: 22564,
    timeZone: 'Europe/Stockholm',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kiruna',
    destinationId: 50546,
    latitude: 67.855743,
    longitude: 20.225229,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Malmoe',
    defaultCurrencyCode: 'USD',
    lookupId: '6.68.680',
    parentId: 68,
    timeZone: 'Europe/Stockholm',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Malmö',
    destinationId: 680,
    latitude: 55.604981,
    longitude: 13.003822,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Stockholm',
    defaultCurrencyCode: 'USD',
    lookupId: '6.68.907',
    parentId: 68,
    timeZone: 'Europe/Stockholm',
    iataCode: 'STO',
    destinationType: 'CITY',
    destinationName: 'Stockholm',
    destinationId: 907,
    latitude: 59.328110858,
    longitude: 18.0756425858,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Uppsala',
    defaultCurrencyCode: 'USD',
    lookupId: '6.68.25555.26512',
    parentId: 25555,
    timeZone: 'Europe/Stockholm',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Uppsala',
    destinationId: 26512,
    latitude: 59.858564,
    longitude: 17.638927,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Vaesteras',
    defaultCurrencyCode: 'USD',
    lookupId: '6.68.25555.26515',
    parentId: 25555,
    timeZone: 'Europe/Stockholm',
    iataCode: 'VST',
    destinationType: 'CITY',
    destinationName: 'Västerås',
    destinationId: 26515,
    latitude: 59.611668,
    longitude: 16.544847,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Ystad',
    defaultCurrencyCode: 'USD',
    lookupId: '6.68.4938',
    parentId: 68,
    timeZone: 'Europe/Stockholm',
    iataCode: 'MMX',
    destinationType: 'CITY',
    destinationName: 'Ystad',
    destinationId: 4938,
    latitude: 55.429505,
    longitude: 13.820031,
  },
  {
    sortOrder: 183,
    selectable: true,
    destinationUrlName: 'Switzerland',
    defaultCurrencyCode: 'USD',
    lookupId: '6.69',
    parentId: 6,
    timeZone: 'Europe/Zurich',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Switzerland',
    destinationId: 69,
    latitude: 46.818188,
    longitude: 8.227512,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Central-Switzerland',
    defaultCurrencyCode: 'USD',
    lookupId: '6.69.22430',
    parentId: 69,
    timeZone: 'Europe/Zurich',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Central Switzerland',
    destinationId: 22430,
    latitude: 46.694636,
    longitude: 8.301114,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Fribourg',
    defaultCurrencyCode: 'USD',
    lookupId: '6.69.26445',
    parentId: 69,
    timeZone: 'Europe/Zurich',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Fribourg',
    destinationId: 26445,
    latitude: 46.711,
    longitude: 7.0697,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Lake-Geneva',
    defaultCurrencyCode: 'USD',
    lookupId: '6.69.22174',
    parentId: 69,
    timeZone: 'Europe/Zurich',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Lake Geneva',
    destinationId: 22174,
    latitude: 46.47166,
    longitude: 6.440593,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Swiss-Alps',
    defaultCurrencyCode: 'USD',
    lookupId: '6.69.5015',
    parentId: 69,
    timeZone: 'Europe/Zurich',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Swiss Alps',
    destinationId: 5015,
    latitude: 46.4965015475,
    longitude: 9.8217773438,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Basel',
    defaultCurrencyCode: 'USD',
    lookupId: '6.69.5010',
    parentId: 69,
    timeZone: 'Europe/Zurich',
    iataCode: 'ZDH',
    destinationType: 'CITY',
    destinationName: 'Basel',
    destinationId: 5010,
    latitude: 47.557421,
    longitude: 7.5925727,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Bern',
    defaultCurrencyCode: 'USD',
    lookupId: '6.69.23275',
    parentId: 69,
    timeZone: 'Europe/Zurich',
    iataCode: 'BRN',
    destinationType: 'CITY',
    destinationName: 'Bern',
    destinationId: 23275,
    latitude: 46.94797,
    longitude: 7.44745,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Chur',
    defaultCurrencyCode: 'USD',
    lookupId: '6.69.5015.24631',
    parentId: 5015,
    timeZone: 'Europe/Zurich',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Chur',
    destinationId: 24631,
    latitude: 46.85068,
    longitude: 9.532369,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Crans-Montana',
    defaultCurrencyCode: 'USD',
    lookupId: '6.69.5015.36692',
    parentId: 5015,
    timeZone: 'Europe/Zurich',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Crans-Montana',
    destinationId: 36692,
    latitude: 46.3429944,
    longitude: 7.2209273,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Davos',
    defaultCurrencyCode: 'USD',
    lookupId: '6.69.5015.24630',
    parentId: 5015,
    timeZone: 'Europe/Zurich',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Davos',
    destinationId: 24630,
    latitude: 46.802738,
    longitude: 9.836623,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Ennetbuergen',
    defaultCurrencyCode: 'USD',
    lookupId: '6.69.51405.52113',
    parentId: 51405,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ennetbuergen',
    destinationId: 52113,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Geneva',
    defaultCurrencyCode: 'USD',
    lookupId: '6.69.22174.578',
    parentId: 22174,
    timeZone: 'Europe/Zurich',
    iataCode: 'GVA',
    destinationType: 'CITY',
    destinationName: 'Geneva',
    destinationId: 578,
    latitude: 46.2038099,
    longitude: 6.1399589,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Grindelwald',
    defaultCurrencyCode: 'USD',
    lookupId: '6.69.5015.34153',
    parentId: 5015,
    timeZone: 'Europe/Zurich',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Grindelwald',
    destinationId: 34153,
    latitude: 46.62407,
    longitude: 8.042141,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Gruyeres',
    defaultCurrencyCode: 'USD',
    lookupId: '6.69.22174.25904',
    parentId: 22174,
    timeZone: 'Europe/Zurich',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Gruyères',
    destinationId: 25904,
    latitude: 46.57776,
    longitude: 7.06248,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Interlaken',
    defaultCurrencyCode: 'USD',
    lookupId: '6.69.5015.5011',
    parentId: 5015,
    timeZone: 'Europe/Zurich',
    iataCode: 'ZIN',
    destinationType: 'CITY',
    destinationName: 'Interlaken',
    destinationId: 5011,
    latitude: 46.6859853,
    longitude: 7.8673189,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'La-Gruyere',
    defaultCurrencyCode: 'USD',
    lookupId: '6.69.26445.51407',
    parentId: 26445,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'La Gruyere',
    destinationId: 51407,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Lausanne',
    defaultCurrencyCode: 'USD',
    lookupId: '6.69.22174.23235',
    parentId: 22174,
    timeZone: 'Europe/Zurich',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lausanne',
    destinationId: 23235,
    latitude: 46.519786,
    longitude: 6.632924,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Lauterbrunnen',
    defaultCurrencyCode: 'USD',
    lookupId: '6.69.5015.25956',
    parentId: 5015,
    timeZone: 'Europe/Zurich',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lauterbrunnen',
    destinationId: 25956,
    latitude: 46.593005,
    longitude: 7.914464,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Lucerne',
    defaultCurrencyCode: 'USD',
    lookupId: '6.69.22430.576',
    parentId: 22430,
    timeZone: 'Europe/Zurich',
    iataCode: 'QLJ',
    destinationType: 'CITY',
    destinationName: 'Lucerne',
    destinationId: 576,
    latitude: 47.045546,
    longitude: 8.308017,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Lugano',
    defaultCurrencyCode: 'USD',
    lookupId: '6.69.26381',
    parentId: 69,
    timeZone: 'Europe/Zurich',
    iataCode: 'LUG',
    destinationType: 'CITY',
    destinationName: 'Lugano',
    destinationId: 26381,
    latitude: 46.00347,
    longitude: 8.953681,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Montreux',
    defaultCurrencyCode: 'USD',
    lookupId: '6.69.22174.5012',
    parentId: 22174,
    timeZone: 'Europe/Zurich',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Montreux',
    destinationId: 5012,
    latitude: 46.4333,
    longitude: 6.9167,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Neuchatel',
    defaultCurrencyCode: 'USD',
    lookupId: '6.69.26380',
    parentId: 69,
    timeZone: 'Europe/Zurich',
    iataCode: 'QNC',
    destinationType: 'CITY',
    destinationName: 'Neuchâtel',
    destinationId: 26380,
    latitude: 46.999,
    longitude: 6.923,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Nidwalden',
    defaultCurrencyCode: 'USD',
    lookupId: '6.69.51405',
    parentId: 69,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nidwalden ',
    destinationId: 51405,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'St-Moritz',
    defaultCurrencyCode: 'USD',
    lookupId: '6.69.5015.5013',
    parentId: 5015,
    timeZone: 'Europe/Zurich',
    iataCode: 'SMV',
    destinationType: 'CITY',
    destinationName: 'St Moritz',
    destinationId: 5013,
    latitude: 46.4950997,
    longitude: 9.8361419,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Thurgau',
    defaultCurrencyCode: 'USD',
    lookupId: '6.69.51408',
    parentId: 69,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Thurgau',
    destinationId: 51408,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Vevey',
    defaultCurrencyCode: 'USD',
    lookupId: '6.69.22174.37221',
    parentId: 22174,
    timeZone: 'Europe/Zurich',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Vevey',
    destinationId: 37221,
    latitude: 46.4495897,
    longitude: 6.7020639,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'Zermatt',
    defaultCurrencyCode: 'USD',
    lookupId: '6.69.5015.5014',
    parentId: 5015,
    timeZone: 'Europe/Zurich',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Zermatt',
    destinationId: 5014,
    latitude: 46.0210726,
    longitude: 7.7479372,
  },
  {
    sortOrder: 23,
    selectable: true,
    destinationUrlName: 'Zurich',
    defaultCurrencyCode: 'USD',
    lookupId: '6.69.577',
    parentId: 69,
    timeZone: 'Europe/Zurich',
    iataCode: 'ZRH',
    destinationType: 'CITY',
    destinationName: 'Zurich',
    destinationId: 577,
    latitude: 47.3690239,
    longitude: 8.5380326,
  },
  {
    sortOrder: 184,
    selectable: true,
    destinationUrlName: 'Sao-Tome-and-Principe',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4920',
    parentId: 1,
    timeZone: 'Africa/Sao_Tome',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'São Tomé and Príncipe',
    destinationId: 4920,
    latitude: 0.8986029,
    longitude: 6.4329964,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Sao-Tome-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4920.50704',
    parentId: 4920,
    timeZone: 'Africa/Windhoek',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sao Tome Island',
    destinationId: 50704,
    latitude: -22.56766,
    longitude: 17.04003,
  },
  {
    sortOrder: 185,
    selectable: true,
    destinationUrlName: 'Taiwan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.778',
    parentId: 2,
    timeZone: 'Asia/Taipei',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Taiwan',
    destinationId: 778,
    latitude: 23.69781,
    longitude: 120.960515,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Taitung',
    defaultCurrencyCode: 'USD',
    lookupId: '2.778.51554',
    parentId: 778,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Taitung',
    destinationId: 51554,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Hualien',
    defaultCurrencyCode: 'USD',
    lookupId: '2.778.4675',
    parentId: 778,
    timeZone: 'Asia/Taipei',
    iataCode: 'HUN',
    destinationType: 'CITY',
    destinationName: 'Hualien',
    destinationId: 4675,
    latitude: 23.9943068,
    longitude: 121.5323973,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Kaohsiung',
    defaultCurrencyCode: 'USD',
    lookupId: '2.778.4676',
    parentId: 778,
    timeZone: 'Asia/Taipei',
    iataCode: 'KHH',
    destinationType: 'CITY',
    destinationName: 'Kaohsiung',
    destinationId: 4676,
    latitude: 22.634666,
    longitude: 120.301118,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Taichung',
    defaultCurrencyCode: 'USD',
    lookupId: '2.778.4678',
    parentId: 778,
    timeZone: 'Asia/Taipei',
    iataCode: 'TXG',
    destinationType: 'CITY',
    destinationName: 'Taichung',
    destinationId: 4678,
    latitude: 24.151424,
    longitude: 120.665195,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Taipei',
    defaultCurrencyCode: 'USD',
    lookupId: '2.778.5262',
    parentId: 778,
    timeZone: 'Asia/Taipei',
    iataCode: 'TPE',
    destinationType: 'CITY',
    destinationName: 'Taipei',
    destinationId: 5262,
    latitude: 25.091075,
    longitude: 121.5598345,
  },
  {
    sortOrder: 186,
    selectable: true,
    destinationUrlName: 'Tajikistan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21938',
    parentId: 2,
    timeZone: 'Asia/Dushanbe',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Tajikistan',
    destinationId: 21938,
    latitude: 38.861,
    longitude: 71.2761,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Khujand',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21938.51640',
    parentId: 21938,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Khujand',
    destinationId: 51640,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Dushanbe',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21938.50471',
    parentId: 21938,
    timeZone: 'Asia/Dushanbe',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Dushanbe',
    destinationId: 50471,
    latitude: 38.557671,
    longitude: 68.775917,
  },
  {
    sortOrder: 187,
    selectable: true,
    destinationUrlName: 'Tanzania',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5589',
    parentId: 1,
    timeZone: 'Africa/Dar_es_Salaam',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Tanzania',
    destinationId: 5589,
    latitude: -6.369028,
    longitude: 34.888822,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Dar-Es-Salaam-Region',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5589.51451',
    parentId: 5589,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Dar Es Salaam Region',
    destinationId: 51451,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Iringa-Region',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5589.51928',
    parentId: 5589,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Iringa Region',
    destinationId: 51928,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Kilimanjaro',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5589.24050',
    parentId: 5589,
    timeZone: 'Africa/Dar_es_Salaam',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Kilimanjaro',
    destinationId: 24050,
    latitude: -3.049925,
    longitude: 37.359749,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Lushoto',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5589.51701',
    parentId: 5589,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Lushoto',
    destinationId: 51701,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Morogoro-Region',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5589.51863',
    parentId: 5589,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Morogoro Region',
    destinationId: 51863,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Ruaha-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5589.52071',
    parentId: 5589,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Ruaha National Park',
    destinationId: 52071,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Serengeti',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5589.27084',
    parentId: 5589,
    timeZone: 'Africa/Dar_es_Salaam',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Serengeti',
    destinationId: 27084,
    latitude: -2.15399,
    longitude: 34.68565,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Udzungwa-Mountains-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5589.52079',
    parentId: 5589,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Udzungwa Mountains National Park',
    destinationId: 52079,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Zanzibar',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5589.5590',
    parentId: 5589,
    timeZone: 'Africa/Dar_es_Salaam',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Zanzibar',
    destinationId: 5590,
    latitude: -6.165917,
    longitude: 39.202641,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Arusha',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5589.5593',
    parentId: 5589,
    timeZone: 'Africa/Dar_es_Salaam',
    iataCode: 'JRO',
    destinationType: 'CITY',
    destinationName: 'Arusha',
    destinationId: 5593,
    latitude: -3.372301,
    longitude: 36.694414,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Dar-es-Salaam',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5589.22688',
    parentId: 5589,
    timeZone: 'Africa/Dar_es_Salaam',
    iataCode: 'DAR',
    destinationType: 'CITY',
    destinationName: 'Dar es Salaam',
    destinationId: 22688,
    latitude: -6.792091,
    longitude: 39.210921,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Karatu',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5589.5593.51130',
    parentId: 5593,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Karatu',
    destinationId: 51130,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Kizimkazi',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5589.5590.50816',
    parentId: 5590,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kizimkazi',
    destinationId: 50816,
    latitude: -6.4446519952,
    longitude: 39.4703573324,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Kizimkazi-Dimbani',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5589.5590.52013',
    parentId: 5590,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kizimkazi Dimbani',
    destinationId: 52013,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Machame',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5589.24050.51912',
    parentId: 24050,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Machame',
    destinationId: 51912,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Michamvi',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5589.5590.51769',
    parentId: 5590,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Michamvi',
    destinationId: 51769,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Moshi',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5589.24050.24103',
    parentId: 24050,
    timeZone: 'Africa/Dar_es_Salaam',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Moshi',
    destinationId: 24103,
    latitude: -3.345436,
    longitude: 37.330217,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Mto-wa-Mbu',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5589.5593.51707',
    parentId: 5593,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mto wa Mbu',
    destinationId: 51707,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Pemba-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5589.5590.51453',
    parentId: 5590,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Pemba Island',
    destinationId: 51453,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Selous-Game-Reserve',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5589.51452',
    parentId: 5589,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Selous Game Reserve',
    destinationId: 51452,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Zanzibar-City',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5589.5590.24350',
    parentId: 5590,
    timeZone: 'Africa/Dar_es_Salaam',
    iataCode: 'ZNZ',
    destinationType: 'CITY',
    destinationName: 'Zanzibar City',
    destinationId: 24350,
    latitude: -6.169657,
    longitude: 39.202575,
  },
  {
    sortOrder: 188,
    selectable: true,
    destinationUrlName: 'Thailand',
    defaultCurrencyCode: 'USD',
    lookupId: '2.20',
    parentId: 2,
    timeZone: 'Asia/Bangkok',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Thailand',
    destinationId: 20,
    latitude: 15.870032,
    longitude: 100.992541,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Central-Thailand',
    defaultCurrencyCode: 'USD',
    lookupId: '2.20.22514',
    parentId: 20,
    timeZone: 'Asia/Bangkok',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Central Thailand',
    destinationId: 22514,
    latitude: 12.93542,
    longitude: 100.89171,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Gulf-of-Thailand',
    defaultCurrencyCode: 'USD',
    lookupId: '2.20.22515',
    parentId: 20,
    timeZone: 'Asia/Bangkok',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Gulf of Thailand',
    destinationId: 22515,
    latitude: 13.458605,
    longitude: 99.957511,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Northern-Thailand',
    defaultCurrencyCode: 'USD',
    lookupId: '2.20.22518',
    parentId: 20,
    timeZone: 'Asia/Bangkok',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Northern Thailand',
    destinationId: 22518,
    latitude: 18.892832,
    longitude: 100.446403,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Southern-Thailand-and-Andaman-Coast',
    defaultCurrencyCode: 'USD',
    lookupId: '2.20.22568',
    parentId: 20,
    timeZone: 'Asia/Bangkok',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Southern Thailand and Andaman Coast',
    destinationId: 22568,
    latitude: 7.860203,
    longitude: 99.716683,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Bangkok',
    defaultCurrencyCode: 'USD',
    lookupId: '2.20.343',
    parentId: 20,
    timeZone: 'Asia/Bangkok',
    iataCode: 'BKK',
    destinationType: 'CITY',
    destinationName: 'Bangkok',
    destinationId: 343,
    latitude: 13.7234186,
    longitude: 100.4762319,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Chiang-Mai',
    defaultCurrencyCode: 'USD',
    lookupId: '2.20.22518.5267',
    parentId: 22518,
    timeZone: 'Asia/Bangkok',
    iataCode: 'CNX',
    destinationType: 'CITY',
    destinationName: 'Chiang Mai',
    destinationId: 5267,
    latitude: 18.790977,
    longitude: 98.9607756,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Chiang-Rai',
    defaultCurrencyCode: 'USD',
    lookupId: '2.20.22518.5268',
    parentId: 22518,
    timeZone: 'Asia/Bangkok',
    iataCode: 'CEI',
    destinationType: 'CITY',
    destinationName: 'Chiang Rai',
    destinationId: 5268,
    latitude: 19.9071656,
    longitude: 99.830955,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Hat-Yai',
    defaultCurrencyCode: 'USD',
    lookupId: '2.20.22515.23620',
    parentId: 22515,
    timeZone: 'Asia/Bangkok',
    iataCode: 'HDY',
    destinationType: 'CITY',
    destinationName: 'Hat Yai',
    destinationId: 23620,
    latitude: 7.00865,
    longitude: 100.47469,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Hua-Hin',
    defaultCurrencyCode: 'USD',
    lookupId: '2.20.22515.22968',
    parentId: 22515,
    timeZone: 'Asia/Bangkok',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Hua Hin',
    destinationId: 22968,
    latitude: 12.582338,
    longitude: 99.945141,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Kanchanaburi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.20.22514.22285',
    parentId: 22514,
    timeZone: 'Asia/Bangkok',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kanchanaburi',
    destinationId: 22285,
    latitude: 14.02278,
    longitude: 99.53281,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Khao-Lak',
    defaultCurrencyCode: 'USD',
    lookupId: '2.20.22568.23786',
    parentId: 22568,
    timeZone: 'Asia/Bangkok',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Khao Lak',
    destinationId: 23786,
    latitude: 8.707001,
    longitude: 98.256898,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Ko-Chang',
    defaultCurrencyCode: 'USD',
    lookupId: '2.20.22515.24532',
    parentId: 22515,
    timeZone: 'Asia/Bangkok',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ko Chang',
    destinationId: 24532,
    latitude: 12.050342,
    longitude: 102.327615,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Koh-Samui',
    defaultCurrencyCode: 'USD',
    lookupId: '2.20.22515.347',
    parentId: 22515,
    timeZone: 'Asia/Bangkok',
    iataCode: 'USM',
    destinationType: 'CITY',
    destinationName: 'Koh Samui',
    destinationId: 347,
    latitude: 9.5120168,
    longitude: 100.0135929,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Koh-Tao',
    defaultCurrencyCode: 'USD',
    lookupId: '2.20.22515.34193',
    parentId: 22515,
    timeZone: 'Asia/Bangkok',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Koh Tao',
    destinationId: 34193,
    latitude: 10.096333,
    longitude: 99.84124,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Ko-Lanta',
    defaultCurrencyCode: 'USD',
    lookupId: '2.20.22568.24522',
    parentId: 22568,
    timeZone: 'Asia/Bangkok',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ko Lanta',
    destinationId: 24522,
    latitude: 7.629341,
    longitude: 99.073401,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Ko-Lipe',
    defaultCurrencyCode: 'USD',
    lookupId: '2.20.22568.37757',
    parentId: 22568,
    timeZone: 'Asia/Bangkok',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ko Lipe',
    destinationId: 37757,
    latitude: 6.4877047,
    longitude: 99.2930736,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Ko-Pha-Ngan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.20.22515.34192',
    parentId: 22515,
    timeZone: 'Asia/Bangkok',
    iataCode: 'USM',
    destinationType: 'CITY',
    destinationName: 'Ko Pha Ngan',
    destinationId: 34192,
    latitude: 9.735978,
    longitude: 99.998371,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Ko-Phi-Phi-Don',
    defaultCurrencyCode: 'USD',
    lookupId: '2.20.22568.40944',
    parentId: 22568,
    timeZone: 'Asia/Bangkok',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ko Phi Phi Don',
    destinationId: 40944,
    latitude: 7.7526506,
    longitude: 98.7390929,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Ko-Yao-Yai',
    defaultCurrencyCode: 'USD',
    lookupId: '2.20.22568.50552',
    parentId: 22568,
    timeZone: 'Asia/Bangkok',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ko Yao Yai',
    destinationId: 50552,
    latitude: 8.06871,
    longitude: 98.58257,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Krabi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.20.22568.348',
    parentId: 22568,
    timeZone: 'Asia/Bangkok',
    iataCode: 'KBV',
    destinationType: 'CITY',
    destinationName: 'Krabi',
    destinationId: 348,
    latitude: 8.1191811,
    longitude: 99.1013498,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Mae-Hong-Son',
    defaultCurrencyCode: 'USD',
    lookupId: '2.20.22518.51553',
    parentId: 22518,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mae Hong Son',
    destinationId: 51553,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Pattaya',
    defaultCurrencyCode: 'USD',
    lookupId: '2.20.22515.344',
    parentId: 22515,
    timeZone: 'Asia/Bangkok',
    iataCode: 'PYX',
    destinationType: 'CITY',
    destinationName: 'Pattaya',
    destinationId: 344,
    latitude: 12.949117,
    longitude: 100.888042,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Phuket',
    defaultCurrencyCode: 'USD',
    lookupId: '2.20.22568.349',
    parentId: 22568,
    timeZone: 'Asia/Bangkok',
    iataCode: 'HKT',
    destinationType: 'CITY',
    destinationName: 'Phuket',
    destinationId: 349,
    latitude: 7.9843109,
    longitude: 98.3307468,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Surat-Thani',
    defaultCurrencyCode: 'USD',
    lookupId: '2.20.22515.32631',
    parentId: 22515,
    timeZone: 'Asia/Bangkok',
    iataCode: 'URT',
    destinationType: 'CITY',
    destinationName: 'Surat Thani',
    destinationId: 32631,
    latitude: 9.134155,
    longitude: 99.326686,
  },
  {
    sortOrder: 189,
    selectable: true,
    destinationUrlName: 'Togo',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4425',
    parentId: 1,
    timeZone: 'Africa/Lome',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Togo',
    destinationId: 4425,
    latitude: 8.6195,
    longitude: 0.8248,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Lome',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4425.4426',
    parentId: 4425,
    timeZone: 'Africa/Lome',
    iataCode: 'LFW',
    destinationType: 'CITY',
    destinationName: 'Lome',
    destinationId: 4426,
    latitude: 6.172234,
    longitude: 1.230797,
  },
  {
    sortOrder: 190,
    selectable: true,
    destinationUrlName: 'Tonga',
    defaultCurrencyCode: 'USD',
    lookupId: '3.4786',
    parentId: 3,
    timeZone: 'Pacific/Tongatapu',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Tonga',
    destinationId: 4786,
    latitude: -18.6077151,
    longitude: -176.8500027,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Kanokupolu',
    defaultCurrencyCode: 'USD',
    lookupId: '3.4786.50362',
    parentId: 4786,
    timeZone: 'Pacific/Tongatapu',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kanokupolu',
    destinationId: 50362,
    latitude: -21.0772,
    longitude: -175.3346,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Tongatapu-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '3.4786.50472',
    parentId: 4786,
    timeZone: 'Pacific/Auckland',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tongatapu Island',
    destinationId: 50472,
    latitude: -40.7762,
    longitude: 173.93678,
  },
  {
    sortOrder: 191,
    selectable: true,
    destinationUrlName: 'Trinidad-and-Tobago',
    defaultCurrencyCode: 'USD',
    lookupId: '4.39',
    parentId: 4,
    timeZone: 'America/Port_of_Spain',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Trinidad and Tobago',
    destinationId: 39,
    latitude: 10.691803,
    longitude: -61.222503,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Tobago',
    defaultCurrencyCode: 'USD',
    lookupId: '4.39.30971',
    parentId: 39,
    timeZone: 'America/Port_of_Spain',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Tobago',
    destinationId: 30971,
    latitude: 11.25118,
    longitude: -60.69969,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Trinidad',
    defaultCurrencyCode: 'USD',
    lookupId: '4.39.30970',
    parentId: 39,
    timeZone: 'America/Port_of_Spain',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Trinidad',
    destinationId: 30970,
    latitude: 10.6918,
    longitude: -61.2225,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Speyside',
    defaultCurrencyCode: 'USD',
    lookupId: '4.39.30971.51126',
    parentId: 30971,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Speyside',
    destinationId: 51126,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 192,
    selectable: true,
    destinationUrlName: 'Tunisia',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4393',
    parentId: 1,
    timeZone: 'Africa/Tunis',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Tunisia',
    destinationId: 4393,
    latitude: 34.104283,
    longitude: 9.5584,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Djerba',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4393.27430',
    parentId: 4393,
    timeZone: 'Africa/Tunis',
    iataCode: 'DJE',
    destinationType: 'CITY',
    destinationName: 'Djerba',
    destinationId: 27430,
    latitude: 33.8076,
    longitude: 10.84515,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Douz',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4393.50632',
    parentId: 4393,
    timeZone: 'Africa/Tunis',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Douz',
    destinationId: 50632,
    latitude: 33.459759,
    longitude: 9.0244,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Gabes',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4393.4394',
    parentId: 4393,
    timeZone: 'Africa/Tunis',
    iataCode: 'GAE',
    destinationType: 'CITY',
    destinationName: 'Gabes',
    destinationId: 4394,
    latitude: 33.886961,
    longitude: 10.102057,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Hammamet',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4393.4457',
    parentId: 4393,
    timeZone: 'Africa/Tunis',
    iataCode: 'NBE',
    destinationType: 'CITY',
    destinationName: 'Hammamet',
    destinationId: 4457,
    latitude: 36.406923,
    longitude: 10.620003,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Monastir',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4393.24335',
    parentId: 4393,
    timeZone: 'Africa/Tunis',
    iataCode: 'MIR',
    destinationType: 'CITY',
    destinationName: 'Monastir',
    destinationId: 24335,
    latitude: 35.764654,
    longitude: 10.813523,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Sousse',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4393.4466',
    parentId: 4393,
    timeZone: 'Africa/Tunis',
    iataCode: 'QSO',
    destinationType: 'CITY',
    destinationName: 'Sousse',
    destinationId: 4466,
    latitude: 35.825921,
    longitude: 10.628352,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Tozeur',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4393.50631',
    parentId: 4393,
    timeZone: 'Africa/Tunis',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Tozeur',
    destinationId: 50631,
    latitude: 33.921452,
    longitude: 8.12964,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Tunis',
    defaultCurrencyCode: 'USD',
    lookupId: '1.4393.30157',
    parentId: 4393,
    timeZone: 'Africa/Tunis',
    iataCode: 'TUN',
    destinationType: 'CITY',
    destinationName: 'Tunis',
    destinationId: 30157,
    latitude: 36.80649,
    longitude: 10.18153,
  },
  {
    sortOrder: 193,
    selectable: true,
    destinationUrlName: 'Turkey',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70',
    parentId: 6,
    timeZone: 'Europe/Istanbul',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Turkey',
    destinationId: 70,
    latitude: 38.963745,
    longitude: 35.243322,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Aegean-Coast',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.24272',
    parentId: 70,
    timeZone: 'Europe/Istanbul',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Aegean Coast',
    destinationId: 24272,
    latitude: 38.399797,
    longitude: 27.106361,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Cappadocia',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.5609',
    parentId: 70,
    timeZone: 'Europe/Istanbul',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Cappadocia',
    destinationId: 5609,
    latitude: 38.709101,
    longitude: 34.842442,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Southeastern-Anatolia',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.25879',
    parentId: 70,
    timeZone: 'Europe/Istanbul',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Southeastern Anatolia',
    destinationId: 25879,
    latitude: 36.19584,
    longitude: 29.6088,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Turkish-Black-Sea-Coast',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.28348',
    parentId: 70,
    timeZone: 'Europe/Istanbul',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Turkish Black Sea Coast',
    destinationId: 28348,
    latitude: 41.89866,
    longitude: 32.38179,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Turkish-Riviera',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.22557',
    parentId: 70,
    timeZone: 'Europe/Istanbul',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Turkish Riviera',
    destinationId: 22557,
    latitude: 36.774092,
    longitude: 30.544739,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Uludag-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.52080',
    parentId: 70,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Uludag National Park',
    destinationId: 52080,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Western-Anatolia',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.27336',
    parentId: 70,
    timeZone: 'Europe/Istanbul',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Western Anatolia',
    destinationId: 27336,
    latitude: 36.89689,
    longitude: 30.71332,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Alanya',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.22557.4289',
    parentId: 22557,
    timeZone: 'Europe/Istanbul',
    iataCode: 'ADF',
    destinationType: 'CITY',
    destinationName: 'Alanya',
    destinationId: 4289,
    latitude: 36.54444,
    longitude: 31.99541,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Ankara',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.584',
    parentId: 70,
    timeZone: 'Europe/Istanbul',
    iataCode: 'ANK',
    destinationType: 'CITY',
    destinationName: 'Ankara',
    destinationId: 584,
    latitude: 39.92077,
    longitude: 32.85411,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Antalya',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.22557.586',
    parentId: 22557,
    timeZone: 'Europe/Istanbul',
    iataCode: 'AYT',
    destinationType: 'CITY',
    destinationName: 'Antalya',
    destinationId: 586,
    latitude: 36.88414,
    longitude: 30.70563,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Belek',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.22557.24523',
    parentId: 22557,
    timeZone: 'Europe/Istanbul',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Belek',
    destinationId: 24523,
    latitude: 36.863444,
    longitude: 31.061375,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Bodrum',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.22557.4292',
    parentId: 22557,
    timeZone: 'Europe/Istanbul',
    iataCode: 'BXN',
    destinationType: 'CITY',
    destinationName: 'Bodrum',
    destinationId: 4292,
    latitude: 37.0333,
    longitude: 27.4333,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Bursa',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.50877',
    parentId: 70,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bursa',
    destinationId: 50877,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Canakkale',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.24272.24273',
    parentId: 24272,
    timeZone: 'Europe/Istanbul',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Canakkale',
    destinationId: 24273,
    latitude: 40.147617,
    longitude: 26.413778,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Denizli',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.50474',
    parentId: 70,
    timeZone: 'Europe/Istanbul',
    iataCode: 'DNZ',
    destinationType: 'CITY',
    destinationName: 'Denizli',
    destinationId: 50474,
    latitude: 37.77869,
    longitude: 29.061661,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Dikili',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.4296',
    parentId: 70,
    timeZone: 'Europe/Istanbul',
    iataCode: 'DIK',
    destinationType: 'CITY',
    destinationName: 'Dikili',
    destinationId: 4296,
    latitude: 39.072097,
    longitude: 26.888203,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Diyarbakir',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.25879.25881',
    parentId: 25879,
    timeZone: 'Europe/Istanbul',
    iataCode: 'DIY',
    destinationType: 'CITY',
    destinationName: 'Diyarbakir',
    destinationId: 25881,
    latitude: 37.924397,
    longitude: 40.208594,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Erzurum',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.25937',
    parentId: 70,
    timeZone: 'Europe/Istanbul',
    iataCode: 'ERZ',
    destinationType: 'CITY',
    destinationName: 'Erzurum',
    destinationId: 25937,
    latitude: 39.905558,
    longitude: 41.26759,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Fethiye',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.22557.5290',
    parentId: 22557,
    timeZone: 'Europe/Istanbul',
    iataCode: 'DLM',
    destinationType: 'CITY',
    destinationName: 'Fethiye',
    destinationId: 5290,
    latitude: 36.6514,
    longitude: 29.1231,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Gaziantep',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.50887',
    parentId: 70,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Gaziantep',
    destinationId: 50887,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Goreme',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.5609.23271',
    parentId: 5609,
    timeZone: 'Europe/Istanbul',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Goreme',
    destinationId: 23271,
    latitude: 38.64482,
    longitude: 34.831035,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Istanbul',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.585',
    parentId: 70,
    timeZone: 'Europe/Istanbul',
    iataCode: 'IST',
    destinationType: 'CITY',
    destinationName: 'Istanbul',
    destinationId: 585,
    latitude: 41.0033342172,
    longitude: 28.9792728424,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Izmir',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.24272.581',
    parentId: 24272,
    timeZone: 'Europe/Istanbul',
    iataCode: 'IZM',
    destinationType: 'CITY',
    destinationName: 'Izmir',
    destinationId: 581,
    latitude: 38.41885,
    longitude: 27.12872,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Kars',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.25936',
    parentId: 70,
    timeZone: 'Europe/Istanbul',
    iataCode: 'KYS',
    destinationType: 'CITY',
    destinationName: 'Kars',
    destinationId: 25936,
    latitude: 40.601423,
    longitude: 43.091836,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Kas',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.22557.22558',
    parentId: 22557,
    timeZone: 'Europe/Istanbul',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kas',
    destinationId: 22558,
    latitude: 36.19991,
    longitude: 29.63955,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Kayseri',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.50298',
    parentId: 70,
    timeZone: 'Europe/Istanbul',
    iataCode: 'ASR',
    destinationType: 'CITY',
    destinationName: 'Kayseri',
    destinationId: 50298,
    latitude: 38.7205,
    longitude: 35.4826,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Kemer',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.22557.23562',
    parentId: 22557,
    timeZone: 'Europe/Istanbul',
    iataCode: 'AYT',
    destinationType: 'CITY',
    destinationName: 'Kemer',
    destinationId: 23562,
    latitude: 36.60275,
    longitude: 30.560342,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Konya',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.50363',
    parentId: 70,
    timeZone: 'Europe/Istanbul',
    iataCode: 'KYA',
    destinationType: 'CITY',
    destinationName: 'Konya',
    destinationId: 50363,
    latitude: 37.8746,
    longitude: 32.4932,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'Kusadasi',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.22557.582',
    parentId: 22557,
    timeZone: 'Europe/Istanbul',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kusadasi',
    destinationId: 582,
    latitude: 37.8609292959,
    longitude: 27.2570800781,
  },
  {
    sortOrder: 23,
    selectable: true,
    destinationUrlName: 'Mardin',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.25879.25882',
    parentId: 25879,
    timeZone: 'Europe/Istanbul',
    iataCode: 'MQM',
    destinationType: 'CITY',
    destinationName: 'Mardin',
    destinationId: 25882,
    latitude: 37.357582,
    longitude: 40.78624,
  },
  {
    sortOrder: 24,
    selectable: true,
    destinationUrlName: 'Marmaris',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.22557.4300',
    parentId: 22557,
    timeZone: 'Europe/Istanbul',
    iataCode: 'MRM',
    destinationType: 'CITY',
    destinationName: 'Marmaris',
    destinationId: 4300,
    latitude: 36.85,
    longitude: 28.2667,
  },
  {
    sortOrder: 25,
    selectable: true,
    destinationUrlName: 'Mugla',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.24272.24380',
    parentId: 24272,
    timeZone: 'Europe/Istanbul',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Muğla',
    destinationId: 24380,
    latitude: 37.2164,
    longitude: 28.3639,
  },
  {
    sortOrder: 26,
    selectable: true,
    destinationUrlName: 'Pamukkale',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.27336.27337',
    parentId: 27336,
    timeZone: 'Europe/Istanbul',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Pamukkale',
    destinationId: 27337,
    latitude: 37.91861,
    longitude: 29.11031,
  },
  {
    sortOrder: 27,
    selectable: true,
    destinationUrlName: 'Sanliurfa',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.50897',
    parentId: 70,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sanliurfa',
    destinationId: 50897,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 28,
    selectable: true,
    destinationUrlName: 'Sarigerme',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.24272.50473',
    parentId: 24272,
    timeZone: 'Europe/Istanbul',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sarigerme',
    destinationId: 50473,
    latitude: 36.714649,
    longitude: 28.703951,
  },
  {
    sortOrder: 29,
    selectable: true,
    destinationUrlName: 'Selcuk',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.24272.25618',
    parentId: 24272,
    timeZone: 'Europe/Istanbul',
    iataCode: 'ADB',
    destinationType: 'CITY',
    destinationName: 'Selçuk',
    destinationId: 25618,
    latitude: 37.95085,
    longitude: 27.36995,
  },
  {
    sortOrder: 30,
    selectable: true,
    destinationUrlName: 'Side',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.22557.23557',
    parentId: 22557,
    timeZone: 'Europe/Istanbul',
    iataCode: 'AYT',
    destinationType: 'CITY',
    destinationName: 'Side',
    destinationId: 23557,
    latitude: 36.76662,
    longitude: 31.389291,
  },
  {
    sortOrder: 31,
    selectable: true,
    destinationUrlName: 'Sinop',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.4302',
    parentId: 70,
    timeZone: 'Europe/Istanbul',
    iataCode: 'SIC',
    destinationType: 'CITY',
    destinationName: 'Sinop',
    destinationId: 4302,
    latitude: 42.02314,
    longitude: 35.153069,
  },
  {
    sortOrder: 32,
    selectable: true,
    destinationUrlName: 'Trabzon',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.28348.4305',
    parentId: 28348,
    timeZone: 'Europe/Istanbul',
    iataCode: 'TZX',
    destinationType: 'CITY',
    destinationName: 'Trabzon',
    destinationId: 4305,
    latitude: 41.002669,
    longitude: 39.716291,
  },
  {
    sortOrder: 33,
    selectable: true,
    destinationUrlName: 'Uchisar',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.5609.50296',
    parentId: 5609,
    timeZone: 'Europe/Istanbul',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Uchisar',
    destinationId: 50296,
    latitude: 38.6289,
    longitude: 34.8039,
  },
  {
    sortOrder: 34,
    selectable: true,
    destinationUrlName: 'Urgup',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.5609.23000',
    parentId: 5609,
    timeZone: 'Europe/Istanbul',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Urgup',
    destinationId: 23000,
    latitude: 38.631309,
    longitude: 34.911663,
  },
  {
    sortOrder: 35,
    selectable: true,
    destinationUrlName: 'Van',
    defaultCurrencyCode: 'USD',
    lookupId: '6.70.25879.25880',
    parentId: 25879,
    timeZone: 'Europe/Istanbul',
    iataCode: 'VAN',
    destinationType: 'CITY',
    destinationName: 'Van',
    destinationId: 25880,
    latitude: 38.507695,
    longitude: 43.376423,
  },
  {
    sortOrder: 194,
    selectable: true,
    destinationUrlName: 'Turkmenistan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21937',
    parentId: 2,
    timeZone: 'Asia/Ashgabat',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Turkmenistan',
    destinationId: 21937,
    latitude: 38.9697,
    longitude: 59.5563,
  },
  {
    sortOrder: 195,
    selectable: true,
    destinationUrlName: 'Turks-and-Caicos',
    defaultCurrencyCode: 'USD',
    lookupId: '4.963',
    parentId: 4,
    timeZone: 'America/Grand_Turk',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Turks and Caicos',
    destinationId: 963,
    latitude: 21.694025,
    longitude: -71.797928,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Grand-Turk',
    defaultCurrencyCode: 'USD',
    lookupId: '4.963.968',
    parentId: 963,
    timeZone: 'America/Grand_Turk',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Grand Turk',
    destinationId: 968,
    latitude: 21.427354,
    longitude: -71.144489,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Providenciales',
    defaultCurrencyCode: 'USD',
    lookupId: '4.963.969',
    parentId: 963,
    timeZone: 'America/Grand_Turk',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Providenciales',
    destinationId: 969,
    latitude: 21.773765,
    longitude: -72.271908,
  },
  {
    sortOrder: 196,
    selectable: true,
    destinationUrlName: 'US-Virgin-Islands',
    defaultCurrencyCode: 'USD',
    lookupId: '4.40',
    parentId: 4,
    timeZone: 'America/St_Thomas',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'US Virgin Islands',
    destinationId: 40,
    latitude: 18.3388837026,
    longitude: -64.7403717041,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'St-Croix',
    defaultCurrencyCode: 'USD',
    lookupId: '4.40.28885',
    parentId: 40,
    timeZone: 'America/St_Thomas',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'St Croix',
    destinationId: 28885,
    latitude: 17.70014,
    longitude: -64.86272,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'St-John',
    defaultCurrencyCode: 'USD',
    lookupId: '4.40.4521',
    parentId: 40,
    timeZone: 'America/St_Thomas',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'St John',
    destinationId: 4521,
    latitude: 18.3401872422,
    longitude: -64.7410583496,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'St-Thomas',
    defaultCurrencyCode: 'USD',
    lookupId: '4.40.965',
    parentId: 40,
    timeZone: 'America/St_Thomas',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'St Thomas',
    destinationId: 965,
    latitude: 18.3545255291,
    longitude: -64.9285125732,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Cruz-Bay',
    defaultCurrencyCode: 'USD',
    lookupId: '4.40.4225',
    parentId: 40,
    timeZone: 'America/St_Thomas',
    iataCode: 'SJF',
    destinationType: 'CITY',
    destinationName: 'Cruz Bay',
    destinationId: 4225,
    latitude: 18.3308,
    longitude: -64.7945,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Frederiksted',
    defaultCurrencyCode: 'USD',
    lookupId: '4.40.4228',
    parentId: 40,
    timeZone: 'America/St_Thomas',
    iataCode: 'STX',
    destinationType: 'CITY',
    destinationName: 'Frederiksted',
    destinationId: 4228,
    latitude: 17.7118,
    longitude: -64.8814,
  },
  {
    sortOrder: 197,
    selectable: true,
    destinationUrlName: 'Uganda',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5575',
    parentId: 1,
    timeZone: 'Africa/Kampala',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Uganda',
    destinationId: 5575,
    latitude: 1.373333,
    longitude: 32.290275,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Kasese',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5575.51684',
    parentId: 5575,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Kasese',
    destinationId: 51684,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Kibale-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5575.52081',
    parentId: 5575,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Kibale National Park',
    destinationId: 52081,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Kisoro',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5575.51704',
    parentId: 5575,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Kisoro',
    destinationId: 51704,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Lake-Mburo-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5575.52072',
    parentId: 5575,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Lake Mburo National Park',
    destinationId: 52072,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Mabira',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5575.51968',
    parentId: 5575,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Mabira',
    destinationId: 51968,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Mgahinga-Gorilla-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5575.51802',
    parentId: 5575,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Mgahinga Gorilla National Park',
    destinationId: 51802,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Moroto',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5575.51864',
    parentId: 5575,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Moroto',
    destinationId: 51864,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Murchison-Falls-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5575.52073',
    parentId: 5575,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Murchison Falls National Park',
    destinationId: 52073,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Bwindi-Impenetrable-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5575.51417',
    parentId: 5575,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bwindi Impenetrable National Park',
    destinationId: 51417,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Jinja',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5575.27151',
    parentId: 5575,
    timeZone: 'Africa/Kampala',
    iataCode: 'JIN',
    destinationType: 'CITY',
    destinationName: 'Jinja',
    destinationId: 27151,
    latitude: 0.44786,
    longitude: 33.20261,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Kabale',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5575.50364',
    parentId: 5575,
    timeZone: 'Africa/Kampala',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kabale',
    destinationId: 50364,
    latitude: -1.241615,
    longitude: 29.984328,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Kampala',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5575.5576',
    parentId: 5575,
    timeZone: 'Africa/Kampala',
    iataCode: 'EBB',
    destinationType: 'CITY',
    destinationName: 'Kampala',
    destinationId: 5576,
    latitude: 0.313611,
    longitude: 32.581111,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Masindi',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5575.50475',
    parentId: 5575,
    timeZone: 'Africa/Kampala',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Masindi',
    destinationId: 50475,
    latitude: 1.68501,
    longitude: 31.71847,
  },
  {
    sortOrder: 198,
    selectable: true,
    destinationUrlName: 'Ukraine',
    defaultCurrencyCode: 'USD',
    lookupId: '6.781',
    parentId: 6,
    timeZone: 'Europe/Kiev',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Ukraine',
    destinationId: 781,
    latitude: 49.012435,
    longitude: 31.357982,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Sloboda-Ukraine-region',
    defaultCurrencyCode: 'USD',
    lookupId: '6.781.50477',
    parentId: 781,
    timeZone: 'Europe/Uzhgorod',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Sloboda Ukraine region',
    destinationId: 50477,
    latitude: 48.22916,
    longitude: 25.63022,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Cherkasy',
    defaultCurrencyCode: 'USD',
    lookupId: '6.781.4841',
    parentId: 781,
    timeZone: 'Europe/Kiev',
    iataCode: 'CKC',
    destinationType: 'CITY',
    destinationName: 'Cherkasy',
    destinationId: 4841,
    latitude: 49.44725,
    longitude: 32.060266,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Kharkiv',
    defaultCurrencyCode: 'USD',
    lookupId: '6.781.50477.50478',
    parentId: 50477,
    timeZone: 'Europe/Kiev',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kharkiv',
    destinationId: 50478,
    latitude: 49.98595,
    longitude: 36.27354,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Kiev',
    defaultCurrencyCode: 'USD',
    lookupId: '6.781.22377',
    parentId: 781,
    timeZone: 'Europe/Kiev',
    iataCode: 'IEV',
    destinationType: 'CITY',
    destinationName: 'Kiev',
    destinationId: 22377,
    latitude: 50.4501,
    longitude: 30.5234,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Lviv',
    defaultCurrencyCode: 'USD',
    lookupId: '6.781.26299',
    parentId: 781,
    timeZone: 'Europe/Kiev',
    iataCode: 'LWO',
    destinationType: 'CITY',
    destinationName: 'Lviv',
    destinationId: 26299,
    latitude: 49.841683,
    longitude: 24.033339,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Odessa',
    defaultCurrencyCode: 'USD',
    lookupId: '6.781.4212',
    parentId: 781,
    timeZone: 'Etc/GMT+2',
    iataCode: 'ODS',
    destinationType: 'CITY',
    destinationName: 'Odessa',
    destinationId: 4212,
    latitude: 46.483808,
    longitude: 30.725564,
  },
  {
    sortOrder: 199,
    selectable: true,
    destinationUrlName: 'United-Arab-Emirates',
    defaultCurrencyCode: 'USD',
    lookupId: '1.743',
    parentId: 1,
    timeZone: 'Asia/Dubai',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'United Arab Emirates',
    destinationId: 743,
    latitude: 23.424076,
    longitude: 53.847818,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Abu-Dhabi',
    defaultCurrencyCode: 'USD',
    lookupId: '1.743.4474',
    parentId: 743,
    timeZone: 'Asia/Dubai',
    iataCode: 'AUH',
    destinationType: 'CITY',
    destinationName: 'Abu Dhabi',
    destinationId: 4474,
    latitude: 24.466667,
    longitude: 54.366667,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Ajman',
    defaultCurrencyCode: 'USD',
    lookupId: '1.743.38683',
    parentId: 743,
    timeZone: 'Asia/Dubai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ajman',
    destinationId: 38683,
    latitude: 25.4034628,
    longitude: 55.3930766,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Al-Ain',
    defaultCurrencyCode: 'USD',
    lookupId: '1.743.25942',
    parentId: 743,
    timeZone: 'Asia/Dubai',
    iataCode: 'AAN',
    destinationType: 'CITY',
    destinationName: 'Al Ain',
    destinationId: 25942,
    latitude: 24.2227,
    longitude: 55.7651,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Deira',
    defaultCurrencyCode: 'USD',
    lookupId: '1.743.828.51501',
    parentId: 828,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Deira',
    destinationId: 51501,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Dubai',
    defaultCurrencyCode: 'USD',
    lookupId: '1.743.828',
    parentId: 743,
    timeZone: 'Asia/Dubai',
    iataCode: 'DXB',
    destinationType: 'CITY',
    destinationName: 'Dubai',
    destinationId: 828,
    latitude: 25.2644444,
    longitude: 55.3116667,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Fujairah',
    defaultCurrencyCode: 'USD',
    lookupId: '1.743.4473',
    parentId: 743,
    timeZone: 'Asia/Dubai',
    iataCode: 'FJR',
    destinationType: 'CITY',
    destinationName: 'Fujairah',
    destinationId: 4473,
    latitude: 25.12881,
    longitude: 56.32648,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Madinat-Zayed',
    defaultCurrencyCode: 'USD',
    lookupId: '1.743.4474.51315',
    parentId: 4474,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Madinat Zayed',
    destinationId: 51315,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Ras-Al-Khaimah',
    defaultCurrencyCode: 'USD',
    lookupId: '1.743.25313',
    parentId: 743,
    timeZone: 'Asia/Dubai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ras Al Khaimah',
    destinationId: 25313,
    latitude: 25.805512,
    longitude: 55.988646,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Sharjah',
    defaultCurrencyCode: 'USD',
    lookupId: '1.743.26417',
    parentId: 743,
    timeZone: 'Asia/Dubai',
    iataCode: 'SHJ',
    destinationType: 'CITY',
    destinationName: 'Sharjah',
    destinationId: 26417,
    latitude: 25.349183,
    longitude: 55.418354,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Umm-Al-Quwain',
    defaultCurrencyCode: 'USD',
    lookupId: '1.743.50365',
    parentId: 743,
    timeZone: 'Asia/Dubai',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Umm Al Quwain',
    destinationId: 50365,
    latitude: 25.5426,
    longitude: 55.5475,
  },
  {
    sortOrder: 200,
    selectable: true,
    destinationUrlName: 'Uruguay',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4514',
    parentId: 9,
    timeZone: 'America/Montevideo',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Uruguay',
    destinationId: 4514,
    latitude: -32.5228,
    longitude: -55.7658,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Colonia-del-Sacramento',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4514.22385',
    parentId: 4514,
    timeZone: 'America/Montevideo',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Colonia del Sacramento',
    destinationId: 22385,
    latitude: -34.48,
    longitude: -57.84,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Montevideo',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4514.4515',
    parentId: 4514,
    timeZone: 'America/Montevideo',
    iataCode: 'MVD',
    destinationType: 'CITY',
    destinationName: 'Montevideo',
    destinationId: 4515,
    latitude: -34.8836111,
    longitude: -56.1819444,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Punta-del-Este',
    defaultCurrencyCode: 'USD',
    lookupId: '9.4514.4906',
    parentId: 4514,
    timeZone: 'America/Montevideo',
    iataCode: 'PDP',
    destinationType: 'CITY',
    destinationName: 'Punta del Este',
    destinationId: 4906,
    latitude: -34.9666667,
    longitude: -54.95,
  },
  {
    sortOrder: 201,
    selectable: true,
    destinationUrlName: 'Uzbekistan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21936',
    parentId: 2,
    timeZone: 'Asia/Samarkand',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Uzbekistan',
    destinationId: 21936,
    latitude: 41.3775,
    longitude: 64.5853,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Central-Uzbekistan',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21936.27663',
    parentId: 21936,
    timeZone: 'Asia/Samarkand',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Central Uzbekistan',
    destinationId: 27663,
    latitude: 39.64952,
    longitude: 66.95822,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Fergana',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21936.51929',
    parentId: 21936,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Fergana',
    destinationId: 51929,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Nurata',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21936.51977',
    parentId: 21936,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Nurata',
    destinationId: 51977,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Bukhara',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21936.50479',
    parentId: 21936,
    timeZone: 'Asia/Samarkand',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bukhara',
    destinationId: 50479,
    latitude: 39.768951,
    longitude: 64.430038,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Khiva',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21936.50862',
    parentId: 21936,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Khiva',
    destinationId: 50862,
    latitude: 41.7105740632,
    longitude: 60.2735412518,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Nukus',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21936.50480',
    parentId: 21936,
    timeZone: 'Asia/Samarkand',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nukus',
    destinationId: 50480,
    latitude: 42.460411,
    longitude: 59.605049,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Samarkand',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21936.27663.27664',
    parentId: 27663,
    timeZone: 'Asia/Samarkand',
    iataCode: 'SKD',
    destinationType: 'CITY',
    destinationName: 'Samarkand',
    destinationId: 27664,
    latitude: 39.62701,
    longitude: 66.97497,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Tashkent',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21936.26668',
    parentId: 21936,
    timeZone: 'Asia/Tashkent',
    iataCode: 'TAS',
    destinationType: 'CITY',
    destinationName: 'Tashkent',
    destinationId: 26668,
    latitude: 41.2995,
    longitude: 69.24007,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Urgench',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21936.51129',
    parentId: 21936,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Urgench',
    destinationId: 51129,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 202,
    selectable: true,
    destinationUrlName: 'Vanuatu',
    defaultCurrencyCode: 'USD',
    lookupId: '3.4772',
    parentId: 3,
    timeZone: 'Pacific/Efate',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Vanuatu',
    destinationId: 4772,
    latitude: -15.37671,
    longitude: 166.95916,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Tanna-Island',
    defaultCurrencyCode: 'USD',
    lookupId: '3.4772.25079',
    parentId: 4772,
    timeZone: 'Pacific/Efate',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Tanna Island',
    destinationId: 25079,
    latitude: -19.51549,
    longitude: 169.35782,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Port-Vila',
    defaultCurrencyCode: 'USD',
    lookupId: '3.4772.4781',
    parentId: 4772,
    timeZone: 'Pacific/Efate',
    iataCode: 'VLI',
    destinationType: 'CITY',
    destinationName: 'Port Vila',
    destinationId: 4781,
    latitude: -17.732353,
    longitude: 168.328741,
  },
  {
    sortOrder: 203,
    selectable: true,
    destinationUrlName: 'Vietnam',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21',
    parentId: 2,
    timeZone: 'Asia/Ho_Chi_Minh',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Vietnam',
    destinationId: 21,
    latitude: 14.058324,
    longitude: 108.277199,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Central-Vietnam',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.765',
    parentId: 21,
    timeZone: 'Asia/Ho_Chi_Minh',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Central Vietnam',
    destinationId: 765,
    latitude: 10.700153,
    longitude: 106.656299,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Mekong-Delta',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.23962',
    parentId: 21,
    timeZone: 'Asia/Phnom_Penh',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Mekong Delta',
    destinationId: 23962,
    latitude: 9.7851093,
    longitude: 102.8921659,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Northern-Vietnam',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.22691',
    parentId: 21,
    timeZone: 'Asia/Ho_Chi_Minh',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Northern Vietnam',
    destinationId: 22691,
    latitude: 22.796439,
    longitude: 105.281982,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Southern-Vietnam',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.22328',
    parentId: 21,
    timeZone: 'Asia/Ho_Chi_Minh',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Southern Vietnam',
    destinationId: 22328,
    latitude: 9.687398,
    longitude: 105.501709,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Ba-Be',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.22691.51895',
    parentId: 22691,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ba Be',
    destinationId: 51895,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Ba-Be-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.22691.52089',
    parentId: 22691,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ba Be National Park',
    destinationId: 52089,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Bao-Lac',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.22691.51949',
    parentId: 22691,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Bao Lac',
    destinationId: 51949,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Ben-Tre',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.23962.50855',
    parentId: 23962,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ben Tre',
    destinationId: 50855,
    latitude: 10.2438117975,
    longitude: 106.3743491895,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Buon-Ma-Thuot',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.765.51583',
    parentId: 765,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Buon Ma Thuot',
    destinationId: 51583,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Cai-Be',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.23962.50571',
    parentId: 23962,
    timeZone: 'Asia/Ho_Chi_Minh',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cai Be',
    destinationId: 50571,
    latitude: 10.33425,
    longitude: 106.03395,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Can-Tho',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.23962.50569',
    parentId: 23962,
    timeZone: 'Asia/Ho_Chi_Minh',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Can Tho',
    destinationId: 50569,
    latitude: 10.0362,
    longitude: 105.78803,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Cao-Bang',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.22691.50948',
    parentId: 22691,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cao Bang',
    destinationId: 50948,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Cat-Ba',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.50572',
    parentId: 21,
    timeZone: 'Asia/Ho_Chi_Minh',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Cat Ba',
    destinationId: 50572,
    latitude: 20.731819,
    longitude: 107.0476,
  },
  {
    sortOrder: 10,
    selectable: true,
    destinationUrlName: 'Con-Dao-Islands',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.22328.51616',
    parentId: 22328,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Con Dao Islands',
    destinationId: 51616,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 11,
    selectable: true,
    destinationUrlName: 'Con-Son',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.22328.51610',
    parentId: 22328,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Con Son',
    destinationId: 51610,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 12,
    selectable: true,
    destinationUrlName: 'Da-Nang',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.765.4680',
    parentId: 765,
    timeZone: 'Asia/Ho_Chi_Minh',
    iataCode: 'DAD',
    destinationType: 'CITY',
    destinationName: 'Da Nang',
    destinationId: 4680,
    latitude: 16.05441,
    longitude: 108.20217,
  },
  {
    sortOrder: 13,
    selectable: true,
    destinationUrlName: 'Dien-Bien-Phu',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.22691.51687',
    parentId: 22691,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Dien Bien Phu',
    destinationId: 51687,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 14,
    selectable: true,
    destinationUrlName: 'Dong-Hoi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.50565',
    parentId: 21,
    timeZone: 'Asia/Ho_Chi_Minh',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Dong Hoi',
    destinationId: 50565,
    latitude: 17.466841,
    longitude: 106.623169,
  },
  {
    sortOrder: 15,
    selectable: true,
    destinationUrlName: 'Ha-Giang',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.22691.50728',
    parentId: 22691,
    timeZone: 'Asia/Ho_Chi_Minh',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ha Giang',
    destinationId: 50728,
    latitude: 22.82822,
    longitude: 104.980888,
  },
  {
    sortOrder: 16,
    selectable: true,
    destinationUrlName: 'Ha-Giang-Province',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.22691.50928',
    parentId: 22691,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Ha Giang Province',
    destinationId: 50928,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 17,
    selectable: true,
    destinationUrlName: 'Halong-Bay',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.22691.22692',
    parentId: 22691,
    timeZone: 'Asia/Ho_Chi_Minh',
    iataCode: 'HPH',
    destinationType: 'CITY',
    destinationName: 'Halong Bay',
    destinationId: 22692,
    latitude: 20.957282,
    longitude: 107.023203,
  },
  {
    sortOrder: 18,
    selectable: true,
    destinationUrlName: 'Hanoi',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.22691.351',
    parentId: 22691,
    timeZone: 'Asia/Ho_Chi_Minh',
    iataCode: 'HAN',
    destinationType: 'CITY',
    destinationName: 'Hanoi',
    destinationId: 351,
    latitude: 21.02425,
    longitude: 105.854694,
  },
  {
    sortOrder: 19,
    selectable: true,
    destinationUrlName: 'Ho-Chi-Minh-City',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.22328.352',
    parentId: 22328,
    timeZone: 'Asia/Ho_Chi_Minh',
    iataCode: 'SGN',
    destinationType: 'CITY',
    destinationName: 'Ho Chi Minh City',
    destinationId: 352,
    latitude: 10.7694444,
    longitude: 106.6819444,
  },
  {
    sortOrder: 20,
    selectable: true,
    destinationUrlName: 'Hoi-An',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.765.5229',
    parentId: 765,
    timeZone: 'Asia/Ho_Chi_Minh',
    iataCode: 'DAD',
    destinationType: 'CITY',
    destinationName: 'Hoi An',
    destinationId: 5229,
    latitude: 15.5097,
    longitude: 108.297501,
  },
  {
    sortOrder: 21,
    selectable: true,
    destinationUrlName: 'Hue',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.765.5219',
    parentId: 765,
    timeZone: 'Asia/Ho_Chi_Minh',
    iataCode: 'HUI',
    destinationType: 'CITY',
    destinationName: 'Hue',
    destinationId: 5219,
    latitude: 16.463461,
    longitude: 107.584702,
  },
  {
    sortOrder: 22,
    selectable: true,
    destinationUrlName: 'Lao-Chai',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.22691.50847',
    parentId: 22691,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lao Chai',
    destinationId: 50847,
    latitude: 22.3089886504,
    longitude: 103.858400965,
  },
  {
    sortOrder: 23,
    selectable: true,
    destinationUrlName: 'Mai-Chau',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.22691.50641',
    parentId: 22691,
    timeZone: 'Asia/Ho_Chi_Minh',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mai Chau',
    destinationId: 50641,
    latitude: 20.663231,
    longitude: 105.083771,
  },
  {
    sortOrder: 24,
    selectable: true,
    destinationUrlName: 'Mu-Cang-Chai',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.22691.51839',
    parentId: 22691,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Mu Cang Chai',
    destinationId: 51839,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 25,
    selectable: true,
    destinationUrlName: 'My-Son',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.765.33747',
    parentId: 765,
    timeZone: 'Asia/Ho_Chi_Minh',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'My Son',
    destinationId: 33747,
    latitude: 15.79072,
    longitude: 108.111175,
  },
  {
    sortOrder: 26,
    selectable: true,
    destinationUrlName: 'Nghia-Lo',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.22691.51940',
    parentId: 22691,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Nghia Lo',
    destinationId: 51940,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 27,
    selectable: true,
    destinationUrlName: 'Nha-Trang',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.4682',
    parentId: 21,
    timeZone: 'Asia/Ho_Chi_Minh',
    iataCode: 'NHA',
    destinationType: 'CITY',
    destinationName: 'Nha Trang',
    destinationId: 4682,
    latitude: 12.238791,
    longitude: 109.196749,
  },
  {
    sortOrder: 28,
    selectable: true,
    destinationUrlName: 'Phan-Thiet',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.22328.50567',
    parentId: 22328,
    timeZone: 'Asia/Ho_Chi_Minh',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Phan Thiet',
    destinationId: 50567,
    latitude: 10.92401,
    longitude: 108.10021,
  },
  {
    sortOrder: 29,
    selectable: true,
    destinationUrlName: 'Phu-Quoc',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.22328.22452',
    parentId: 22328,
    timeZone: 'Asia/Ho_Chi_Minh',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Phu Quoc',
    destinationId: 22452,
    latitude: 10.157977,
    longitude: 103.998407,
  },
  {
    sortOrder: 30,
    selectable: true,
    destinationUrlName: 'Qui-Nhon',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.4587',
    parentId: 21,
    timeZone: 'Asia/Ho_Chi_Minh',
    iataCode: 'UIH',
    destinationType: 'CITY',
    destinationName: 'Qui Nhon',
    destinationId: 4587,
    latitude: 13.78,
    longitude: 109.18,
  },
  {
    sortOrder: 31,
    selectable: true,
    destinationUrlName: 'Sapa',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.22691.50492',
    parentId: 22691,
    timeZone: 'America/Chicago',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Sapa',
    destinationId: 50492,
    latitude: 33.547859,
    longitude: -89.201561,
  },
  {
    sortOrder: 32,
    selectable: true,
    destinationUrlName: 'Vinh-Long',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.23962.51125',
    parentId: 23962,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Vinh Long',
    destinationId: 51125,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 33,
    selectable: true,
    destinationUrlName: 'Vung-Tau',
    defaultCurrencyCode: 'USD',
    lookupId: '2.21.22328.25711',
    parentId: 22328,
    timeZone: 'Asia/Ho_Chi_Minh',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Vung Tau',
    destinationId: 25711,
    latitude: 10.411284,
    longitude: 107.139116,
  },
  {
    sortOrder: 204,
    selectable: true,
    destinationUrlName: 'Wales',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.5157',
    parentId: 6,
    timeZone: 'Europe/London',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Wales',
    destinationId: 5157,
    latitude: 51.481581,
    longitude: -3.17909,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Brecon-Beacons-National-Park',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.5157.52060',
    parentId: 5157,
    timeZone: '',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Brecon Beacons National Park',
    destinationId: 52060,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Snowdonia',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.5157.24144',
    parentId: 5157,
    timeZone: 'Europe/London',
    iataCode: null,
    destinationType: 'REGION',
    destinationName: 'Snowdonia',
    destinationId: 24144,
    latitude: 53.0671,
    longitude: -4.077,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Bangor',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.5157.23273',
    parentId: 5157,
    timeZone: 'Europe/London',
    iataCode: 'BGR',
    destinationType: 'CITY',
    destinationName: 'Bangor',
    destinationId: 23273,
    latitude: 53.227418,
    longitude: -4.128013,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Betws-y-Coed',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.5157.24144.50819',
    parentId: 24144,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Betws-y-Coed',
    destinationId: 50819,
    latitude: 53.095019113,
    longitude: -3.8013984409,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Caernarfon',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.5157.24737',
    parentId: 5157,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Caernarfon',
    destinationId: 24737,
    latitude: 53.139515,
    longitude: -4.271712,
  },
  {
    sortOrder: 4,
    selectable: true,
    destinationUrlName: 'Capel-Curig',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.5157.24144.51738',
    parentId: 24144,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Capel Curig',
    destinationId: 51738,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 5,
    selectable: true,
    destinationUrlName: 'Cardiff',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.5157.5158',
    parentId: 5157,
    timeZone: 'Europe/London',
    iataCode: 'CWL',
    destinationType: 'CITY',
    destinationName: 'Cardiff',
    destinationId: 5158,
    latitude: 51.481581,
    longitude: -3.17909,
  },
  {
    sortOrder: 6,
    selectable: true,
    destinationUrlName: 'Conwy',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.5157.50910',
    parentId: 5157,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Conwy',
    destinationId: 50910,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 7,
    selectable: true,
    destinationUrlName: 'Llandudno',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.5157.27174',
    parentId: 5157,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Llandudno',
    destinationId: 27174,
    latitude: 53.32406,
    longitude: -3.82761,
  },
  {
    sortOrder: 8,
    selectable: true,
    destinationUrlName: 'Swansea',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.5157.22135',
    parentId: 5157,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Swansea',
    destinationId: 22135,
    latitude: 51.621424,
    longitude: -3.94407,
  },
  {
    sortOrder: 9,
    selectable: true,
    destinationUrlName: 'Wrexham',
    defaultCurrencyCode: 'GBP',
    lookupId: '6.5157.24096',
    parentId: 5157,
    timeZone: 'Europe/London',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Wrexham',
    destinationId: 24096,
    latitude: 53.043076,
    longitude: -2.989928,
  },
  {
    sortOrder: 205,
    selectable: true,
    destinationUrlName: 'Zambia',
    defaultCurrencyCode: 'USD',
    lookupId: '1.779',
    parentId: 1,
    timeZone: 'Africa/Dar_es_Salaam',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Zambia',
    destinationId: 779,
    latitude: -13.133897,
    longitude: 27.849332,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Kafue-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '1.779.51419',
    parentId: 779,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Kafue National Park',
    destinationId: 51419,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Livingstone',
    defaultCurrencyCode: 'USD',
    lookupId: '1.779.5313',
    parentId: 779,
    timeZone: 'Africa/Dar_es_Salaam',
    iataCode: 'LVI',
    destinationType: 'CITY',
    destinationName: 'Livingstone',
    destinationId: 5313,
    latitude: -17.8519791,
    longitude: 25.8285153,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Lusaka',
    defaultCurrencyCode: 'USD',
    lookupId: '1.779.50366',
    parentId: 779,
    timeZone: 'Africa/Lusaka',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Lusaka',
    destinationId: 50366,
    latitude: -15.3875,
    longitude: 28.3228,
  },
  {
    sortOrder: 206,
    selectable: true,
    destinationUrlName: 'Zimbabwe',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5308',
    parentId: 1,
    timeZone: 'Africa/Nairobi',
    iataCode: null,
    destinationType: 'COUNTRY',
    destinationName: 'Zimbabwe',
    destinationId: 5308,
    latitude: 19.0167,
    longitude: 30.0167,
  },
  {
    sortOrder: 1,
    selectable: true,
    destinationUrlName: 'Harare',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5308.31762',
    parentId: 5308,
    timeZone: 'Africa/Harare',
    iataCode: 'HRE',
    destinationType: 'CITY',
    destinationName: 'Harare',
    destinationId: 31762,
    latitude: -17.823489,
    longitude: 31.03454,
  },
  {
    sortOrder: 2,
    selectable: true,
    destinationUrlName: 'Hwange-National-Park',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5308.51420',
    parentId: 5308,
    timeZone: '',
    iataCode: '',
    destinationType: 'CITY',
    destinationName: 'Hwange National Park',
    destinationId: 51420,
    latitude: null,
    longitude: null,
  },
  {
    sortOrder: 3,
    selectable: true,
    destinationUrlName: 'Victoria-Falls',
    defaultCurrencyCode: 'USD',
    lookupId: '1.5308.5309',
    parentId: 5308,
    timeZone: 'Africa/Nairobi',
    iataCode: 'VFA',
    destinationType: 'CITY',
    destinationName: 'Victoria Falls',
    destinationId: 5309,
    latitude: -17.9318052,
    longitude: 25.8255575,
  },
];
